import * as React from 'react';
import React__default from 'react';
import FocusTrap from 'focus-trap-react';
import styled, { css, keyframes } from 'styled-components';
import DatePicker, { registerLocale } from 'react-datepicker';
import Hammer from 'react-hammerjs';
import InputMask from 'react-input-mask';
import Cropper from 'react-image-crop';
import { useTable, useSortBy, usePagination } from 'react-table';

var ameiConfig = {
    'https://amei.sebrae.com.br/auth': {
        authRealm: 'externo',
        avatarUrl: 'https://api-cpe.sebrae.com.br/v1/keycloak/public/usuario/foto',
        cpeUrl: 'https://cpe.sebrae.com.br',
    },
    'https://amei.homolog.kubernetes.sebrae.com.br/auth': {
        authRealm: 'externo',
        avatarUrl: 'https://cpe-backend.homologacao.sebrae.com.br/v1/keycloak/public/usuario/foto',
        cpeUrl: 'https://cpe-frontend.homologacao.sebrae.com.br',
    },
    'http://localhost:8080/auth': {
        authRealm: 'master',
        avatarUrl: 'https://cpe-backend.homologacao.sebrae.com.br/v1/keycloak/public/usuario/foto',
        cpeUrl: 'https://cpe-frontend.homologacao.sebrae.com.br',
    },
};
var BaSeConfig = {
    docsUrl: 'https://base-react.sebrae.com.br',
    staticAssetsUrl: 'https://base-estatico.sebrae.com.br',
    ameiConfig: ameiConfig,
};

const version="1.61.3";

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var palette = {
    transparent: 'transparent',
    shadowColor: 'rgba(20, 46, 82, 0.2)',
    white: '#ffffff',
    black: '#000000',
    lightGray: '#e0e5eb',
    azulSebrae10: '#0a1729',
    azulSebrae20: '#142e52',
    azulSebrae30: '#0f438a',
    azulSebrae36: '#005eb8',
    azulSebrae60: '#5c8fd6',
    azulSebrae75: '#8fb8ef',
    azulSebrae90: '#cfe2fc',
    azulSebrae97: '#f0f6fe',
    cinzaSebrae10: '#121a21',
    cinzaSebrae20: '#243342',
    cinzaSebrae30: '#394d60',
    cinzaSebrae45: '#617385',
    cinzaSebrae60: '#8b99a7',
    cinzaSebrae75: '#b6bfc8',
    cinzaSebrae90: '#e0e5eb',
    cinzaSebrae97: '#f5f7fa',
    marrom10: '#231910',
    marrom20: '#463320',
    marrom30: '#6a4c2f',
    marrom50: '#b07f4f',
    marrom60: '#b8997a',
    marrom75: '#d2c0ac',
    marrom90: '#ede5de',
    laranja10: '#29140a',
    laranja25: '#66331a',
    laranja40: '#a35229',
    laranja63: '#ff8040',
    laranja73: '#ffa375',
    laranja80: '#ffbb99',
    laranja90: '#fcdecf',
    verdeOliva10: '#1c280b',
    verdeOliva20: '#385214',
    verdeOliva30: '#547a1f',
    verdeOliva47: '#83bf30',
    verdeOliva60: '#a2cf63',
    verdeOliva75: '#c5e19e',
    verdeOliva90: '#e7f3d8',
    cinza10: '#181a1b',
    cinza25: '#3c4143',
    cinza30: '#61686b',
    cinza67: '#a1adb3',
    cinza75: '#b9c1c6',
    cinza85: '#d4dadd',
    cinza90: '#e2e6e8',
    roxo10: '#231023',
    roxo20: '#462046',
    roxo30: '#6a2f6a',
    roxo44: '#994599',
    roxo60: '#b87ab8',
    roxo75: '#d2acd2',
    roxo90: '#f0dbf0',
    turquesa10: '#003325',
    turquesa15: '#004d37',
    turquesa25: '#00805c',
    turquesa40: '#00cc92',
    turquesa60: '#55ddb7',
    turquesa75: '#94ead2',
    turquesa90: '#d4f7ed',
    azulAqua10: '#05282e',
    azulAqua20: '#094f5d',
    azulAqua30: '#0e778b',
    azulAqua44: '#14adcc',
    azulAqua60: '#58c4da',
    azulAqua75: '#96dbe9',
    azulAqua90: '#d5f1f6',
    vermelho10: '#280b0d',
    vermelho20: '#52141a',
    vermelho35: '#8e242c',
    vermelho47: '#bf303c',
    vermelho65: '#e06c76',
    vermelho80: '#f0a8af',
    vermelho90: '#f3d8da',
    amarelo10: '#291f0a',
    amarelo25: '#664d1a',
    amarelo35: '#8f6b24',
    amarelo63: '#ffbf40',
    amarelo73: '#ffd175',
    amarelo80: '#ffdd99',
    amarelo90: '#ffeecc',
    sucesso20: '#00662a',
    sucesso26: '#008537',
    sucesso45: '#35b068',
    sucesso70: '#85e0a3',
    sucesso75: '#99e5b2',
    sucesso85: '#c2efd1',
    sucesso95: '#ebfaf0',
    erro35: '#b22400',
    erro45: '#db340b',
    erro60: '#f5623d',
    erro70: '#ff8566',
    erro75: '#ff9980',
    erro85: '#ffc1b3',
    erro95: '#ffeae5',
    atencao35: '#ab6005',
    atencao55: '#ffb31a',
    atencao60: '#ffbc33',
    atencao70: '#ffdc66',
    atencao75: '#ffe380',
    atencao85: '#fff0b3',
    atencao95: '#fffae6',
};
var contrastPalette = {
    azulSebrae10: palette.white,
    azulSebrae20: palette.white,
    azulSebrae30: palette.white,
    azulSebrae36: palette.white,
    azulSebrae60: palette.cinzaSebrae10,
    azulSebrae75: palette.cinzaSebrae10,
    azulSebrae90: palette.cinzaSebrae20,
    azulSebrae97: palette.cinzaSebrae20,
    cinzaSebrae10: palette.white,
    cinzaSebrae20: palette.white,
    cinzaSebrae30: palette.white,
    cinzaSebrae45: palette.white,
    cinzaSebrae60: palette.cinzaSebrae10,
    cinzaSebrae75: palette.cinzaSebrae10,
    cinzaSebrae90: palette.cinzaSebrae20,
    cinzaSebrae97: palette.cinzaSebrae30,
    marrom10: palette.white,
    marrom20: palette.white,
    marrom30: palette.white,
    marrom50: palette.cinzaSebrae10,
    marrom60: palette.cinzaSebrae10,
    marrom75: palette.cinzaSebrae10,
    marrom90: palette.cinzaSebrae10,
    laranja10: palette.white,
    laranja25: palette.white,
    laranja40: palette.white,
    laranja63: palette.cinzaSebrae10,
    laranja73: palette.cinzaSebrae10,
    laranja80: palette.cinzaSebrae20,
    laranja90: palette.cinzaSebrae20,
    verdeOliva10: palette.white,
    verdeOliva20: palette.white,
    verdeOliva30: palette.white,
    verdeOliva47: palette.cinzaSebrae10,
    verdeOliva60: palette.cinzaSebrae10,
    verdeOliva75: palette.cinzaSebrae10,
    verdeOliva90: palette.cinzaSebrae20,
    cinza10: palette.white,
    cinza25: palette.white,
    cinza30: palette.white,
    cinza67: palette.cinzaSebrae10,
    cinza75: palette.cinzaSebrae10,
    cinza85: palette.cinzaSebrae20,
    cinza90: palette.cinzaSebrae20,
    roxo10: palette.white,
    roxo20: palette.white,
    roxo30: palette.white,
    roxo44: palette.white,
    roxo60: palette.cinzaSebrae10,
    roxo75: palette.cinzaSebrae10,
    roxo90: palette.cinzaSebrae20,
    turquesa10: palette.white,
    turquesa15: palette.white,
    turquesa25: palette.white,
    turquesa40: palette.cinzaSebrae10,
    turquesa60: palette.cinzaSebrae10,
    turquesa75: palette.cinzaSebrae10,
    turquesa90: palette.cinzaSebrae20,
    azulAqua10: palette.white,
    azulAqua20: palette.white,
    azulAqua30: palette.white,
    azulAqua44: palette.cinzaSebrae10,
    azulAqua60: palette.cinzaSebrae10,
    azulAqua75: palette.cinzaSebrae10,
    azulAqua90: palette.cinzaSebrae20,
    vermelho10: palette.white,
    vermelho20: palette.white,
    vermelho35: palette.white,
    vermelho47: palette.cinzaSebrae10,
    vermelho65: palette.cinzaSebrae10,
    vermelho80: palette.cinzaSebrae10,
    vermelho90: palette.cinzaSebrae10,
    amarelo10: palette.white,
    amarelo25: palette.white,
    amarelo35: palette.white,
    amarelo63: palette.cinzaSebrae10,
    amarelo73: palette.cinzaSebrae20,
    amarelo80: palette.cinzaSebrae20,
    amarelo90: palette.cinzaSebrae20,
    sucesso20: palette.white,
    sucesso26: palette.white,
    sucesso45: palette.cinzaSebrae10,
    sucesso70: palette.cinzaSebrae10,
    sucesso75: palette.cinzaSebrae10,
    sucesso85: palette.cinzaSebrae20,
    sucesso95: palette.cinzaSebrae20,
    erro35: palette.white,
    erro45: palette.white,
    erro60: palette.cinzaSebrae10,
    erro70: palette.cinzaSebrae10,
    erro75: palette.cinzaSebrae10,
    erro85: palette.cinzaSebrae20,
    erro95: palette.cinzaSebrae20,
    atencao35: palette.white,
    atencao55: palette.cinzaSebrae10,
    atencao60: palette.cinzaSebrae10,
    atencao70: palette.cinzaSebrae20,
    atencao75: palette.cinzaSebrae20,
    atencao85: palette.cinzaSebrae20,
    atencao95: palette.cinzaSebrae20,
};
var BaSeColors = {
    institucionais: {
        azulSebrae: palette.azulSebrae36,
        azulSebrae10: palette.azulSebrae10,
        azulSebrae20: palette.azulSebrae20,
        azulSebrae30: palette.azulSebrae30,
        azulSebrae36: palette.azulSebrae36,
        azulSebrae60: palette.azulSebrae60,
        azulSebrae75: palette.azulSebrae75,
        azulSebrae90: palette.azulSebrae90,
        azulSebrae97: palette.azulSebrae97,
        cinzaSebrae: palette.cinzaSebrae10,
        cinzaSebrae10: palette.cinzaSebrae10,
        cinzaSebrae20: palette.cinzaSebrae20,
        cinzaSebrae30: palette.cinzaSebrae30,
        cinzaSebrae45: palette.cinzaSebrae45,
        cinzaSebrae60: palette.cinzaSebrae60,
        cinzaSebrae75: palette.cinzaSebrae75,
        cinzaSebrae90: palette.cinzaSebrae90,
        cinzaSebrae97: palette.cinzaSebrae97,
    },
    gestao: {
        cooperacao: palette.marrom50,
        marrom10: palette.marrom10,
        marrom20: palette.marrom20,
        marrom30: palette.marrom30,
        marrom50: palette.marrom50,
        marrom60: palette.marrom60,
        marrom75: palette.marrom75,
        marrom90: palette.marrom90,
        empreendedorismo: palette.laranja63,
        laranja10: palette.laranja10,
        laranja25: palette.laranja25,
        laranja40: palette.laranja40,
        laranja63: palette.laranja63,
        laranja73: palette.laranja73,
        laranja80: palette.laranja80,
        laranja90: palette.laranja90,
        financas: palette.verdeOliva47,
        verdeOliva10: palette.verdeOliva10,
        verdeOliva20: palette.verdeOliva20,
        verdeOliva30: palette.verdeOliva30,
        verdeOliva47: palette.verdeOliva47,
        verdeOliva60: palette.verdeOliva60,
        verdeOliva75: palette.verdeOliva75,
        verdeOliva90: palette.verdeOliva90,
        inovacao: palette.cinza67,
        cinza10: palette.cinza10,
        cinza25: palette.cinza25,
        cinza30: palette.cinza30,
        cinza67: palette.cinza67,
        cinza75: palette.cinza75,
        cinza85: palette.cinza85,
        cinza90: palette.cinza90,
        leis: palette.roxo44,
        roxo10: palette.roxo10,
        roxo20: palette.roxo20,
        roxo30: palette.roxo30,
        roxo44: palette.roxo44,
        roxo60: palette.roxo60,
        roxo75: palette.roxo75,
        roxo90: palette.roxo90,
        mercadoVendas: palette.turquesa40,
        turquesa10: palette.turquesa10,
        turquesa15: palette.turquesa15,
        turquesa25: palette.turquesa25,
        turquesa40: palette.turquesa40,
        turquesa60: palette.turquesa60,
        turquesa75: palette.turquesa75,
        turquesa90: palette.turquesa90,
        organizacao: palette.azulAqua44,
        azulAqua10: palette.azulAqua10,
        azulAqua20: palette.azulAqua20,
        azulAqua30: palette.azulAqua30,
        azulAqua44: palette.azulAqua44,
        azulAqua60: palette.azulAqua60,
        azulAqua75: palette.azulAqua75,
        azulAqua90: palette.azulAqua90,
        pessoas: palette.vermelho47,
        vermelho10: palette.vermelho10,
        vermelho20: palette.vermelho20,
        vermelho35: palette.vermelho35,
        vermelho47: palette.vermelho47,
        vermelho65: palette.vermelho65,
        vermelho80: palette.vermelho80,
        vermelho90: palette.vermelho90,
        planejamento: palette.amarelo63,
        amarelo10: palette.amarelo10,
        amarelo25: palette.amarelo25,
        amarelo35: palette.amarelo35,
        amarelo63: palette.amarelo63,
        amarelo73: palette.amarelo73,
        amarelo80: palette.amarelo80,
        amarelo90: palette.amarelo90,
    },
    feedbackInterface: {
        sucesso: palette.sucesso70,
        sucesso20: palette.sucesso20,
        sucesso26: palette.sucesso26,
        sucesso45: palette.sucesso45,
        sucesso70: palette.sucesso70,
        sucesso75: palette.sucesso75,
        sucesso85: palette.sucesso85,
        sucesso95: palette.sucesso95,
        erro: palette.erro70,
        erro35: palette.erro35,
        erro45: palette.erro45,
        erro60: palette.erro60,
        erro70: palette.erro70,
        erro75: palette.erro75,
        erro85: palette.erro85,
        erro95: palette.erro95,
        atencao: palette.atencao70,
        atencao35: palette.atencao35,
        atencao55: palette.atencao55,
        atencao60: palette.atencao60,
        atencao70: palette.atencao70,
        atencao75: palette.atencao75,
        atencao85: palette.atencao85,
        atencao95: palette.atencao95,
        informacao: palette.azulSebrae36,
        azulSebrae10: palette.azulSebrae10,
        azulSebrae20: palette.azulSebrae20,
        azulSebrae30: palette.azulSebrae30,
        azulSebrae36: palette.azulSebrae36,
        azulSebrae60: palette.azulSebrae60,
        azulSebrae75: palette.azulSebrae75,
        azulSebrae90: palette.azulSebrae90,
    },
    defaultColors: {
        transparent: palette.transparent,
        shadowColor: palette.shadowColor,
        lightGray: palette.lightGray,
        white: palette.white,
        black: palette.black,
    },
    contrast: {
        institucionais: {
            azulSebrae: contrastPalette.azulSebrae36,
            azulSebrae10: contrastPalette.azulSebrae10,
            azulSebrae20: contrastPalette.azulSebrae20,
            azulSebrae30: contrastPalette.azulSebrae30,
            azulSebrae36: contrastPalette.azulSebrae36,
            azulSebrae60: contrastPalette.azulSebrae60,
            azulSebrae75: contrastPalette.azulSebrae75,
            azulSebrae90: contrastPalette.azulSebrae90,
            azulSebrae97: contrastPalette.azulSebrae97,
            cinzaSebrae: contrastPalette.cinzaSebrae10,
            cinzaSebrae10: contrastPalette.cinzaSebrae10,
            cinzaSebrae20: contrastPalette.cinzaSebrae20,
            cinzaSebrae30: contrastPalette.cinzaSebrae30,
            cinzaSebrae45: contrastPalette.cinzaSebrae45,
            cinzaSebrae60: contrastPalette.cinzaSebrae60,
            cinzaSebrae75: contrastPalette.cinzaSebrae75,
            cinzaSebrae90: contrastPalette.cinzaSebrae90,
            cinzaSebrae97: contrastPalette.cinzaSebrae97,
        },
        gestao: {
            cooperacao: contrastPalette.marrom50,
            marrom10: contrastPalette.marrom10,
            marrom20: contrastPalette.marrom20,
            marrom30: contrastPalette.marrom30,
            marrom50: contrastPalette.marrom50,
            marrom60: contrastPalette.marrom60,
            marrom75: contrastPalette.marrom75,
            marrom90: contrastPalette.marrom90,
            empreendedorismo: contrastPalette.laranja63,
            laranja10: contrastPalette.laranja10,
            laranja25: contrastPalette.laranja25,
            laranja40: contrastPalette.laranja40,
            laranja63: contrastPalette.laranja63,
            laranja73: contrastPalette.laranja73,
            laranja80: contrastPalette.laranja80,
            laranja90: contrastPalette.laranja90,
            financas: contrastPalette.verdeOliva47,
            verdeOliva10: contrastPalette.verdeOliva10,
            verdeOliva20: contrastPalette.verdeOliva20,
            verdeOliva30: contrastPalette.verdeOliva30,
            verdeOliva47: contrastPalette.verdeOliva47,
            verdeOliva60: contrastPalette.verdeOliva60,
            verdeOliva75: contrastPalette.verdeOliva75,
            verdeOliva90: contrastPalette.verdeOliva90,
            inovacao: contrastPalette.cinza67,
            cinza10: contrastPalette.cinza10,
            cinza25: contrastPalette.cinza25,
            cinza30: contrastPalette.cinza30,
            cinza67: contrastPalette.cinza67,
            cinza75: contrastPalette.cinza75,
            cinza85: contrastPalette.cinza85,
            cinza90: contrastPalette.cinza90,
            leis: contrastPalette.roxo44,
            roxo10: contrastPalette.roxo10,
            roxo20: contrastPalette.roxo20,
            roxo30: contrastPalette.roxo30,
            roxo44: contrastPalette.roxo44,
            roxo60: contrastPalette.roxo60,
            roxo75: contrastPalette.roxo75,
            roxo90: contrastPalette.roxo90,
            mercadoVendas: contrastPalette.turquesa40,
            turquesa10: contrastPalette.turquesa10,
            turquesa15: contrastPalette.turquesa15,
            turquesa25: contrastPalette.turquesa25,
            turquesa40: contrastPalette.turquesa40,
            turquesa60: contrastPalette.turquesa60,
            turquesa75: contrastPalette.turquesa75,
            turquesa90: contrastPalette.turquesa90,
            organizacao: contrastPalette.azulAqua44,
            azulAqua10: contrastPalette.azulAqua10,
            azulAqua20: contrastPalette.azulAqua20,
            azulAqua30: contrastPalette.azulAqua30,
            azulAqua44: contrastPalette.azulAqua44,
            azulAqua60: contrastPalette.azulAqua60,
            azulAqua75: contrastPalette.azulAqua75,
            azulAqua90: contrastPalette.azulAqua90,
            pessoas: contrastPalette.vermelho47,
            vermelho10: contrastPalette.vermelho10,
            vermelho20: contrastPalette.vermelho20,
            vermelho35: contrastPalette.vermelho35,
            vermelho47: contrastPalette.vermelho47,
            vermelho65: contrastPalette.vermelho65,
            vermelho80: contrastPalette.vermelho80,
            vermelho90: contrastPalette.vermelho90,
            planejamento: contrastPalette.amarelo63,
            amarelo10: contrastPalette.amarelo10,
            amarelo25: contrastPalette.amarelo25,
            amarelo35: contrastPalette.amarelo35,
            amarelo63: contrastPalette.amarelo63,
            amarelo73: contrastPalette.amarelo73,
            amarelo80: contrastPalette.amarelo80,
            amarelo90: contrastPalette.amarelo90,
        },
        feedbackInterface: {
            sucesso: contrastPalette.sucesso70,
            sucesso20: contrastPalette.sucesso20,
            sucesso26: contrastPalette.sucesso26,
            sucesso45: contrastPalette.sucesso45,
            sucesso70: contrastPalette.sucesso70,
            sucesso75: contrastPalette.sucesso75,
            sucesso85: contrastPalette.sucesso85,
            sucesso95: contrastPalette.sucesso95,
            erro: contrastPalette.erro70,
            erro35: contrastPalette.erro35,
            erro45: contrastPalette.erro45,
            erro60: contrastPalette.erro60,
            erro70: contrastPalette.erro70,
            erro75: contrastPalette.erro75,
            erro85: contrastPalette.erro85,
            erro95: contrastPalette.erro95,
            atencao: contrastPalette.atencao70,
            atencao35: contrastPalette.atencao35,
            atencao55: contrastPalette.atencao55,
            atencao60: contrastPalette.atencao60,
            atencao70: contrastPalette.atencao70,
            atencao75: contrastPalette.atencao75,
            atencao85: contrastPalette.atencao85,
            atencao95: contrastPalette.atencao95,
            informacao: contrastPalette.azulSebrae36,
            azulSebrae10: contrastPalette.azulSebrae10,
            azulSebrae20: contrastPalette.azulSebrae20,
            azulSebrae30: contrastPalette.azulSebrae30,
            azulSebrae36: contrastPalette.azulSebrae36,
            azulSebrae60: contrastPalette.azulSebrae60,
            azulSebrae75: contrastPalette.azulSebrae75,
            azulSebrae90: contrastPalette.azulSebrae90,
        },
    },
};

var BaSeShadows = {
    profundidade2: " 0  2px  4px 0 ".concat(BaSeColors.defaultColors.shadowColor),
    profundidade4: " 0  4px  8px 0 ".concat(BaSeColors.defaultColors.shadowColor),
    profundidade8: " 0  8px 12px 0 ".concat(BaSeColors.defaultColors.shadowColor),
    profundidade16: "0 16px 32px 0 ".concat(BaSeColors.defaultColors.shadowColor),
    profundidade32: "0 32px 30px 0 ".concat(BaSeColors.defaultColors.shadowColor),
    profundidade64: "0 64px 40px 0 ".concat(BaSeColors.defaultColors.shadowColor),
    focusPrimary: "0 0 4px ".concat(BaSeColors.institucionais.azulSebrae75),
    focusError: "0 0 4px ".concat(BaSeColors.feedbackInterface.erro70),
    focusValidated: "0 0 4px ".concat(BaSeColors.feedbackInterface.sucesso70), // TODO Ver se vai ter isso mesmo
};
function getShadow(level) {
    if (level < minShadowLevel) {
        level = minShadowLevel;
    }
    if (level > maxShadowLevel) {
        level = maxShadowLevel;
    }
    return BaSeShadows["profundidade".concat(level)];
}
function validateShadowLevel(level) {
    return [2, 4, 8, 16, 32, 64].includes(level);
}
var shadowLevelFactor = 2;
var minShadowLevel = 2;
var maxShadowLevel = 64;

var continuousTimingFunction = 'cubic-bezier(0.4, 0, 0.2, 1)';
var elasticTimingFunction = 'cubic-bezier(0.18, 0.89, 0.67, 1.57)';
var durationNormalInMilliseconds = 255;
var durationSlowInMilliseconds = 1000;
var durationFastInMilliseconds = 120;
var durationNormal = "".concat(durationNormalInMilliseconds, "ms");
var durationSlow = "".concat(durationSlowInMilliseconds, "ms");
var durationFast = "".concat(durationFastInMilliseconds, "ms");
function transition(duration, timingFunction) {
    return "all ".concat(duration, " ").concat(timingFunction);
}
var BaSeTransitions = {
    allPropertiesContinuousNormal: transition(durationNormal, continuousTimingFunction),
    allPropertiesContinuousSlow: transition(durationSlow, continuousTimingFunction),
    allPropertiesContinuousFast: transition(durationFast, continuousTimingFunction),
    allPropertiesElasticNormal: transition(durationNormal, elasticTimingFunction),
    allPropertiesElasticLenta: transition(durationSlow, elasticTimingFunction),
    allPropertiesElasticRapida: transition(durationFast, elasticTimingFunction),
    continuousTimingFunction: continuousTimingFunction,
    elasticTimingFunction: elasticTimingFunction,
    durationNormalInMilliseconds: durationNormalInMilliseconds,
    durationSlowInMilliseconds: durationSlowInMilliseconds,
    durationFastInMilliseconds: durationFastInMilliseconds,
    durationNormal: durationNormal,
    durationSlow: durationSlow,
    durationFast: durationFast,
};

var BaSeTypography = {
    fontFamily: 'Lato',
    fontSizeBase: '16px',
    lineHeight: '2em',
};

var desktopLarge = {
    type: 'desktop',
    maxWidth: Number.MAX_SAFE_INTEGER,
    minWidth: 1440,
    gap: 16,
    mediaQuery: '',
    mediaQuerySelector: '',
    mediaQueryCss: function () { return ''; },
};
var desktop = {
    type: 'desktop',
    maxWidth: 1439,
    minWidth: 1280,
    gap: 16,
    mediaQuery: '',
    mediaQuerySelector: '',
    mediaQueryCss: function () { return ''; },
};
var tablet = {
    type: 'tablet',
    maxWidth: 1279,
    minWidth: 768,
    gap: 16,
    mediaQuery: '',
    mediaQuerySelector: '',
    mediaQueryCss: function () { return ''; },
};
var mobileLarge = {
    type: 'mobile',
    maxWidth: 767,
    minWidth: 375,
    gap: 16,
    mediaQuery: '',
    mediaQuerySelector: '',
    mediaQueryCss: function () { return ''; },
};
var mobile = {
    type: 'mobile',
    maxWidth: 374,
    minWidth: 360,
    gap: 32,
    mediaQuery: '',
    mediaQuerySelector: '',
    mediaQueryCss: function () { return ''; },
};
var mobileSmall = {
    type: 'mobile',
    maxWidth: 359,
    minWidth: 320,
    gap: 32,
    mediaQuery: '',
    mediaQuerySelector: '',
    mediaQueryCss: function () { return ''; },
};
desktopLarge.mediaQuery = "(min-width: ".concat(desktopLarge.minWidth, "px)");
desktop.mediaQuery = "(min-width: ".concat(desktop.minWidth, "px) and (max-width: ").concat(desktop.maxWidth, "px)");
tablet.mediaQuery = "(min-width: ".concat(tablet.minWidth, "px) and (max-width: ").concat(tablet.maxWidth, "px)");
mobileLarge.mediaQuery = "(min-width: ".concat(mobileLarge.minWidth, "px) and (max-width: ").concat(mobileLarge.maxWidth, "px)");
mobile.mediaQuery = "(min-width: ".concat(mobile.minWidth, "px) and (max-width: ").concat(mobile.maxWidth, "px)");
mobileSmall.mediaQuery = "(max-width: ".concat(mobileSmall.maxWidth, "px)");
desktopLarge.mediaQuerySelector = "@media screen and ".concat(desktopLarge.mediaQuery);
desktop.mediaQuerySelector = "@media screen and ".concat(desktop.mediaQuery);
tablet.mediaQuerySelector = "@media screen and ".concat(tablet.mediaQuery);
mobileLarge.mediaQuerySelector = "@media screen and ".concat(mobileLarge.mediaQuery);
mobile.mediaQuerySelector = "@media screen and ".concat(mobile.mediaQuery);
mobileSmall.mediaQuerySelector = "@media screen and ".concat(mobileSmall.mediaQuery);
desktopLarge.mediaQueryCss = function (content) { return "".concat(desktopLarge.mediaQuerySelector, " { ").concat(content, " }"); };
desktop.mediaQueryCss = function (content) { return "".concat(desktop.mediaQuerySelector, " { ").concat(content, " }"); };
tablet.mediaQueryCss = function (content) { return "".concat(tablet.mediaQuerySelector, " { ").concat(content, " }"); };
mobileLarge.mediaQueryCss = function (content) { return "".concat(mobileLarge.mediaQuerySelector, " { ").concat(content, " }"); };
mobile.mediaQueryCss = function (content) { return "".concat(mobile.mediaQuerySelector, " { ").concat(content, " }"); };
mobileSmall.mediaQueryCss = function (content) { return "".concat(mobileSmall.mediaQuerySelector, " { ").concat(content, " }"); };
var BaSeBreakpoints = {
    mobileSmall: mobileSmall,
    mobile: mobile,
    mobileLarge: mobileLarge,
    tablet: tablet,
    desktop: desktop,
    desktopLarge: desktopLarge,
};

var button = {
    colors: {
        default: 'default',
        padrao: 'default',
        destructive: 'destructive',
        destrutivo: 'destructive',
        confirmation: 'confirmation',
        confirmacao: 'confirmation',
        negative: 'negative',
        negativo: 'negative',
        attention: 'attention',
        atencao: 'attention',
    },
};
var BaSeComponents = {
    button: button,
};

var BaSeStackOrder = {
    default: 0,
    normal: 1,
    aboveNormal: 10,
    belowOverlay: 100,
    overlay: 1000,
    aboveOverlay: 9999,
};

var BaSeTheme = {
    colors: BaSeColors,
    shadows: BaSeShadows,
    typography: BaSeTypography,
    transitions: BaSeTransitions,
    breakpoints: BaSeBreakpoints,
    components: BaSeComponents,
    stackOrder: BaSeStackOrder,
};

var queryMatchDefault = {
    onMobileSmall: false,
    onMobile: false,
    onMobileLarge: false,
    onTablet: false,
    onDesktop: false,
    onDesktopLarge: false,
    isInPortraitMode: false,
    isInLandscapeMode: false,
    inMobileSmall: false,
    inMobile: false,
    inMobileLarge: false,
    inTablet: false,
    inDesktop: false,
    inDesktopLarge: false,
};
var BaSeBreakpointContext = React.createContext(queryMatchDefault);
var BaSeBreakpointProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState({}), queryMatch = _b[0], setQueryMatch = _b[1];
    React.useEffect(function () {
        var queries = {
            onMobileSmall: BaSeTheme.breakpoints.mobileSmall.mediaQuery,
            onMobile: BaSeTheme.breakpoints.mobile.mediaQuery,
            onMobileLarge: BaSeTheme.breakpoints.mobileLarge.mediaQuery,
            onTablet: BaSeTheme.breakpoints.tablet.mediaQuery,
            onDesktop: BaSeTheme.breakpoints.desktop.mediaQuery,
            onDesktopLarge: BaSeTheme.breakpoints.desktopLarge.mediaQuery,
            isInPortraitMode: '(orientation: portrait)',
            isInLandscapeMode: '(orientation: landscape)',
        };
        var mediaQueryLists = {};
        var keys = Object.keys(queries);
        var recursiveQueries = {
            inMobileSmall: BaSeTheme.breakpoints.mobileSmall.mediaQuery,
            inMobile: BaSeTheme.breakpoints.mobile.mediaQuery,
            inMobileLarge: BaSeTheme.breakpoints.mobileLarge.mediaQuery,
            inTablet: BaSeTheme.breakpoints.tablet.mediaQuery,
            inDesktop: BaSeTheme.breakpoints.desktop.mediaQuery,
            inDesktopLarge: BaSeTheme.breakpoints.desktopLarge.mediaQuery,
        };
        var recursiveKeys = Object.keys(recursiveQueries);
        var isAttached = false;
        var handleRecursiveQueries = function (options) {
            var index = 0;
            var checked = true;
            var queryReturn = {};
            var updatedMatches = recursiveKeys.reduce(function (acc, media, matchIndex) {
                acc[matchIndex] = media;
                return acc;
            }, {});
            // tslint:disable-next-line: forin
            for (var query in options) {
                queryReturn[updatedMatches[index++]] = !!checked;
                if (options[query]) {
                    checked = false;
                }
            }
            return __assign(__assign({}, options), queryReturn);
        };
        var handleQueryListener = function () {
            var updatedMatches = keys.reduce(function (acc, media) {
                acc[media] = !!(mediaQueryLists[media] && mediaQueryLists[media].matches);
                return acc;
            }, {});
            setQueryMatch(handleRecursiveQueries(updatedMatches));
        };
        if (window && window.matchMedia) {
            var matches_1 = {};
            keys.forEach(function (media) {
                if (typeof queries[media] === 'string') {
                    mediaQueryLists[media] = window.matchMedia(queries[media]);
                    matches_1[media] = mediaQueryLists[media].matches;
                }
                else {
                    matches_1[media] = false;
                }
            });
            setQueryMatch(handleRecursiveQueries(matches_1));
            isAttached = true;
            keys.forEach(function (media) {
                if (typeof queries[media] === 'string') {
                    mediaQueryLists[media].addListener(handleQueryListener);
                }
            });
        }
        return function () {
            if (isAttached) {
                keys.forEach(function (media) {
                    if (typeof queries[media] === 'string') {
                        mediaQueryLists[media].removeListener(handleQueryListener);
                    }
                });
            }
        };
    }, []);
    return (React.createElement(BaSeBreakpointContext.Provider, { value: queryMatch }, children));
};
var BaSeBreakpointConsumer = BaSeBreakpointContext.Consumer;

function idGenerator() {
    var counter, random;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                counter = 0;
                _a.label = 1;
            case 1:
                random = Math.random().toString(36).substring(3);
                return [4 /*yield*/, {
                        hash: "BaSe__".concat(random).concat(++counter),
                        counter: counter,
                    }];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
}
function getNextHash(idSequence) {
    return idSequence.next().value.hash;
}
function getNextCounter(idSequence) {
    return idSequence.next().value.counter;
}

function useNextHashId(idSequence) {
    return React.useMemo(function () { return getNextHash(idSequence); }, []);
}
function useNextCounterId(idSequence) {
    return React.useMemo(function () { return getNextCounter(idSequence); }, []);
}

var Color = /** @class */ (function () {
    function Color(r, g, b, o) {
        if (o === void 0) { o = 1; }
        this.thresholdToLightenHover = 0.95;
        this.thresholdToLightenFocus = 0.75;
        this.thresholdToDarkenHover = 0.54;
        this.thresholdToDecreaseDarkValue = 0.12;
        this.set(r, g, b, o);
    }
    Color.generate = function (color) {
        color = color.replace(/\s/g, '');
        if (color.match(Color.hexColorRegExp)) {
            return Color.generateFromHex(color);
        }
        if (color.match(Color.rgbColorRegExp)) {
            return Color.generateFromCSSrgb(color);
        }
        if (color.match(Color.hslColorRegExp)) {
            return Color.generateFromHslString(color);
        }
        return null;
    };
    Color.generateFromCSSrgb = function (rgbValue) {
        rgbValue = rgbValue.replace(/\s/g, '');
        var rgb = rgbValue.split('(')[1].split(')')[0].split(',');
        if (rgb.length === 3 || rgb.length === 4) {
            var r = rgb[0], g = rgb[1], b = rgb[2], o = rgb[3];
            return new Color(parseInt(r, 10), parseInt(g, 10), parseInt(b, 10), parseFloat(o));
        }
        return null;
    };
    Color.generateFromHex = function (hexValue) {
        try {
            if (hexValue.length === 4) {
                hexValue = "#".concat(hexValue[1].repeat(2)).concat(hexValue[2].repeat(2)).concat(hexValue[3].repeat(2));
            }
            else if (hexValue.length === 5) {
                hexValue = "#".concat(hexValue[1].repeat(2)).concat(hexValue[2].repeat(2)).concat(hexValue[3].repeat(2)).concat(hexValue[4].repeat(2));
            }
            var r = parseInt(hexValue.substring(1, 3), 16);
            var g = parseInt(hexValue.substring(3, 5), 16);
            var b = parseInt(hexValue.substring(5, 7), 16);
            var o = parseInt(hexValue.substring(7, 9), 16);
            if (o) {
                return new Color(r, g, b, o / 255);
            }
            return new Color(r, g, b);
        }
        catch (_a) {
            return null;
        }
    };
    Color.generateFromHslString = function (hslValue) {
        try {
            hslValue = hslValue.split(' ').join('');
            var auxColor = new Color(0, 0, 0, 1);
            var _a = hslValue
                .split('(')[1]
                .split(')')[0]
                .split(',')
                .map(function (i) { return parseInt(i.replace('%', ''), 10); }), h = _a[0], s = _a[1], l = _a[2], opacity = _a[3];
            var _b = auxColor.HSVtoRGB(h / 360, s / 100, l / 100), r = _b.r, g = _b.g, b = _b.b;
            return new Color(r, g, b, opacity);
        }
        catch (_c) {
            return null;
        }
    };
    Color.generateMiddleColor = function (colorHex1, colorHex2) {
        var val1 = Color.generate(colorHex1);
        var val2 = Color.generate(colorHex2);
        var _a = val1 === null || val1 === void 0 ? void 0 : val1.hsl(), h1 = _a.h, s1 = _a.s, l1 = _a.l;
        var _b = val2 === null || val2 === void 0 ? void 0 : val2.hsl(), h2 = _b.h, s2 = _b.s, l2 = _b.l;
        var newH = (h1 + h2) / 200;
        var newS = (s1 + s2) / 200;
        var newL = (l1 + l2) / 200;
        var auxColor = new Color(0, 0, 0);
        var _c = auxColor.HSVtoRGB(newH, newS, newL), r = _c.r, g = _c.g, b = _c.b;
        return new Color(r, g, b);
    };
    Color.validateColor = function (color) {
        color = color.replace(/\s/g, '');
        return !!(color.match(Color.hexColorRegExp) ||
            color.match(Color.rgbColorRegExp) ||
            color.match(Color.hslColorRegExp));
    };
    Color.prototype.toString = function (type) {
        if (type === void 0) { type = 'rgb'; }
        var r = Math.round(this.r);
        var g = Math.round(this.g);
        var b = Math.round(this.b);
        var p = this.opacity;
        if (type === 'rgb') {
            return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(p !== null && p !== void 0 ? p : 1, ")");
        }
        function toHex(color) {
            var hex = color.toString(16);
            if (hex.length === 1) {
                return "0".concat(hex);
            }
            return hex;
        }
        return "#".concat(toHex(r)).concat(toHex(g)).concat(toHex(b)).concat(toHex(parseInt(Math.round(p * 255) + '', 10)));
    };
    Color.prototype.toStringWithOpacity = function (opacity, type) {
        if (opacity === void 0) { opacity = 1; }
        if (type === void 0) { type = 'rgb'; }
        if (opacity < 0 || opacity > 1) {
            throw Error('Informe um valor entre 0 e 1 para a opacidade. Exemplo: 0.5');
        }
        if (type === 'hex') {
            var opacityHex = parseInt((opacity * 255).toFixed(0), 10).toString(16);
            return "".concat(this.toString(type)).concat(opacityHex);
        }
        return this.toString(type).replace(')', ", ".concat(opacity, ")"));
    };
    Color.prototype.isGrayScale = function () {
        return this.r === this.b && this.b === this.g;
    };
    Color.prototype.set = function (r, g, b, o) {
        if (o === void 0) { o = 1; }
        this.r = this.clamp(r);
        this.g = this.clamp(g);
        this.b = this.clamp(b);
        this.opacity = this.clamp(o, 1);
    };
    Color.prototype.hueRotate = function (angle) {
        if (angle === void 0) { angle = 0; }
        angle = (angle / 180) * Math.PI;
        var sin = Math.sin(angle);
        var cos = Math.cos(angle);
        this.multiply([
            0.213 + cos * 0.787 - sin * 0.213,
            0.715 - cos * 0.715 - sin * 0.715,
            0.072 - cos * 0.072 + sin * 0.928,
            0.213 - cos * 0.213 + sin * 0.143,
            0.715 + cos * 0.285 + sin * 0.14,
            0.072 - cos * 0.072 - sin * 0.283,
            0.213 - cos * 0.213 - sin * 0.787,
            0.715 - cos * 0.715 + sin * 0.715,
            0.072 + cos * 0.928 + sin * 0.072,
        ]);
    };
    Color.prototype.grayscale = function (value) {
        if (value === void 0) { value = 1; }
        this.multiply([
            0.2126 + 0.7874 * (1 - value),
            0.7152 - 0.7152 * (1 - value),
            0.0722 - 0.0722 * (1 - value),
            0.2126 - 0.2126 * (1 - value),
            0.7152 + 0.2848 * (1 - value),
            0.0722 - 0.0722 * (1 - value),
            0.2126 - 0.2126 * (1 - value),
            0.7152 - 0.7152 * (1 - value),
            0.0722 + 0.9278 * (1 - value),
        ]);
    };
    Color.prototype.sepia = function (value) {
        if (value === void 0) { value = 1; }
        this.multiply([
            0.393 + 0.607 * (1 - value),
            0.769 - 0.769 * (1 - value),
            0.189 - 0.189 * (1 - value),
            0.349 - 0.349 * (1 - value),
            0.686 + 0.314 * (1 - value),
            0.168 - 0.168 * (1 - value),
            0.272 - 0.272 * (1 - value),
            0.534 - 0.534 * (1 - value),
            0.131 + 0.869 * (1 - value),
        ]);
    };
    Color.prototype.saturate = function (value) {
        if (value === void 0) { value = 1; }
        this.multiply([
            0.213 + 0.787 * value,
            0.715 - 0.715 * value,
            0.072 - 0.072 * value,
            0.213 - 0.213 * value,
            0.715 + 0.285 * value,
            0.072 - 0.072 * value,
            0.213 - 0.213 * value,
            0.715 - 0.715 * value,
            0.072 + 0.928 * value,
        ]);
    };
    Color.prototype.multiply = function (matrix) {
        var newR = this.clamp(this.r * matrix[0] + this.g * matrix[1] + this.b * matrix[2]);
        var newG = this.clamp(this.r * matrix[3] + this.g * matrix[4] + this.b * matrix[5]);
        var newB = this.clamp(this.r * matrix[6] + this.g * matrix[7] + this.b * matrix[8]);
        this.r = newR;
        this.g = newG;
        this.b = newB;
    };
    Color.prototype.brightness = function (value) {
        if (value === void 0) { value = 1; }
        this.linear(value);
    };
    Color.prototype.contrast = function (value) {
        if (value === void 0) { value = 1; }
        this.linear(value, -(0.5 * value) + 0.5);
    };
    Color.prototype.linear = function (slope, intercept) {
        if (slope === void 0) { slope = 1; }
        if (intercept === void 0) { intercept = 0; }
        this.r = this.clamp(this.r * slope + intercept * 255);
        this.g = this.clamp(this.g * slope + intercept * 255);
        this.b = this.clamp(this.b * slope + intercept * 255);
    };
    Color.prototype.invert = function (value) {
        if (value === void 0) { value = 1; }
        this.r = this.clamp((value + (this.r / 255) * (1 - 2 * value)) * 255);
        this.g = this.clamp((value + (this.g / 255) * (1 - 2 * value)) * 255);
        this.b = this.clamp((value + (this.b / 255) * (1 - 2 * value)) * 255);
    };
    Color.prototype.hsl = function () {
        // Code taken from https://stackoverflow.com/a/9493060/2688027, licensed under CC BY-SA.
        var r = this.r / 255;
        var g = this.g / 255;
        var b = this.b / 255;
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var h = (max + min) / 2;
        var s = (max + min) / 2;
        var l = (max + min) / 2;
        if (max === min) {
            h = s = 0;
        }
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h * 100,
            s: s * 100,
            l: l * 100,
        };
    };
    Color.prototype.HSVtoRGB = function (h, s, l) {
        var r;
        var g;
        var b;
        if (s === 0) {
            r = g = b = l; // achromatic
        }
        else {
            var hue2rgb = function (pp, qq, t) {
                if (t < 0) {
                    t += 1;
                }
                if (t > 1) {
                    t -= 1;
                }
                if (t < 1 / 6) {
                    return pp + (qq - pp) * 6 * t;
                }
                if (t < 1 / 2) {
                    return qq;
                }
                if (t < 2 / 3) {
                    return pp + (qq - pp) * (2 / 3 - t) * 6;
                }
                return pp;
            };
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: Math.round(r * 255),
            g: Math.round(g * 255),
            b: Math.round(b * 255),
        };
    };
    Color.prototype.applyLightColor = function (newValueL) {
        var _a = this.hsl(), h = _a.h, s = _a.s;
        h /= 100;
        s /= 100;
        var l = newValueL();
        var _b = this.HSVtoRGB(h, s, l), r = _b.r, g = _b.g, b = _b.b;
        return new Color(r, g, b);
    };
    Color.prototype.generateLighterColorToHover = function () {
        var _this = this;
        return this.applyLightColor(function () { return _this.thresholdToLightenHover; });
    };
    Color.prototype.generateLighterColorToFocus = function () {
        var _this = this;
        return this.applyLightColor(function () { return _this.thresholdToLightenFocus; });
    };
    Color.prototype.generateColorFromCurrentLight = function (tax) {
        var _a = this.hsl(), h = _a.h, s = _a.s, l = _a.l;
        h /= 100;
        s /= 100;
        l /= 100;
        l = l + tax;
        var _b = this.HSVtoRGB(h, s, l), r = _b.r, g = _b.g, b = _b.b;
        return new Color(r, g, b);
    };
    Color.prototype.generateDarkColor = function () {
        var _a = this.hsl(), h = _a.h, s = _a.s, l = _a.l;
        h /= 100;
        s /= 100;
        l /= 100;
        l = Math.min(this.thresholdToDarkenHover, Math.max(0, l > this.thresholdToDecreaseDarkValue
            ? l - this.thresholdToDecreaseDarkValue
            : l));
        var _b = this.HSVtoRGB(h, s, l), r = _b.r, g = _b.g, b = _b.b;
        return new Color(r, g, b);
    };
    Color.prototype.generateOpacityLightString = function () {
        return this.toStringWithOpacity(0.15);
    };
    Color.prototype.generateOpacityLightFocusString = function () {
        return this.toStringWithOpacity(0.5);
    };
    Color.prototype.clamp = function (value, limit) {
        if (limit === void 0) { limit = 255; }
        if (value > limit) {
            value = limit;
        }
        if (value < 0) {
            value = 0;
        }
        return value;
    };
    Color.hexColorRegExp = /^\#?([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$/;
    Color.rgbColorRegExp = /rgba{0,1}\(\d{1,3}\,\d{1,3}\,\d{1,3}?(\,?(\d{1}|(\d{0,1}\.\d{1,3}))){0,1}\)/g;
    Color.hslColorRegExp = /hsla{0,1}\(\d{1,3}\,\d{1,3}\%\,\d{1,3}\%()?(\,?(\d{1}|(\d{0,1}\.\d{1,3}))){0,1}\)/g;
    return Color;
}());

var Solver = /** @class */ (function () {
    function Solver(target) {
        this.target = target;
        this.targetHSL = target.hsl();
        this.reusedColor = new Color(0, 0, 0); // Object pool
    }
    Solver.prototype.solve = function () {
        var result = this.solveNarrow(this.solveWide());
        return {
            values: result.values,
            loss: result.loss,
            filter: this.css(result.values),
        };
    };
    Solver.prototype.solveWide = function () {
        var A = 5;
        var c = 15;
        var a = [60, 180, 18000, 600, 1.2, 1.2];
        var best = { loss: Infinity };
        for (var i = 0; best.loss > 25 && i < 3; i++) {
            var initial = [50, 20, 3750, 50, 100, 100];
            var result = this.spsa(A, a, c, initial, 1000);
            if (result.loss < best.loss) {
                best = result;
            }
        }
        return best;
    };
    Solver.prototype.solveNarrow = function (wide) {
        var A = wide.loss;
        var c = 2;
        var A1 = A + 1;
        var a = [0.25 * A1, 0.25 * A1, A1, 0.25 * A1, 0.2 * A1, 0.2 * A1];
        return this.spsa(A, a, c, wide.values, 500);
    };
    Solver.prototype.spsa = function (A, a, c, values, iters) {
        var alpha = 1;
        var gamma = 0.16666666666666666;
        var best = null;
        var bestLoss = Infinity;
        var deltas = new Array(6);
        var highArgs = new Array(6);
        var lowArgs = new Array(6);
        for (var k = 0; k < iters; k++) {
            var ck = c / Math.pow(k + 1, gamma);
            for (var i = 0; i < 6; i++) {
                deltas[i] = Math.random() > 0.5 ? 1 : -1;
                highArgs[i] = values[i] + ck * deltas[i];
                lowArgs[i] = values[i] - ck * deltas[i];
            }
            var lossDiff = this.loss(highArgs) - this.loss(lowArgs);
            for (var i = 0; i < 6; i++) {
                var g = lossDiff / (2 * ck) * deltas[i];
                var ak = a[i] / Math.pow(A + k + 1, alpha);
                values[i] = fix(values[i] - ak * g, i);
            }
            var loss = this.loss(values);
            if (loss < bestLoss) {
                best = values.slice(0);
                bestLoss = loss;
            }
        }
        return { values: best, loss: bestLoss };
        function fix(value, idx) {
            var max = 100;
            if (idx === 2 /* saturate */) {
                max = 7500;
            }
            if (idx === 4 /* brightness */ || idx === 5 /* contrast */) {
                max = 200;
            }
            if (idx === 3 /* hue-rotate */) {
                if (value > max) {
                    value = value % max;
                }
                if (value < 0) {
                    value = max + value % max;
                }
            }
            else {
                if (value < 0) {
                    value = 0;
                }
                if (value > max) {
                    value = max;
                }
            }
            return value;
        }
    };
    Solver.prototype.loss = function (filters) {
        var color = this.reusedColor;
        color.set(0, 0, 0);
        color.invert(filters[0] / 100);
        color.sepia(filters[1] / 100);
        color.saturate(filters[2] / 100);
        color.hueRotate(filters[3] * 3.6);
        color.brightness(filters[4] / 100);
        color.contrast(filters[5] / 100);
        var colorHSL = color.hsl();
        return Math.abs(color.r - this.target.r)
            + Math.abs(color.g - this.target.g)
            + Math.abs(color.b - this.target.b)
            + Math.abs(colorHSL.h - this.targetHSL.h)
            + Math.abs(colorHSL.s - this.targetHSL.s)
            + Math.abs(colorHSL.l - this.targetHSL.l);
    };
    Solver.prototype.css = function (filters) {
        function fmt(idx, multiplier) {
            if (multiplier === void 0) { multiplier = 1; }
            return Math.round(filters[idx] * multiplier);
        }
        return "invert(".concat(fmt(0), "%) sepia(").concat(fmt(1), "%) saturate(").concat(fmt(2), "%) hue-rotate(").concat(fmt(3, 3.6), "deg) brightness(").concat(fmt(4), "%) contrast(").concat(fmt(5), "%);");
    };
    return Solver;
}());

var cache$1 = {};
var transformToFilter = function (color) {
    try {
        if (cache$1.hasOwnProperty(color)) {
            return cache$1[color];
        }
        var colorInstance = Color.generate(color);
        var filter = new Solver(colorInstance).solve().filter;
        cache$1[color] = filter;
        return filter;
    }
    catch (_a) {
        return 'none';
    }
};

function _forceString(text, trimmed) {
    if (text === void 0) { text = ''; }
    if (trimmed === void 0) { trimmed = true; }
    if (typeof text !== 'string') {
        text = '';
    }
    return trimmed ? text === null || text === void 0 ? void 0 : text.trim() : text;
}
/**
 * Limpa a(s) barra(s) no final da URL informada
 *
 * @param url
 */
function urlSanitizer(url) {
    return _forceString(url).replace(/\/$/, '');
}
/**
 * Atalho para `encodeURIComponent()`
 * @param url Algo que precisa de ser codificado
 */
function urlEncode(url) {
    return encodeURIComponent(url);
}
/**
 * Atalho para `decodeURIComponent()`
 * @param url Algo que precisa de ser decodificado
 */
function urlDecode(url) {
    return decodeURIComponent(url);
}
/**
 * Atalho para codificar em base64 usando UTF-8
 * @param str Texto a ser codificado
 */
function base64Encode(str) {
    return btoa(urlEncode(str).replace(/%([0-9A-F]{2})/g, function (_, char) {
        return String.fromCharCode(parseInt('0x' + char, 16));
    }));
}
/**
 * Atalho para decodificar um texto em UTF-8 na codificação base64
 * @param base64 Texto a ser decodificado
 */
function base64Decode(base64) {
    return urlDecode(atob(base64)
        .split('')
        .map(function (char) { return '%' + ('00' + char.charCodeAt(0).toString(16)).slice(-2); })
        .join(''));
}
/**
 * Atalho para decodificar um texto em UTF-8 na codificação base64
 * Retornando um TypedArray: Uint8Array
 * @param base64 Texto a ser decodificado
 */
function base64DecodeToTypedArray(base64) {
    var binaryString = base64Decode(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}
/**
 * Atalho para decodificar um texto em UTF-8 na codificação base64
 * Retornando um Blob
 * @param base64 Texto a ser decodificado
 * @param contentType Mime type do Blob
 */
function base64DecodeToBlob(base64, contentType) {
    contentType = contentType || 'application/octet-stream';
    return new Blob([base64DecodeToTypedArray(base64)], { type: contentType });
}
/**
 * Atalho para para converter uma string em objeto Blob
 * Retornando um Blob
 * @param str Texto a ser decodificado
 * @param contentType Mime type do Blob
 */
function stringToBlob(str, contentType) {
    if (contentType === void 0) { contentType = 'application/octet-stream'; }
    return new Blob([stringToTypedArray(str)], { type: contentType });
}
/**
 * Atalho para decodificar um texto em TypedArray
 * Retornando um TypedArray: Uint8Array
 * @param str Texto a ser decodificado
 */
function stringToTypedArray(str) {
    var binaryLen = str.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
        bytes[i] = str.charCodeAt(i);
    }
    return bytes;
}
/**
 * Verifica se o valor passado contém um número válido
 * Retornando um boolean
 * @param value Valor a ser validado como númerico
 */
function isNumeric(value) {
    return !isNaN(value);
}
/*
 * Remove todas as tags de um HTML informado
 * Retornando o texto sem as tags
 * @param html
 */
function stripHtmlTags(html) {
    if (html === void 0) { html = ''; }
    return _forceString(html, false).replace(/<[^>]*>/g, '');
}
/**
 * Normaliza o texto informado para minúsculo e sem acentuações
 * @param text
 */
function normalize(text) {
    if (text === void 0) { text = ''; }
    text = _forceString(text);
    if (!text) {
        return '';
    }
    var i;
    var normalized = String(text).toLowerCase().trim();
    var map = {
        a: '[àáâãäå]',
        e: '[èéêë]',
        i: '[ìíîï]',
        o: '[òóôõö]',
        u: '[ùúûűü]',
        y: '[ýÿ]',
        c: 'ç',
        n: 'ñ',
        '-': '–',
        ' ': '\\s+',
    };
    for (i in map) {
        if (map.hasOwnProperty(i)) {
            normalized = normalized.replace(new RegExp(map[i], 'img'), i);
        }
    }
    normalized = normalized.replace(/\s+/g, ' ');
    return normalized;
}
/**
 * Aplica a abreviação retornando a sigla do nome de acordo com o 1º e o ultimo nome
 * @param name Nome a ser abreviado
 */
function nameAbbreviation(name) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (name === void 0) { name = ''; }
    name = _forceString(name);
    var filterRegex = /^D[AEO]$/g;
    var nameSplitted = ((_b = (_a = name === null || name === void 0 ? void 0 : name.toUpperCase()) === null || _a === void 0 ? void 0 : _a.split(' ')) !== null && _b !== void 0 ? _b : [])
        .map(function (term) { return term.trim(); })
        .filter(function (term) { return !filterRegex.test(term); });
    var firstIndex = 0;
    var lastIndex = nameSplitted.length - 1;
    var first = (_e = (_d = (_c = nameSplitted === null || nameSplitted === void 0 ? void 0 : nameSplitted[firstIndex]) === null || _c === void 0 ? void 0 : _c.charAt) === null || _d === void 0 ? void 0 : _d.call(_c, 0)) !== null && _e !== void 0 ? _e : '';
    var last = '';
    if (firstIndex < lastIndex) {
        last = (_h = (_g = (_f = nameSplitted === null || nameSplitted === void 0 ? void 0 : nameSplitted[lastIndex]) === null || _f === void 0 ? void 0 : _f.charAt) === null || _g === void 0 ? void 0 : _g.call(_f, 0)) !== null && _h !== void 0 ? _h : '';
    }
    return "".concat(first).concat(last);
}
/**
 * Retorna a primeira letra maiuscula do texto informado
 * @param text Texto a ser modificado
 */
function firstLetterUpperCase(text) {
    var _a;
    if (text === void 0) { text = ''; }
    text = _forceString(text);
    var firstLetter = (_a = text === null || text === void 0 ? void 0 : text.charAt(0)) === null || _a === void 0 ? void 0 : _a.toUpperCase();
    var othersLetters = text === null || text === void 0 ? void 0 : text.substr(1);
    return firstLetter + othersLetters;
}
/**
 * Retorna o valor com a unidade
 * @param value Valor com a unidade ou só o número para concatenar com a unidade padrão. Caso passado undefined retorna "0"
 * @param unit Unidade de retono caso passado um número no value. Unidade padrão "px"
 */
function numberWithUnit(value, unit, empty) {
    if (unit === void 0) { unit = 'px'; }
    if (empty === void 0) { empty = 'initial'; }
    if (!value) {
        return empty;
    }
    return isNumeric(value) ? "".concat(value).concat(unit) : "".concat(value);
}
/**
 * Converte o input em camelCase. Exemplo passando 'um-dois-tres' vai retornar umDoisTres
 * @param input Valor de entrada
 * @param separator Separador das palavras. Padrão: "-"
 * @returns A string no padrão camelCase
 */
function camelCase(input, separator) {
    if (separator === void 0) { separator = '-'; }
    var regExp = new RegExp("\\".concat(separator.toLowerCase(), "(.)"), 'g');
    return input
        .toLowerCase()
        .replace(regExp, function (_, letter) { var _a; return (_a = letter === null || letter === void 0 ? void 0 : letter.toUpperCase) === null || _a === void 0 ? void 0 : _a.call(letter); });
}

var StaticAssetStyled = styled.img(templateObject_3$D || (templateObject_3$D = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  filter: ", ";\n\n  ", "\n\n  &::selection {\n    background: transparent;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  filter: ", ";\n\n  ", "\n\n  &::selection {\n    background: transparent;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n"])), function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var filter = _a.filter;
    return filter;
}, function (_a) {
    var colorTransition = _a.colorTransition;
    return colorTransition && css(templateObject_1$Z || (templateObject_1$Z = __makeTemplateObject(["\n      transition: filter ", ";\n    "], ["\n      transition: filter ", ";\n    "])), "\n        ".concat(BaSeTheme.transitions["duration".concat(firstLetterUpperCase(colorTransition))], "\n        ").concat(BaSeTheme.transitions.continuousTimingFunction, "\n      "));
}, function (_a) {
    var onClick = _a.onClick;
    return onClick && css(templateObject_2$N || (templateObject_2$N = __makeTemplateObject(["\n      cursor: pointer;\n      // TODO ver qual vai ser o efeito de focus e hover\n      // &:focus {\n      //   ...\n      // }\n      // &:hover {\n      //   ...\n      // }\n    "], ["\n      cursor: pointer;\n      // TODO ver qual vai ser o efeito de focus e hover\n      // &:focus {\n      //   ...\n      // }\n      // &:hover {\n      //   ...\n      // }\n    "])));
});
var templateObject_1$Z, templateObject_2$N, templateObject_3$D;

function getSrc(path) {
    if (!path) {
        return '';
    }
    return "".concat(urlSanitizer(BaSeConfig.staticAssetsUrl), "/").concat(path);
}
var BaSeStaticAsset = React.memo(function (_a) {
    var path = _a.path, description = _a.description, width = _a.width, height = _a.height, color = _a.color, colorTransition = _a.colorTransition, onClick = _a.onClick;
    if (!description) {
        throw Error('Informe a descrição da imagem. Atributo "description"');
    }
    var fallbackImage = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    var _b = React.useState(typeof path === 'string' ? [path] : path), paths = _b[0], setPaths = _b[1];
    var _c = React.useState(paths[0]), pathToApply = _c[0], setPathToApply = _c[1];
    var _d = React.useState(), src = _d[0], setSrc = _d[1];
    var filter = React.useMemo(function () { return (!!color ? transformToFilter(color) : 'none'); }, [color]);
    React.useEffect(function () { return setPaths(typeof path === 'string' ? [path] : path); }, [path]);
    React.useEffect(function () { return setPathToApply(paths[0]); }, [paths]);
    React.useEffect(function () { return setSrc(getSrc(pathToApply)); }, [pathToApply]);
    return (React.createElement(StaticAssetStyled, { decoding: "async", loading: "lazy", src: src, alt: description, width: width, height: height, filter: filter, colorTransition: colorTransition, onError: function () {
            return paths.length === 0
                ? setSrc(fallbackImage)
                : setPaths(function (actualPaths) {
                    return actualPaths.filter(function (_, index) { return index > 0; });
                });
        }, onClick: onClick, onKeyDown: function (e) { return e.key === 'Enter' && (onClick === null || onClick === void 0 ? void 0 : onClick(e)); }, tabIndex: onClick ? 0 : -1, role: onClick ? 'button' : undefined }));
});
BaSeStaticAsset.displayName = 'BaSeStaticAsset';

function extractWidthHeight(size, width, height) {
    width = numberWithUnit(size !== null && size !== void 0 ? size : width);
    height = numberWithUnit(size !== null && size !== void 0 ? size : height);
    return {
        width: width,
        height: height,
    };
}

var BaSeIcon = function (_a) {
    var name = _a.name, description = _a.description, size = _a.size, color = _a.color, colorTransition = _a.colorTransition, onClick = _a.onClick;
    return (React.createElement(BaSeStaticAsset, __assign({}, extractWidthHeight(size), { description: description, path: "images/icons/".concat(name, ".svg"), color: color, colorTransition: colorTransition, onClick: onClick })));
};
BaSeIcon.displayName = 'BaSeIcon';

var TextButton = styled.span(templateObject_1$Y || (templateObject_1$Y = __makeTemplateObject(["\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    font-size : ", "em;\n    font-weight : ", ";\n    font-style : normal;\n    font-family : ", ";\n    color: ", ";\n    line-height: ", "em;\n    align-self: auto;\n    margin-left:\n    ", ";\n    margin-right:", "\n"], ["\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    font-size : ", "em;\n    font-weight : ", ";\n    font-style : normal;\n    font-family : ", ";\n    color: ", ";\n    line-height: ", "em;\n    align-self: auto;\n    margin-left:\n    ", ";\n    margin-right:", "\n"])), function (props) { return props.fontSize; }, function (props) { return props.fontWeigt; }, BaSeTheme.typography.fontFamily, function (props) { return props.color; }, function (props) { return props.lineHeight; }, function (props) { return !!props.hasLeftIcon
    ? props.fontSize > 1
        ? '12px'
        : '8px'
    : '0px'; }, function (props) { return !!props.hasRightIcon
    ? props.fontSize > 1
        ? '12px'
        : '8px'
    : '0px'; });
var templateObject_1$Y;

var BaSeTextButton = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#ffffff' : _b, _c = _a.fontSize, fontSize = _c === void 0 ? 1 : _c, _d = _a.lineHeight, lineHeight = _d === void 0 ? 1.2 : _d, _e = _a.hasLeftIcon, hasLeftIcon = _e === void 0 ? false : _e, _f = _a.hasRightIcon, hasRightIcon = _f === void 0 ? false : _f, _g = _a.fontWeigt, fontWeigt = _g === void 0 ? 'normal' : _g, _h = _a.children, children = _h === void 0 ? '' : _h;
    return (React.createElement(TextButton, { color: color, fontSize: fontSize, lineHeight: lineHeight, hasLeftIcon: hasLeftIcon, hasRightIcon: hasRightIcon, fontWeigt: fontWeigt }, children));
};
BaSeTextButton.displayName = 'BaSeTextButton';

var spinnerMap = {
    // TODO verificar cores se estão mapeadas
    primary: {
        darkColor: '#8FB8EF',
        mediumColor: Color.generateMiddleColor('#8FB8EF', '#e0edfb').toString(),
        lightColor: '#e0edfb',
        negative: {
            darkColor: '#005eb8',
            mediumColor: Color.generateMiddleColor('#005eb8', '#f0f3f6').toString(),
            lightColor: '#f0f3f6',
        },
    },
    secondary: {
        darkColor: '#394D60',
        mediumColor: Color.generateMiddleColor('#394D60', '#e0e5eb').toString(),
        lightColor: '#e0e5eb',
        negative: {
            darkColor: '#394D60',
            mediumColor: Color.generateMiddleColor('#394D60', '#e0e5eb').toString(),
            lightColor: '#e0e5eb',
        },
    },
    tertiary: {
        darkColor: '#005eb8',
        mediumColor: Color.generateMiddleColor('#005eb8', '#f0f3f6').toString(),
        lightColor: '#f0f3f6',
        negative: {
            darkColor: '#394D60',
            mediumColor: Color.generateMiddleColor('#394D60', '#e0e5eb').toString(),
            lightColor: '#e0e5eb',
        },
    },
    disabled: {
        darkColor: '#394D60',
        mediumColor: Color.generateMiddleColor('#394D60', '#e0e5eb').toString(),
        lightColor: '#e0e5eb',
    },
};
var spinnerCustomMap = function (color, primary) {
    var _a, _b, _c;
    return ({
        darkColor: (_a = Color.generate(color !== null && color !== void 0 ? color : BaSeTheme.colors.institucionais.azulSebrae)) === null || _a === void 0 ? void 0 : _a.generateColorFromCurrentLight(primary ? 0.1 : 0).toString(),
        mediumColor: (_b = Color.generate(color !== null && color !== void 0 ? color : BaSeTheme.colors.institucionais.azulSebrae)) === null || _b === void 0 ? void 0 : _b.applyLightColor(function () { return 0.85; }).toString(),
        lightColor: (_c = Color.generate(color !== null && color !== void 0 ? color : BaSeTheme.colors.institucionais.azulSebrae)) === null || _c === void 0 ? void 0 : _c.applyLightColor(function () { return 0.99; }).toString(),
    });
};
var mappedSingleColors = {
    destructive: BaSeTheme.colors.feedbackInterface.erro45,
    confirmation: BaSeTheme.colors.feedbackInterface.sucesso26,
};

var loadingRotatation = keyframes(templateObject_1$X || (templateObject_1$X = __makeTemplateObject(["\n  to {\n    transform: rotate(2turn);\n  }\n"], ["\n  to {\n    transform: rotate(2turn);\n  }\n"])));
var loadingSize = keyframes(templateObject_2$M || (templateObject_2$M = __makeTemplateObject(["\n  from, 60% {\n    stroke-dasharray: 100% 180%;\n  }\n"], ["\n  from, 60% {\n    stroke-dasharray: 100% 180%;\n  }\n"])));
var GenericAnimated = styled.span(templateObject_3$C || (templateObject_3$C = __makeTemplateObject(["\n  stroke: ", ";\n  stroke-linecap: round;\n  stroke-dasharray: 180% 100%;\n  animation: ", " 3s cubic-bezier(0.5, -0.4, 0.5, 1.4) infinite,\n    ", " 1.5s cubic-bezier(0.5, -0.8, 0.5, 1.8) infinite alternate;\n"], ["\n  stroke: ", ";\n  stroke-linecap: round;\n  stroke-dasharray: 180% 100%;\n  animation: ", " 3s cubic-bezier(0.5, -0.4, 0.5, 1.4) infinite,\n    ", " 1.5s cubic-bezier(0.5, -0.8, 0.5, 1.8) infinite alternate;\n"])), BaSeTheme.colors.defaultColors.white, loadingRotatation, loadingSize);
var UseSpinnerAnimated = function (props) { return React.createElement(GenericAnimated, __assign({ as: "use" }, props)); };
var GenericGradient = styled.span(templateObject_5$t || (templateObject_5$t = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var uuid = _a.uuid, index = _a.index, rotation = _a.rotation;
    return css(templateObject_4$w || (templateObject_4$w = __makeTemplateObject(["\n    transform: rotate(", ");\n    mask: url('#base-loading-spinner-", "-mask');\n    stroke: url('#base-loading-spinner-", "-gradient-", "');\n  "], ["\n    transform: rotate(", ");\n    mask: url('#base-loading-spinner-", "-mask');\n    stroke: url('#base-loading-spinner-", "-gradient-", "');\n  "])), rotation, uuid, uuid, index);
});
var GeometrySpinnerGradient = function (_a) {
    var children = _a.children, index = _a.index, uuid = _a.uuid, rotation = _a.rotation;
    return (React.createElement(GenericGradient, { as: "g", index: index, uuid: uuid, rotation: rotation }, children));
};
var SvgSpinner = styled.svg(templateObject_7$o || (templateObject_7$o = __makeTemplateObject(["\n  ", "\n  fill: none;\n  stroke: transparent;\n  stroke-width: 12%;\n  background: transparent;\n  transform: rotate(110deg);\n"], ["\n  ", "\n  fill: none;\n  stroke: transparent;\n  stroke-width: 12%;\n  background: transparent;\n  transform: rotate(110deg);\n"])), function (_a) {
    var diameter = _a.diameter;
    return css(templateObject_6$s || (templateObject_6$s = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n  "], ["\n    width: ", "px;\n    height: ", "px;\n  "])), diameter, diameter);
});
var LoadingContainer = styled.div(templateObject_9$k || (templateObject_9$k = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: grid;\n  place-items: center;\n  padding: 32px;\n  box-sizing: border-box;\n  ", "\n"], ["\n  width: 100%;\n  height: 100%;\n  display: grid;\n  place-items: center;\n  padding: 32px;\n  box-sizing: border-box;\n  ", "\n"])), function (_a) {
    var roundedCorner = _a.roundedCorner, shadow = _a.shadow, backgroundColor = _a.backgroundColor;
    return css(templateObject_8$m || (templateObject_8$m = __makeTemplateObject(["\n    border-radius: ", "px;\n    box-shadow: ", ";\n    background-color: ", ";\n  "], ["\n    border-radius: ", "px;\n    box-shadow: ", ";\n    background-color: ", ";\n  "])), roundedCorner ? 12 : 0, shadow !== null && shadow !== void 0 ? shadow : 'none', backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : BaSeTheme.colors.defaultColors.transparent);
});
var LoadingItems = styled.div(templateObject_10$g || (templateObject_10$g = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n"])));
var templateObject_1$X, templateObject_2$M, templateObject_3$C, templateObject_4$w, templateObject_5$t, templateObject_6$s, templateObject_7$o, templateObject_8$m, templateObject_9$k, templateObject_10$g;

var validateType = function (type) {
    if (type === 'primary' || type === 'secondary' || type === 'tertiary') {
        return type;
    }
    return 'primary';
};
var idSequence$c = idGenerator();
var BaSeLoadingSpinner = function (_a) {
    var _b = _a.diameter, diameter = _b === void 0 ? 64 : _b, _c = _a.description, description = _c === void 0 ? 'Carregando… Aguarde.' : _c, color = _a.color, _d = _a.type, type = _d === void 0 ? 'tertiary' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e;
    var uuid = useNextHashId(idSequence$c);
    // TODO refatorar operadores ternarios para algo mais simples
    var mappedColorValues = disabled
        ? spinnerMap.disabled
        : color === 'negative'
            ? spinnerMap[validateType(type)].negative
            : !color || color === 'default'
                ? spinnerMap[validateType(type)]
                : color in mappedSingleColors
                    ? spinnerCustomMap(mappedSingleColors[color], type === 'primary')
                    : spinnerCustomMap(color, type === 'primary');
    var darkColor = mappedColorValues.darkColor, lightColor = mappedColorValues.lightColor, mediumColor = mappedColorValues.mediumColor;
    var halfDiameter = (diameter / 2).toFixed(1);
    var quarterDiameter = (diameter / 4).toFixed(1);
    return (React.createElement(SvgSpinner, { role: "img", className: "BaSe--loading-spinner", "aria-label": description || undefined, "aria-hidden": !description ? 'true' : undefined, viewBox: "-".concat(halfDiameter, " -").concat(quarterDiameter, " ").concat(diameter, " ").concat(halfDiameter), diameter: diameter },
        React.createElement("linearGradient", { id: "base-loading-spinner-".concat(uuid, "-gradient-1") },
            React.createElement("stop", { stopColor: mediumColor }),
            React.createElement("stop", { stopColor: darkColor, offset: "1" })),
        React.createElement("linearGradient", { id: "base-loading-spinner-".concat(uuid, "-gradient-2") },
            React.createElement("stop", { stopColor: lightColor }),
            React.createElement("stop", { stopColor: mediumColor, offset: "1" })),
        React.createElement("circle", { id: "base-loading-spinner-".concat(uuid, "-circle"), r: "50%" }),
        React.createElement("mask", { id: "base-loading-spinner-".concat(uuid, "-mask") },
            React.createElement("circle", null),
            React.createElement(UseSpinnerAnimated, { xlinkHref: "#base-loading-spinner-".concat(uuid, "-circle") })),
        React.createElement(GeometrySpinnerGradient, { rotation: "310deg", index: "2", uuid: uuid },
            React.createElement("use", { xlinkHref: "#base-loading-spinner-".concat(uuid, "-circle") })),
        React.createElement(GeometrySpinnerGradient, { rotation: "80deg", index: "1", uuid: uuid },
            React.createElement("use", { xlinkHref: "#base-loading-spinner-".concat(uuid, "-circle") }))));
};
BaSeLoadingSpinner.displayName = 'BaSeLoadingSpinner';

var buttonWidth = function (width) { return css(templateObject_1$W || (templateObject_1$W = __makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), numberWithUnit(width)); };
var StyledButton = styled.button(templateObject_5$s || (templateObject_5$s = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor, width = _a.width, border = _a.border, padding = _a.padding, minWidth = _a.minWidth, justifyContent = _a.justifyContent, backgroundOnHover = _a.backgroundOnHover, boxShadowFocus = _a.boxShadowFocus, hideBorder = _a.hideBorder, boxShadow = _a.boxShadow, thickBorder = _a.thickBorder, medium = _a.medium;
    return css(templateObject_4$v || (templateObject_4$v = __makeTemplateObject(["\n    position: relative;\n    background-color: ", ";\n    ", "\n    min-width: ", "px;\n    border-radius: 4px;\n    border: ", ";\n    padding: ", ";\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: ", ";\n    transition: ", ";\n    ", "\n    ", "\n    &:hover {\n      cursor: pointer;\n      background-color: ", ";\n    }\n    &:focus {\n      outline: none;\n      box-shadow: ", ";\n      ", "\n    }\n    &:active:not(:disabled) {\n      box-shadow: none;\n      transform: translateY(2px);\n    }\n    &:disabled {\n      cursor: not-allowed;\n    }\n  "], ["\n    position: relative;\n    background-color: ", ";\n    ", "\n    min-width: ", "px;\n    border-radius: 4px;\n    border: ", ";\n    padding: ", ";\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: ", ";\n    transition: ", ";\n    ", "\n    ", "\n    &:hover {\n      cursor: pointer;\n      background-color: ", ";\n    }\n    &:focus {\n      outline: none;\n      box-shadow: ", ";\n      ", "\n    }\n    &:active:not(:disabled) {\n      box-shadow: none;\n      transform: translateY(2px);\n    }\n    &:disabled {\n      cursor: not-allowed;\n    }\n  "])), backgroundColor, buttonWidth(width), minWidth, border, padding, justifyContent, BaSeTheme.transitions.allPropertiesContinuousFast, medium && css(templateObject_2$L || (templateObject_2$L = __makeTemplateObject(["\n      min-height: 40px;\n    "], ["\n      min-height: 40px;\n    "]))), boxShadow && css(templateObject_3$B || (templateObject_3$B = __makeTemplateObject(["\n      box-shadow: ", ";\n    "], ["\n      box-shadow: ", ";\n    "])), BaSeTheme.shadows.profundidade2), backgroundOnHover, boxShadowFocus, hideBorder &&
        "border: ".concat(thickBorder ? 2 : 1, "px solid ").concat(BaSeTheme.colors.defaultColors.transparent, ";"));
});
var SpinnerContainer = styled.div(templateObject_7$n || (templateObject_7$n = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var size = _a.size;
    return css(templateObject_6$r || (templateObject_6$r = __makeTemplateObject(["\n    margin-right: ", "px;\n    display: grid;\n    place-items: center;\n  "], ["\n    margin-right: ", "px;\n    display: grid;\n    place-items: center;\n  "])), size === 'big' ? 12 : 4);
});
var templateObject_1$W, templateObject_2$L, templateObject_3$B, templateObject_4$v, templateObject_5$s, templateObject_6$r, templateObject_7$n;

var lightLevelHover = 0.65;
var lightLevelFocus = 0.7;
var opacityLevelHover = 0.14;
var opacityLevelFocus = 0.83;
var getHSLValues = function (color) {
    var _a;
    if (!color) {
        return null;
    }
    if (typeof color === 'string') {
        var newColor = Color.generate(color);
        if (newColor) {
            return newColor.hsl();
        }
        return null;
    }
    return (_a = color) === null || _a === void 0 ? void 0 : _a.hsl();
};
var hueMapperHover = function (color) {
    if (!color) {
        return;
    }
    var _a = color.hsl(), h = _a.h, s = _a.s;
    h /= 100;
    s /= 100;
    var _b = color.HSVtoRGB(h, s, lightLevelHover), r = _b.r, g = _b.g, b = _b.b;
    return new Color(r, g, b).toStringWithOpacity(opacityLevelHover);
};
var hueMapperFocus = function (color) {
    if (!color) {
        return;
    }
    var _a = color.hsl(), h = _a.h, s = _a.s;
    h /= 100;
    s /= 100;
    var _b = color.HSVtoRGB(h, s, lightLevelFocus), r = _b.r, g = _b.g, b = _b.b;
    return new Color(r, g, b).toStringWithOpacity(opacityLevelFocus);
};
var createButtonHoverColor = function (color) {
    var baseColorObj = Color.generate(color);
    if (baseColorObj === null || baseColorObj === void 0 ? void 0 : baseColorObj.isGrayScale()) {
        return baseColorObj.toStringWithOpacity(0.14);
    }
    return hueMapperHover(baseColorObj);
};
var createButtonFocusColor = function (color) {
    var baseColorObj = Color.generate(color);
    if (baseColorObj === null || baseColorObj === void 0 ? void 0 : baseColorObj.isGrayScale()) {
        return baseColorObj.toStringWithOpacity(0.83);
    }
    return hueMapperFocus(baseColorObj);
};
var createButtonDarkTextColor = function (color) {
    var baseColorObj = Color.generate(color);
    if (!baseColorObj) {
        return;
    }
    var _a = baseColorObj.hsl(), h = _a.h, l = _a.l, s = _a.s;
    var newL = l / 100;
    var reduceValue = 0.1;
    newL = Math.max(0, newL - reduceValue);
    var _b = baseColorObj.HSVtoRGB(h / 100, s / 100, newL), r = _b.r, g = _b.g, b = _b.b;
    return new Color(r, g, b).toString();
};
var createColor = function (color, colorConfig) {
    if (!color) {
        return '#000';
    }
    if (!colorConfig) {
        return color;
    }
    try {
        var colorClass = Color.generate(color);
        if (!colorClass) {
            return '#000';
        }
        var _a = colorClass.hsl(), ccH = _a.h, ccS = _a.s, ccL = _a.l;
        var h = colorConfig.h, s = colorConfig.s, l = colorConfig.l, opacity = colorConfig.opacity;
        var _b = colorClass.HSVtoRGB(h !== null && h !== void 0 ? h : ccH / 100, s !== null && s !== void 0 ? s : ccS / 100, l !== null && l !== void 0 ? l : ccL / 100), r = _b.r, g = _b.g, b = _b.b;
        var newColorClass = new Color(r, g, b, opacity);
        return newColorClass.toString();
    }
    catch (e) {
        return '#000';
    }
};
var createColorSmartLightingControl = function (color, colorConfig, lightLevel) {
    var gapThreshold = 0.05;
    if (Color.validateColor(color) && colorConfig) {
        var colorClass = Color.generate(color);
        if (!colorClass) {
            return '#000';
        }
        var light = colorClass.hsl().l;
        var l = colorConfig.l;
        if (l && lightLevel) {
            if (lightLevel === 'darker' && light / 100 < l + gapThreshold) {
                return createColor(color, __assign(__assign({}, colorConfig), { l: light / 200 }));
            }
            if (lightLevel === 'lighter' && light / 100 > l - gapThreshold) {
                var newLight = light / 100;
                return createColor(color, __assign(__assign({}, colorConfig), { l: newLight + (1 - newLight) / 2 }));
            }
            return createColor(color, colorConfig);
        }
    }
    return createColor(color, colorConfig);
};

var inst$1 = BaSeTheme.colors.institucionais;
var feed$1 = BaSeTheme.colors.feedbackInterface;
var reduceLevel$1 = function (level) {
    if (level > 1 && level <= 100) {
        level /= 100;
    }
    return level;
};
var memo = {};
var ColorMapper = {
    default: {
        foreground: inst$1.azulSebrae36,
        hover: {
            defaultDark: inst$1.azulSebrae30,
            defaultLight: inst$1.azulSebrae97,
            transparentLight: createColor(inst$1.azulSebrae97, {
                l: reduceLevel$1(65),
                opacity: reduceLevel$1(14),
            }),
        },
        focus: {
            defaultLight: inst$1.azulSebrae75,
            transparentLight: createColor(inst$1.azulSebrae75, {
                l: reduceLevel$1(70),
                opacity: reduceLevel$1(83),
            }),
        },
        unchecked: inst$1.azulSebrae60,
        getColorByNumber: function (level) {
            return createColor(inst$1.azulSebrae36, { l: reduceLevel$1(level) });
        },
        getColorByNumberOpacity: function (level, opacity) {
            return createColor(inst$1.azulSebrae36, {
                l: reduceLevel$1(level),
                opacity: reduceLevel$1(opacity),
            });
        },
    },
    grayScale: {
        foreground: inst$1.cinzaSebrae45,
        hover: {
            defaultDark: inst$1.cinzaSebrae30,
            defaultLight: inst$1.cinzaSebrae97,
        },
        focus: {
            defaultLight: inst$1.cinzaSebrae75,
            transparentLight: '#A8B3BDD4',
        },
        getColorByNumber: function (level) {
            return createColor(inst$1.cinzaSebrae45, { l: reduceLevel$1(level) });
        },
        getColorByNumberOpacity: function (level, opacity) {
            return createColor(inst$1.cinzaSebrae45, {
                l: reduceLevel$1(level),
                opacity: reduceLevel$1(opacity),
            });
        },
    },
    confirmation: {
        foreground: feed$1.sucesso26,
        hover: {
            defaultDark: feed$1.sucesso20,
            defaultLight: feed$1.sucesso95,
            transparentLight: createColor(feed$1.sucesso95, {
                l: reduceLevel$1(65),
                opacity: reduceLevel$1(14),
            }),
        },
        focus: {
            defaultLight: feed$1.sucesso75,
            transparentLight: createColor(feed$1.sucesso75, {
                l: reduceLevel$1(70),
                opacity: reduceLevel$1(83),
            }),
        },
        unchecked: createColor(feed$1.sucesso26, { l: 0.6 }),
        getColorByNumber: function (level) {
            return createColor(feed$1.sucesso26, { l: reduceLevel$1(level) });
        },
        getColorByNumberOpacity: function (level, opacity) {
            return createColor(feed$1.sucesso26, {
                l: reduceLevel$1(level),
                opacity: reduceLevel$1(opacity),
            });
        },
    },
    destructive: {
        foreground: feed$1.erro45,
        hover: {
            defaultDark: feed$1.erro35,
            defaultLight: feed$1.erro95,
            transparentLight: createColor(feed$1.erro95, {
                l: reduceLevel$1(65),
                opacity: reduceLevel$1(14),
            }),
        },
        focus: {
            defaultLight: feed$1.erro75,
            transparentLight: createColor(feed$1.erro75, {
                l: reduceLevel$1(70),
                opacity: reduceLevel$1(83),
            }),
        },
        unchecked: createColor(feed$1.erro45, { l: 0.6 }),
        getColorByNumber: function (level) {
            return createColor(feed$1.erro45, { l: reduceLevel$1(level) });
        },
        getColorByNumberOpacity: function (level, opacity) {
            return createColor(feed$1.erro45, {
                l: reduceLevel$1(level),
                opacity: reduceLevel$1(opacity),
            });
        },
    },
    attention: {
        foreground: feed$1.atencao55,
        hover: {
            defaultDark: feed$1.atencao35,
            defaultLight: feed$1.atencao95,
            transparentLight: createColor(feed$1.atencao95, {
                l: reduceLevel$1(65),
                opacity: reduceLevel$1(14),
            }),
        },
        focus: {
            defaultLight: feed$1.atencao75,
            transparentLight: createColor(feed$1.atencao75, {
                l: reduceLevel$1(70),
                opacity: reduceLevel$1(83),
            }),
        },
        unchecked: createColor(feed$1.atencao55, { l: 0.6 }),
        getColorByNumber: function (level) {
            return createColor(feed$1.atencao55, { l: reduceLevel$1(level) });
        },
        getColorByNumberOpacity: function (level, opacity) {
            return createColor(feed$1.atencao55, {
                l: reduceLevel$1(level),
                opacity: reduceLevel$1(opacity),
            });
        },
    },
    disabled: {
        foreground: inst$1.cinzaSebrae75,
        background: inst$1.cinzaSebrae90,
        lighterBackground: inst$1.cinzaSebrae97,
        bold: inst$1.cinzaSebrae30,
        getColorByNumber: function (level) {
            return createColor(inst$1.cinzaSebrae75, { l: reduceLevel$1(level) });
        },
        getColorByNumberOpacity: function (level, opacity) {
            return createColor(inst$1.cinzaSebrae75, {
                l: reduceLevel$1(level),
                opacity: reduceLevel$1(opacity),
            });
        },
    },
    light: {
        focus: {
            create: function (color) {
                return createColorSmartLightingControl(color, { l: 0.75 }, 'lighter');
            },
            createTransparent: function (color) {
                return createColorSmartLightingControl(color, { l: 0.7, opacity: 0.83 }, 'lighter');
            },
        },
        hover: {
            create: function (color) {
                return createColorSmartLightingControl(color, { l: 0.95 }, 'lighter');
            },
            createTransparent: function (color) {
                return createColorSmartLightingControl(color, { l: 0.6, opacity: 0.14 }, 'lighter');
            },
        },
    },
    dark: {
        hover: {
            create: function (color) {
                return createColorSmartLightingControl(color, { l: 0.3 }, 'darker');
            },
        },
    },
    create: function (color, lightLevel) {
        if (lightLevel > 1 && lightLevel <= 100) {
            lightLevel /= 100;
        }
        return createColor(color, { l: lightLevel });
    },
    createTransparent: function (color, lightLevel, opacity) {
        if (lightLevel > 1 && lightLevel <= 100) {
            lightLevel /= 100;
        }
        if (opacity > 1 && opacity <= 100) {
            opacity /= 100;
        }
        return createColor(color, { l: lightLevel, opacity: opacity });
    },
    createMostUsedColors: function (color) {
        if (memo[color]) {
            return memo[color];
        }
        var darkHoverColor = createColorSmartLightingControl(color, { l: 0.3 }, 'darker');
        var lightHoverColor = createColorSmartLightingControl(color, { l: 0.95 }, 'lighter');
        var lightFocusColor = createColorSmartLightingControl(color, { l: 0.75 }, 'lighter');
        var lightHoverColorTransparent = createColorSmartLightingControl(color, { l: 0.6, opacity: 0.14 }, 'lighter');
        var lightFocusColorTransparent = createColorSmartLightingControl(color, { l: 0.7, opacity: 0.83 }, 'lighter');
        memo[color] = {
            darkHoverColor: darkHoverColor,
            lightFocusColor: lightFocusColor,
            lightHoverColor: lightHoverColor,
            lightFocusColorTransparent: lightFocusColorTransparent,
            lightHoverColorTransparent: lightHoverColorTransparent,
        };
        return memo[color];
    },
    typography: {
        default: inst$1.cinzaSebrae,
        strong: inst$1.cinzaSebrae30,
        soft: inst$1.cinzaSebrae45,
        unselected: inst$1.cinzaSebrae60,
        selected: inst$1.cinzaSebrae20,
    },
    isValidType: function (color) {
        return color === 'default' ||
            color === 'confirmation' ||
            color === 'attention' ||
            color === 'destructive';
    },
    isValidColor: function (color) { return Color.validateColor(color); },
    getColor: function (color, defaultReturn) {
        var _a;
        var stringReturn = defaultReturn !== null && defaultReturn !== void 0 ? defaultReturn : '';
        if (!color) {
            return stringReturn;
        }
        if (Color.validateColor(color)) {
            return color;
        }
        if (ColorMapper.isValidType(color)) {
            return (_a = ColorMapper[color]) === null || _a === void 0 ? void 0 : _a.foreground;
        }
        return stringReturn;
    },
};

var reduceLevel = function (level) {
    if (level > 1 && level <= 100) {
        level /= 100;
    }
    return level;
};
// *********************
// REGULAR BUTTONS
// *********************
var mapButtonValues = {
    primary: {
        default: {
            color: BaSeTheme.colors.defaultColors.white,
            iconColor: BaSeTheme.colors.defaultColors.white,
            style: {
                bgC: ColorMapper.default.foreground,
                bcCHover: ColorMapper.default.hover.defaultDark,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.default.focus.defaultLight),
                border: 'none',
            },
        },
        destructive: {
            color: BaSeTheme.colors.defaultColors.white,
            iconColor: BaSeTheme.colors.defaultColors.white,
            style: {
                bgC: ColorMapper.destructive.foreground,
                bcCHover: ColorMapper.destructive.hover.defaultDark,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.destructive.focus.defaultLight),
                border: 'none',
            },
        },
        confirmation: {
            color: BaSeTheme.colors.defaultColors.white,
            iconColor: BaSeTheme.colors.defaultColors.white,
            style: {
                bgC: ColorMapper.confirmation.foreground,
                bcCHover: ColorMapper.confirmation.hover.defaultDark,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.confirmation.focus.defaultLight),
                border: 'none',
            },
        },
        disabled: {
            color: ColorMapper.disabled.foreground,
            iconColor: ColorMapper.disabled.foreground,
            style: {
                bgC: ColorMapper.disabled.background,
                bcCHover: ColorMapper.disabled.background,
                boxShadowFocus: 'none',
                border: 'none',
            },
        },
        negative: {
            color: ColorMapper.default.foreground,
            iconColor: ColorMapper.default.foreground,
            style: {
                bgC: BaSeTheme.colors.defaultColors.white,
                bcCHover: ColorMapper.default.hover.defaultLight,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.default.focus.defaultLight),
                border: 'none',
                colorHover: ColorMapper.default.hover.defaultDark,
            },
            disabled: {
                color: ColorMapper.disabled.foreground,
                iconColor: ColorMapper.disabled.foreground,
                style: {
                    bgC: ColorMapper.disabled.background,
                    bcCHover: ColorMapper.disabled.background,
                    boxShadowFocus: 'none',
                    border: 'none',
                },
            },
        },
    },
    secondary: {
        default: {
            color: ColorMapper.grayScale.foreground,
            iconColor: ColorMapper.grayScale.foreground,
            style: {
                bgC: BaSeTheme.colors.defaultColors.white,
                bcCHover: ColorMapper.grayScale.hover.defaultLight,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.grayScale.focus.defaultLight),
                border: "1px solid ".concat(ColorMapper.grayScale.hover.defaultDark),
                colorHover: ColorMapper.grayScale.hover.defaultDark,
            },
        },
        destructive: {
            color: ColorMapper.destructive.foreground,
            iconColor: ColorMapper.destructive.foreground,
            style: {
                bgC: BaSeTheme.colors.defaultColors.white,
                bcCHover: ColorMapper.destructive.hover.defaultLight,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.destructive.focus.defaultLight),
                border: "1px solid ".concat(ColorMapper.destructive.foreground),
                colorHover: ColorMapper.destructive.hover.defaultDark,
            },
        },
        confirmation: {
            color: ColorMapper.confirmation.foreground,
            iconColor: ColorMapper.confirmation.foreground,
            style: {
                bgC: BaSeTheme.colors.defaultColors.white,
                bcCHover: ColorMapper.confirmation.hover.defaultLight,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.confirmation.focus.defaultLight),
                border: "1px solid ".concat(ColorMapper.confirmation.foreground),
                colorHover: ColorMapper.confirmation.hover.defaultDark,
            },
        },
        disabled: {
            color: ColorMapper.disabled.foreground,
            iconColor: ColorMapper.disabled.foreground,
            style: {
                bgC: ColorMapper.disabled.background,
                bcCHover: '',
                boxShadowFocus: "",
                border: "1px solid ".concat(ColorMapper.disabled.foreground),
            },
        },
        negative: {
            color: BaSeTheme.colors.defaultColors.white,
            iconColor: BaSeTheme.colors.defaultColors.white,
            style: {
                bgC: BaSeTheme.colors.defaultColors.transparent,
                bcCHover: createColor(BaSeTheme.colors.defaultColors.white, {
                    opacity: reduceLevel(50),
                }),
                boxShadowFocus: "0px 0px 0px 4px ".concat(ColorMapper.default.focus.defaultLight),
                border: "2px solid ".concat(BaSeTheme.colors.defaultColors.white),
            },
            disabled: {
                color: ColorMapper.disabled.foreground,
                iconColor: ColorMapper.disabled.foreground,
                style: {
                    bgC: ColorMapper.disabled.background,
                    bcCHover: '',
                    boxShadowFocus: "",
                    border: "2px solid ".concat(ColorMapper.disabled.foreground),
                },
            },
        },
    },
    tertiary: {
        default: {
            color: ColorMapper.default.foreground,
            iconColor: ColorMapper.default.foreground,
            style: {
                bgC: BaSeTheme.colors.defaultColors.transparent,
                bcCHover: ColorMapper.default.hover.transparentLight,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.default.focus.transparentLight, ";"),
                border: "none",
                colorHover: ColorMapper.default.hover.defaultDark,
            },
        },
        destructive: {
            color: ColorMapper.destructive.foreground,
            iconColor: ColorMapper.destructive.foreground,
            style: {
                bgC: BaSeTheme.colors.defaultColors.transparent,
                bcCHover: ColorMapper.destructive.hover.transparentLight,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.destructive.focus.transparentLight),
                border: "none",
                colorHover: ColorMapper.destructive.hover.defaultDark,
            },
        },
        confirmation: {
            color: ColorMapper.confirmation.foreground,
            iconColor: ColorMapper.confirmation.foreground,
            style: {
                bgC: BaSeTheme.colors.defaultColors.transparent,
                bcCHover: ColorMapper.confirmation.hover.transparentLight,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.confirmation.focus.transparentLight),
                border: "none",
                colorHover: ColorMapper.confirmation.hover.defaultDark,
            },
        },
        disabled: {
            color: ColorMapper.disabled.foreground,
            iconColor: ColorMapper.disabled.foreground,
            style: {
                bgC: BaSeTheme.colors.defaultColors.transparent,
                bcCHover: BaSeTheme.colors.defaultColors.transparent,
                boxShadowFocus: "none",
                border: "none",
            },
        },
        negative: {
            color: BaSeTheme.colors.defaultColors.white,
            iconColor: BaSeTheme.colors.defaultColors.white,
            style: {
                bgC: BaSeTheme.colors.defaultColors.transparent,
                bcCHover: createColor(BaSeTheme.colors.defaultColors.white, {
                    opacity: reduceLevel(50),
                }),
                boxShadowFocus: "0px 0px 0px 4px ".concat(ColorMapper.default.getColorByNumber(90)),
                border: "none",
            },
            disabled: {
                color: ColorMapper.disabled.getColorByNumber(60),
                iconColor: ColorMapper.disabled.getColorByNumber(60),
                style: {
                    bgC: BaSeTheme.colors.defaultColors.transparent,
                    bcCHover: BaSeTheme.colors.defaultColors.transparent,
                    boxShadowFocus: "none",
                    border: "none",
                },
            },
        },
    },
};
var styleMapSize = {
    medium: {
        padding: '8.5px 12px',
        fontSize: '1',
        lineHeight: '1.4375',
        loadingSize: 16,
    },
    small: {
        padding: '8px',
        fontSize: '0.83',
        lineHeight: '1.24',
        loadingSize: 16,
    },
    big: {
        padding: '12px 16px',
        fontSize: '1.2',
        lineHeight: '1.25',
        loadingSize: 24,
    },
};
// *********************
//  SHAPE BUTTON MAPS
// *********************
var shapeButtonMapStyle = function (color) {
    var adaptColor = color === 'default' ? 'grayScale' : color;
    return {
        primary: {
            standard: {
                background: ColorMapper[color].foreground,
                iconColor: BaSeTheme.colors.defaultColors.white,
                hoverColor: ColorMapper[color].hover.defaultDark,
                backgroundOnFocus: ColorMapper[color].hover.defaultDark,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper[color].focus.defaultLight),
                border: 'none',
                disabled: {
                    background: ColorMapper.disabled.background,
                    iconColor: ColorMapper.disabled.foreground,
                    hoverColor: '',
                    backgroundOnFocus: '',
                    boxShadowFocus: "0px 0px 0px 3px ".concat(BaSeTheme.colors.institucionais.azulSebrae75),
                    border: 'none',
                },
            },
            negative: {
                background: BaSeTheme.colors.defaultColors.white,
                iconColor: ColorMapper.default.foreground,
                hoverColor: ColorMapper.default.hover.defaultLight,
                backgroundOnFocus: BaSeTheme.colors.defaultColors.white,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.default.focus.defaultLight),
                border: 'none',
                disabled: {
                    background: ColorMapper.disabled.background,
                    iconColor: ColorMapper.disabled.foreground,
                    hoverColor: '',
                    backgroundOnFocus: '',
                    boxShadowFocus: "0px 0px 0px 3px ".concat(BaSeTheme.colors.institucionais.azulSebrae75),
                    border: 'none',
                },
            },
        },
        secondary: {
            standard: {
                background: BaSeTheme.colors.defaultColors.white,
                iconColor: ColorMapper[adaptColor].foreground,
                hoverColor: ColorMapper[adaptColor].hover.defaultLight,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper[adaptColor].focus.defaultLight),
                border: "1px solid ".concat(ColorMapper[adaptColor].foreground),
                backgroundOnFocus: ColorMapper[adaptColor].hover.defaultLight,
                borderHoverColor: "1px solid ".concat(ColorMapper[adaptColor].hover.defaultDark),
                iconHoverColor: ColorMapper[adaptColor].hover.defaultDark,
                disabled: {
                    background: ColorMapper.disabled.background,
                    iconColor: ColorMapper.disabled.foreground,
                    hoverColor: 'none',
                    boxShadowFocus: 'none',
                    backgroundOnFocus: '',
                    border: "1px solid ".concat(ColorMapper.disabled.foreground),
                    borderHoverColor: "1px solid ".concat(ColorMapper.grayScale.hover.defaultDark),
                    iconHoverColor: ColorMapper.grayScale.hover.defaultDark,
                },
            },
            negative: {
                background: BaSeTheme.colors.defaultColors.transparent,
                iconColor: BaSeTheme.colors.defaultColors.white,
                hoverColor: createColor(BaSeTheme.colors.defaultColors.white, {
                    opacity: reduceLevel(50),
                }),
                border: "2px solid ".concat(BaSeTheme.colors.defaultColors.white),
                borderColor: ColorMapper.default.foreground,
                backgroundOnFocus: BaSeTheme.colors.defaultColors.transparent,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper.default.focus.defaultLight),
                disabled: {
                    background: ColorMapper.disabled.background,
                    iconColor: ColorMapper.disabled.foreground,
                    hoverColor: 'none',
                    boxShadowFocus: 'none',
                    backgroundOnFocus: '',
                    border: "2px solid ".concat(ColorMapper.disabled.foreground),
                    borderHoverColor: "1px solid ".concat(ColorMapper.grayScale.hover.defaultDark),
                    iconHoverColor: ColorMapper.grayScale.hover.defaultDark,
                },
            },
        },
        tertiary: {
            standard: {
                background: BaSeTheme.colors.defaultColors.transparent,
                iconColor: ColorMapper[color].foreground,
                hoverColor: ColorMapper[color].hover.transparentLight,
                backgroundOnFocus: ColorMapper[color].hover.transparentLight,
                boxShadowFocus: "0px 0px 0px 3px ".concat(ColorMapper[color].focus.defaultLight),
                border: 'none',
                disabled: {
                    background: ColorMapper.disabled.background,
                    iconColor: ColorMapper.disabled.foreground,
                    hoverColor: 'none',
                    boxShadowFocus: 'none',
                    backgroundOnFocus: '',
                    border: 'none',
                },
            },
            negative: {
                background: BaSeTheme.colors.defaultColors.transparent,
                iconColor: BaSeTheme.colors.defaultColors.white,
                hoverColor: createColor(BaSeTheme.colors.defaultColors.white, {
                    opacity: reduceLevel(50),
                }),
                backgroundOnFocus: BaSeTheme.colors.defaultColors.transparent,
                boxShadowFocus: "0px 0px 0px 3px ".concat(BaSeTheme.colors.defaultColors.white),
                border: 'none',
                disabled: {
                    background: BaSeTheme.colors.defaultColors.transparent,
                    iconColor: ColorMapper.disabled.foreground,
                    hoverColor: 'none',
                    backgroundOnFocus: '',
                    boxShadowFocus: '',
                    border: 'none',
                },
            },
        },
    };
};
var shapeButtonIconMapSize = {
    small: {
        iconSize: 16,
    },
    medium: {
        iconSize: 24,
    },
    big: {
        iconSize: 32,
    },
};
var shapeButtonBorderRadius = {
    circle: '50%',
    square: '4px;',
};
// *********************
//  DUAL BUTTON MAPS
// *********************
var dualButtonMapStyle = {
    primary: {
        default: {
            background: BaSeTheme.colors.defaultColors.white,
            color: ColorMapper.default.foreground,
            hoverColor: ColorMapper.default.hover.defaultLight,
            boxShadowFocus: "0 0 0 4px ".concat(ColorMapper.default.focus.defaultLight),
            border: '1px 1px 1px 1px',
            borderColor: ColorMapper.default.focus.defaultLight,
            borderRadius: '4',
        },
        negative: {
            background: BaSeTheme.colors.defaultColors.transparent,
            color: BaSeTheme.colors.defaultColors.white,
            hoverColor: createColor(BaSeTheme.colors.defaultColors.white, {
                opacity: reduceLevel(50),
            }),
            boxShadowFocus: "0 0 0 4px ".concat(ColorMapper.default.focus.defaultLight),
            border: '1px 1px 1px 0px',
            borderColor: ColorMapper.grayScale.focus.defaultLight,
            borderRadius: '4',
        },
        error: {
            background: BaSeTheme.colors.defaultColors.transparent,
            color: ColorMapper.destructive.hover.defaultDark,
            hoverColor: '',
            boxShadowFocus: '0px 0px 0px 0px',
            border: '1px 1px 1px 0px',
            borderColor: ColorMapper.destructive.hover.defaultDark,
            borderRadius: '4',
        },
    },
    selected: {
        default: {
            background: ColorMapper.default.foreground,
            color: BaSeTheme.colors.defaultColors.white,
            hoverColor: '',
            boxShadowFocus: "0 0 0 4px ".concat(ColorMapper.default.focus.defaultLight),
            border: '1px 1px 1px 0px',
            borderColor: ColorMapper.default.foreground,
            borderRadius: '4',
        },
        negative: {
            background: BaSeTheme.colors.defaultColors.white,
            color: ColorMapper.default.foreground,
            hoverColor: '',
            boxShadowFocus: "0 0 0 4px ".concat(ColorMapper.default.focus.defaultLight),
            border: '1px 1px 1px 0px',
            borderColor: BaSeTheme.colors.defaultColors.white,
            borderRadius: '4',
        },
        error: {
            background: BaSeTheme.colors.defaultColors.transparent,
            color: ColorMapper.destructive.hover.defaultDark,
            hoverColor: '',
            boxShadowFocus: '0px 0px 0px 0px',
            border: '1px 1px 1px 0px',
            borderColor: ColorMapper.destructive.hover.defaultDark,
            borderRadius: '4',
        },
    },
};
// *********************
//  ARROW BUTTON MAPS
// *********************
var arrowButtonMapStyle = {
    primary: {
        default: {
            background: ColorMapper.default.foreground,
            color: BaSeTheme.colors.defaultColors.white,
            hoverColor: ColorMapper.default.hover.defaultDark,
            boxShadowFocus: ColorMapper.default.focus.defaultLight,
            border: '0px',
            borderColor: ColorMapper.default.foreground,
            borderRadius: '7.5',
            arrows: {
                top: '4.75px',
            },
        },
        negative: {
            background: BaSeTheme.colors.defaultColors.white,
            color: ColorMapper.default.foreground,
            hoverColor: ColorMapper.default.hover.transparentLight,
            boxShadowFocus: ColorMapper.default.focus.transparentLight,
            border: '0px',
            borderColor: BaSeTheme.colors.defaultColors.white,
            borderRadius: '7.5',
            textHoverColor: ColorMapper.default.hover.defaultDark,
            borderHoverColor: ColorMapper.default.hover.defaultDark,
            arrows: {
                top: '4.75px',
            },
        },
        disabled: {
            background: ColorMapper.disabled.background,
            color: ColorMapper.disabled.foreground,
            hoverColor: '',
            boxShadowFocus: '',
            border: '0px',
            borderColor: BaSeTheme.colors.defaultColors.white,
            borderRadius: '7.5',
            arrows: {
                top: '4.75px',
            },
            negative: {
                background: BaSeTheme.colors.defaultColors.white,
                color: ColorMapper.default.foreground,
                hoverColor: ColorMapper.default.hover.transparentLight,
                boxShadowFocus: ColorMapper.default.focus.defaultLight,
                border: '0px',
                borderColor: BaSeTheme.colors.defaultColors.white,
                borderRadius: '7.5',
                textHoverColor: ColorMapper.default.hover.defaultDark,
                borderHoverColor: ColorMapper.default.hover.defaultDark,
                arrows: {
                    top: '4.75px',
                },
            },
        },
    },
    secondary: {
        default: {
            background: BaSeTheme.colors.defaultColors.white,
            color: ColorMapper.grayScale.foreground,
            hoverColor: ColorMapper.grayScale.hover.defaultLight,
            boxShadowFocus: ColorMapper.disabled.foreground,
            border: '1px',
            borderColor: ColorMapper.grayScale.foreground,
            borderRadius: '7.5',
            textHoverColor: ColorMapper.grayScale.hover.defaultDark,
            borderHoverColor: ColorMapper.grayScale.hover.defaultDark,
            arrows: {
                top: '3.75px',
            },
        },
        negative: {
            background: BaSeTheme.colors.defaultColors.transparent,
            color: BaSeTheme.colors.defaultColors.white,
            hoverColor: createColor(BaSeTheme.colors.defaultColors.white, {
                opacity: reduceLevel(50),
            }),
            boxShadowFocus: "".concat(ColorMapper.default.focus.defaultLight),
            border: '2px',
            borderColor: BaSeTheme.colors.defaultColors.white,
            borderRadius: '7.5',
            arrows: {
                top: '2.75px',
            },
        },
        disabled: {
            background: ColorMapper.disabled.background,
            color: ColorMapper.disabled.foreground,
            hoverColor: '',
            boxShadowFocus: '',
            border: '1px',
            borderColor: "".concat(ColorMapper.disabled.foreground),
            borderRadius: '7.5',
            negative: {
                background: ColorMapper.disabled.background,
                color: ColorMapper.disabled.foreground,
                hoverColor: '',
                boxShadowFocus: '',
                border: '2px',
                borderColor: "".concat(ColorMapper.disabled.foreground),
                borderRadius: '7.5',
                arrows: {
                    top: '2.75px',
                },
            },
            arrows: {
                top: '3.5px',
            },
        },
    },
};
// *********************
//  CUSTOM COLORS BUTTON MAPS
// *********************
var mapCustomColorsButtonValues = function (customColor, ignoreTextHover, overrideColors) {
    var _a, _b;
    if (ignoreTextHover === void 0) { ignoreTextHover = false; }
    var _c = ColorMapper.createMostUsedColors(customColor), darkHoverColor = _c.darkHoverColor, lightFocusColor = _c.lightFocusColor, lightHoverColor = _c.lightHoverColor, lightFocusColorTransparent = _c.lightFocusColorTransparent, lightHoverColorTransparent = _c.lightHoverColorTransparent;
    var matchColorToReplace = function (matchColor, defaultColor) {
        return ignoreTextHover ? defaultColor : matchColor;
    };
    return {
        primary: {
            color: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground, BaSeTheme.colors.defaultColors.white),
            iconColor: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground, BaSeTheme.colors.defaultColors.white),
            style: {
                bgC: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor, customColor !== null && customColor !== void 0 ? customColor : ColorMapper.default.foreground),
                bcCHover: (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor)
                    ? ColorMapper.dark.hover.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor))
                    : darkHoverColor,
                boxShadowFocus: "0px 0px 0px 3px ".concat((overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor)
                    ? ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.light.focus.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor))
                    : lightFocusColor),
                border: 'none',
            },
        },
        secondary: {
            color: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground, customColor !== null && customColor !== void 0 ? customColor : ColorMapper.grayScale.foreground),
            iconColor: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground, customColor !== null && customColor !== void 0 ? customColor : ColorMapper.grayScale.foreground),
            style: {
                bgC: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor, BaSeTheme.colors.defaultColors.white),
                bcCHover: (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor)
                    ? ColorMapper.light.hover.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor))
                    : lightHoverColor,
                boxShadowFocus: "0px 0px 0px 3px ".concat((overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor)
                    ? ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.light.focus.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor))
                    : lightFocusColor),
                border: (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.borderColor)
                    ? "1px solid ".concat(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.borderColor))
                    : "1px solid ".concat(customColor),
                colorHover: (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground)
                    ? matchColorToReplace((_a = ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.dark) === null || _a === void 0 ? void 0 : _a.hover.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground)), overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground)
                    : matchColorToReplace(darkHoverColor, ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground, customColor !== null && customColor !== void 0 ? customColor : ColorMapper.grayScale.foreground)),
            },
        },
        tertiary: {
            color: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground, customColor !== null && customColor !== void 0 ? customColor : ColorMapper.grayScale.foreground),
            iconColor: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground, customColor !== null && customColor !== void 0 ? customColor : ColorMapper.grayScale.foreground),
            style: {
                bgC: BaSeTheme.colors.defaultColors.transparent,
                bcCHover: (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground)
                    ? ColorMapper.light.hover.createTransparent(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground))
                    : lightHoverColorTransparent,
                boxShadowFocus: "0px 0px 0px 3px ".concat((overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground)
                    ? ColorMapper.light.focus.createTransparent(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground))
                    : lightFocusColorTransparent),
                border: "none",
                colorHover: (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground)
                    ? matchColorToReplace((_b = ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.dark) === null || _b === void 0 ? void 0 : _b.hover.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground)), overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground)
                    : matchColorToReplace(darkHoverColor, ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground, customColor !== null && customColor !== void 0 ? customColor : ColorMapper.grayScale.foreground)),
            },
        },
    };
};
// *********************
//  CUSTOM COLORS ARROW BUTTON MAPS
// *********************
var mapCustomColorsArrowButtonValues = function (customColor) {
    var _a = ColorMapper.createMostUsedColors(customColor), darkHoverColor = _a.darkHoverColor, lightFocusColor = _a.lightFocusColor, lightHoverColor = _a.lightHoverColor;
    return {
        primary: {
            background: customColor,
            color: BaSeTheme.colors.defaultColors.white,
            hoverColor: darkHoverColor,
            boxShadowFocus: lightFocusColor,
            border: '0px',
            borderColor: BaSeTheme.colors.defaultColors.white,
            borderRadius: '7.5',
        },
        secondary: {
            background: BaSeTheme.colors.defaultColors.white,
            color: customColor,
            hoverColor: lightHoverColor,
            boxShadowFocus: lightFocusColor,
            border: '1px',
            borderColor: customColor,
            borderRadius: '7.5',
        },
    };
};
// *********************
//  CUSTOM COLORS ARROW BUTTON MAPS
// *********************
var mapCustomColorsShapeButtonValues = function (customColor) {
    var _a = ColorMapper.createMostUsedColors(customColor), darkHoverColor = _a.darkHoverColor, lightFocusColor = _a.lightFocusColor, lightHoverColor = _a.lightHoverColor, lightFocusColorTransparent = _a.lightFocusColorTransparent, lightHoverColorTransparent = _a.lightHoverColorTransparent;
    return {
        primary: {
            background: customColor,
            iconColor: BaSeTheme.colors.defaultColors.white,
            hoverColor: darkHoverColor,
            boxShadowFocus: "0px 0px 0px 3px ".concat(lightFocusColor),
            border: 'none',
        },
        secondary: {
            background: BaSeTheme.colors.defaultColors.white,
            iconColor: customColor,
            hoverColor: lightHoverColor,
            boxShadowFocus: "0px 0px 0px 3px ".concat(lightFocusColor),
            border: "1px solid ".concat(customColor),
        },
        tertiary: {
            background: BaSeTheme.colors.defaultColors.transparent,
            iconColor: customColor,
            hoverColor: lightHoverColorTransparent,
            boxShadowFocus: "0px 0px 0px 3px ".concat(lightFocusColorTransparent),
            border: 'none',
        },
    };
};
// Overrider
var buttonOverrideColor = function (overrider) {
    return {
        primary: {
            color: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground),
            iconColor: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground),
            style: {
                bgC: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor),
                bcCHover: (overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor) &&
                    ColorMapper.dark.hover.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor)),
                boxShadowFocus: (overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor) &&
                    "0px 0px 0px 3px ".concat(ColorMapper.light.focus.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor))),
            },
        },
        secondary: {
            color: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground),
            iconColor: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground),
            style: {
                bgC: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor),
                bcCHover: ((overrider === null || overrider === void 0 ? void 0 : overrider.foreground) || (overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor)) &&
                    (ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.light.hover.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor((overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor) || (overrider === null || overrider === void 0 ? void 0 : overrider.foreground)))),
                boxShadowFocus: ((overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor) || (overrider === null || overrider === void 0 ? void 0 : overrider.foreground)) &&
                    "0px 0px 0px 3px ".concat(ColorMapper.light.focus.create(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor((overrider === null || overrider === void 0 ? void 0 : overrider.backgroundColor) || (overrider === null || overrider === void 0 ? void 0 : overrider.foreground)))),
                border: (overrider === null || overrider === void 0 ? void 0 : overrider.borderColor) &&
                    "1px solid ".concat(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.borderColor)),
                colorHover: (overrider === null || overrider === void 0 ? void 0 : overrider.foreground) &&
                    ColorMapper.dark.hover.create(ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground)),
            },
        },
        tertiary: {
            color: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground),
            iconColor: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground),
            style: {
                bcCHover: (overrider === null || overrider === void 0 ? void 0 : overrider.foreground) &&
                    (ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.light.hover.createTransparent(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground))),
                boxShadowFocus: (overrider === null || overrider === void 0 ? void 0 : overrider.foreground) &&
                    "0px 0px 0px 3px ".concat(ColorMapper.light.focus.createTransparent(ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground))),
                border: 'none',
                colorHover: (overrider === null || overrider === void 0 ? void 0 : overrider.foreground) &&
                    ColorMapper.dark.hover.create(ColorMapper.getColor(overrider === null || overrider === void 0 ? void 0 : overrider.foreground)),
            },
        },
    };
};

var en = {"avatarImage.description":"User's AMEI image","buttonIcon.defaultDescription":"Button image","buttonIcon.inputIcon":"Input action","buttonIcon.hidePassword":"Hide password","buttonIcon.showPassword":"Show password","changePassword.label":"Change Password","filePicker.fileInvalidMessage":"File type is invalid","filePicker.buttonPickLabel":"Choose","filePicker.buttonDeleteLabel":"Delete","filePicker.buttonUpdateLabel":"Switch","filePicker.dragInfo":"Or drop the file here to add it","accordion.iconDescription":"Icon to indicate if item is opened or closed","imageAccountProfile.description":"Account profile image","imagePicker.selectedImage":"Selected image","imagePicker.imagePlaceholder":"No selected image","imagePicker.imageNotFound":"Image not found","ImagePicker.modalTitle":"Edit photo","helperText.openButton":"Hide details","helperText.closeButton":"Show details","loading.description":"Loading…","login.label":"Login","logout.label":"Logout","menuAccountProfile.ariaLabel":"Account profile menu options","myAccount.label":"My account","myBusiness.label":"My business","myProfile.label":"My profile","socialAccounts.label":"Social Accounts","stepCurrent.description":"Step {0} completed","dataConfigAction.hint":"Configuration","dataDensity.high":"Compacted","dataDensity.normal":"Normal","dataDensity.low":"Spaced","dataTable.sortHint":"Toggle sort","dataTable.sortHint.asc":"Sorted ascending","dataTable.sortHint.desc":"Sorted descending","dataItem.singularItemDescription":"item","dataItem.pluralItemDescription":"items","dataPagination.noItemsToDisplay":"No {0} to display","dataPagination.showingOneItems":"Showing 1 {0}","dataPagination.showingMoreThanOneItem":"Showing {0} {1}","dataPagination.showingItems":"Showing {0} of {1} {2}","dataPagination.showingItemsPerPage":"Per page","dataSelection.unselectAllItems.male":"Unselect all","dataSelection.unselectAllItems.female":"Unselect all","dataSelection.allPageSelected":"All page selected","dataSelection.selectAnothersRemaining.male":"Select anothers {0} remaining {1}?","dataSelection.selectAnothersRemaining.female":"Select anothers {0} remaining {1}?","dataSelection.almostAllSelected.male":"Almost all selected","dataSelection.almostAllSelected.female":"Almost all selected","dataSelection.selectTheLastOne.male":"Select the last remaining {0} one too? ","dataSelection.selectTheLastOne.female":"Select the last remaining {0} one too? ","dataSelection.allItemsSelected.male":"Selected all {0} {1}","dataSelection.allItemsSelected.female":"Selected all {0} {1}","dataSelection.oneItemSelected.male":"One {1} selected","dataSelection.oneItemSelected.female":"One {1} selected","dataSelection.manyItemSelected.male":"{0} {1} selected","dataSelection.manyItemSelected.female":"{0} {1} selected","dataFilter.textFilterPlaceholder":"Type text to search","dataFilter.customFilterTitle":"Filters","dataFilter.customFilterActivated":"Activated filters:","dataFilter.customFilterClear":"Clear filters","dataFilter.openFilter":"Open filter","dataFilter.closeFilter":"Close filter","footer.system.version":"Version","footer.relationText":"Relationship Center: ","footer.collapsedHeader":"Know all about Sebrae","system.rights":"All rights reserved","system.sebrae":"Sebrae","select.selectedCounter":"{0} selected","select.selectAll":"Select all","select.cleanSearch":"Clean search","select.closeOptions":"Close the options","select.openOptions":"Open the options","selected.and":"and","select.emptyValue":"Select","cropper.button.save":"Save","cropper.button.cancel":"Cancel","cropper.file.default.name":"File created: {0}.jpg","cropper.error.upload":"Error on image upload","cropper.error.crop":"Error on image crop","textArea.counter.words":"words","textArea.counter.chars":"characters","textArea.counter.lines":"lines","textArea.counter.word":"word","textArea.counter.char":"character","textArea.counter.line":"line","textArea.counter.initialMin":"Minimum of {0} {1}","textArea.counter.min":"{0} {1} left","textArea.counter.minLastOne":"{0} {1} to go","textArea.counter.doneMin":"Reached the minimum of {0} {1}","textArea.counter.initialMax":"Maximum of {0} {1}","textArea.counter.max":"{0} {1} left","textArea.counter.maxLastOne":"{0} {1} to go","textArea.counter.doneMax":"Reached the maximum of {0} {1}","textArea.counter.minMax":"Min: {0}/{1} | Max: {2}/{3} of {4}","textArea.counter.withoutMinMax":"{0} {1}","icon.label":"Icon: {0}","logo.description":"Sebrae logo","checkbox.iconDescription":"checkbox-icon","toggler.iconDescription":"Highlighted checkbox","errorPage.backButton":"Back","errorPage.defaultDescription":"Please, try again later or find for some help.","errorPage.defaultTitle":"Something wrong here","backendNoSignalPage.title":"No connection to the system","backendNoSignalPage.errorMessage":"Please, try again later.","forbiddenPage.title":"Access Denied","forbiddenPage.errorMessage":"Please verify that your login credentials are correct.","notFoundPage.title":"Page not found","notFoundPage.errorMessage":"Please verify that the page address is correct."};

var ptBr = {"avatarImage.description":"Imagem da pessoa autenticada no AMEI","buttonIcon.defaultDescription":"Imagem do botão","buttonIcon.inputIcon":"Ação do campo","buttonIcon.hidePassword":"Esconder senha","buttonIcon.showPassword":"Exibir senha","changePassword.label":"Alterar senha","filePicker.fileInvalidMessage":"Tipo do arquivo é inválido","filePicker.buttonPickLabel":"Escolher","filePicker.buttonDeleteLabel":"Excluir","filePicker.buttonUpdateLabel":"Trocar","filePicker.dragInfo":"Ou arraste o arquivo aqui para adicioná-lo","accordion.iconDescription":"Ícone que indica se item está aberto ou fechado","imageAccountProfile.description":"Imagem de uma pessoa, indicando a área para fazer login","imagePicker.selectedImage":"Imagem selecionada","imagePicker.imagePlaceholder":"Nenhuma imagem selecionada","imagePicker.imageNotFound":"Imagem não encontrada","ImagePicker.modalTitle":"Editar foto","helperText.openButton":"Esconder detalhes","helperText.closeButton":"Exibir detalhes","loading.description":"Carregando…","login.label":"Entrar","logout.label":"Sair","menuAccountProfile.ariaLabel":"Menu com as opções do Autenticador","myAccount.label":"Minha Conta","myBusiness.label":"Minha empresa","myProfile.label":"Meu perfil","socialAccounts.label":"Vincular redes sociais","stepCurrent.description":"Etapa {0} concluida","dataConfigAction.hint":"Configuração","dataDensity.high":"Compacto","dataDensity.normal":"Normal","dataDensity.low":"Espaçado","dataTable.sortHint":"Ordenar coluna","dataTable.sortHint.asc":"Coluna ordenada de forma ascendente","dataTable.sortHint.desc":"Coluna ordenada de forma descendente","dataItem.singularItemDescription":"item","dataItem.pluralItemDescription":"itens","dataPagination.noItemsToDisplay":"Sem {0} para exibir","dataPagination.showingOneItems":"Mostrando 1 {0}","dataPagination.showingMoreThanOneItem":"Mostrando {0} {1}","dataPagination.showingItems":"Mostrando {0} de {1} {2}","dataPagination.showingItemsPerPage":"Por página","dataSelection.unselectAllItems.male":"Desmarcar todos","dataSelection.unselectAllItems.female":"Desmarcar todas","dataSelection.allPageSelected":"Toda a página selecionada","dataSelection.selectAnothersRemaining.male":"Selecionar os outros {0} {1} restantes?","dataSelection.selectAnothersRemaining.female":"Selecionar as outras {0} {1} restantes?","dataSelection.almostAllSelected.male":"Quase todos selecionados","dataSelection.almostAllSelected.female":"Quase todas selecionados","dataSelection.selectTheLastOne.male":"Selecionar o último {0} restante também?","dataSelection.selectTheLastOne.female":"Selecionar a última {0} restante também?","dataSelection.allItemsSelected.male":"Todos os {0} {1} selecionados","dataSelection.allItemsSelected.female":"Todas as {0} {1} selecionadas","dataSelection.oneItemSelected.male":"Um {0} selecionado","dataSelection.oneItemSelected.female":"Uma {0} selecionada","dataSelection.manyItemSelected.male":"{0} {1} selecionados","dataSelection.manyItemSelected.female":"{0} {1} selecionadas","dataFilter.textFilterPlaceholder":"Pesquise aqui…","dataFilter.customFilterTitle":"Filtros","dataFilter.customFilterActivated":"Filtros ativados:","dataFilter.customFilterClear":"Limpar filtros","dataFilter.openFilter":"Abre o filtro","dataFilter.closeFilter":"Fecha o filtro","footer.system.version":"Versão","footer.relationText":"Central de relacionamento: ","footer.collapsedHeader":"Conheça o Sebrae","system.rights":"Todos os direitos reservados","system.sebrae":"Sebrae","select.selectedCounter":"{0} selecionados","select.selectAll":"Marcar todos","select.cleanSearch":"Limpar pesquisa","select.closeOptions":"Fecha as opções","select.openOptions":"Abre as opções","select.and":"e","select.emptyValue":"Selecione","cropper.button.save":"Salvar","cropper.button.cancel":"Cancelar","cropper.file.default.name":"Arquivo gerado: {0}.jpg","cropper.error.upload":"Erro ao carregar imagem","cropper.error.crop":"Error ao realizar crop da imagem","textArea.counter.words":"palavras","textArea.counter.chars":"caracteres","textArea.counter.lines":"linhas","textArea.counter.word":"palavra","textArea.counter.char":"caractere","textArea.counter.line":"linha","textArea.counter.initialMin":"Mínimo de {0} {1}","textArea.counter.min":"Faltam {0} {1}","textArea.counter.minLastOne":"Falta {0} {1}","textArea.counter.doneMin":"Atingiu o mínimo de {0} {1}","textArea.counter.initialMax":"Máximo de {0} {1}","textArea.counter.max":"Faltam {0} {1}","textArea.counter.maxLastOne":"Falta {0} {1}","textArea.counter.doneMax":"Atingiu o máximo de {0} {1}","textArea.counter.minMax":"Mín: {0}/{1} | Máx: {2}/{3} de {4}","textArea.counter.withoutMinMax":"{0} {1}","icon.label":"Ícone: {0}","notification.iconDescription":"Ícone sinalizando a notificação","logo.description":"Logotipo do Sebrae","checkbox.iconDescription":"checkbox-icon","toggler.iconDescription":"Checkbox marcado","errorPage.backButton":"Voltar","errorPage.defaultDescription":"Por favor, tente novamente mais tarde ou procure ajuda.","errorPage.defaultTitle":"Algo deu errado","backendNoSignalPage.title":"Sem comunicação com o sistema","backendNoSignalPage.errorMessage":"Por favor, tente acessar mais tarde.","forbiddenPage.title":"Acesso negado","forbiddenPage.errorMessage":"Por favor, verifique se você tem permissão para acessar.","notFoundPage.title":"Página não encontrada","notFoundPage.errorMessage":"Por favor, verifique se o endereço da página está correto."};

var localizedMessages = {
    'pt-BR': ptBr,
    en: en,
};
function createMessages(keys, locales) {
    var result = {};
    keys.forEach(function (key) {
        var _a;
        result[key] = (_a = result === null || result === void 0 ? void 0 : result[key]) !== null && _a !== void 0 ? _a : {};
        locales.forEach(function (locale) { var _a, _b; return (result[key][locale] = (_b = (_a = localizedMessages === null || localizedMessages === void 0 ? void 0 : localizedMessages[locale]) === null || _a === void 0 ? void 0 : _a[key]) !== null && _b !== void 0 ? _b : key); });
    });
    return result;
}
var messages = createMessages(Object.keys(ptBr), [
    'en',
    'pt-BR',
]);

var formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: 'menos de um segundo',
    other: 'menos de {{count}} segundos'
  },
  xSeconds: {
    one: '1 segundo',
    other: '{{count}} segundos'
  },
  halfAMinute: 'meio minuto',
  lessThanXMinutes: {
    one: 'menos de um minuto',
    other: 'menos de {{count}} minutos'
  },
  xMinutes: {
    one: '1 minuto',
    other: '{{count}} minutos'
  },
  aboutXHours: {
    one: 'cerca de 1 hora',
    other: 'cerca de {{count}} horas'
  },
  xHours: {
    one: '1 hora',
    other: '{{count}} horas'
  },
  xDays: {
    one: '1 dia',
    other: '{{count}} dias'
  },
  aboutXWeeks: {
    one: 'cerca de 1 semana',
    other: 'cerca de {{count}} semanas'
  },
  xWeeks: {
    one: '1 semana',
    other: '{{count}} semanas'
  },
  aboutXMonths: {
    one: 'cerca de 1 mês',
    other: 'cerca de {{count}} meses'
  },
  xMonths: {
    one: '1 mês',
    other: '{{count}} meses'
  },
  aboutXYears: {
    one: 'cerca de 1 ano',
    other: 'cerca de {{count}} anos'
  },
  xYears: {
    one: '1 ano',
    other: '{{count}} anos'
  },
  overXYears: {
    one: 'mais de 1 ano',
    other: 'mais de {{count}} anos'
  },
  almostXYears: {
    one: 'quase 1 ano',
    other: 'quase {{count}} anos'
  }
};
function formatDistance$2(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$1[token] === 'string') {
    result = formatDistanceLocale$1[token];
  } else if (count === 1) {
    result = formatDistanceLocale$1[token].one;
  } else {
    result = formatDistanceLocale$1[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'em ' + result;
    } else {
      return 'há ' + result;
    }
  }

  return result;
}

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats$1 = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: 'd MMM y',
  short: 'dd/MM/yyyy'
};
var timeFormats$1 = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$1 = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: 'full'
  })
};
var formatLong$3 = formatLong$2;

var formatRelativeLocale$1 = {
  lastWeek: function (date, _baseDate, _options) {
    var weekday = date.getUTCDay();
    var last = weekday === 0 || weekday === 6 ? 'último' : 'última';
    return "'" + last + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: 'P'
};
function formatRelative$2(token, date, baseDate, options) {
  var format = formatRelativeLocale$1[token];

  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }

  return format;
}

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

var eraValues$1 = {
  narrow: ['AC', 'DC'],
  abbreviated: ['AC', 'DC'],
  wide: ['antes de cristo', 'depois de cristo']
};
var quarterValues$1 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
};
var monthValues$1 = {
  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
  wide: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
};
var dayValues$1 = {
  narrow: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  short: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'],
  abbreviated: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
  wide: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado']
};
var dayPeriodValues$1 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noite'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noite'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noite'
  }
};
var formattingDayPeriodValues$1 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da tarde',
    night: 'da noite'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da tarde',
    night: 'da noite'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da tarde',
    night: 'da noite'
  }
};

function ordinalNumber$1(dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber);
  var options = dirtyOptions || {};
  var unit = String(options.unit);

  if (unit === 'week' || unit === 'isoWeek') {
    return number + 'ª';
  }

  return number + 'º';
}

var localize$2 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: 'wide'
  })
};
var localize$3 = localize$2;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern$1 = /^(\d+)[ºªo]?/i;
var parseOrdinalNumberPattern$1 = /\d+/i;
var matchEraPatterns$1 = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i
};
var parseEraPatterns$1 = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i]
};
var matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1 = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns$1 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
};
var matchDayPatterns$1 = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var parseDayPatterns$1 = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
};
var matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i
  }
};
var match$2 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: 'any'
  })
};
var match$3 = match$2;

/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
 */

var locale$1 = {
  code: 'pt-BR',
  formatDistance: formatDistance$2,
  formatLong: formatLong$3,
  formatRelative: formatRelative$2,
  localize: localize$3,
  match: match$3,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var pt = locale$1;

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'menos de un segundo',
    other: 'menos de {{count}} segundos'
  },
  xSeconds: {
    one: '1 segundo',
    other: '{{count}} segundos'
  },
  halfAMinute: 'medio minuto',
  lessThanXMinutes: {
    one: 'menos de un minuto',
    other: 'menos de {{count}} minutos'
  },
  xMinutes: {
    one: '1 minuto',
    other: '{{count}} minutos'
  },
  aboutXHours: {
    one: 'alrededor de 1 hora',
    other: 'alrededor de {{count}} horas'
  },
  xHours: {
    one: '1 hora',
    other: '{{count}} horas'
  },
  xDays: {
    one: '1 día',
    other: '{{count}} días'
  },
  aboutXWeeks: {
    one: 'alrededor de 1 semana',
    other: 'alrededor de {{count}} semanas'
  },
  xWeeks: {
    one: '1 semana',
    other: '{{count}} semanas'
  },
  aboutXMonths: {
    one: 'alrededor de 1 mes',
    other: 'alrededor de {{count}} meses'
  },
  xMonths: {
    one: '1 mes',
    other: '{{count}} meses'
  },
  aboutXYears: {
    one: 'alrededor de 1 año',
    other: 'alrededor de {{count}} años'
  },
  xYears: {
    one: '1 año',
    other: '{{count}} años'
  },
  overXYears: {
    one: 'más de 1 año',
    other: 'más de {{count}} años'
  },
  almostXYears: {
    one: 'casi 1 año',
    other: 'casi {{count}} años'
  }
};

var formatDistance = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'en ' + result;
    } else {
      return 'hace ' + result;
    }
  }

  return result;
};

var formatDistance$1 = formatDistance;

var dateFormats = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: 'd MMM y',
  short: 'dd/MM/y'
};
var timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: 'P'
};
var formatRelativeLocalePlural = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: 'P'
};

var formatRelative = function (token, date, _baseDate, _options) {
  if (date.getUTCHours() !== 1) {
    return formatRelativeLocalePlural[token];
  } else {
    return formatRelativeLocale[token];
  }
};

var formatRelative$1 = formatRelative;

var eraValues = {
  narrow: ['AC', 'DC'],
  abbreviated: ['AC', 'DC'],
  wide: ['antes de cristo', 'después de cristo']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
};
var monthValues = {
  narrow: ['e', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
  wide: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
};
var dayValues = {
  narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
  short: ['do', 'lu', 'ma', 'mi', 'ju', 'vi', 'sá'],
  abbreviated: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  wide: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'mañana',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noche'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'mañana',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noche'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'mañana',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noche'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'de la mañana',
    afternoon: 'de la tarde',
    evening: 'de la tarde',
    night: 'de la noche'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'de la mañana',
    afternoon: 'de la tarde',
    evening: 'de la tarde',
    night: 'de la noche'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'de la mañana',
    afternoon: 'de la tarde',
    evening: 'de la tarde',
    night: 'de la noche'
  }
};

var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + 'º';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var parseEraPatterns = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var parseMonthPatterns = {
  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
};
var matchDayPatterns = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var parseDayPatterns = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */
var locale = {
  code: 'es',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var es = locale;

var BaSeI18nContext = React.createContext({
    locale: 'pt-BR',
    getMessage: function () { return ''; },
    changeLocale: function () { },
});
var initializedDateRegister = {};
var registerLocaleMap = {
    'pt-BR': pt,
    'es': es,
};
var BaSeI18nProvider = function (_a) {
    var localeDefault = _a.locale, children = _a.children;
    var _b = React.useState(localeDefault), locale = _b[0], setLocale = _b[1];
    var getMessage = React.useCallback(function (key) {
        var _a, _b;
        var replacements = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            replacements[_i - 1] = arguments[_i];
        }
        var message = (_b = (_a = messages === null || messages === void 0 ? void 0 : messages[key]) === null || _a === void 0 ? void 0 : _a[locale]) !== null && _b !== void 0 ? _b : key;
        if ((replacements === null || replacements === void 0 ? void 0 : replacements.length) > 0) {
            if (Array.isArray(replacements[0])) {
                replacements = replacements[0];
            }
            return (replacements.reduce(function (messageReplaced, term, index) {
                var regExp = new RegExp("\\{".concat(index, "\\}"), 'g');
                return (messageReplaced + '').replace(regExp, term + '');
            }, message) + '');
        }
        return message;
    }, [locale]);
    var registerDateLocale = React.useCallback(function (localeName) {
        if (!initializedDateRegister[localeName]) {
            registerLocale(localeName, registerLocaleMap[localeName]);
            initializedDateRegister[localeName] = true;
        }
    }, []);
    React.useEffect(function () { return setLocale(localeDefault); }, [localeDefault]);
    return (React.createElement(BaSeI18nContext.Provider, { value: {
            locale: locale,
            getMessage: getMessage,
            changeLocale: setLocale,
            registerDateLocale: registerDateLocale,
        } }, children));
};
var BaSeI18nConsumer = BaSeI18nContext.Consumer;

function useDebounce(state, delay) {
    var _a = React.useState(state), debouncedValue = _a[0], setDebouncedValue = _a[1];
    React.useEffect(function () {
        var handler = setTimeout(function () {
            setDebouncedValue(state);
        }, delay);
        return function () {
            clearTimeout(handler);
        };
    }, [state, delay]);
    return debouncedValue;
}

var childrenMappedTypographyElements = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'span',
    'p',
    'a',
    'li',
    'small',
]
    .map(function (i) { return '> ' + i; })
    .join(', ')
    .toString();
var handleColor = function (hasHref, color) {
    var _a, _b, _c;
    if (!color) {
        return hasHref
            ? BaSeTheme.colors.institucionais.azulSebrae36
            : BaSeTheme.colors.institucionais.cinzaSebrae;
    }
    return ((_c = (_a = ColorMapper.typography[color]) !== null && _a !== void 0 ? _a : (_b = ColorMapper[color]) === null || _b === void 0 ? void 0 : _b.foreground) !== null && _c !== void 0 ? _c : color);
};
var makeDefaultTypographytStyled = function (element, tagName, fontSize, lineHeight) { return styled[tagName].attrs({
    className: "BaSe--".concat(element.toLocaleLowerCase()),
})(templateObject_1$V || (templateObject_1$V = __makeTemplateObject(["\n  font-size: ", "em;\n  font-style: ", ";\n  font-family: '", "';\n  font-weight: ", ";\n  color: ", ";\n  line-height: ", "em;\n  ", " {\n    font-size: inherit;\n    font-style: inherit;\n    font-weight: inherit;\n    line-height: inherit;\n  }\n"], ["\n  font-size: ", "em;\n  font-style: ", ";\n  font-family: '", "';\n  font-weight: ", ";\n  color: ", ";\n  line-height: ", "em;\n  ", " {\n    font-size: inherit;\n    font-style: inherit;\n    font-weight: inherit;\n    line-height: inherit;\n  }\n"])), fontSize, function (props) { return ((props === null || props === void 0 ? void 0 : props.isItalic) ? 'italic' : 'normal'); }, BaSeTheme.typography.fontFamily, function (props) { return ((props === null || props === void 0 ? void 0 : props.isThin) ? '300' : (props === null || props === void 0 ? void 0 : props.isBold) ? '700' : '400'); }, function (props) {
    return handleColor(false, props === null || props === void 0 ? void 0 : props.color);
}, lineHeight, childrenMappedTypographyElements); };
var LinkWrapper = styled.a(templateObject_3$A || (templateObject_3$A = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var isDisabled = _a.isDisabled, isUnderline = _a.isUnderline, colors = _a.colors, fontSize = _a.fontSize, lineHeight = _a.lineHeight;
    return css(templateObject_2$K || (templateObject_2$K = __makeTemplateObject(["\n    cursor: pointer;\n    outline: none;\n    color: ", ";\n    text-decoration: ", ";\n    font-size: ", "em;\n    line-height: ", "em;\n    ", " {\n      display: inline;\n      font-size: inherit;\n      color: ", ";\n    }\n    ", "\n  "], ["\n    cursor: pointer;\n    outline: none;\n    color: ", ";\n    text-decoration: ", ";\n    font-size: ", "em;\n    line-height: ", "em;\n    ", " {\n      display: inline;\n      font-size: inherit;\n      color: ", ";\n    }\n    ", "\n  "])), handleColor(true, colors === null || colors === void 0 ? void 0 : colors.foreground), isUnderline ? 'underline' : 'none', fontSize, lineHeight, childrenMappedTypographyElements, handleColor(true, colors === null || colors === void 0 ? void 0 : colors.foreground), isDisabled
        ? "\n      pointer-events: none;\n      color: ".concat((_b = colors === null || colors === void 0 ? void 0 : colors.disabled) !== null && _b !== void 0 ? _b : BaSeTheme.colors.institucionais.cinzaSebrae75, ";\n      ").concat(childrenMappedTypographyElements, " {\n        color: ").concat((_c = colors === null || colors === void 0 ? void 0 : colors.disabled) !== null && _c !== void 0 ? _c : BaSeTheme.colors.institucionais.cinzaSebrae75, ";\n      }\n      ")
        : "\n        &:visited {\n          color: ".concat((_d = colors === null || colors === void 0 ? void 0 : colors.visited) !== null && _d !== void 0 ? _d : BaSeTheme.colors.gestao.roxo60, ";\n          ").concat(childrenMappedTypographyElements, " {\n            color: ").concat((_e = colors === null || colors === void 0 ? void 0 : colors.visited) !== null && _e !== void 0 ? _e : BaSeTheme.colors.gestao.roxo60, ";\n          }\n        }\n        &:hover {\n          color: ").concat((_f = colors === null || colors === void 0 ? void 0 : colors.hover) !== null && _f !== void 0 ? _f : BaSeTheme.colors.institucionais.azulSebrae60, ";\n          text-decoration: none;\n          ").concat(childrenMappedTypographyElements, " {\n            color: ").concat((_g = colors === null || colors === void 0 ? void 0 : colors.hover) !== null && _g !== void 0 ? _g : BaSeTheme.colors.institucionais.azulSebrae60, ";\n          }\n        }\n        &:focus {\n          color: ").concat((_h = colors === null || colors === void 0 ? void 0 : colors.focus) !== null && _h !== void 0 ? _h : BaSeTheme.colors.institucionais.azulSebrae60, ";\n          text-decoration: none;\n          border: none;\n          ").concat(childrenMappedTypographyElements, " {\n            color: ").concat((_j = colors === null || colors === void 0 ? void 0 : colors.focus) !== null && _j !== void 0 ? _j : BaSeTheme.colors.institucionais.azulSebrae60, ";\n            border: 1px solid ").concat((_k = colors === null || colors === void 0 ? void 0 : colors.focusShadow) !== null && _k !== void 0 ? _k : BaSeTheme.colors.institucionais.azulSebrae75, ";\n            padding: 2px 7.5px;\n            border-radius: 4px;\n          }\n        }\n        &:active {\n          color: ").concat((_l = colors === null || colors === void 0 ? void 0 : colors.active) !== null && _l !== void 0 ? _l : BaSeTheme.colors.institucionais.azulSebrae30, ";\n          text-decoration: ").concat(isUnderline ? 'underline' : 'none', ";\n          ").concat(childrenMappedTypographyElements, " {\n            color: ").concat((_m = colors === null || colors === void 0 ? void 0 : colors.active) !== null && _m !== void 0 ? _m : BaSeTheme.colors.institucionais.azulSebrae30, ";\n            border: none;\n            padding: 0;\n            border-radius: 0;\n          }\n        }\n      "));
});
var templateObject_1$V, templateObject_2$K, templateObject_3$A;

var inst = BaSeTheme.colors.institucionais;
var gest = BaSeTheme.colors.gestao;
var def = BaSeTheme.colors.defaultColors;
var feed = BaSeTheme.colors.feedbackInterface;
var TypographyLinkMapper = {
    default: {
        foreground: ColorMapper.default.foreground,
        hover: ColorMapper.default.unchecked,
        active: ColorMapper.default.hover.defaultDark,
        focus: ColorMapper.default.unchecked,
        focusShadow: ColorMapper.default.focus.defaultLight,
        visited: gest.roxo44,
        disabled: ColorMapper.disabled.foreground,
    },
    destructive: {
        foreground: ColorMapper.destructive.foreground,
        hover: ColorMapper.destructive.unchecked,
        active: ColorMapper.destructive.hover.defaultDark,
        focus: ColorMapper.destructive.unchecked,
        focusShadow: ColorMapper.destructive.focus.defaultLight,
        visited: gest.roxo44,
        disabled: ColorMapper.disabled.foreground,
    },
    confirmation: {
        foreground: ColorMapper.confirmation.foreground,
        hover: ColorMapper.confirmation.unchecked,
        active: ColorMapper.confirmation.hover.defaultDark,
        focus: ColorMapper.confirmation.unchecked,
        focusShadow: ColorMapper.confirmation.focus.defaultLight,
        visited: gest.roxo44,
        disabled: ColorMapper.disabled.foreground,
    },
    negative: {
        foreground: inst.azulSebrae90,
        hover: def.white,
        active: ColorMapper.default.focus.defaultLight,
        focus: def.white,
        focusShadow: inst.azulSebrae90,
        visited: gest.roxo75,
        disabled: ColorMapper.grayScale.foreground,
    },
};
var TypographyCustomLinkMapper = function (color) {
    if (!Color.validateColor(color)) {
        return undefined;
    }
    return {
        foreground: color,
        hover: createColorSmartLightingControl(color, { l: 0.6 }, 'lighter'),
        active: ColorMapper.dark.hover.create(color),
        focus: createColorSmartLightingControl(color, { l: 0.6 }, 'lighter'),
        focusShadow: ColorMapper.light.focus.create(color),
        visited: gest.roxo44,
        disabled: ColorMapper.disabled.foreground,
    };
};
var TypographyTypesColor = {
    default: {
        foreground: inst.cinzaSebrae45,
        strong: inst.cinzaSebrae30,
        soft: inst.cinzaSebrae45,
        unselected: inst.cinzaSebrae60,
        selected: inst.cinzaSebrae20,
    },
    confirmation: {
        foreground: feed.sucesso45,
        strong: feed.sucesso26,
        soft: feed.sucesso45,
        unselected: feed.sucesso70,
        selected: feed.sucesso20,
    },
    destructive: {
        foreground: feed.erro45,
        strong: feed.erro35,
        soft: feed.erro45,
        unselected: feed.erro60,
        selected: createColorSmartLightingControl(feed.erro45, { l: 0.2 }, 'darker'),
    },
};
var TypographtCustomTypesColor = function (color) {
    if (!color) {
        return undefined;
    }
    return {
        foreground: color,
        strong: createColorSmartLightingControl(color, { l: 0.3 }, 'darker'),
        soft: color,
        unselected: createColorSmartLightingControl(color, { l: 0.6 }, 'lighter'),
        selected: createColorSmartLightingControl(color, { l: 0.2 }, 'darker'),
    };
};

var BaSeTyporaphyWrapper = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var fontSize = props.fontSize, lineHeight = props.lineHeight, children = props.children, color = props.color, type = props.type, link = props.link, Wrapper = props.wrapper, 
    // tslint:disable-next-line: trailing-comma
    other = __rest(props, ["fontSize", "lineHeight", "children", "color", "type", "link", "wrapper"]);
    var avaliableColors = !!color
        ? (_a = TypographyLinkMapper[color]) !== null && _a !== void 0 ? _a : TypographyCustomLinkMapper(color)
        : undefined;
    var typeColor = !!type
        ? (_c = (_b = TypographyTypesColor[color !== null && color !== void 0 ? color : 'default']) === null || _b === void 0 ? void 0 : _b[type]) !== null && _c !== void 0 ? _c : (_d = TypographtCustomTypesColor(color)) === null || _d === void 0 ? void 0 : _d[type]
        : null;
    var AbstractElement = React.memo(function (memoProps) { return (React.createElement(LinkWrapper, { fontSize: fontSize, lineHeight: lineHeight, isDisabled: memoProps === null || memoProps === void 0 ? void 0 : memoProps.isDisabled, isUnderline: memoProps === null || memoProps === void 0 ? void 0 : memoProps.isUnderline, href: !!(memoProps === null || memoProps === void 0 ? void 0 : memoProps.link) ? memoProps.link : undefined, colors: avaliableColors, target: memoProps === null || memoProps === void 0 ? void 0 : memoProps.target },
        React.createElement(Wrapper, __assign({ color: avaliableColors === null || avaliableColors === void 0 ? void 0 : avaliableColors.foreground }, other), children))); });
    var basicLink = React.useMemo(function () { return link; }, [link]);
    if (!!link) {
        if (typeof link === 'string') {
            return (React.createElement(AbstractElement, { isUnderline: true, link: link, isDisabled: false }));
        }
        if (!!(basicLink === null || basicLink === void 0 ? void 0 : basicLink.href)) {
            return (React.createElement(AbstractElement, { isUnderline: !!(basicLink === null || basicLink === void 0 ? void 0 : basicLink.isUnderline), link: (basicLink === null || basicLink === void 0 ? void 0 : basicLink.isDisabled) ? '' : (_e = basicLink === null || basicLink === void 0 ? void 0 : basicLink.href) !== null && _e !== void 0 ? _e : '', isDisabled: !!(basicLink === null || basicLink === void 0 ? void 0 : basicLink.isDisabled), target: basicLink === null || basicLink === void 0 ? void 0 : basicLink.target }));
        }
        if (!!(basicLink === null || basicLink === void 0 ? void 0 : basicLink.element) && React.isValidElement((_f = basicLink === null || basicLink === void 0 ? void 0 : basicLink.element) === null || _f === void 0 ? void 0 : _f.call(basicLink))) {
            return React.cloneElement((_g = basicLink === null || basicLink === void 0 ? void 0 : basicLink.element) === null || _g === void 0 ? void 0 : _g.call(basicLink), (basicLink === null || basicLink === void 0 ? void 0 : basicLink.isDisabled) ? { to: '' } : {}, React.createElement(AbstractElement, { isUnderline: !!(basicLink === null || basicLink === void 0 ? void 0 : basicLink.isUnderline), link: !!(basicLink === null || basicLink === void 0 ? void 0 : basicLink.isDisabled)
                    ? ''
                    : (_l = (_k = (_j = (_h = basicLink === null || basicLink === void 0 ? void 0 : basicLink.element) === null || _h === void 0 ? void 0 : _h.call(basicLink)) === null || _j === void 0 ? void 0 : _j.props) === null || _k === void 0 ? void 0 : _k.to) !== null && _l !== void 0 ? _l : '#', isDisabled: !!(basicLink === null || basicLink === void 0 ? void 0 : basicLink.isDisabled), target: basicLink === null || basicLink === void 0 ? void 0 : basicLink.target }));
        }
        if (React.isValidElement(link === null || link === void 0 ? void 0 : link())) {
            return React.cloneElement(link === null || link === void 0 ? void 0 : link(), {}, React.createElement(AbstractElement, { isUnderline: true, link: (_q = (_p = (_o = (_m = link) === null || _m === void 0 ? void 0 : _m()) === null || _o === void 0 ? void 0 : _o.props) === null || _p === void 0 ? void 0 : _p.to) !== null && _q !== void 0 ? _q : '#', isDisabled: false }));
        }
    }
    return (React.createElement(Wrapper, __assign({ color: typeColor !== null && typeColor !== void 0 ? typeColor : avaliableColors === null || avaliableColors === void 0 ? void 0 : avaliableColors.foreground }, other), children));
};

var StyledSmall1 = makeDefaultTypographytStyled('Small1', 'small', 0.83, 1.2);

var BaSeSmall1 = function (props) { return (React.createElement(BaSeTyporaphyWrapper, __assign({ fontSize: 0.83, lineHeight: 1.2, wrapper: StyledSmall1 }, props), props.children)); };
BaSeSmall1.displayName = 'BaSeSmall1';

var StyledSmall2 = makeDefaultTypographytStyled('Small2', 'small', 0.69, 1.2);

var BaSeSmall2 = function (props) { return (React.createElement(BaSeTyporaphyWrapper, __assign({ fontSize: 0.69, lineHeight: 1.2, wrapper: StyledSmall2 }, props), props.children)); };
BaSeSmall2.displayName = 'BaSeSmall2';

var none$1 = 'none';
var borderSize$2 = 7;
var transparenteBorder$1 = "".concat(borderSize$2, "px solid ").concat(BaSeTheme.colors.defaultColors.transparent);
var basePosition$1 = "".concat(-1 * borderSize$2, "px");
var calcPosition$1 = "calc(50% - ".concat(borderSize$2, "px)");
var transparenteBorderSmaller$1 = "".concat(borderSize$2, "px solid ").concat(BaSeTheme.colors.defaultColors.transparent);
var basePositionSmaller$1 = "".concat(-1 * borderSize$2 + 1, "px");
var calcPositionSmaller$1 = "calc(50% - ".concat(borderSize$2, "px)");
var replaceColor = function (color) {
    return color
        ? "".concat(borderSize$2, "px solid ").concat(color)
        : "".concat(borderSize$2, "px solid ").concat(BaSeTheme.colors.defaultColors.white);
};
var getTriangleMapper$1 = function (themeMode, color, direction, overrideColors, darkColor) {
    var _a;
    var TriangleProps = {
        dark: {
            neutral: {
                widthTop: none$1,
                widthRight: none$1,
                widthBottom: none$1,
                widthLeft: none$1,
            },
            top: {
                positionBottom: basePosition$1,
                positionRight: calcPosition$1,
                widthTop: "".concat(borderSize$2, "px solid ").concat(darkColor || ColorMapper.create(ColorMapper.getColor(color), 0.5)),
                widthRight: transparenteBorder$1,
                widthBottom: none$1,
                widthLeft: transparenteBorder$1,
            },
            right: {
                positionLeft: basePosition$1,
                positionBottom: calcPosition$1,
                widthTop: transparenteBorder$1,
                widthRight: "".concat(borderSize$2, "px solid ").concat(darkColor || ColorMapper.create(ColorMapper.getColor(color), 0.5)),
                widthBottom: transparenteBorder$1,
                widthLeft: none$1,
            },
            bottom: {
                positionTop: basePosition$1,
                positionRight: calcPosition$1,
                widthTop: none$1,
                widthRight: transparenteBorder$1,
                widthBottom: "".concat(borderSize$2, "px solid ").concat(darkColor || ColorMapper.create(ColorMapper.getColor(color), 0.5)),
                widthLeft: transparenteBorder$1,
            },
            left: {
                positionRight: basePosition$1,
                positionBottom: calcPosition$1,
                widthTop: transparenteBorder$1,
                widthRight: none$1,
                widthBottom: transparenteBorder$1,
                widthLeft: "".concat(borderSize$2, "px solid ").concat(darkColor || ColorMapper.create(ColorMapper.getColor(color), 0.5)),
            },
        },
        light: {
            neutral: {
                widthTop: none$1,
                widthRight: none$1,
                widthBottom: none$1,
                widthLeft: none$1,
            },
            top: {
                positionBottom: basePosition$1,
                positionRight: calcPosition$1,
                widthTop: "".concat(borderSize$2, "px solid ").concat(overrideColors || color),
                widthRight: transparenteBorder$1,
                widthBottom: none$1,
                widthLeft: transparenteBorder$1,
            },
            right: {
                positionLeft: basePosition$1,
                positionBottom: calcPosition$1,
                widthTop: transparenteBorder$1,
                widthRight: "".concat(borderSize$2, "px solid ").concat(overrideColors || color),
                widthBottom: transparenteBorder$1,
                widthLeft: none$1,
            },
            bottom: {
                positionTop: basePosition$1,
                positionRight: calcPosition$1,
                widthTop: none$1,
                widthRight: transparenteBorder$1,
                widthBottom: "".concat(borderSize$2, "px solid ").concat(overrideColors || color),
                widthLeft: transparenteBorder$1,
            },
            left: {
                positionRight: basePosition$1,
                positionBottom: calcPosition$1,
                widthTop: transparenteBorder$1,
                widthRight: none$1,
                widthBottom: transparenteBorder$1,
                widthLeft: "".concat(borderSize$2, "px solid ").concat(overrideColors || color),
            },
        },
    };
    return TriangleProps[themeMode]
        ? (_a = TriangleProps[themeMode][direction]) !== null && _a !== void 0 ? _a : TriangleProps[themeMode].neutral
        : TriangleProps.dark.neutral;
};
var getTriangleMapperSmaller$1 = function (themeMode, color, direction, overrideColors) {
    var _a;
    var TrianglePropsSmaller = {
        dark: {
            neutral: {
                widthTop: none$1,
                widthRight: none$1,
                widthBottom: none$1,
                widthLeft: none$1,
            },
            top: {
                positionBottom: basePositionSmaller$1,
                positionRight: calcPositionSmaller$1,
                widthTop: "".concat(borderSize$2, "px solid ").concat(overrideColors || ColorMapper.create(ColorMapper.getColor(color), 0.5)),
                widthRight: transparenteBorderSmaller$1,
                widthBottom: none$1,
                widthLeft: transparenteBorderSmaller$1,
            },
            right: {
                positionLeft: basePositionSmaller$1,
                positionBottom: calcPositionSmaller$1,
                widthTop: transparenteBorderSmaller$1,
                widthRight: "".concat(borderSize$2, "px solid ").concat(overrideColors || ColorMapper.create(ColorMapper.getColor(color), 0.5)),
                widthBottom: transparenteBorderSmaller$1,
                widthLeft: none$1,
            },
            bottom: {
                positionTop: basePositionSmaller$1,
                positionRight: calcPositionSmaller$1,
                widthTop: none$1,
                widthRight: transparenteBorderSmaller$1,
                widthBottom: "".concat(borderSize$2, "px solid ").concat(overrideColors || ColorMapper.create(ColorMapper.getColor(color), 0.5)),
                widthLeft: transparenteBorderSmaller$1,
            },
            left: {
                positionRight: basePositionSmaller$1,
                positionBottom: calcPositionSmaller$1,
                widthTop: transparenteBorderSmaller$1,
                widthRight: none$1,
                widthBottom: transparenteBorderSmaller$1,
                widthLeft: "".concat(borderSize$2, "px solid ").concat(overrideColors || ColorMapper.create(ColorMapper.getColor(color), 0.5)),
            },
        },
        light: {
            neutral: {
                widthTop: none$1,
                widthRight: none$1,
                widthBottom: none$1,
                widthLeft: none$1,
            },
            top: {
                positionBottom: basePositionSmaller$1,
                positionRight: calcPositionSmaller$1,
                widthTop: replaceColor(overrideColors),
                widthRight: transparenteBorderSmaller$1,
                widthBottom: none$1,
                widthLeft: transparenteBorderSmaller$1,
            },
            right: {
                positionLeft: basePositionSmaller$1,
                positionBottom: calcPositionSmaller$1,
                widthTop: transparenteBorderSmaller$1,
                widthRight: replaceColor(overrideColors),
                widthBottom: transparenteBorderSmaller$1,
                widthLeft: none$1,
            },
            bottom: {
                positionTop: basePositionSmaller$1,
                positionRight: calcPositionSmaller$1,
                widthTop: none$1,
                widthRight: transparenteBorderSmaller$1,
                widthBottom: replaceColor(overrideColors),
                widthLeft: transparenteBorderSmaller$1,
            },
            left: {
                positionRight: basePositionSmaller$1,
                positionBottom: calcPositionSmaller$1,
                widthTop: transparenteBorderSmaller$1,
                widthRight: none$1,
                widthBottom: transparenteBorderSmaller$1,
                widthLeft: replaceColor(overrideColors),
            },
        },
    };
    return TrianglePropsSmaller[themeMode]
        ? (_a = TrianglePropsSmaller[themeMode][direction]) !== null && _a !== void 0 ? _a : TrianglePropsSmaller[themeMode].neutral
        : TrianglePropsSmaller.dark.neutral;
};
var TooltipColorMapper = {
    default: BaSeTheme.colors.institucionais.azulSebrae36,
    destructive: BaSeTheme.colors.feedbackInterface.erro45,
    attention: BaSeTheme.colors.feedbackInterface.atencao55,
    confirmation: BaSeTheme.colors.feedbackInterface.sucesso26,
};

var TooltipContainer = styled.div.attrs({
    className: 'BaSe--tooltip',
})(templateObject_9$j || (templateObject_9$j = __makeTemplateObject(["\n  z-index: ", ";\n  transition: ", ";\n  will-change: opacity;\n  position: absolute;\n\n  ", "\n  ", "\n  opacity: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  z-index: ", ";\n  transition: ", ";\n  will-change: opacity;\n  position: absolute;\n\n  ", "\n  ", "\n  opacity: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), BaSeTheme.stackOrder.aboveNormal, BaSeTheme.transitions.allPropertiesContinuousNormal, function (props) {
    return props.open
        ? css(templateObject_1$U || (templateObject_1$U = __makeTemplateObject(["\n          visibility: visible;\n        "], ["\n          visibility: visible;\n        "]))) : css(templateObject_2$J || (templateObject_2$J = __makeTemplateObject(["\n          visibility: hidden;\n        "], ["\n          visibility: hidden;\n        "])));
}, function (props) {
    return !props.open && css(templateObject_3$z || (templateObject_3$z = __makeTemplateObject(["\n      pointer-events: none;\n    "], ["\n      pointer-events: none;\n    "])));
}, function (props) { return (props.open ? 1 : 0); }, function (props) {
    return props.top && css(templateObject_4$u || (templateObject_4$u = __makeTemplateObject(["\n      top: ", ";\n    "], ["\n      top: ", ";\n    "])), props.top);
}, function (props) {
    return props.right && css(templateObject_5$r || (templateObject_5$r = __makeTemplateObject(["\n      right: ", ";\n    "], ["\n      right: ", ";\n    "])), props.right);
}, function (props) {
    return props.bottom && css(templateObject_6$q || (templateObject_6$q = __makeTemplateObject(["\n      bottom: ", ";\n    "], ["\n      bottom: ", ";\n    "])), props.bottom);
}, function (props) {
    return props.left && css(templateObject_7$m || (templateObject_7$m = __makeTemplateObject(["\n      left: ", ";\n    "], ["\n      left: ", ";\n    "])), props.left);
}, function (props) { return css(templateObject_8$l || (templateObject_8$l = __makeTemplateObject(["\n    width: ", ";\n  "], ["\n    width: ", ";\n  "])), props.width ? "".concat(props.width, "px") : 'auto'); });
var TooltipBody = styled.div.attrs({
    className: 'BaSe--tooltip-body',
})(templateObject_11$d || (templateObject_11$d = __makeTemplateObject(["\n  background-color: ", ";\n  ", "\n  border-radius: 4px;\n  ", "\n  position: relative;\n"], ["\n  background-color: ", ";\n  ", "\n  border-radius: 4px;\n  ", "\n  position: relative;\n"])), function (props) {
    var _a, _b;
    return props.themeMode === 'light'
        ? (ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.getColor((_a = props === null || props === void 0 ? void 0 : props.overrideColors) === null || _a === void 0 ? void 0 : _a.backgroundColor)) ||
            BaSeTheme.colors.defaultColors.white
        : ColorMapper.getColor((_b = props === null || props === void 0 ? void 0 : props.overrideColors) === null || _b === void 0 ? void 0 : _b.backgroundColor) ||
            ColorMapper.create(ColorMapper.getColor(props === null || props === void 0 ? void 0 : props.color), 0.5);
}, function (props) {
    var _a, _b;
    return props.themeMode === 'light' &&
        "border: 1px solid ".concat((_b = (_a = props === null || props === void 0 ? void 0 : props.overrideColors) === null || _a === void 0 ? void 0 : _a.borderColor) !== null && _b !== void 0 ? _b : props.color, ";");
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b;
    return css(templateObject_10$f || (templateObject_10$f = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", // medium
        ";\n  "])), size === 'small' ? '4px' : size === 'big' ? '12px' : '8px 12px' // medium
    );
});
var MessageWrapper = styled.span(templateObject_13$b || (templateObject_13$b = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n\n  ", "\n\n  & > small {\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n\n  ", "\n\n  & > small {\n    color: ", ";\n  }\n"])), function (_a) {
    var messageNoBreakLine = _a.messageNoBreakLine;
    return messageNoBreakLine && css(templateObject_12$c || (templateObject_12$c = __makeTemplateObject(["\n      white-space: nowrap;\n    "], ["\n      white-space: nowrap;\n    "])));
}, function (_a) {
    var color = _a.color, themeMode = _a.themeMode, overrideColors = _a.overrideColors;
    return (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground) ||
        (themeMode === 'light' ? color : BaSeTheme.colors.defaultColors.white);
});
var TooltipTriangle = styled.div(templateObject_14$b || (templateObject_14$b = __makeTemplateObject(["\n  width: 0;\n  height: 0;\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  border-top: ", ";\n  border-right: ", ";\n  border-left: ", ";\n  border-bottom: ", ";\n  z-index: ", ";\n"], ["\n  width: 0;\n  height: 0;\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  border-top: ", ";\n  border-right: ", ";\n  border-left: ", ";\n  border-bottom: ", ";\n  z-index: ", ";\n"])), function (props) { return props.positionTop && "top: ".concat(props.positionTop, ";"); }, function (props) { return props.positionRight && "right: ".concat(props.positionRight, ";"); }, function (props) { return props.positionLeft && "left: ".concat(props.positionLeft, ";"); }, function (props) { return props.positionBottom && "bottom: ".concat(props.positionBottom, ";"); }, function (props) { return props.widthTop; }, function (props) { return props.widthRight; }, function (props) { return props.widthLeft; }, function (props) { return props.widthBottom; }, BaSeTheme.stackOrder.aboveNormal + 1);
var TooltipTriangleSmaller = styled.div(templateObject_15$8 || (templateObject_15$8 = __makeTemplateObject(["\n  width: 0;\n  height: 0;\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  border-top: ", ";\n  border-right: ", ";\n  border-left: ", ";\n  border-bottom: ", ";\n  z-index: ", ";\n"], ["\n  width: 0;\n  height: 0;\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  border-top: ", ";\n  border-right: ", ";\n  border-left: ", ";\n  border-bottom: ", ";\n  z-index: ", ";\n"])), function (props) { return props.positionTop && "top: ".concat(props.positionTop, ";"); }, function (props) { return props.positionRight && "right: ".concat(props.positionRight, ";"); }, function (props) { return props.positionLeft && "left: ".concat(props.positionLeft, ";"); }, function (props) { return props.positionBottom && "bottom: ".concat(props.positionBottom, ";"); }, function (props) { return props.widthTop; }, function (props) { return props.widthRight; }, function (props) { return props.widthLeft; }, function (props) { return props.widthBottom; }, BaSeTheme.stackOrder.aboveNormal + 2);
var templateObject_1$U, templateObject_2$J, templateObject_3$z, templateObject_4$u, templateObject_5$r, templateObject_6$q, templateObject_7$m, templateObject_8$l, templateObject_9$j, templateObject_10$f, templateObject_11$d, templateObject_12$c, templateObject_13$b, templateObject_14$b, templateObject_15$8;

var BaSeTooltip = function (_a) {
    var width = _a.width, _b = _a.message, message = _b === void 0 ? '' : _b, _c = _a.messageNoBreakLine, messageNoBreakLine = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 'medium' : _d, _e = _a.direction, direction = _e === void 0 ? 'neutral' : _e, _f = _a.color, color = _f === void 0 ? 'default' : _f, _g = _a.themeMode, themeMode = _g === void 0 ? 'light' : _g, _h = _a.coordinates, coordinates = _h === void 0 ? {} : _h, _j = _a.delayToOpen, delayToOpen = _j === void 0 ? 0 : _j, _k = _a.open, externalOpen = _k === void 0 ? false : _k, buddyRef = _a.buddyRef, _l = _a.refOutput, refOutput = _l === void 0 ? function () { } : _l, overrideColors = _a.overrideColors;
    var open = useDebounce(externalOpen, externalOpen ? delayToOpen : 0);
    var messages = Array.isArray(message) ? message : [message];
    var mappedColor = React.useCallback(function () { var _a; return (_a = TooltipColorMapper[color]) !== null && _a !== void 0 ? _a : color; }, [color, TooltipColorMapper]);
    var TriangleProps = React.useCallback(function () {
        return getTriangleMapper$1(themeMode, mappedColor(), direction, overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.borderColor, overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor);
    }, [getTriangleMapper$1, themeMode, mappedColor, direction, overrideColors]);
    var TrianglePropsSmaller = React.useCallback(function () {
        return getTriangleMapperSmaller$1(themeMode, mappedColor(), direction, overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor);
    }, [direction, mappedColor, themeMode, overrideColors]);
    var getCoordenates = React.useCallback(function () {
        var _a, _b;
        if (!(buddyRef === null || buddyRef === void 0 ? void 0 : buddyRef.current)) {
            return coordinates;
        }
        var rect = (_b = (_a = buddyRef === null || buddyRef === void 0 ? void 0 : buddyRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect) === null || _b === void 0 ? void 0 : _b.call(_a);
        if (!rect) {
            throw Error('BaSeTooltip: Não foi possível recuperar as informações de tamanho e posição do "buddyRef"');
        }
        if (direction === 'neutral') {
            throw Error("BaSeTooltip: Caso tenha \"buddyRef\",\n        informe uma dire\u00E7\u00E3o aqui com a prop \"direction\" entre:\n        - top;\n        - left;\n        - right; ou\n        - bottom.");
        }
        var triangleHeight = 8;
        var unset = 'unset';
        var height = rect.height + '';
        var heightPlusTriangleHeight = "".concat(rect.height + triangleHeight, "px");
        var widthPlusTriangleHeight = "".concat(rect.width + triangleHeight, "px");
        var coords = {
            top: {
                top: unset,
                bottom: heightPlusTriangleHeight,
                left: unset,
                right: unset,
            },
            bottom: {
                top: heightPlusTriangleHeight,
                bottom: unset,
                left: unset,
                right: unset,
            },
            left: {
                top: height,
                bottom: height,
                left: unset,
                right: widthPlusTriangleHeight,
            },
            right: {
                top: height,
                bottom: height,
                left: widthPlusTriangleHeight,
                right: unset,
            },
        };
        return __assign(__assign({}, coords[direction]), coordinates);
    }, [buddyRef === null || buddyRef === void 0 ? void 0 : buddyRef.current, coordinates]);
    var _m = React.useMemo(function () { return getCoordenates(); }, [getCoordenates]), top = _m.top, left = _m.left, bottom = _m.bottom, right = _m.right;
    var ref = React.useRef(null);
    React.useEffect(function () {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            refOutput(ref === null || ref === void 0 ? void 0 : ref.current);
        }
    }, [ref, message]);
    return (React.createElement(TooltipContainer, { "aria-hidden": !open, open: open, ref: ref, top: top, left: left, bottom: bottom, right: right, width: width },
        React.createElement(TooltipTriangle, __assign({}, TriangleProps())),
        React.createElement(TooltipTriangleSmaller, __assign({}, TrianglePropsSmaller())),
        React.createElement(TooltipBody, { overrideColors: overrideColors, size: size, color: mappedColor(), themeMode: themeMode }, messages.map(function (item, index) { return (React.createElement(MessageWrapper, { key: index, messageNoBreakLine: messageNoBreakLine, color: mappedColor(), overrideColors: overrideColors, themeMode: themeMode }, size === 'small' ? (React.createElement(BaSeSmall2, null, item)) : (React.createElement(BaSeSmall1, null, item)))); }))));
};
BaSeTooltip.displayName = 'BaSeTooltip';

var objectNotEmpty = function (obj) { return !!obj && !!Object.keys(obj).length; };

var BaSeButton = function (_a) {
    var _b;
    var _c = _a.type, type = _c === void 0 ? 'primary' : _c, _d = _a.value, value = _d === void 0 ? '' : _d, _e = _a.size, size = _e === void 0 ? 'medium' : _e, _f = _a.width, width = _f === void 0 ? 'auto' : _f, _g = _a.rightIcon, rightIcon = _g === void 0 ? '' : _g, _h = _a.leftIcon, leftIcon = _h === void 0 ? '' : _h, _j = _a.isBold, isBold = _j === void 0 ? false : _j, _k = _a.spacedIcons, spacedIcons = _k === void 0 ? false : _k, _l = _a.isDisabled, isDisabled = _l === void 0 ? false : _l, _m = _a.buttonType, buttonType = _m === void 0 ? 'button' : _m, _o = _a.color, color = _o === void 0 ? 'default' : _o, _p = _a.autoFocus, autoFocus = _p === void 0 ? false : _p, _q = _a.isLoading, isLoading = _q === void 0 ? false : _q, _r = _a.loadingText, loadingText = _r === void 0 ? 'Carregando…' : _r, _s = _a.tooltip, tooltip = _s === void 0 ? {} : _s, overrideColors = _a.overrideColors, _t = _a.disableTextColorHover, disableTextColorHover = _t === void 0 ? false : _t, onClick = _a.onClick, onFocus = _a.onFocus, onBlur = _a.onBlur;
    var fontWeigt = React.useCallback(function () { return (isBold ? 'bold' : 'normal'); }, [isBold]);
    var justifyContent = React.useCallback(function () {
        return spacedIcons && (!!leftIcon || !!rightIcon) ? 'space-between' : 'center';
    }, [spacedIcons, leftIcon, rightIcon]);
    var minWidth = React.useCallback(function () { return (Number(!!leftIcon) + Number(!!rightIcon)) * 30 + 50; }, [leftIcon, rightIcon]);
    var sizeValues = React.useCallback(function () { var _a; return (_a = styleMapSize[size]) !== null && _a !== void 0 ? _a : styleMapSize.medium; }, [size]);
    var replaceObjects = React.useCallback(function (originalColors) {
        var _a, _b, _c, _d;
        if (!overrideColors) {
            if (disableTextColorHover) {
                originalColors.style.colorHover = originalColors.color;
            }
            return originalColors;
        }
        var overrider = (_b = (_a = buttonOverrideColor(overrideColors)) === null || _a === void 0 ? void 0 : _a[type]) !== null && _b !== void 0 ? _b : (_c = buttonOverrideColor(overrideColors)) === null || _c === void 0 ? void 0 : _c.primary;
        var finalObj = {};
        for (var key in originalColors) {
            if (key === 'style') {
                finalObj.style = {};
                // tslint:disable-next-line: forin
                for (var style in originalColors.style) {
                    finalObj.style[style] =
                        ((_d = overrider === null || overrider === void 0 ? void 0 : overrider.style) === null || _d === void 0 ? void 0 : _d[style]) || originalColors.style[style];
                }
            }
            else {
                finalObj[key] = overrider[key] || originalColors[key];
            }
        }
        if (disableTextColorHover) {
            finalObj.style.colorHover = finalObj.color;
        }
        return finalObj;
    }, [color, type, overrideColors, disableTextColorHover]);
    var getColorsAtributes = React.useCallback(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (color) {
            if (!ColorMapper.isValidType(color)) {
                return ((_b = (_a = mapCustomColorsButtonValues(color, disableTextColorHover, overrideColors)) === null || _a === void 0 ? void 0 : _a[type]) !== null && _b !== void 0 ? _b : mapCustomColorsButtonValues(color, disableTextColorHover, overrideColors).primary);
            }
            else {
                return replaceObjects((_d = (_c = mapButtonValues[type]) === null || _c === void 0 ? void 0 : _c[color]) !== null && _d !== void 0 ? _d : (_e = mapButtonValues.primary) === null || _e === void 0 ? void 0 : _e[color]);
            }
        }
        else {
            return replaceObjects((_g = (_f = mapButtonValues[type]) === null || _f === void 0 ? void 0 : _f.default) !== null && _g !== void 0 ? _g : (_h = mapButtonValues.primary) === null || _h === void 0 ? void 0 : _h.default);
        }
    }, [
        ColorMapper,
        mapButtonValues,
        type,
        color,
        overrideColors,
        disableTextColorHover,
        replaceObjects,
    ]);
    var buttonValues = React.useCallback(function () {
        var _a, _b, _c;
        return isDisabled
            ? color === 'negative'
                ? (_a = mapButtonValues[type].negative) === null || _a === void 0 ? void 0 : _a.disabled
                : (_c = (_b = mapButtonValues[type]) === null || _b === void 0 ? void 0 : _b.disabled) !== null && _c !== void 0 ? _c : mapButtonValues.primary.disabled
            : getColorsAtributes();
    }, [type, getColorsAtributes, mapButtonValues, isDisabled]);
    var _u = buttonValues(), _v = _u.style, bgC = _v.bgC, bcCHover = _v.bcCHover, boxShadowFocus = _v.boxShadowFocus, border = _v.border, colorHover = _v.colorHover, iconColor = _u.iconColor, buttonColor = _u.color;
    var _w = sizeValues(), fontSize = _w.fontSize, lineHeight = _w.lineHeight, padding = _w.padding, loadingSize = _w.loadingSize;
    var handleClick = function (e) {
        var _a;
        if (!isLoading) {
            (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            onClick(e);
        }
    };
    var buttonRef = React.useRef(null);
    var _x = React.useState(false), hasHover = _x[0], setHasHover = _x[1];
    var checkHover = React.useCallback(function (defaultColor) {
        return (type !== 'primary' ||
            (type === 'primary' && color === 'negative')) &&
            hasHover &&
            !!colorHover
            ? colorHover
            : defaultColor;
    }, [type, hasHover, colorHover]);
    var _y = React.useState(false), isTooltipOpen = _y[0], setIsTooltipOpen = _y[1];
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(StyledButton, { ref: buttonRef, className: "BaSe--button", autoFocus: autoFocus, onClick: handleClick, disabled: isDisabled, type: buttonType, backgroundColor: bgC, backgroundOnHover: bcCHover, border: border, hideBorder: type === 'secondary' || color === 'negative', padding: padding, width: width, minWidth: minWidth(), justifyContent: justifyContent(), boxShadowFocus: boxShadowFocus, onMouseEnter: function () {
            setHasHover(true);
            setIsTooltipOpen(true);
        }, onMouseLeave: function () {
            setHasHover(false);
            setIsTooltipOpen(false);
        }, onFocus: function (e) {
            setHasHover(true);
            onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
        }, onBlur: function (e) {
            setHasHover(false);
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        }, "aria-label": isLoading ? loadingText : '', boxShadow: type !== 'tertiary' && color !== 'negative', thickBorder: color === 'negative', medium: size === 'medium' },
        isLoading ? (React.createElement(React.Fragment, null,
            React.createElement(SpinnerContainer, { size: size },
                React.createElement(BaSeLoadingSpinner, { description: getMessage('loading.description'), diameter: loadingSize, color: color, type: type, disabled: isDisabled })),
            React.createElement(BaSeTextButton, { fontSize: fontSize, lineHeight: lineHeight, color: checkHover(buttonColor), hasLeftIcon: !!leftIcon, hasRightIcon: !!rightIcon, fontWeigt: fontWeigt() }, loadingText))) : (React.createElement(React.Fragment, null,
            !!leftIcon && (React.createElement(BaSeIcon, { description: getMessage('buttonIcon.defaultDescription'), name: leftIcon, size: Math.floor(fontSize * 16), color: checkHover(iconColor) })),
            React.createElement(BaSeTextButton, { fontSize: fontSize, lineHeight: lineHeight, color: checkHover(buttonColor), hasLeftIcon: !!leftIcon, hasRightIcon: !!rightIcon, fontWeigt: fontWeigt() }, value),
            !!rightIcon && (React.createElement(BaSeIcon, { description: getMessage('buttonIcon.defaultDescription'), name: rightIcon, size: Math.floor(fontSize * 16), color: checkHover(iconColor) })))),
        objectNotEmpty(tooltip) && (React.createElement(BaSeTooltip, { buddyRef: buttonRef, color: tooltip === null || tooltip === void 0 ? void 0 : tooltip.color, direction: tooltip === null || tooltip === void 0 ? void 0 : tooltip.direction, message: (_b = tooltip === null || tooltip === void 0 ? void 0 : tooltip.message) !== null && _b !== void 0 ? _b : '', open: isTooltipOpen, width: tooltip === null || tooltip === void 0 ? void 0 : tooltip.width, coordinates: tooltip === null || tooltip === void 0 ? void 0 : tooltip.coordinates }))));
};
BaSeButton.displayName = 'BaSeButton';

var ShapeStyle = styled.button(templateObject_1$T || (templateObject_1$T = __makeTemplateObject(["\n  position: relative;\n  border-radius: ", ";\n  display: flex;\n  background-color: ", ";\n  border: ", ";\n  align-items: center;\n  justify-content: center;\n  padding: ", "px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:focus {\n    border-radius: ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n    outline: none;\n    border-color: ", ";\n  }\n\n  &:active:not(:disabled) {\n    box-shadow: none;\n    transform: translateY(2px);\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n"], ["\n  position: relative;\n  border-radius: ", ";\n  display: flex;\n  background-color: ", ";\n  border: ", ";\n  align-items: center;\n  justify-content: center;\n  padding: ", "px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:focus {\n    border-radius: ", ";\n    background-color: ", ";\n    box-shadow: ", ";\n    outline: none;\n    border-color: ", ";\n  }\n\n  &:active:not(:disabled) {\n    box-shadow: none;\n    transform: translateY(2px);\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n"])), function (props) {
    return props.sideButton === 'none'
        ? props.borderRadius
        : props.sideButton === 'left'
            ? '4px 0px 0px 4px'
            : '0px 4px 4px 0px';
}, function (props) { return props.backgroundColor; }, function (props) { return props.border; }, function (props) { return props.padding; }, BaSeTheme.transitions.allPropertiesContinuousFast, function (props) { return props.backgroundOnHover; }, function (props) {
    return props.sideButton === 'none'
        ? props.borderRadius
        : props.sideButton === 'left'
            ? '4px 0px 0px 4px'
            : '0px 4px 4px 0px';
}, function (props) { return props.backgroundOnFocus; }, function (props) { return props.boxShadowOnFocus; }, BaSeTheme.colors.defaultColors.transparent);
var templateObject_1$T;

var extraSmallIconSize = { iconSize: 12 };
var BaSeShapeButton = function (_a) {
    var _b, _c, _d, _e, _f;
    var nameIcon = _a.nameIcon, value = _a.value, _g = _a.type, type = _g === void 0 ? 'primary' : _g, _h = _a.color, color = _h === void 0 ? BaSeTheme.components.button.colors.default : _h, _j = _a.shape, shape = _j === void 0 ? 'circle' : _j, _k = _a.sizeIcon, sizeIcon = _k === void 0 ? 'small' : _k, _l = _a.size, size = _l === void 0 ? 'medium' : _l, _m = _a.isDisabled, isDisabled = _m === void 0 ? false : _m, _o = _a.buttonType, buttonType = _o === void 0 ? 'button' : _o, _p = _a.sideButton, sideButton = _p === void 0 ? 'none' : _p, _q = _a.autoFocus, autoFocus = _q === void 0 ? false : _q, _r = _a.isLoading, isLoading = _r === void 0 ? false : _r, _s = _a.tooltip, tooltip = _s === void 0 ? {} : _s, onClick = _a.onClick, onFocus = _a.onFocus, onBlur = _a.onBlur;
    if (!nameIcon && !value) {
        throw Error('[BaSeShapeButton] error: Nome do ícone ou um valor textual é obrigatório!');
    }
    var borderRadius = (_b = shapeButtonBorderRadius[shape]) !== null && _b !== void 0 ? _b : shapeButtonBorderRadius.circle;
    var iconSize = (size === 'extra-small' || size === 'mega-small'
        ? extraSmallIconSize
        : (_c = shapeButtonIconMapSize[sizeIcon]) !== null && _c !== void 0 ? _c : shapeButtonIconMapSize.medium).iconSize;
    // TODO molhorar código
    var padding = size === 'big'
        ? (40 - iconSize) / 2 + 4
        : size === 'medium'
            ? (40 - iconSize) / 2
            : size === 'small' || size === 'extra-small'
                ? 4
                : 1.5;
    var colorIsMapped = color === BaSeTheme.components.button.colors.default ||
        color === BaSeTheme.components.button.colors.negative ||
        color === BaSeTheme.components.button.colors.destructive ||
        color === BaSeTheme.components.button.colors.confirmation;
    var colorIsNegative = color === BaSeTheme.components.button.colors.negative;
    var getColorsAtributes = function () {
        var _a, _b, _c, _d;
        if (color) {
            if (!colorIsMapped) {
                if (Color.validateColor(color)) {
                    return (_a = mapCustomColorsShapeButtonValues(color)) === null || _a === void 0 ? void 0 : _a[type];
                }
                return (_b = shapeButtonMapStyle('default')[type]) === null || _b === void 0 ? void 0 : _b.standard;
            }
            return (_c = shapeButtonMapStyle(color)[type]) === null || _c === void 0 ? void 0 : _c.standard;
        }
        return (_d = shapeButtonMapStyle('default')[type]) === null || _d === void 0 ? void 0 : _d.standard;
    };
    var typeMapped = colorIsNegative
        ? isDisabled
            ? (_d = shapeButtonMapStyle('default')[type]) === null || _d === void 0 ? void 0 : _d.negative.disabled
            : (_e = shapeButtonMapStyle('default')[type]) === null || _e === void 0 ? void 0 : _e.negative
        : isDisabled
            ? (_f = shapeButtonMapStyle('default')[type]) === null || _f === void 0 ? void 0 : _f.standard.disabled
            : getColorsAtributes();
    var background = typeMapped.background, border = typeMapped.border, backgroundOnFocus = typeMapped.backgroundOnFocus, iconColor = typeMapped.iconColor, hoverColor = typeMapped.hoverColor, boxShadowFocus = typeMapped.boxShadowFocus, borderHoverColor = typeMapped.borderHoverColor, iconHoverColor = typeMapped.iconHoverColor;
    var _t = React.useState(false), isHover = _t[0], setIsHover = _t[1];
    var _u = React.useState(false), isTooltipOpen = _u[0], setIsTooltipOpen = _u[1];
    var buttonRef = React.useRef(null);
    var handleClick = React.useCallback(function (event) {
        var _a;
        (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        onClick(event);
    }, [onClick, buttonRef]);
    return (React.createElement(ShapeStyle, { ref: buttonRef, className: "BaSe--button-shape", autoFocus: autoFocus, disabled: isDisabled, type: buttonType, backgroundOnFocus: backgroundOnFocus, border: isHover && !!borderHoverColor ? borderHoverColor : border, borderRadius: borderRadius, backgroundColor: background, backgroundOnHover: hoverColor, boxShadowOnFocus: size.includes('small')
            ? boxShadowFocus.replace('3', '2')
            : boxShadowFocus, padding: border === 'none' ? padding : padding - 1, sideButton: sideButton, onMouseEnter: function () {
            setIsHover(true);
            setIsTooltipOpen(true);
        }, onMouseLeave: function () {
            setIsHover(false);
            setIsTooltipOpen(false);
        }, onClick: handleClick, onFocus: onFocus, onBlur: onBlur },
        React.createElement(BaSeI18nConsumer, null, function (_a) {
            var getMessage = _a.getMessage;
            return isLoading ? (React.createElement(BaSeLoadingSpinner, { diameter: iconSize, color: isHover && !!iconHoverColor ? iconHoverColor : iconColor, description: getMessage('loading.description'), disabled: isDisabled, type: "tertiary" })) : nameIcon ? (React.createElement(BaSeIcon, { description: getMessage('buttonIcon.defaultDescription'), name: nameIcon, size: iconSize, color: isHover && !!iconHoverColor ? iconHoverColor : iconColor, colorTransition: "fast" })) : (React.createElement("div", { style: {
                    width: iconSize,
                    height: iconSize,
                    display: 'grid',
                    placeItems: 'center',
                } },
                React.createElement(BaSeSmall2, { color: isHover && !!iconHoverColor ? iconHoverColor : iconColor }, value)));
        }),
        objectNotEmpty(tooltip) && (React.createElement(BaSeTooltip, __assign({ buddyRef: buttonRef, open: isTooltipOpen }, tooltip)))));
};
BaSeShapeButton.displayName = 'BaSeShapeButton';

var StyledHeading4 = makeDefaultTypographytStyled('Heading4', 'h4', 1.44, 1.2);

var BaSeHeading4 = function (props) { return (React.createElement(BaSeTyporaphyWrapper, __assign({ fontSize: 1.44, lineHeight: 1.2, wrapper: StyledHeading4 }, props), props.children)); };
BaSeHeading4.displayName = 'BaSeHeading4';

var zIndexOverlay = BaSeTheme.stackOrder.overlay * 2;
function widthMobile() {
    return "90%;";
}
function widthTablet(size) {
    if (size === 'large') {
        return '450px';
    }
    if (size === 'medium') {
        return '450px';
    }
    // size === 'small'
    return '390px';
}
function widthDesktop(size) {
    if (size === 'large') {
        return '570px';
    }
    if (size === 'medium') {
        return '450px';
    }
    // size === 'small'
    return '390px';
}
function setModalWidth(isFluid, delimiter, defaultStyle) {
    if (!isFluid) {
        return defaultStyle;
    }
    return css(templateObject_1$S || (templateObject_1$S = __makeTemplateObject(["\n    width: 90%;\n    max-width: ", "px;\n  "], ["\n    width: 90%;\n    max-width: ", "px;\n  "])), BaSeTheme.breakpoints[delimiter].maxWidth);
}
var fadeIn = keyframes(templateObject_2$I || (templateObject_2$I = __makeTemplateObject(["\n  from {\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n"], ["\n  from {\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n"])));
var ModalContainer = styled.div(templateObject_3$y || (templateObject_3$y = __makeTemplateObject(["\n  display: grid;\n  place-items: center;\n  z-index: ", ";\n  padding: 8px;\n  box-sizing: border-box;\n\n  &,\n  &::before {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n  }\n\n  &::before {\n    content: '';\n    background: ", ";\n    opacity: 0.5;\n  }\n"], ["\n  display: grid;\n  place-items: center;\n  z-index: ", ";\n  padding: 8px;\n  box-sizing: border-box;\n\n  &,\n  &::before {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n  }\n\n  &::before {\n    content: '';\n    background: ", ";\n    opacity: 0.5;\n  }\n"])), zIndexOverlay + 0, BaSeTheme.colors.institucionais.cinzaSebrae20);
var ModalDialog = styled.div(templateObject_6$p || (templateObject_6$p = __makeTemplateObject(["\n  box-sizing: content-box;\n  background-color: ", ";\n  box-shadow: ", ";\n  z-index: ", ";\n  border: 2px solid ", ";\n  border-radius: 4px;\n  padding: 0;\n  margin: 0;\n  will-change: opacity, transform;\n  animation: ", " ", " forwards;\n\n  ", "\n"], ["\n  box-sizing: content-box;\n  background-color: ", ";\n  box-shadow: ", ";\n  z-index: ", ";\n  border: 2px solid ", ";\n  border-radius: 4px;\n  padding: 0;\n  margin: 0;\n  will-change: opacity, transform;\n  animation: ", " ", " forwards;\n\n  ", "\n"])), BaSeTheme.colors.defaultColors.white, BaSeTheme.shadows.profundidade32, zIndexOverlay + 1, BaSeTheme.colors.institucionais.azulSebrae90, fadeIn, BaSeTheme.transitions.durationNormal, function (_a) {
    var size = _a.size, delimiter = _a.delimiter, isFluid = _a.isFluid;
    return css(templateObject_5$q || (templateObject_5$q = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), setModalWidth(isFluid, delimiter, css(templateObject_4$t || (templateObject_4$t = __makeTemplateObject(["\n        /*mobileSmall*/\n        ", "\n        /*mobile*/\n        ", "\n        /*mobileLarge*/\n        ", "\n        /*tablet*/\n        ", "\n        /*desktop*/\n        ", "\n        /*desktopLarge*/\n        ", "\n      "], ["\n        /*mobileSmall*/\n        ", "\n        /*mobile*/\n        ", "\n        /*mobileLarge*/\n        ", "\n        /*tablet*/\n        ", "\n        /*desktop*/\n        ", "\n        /*desktopLarge*/\n        ", "\n      "])), BaSeTheme.breakpoints.mobileSmall.mediaQueryCss("\n            width: ".concat(widthMobile(), ";\n            min-width: ").concat(widthMobile(), ";\n            max-width: ").concat(widthMobile(), ";\n        ")), BaSeTheme.breakpoints.mobile.mediaQueryCss("\n            width: ".concat(widthMobile(), ";\n            min-width: ").concat(widthMobile(), ";\n            max-width: ").concat(widthMobile(), ";\n        ")), BaSeTheme.breakpoints.mobileLarge.mediaQueryCss("\n            width: ".concat(widthMobile(), ";\n            min-width: ").concat(widthMobile(), ";\n            max-width: ").concat(widthMobile(), ";\n        ")), BaSeTheme.breakpoints.tablet.mediaQueryCss("\n            width: ".concat(widthTablet(size), ";\n            min-width: ").concat(widthTablet(size), ";\n            max-width: ").concat(widthTablet(size), ";\n        ")), BaSeTheme.breakpoints.desktop.mediaQueryCss("\n            width: ".concat(widthDesktop(size), ";\n            min-width: ").concat(widthDesktop(size), ";\n            max-width: ").concat(widthDesktop(size), ";\n        ")), BaSeTheme.breakpoints.desktopLarge.mediaQueryCss("\n            width: ".concat(widthDesktop(size), ";\n            min-width: ").concat(widthDesktop(size), ";\n            max-width: ").concat(widthDesktop(size), ";\n        ")))));
});
var ModalHeader = styled.div(templateObject_7$l || (templateObject_7$l = __makeTemplateObject(["\n  margin: 0;\n  padding: 16px;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  border: none;\n  border-bottom: 1px solid ", ";\n"], ["\n  margin: 0;\n  padding: 16px;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  border: none;\n  border-bottom: 1px solid ", ";\n"])), BaSeTheme.colors.institucionais.cinzaSebrae90);
var ModalBody = styled.div(templateObject_8$k || (templateObject_8$k = __makeTemplateObject(["\n  margin: 0;\n  padding: 16px;\n"], ["\n  margin: 0;\n  padding: 16px;\n"])));
var ModalFooter = styled.div(templateObject_9$i || (templateObject_9$i = __makeTemplateObject(["\n  margin: 0;\n  padding: 0 16px 16px;\n  display: flex;\n  gap: 16px;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: ", ";\n  align-items: center;\n  &:empty {\n    padding-bottom: 0;\n  }\n"], ["\n  margin: 0;\n  padding: 0 16px 16px;\n  display: flex;\n  gap: 16px;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: ", ";\n  align-items: center;\n  &:empty {\n    padding-bottom: 0;\n  }\n"])), function (_a) {
    var _b = _a.alignActions, alignActions = _b === void 0 ? 'start' : _b;
    return alignActions === 'center' ? 'center' : "flex-".concat(alignActions);
});
var templateObject_1$S, templateObject_2$I, templateObject_3$y, templateObject_4$t, templateObject_5$q, templateObject_6$p, templateObject_7$l, templateObject_8$k, templateObject_9$i;

var ModalContent = React.memo(function (_a) {
    var content = _a.content, onClose = _a.onClose, onContentEvent = _a.onContentEvent;
    return (React.createElement(React.Fragment, null, content === null || content === void 0 ? void 0 : content({
        closeModal: onClose,
        emitEvent: onContentEvent !== null && onContentEvent !== void 0 ? onContentEvent : (function () { }),
    })));
});
var idSequence$b = idGenerator();
function forcePromise(what) {
    if (!(what instanceof Promise)) {
        return Promise.resolve(what);
    }
    return what;
}
var BaSeModal = function (_a) {
    var size = _a.size, title = _a.title, titleColor = _a.titleColor, _b = _a.actions, actions = _b === void 0 ? ['Fechar'] : _b, _c = _a.alignActions, alignActions = _c === void 0 ? 'start' : _c, _d = _a.dismissable, dismissable = _d === void 0 ? true : _d, _e = _a.dismissibleIconColor, dismissibleIconColor = _e === void 0 ? 'negative' : _e, _f = _a.dismissibleIconType, dismissibleIconType = _f === void 0 ? 'primary' : _f, _g = _a.dismissibleIconName, dismissibleIconName = _g === void 0 ? 'close-big' : _g, _h = _a.isFluid, isFluid = _h === void 0 ? false : _h, _j = _a.breakpointDelimiter, breakpointDelimiter = _j === void 0 ? 'desktopLarge' : _j, beforeClose = _a.beforeClose, onClose = _a.onClose, onCancel = _a.onCancel, onContentEvent = _a.onContentEvent, content = _a.content;
    var ramdom = useNextCounterId(idSequence$b);
    var _k = React.useState(false), dismiss = _k[0], setDismiss = _k[1];
    var _l = React.useState(), actionSelected = _l[0], setActionSelected = _l[1];
    var _m = React.useState(actions.map(function () { return false; })), actionLoading = _m[0], setActionLoading = _m[1];
    React.useEffect(function () {
        if (dismiss) {
            return onCancel();
        }
        if (actionSelected) {
            return onClose(actionSelected);
        }
    }, [actionSelected, dismiss]);
    var dismissing = React.useCallback(function () { return setDismiss(true); }, [setDismiss]);
    var handleClickAction = React.useCallback(function (actionConfig) {
        var _a;
        var mounted = true;
        var action = typeof actionConfig === 'string' ? actionConfig : actionConfig.action;
        setActionLoading(actions.map(function (actualActionConfig) { return actionConfig === actualActionConfig; }));
        forcePromise((_a = beforeClose === null || beforeClose === void 0 ? void 0 : beforeClose(action)) !== null && _a !== void 0 ? _a : true)
            .then(function (canClose) {
            return mounted && setActionSelected(canClose ? action : undefined);
        })
            .finally(function () { return mounted && setActionLoading(actions.map(function () { return false; })); });
        return function () { return (mounted = false); };
    }, [setActionSelected]);
    return (React.createElement(ModalContainer, { className: "BaSe--modal-container" },
        React.createElement(FocusTrap, { focusTrapOptions: {
                delayInitialFocus: true,
                escapeDeactivates: dismissable,
                clickOutsideDeactivates: dismissable,
                onDeactivate: dismissing,
            } },
            React.createElement(ModalDialog, { className: "BaSe--modal-dialog", role: "dialog", "aria-labelledby": "BaSe--modal-title-".concat(ramdom), "aria-describedby": "BaSe--modal-description-".concat(ramdom), "aria-modal": "true", isFluid: !!isFluid, delimiter: breakpointDelimiter, size: size },
                (title || dismissable) && (React.createElement(ModalHeader, { className: "BaSe--modal-header" },
                    React.createElement("span", { id: "BaSe--modal-title-".concat(ramdom) }, typeof title === 'string' ? (React.createElement(BaSeHeading4, { color: titleColor !== null && titleColor !== void 0 ? titleColor : BaSeTheme.colors.institucionais.cinzaSebrae45, isBold: true }, title)) : (title())),
                    dismissable && (React.createElement(BaSeShapeButton, { buttonType: "button", nameIcon: dismissibleIconName, shape: "circle", size: "small", sizeIcon: "small", type: dismissibleIconType, color: dismissibleIconColor, onClick: function () { return dismissing(); } })))),
                React.createElement(ModalBody, { id: "BaSe--modal-description-".concat(ramdom) },
                    React.createElement(ModalContent, { content: content, onClose: onClose, onContentEvent: onContentEvent })),
                React.createElement(ModalFooter, { className: "BaSe--modal-footer", alignActions: alignActions }, actions === null || actions === void 0 ? void 0 : actions.map(function (action, index) {
                    var _a, _b, _c;
                    return (React.createElement(BaSeButton, { key: typeof action === 'string' ? action : action.action, autoFocus: index === 0, buttonType: "button", size: "medium", onClick: function () { return handleClickAction(action); }, type: typeof action === 'string'
                            ? "".concat(index === 0 ? 'primary' : 'secondary')
                            : (_a = action === null || action === void 0 ? void 0 : action.type) !== null && _a !== void 0 ? _a : "".concat(index === 0 ? 'primary' : 'secondary'), color: typeof action === 'string'
                            ? 'default'
                            : (_b = action === null || action === void 0 ? void 0 : action.color) !== null && _b !== void 0 ? _b : 'default', value: typeof action === 'string' ? action : action.action, loadingText: typeof action !== 'string'
                            ? (_c = action === null || action === void 0 ? void 0 : action.loadingText) !== null && _c !== void 0 ? _c : undefined
                            : undefined, isLoading: actionLoading[index] }));
                }))))));
};
BaSeModal.displayName = 'BaSeModal';

var StyledHeading6 = makeDefaultTypographytStyled('Heading6', 'h6', 1, 1.2);

var BaSeHeading6 = function (props) { return (React.createElement(BaSeTyporaphyWrapper, __assign({ fontSize: 1, lineHeight: 1.2, wrapper: StyledHeading6 }, props), props.children)); };
BaSeHeading6.displayName = 'BaSeHeading6';

var StyledParagraph = makeDefaultTypographytStyled('Paragraph', 'p', 1, 1.46);

var BaSeParagraph = function (props) { return (React.createElement(BaSeTyporaphyWrapper, __assign({ fontSize: 1, lineHeight: 1.46, wrapper: StyledParagraph }, props), props.children)); };
BaSeParagraph.displayName = 'BaSeParagraph';

var show = keyframes(templateObject_1$R || (templateObject_1$R = __makeTemplateObject(["\n  from {\n    transform: translate(-50%, -100%);\n  }\n  to {\n    transform: translate(-50%, 0);\n  }\n"], ["\n  from {\n    transform: translate(-50%, -100%);\n  }\n  to {\n    transform: translate(-50%, 0);\n  }\n"])));
var NotificationDialog = styled.div(templateObject_2$H || (templateObject_2$H = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  align-items: flex-start;\n  padding: 12px;\n  border-radius: 4px;\n  box-shadow: ", ";\n  width: 90%;\n  max-width: 390px;\n  position: fixed;\n  top: 5%;\n  left: 50%;\n  transform: translate(-50%, 0);\n  z-index: ", ";\n  transition: transform ", "\n    ", ";\n  background: ", ";\n  animation: ", " ", "\n    ", " 1;\n\n  &.exiting {\n    transform: translate(-50%, -100%);\n  }\n\n  .message {\n    flex: 1;\n  }\n\n  h6 {\n    color: ", ";\n  }\n\n  p {\n    color: ", ";\n  }\n\n  /*mobileSmall*/\n  ", "\n  /*mobile*/\n  ", "\n  /*mobileLarge*/\n  ", "\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  align-items: flex-start;\n  padding: 12px;\n  border-radius: 4px;\n  box-shadow: ", ";\n  width: 90%;\n  max-width: 390px;\n  position: fixed;\n  top: 5%;\n  left: 50%;\n  transform: translate(-50%, 0);\n  z-index: ", ";\n  transition: transform ", "\n    ", ";\n  background: ", ";\n  animation: ", " ", "\n    ", " 1;\n\n  &.exiting {\n    transform: translate(-50%, -100%);\n  }\n\n  .message {\n    flex: 1;\n  }\n\n  h6 {\n    color: ", ";\n  }\n\n  p {\n    color: ", ";\n  }\n\n  /*mobileSmall*/\n  ", "\n  /*mobile*/\n  ", "\n  /*mobileLarge*/\n  ", "\n"])), BaSeTheme.shadows.profundidade16, zIndexOverlay + 1, BaSeTheme.transitions.durationNormal, BaSeTheme.transitions.elasticTimingFunction, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, show, BaSeTheme.transitions.durationNormal, BaSeTheme.transitions.elasticTimingFunction, function (_a) {
    var color = _a.color;
    return color;
}, BaSeTheme.colors.institucionais.cinzaSebrae30, BaSeTheme.breakpoints.mobileSmall.mediaQueryCss("\n    top: unset;\n    bottom: 5%;\n  "), BaSeTheme.breakpoints.mobile.mediaQueryCss("\n    top: unset;\n    bottom: 5%;\n  "), BaSeTheme.breakpoints.mobileLarge.mediaQueryCss("\n    top: unset;\n    bottom: 5%;\n  "));
var templateObject_1$R, templateObject_2$H;

var mapNotificationValues = function (color) {
    return {
        primary: {
            generalColors: {
                color: ColorMapper[color].hover.defaultDark,
                style: {
                    bgC: ColorMapper[color].hover.defaultLight,
                },
            },
        },
    };
};
var mapCustomColorsNotificationValues = function (customColor) {
    var customColorHsv = Color.generateFromHex(customColor);
    return {
        primary: {
            color: BaSeTheme.colors.defaultColors.white,
            style: {
                bgC: customColor && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
            },
        },
    };
};

var ExitingMode;
(function (ExitingMode) {
    ExitingMode[ExitingMode["forced"] = 0] = "forced";
    ExitingMode[ExitingMode["auto"] = 1] = "auto";
    ExitingMode[ExitingMode["action"] = 2] = "action";
})(ExitingMode || (ExitingMode = {}));
var iconColorMap = {
    attention: 'exclamation-triangle',
    default: 'info-circle',
    destructive: 'exclamation-octagon',
    confirmation: 'check-circle',
};
var idSequence$a = idGenerator();
var BaSeNotification = function (_a) {
    var color = _a.color, icon = _a.icon, message = _a.message, supportMessage = _a.supportMessage, _b = _a.secondsToClose, secondsToClose = _b === void 0 ? 5 : _b, action = _a.action, onClose = _a.onClose, onAction = _a.onAction;
    var counterId = useNextCounterId(idSequence$a);
    var iconName = React.useMemo(function () {
        var iconNameDefault = iconColorMap[color];
        return icon === false ? undefined : icon !== null && icon !== void 0 ? icon : iconNameDefault;
    }, [color, icon]);
    var _c = React.useState(), exiting = _c[0], setExiting = _c[1];
    var _d = React.useState(true), autoClose = _d[0], setAutoClose = _d[1];
    var _e = React.useState(), timeoutToAutoClose = _e[0], setTimeoutToAutoClose = _e[1];
    var forceClose = React.useCallback(function () { return setExiting(ExitingMode.forced); }, []);
    var actionClose = React.useCallback(function () { return setExiting(ExitingMode.action); }, []);
    var pauseAutoClose = React.useCallback(function () {
        setAutoClose(false);
    }, []);
    var resumeAutoClose = React.useCallback(function () {
        setAutoClose(true);
    }, []);
    React.useEffect(function () { return function () { return timeoutToAutoClose && clearTimeout(timeoutToAutoClose); }; }, [timeoutToAutoClose]);
    React.useEffect(function () {
        if (secondsToClose > 0) {
            setTimeoutToAutoClose(autoClose
                ? setTimeout(function () { return setExiting(ExitingMode.auto); }, secondsToClose * 1000)
                : undefined);
        }
    }, [autoClose, secondsToClose]);
    React.useEffect(function () {
        if (exiting === ExitingMode.forced) {
            var timeout_1 = setTimeout(function () { return onClose(true); }, BaSeTheme.transitions.durationFastInMilliseconds);
            return function () { return clearTimeout(timeout_1); };
        }
        if (exiting === ExitingMode.auto) {
            var timeout_2 = setTimeout(function () { return onClose(false); }, BaSeTheme.transitions.durationFastInMilliseconds);
            return function () { return clearTimeout(timeout_2); };
        }
        if (exiting === ExitingMode.action) {
            var timeout_3 = setTimeout(function () { return onAction(); }, BaSeTheme.transitions.durationFastInMilliseconds);
            return function () { return clearTimeout(timeout_3); };
        }
        return;
    }, [exiting]);
    React.useEffect(function () {
        var shownTimeout = setTimeout(function () { var _a; return (_a = navigator === null || navigator === void 0 ? void 0 : navigator.vibrate) === null || _a === void 0 ? void 0 : _a.call(navigator, BaSeTheme.transitions.durationFastInMilliseconds); }, 0);
        return function () { return clearTimeout(shownTimeout); };
    }, []);
    var colorIsMapped = color === BaSeTheme.components.button.colors.default ||
        color === BaSeTheme.components.button.colors.destructive ||
        color === BaSeTheme.components.button.colors.confirmation ||
        color === BaSeTheme.components.button.colors.attention;
    var getColorsAtributes = function () {
        var _a;
        if (color) {
            if (!colorIsMapped) {
                return mapCustomColorsNotificationValues(color).primary;
            }
            else {
                return (_a = mapNotificationValues(color).primary) === null || _a === void 0 ? void 0 : _a.generalColors;
            }
        }
        else {
            return mapNotificationValues('default').primary.generalColors;
        }
    };
    var colorValues = getColorsAtributes();
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(NotificationDialog, { className: "BaSe--notification-dialog ".concat(exiting !== undefined ? 'exiting' : ''), color: colorValues.color, backgroundColor: colorValues.style.bgC, role: "dialog", "aria-modal": "false", "aria-labelledby": "BaSe--notification-title-".concat(counterId), "aria-describedby": "BaSe--notification-description-".concat(counterId), onFocusCapture: function () { return pauseAutoClose(); }, onBlurCapture: function () { return resumeAutoClose(); }, onMouseEnter: function () { return pauseAutoClose(); }, onMouseLeave: function () { return resumeAutoClose(); } },
        iconName && (React.createElement("span", { className: "icon-wrapper" },
            React.createElement(BaSeIcon, { color: colorValues.color, name: iconName, size: 26, description: getMessage('notification.iconDescription') }))),
        React.createElement("div", { className: "message" },
            React.createElement("span", { id: "BaSe--notification-title-".concat(counterId) },
                React.createElement(BaSeHeading6, { isBold: true }, message)),
            supportMessage && (React.createElement("span", { id: "BaSe--notification-description-".concat(counterId) },
                React.createElement(BaSeParagraph, null, supportMessage)))),
        action && (React.createElement(BaSeButton, { buttonType: "button", size: "small", type: "tertiary", color: colorValues.color, value: action, onClick: function () { return actionClose(); } })),
        React.createElement(BaSeShapeButton, { buttonType: "button", nameIcon: "close", shape: "circle", size: "small", sizeIcon: "small", type: "tertiary", color: colorValues.color, onClick: function () { return forceClose(); } })));
};
BaSeNotification.displayName = 'BaSeNotification';

var idSequence$9 = idGenerator();
function addInPool(setPoolState, item) {
    setPoolState(function (pool) { return __spreadArray(__spreadArray([], pool, true), [item], false); });
}
function removeFromPool(setPoolState, itemToRemove) {
    setPoolState(function (pool) { return pool.filter(function (item) { return item.id !== itemToRemove.id; }); });
}
var BaSeDialogContext = React.createContext({
    showModal: function () { },
    showNotification: function () { },
});
var BaSeDialogProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState([]), modalPool = _b[0], setModalPool = _b[1];
    var _c = React.useState([]), notificationPool = _c[0], setNotificationPool = _c[1];
    var showModal = React.useCallback(function (config) {
        var _a;
        var size = config.size, title = config.title, titleColor = config.titleColor, actions = config.actions, alignActions = config.alignActions, dismissable = config.dismissable, dismissibleIconColor = config.dismissibleIconColor, dismissibleIconType = config.dismissibleIconType, dismissibleIconName = config.dismissibleIconName, isFluid = config.isFluid, breakpointDelimiter = config.breakpointDelimiter, content = config.content, onContentEvent = config.onContentEvent, beforeClose = config.beforeClose;
        var id = getNextCounter(idSequence$9);
        var modal = {
            id: id,
            size: size,
            title: title,
            titleColor: titleColor,
            actions: actions,
            alignActions: alignActions,
            dismissable: dismissable,
            dismissibleIconColor: dismissibleIconColor,
            dismissibleIconType: dismissibleIconType,
            dismissibleIconName: dismissibleIconName,
            isFluid: isFluid,
            breakpointDelimiter: breakpointDelimiter,
            content: content,
            onContentEvent: onContentEvent,
            beforeClose: beforeClose,
            onCancel: function () {
                var _a, _b;
                (_a = config === null || config === void 0 ? void 0 : config.onDismiss) === null || _a === void 0 ? void 0 : _a.call(config);
                removeFromPool(setModalPool, modal);
                (_b = config === null || config === void 0 ? void 0 : config.afterClose) === null || _b === void 0 ? void 0 : _b.call(config);
            },
            onClose: function (action) {
                var _a, _b;
                (_a = config === null || config === void 0 ? void 0 : config.onChooseAction) === null || _a === void 0 ? void 0 : _a.call(config, action);
                removeFromPool(setModalPool, modal);
                (_b = config === null || config === void 0 ? void 0 : config.afterClose) === null || _b === void 0 ? void 0 : _b.call(config);
            },
        };
        (_a = config === null || config === void 0 ? void 0 : config.onOpen) === null || _a === void 0 ? void 0 : _a.call(config);
        addInPool(setModalPool, modal);
    }, []);
    var showNotification = React.useCallback(function (config) {
        var _a;
        var color = config.color, message = config.message, supportMessage = config.supportMessage, secondsToClose = config.secondsToClose, action = config.action, icon = config.icon;
        var id = getNextCounter(idSequence$9);
        var notification = {
            id: id,
            icon: icon,
            color: color,
            message: message,
            supportMessage: supportMessage,
            secondsToClose: secondsToClose,
            action: action,
            onClose: function (forced) {
                var _a, _b, _c;
                if (forced) {
                    (_a = config === null || config === void 0 ? void 0 : config.onForceClose) === null || _a === void 0 ? void 0 : _a.call(config);
                }
                else {
                    (_b = config === null || config === void 0 ? void 0 : config.onAutoClose) === null || _b === void 0 ? void 0 : _b.call(config);
                }
                removeFromPool(setNotificationPool, notification);
                (_c = config === null || config === void 0 ? void 0 : config.afterClose) === null || _c === void 0 ? void 0 : _c.call(config);
            },
            onAction: function () {
                var _a, _b;
                (_a = config === null || config === void 0 ? void 0 : config.onActionClose) === null || _a === void 0 ? void 0 : _a.call(config);
                removeFromPool(setNotificationPool, notification);
                (_b = config === null || config === void 0 ? void 0 : config.afterClose) === null || _b === void 0 ? void 0 : _b.call(config);
            },
        };
        (_a = config === null || config === void 0 ? void 0 : config.onOpen) === null || _a === void 0 ? void 0 : _a.call(config);
        addInPool(setNotificationPool, notification);
    }, []);
    var providedValue = {
        showModal: showModal,
        showNotification: showNotification,
    };
    return (React.createElement(BaSeDialogContext.Provider, { value: providedValue },
        children,
        modalPool.map(function (_a) {
            var id = _a.id, rest = __rest(_a, ["id"]);
            return (React.createElement(BaSeModal, __assign({ key: id }, rest)));
        }),
        notificationPool.map(function (_a) {
            var id = _a.id, rest = __rest(_a, ["id"]);
            return (React.createElement(BaSeNotification, __assign({ key: id }, rest)));
        })));
};
var BaSeDialogConsumer = BaSeDialogContext.Consumer;

var BaSeRoot = function (_a) {
    var _b = _a.locale, locale = _b === void 0 ? 'pt-BR' : _b, children = _a.children;
    return (React.createElement(BaSeI18nProvider, { locale: locale },
        React.createElement(BaSeBreakpointProvider, null,
            React.createElement(BaSeDialogProvider, null, children))));
};

var StyledHeading1 = makeDefaultTypographytStyled('Heading1', 'h1', 2.48, 1.2);

var BaSeHeading1 = function (props) { return (React.createElement(BaSeTyporaphyWrapper, __assign({ fontSize: 2.48, lineHeight: 1.2, wrapper: StyledHeading1 }, props), props.children)); };
BaSeHeading1.displayName = 'BaSeHeading1';

var StyledHeading2 = makeDefaultTypographytStyled('Heading2', 'h2', 2.07, 1.2);

var BaSeHeading2 = function (props) { return (React.createElement(BaSeTyporaphyWrapper, __assign({ fontSize: 2.07, lineHeight: 1.2, wrapper: StyledHeading2 }, props), props.children)); };
BaSeHeading2.displayName = 'BaSeHeading2';

var StyledHeading3 = makeDefaultTypographytStyled('Heading3', 'h3', 1.72, 1.2);

var BaSeHeading3 = function (props) { return (React.createElement(BaSeTyporaphyWrapper, __assign({ fontSize: 1.72, lineHeight: 1.2, wrapper: StyledHeading3 }, props), props.children)); };
BaSeHeading3.displayName = 'BaSeHeading3';

var StyledHeading5 = makeDefaultTypographytStyled('Heading5', 'h5', 1.2, 1.2);

var BaSeHeading5 = function (props) { return (React.createElement(BaSeTyporaphyWrapper, __assign({ fontSize: 1.2, lineHeight: 1.2, wrapper: StyledHeading5 }, props), props.children)); };
BaSeHeading5.displayName = 'BaSeHeading5';

function useMenuItemsShrink(setMenuItemsShrink, collapsedBreakpoint) {
    var queryContext = React.useContext(BaSeBreakpointContext);
    var handleMenuItemsShrink = React.useCallback(function () {
        if (!collapsedBreakpoint ||
            !(collapsedBreakpoint in queryContext)) {
            setMenuItemsShrink(true);
        }
        else {
            var queryMarked = false;
            // tslint:disable-next-line: forin
            for (var query in queryContext) {
                queryMarked += queryContext[query];
                if (query === collapsedBreakpoint) {
                    break;
                }
            }
            setMenuItemsShrink(!!queryMarked);
        }
    }, [queryContext]);
    React.useEffect(function () {
        handleMenuItemsShrink();
    }, [handleMenuItemsShrink]);
}

function useOutsideEvent(ref, calbackWhenAreOutside) {
    React.useEffect(function () {
        var handleClickOutside = function (event) {
            var _a, _b;
            return !((_b = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.contains) === null || _b === void 0 ? void 0 : _b.call(_a, event === null || event === void 0 ? void 0 : event.target)) && (calbackWhenAreOutside === null || calbackWhenAreOutside === void 0 ? void 0 : calbackWhenAreOutside(false));
        };
        var handleKeyEscPressed = function (event) {
            return event.key === 'Escape' && (calbackWhenAreOutside === null || calbackWhenAreOutside === void 0 ? void 0 : calbackWhenAreOutside(false));
        };
        var parent = document;
        parent.addEventListener('mousedown', handleClickOutside);
        parent.addEventListener('keyup', handleKeyEscPressed);
        return function () {
            parent.removeEventListener('mousedown', handleClickOutside);
            parent.removeEventListener('keyup', handleKeyEscPressed);
        };
    }, [ref, calbackWhenAreOutside]);
}

var StyledText = makeDefaultTypographytStyled('Text', 'span', 1, 1.46);

var BaSeText = function (props) { return (React.createElement(BaSeTyporaphyWrapper, __assign({ fontSize: 1, lineHeight: 1.46, wrapper: StyledText }, props), props.children)); };
BaSeText.displayName = 'BaSeText';

var AvatarOrIconAndNameAndEmail = React.memo(function (props) {
    var _a = React.useState(true), hasAvatar = _a[0], setHasAvatar = _a[1];
    return (React.createElement(React.Fragment, null,
        hasAvatar ? (React.createElement(BaSeI18nConsumer, null, function (_a) {
            var getMessage = _a.getMessage;
            return (React.createElement("img", { loading: "lazy", className: "BaSe--account-profile-avatar", src: props.avatar, alt: getMessage('avatarImage.description'), onError: function () { return setHasAvatar(false); } }));
        })) : (React.createElement("span", { className: "BaSe--account-profile-name-abbr-icon", "aria-hidden": "true" }, props.icon)),
        props.email ? (React.createElement("span", { className: "BaSe--account-profile-name-with-close" },
            React.createElement("span", { className: "BaSe--account-profile-name" },
                React.createElement("span", null, props.name),
                React.createElement("div", { className: "BaSe--account-profile-close-button" },
                    React.createElement(BaSeShapeButton, { buttonType: "button", nameIcon: "close", shape: "circle", size: "small", sizeIcon: "small", type: "tertiary", color: BaSeTheme.colors.institucionais.cinzaSebrae75, onClick: function () { var _a; return (_a = props === null || props === void 0 ? void 0 : props.onClose) === null || _a === void 0 ? void 0 : _a.call(props); } }))),
            React.createElement("br", null),
            React.createElement("small", { className: "BaSe--account-profile-email" }, props.email))) : (React.createElement("span", null,
            React.createElement("span", { className: "BaSe--account-profile-name" }, props.name)))));
});

var TRANSITION = BaSeTheme.transitions.allPropertiesContinuousNormal;
var BUTTON_FOCUS_BOX_SHADOW_COLOR = BaSeTheme.colors.institucionais.azulSebrae75;
var BUTTON_HOVER_BACKGROUND_COLOR = BaSeTheme.colors.institucionais.azulSebrae30;
var BUTTON_BACKGROUND_COLOR = BaSeTheme.colors.defaultColors.transparent;
var BUTTON_HEIGHT = 32;
var BUTTON_ICON_COLOR = BaSeTheme.colors.institucionais.azulSebrae;
var BUTTON_ICON_SIZE = 32;
var BUTTON_TEXT_COLOR = BaSeTheme.colors.defaultColors.white;
var MENU_BACKGROUND_COLOR = BaSeTheme.colors.defaultColors.white;
var MENU_BORDER_COLOR = BaSeTheme.colors.institucionais.azulSebrae90;
var MENU_COLOR = BaSeTheme.colors.institucionais.azulSebrae;
var MENU_EMAIL_COLOR = BaSeTheme.colors.institucionais.cinzaSebrae60;
var MENU_ICON_SHADOW = BaSeTheme.shadows.profundidade2;
var MENU_ICON_SIZE = 38;
var MENU_LINK_COLOR = BaSeTheme.colors.institucionais.azulSebrae;
var MENU_NAME_COLOR = BaSeTheme.colors.institucionais.cinzaSebrae30;
var MENU_SEPARATOR_COLOR = BaSeTheme.colors.institucionais.cinzaSebrae90;
var MENU_SHADOW = BaSeTheme.shadows.profundidade8;

var ContainerButtonStyled = styled.button(templateObject_2$G || (templateObject_2$G = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var iconSize = _a.iconSize, backgroundColor = _a.backgroundColor, textColor = _a.textColor, transition = _a.transition, focusBoxShadowColor = _a.focusBoxShadowColor, hoverBackgroundColor = _a.hoverBackgroundColor, iconColor = _a.iconColor;
    return css(templateObject_1$Q || (templateObject_1$Q = __makeTemplateObject(["\n\n  font-size: ", ";\n  display: grid;\n  gap: 6px;\n  grid-template-columns: ", "px 1fr;\n  place-items: center;\n  background: ", ";\n  border-radius: 4px;\n  border: none;\n  outline: none;\n  color: ", ";\n  overflow: hidden;\n  transition: ", ";\n  padding: 4px 6px;\n  margin: 0;\n\n  &,\n  * {\n    font-family: ", ";\n  }\n\n  &:focus,\n  &:focus-within,\n  &:hover,\n  &:active {\n    cursor: pointer;\n    outline: none;\n  }\n\n  &:focus,\n  &:focus-within {\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n\n  &:hover,\n  &:active {\n    background-color: ", ";\n  }\n\n  .BaSe--account-profile-avatar,\n  .BaSe--account-profile-name-abbr-icon {\n    background: ", ";\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n    overflow: hidden;\n  }\n\n  .BaSe--account-profile-avatar {\n    object-fit: contain;\n  }\n\n  .BaSe--account-profile-name-abbr-icon {\n    display: grid;\n    place-items: center;\n    color: ", ";\n    line-height: ", "px;\n    font-size: 13px;\n  }\n\n  .BaSe--account-profile-name {\n    display: inline;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    max-width: 100px;\n  }\n  "], ["\n\n  font-size: ", ";\n  display: grid;\n  gap: 6px;\n  grid-template-columns: ", "px 1fr;\n  place-items: center;\n  background: ", ";\n  border-radius: 4px;\n  border: none;\n  outline: none;\n  color: ", ";\n  overflow: hidden;\n  transition: ", ";\n  padding: 4px 6px;\n  margin: 0;\n\n  &,\n  * {\n    font-family: ", ";\n  }\n\n  &:focus,\n  &:focus-within,\n  &:hover,\n  &:active {\n    cursor: pointer;\n    outline: none;\n  }\n\n  &:focus,\n  &:focus-within {\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n\n  &:hover,\n  &:active {\n    background-color: ", ";\n  }\n\n  .BaSe--account-profile-avatar,\n  .BaSe--account-profile-name-abbr-icon {\n    background: ", ";\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n    overflow: hidden;\n  }\n\n  .BaSe--account-profile-avatar {\n    object-fit: contain;\n  }\n\n  .BaSe--account-profile-name-abbr-icon {\n    display: grid;\n    place-items: center;\n    color: ", ";\n    line-height: ", "px;\n    font-size: 13px;\n  }\n\n  .BaSe--account-profile-name {\n    display: inline;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    max-width: 100px;\n  }\n  "])), BaSeTheme.typography.fontSizeBase, iconSize, backgroundColor, textColor, transition, BaSeTheme.typography.fontFamily, focusBoxShadowColor, hoverBackgroundColor, textColor, iconSize, iconSize, iconSize / 2, iconColor, iconSize);
});
var templateObject_1$Q, templateObject_2$G;

var ContainerMenuStyled = styled.div(templateObject_1$P || (templateObject_1$P = __makeTemplateObject(["\n  font-size: ", ";\n  z-index: ", ";\n  height: 350px;\n  min-width: 300px;\n  background: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  top: ", "px;\n  right: 0;\n  transition: ", ";\n  box-shadow: ", ";\n\n  &,\n  * {\n    font-family: ", ";\n  }\n\n  &,\n  &::before {\n    position: absolute;\n    opacity: 1;\n    transition-delay: 0;\n  }\n\n  &::before {\n    content: '';\n    display: block;\n    transform: rotate(45deg) scale(1) translateY(0);\n    top: -8px;\n    right: 11px;\n    height: 14px;\n    width: 14px;\n    background: ", ";\n    border: 1px solid transparent;\n    border-color: ", " transparent transparent\n      ", ";\n    pointer-events: none;\n  }\n\n  .BaSe--account-profile-menu-wrapper {\n    position: relative;\n    overflow: hidden;\n    height: 100%;\n    width: 100%;\n    display: grid;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n\n    .BaSe--account-profile-separator,\n    .BaSe--account-profile-context-link,\n    .BaSe--account-profile-auth-link {\n      margin: 0 32px 0 70px;\n    }\n\n    .BaSe--account-profile-avatar-and-name-email {\n      padding: 0;\n      display: grid;\n      grid-template-columns: 70px 1fr;\n      place-items: center;\n\n      & > span:not(.BaSe--account-profile-name-abbr-icon) {\n        justify-self: start;\n      }\n\n      .BaSe--account-profile-name-abbr-icon,\n      .BaSe--account-profile-avatar {\n        object-fit: contain;\n        width: ", "px;\n        height: ", "px;\n        border-radius: ", "px;\n        display: grid;\n        place-items: center;\n      }\n\n      .BaSe--account-profile-name-abbr-icon {\n        box-shadow: ", ";\n      }\n\n      .BaSe--account-profile-name-with-close {\n        width: calc(100% - 16px);\n        text-overflow: ellipsis;\n        overflow: hidden;\n      }\n\n      .BaSe--account-profile-name {\n        color: ", ";\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n      }\n\n      .BaSe--account-profile-email {\n        color: ", ";\n      }\n    }\n\n    .BaSe--account-profile-separator {\n      border-bottom: 1px solid ", ";\n      height: 1px;\n    }\n\n    .BaSe--account-profile-context-link,\n    .BaSe--account-profile-auth-link {\n      text-overflow: ellipsis;\n      display: inline;\n      overflow: hidden;\n      white-space: nowrap;\n    }\n\n    .BaSe--account-profile-close-button {\n      position: absolute;\n      right: 16px;\n    }\n  }\n\n  &.BaSe--account-profile-hidden {\n    pointer-events: none;\n\n    &,\n    &::before {\n      border: none;\n    }\n    &::before {\n      transform: rotate(0) scale(0) translateY(100%);\n    }\n\n    &,\n    .BaSe--account-profile-menu-wrapper {\n      height: 0;\n    }\n  }\n"], ["\n  font-size: ", ";\n  z-index: ", ";\n  height: 350px;\n  min-width: 300px;\n  background: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  top: ", "px;\n  right: 0;\n  transition: ", ";\n  box-shadow: ", ";\n\n  &,\n  * {\n    font-family: ", ";\n  }\n\n  &,\n  &::before {\n    position: absolute;\n    opacity: 1;\n    transition-delay: 0;\n  }\n\n  &::before {\n    content: '';\n    display: block;\n    transform: rotate(45deg) scale(1) translateY(0);\n    top: -8px;\n    right: 11px;\n    height: 14px;\n    width: 14px;\n    background: ", ";\n    border: 1px solid transparent;\n    border-color: ", " transparent transparent\n      ", ";\n    pointer-events: none;\n  }\n\n  .BaSe--account-profile-menu-wrapper {\n    position: relative;\n    overflow: hidden;\n    height: 100%;\n    width: 100%;\n    display: grid;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n\n    .BaSe--account-profile-separator,\n    .BaSe--account-profile-context-link,\n    .BaSe--account-profile-auth-link {\n      margin: 0 32px 0 70px;\n    }\n\n    .BaSe--account-profile-avatar-and-name-email {\n      padding: 0;\n      display: grid;\n      grid-template-columns: 70px 1fr;\n      place-items: center;\n\n      & > span:not(.BaSe--account-profile-name-abbr-icon) {\n        justify-self: start;\n      }\n\n      .BaSe--account-profile-name-abbr-icon,\n      .BaSe--account-profile-avatar {\n        object-fit: contain;\n        width: ", "px;\n        height: ", "px;\n        border-radius: ", "px;\n        display: grid;\n        place-items: center;\n      }\n\n      .BaSe--account-profile-name-abbr-icon {\n        box-shadow: ", ";\n      }\n\n      .BaSe--account-profile-name-with-close {\n        width: calc(100% - 16px);\n        text-overflow: ellipsis;\n        overflow: hidden;\n      }\n\n      .BaSe--account-profile-name {\n        color: ", ";\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n      }\n\n      .BaSe--account-profile-email {\n        color: ", ";\n      }\n    }\n\n    .BaSe--account-profile-separator {\n      border-bottom: 1px solid ", ";\n      height: 1px;\n    }\n\n    .BaSe--account-profile-context-link,\n    .BaSe--account-profile-auth-link {\n      text-overflow: ellipsis;\n      display: inline;\n      overflow: hidden;\n      white-space: nowrap;\n    }\n\n    .BaSe--account-profile-close-button {\n      position: absolute;\n      right: 16px;\n    }\n  }\n\n  &.BaSe--account-profile-hidden {\n    pointer-events: none;\n\n    &,\n    &::before {\n      border: none;\n    }\n    &::before {\n      transform: rotate(0) scale(0) translateY(100%);\n    }\n\n    &,\n    .BaSe--account-profile-menu-wrapper {\n      height: 0;\n    }\n  }\n"])), BaSeTheme.typography.fontSizeBase, BaSeTheme.stackOrder.overlay, function (props) { return props.backgroundColor; }, function (props) { return props.textColor; }, function (props) { return props.borderColor; }, function (props) { return props.wrapperHeight * 1.25; }, function (props) { return props.transition; }, function (props) { return props.menuShadow; }, BaSeTheme.typography.fontFamily, function (props) { return props.backgroundColor; }, function (props) { return props.borderColor; }, function (props) { return props.borderColor; }, function (props) { return props.iconSize; }, function (props) { return props.iconSize; }, function (props) { return props.iconSize / 2; }, function (props) { return props.iconShadow; }, function (props) { return props.textNameColor; }, function (props) { return props.textEmailColor; }, function (props) { return props.separatorColor; });
var templateObject_1$P;

var LinkStyled = styled.a(templateObject_1$O || (templateObject_1$O = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: ", ";\n  background: transparent;\n  border: 1px solid transparent;\n  text-decoration: none;\n  font-weight: normal;\n  line-height: 1.2em;\n  padding: 0;\n  color: ", ";\n\n  &:hover,\n  &:focus {\n    cursor: pointer;\n    outline: none;\n    text-decoration: underline;\n  }\n  &:active {\n    border-color: ", ";\n    text-decoration: none;\n  }\n"], ["\n  font-family: ", ";\n  font-size: ", ";\n  background: transparent;\n  border: 1px solid transparent;\n  text-decoration: none;\n  font-weight: normal;\n  line-height: 1.2em;\n  padding: 0;\n  color: ", ";\n\n  &:hover,\n  &:focus {\n    cursor: pointer;\n    outline: none;\n    text-decoration: underline;\n  }\n  &:active {\n    border-color: ", ";\n    text-decoration: none;\n  }\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, function (props) { return props.textColor; }, function (props) { return props.textColor; });
var templateObject_1$O;

var WrapperStyled = styled.div.attrs({
    className: 'BaSe--account-profile',
})(templateObject_1$N || (templateObject_1$N = __makeTemplateObject(["\n  font-family: ", ";\n  font-size: ", ";\n  position: relative;\n  overflow: visible;\n  height: ", ";\n  padding: 0;\n"], ["\n  font-family: ", ";\n  font-size: ", ";\n  position: relative;\n  overflow: visible;\n  height: ", ";\n  padding: 0;\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase, function (props) { return props.wrapperHeight; });
var templateObject_1$N;

var focusHoverConfig = {
    opacity: 0.2,
    l: 0.7,
};
function makeAuthUrl(authServerUrl, realm) {
    return urlSanitizer("".concat(authServerUrl, "/realms/").concat(realm));
}
var BaSeAccountProfile = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var clientName = _a.clientName, clientUri = _a.clientUri, clientId = _a.clientId, avatarUrl = _a.avatarUrl, cpeUrl = _a.cpeUrl, authServerUrl = _a.authServerUrl, authRealm = _a.authRealm, _k = _a.authenticated, authenticated = _k === void 0 ? false : _k, _l = _a.keycloak, keycloak = _l === void 0 ? null : _l, _m = _a.userName, userName = _m === void 0 ? '' : _m, _o = _a.userEmail, userEmail = _o === void 0 ? '' : _o, _p = _a.userId, userId = _p === void 0 ? '' : _p, _q = _a.contextLinks, contextLinks = _q === void 0 ? [] : _q, _r = _a.buttonCollapsed, buttonCollapsed = _r === void 0 ? false : _r, _s = _a.foregroundColor, foregroundColor = _s === void 0 ? BaSeTheme.colors.defaultColors.white : _s, _t = _a.backgroundColor, iconBackColor = _t === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _t;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    if (!Array.isArray(contextLinks)) {
        contextLinks = [];
    }
    authServerUrl = urlSanitizer(authServerUrl);
    avatarUrl = avatarUrl
        ? urlSanitizer(avatarUrl)
        : (_c = (_b = BaSeConfig.ameiConfig) === null || _b === void 0 ? void 0 : _b[authServerUrl]) === null || _c === void 0 ? void 0 : _c.avatarUrl;
    cpeUrl = cpeUrl
        ? urlSanitizer(cpeUrl)
        : (_e = (_d = BaSeConfig.ameiConfig) === null || _d === void 0 ? void 0 : _d[authServerUrl]) === null || _e === void 0 ? void 0 : _e.cpeUrl;
    function keycloakCopyPaste(kc) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (kc) {
            authenticated = (_a = kc.authenticated) !== null && _a !== void 0 ? _a : false;
            authServerUrl = urlSanitizer(kc.authServerUrl);
            authRealm = kc.realm;
            clientId = kc.clientId;
            userName = (_b = kc.tokenParsed) === null || _b === void 0 ? void 0 : _b['name'];
            userEmail = (_c = kc.tokenParsed) === null || _c === void 0 ? void 0 : _c['email'];
            avatarUrl = (_e = (_d = BaSeConfig.ameiConfig) === null || _d === void 0 ? void 0 : _d[authServerUrl]) === null || _e === void 0 ? void 0 : _e.avatarUrl;
            cpeUrl = (_g = (_f = BaSeConfig.ameiConfig) === null || _f === void 0 ? void 0 : _f[authServerUrl]) === null || _g === void 0 ? void 0 : _g.cpeUrl;
        }
    }
    keycloakCopyPaste(keycloak);
    clientUri = clientUri
        ? urlSanitizer(clientUri)
        : window.location.href;
    var authLinks = __spreadArray(__spreadArray(__spreadArray([
        {
            label: getMessage('myProfile.label'),
            url: "".concat(makeAuthUrl(authServerUrl, authRealm), "/account/") +
                "?referrer=".concat(encodeURIComponent(clientId)) +
                "&referrer_uri=".concat(encodeURIComponent(clientUri)) +
                (!!clientName
                    ? "&referrer_name=".concat(encodeURIComponent(clientName))
                    : ''),
        }
    ], (!cpeUrl
        ? []
        : [
            {
                label: getMessage('myBusiness.label'),
                url: cpeUrl +
                    "?voltar=".concat(encodeURIComponent(clientUri)) +
                    (!!clientName
                        ? "&sistema=".concat(encodeURIComponent(clientName))
                        : ''),
            },
        ]), true), (authRealm === 'interno'
        ? []
        : [
            {
                label: getMessage('changePassword.label'),
                onClick: function () {
                    if (typeof (keycloak === null || keycloak === void 0 ? void 0 : keycloak.login) === 'function') {
                        keycloak.login({ action: 'UPDATE_PASSWORD' });
                        return;
                    }
                    window.location.href =
                        "".concat(makeAuthUrl(authServerUrl, authRealm), "/account/password") +
                            "?referrer=".concat(encodeURIComponent(clientId)) +
                            "&referrer_uri=".concat(encodeURIComponent(clientUri)) +
                            (!!clientName
                                ? "&referrer_name=".concat(encodeURIComponent(clientName))
                                : '');
                },
            },
        ]), true), [
        {
            label: getMessage('socialAccounts.label'),
            url: "".concat(makeAuthUrl(authServerUrl, authRealm), "/account/identity") +
                "?referrer=".concat(encodeURIComponent(clientId)) +
                "&referrer_uri=".concat(encodeURIComponent(clientUri)) +
                (!!clientName
                    ? "&referrer_name=".concat(encodeURIComponent(clientName))
                    : ''),
        },
    ], false);
    var _u = React.useState(false), menuOpened = _u[0], setMenuOpened = _u[1];
    var wrapperRef = React.useRef(null);
    useOutsideEvent(wrapperRef, setMenuOpened);
    React.useEffect(function () { return keycloakCopyPaste(keycloak); }, [keycloak]);
    function isAuthenticated() {
        var _a;
        return (_a = keycloak === null || keycloak === void 0 ? void 0 : keycloak.authenticated) !== null && _a !== void 0 ? _a : authenticated;
    }
    function getLoggedFullName() {
        var _a, _b, _c, _d, _e, _f, _g;
        return ((_g = (_f = (_d = (_b = (_a = keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed) === null || _a === void 0 ? void 0 : _a['name']) !== null && _b !== void 0 ? _b : (_c = keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed) === null || _c === void 0 ? void 0 : _c['given_name']) !== null && _d !== void 0 ? _d : (_e = keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed) === null || _e === void 0 ? void 0 : _e['preferred_username']) !== null && _f !== void 0 ? _f : userName) !== null && _g !== void 0 ? _g : getMessage('myAccount.label'));
    }
    function getLoggedName() {
        var _a, _b, _c;
        return (_c = (_b = (_a = getLoggedFullName()) === null || _a === void 0 ? void 0 : _a.split(' ')) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : '';
    }
    function getLoggedEmail() {
        var _a, _b;
        return (_b = (keycloak ? (_a = keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed) === null || _a === void 0 ? void 0 : _a['email'] : userEmail)) !== null && _b !== void 0 ? _b : '';
    }
    function getAvatar() {
        var _a, _b;
        return "".concat(avatarUrl, "/").concat((_b = (keycloak ? (_a = keycloak === null || keycloak === void 0 ? void 0 : keycloak.tokenParsed) === null || _a === void 0 ? void 0 : _a.sub : userId)) !== null && _b !== void 0 ? _b : 'O.o');
    }
    function authLogin() {
        if (typeof (keycloak === null || keycloak === void 0 ? void 0 : keycloak.login) === 'function') {
            if (clientUri) {
                keycloak.login({ redirectUri: clientUri });
                return;
            }
            keycloak.login();
            return;
        }
        window.location.href =
            "".concat(makeAuthUrl(authServerUrl, authRealm), "/protocol/openid-connect/auth") +
                "?client_id=".concat(encodeURIComponent(clientId), "&response_type=code") +
                "&redirect_uri=".concat(encodeURIComponent(clientUri));
        // `${authUrl}/protocol/openid-connect/login?redirect_uri=${encodeURIComponent(clientUri as string)}`;
    }
    function authLogout() {
        if (typeof (keycloak === null || keycloak === void 0 ? void 0 : keycloak.logout) === 'function') {
            if (clientUri) {
                keycloak.logout({ redirectUri: clientUri });
                return;
            }
            keycloak.logout();
            return;
        }
        window.location.href =
            "".concat(makeAuthUrl(authServerUrl, authRealm), "/protocol/openid-connect/logout?") +
                "redirect_uri=".concat(encodeURIComponent(clientUri));
    }
    if (isAuthenticated()) {
        return (React.createElement(WrapperStyled, { ref: wrapperRef, wrapperHeight: BUTTON_HEIGHT },
            React.createElement(ContainerButtonStyled, { type: "button", onClick: function () { return setMenuOpened(function (opened) { return !opened; }); }, hoverBackgroundColor: (_f = createColor(foregroundColor, focusHoverConfig)) !== null && _f !== void 0 ? _f : BUTTON_HOVER_BACKGROUND_COLOR, focusBoxShadowColor: (_g = createButtonFocusColor(foregroundColor)) !== null && _g !== void 0 ? _g : BUTTON_FOCUS_BOX_SHADOW_COLOR, backgroundColor: BUTTON_BACKGROUND_COLOR, iconSize: BUTTON_ICON_SIZE, textColor: foregroundColor, iconColor: iconBackColor, transition: TRANSITION },
                React.createElement(AvatarOrIconAndNameAndEmail, { avatar: getAvatar(), icon: nameAbbreviation(getLoggedFullName()), name: buttonCollapsed ? '' : getLoggedName() })),
            React.createElement(ContainerMenuStyled, { className: menuOpened ? '' : 'BaSe--account-profile-hidden', role: "menu", "aria-label": getMessage('menuAccountProfile.ariaLabel'), wrapperHeight: BUTTON_HEIGHT, backgroundColor: MENU_BACKGROUND_COLOR, borderColor: MENU_BORDER_COLOR, textColor: MENU_COLOR, textEmailColor: MENU_EMAIL_COLOR, iconShadow: MENU_ICON_SHADOW, iconSize: MENU_ICON_SIZE, textNameColor: MENU_NAME_COLOR, separatorColor: MENU_SEPARATOR_COLOR, menuShadow: MENU_SHADOW, transition: TRANSITION },
                React.createElement("ul", { className: "BaSe--account-profile-menu-wrapper" },
                    React.createElement("li", { role: "menuitem", className: "BaSe--account-profile-avatar-and-name-email" },
                        React.createElement(AvatarOrIconAndNameAndEmail, { avatar: getAvatar(), icon: nameAbbreviation(getLoggedFullName()), name: getLoggedFullName(), email: getLoggedEmail(), onClose: function () { return setMenuOpened(false); } })), contextLinks === null || contextLinks === void 0 ? void 0 :
                    contextLinks.map(function (link) { return (React.createElement("li", { role: "menuitem", className: "BaSe--account-profile-context-link", key: link.label },
                        React.createElement(LinkStyled, { textColor: MENU_LINK_COLOR, as: "a", title: link.label, href: link.url }, link.label))); }),
                    React.createElement("li", { className: "BaSe--account-profile-separator", "aria-hidden": "true" }),
                    authLinks.map(function (link) { return (React.createElement("li", { role: "menuitem", className: "BaSe--account-profile-auth-link", key: link.label },
                        React.createElement(LinkStyled, { textColor: MENU_LINK_COLOR, as: link.onClick ? 'button' : 'a', title: link.label, href: link.url, type: link.onClick ? 'button' : undefined, onClick: link.onClick }, link.label))); }),
                    React.createElement("li", { role: "menuitem", className: "BaSe--account-profile-auth-link" },
                        React.createElement(LinkStyled, { textColor: MENU_LINK_COLOR, as: "button", title: getMessage('logout.label'), type: "button", onClick: authLogout }, getMessage('logout.label')))))));
    }
    return (React.createElement(ContainerButtonStyled, { type: "button", onClick: authLogin, hoverBackgroundColor: (_h = createColor(foregroundColor, focusHoverConfig)) !== null && _h !== void 0 ? _h : BUTTON_HOVER_BACKGROUND_COLOR, focusBoxShadowColor: (_j = createButtonFocusColor(foregroundColor)) !== null && _j !== void 0 ? _j : BUTTON_FOCUS_BOX_SHADOW_COLOR, backgroundColor: BUTTON_BACKGROUND_COLOR, iconSize: BUTTON_ICON_SIZE, textColor: BUTTON_TEXT_COLOR, iconColor: BUTTON_ICON_COLOR, transition: TRANSITION },
        React.createElement(BaSeIcon, { size: BUTTON_ICON_SIZE, name: "user", color: foregroundColor, description: getMessage('imageAccountProfile.description') }),
        React.createElement(BaSeText, { isBold: true, isItalic: false, isThin: false, color: foregroundColor }, buttonCollapsed ? '' : getMessage('login.label'))));
};
BaSeAccountProfile.displayName = 'BaSeAccountProfile';

function getLogoPath(easterEgg, image) {
    var paths = [];
    var extension = '.svg';
    easterEgg = false; // TODO quando a estratégia do easter egg estiver ok, remover essa linha
    if (easterEgg) {
        var easterEggPrefix = '__';
        var today = new Date();
        var month = today.getMonth() + 1;
        var day = today.getDate();
        paths.push("".concat(image).concat(easterEggPrefix).concat(month, "_").concat(day).concat(extension));
        paths.push("".concat(image).concat(easterEggPrefix).concat(month).concat(extension));
    }
    paths.push("".concat(image).concat(extension));
    return paths;
}

var BaSeLogoSebrae = function (_a) {
    var onClick = _a.onClick, _b = _a.width, width = _b === void 0 ? 'auto' : _b, _c = _a.easterEgg, easterEgg = _c === void 0 ? false : _c;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(BaSeStaticAsset, { description: getMessage('logo.description'), path: getLogoPath(easterEgg, 'images/logos/sebrae_logo'), onClick: onClick, width: numberWithUnit(width) }));
};
BaSeLogoSebrae.displayName = 'BaSeLogoSebrae';

var BaSeLogoSebraeInverse = function (_a) {
    var onClick = _a.onClick, _b = _a.width, width = _b === void 0 ? 'auto' : _b, _c = _a.easterEgg, easterEgg = _c === void 0 ? false : _c;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(BaSeStaticAsset, { description: getMessage('logo.description'), path: getLogoPath(easterEgg, 'images/logos/sebrae_logo-inverse'), onClick: onClick, width: numberWithUnit(width) }));
};
BaSeLogoSebraeInverse.displayName = 'BaSeLogoSebraeInverse';

var slideIn$2 = keyframes(templateObject_1$M || (templateObject_1$M = __makeTemplateObject(["\n  from {\n    transform: translateX(-100vw);\n  };\n  to {\n    transform: translateX(0);\n  };\n"], ["\n  from {\n    transform: translateX(-100vw);\n  };\n  to {\n    transform: translateX(0);\n  };\n"])));
var slideOut = keyframes(templateObject_2$F || (templateObject_2$F = __makeTemplateObject(["\n  from {\n    transform: translateX(0);\n  };\n  to {\n    transform: translateX(-100vw);\n  }\n"], ["\n  from {\n    transform: translateX(0);\n  };\n  to {\n    transform: translateX(-100vw);\n  }\n"])));
var HeaderOutsideContainer = styled.div(templateObject_3$x || (templateObject_3$x = __makeTemplateObject(["\n  min-height: 60px;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  box-shadow: ", ";\n"], ["\n  min-height: 60px;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  box-shadow: ", ";\n"])), function (props) { return props.color; }, BaSeTheme.shadows.profundidade4);
var HeaderContainer = styled.div(templateObject_8$j || (templateObject_8$j = __makeTemplateObject(["\n  max-width: ", ";\n  width: 100%;\n  display: grid;\n  ", "\n  color: ", ";\n  align-items: center;\n  justify-content: space-between;\n  ", ";\n"], ["\n  max-width: ", ";\n  width: 100%;\n  display: grid;\n  ", "\n  color: ", ";\n  align-items: center;\n  justify-content: space-between;\n  ", ";\n"])), function (props) { return (props.maxWidth ? "".concat(props.maxWidth, "px") : '100%'); }, function (props) {
    return props.mobile && props.hasItems
        ? css(templateObject_4$s || (templateObject_4$s = __makeTemplateObject(["\n          grid-template-columns: 1fr 1fr 1fr;\n        "], ["\n          grid-template-columns: 1fr 1fr 1fr;\n        "]))) : css(templateObject_5$p || (templateObject_5$p = __makeTemplateObject(["\n          grid-template-columns: 1fr auto;\n        "], ["\n          grid-template-columns: 1fr auto;\n        "])));
}, function (props) { return props.textColor; }, function (props) {
    return props.mobile
        ? css(templateObject_6$o || (templateObject_6$o = __makeTemplateObject(["\n          padding: 0 18px 0 10px;\n        "], ["\n          padding: 0 18px 0 10px;\n        "]))) : css(templateObject_7$k || (templateObject_7$k = __makeTemplateObject(["\n          padding: 0 24px;\n        "], ["\n          padding: 0 24px;\n        "])));
});
var HeaderExpandedMenuItemsContainer = styled.ul(templateObject_10$e || (templateObject_10$e = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  gap: 16px;\n  font-size: 13px;\n  height: 21px;\n  align-items: center;\n  padding-right: 25px;\n  height: 100%;\n\n  &:empty {\n    padding-right: 0px;\n    margin-right: 0px;\n  }\n\n  ", "\n"], ["\n  position: relative;\n  display: flex;\n  gap: 16px;\n  font-size: 13px;\n  height: 21px;\n  align-items: center;\n  padding-right: 25px;\n  height: 100%;\n\n  &:empty {\n    padding-right: 0px;\n    margin-right: 0px;\n  }\n\n  ", "\n"])), function (props) {
    return props.showBorder && css(templateObject_9$h || (templateObject_9$h = __makeTemplateObject(["\n      margin-right: 26px;\n\n      ::after {\n        content: '';\n        position: absolute;\n        right: 0;\n        height: 21px;\n        top: calc(50% - 10.5px);\n        width: 1px;\n        background-color: ", ";\n      }\n    "], ["\n      margin-right: 26px;\n\n      ::after {\n        content: '';\n        position: absolute;\n        right: 0;\n        height: 21px;\n        top: calc(50% - 10.5px);\n        width: 1px;\n        background-color: ", ";\n      }\n    "])), props.color);
});
var HeaderFlex = styled.div(templateObject_14$a || (templateObject_14$a = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  ", "\n  ", "\n  ", ";\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  ", "\n  ", "\n  ", ";\n  ", "\n"])), function (props) {
    return props.alignEnd ? 'flex-end' : props.alignStart ? 'start' : 'center';
}, function (props) {
    return props.alignEnd && css(templateObject_11$c || (templateObject_11$c = __makeTemplateObject(["\n      button {\n        gap: 0;\n      }\n    "], ["\n      button {\n        gap: 0;\n      }\n    "])));
}, function (props) {
    return props.fullWidth && css(templateObject_12$b || (templateObject_12$b = __makeTemplateObject(["\n      width: 100%;\n    "], ["\n      width: 100%;\n    "])));
}, function (props) { var _a; return "gap: ".concat((_a = props.gap) !== null && _a !== void 0 ? _a : 0, "px"); }, function (props) {
    return props.fullHeight && css(templateObject_13$a || (templateObject_13$a = __makeTemplateObject(["\n      height: 100%;\n    "], ["\n      height: 100%;\n    "])));
});
var HeaderSideMenu = styled.aside(templateObject_15$7 || (templateObject_15$7 = __makeTemplateObject(["\n  background-color: ", ";\n  height: 100%;\n  display: flex;\n  flex-flow: column;\n  gap: 16px;\n  padding: 16px;\n  h5 {\n    margin-bottom: 16px;\n  }\n"], ["\n  background-color: ", ";\n  height: 100%;\n  display: flex;\n  flex-flow: column;\n  gap: 16px;\n  padding: 16px;\n  h5 {\n    margin-bottom: 16px;\n  }\n"])), function (props) { return props.sidebarBackgroundColor; });
var HeaderCollapsedContainer = styled.div(templateObject_16$5 || (templateObject_16$5 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: ", ";\n  width: 100vw;\n  min-height: 100vh;\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: ", ";\n  width: 100vw;\n  min-height: 100vh;\n"])), BaSeTheme.stackOrder.overlay + 2);
var HeaderCollapsedTransparentContainer = styled.div(templateObject_17$4 || (templateObject_17$4 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: ", ";\n  opacity: 0.5;\n  width: 100vw;\n  height: 100vh;\n  z-index: ", ";\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: ", ";\n  opacity: 0.5;\n  width: 100vw;\n  height: 100vh;\n  z-index: ", ";\n"])), BaSeTheme.colors.institucionais.cinzaSebrae20, BaSeTheme.stackOrder.overlay + 3);
var HeaderCollapsedContent = styled.div(templateObject_20$4 || (templateObject_20$4 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: calc(100vw - 56px);\n  height: 100vh;\n  z-index: ", ";\n  ", ";\n\n  &.closed {\n    ", ";\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: calc(100vw - 56px);\n  height: 100vh;\n  z-index: ", ";\n  ", ";\n\n  &.closed {\n    ", ";\n  }\n"])), BaSeTheme.stackOrder.overlay + 4, css(templateObject_18$4 || (templateObject_18$4 = __makeTemplateObject(["\n    animation: ", " ", "\n      ", ";\n  "], ["\n    animation: ", " ", "\n      ", ";\n  "])), slideIn$2, BaSeTheme.transitions.durationNormal, BaSeTheme.transitions.continuousTimingFunction), css(templateObject_19$4 || (templateObject_19$4 = __makeTemplateObject(["\n      animation: ", " ", "\n        ", ";\n    "], ["\n      animation: ", " ", "\n        ", ";\n    "])), slideOut, BaSeTheme.transitions.durationNormal, BaSeTheme.transitions.continuousTimingFunction));
var HeaderCollapsedMenuItemNonNav = styled.div(templateObject_21$4 || (templateObject_21$4 = __makeTemplateObject(["\n  z-index: 1;\n"], ["\n  z-index: 1;\n"])));
var HeaderCollapsedMenuItemContainer = styled.li(templateObject_24$3 || (templateObject_24$3 = __makeTemplateObject(["\n  ", ";\n  position: relative;\n  animation-delay: ", "ms;\n  animation-fill-mode: both;\n  margin: 0.5em 0;\n\n  ", "\n"], ["\n  ", ";\n  position: relative;\n  animation-delay: ", "ms;\n  animation-fill-mode: both;\n  margin: 0.5em 0;\n\n  ", "\n"])), css(templateObject_22$3 || (templateObject_22$3 = __makeTemplateObject(["\n    animation: ", " ", "\n      ", ";\n  "], ["\n    animation: ", " ", "\n      ", ";\n  "])), slideIn$2, BaSeTheme.transitions.durationNormal, BaSeTheme.transitions.continuousTimingFunction), function (props) { return props.delay; }, function (_a) {
    var hasClick = _a.hasClick, color = _a.color;
    return hasClick && css(templateObject_23$3 || (templateObject_23$3 = __makeTemplateObject(["\n      cursor: pointer;\n\n      &::after,\n      &::before {\n        content: '';\n        transition: all ", ";\n        position: absolute;\n        background-color: ", ";\n        height: 0;\n      }\n\n      &::after {\n        top: 0;\n        width: 1px;\n        left: -16px;\n      }\n\n      &::before {\n        bottom: 0;\n        left: -16px;\n        width: 4px;\n      }\n\n      &:focus {\n        outline: none;\n\n        &::after {\n          height: 100%;\n        }\n      }\n\n      &:hover::before {\n        height: 100%;\n      }\n    "], ["\n      cursor: pointer;\n\n      &::after,\n      &::before {\n        content: '';\n        transition: all ", ";\n        position: absolute;\n        background-color: ", ";\n        height: 0;\n      }\n\n      &::after {\n        top: 0;\n        width: 1px;\n        left: -16px;\n      }\n\n      &::before {\n        bottom: 0;\n        left: -16px;\n        width: 4px;\n      }\n\n      &:focus {\n        outline: none;\n\n        &::after {\n          height: 100%;\n        }\n      }\n\n      &:hover::before {\n        height: 100%;\n      }\n    "])), BaSeTheme.transitions.durationNormal, color);
});
var HeaderMenuIconContainer = styled.div(templateObject_25$2 || (templateObject_25$2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n"])));
var HeaderCloseIconContent = styled.div(templateObject_26$2 || (templateObject_26$2 = __makeTemplateObject(["\n  position: absolute;\n  right: 20px;\n  top: 20px;\n  z-index: ", ";\n\n  button {\n    background-color: ", ";\n  }\n"], ["\n  position: absolute;\n  right: 20px;\n  top: 20px;\n  z-index: ", ";\n\n  button {\n    background-color: ", ";\n  }\n"])), BaSeTheme.stackOrder.normal + 1, function (_a) {
    var buttonBackgroundColor = _a.buttonBackgroundColor;
    return buttonBackgroundColor;
});
var HeaderExpandedMenuItemContainer = styled.li(templateObject_28$2 || (templateObject_28$2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var onClick = _a.onClick, color = _a.color;
    return onClick && css(templateObject_27$2 || (templateObject_27$2 = __makeTemplateObject(["\n      cursor: pointer;\n      position: relative;\n      height: 100%;\n      display: flex;\n      flex-flow: column;\n      justify-content: center;\n\n      &::after,\n      &::before {\n        content: '';\n        transition: all ", ";\n        position: absolute;\n        background-color: ", ";\n        width: 0;\n      }\n\n      &::after {\n        left: 0;\n        bottom: 0px;\n        height: 1px;\n      }\n\n      &::before {\n        right: 0;\n        bottom: 0;\n        height: 4px;\n      }\n\n      &:focus {\n        outline: none;\n\n        &::after {\n          width: 100%;\n        }\n      }\n\n      &:hover::before {\n        width: 100%;\n      }\n    "], ["\n      cursor: pointer;\n      position: relative;\n      height: 100%;\n      display: flex;\n      flex-flow: column;\n      justify-content: center;\n\n      &::after,\n      &::before {\n        content: '';\n        transition: all ", ";\n        position: absolute;\n        background-color: ", ";\n        width: 0;\n      }\n\n      &::after {\n        left: 0;\n        bottom: 0px;\n        height: 1px;\n      }\n\n      &::before {\n        right: 0;\n        bottom: 0;\n        height: 4px;\n      }\n\n      &:focus {\n        outline: none;\n\n        &::after {\n          width: 100%;\n        }\n      }\n\n      &:hover::before {\n        width: 100%;\n      }\n    "])), BaSeTheme.transitions.durationNormal, color);
});
var HeaderGhostContainer = styled.div(templateObject_29$2 || (templateObject_29$2 = __makeTemplateObject(["\n  width: 24px;\n  height: 100vh;\n  background-color: ", ";\n  position: fixed;\n"], ["\n  width: 24px;\n  height: 100vh;\n  background-color: ", ";\n  position: fixed;\n"])), BaSeTheme.colors.defaultColors.transparent);
var HeaderExpandedComponentsContainer = styled.div(templateObject_30$2 || (templateObject_30$2 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"], ["\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"])));
var SubHeaderContainer = styled.div.attrs({
    className: 'BaSe--header-submenu',
})(templateObject_31$1 || (templateObject_31$1 = __makeTemplateObject(["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  box-shadow: ", ";\n  align-items: center;\n  max-height: ", ";\n  transition: ", ";\n  overflow: hidden;\n"], ["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  box-shadow: ", ";\n  align-items: center;\n  max-height: ", ";\n  transition: ", ";\n  overflow: hidden;\n"])), function (props) { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : BaSeTheme.colors.defaultColors.white; }, BaSeTheme.shadows.profundidade4, function (props) { return (props.open ? '100vh' : '0px'); }, BaSeTheme.transitions.allPropertiesContinuousNormal);
var templateObject_1$M, templateObject_2$F, templateObject_3$x, templateObject_4$s, templateObject_5$p, templateObject_6$o, templateObject_7$k, templateObject_8$j, templateObject_9$h, templateObject_10$e, templateObject_11$c, templateObject_12$b, templateObject_13$a, templateObject_14$a, templateObject_15$7, templateObject_16$5, templateObject_17$4, templateObject_18$4, templateObject_19$4, templateObject_20$4, templateObject_21$4, templateObject_22$3, templateObject_23$3, templateObject_24$3, templateObject_25$2, templateObject_26$2, templateObject_27$2, templateObject_28$2, templateObject_29$2, templateObject_30$2, templateObject_31$1;

var animationTime = 250;
var LEFT_TO_RIGHT = 4;
var RIGHT_TO_LEFT = 2;
var BaSeHeader = function (_a) {
    var _b = _a.menuItens, menuItens = _b === void 0 ? [] : _b, _c = _a.textColor, textColor = _c === void 0 ? BaSeTheme.colors.contrast.institucionais.azulSebrae36 : _c, _d = _a.backgroundColor, backgroundColor = _d === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _d, _e = _a.sidebarBackgroundColor, sidebarBackgroundColor = _e === void 0 ? BaSeTheme.colors.contrast.institucionais
        .azulSebrae36 : _e, _f = _a.sidebarTextColor, sidebarTextColor = _f === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _f, _g = _a.systemName, systemName = _g === void 0 ? '' : _g, accountProfileProps = _a.accountProfileProps, _h = _a.customComponents, customComponents = _h === void 0 ? [] : _h, _j = _a.collapsedBreakpoint, collapsedBreakpoint = _j === void 0 ? 'onTablet' : _j, logoOnClick = _a.logoOnClick, systemLogo = _a.systemLogo, _k = _a.logoInverseColor, logoInverseColor = _k === void 0 ? true : _k, _l = _a.submenuProps, submenuProps = _l === void 0 ? {} : _l, delimitedOnBreakpoint = _a.delimitedOnBreakpoint;
    var _m = submenuProps.open, submenuOpen = _m === void 0 ? false : _m, submenuBackgroundColor = submenuProps.backgroundColor, submenuCollapsedBreakpoint = submenuProps.collapsedBreakpoint;
    var _o = React.useState(false), menuDisplay = _o[0], setMenuDisplay = _o[1];
    var _p = React.useState(false), menuOpen = _p[0], setMenuOpen = _p[1];
    var _q = React.useState(false), submenuOpenQuery = _q[0], setSubmenuOpenQuery = _q[1];
    var _r = React.useState(''), classClosed = _r[0], setClassClosed = _r[1];
    var handleMenuAnimations = React.useCallback(function (force) {
        if (force === void 0) { force = false; }
        if (force || menuOpen) {
            setClassClosed('closed');
            setTimeout(function () {
                setMenuOpen(false);
                setClassClosed('');
            }, animationTime);
        }
        else {
            setMenuOpen(true);
        }
    }, [menuOpen]);
    var handleDelimiterBreakpoint = React.useCallback(function () {
        if (delimitedOnBreakpoint &&
            delimitedOnBreakpoint in BaSeTheme.breakpoints) {
            return BaSeTheme.breakpoints[delimitedOnBreakpoint].minWidth;
        }
        return;
    }, [delimitedOnBreakpoint]);
    var handleDeactivateFocusTrap = React.useCallback(function () {
        handleMenuAnimations(true);
    }, []);
    var handleClickMenuItem = React.useCallback(function (item, e) {
        if (item.onClick) {
            item.onClick(e);
            handleMenuAnimations(true);
        }
    }, []);
    useMenuItemsShrink(setMenuDisplay, collapsedBreakpoint);
    useMenuItemsShrink(setSubmenuOpenQuery, submenuCollapsedBreakpoint);
    var delayTime = React.useCallback(function (index) { return 100 + index * 50; }, []);
    var handleSwipe = React.useCallback(function (swipe, direction) {
        if (swipe.direction === direction) {
            handleMenuAnimations();
        }
    }, [handleMenuAnimations]);
    var SystemLogoMemo = React.useMemo(function () {
        var _a;
        return ((_a = systemLogo === null || systemLogo === void 0 ? void 0 : systemLogo()) !== null && _a !== void 0 ? _a : (logoInverseColor ? (React.createElement(BaSeLogoSebraeInverse, { easterEgg: true, onClick: logoOnClick, width: 68 })) : (React.createElement(BaSeLogoSebrae, { easterEgg: true, onClick: logoOnClick, width: 68 }))));
    }, [systemLogo, logoInverseColor]); // TODO add estaerEgg props no array do memo
    React.useEffect(function () {
        var _a;
        if (accountProfileProps) {
            (_a = accountProfileProps.clientName) !== null && _a !== void 0 ? _a : (accountProfileProps.clientName = systemName);
        }
    }, [accountProfileProps, systemName]);
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderOutsideContainer, { className: "BaSe--header", color: backgroundColor },
            React.createElement(HeaderContainer, { textColor: textColor, hasItems: menuItens.length > 0, mobile: menuDisplay, maxWidth: handleDelimiterBreakpoint() },
                menuDisplay && menuItens.length > 0 && (React.createElement(HeaderFlex, { alignStart: true },
                    React.createElement(HeaderMenuIconContainer, null,
                        React.createElement(BaSeShapeButton, { nameIcon: "bars", type: "tertiary", buttonType: "button", size: "medium", sizeIcon: "medium", color: textColor, onClick: function () { return handleMenuAnimations(); } })),
                    customComponents
                        .filter(function (widget) { return widget.showOnCollapsed; })
                        .map(function (item, key) { return (React.createElement(HeaderFlex, { alignStart: true, fullWidth: true, key: key }, item.component(function () { }))); }))),
                React.createElement(HeaderFlex, { alignStart: menuItens.length === 0, gap: 16 },
                    SystemLogoMemo,
                    !menuDisplay && (React.createElement(HeaderExpandedComponentsContainer, null, customComponents
                        .filter(function (widget) { return widget.showOnExpanded; })
                        .map(function (item, key) { return (React.createElement(HeaderFlex, { fullWidth: true, key: key }, item.component(function () { }))); }))),
                    menuDisplay &&
                        menuItens.length === 0 &&
                        customComponents
                            .filter(function (widget) { return widget.showOnCollapsed; })
                            .map(function (item, key) { return (React.createElement(HeaderFlex, { alignStart: true, fullWidth: true, key: key }, item.component(function () { }))); })),
                React.createElement(HeaderFlex, { fullHeight: true, alignEnd: menuDisplay },
                    !menuDisplay && (React.createElement(HeaderExpandedMenuItemsContainer, { showBorder: menuItens.length > 0 && !!accountProfileProps, color: textColor, role: "menu" }, menuItens.map(function (item, index) {
                        var _a, _b;
                        return (React.createElement(HeaderExpandedMenuItemContainer, { key: index, role: "menuitem", tabIndex: !!item.onClick ? 0 : undefined, onKeyDown: function (e) { var _a; return e.key === 'Enter' && ((_a = item === null || item === void 0 ? void 0 : item.onClick) === null || _a === void 0 ? void 0 : _a.call(item, e)); }, onClick: item.onClick, color: textColor }, (_b = (_a = item === null || item === void 0 ? void 0 : item.component) === null || _a === void 0 ? void 0 : _a.call(item, function () { })) !== null && _b !== void 0 ? _b : (React.createElement(BaSeParagraph, { color: textColor }, item.label))));
                    }))),
                    accountProfileProps && (React.createElement(BaSeAccountProfile, __assign({ foregroundColor: textColor, backgroundColor: backgroundColor }, accountProfileProps, { buttonCollapsed: menuDisplay })))))),
        React.createElement(SubHeaderContainer, { open: submenuOpen && submenuOpenQuery, color: submenuBackgroundColor }, customComponents
            .filter(function (widget) { return widget.showOnSubmenu; })
            .map(function (item, key) { return (React.createElement(HeaderFlex, { key: key }, item.component(function () { }))); })),
        menuDisplay && (React.createElement(Hammer, { onSwipe: function (e) { return handleSwipe(e, LEFT_TO_RIGHT); } },
            React.createElement(HeaderGhostContainer, null))),
        menuOpen && menuDisplay && (React.createElement(Hammer, { onSwipe: function (e) { return handleSwipe(e, RIGHT_TO_LEFT); } },
            React.createElement(HeaderCollapsedContainer, null,
                React.createElement(HeaderCollapsedTransparentContainer, null),
                React.createElement(FocusTrap, { focusTrapOptions: {
                        delayInitialFocus: true,
                        escapeDeactivates: true,
                        clickOutsideDeactivates: true,
                        onDeactivate: handleDeactivateFocusTrap,
                    } },
                    React.createElement(HeaderCollapsedContent, { className: "BaSe--header-collapsed-content ".concat(classClosed) },
                        React.createElement(HeaderSideMenu, { sidebarBackgroundColor: sidebarBackgroundColor ||
                                BaSeTheme.colors.defaultColors.white },
                            React.createElement(BaSeHeading5, { isBold: true, color: sidebarTextColor }, systemName),
                            React.createElement(HeaderCollapsedMenuItemNonNav, null, customComponents
                                .filter(function (widget) { return widget.showOnSidebar; })
                                .map(function (item, key) { return (React.createElement(HeaderCollapsedMenuItemContainer, { as: "div", delay: 100, key: key, hasClick: false }, item.component(function () { return handleMenuAnimations(); }))); })),
                            React.createElement("nav", null,
                                React.createElement("ul", { role: "menu" }, menuItens
                                    .filter(function (i) { return !i.hideOnSidebar; })
                                    .map(function (item, index) {
                                    var _a, _b;
                                    return (React.createElement(HeaderCollapsedMenuItemContainer, { color: sidebarTextColor, tabIndex: !!item.onClick ? 0 : undefined, key: index, role: "menuitem", onKeyDown: function (e) {
                                            return e.key === 'Enter' && handleClickMenuItem(item, e);
                                        }, onClick: function (e) {
                                            return handleClickMenuItem(item, e);
                                        }, hasClick: !!item.onClick, delay: delayTime(index) }, (_b = (_a = item === null || item === void 0 ? void 0 : item.component) === null || _a === void 0 ? void 0 : _a.call(item, function () {
                                        return handleMenuAnimations();
                                    })) !== null && _b !== void 0 ? _b : (React.createElement(BaSeText, { color: sidebarTextColor }, item.label))));
                                })))),
                        React.createElement(HeaderCloseIconContent, { buttonBackgroundColor: sidebarBackgroundColor },
                            React.createElement(BaSeShapeButton, { onClick: function () { return handleMenuAnimations(); }, buttonType: "button", nameIcon: "close", shape: "circle", size: "medium", sizeIcon: "medium", type: "tertiary", color: sidebarTextColor })))))))));
};
BaSeHeader.displayName = 'BaSeHeader';

var validateColor = function (color) {
    var customColorHsv = Color.generateFromHex(color);
    return color && customColorHsv;
};
var defaultColor = {
    background: BaSeTheme.colors.institucionais.cinzaSebrae97,
    link: BaSeTheme.colors.institucionais.azulSebrae36,
    text: BaSeTheme.colors.institucionais.cinzaSebrae60,
    version: BaSeTheme.colors.institucionais.cinzaSebrae75,
    mobileHeader: BaSeTheme.colors.institucionais.azulSebrae36,
    separator: BaSeTheme.colors.gestao.cinza85,
};
var FooterWrapper = styled.footer(templateObject_1$L || (templateObject_1$L = __makeTemplateObject(["\n  width: 100%;\n  background-color: ", ";\n  display: grid;\n  place-items: center;\n"], ["\n  width: 100%;\n  background-color: ", ";\n  display: grid;\n  place-items: center;\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor && validateColor(backgroundColor)
        ? backgroundColor
        : defaultColor.background;
});
var CollapsedSubFooter = styled.div(templateObject_2$E || (templateObject_2$E = __makeTemplateObject(["\n  justify-self: start;\n  padding: 16px;\n  a,\n  p {\n    padding: 8px 0;\n    justify-content: start;\n  }\n"], ["\n  justify-self: start;\n  padding: 16px;\n  a,\n  p {\n    padding: 8px 0;\n    justify-content: start;\n  }\n"])));
var CollapsedUpperFooter = styled.div(templateObject_3$w || (templateObject_3$w = __makeTemplateObject(["\n  width: 100%;\n  p,\n  a {\n    padding-left: 0;\n  }\n"], ["\n  width: 100%;\n  p,\n  a {\n    padding-left: 0;\n  }\n"])));
var TextFooter = styled.div(templateObject_4$r || (templateObject_4$r = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: ", ";\n  justify-content: space-between;\n  padding: ", ";\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: ", ";\n  justify-content: space-between;\n  padding: ", ";\n"])), function (_a) {
    var direction = _a.direction;
    return direction;
}, function (_a) {
    var direction = _a.direction;
    return (direction === 'row' ? '13px 0px' : '0px');
});
styled.div(templateObject_5$o || (templateObject_5$o = __makeTemplateObject(["\n  background-color: ", ";\n  padding: 18px 16px;\n  color: #ffffff;\n  font-size: 13px;\n"], ["\n  background-color: ", ";\n  padding: 18px 16px;\n  color: #ffffff;\n  font-size: 13px;\n"])), function (_a) {
    var mobileHeaderColor = _a.mobileHeaderColor;
    return mobileHeaderColor && validateColor(mobileHeaderColor)
        ? mobileHeaderColor
        : defaultColor.mobileHeader;
});
var YearText = styled.p(templateObject_6$n || (templateObject_6$n = __makeTemplateObject(["\n  color: ", ";\n  font-size: 13px;\n  a {\n    padding: 0;\n  }\n"], ["\n  color: ", ";\n  font-size: 13px;\n  a {\n    padding: 0;\n  }\n"])), function (_a) {
    var textColor = _a.textColor;
    return textColor && validateColor(textColor) ? textColor : defaultColor.text;
});
var SystemFooter = styled.p(templateObject_7$j || (templateObject_7$j = __makeTemplateObject(["\n  color: ", ";\n  font-size: 11px;\n"], ["\n  color: ", ";\n  font-size: 11px;\n"])), function (_a) {
    var versionColor = _a.versionColor;
    return versionColor && validateColor(versionColor)
        ? versionColor
        : defaultColor.version;
});
var RelationFooter = styled.div(templateObject_8$i || (templateObject_8$i = __makeTemplateObject(["\n  font-size: 13px;\n  align-content: center;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  justify-content: flex-end;\n  text-align: ", ";\n"], ["\n  font-size: 13px;\n  align-content: center;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  justify-content: flex-end;\n  text-align: ", ";\n"])), function (_a) {
    var direction = _a.direction;
    return (direction === 'row' ? 'end' : 'start');
});
var Line = styled.hr(templateObject_9$g || (templateObject_9$g = __makeTemplateObject(["\n  border: none;\n  border-bottom: 1px solid\n    ", ";\n  width: 100%;\n  margin: 0px;\n"], ["\n  border: none;\n  border-bottom: 1px solid\n    ", ";\n  width: 100%;\n  margin: 0px;\n"])), function (_a) {
    var separatorColor = _a.separatorColor;
    return separatorColor && validateColor(separatorColor)
        ? separatorColor
        : defaultColor.separator;
});
var Separator = styled(Line)(templateObject_10$d || (templateObject_10$d = __makeTemplateObject(["\n  transform: translateY(16px);\n"], ["\n  transform: translateY(16px);\n"])));
var FooterLinks = styled.div(templateObject_12$a || (templateObject_12$a = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-self: start;\n  text-align: center;\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-self: start;\n  text-align: center;\n\n  ", "\n"])), function (_a) {
    var direction = _a.direction;
    return direction;
}, function (_a) {
    var direction = _a.direction;
    return (direction === 'row' ? 'center' : 'start');
}, function (_a) {
    var direction = _a.direction;
    return direction === 'column' && css(templateObject_11$b || (templateObject_11$b = __makeTemplateObject(["\n      padding: 0;\n      p:not(:last-child),\n      a:not(:last-child) {\n        border: none;\n      }\n    "], ["\n      padding: 0;\n      p:not(:last-child),\n      a:not(:last-child) {\n        border: none;\n      }\n    "])));
});
var FooterLink = styled.p(templateObject_13$9 || (templateObject_13$9 = __makeTemplateObject(["\n  font-size: 13px;\n  text-decoration: none;\n  color: ", ";\n  cursor: pointer;\n  padding: 4px 16px;\n  :not(:last-child) {\n    border-right: 1px solid\n      ", ";\n  }\n  :first-child {\n    padding-left: 0;\n  }\n"], ["\n  font-size: 13px;\n  text-decoration: none;\n  color: ", ";\n  cursor: pointer;\n  padding: 4px 16px;\n  :not(:last-child) {\n    border-right: 1px solid\n      ", ";\n  }\n  :first-child {\n    padding-left: 0;\n  }\n"])), function (_a) {
    var linkColor = _a.linkColor;
    return linkColor && validateColor(linkColor) ? linkColor : defaultColor.link;
}, function (_a) {
    var separatorColor = _a.separatorColor;
    return separatorColor && validateColor(separatorColor)
        ? separatorColor
        : defaultColor.separator;
});
var FooterContent = styled.div(templateObject_14$9 || (templateObject_14$9 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var templateObject_1$L, templateObject_2$E, templateObject_3$w, templateObject_4$r, templateObject_5$o, templateObject_6$n, templateObject_7$j, templateObject_8$i, templateObject_9$g, templateObject_10$d, templateObject_11$b, templateObject_12$a, templateObject_13$9, templateObject_14$9;

function getValue(unit) {
    if (unit === undefined) {
        return undefined;
    }
    return numberWithUnit(unit);
}
var GridWrapper = styled.div(templateObject_3$v || (templateObject_3$v = __makeTemplateObject(["\n  margin: 0 auto;\n  position: relative;\n  display: grid;\n  justify-content: center;\n  grid-template-columns: repeat(12, 1fr);\n  width: auto;\n  ", "\n  ", "\n  /*mobileSmall*/\n  ", "\n  /*mobile*/\n  ", "\n  /*mobileLarge*/\n  ", "\n  /*tablet*/\n  ", "\n  /*desktop*/\n  ", "\n  /*desktopLarge*/\n  ", "\n"], ["\n  margin: 0 auto;\n  position: relative;\n  display: grid;\n  justify-content: center;\n  grid-template-columns: repeat(12, 1fr);\n  width: auto;\n  ", "\n  ", "\n  /*mobileSmall*/\n  ", "\n  /*mobile*/\n  ", "\n  /*mobileLarge*/\n  ", "\n  /*tablet*/\n  ", "\n  /*desktop*/\n  ", "\n  /*desktopLarge*/\n  ", "\n"])), function (_a) {
    var delimitedOnBreakpoint = _a.delimitedOnBreakpoint;
    return delimitedOnBreakpoint && css(templateObject_1$K || (templateObject_1$K = __makeTemplateObject(["\n      max-width: ", "px;\n    "], ["\n      max-width: ", "px;\n    "])), BaSeTheme.breakpoints[delimitedOnBreakpoint].minWidth);
}, function (_a) {
    var padding = _a.padding;
    return padding && css(templateObject_2$D || (templateObject_2$D = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), getValue(padding));
}, function (_a) {
    var _b;
    var gap = _a.gap;
    return BaSeTheme.breakpoints.mobileSmall.mediaQueryCss("\n    gap: ".concat((_b = getValue(gap)) !== null && _b !== void 0 ? _b : "".concat(BaSeTheme.breakpoints.mobileSmall.gap, "px"), ";\n  "));
}, function (_a) {
    var _b;
    var gap = _a.gap;
    return BaSeTheme.breakpoints.mobile.mediaQueryCss("\n    gap: ".concat((_b = getValue(gap)) !== null && _b !== void 0 ? _b : "".concat(BaSeTheme.breakpoints.mobile.gap, "px"), ";\n  "));
}, function (_a) {
    var _b;
    var gap = _a.gap;
    return BaSeTheme.breakpoints.mobileLarge.mediaQueryCss("\n    gap: ".concat((_b = getValue(gap)) !== null && _b !== void 0 ? _b : "".concat(BaSeTheme.breakpoints.mobileLarge.gap, "px"), ";\n  "));
}, function (_a) {
    var _b;
    var gap = _a.gap;
    return BaSeTheme.breakpoints.tablet.mediaQueryCss("\n    gap: ".concat((_b = getValue(gap)) !== null && _b !== void 0 ? _b : "".concat(BaSeTheme.breakpoints.tablet.gap, "px"), ";\n  "));
}, function (_a) {
    var _b;
    var gap = _a.gap;
    return BaSeTheme.breakpoints.desktop.mediaQueryCss("\n    gap: ".concat((_b = getValue(gap)) !== null && _b !== void 0 ? _b : "".concat(BaSeTheme.breakpoints.desktop.gap, "px"), ";\n  "));
}, function (_a) {
    var _b;
    var gap = _a.gap;
    return BaSeTheme.breakpoints.desktopLarge.mediaQueryCss("\n    gap: ".concat((_b = getValue(gap)) !== null && _b !== void 0 ? _b : "".concat(BaSeTheme.breakpoints.desktopLarge.gap, "px"), ";\n  "));
});
var templateObject_1$K, templateObject_2$D, templateObject_3$v;

var BaSeGrid = function (_a) {
    var gap = _a.gap, padding = _a.padding, delimitedOnBreakpoint = _a.delimitedOnBreakpoint, children = _a.children;
    return (React.createElement(GridWrapper, { className: "BaSe--grid", padding: padding, gap: gap, delimitedOnBreakpoint: delimitedOnBreakpoint }, children));
};
BaSeGrid.displayName = 'BaSeGrid';

function gridColumn(size, startAt) {
    return startAt !== undefined
        ? "".concat(startAt + 1, " / span ").concat(size)
        : "span ".concat(size);
}
function get(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14;
    var what = _a.what, props = _a.props, breakpoint = _a.breakpoint;
    var fallback = {
        mobileSmall: (_b = props.all) === null || _b === void 0 ? void 0 : _b[what],
        mobile: (_d = (_c = props === null || props === void 0 ? void 0 : props.mobileSmall) === null || _c === void 0 ? void 0 : _c[what]) !== null && _d !== void 0 ? _d : (_e = props.all) === null || _e === void 0 ? void 0 : _e[what],
        mobileLarge: (_j = (_g = (_f = props === null || props === void 0 ? void 0 : props.mobile) === null || _f === void 0 ? void 0 : _f[what]) !== null && _g !== void 0 ? _g : (_h = props === null || props === void 0 ? void 0 : props.mobileSmall) === null || _h === void 0 ? void 0 : _h[what]) !== null && _j !== void 0 ? _j : (_k = props.all) === null || _k === void 0 ? void 0 : _k[what],
        tablet: (_r = (_p = (_m = (_l = props === null || props === void 0 ? void 0 : props.mobileLarge) === null || _l === void 0 ? void 0 : _l[what]) !== null && _m !== void 0 ? _m : (_o = props === null || props === void 0 ? void 0 : props.mobile) === null || _o === void 0 ? void 0 : _o[what]) !== null && _p !== void 0 ? _p : (_q = props === null || props === void 0 ? void 0 : props.mobileSmall) === null || _q === void 0 ? void 0 : _q[what]) !== null && _r !== void 0 ? _r : (_s = props.all) === null || _s === void 0 ? void 0 : _s[what],
        desktop: (_0 = (_y = (_w = (_u = (_t = props === null || props === void 0 ? void 0 : props.tablet) === null || _t === void 0 ? void 0 : _t[what]) !== null && _u !== void 0 ? _u : (_v = props === null || props === void 0 ? void 0 : props.mobileLarge) === null || _v === void 0 ? void 0 : _v[what]) !== null && _w !== void 0 ? _w : (_x = props === null || props === void 0 ? void 0 : props.mobile) === null || _x === void 0 ? void 0 : _x[what]) !== null && _y !== void 0 ? _y : (_z = props === null || props === void 0 ? void 0 : props.mobileSmall) === null || _z === void 0 ? void 0 : _z[what]) !== null && _0 !== void 0 ? _0 : (_1 = props.all) === null || _1 === void 0 ? void 0 : _1[what],
        desktopLarge: (_11 = (_9 = (_7 = (_5 = (_3 = (_2 = props === null || props === void 0 ? void 0 : props.desktop) === null || _2 === void 0 ? void 0 : _2[what]) !== null && _3 !== void 0 ? _3 : (_4 = props === null || props === void 0 ? void 0 : props.tablet) === null || _4 === void 0 ? void 0 : _4[what]) !== null && _5 !== void 0 ? _5 : (_6 = props === null || props === void 0 ? void 0 : props.mobileLarge) === null || _6 === void 0 ? void 0 : _6[what]) !== null && _7 !== void 0 ? _7 : (_8 = props === null || props === void 0 ? void 0 : props.mobile) === null || _8 === void 0 ? void 0 : _8[what]) !== null && _9 !== void 0 ? _9 : (_10 = props === null || props === void 0 ? void 0 : props.mobileSmall) === null || _10 === void 0 ? void 0 : _10[what]) !== null && _11 !== void 0 ? _11 : (_12 = props.all) === null || _12 === void 0 ? void 0 : _12[what],
    };
    return (_14 = (_13 = props === null || props === void 0 ? void 0 : props[breakpoint]) === null || _13 === void 0 ? void 0 : _13[what]) !== null && _14 !== void 0 ? _14 : fallback[breakpoint];
}
function getSize$1(_a) {
    var props = _a.from, breakpoint = _a.atBreakpoint;
    return get({ props: props, breakpoint: breakpoint, what: 'size' });
}
function getStartAt(_a) {
    var props = _a.from, breakpoint = _a.atBreakpoint;
    return get({ props: props, breakpoint: breakpoint, what: 'startAt' });
}
function gridColumnBreakpoint(props, breakpoint) {
    return gridColumn(getSize$1({ from: props, atBreakpoint: breakpoint }), getStartAt({ from: props, atBreakpoint: breakpoint }));
}
var GridItemWrapper = styled.div(templateObject_1$J || (templateObject_1$J = __makeTemplateObject(["\n  grid-column: ", ";\n\n  /* mobileSmall */\n  ", "\n  /* mobile */\n  ", "\n  /* mobileLarge */\n  ", "\n  /* tablet */\n  ", "\n  /* desktop */\n  ", "\n  /* desktopLarge */\n  ", "\n"], ["\n  grid-column: ", ";\n\n  /* mobileSmall */\n  ", "\n  /* mobile */\n  ", "\n  /* mobileLarge */\n  ", "\n  /* tablet */\n  ", "\n  /* desktop */\n  ", "\n  /* desktopLarge */\n  ", "\n"])), function (props) { var _a; return gridColumn(props.all.size, (_a = props.all) === null || _a === void 0 ? void 0 : _a.startAt); }, function (props) {
    return BaSeTheme.breakpoints.mobileSmall.mediaQueryCss("\n    grid-column: ".concat(gridColumnBreakpoint(props, 'mobileSmall'), ";\n  "));
}, function (props) {
    return BaSeTheme.breakpoints.mobile.mediaQueryCss("\n    grid-column: ".concat(gridColumnBreakpoint(props, 'mobile'), ";\n  "));
}, function (props) {
    return BaSeTheme.breakpoints.mobileLarge.mediaQueryCss("\n    grid-column: ".concat(gridColumnBreakpoint(props, 'mobileLarge'), ";\n  "));
}, function (props) {
    return BaSeTheme.breakpoints.tablet.mediaQueryCss("\n    grid-column: ".concat(gridColumnBreakpoint(props, 'tablet'), ";\n  "));
}, function (props) {
    return BaSeTheme.breakpoints.desktop.mediaQueryCss("\n    grid-column: ".concat(gridColumnBreakpoint(props, 'desktop'), ";\n  "));
}, function (props) {
    return BaSeTheme.breakpoints.desktopLarge.mediaQueryCss("\n    grid-column: ".concat(gridColumnBreakpoint(props, 'desktopLarge'), ";\n  "));
});
var templateObject_1$J;

var BaSeGridItem = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 12 : _b, startAt = _a.startAt, mobileSmall = _a.mobileSmall, mobile = _a.mobile, mobileLarge = _a.mobileLarge, tablet = _a.tablet, desktop = _a.desktop, desktopLarge = _a.desktopLarge, children = _a.children;
    return (React.createElement(GridItemWrapper, { className: "BaSe--grid-item", all: { size: size, startAt: startAt }, mobileSmall: mobileSmall, mobile: mobile, mobileLarge: mobileLarge, tablet: tablet, desktop: desktop, desktopLarge: desktopLarge }, children));
};
BaSeGridItem.displayName = 'BaSeGridItem';

var iconAncleRight = 'images/icons/angle-down.svg';
function getFilter$1(color) {
    return transformToFilter(color);
}
function getImageUrl() {
    return "".concat(urlSanitizer(BaSeConfig.staticAssetsUrl), "/").concat(iconAncleRight);
}
var AccordionContainer = styled.div.attrs({
    className: 'BaSe--accordion',
})(templateObject_2$C || (templateObject_2$C = __makeTemplateObject(["\n  overflow: hidden;\n  box-shadow: ", ";\n\n  ", "\n"], ["\n  overflow: hidden;\n  box-shadow: ", ";\n\n  ", "\n"])), function (_a) {
    var shadow = _a.shadow;
    return shadow;
}, function (_a) {
    var isSingle = _a.isSingle;
    return !isSingle && css(templateObject_1$I || (templateObject_1$I = __makeTemplateObject(["\n      border-radius: 4px;\n    "], ["\n      border-radius: 4px;\n    "])));
});
var AccordionContainerWrapper = styled.div(templateObject_3$u || (templateObject_3$u = __makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var AccordionOption = styled.input(templateObject_4$q || (templateObject_4$q = __makeTemplateObject(["\n  position: absolute;\n  width: 0;\n  height: 0;\n\n  &:checked {\n    + .BaSe--accordion-title {\n      &::after {\n        transform: rotate(180deg);\n      }\n    }\n    ~ .BaSe--accordion-content {\n      max-height: 10000vh;\n      padding: 1em;\n    }\n  }\n"], ["\n  position: absolute;\n  width: 0;\n  height: 0;\n\n  &:checked {\n    + .BaSe--accordion-title {\n      &::after {\n        transform: rotate(180deg);\n      }\n    }\n    ~ .BaSe--accordion-content {\n      max-height: 10000vh;\n      padding: 1em;\n    }\n  }\n"])));
var AccordionTitle = styled.label.attrs({
    className: 'BaSe--accordion-title',
})(templateObject_7$i || (templateObject_7$i = __makeTemplateObject(["\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  font-size: 21px;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  padding: 1em;\n  cursor: pointer;\n  position: relative;\n\n  color: ", ";\n  border: 1px solid ", ";\n  background: ", ";\n\n  ", "\n\n  ", "\n\n  &::after {\n    will-change: transform;\n    content: url(", ");\n    position: absolute;\n    right: 15px;\n    top: 15px;\n    width: 28px;\n    height: 28px;\n    text-align: center;\n    transition: ", ";\n    filter: ", ";\n  }\n"], ["\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  font-size: 21px;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  padding: 1em;\n  cursor: pointer;\n  position: relative;\n\n  color: ", ";\n  border: 1px solid ", ";\n  background: ", ";\n\n  ", "\n\n  ", "\n\n  &::after {\n    will-change: transform;\n    content: url(", ");\n    position: absolute;\n    right: 15px;\n    top: 15px;\n    width: 28px;\n    height: 28px;\n    text-align: center;\n    transition: ", ";\n    filter: ", ";\n  }\n"])), BaSeTheme.typography.fontFamily, function (_a) {
    var headerColor = _a.headerColor;
    return headerColor;
}, function (_a) {
    var borderHeaderColor = _a.borderHeaderColor;
    return borderHeaderColor;
}, function (_a) {
    var backgroundHeaderColor = _a.backgroundHeaderColor;
    return backgroundHeaderColor;
}, function (_a) {
    var isFirst = _a.isFirst, isSingle = _a.isSingle;
    return isFirst &&
        !isSingle && css(templateObject_5$n || (templateObject_5$n = __makeTemplateObject(["\n      border-radius: 4px 4px 0px 0px;\n    "], ["\n      border-radius: 4px 4px 0px 0px;\n    "])));
}, function (_a) {
    var isLast = _a.isLast, isSingle = _a.isSingle, isOpen = _a.isOpen;
    return !isSingle &&
        !isOpen &&
        isLast && css(templateObject_6$m || (templateObject_6$m = __makeTemplateObject(["\n      border-radius: 0px 0px 4px 4px;\n    "], ["\n      border-radius: 0px 0px 4px 4px;\n    "])));
}, getImageUrl(), BaSeTheme.transitions.allPropertiesContinuousFast, function (_a) {
    var headerColor = _a.headerColor;
    return getFilter$1(headerColor);
});
var AccordionContent = styled.div.attrs({
    className: 'BaSe--accordion-content',
})(templateObject_8$h || (templateObject_8$h = __makeTemplateObject(["\n  will-change: max-height, padding;\n  overflow: hidden;\n  background: ", ";\n  box-sizing: border-box;\n  box-shadow: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  font-size: 19px;\n  line-height: 23px;\n  color: ", ";\n  max-height: 0;\n  padding: 0 1em;\n  transition: ", ";\n"], ["\n  will-change: max-height, padding;\n  overflow: hidden;\n  background: ", ";\n  box-sizing: border-box;\n  box-shadow: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  font-size: 19px;\n  line-height: 23px;\n  color: ", ";\n  max-height: 0;\n  padding: 0 1em;\n  transition: ", ";\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var shadow = _a.shadow;
    return shadow;
}, BaSeTheme.typography.fontFamily, BaSeTheme.colors.institucionais.cinzaSebrae30, BaSeTheme.transitions.allPropertiesContinuousFast);
var templateObject_1$I, templateObject_2$C, templateObject_3$u, templateObject_4$q, templateObject_5$n, templateObject_6$m, templateObject_7$i, templateObject_8$h;

var idSequence$8 = idGenerator();
var BaSeAccordion = function (_a) {
    var _b = _a.options, options = _b === void 0 ? [] : _b, _c = _a.backgroundTitleColor, backgroundTitleColor = _c === void 0 ? BaSeTheme.colors.defaultColors.white : _c, _d = _a.backgroundContentColor, backgroundContentColor = _d === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae97 : _d, _e = _a.titleColor, titleColor = _e === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae45 : _e, _f = _a.borderTitleColor, borderTitleColor = _f === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae97 : _f, _g = _a.shadow, shadow = _g === void 0 ? BaSeTheme.shadows.profundidade2 : _g, _h = _a.multipleOpen, multipleOpen = _h === void 0 ? false : _h, initialStartOpen = _a.startOpen;
    var startOpen = React.useMemo(function () {
        return Array.isArray(initialStartOpen)
            ? initialStartOpen
            : typeof initialStartOpen === 'number'
                ? [initialStartOpen]
                : undefined;
    }, [initialStartOpen]);
    if (startOpen) {
        if (!multipleOpen && (startOpen === null || startOpen === void 0 ? void 0 : startOpen.length) > 1) {
            throw Error('[BaSeAccordion] Para passar mais de um valor para a propriedade "startOpen", é necessário definir a propriedade "multipleOpen" como true');
        }
        if ((startOpen === null || startOpen === void 0 ? void 0 : startOpen.length) > options.length) {
            throw Error('[BaSeAccordion] Não é possível passar uma quantidade no "startOpen" maior que a quantidade de itens do "Accordion"');
        }
        startOpen.forEach(function (item) {
            if (item > options.length - 1) {
                throw Error('[BaSeAccordion] Não é possível inserir um valor de índice no "startOpen" que não existe no "Accordion"');
            }
        });
    }
    var _j = React.useState([]), selecteds = _j[0], setSelecteds = _j[1];
    var ids = React.useMemo(function () {
        return options.reduce(function (acc, _a) {
            var _b;
            var title = _a.title;
            return (__assign(__assign({}, acc), (_b = {}, _b[title] = getNextHash(idSequence$8), _b)));
        }, {});
    }, [options]);
    React.useEffect(function () {
        setSelecteds(startOpen !== undefined ? startOpen : []);
    }, [startOpen]);
    return (React.createElement(AccordionContainer, { shadow: shadow, isSingle: options.length === 1 }, options.map(function (data, index) { return (React.createElement(AccordionContainerWrapper, { key: ids[data.title] },
        multipleOpen || options.length === 1 ? (React.createElement(AccordionOption, { type: "checkbox", id: ids[data.title], checked: selecteds.includes(index), onChange: function () {
                return setSelecteds(function (values) {
                    return values.includes(index)
                        ? values.filter(function (item) { return item !== index; })
                        : __spreadArray(__spreadArray([], values, true), [index], false);
                });
            } })) : (React.createElement(AccordionOption, { type: "radio", name: "option", id: ids[data.title], checked: selecteds.includes(index), onChange: function () { }, onClick: function () {
                setSelecteds(function (values) {
                    return values.includes(index) ? [] : [index];
                });
            } })),
        React.createElement(AccordionTitle, { htmlFor: ids[data.title], isFirst: index === 0, isLast: index === options.length - 1, isSingle: options.length === 1, isOpen: selecteds.includes(index), headerColor: titleColor, borderHeaderColor: borderTitleColor, backgroundHeaderColor: backgroundTitleColor }, data.title),
        React.createElement(AccordionContent, { backgroundColor: backgroundContentColor, shadow: shadow }, data.content))); })));
};
BaSeAccordion.displayName = 'BaSeAccordion';

var BaSeFooter = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.links, links = _f === void 0 ? [] : _f, _g = _a.systemName, systemName = _g === void 0 ? '' : _g, _h = _a.systemVersion, systemVersion = _h === void 0 ? '' : _h, relationText = _a.relationText, _j = _a.relationLink, relationLink = _j === void 0 ? {} : _j, collapsedHeader = _a.collapsedHeader, _k = _a.collapsedHeaderColor, collapsedHeaderColor = _k === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _k, _l = _a.backgroundColor, backgroundColor = _l === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae97 : _l, _m = _a.linkColor, linkColor = _m === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _m, _o = _a.textColor, textColor = _o === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae60 : _o, _p = _a.versionColor, versionColor = _p === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae75 : _p, _q = _a.separatorColor, separatorColor = _q === void 0 ? BaSeTheme.colors.gestao.cinza85 : _q, _r = _a.collapsedBreakpoint, collapsedBreakpoint = _r === void 0 ? 'onTablet' : _r, _s = _a.delimitedOnBreakpoint, delimitedOnBreakpoint = _s === void 0 ? 'desktop' : _s;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    if (relationText === undefined) {
        relationText = getMessage('footer.relationText');
    }
    if (collapsedHeader === undefined) {
        collapsedHeader = getMessage('footer.collapsedHeader');
    }
    var _t = React.useState(false), menuDisplay = _t[0], setMenuDisplay = _t[1];
    var showModal = React.useContext(BaSeDialogContext).showModal;
    useMenuItemsShrink(setMenuDisplay, collapsedBreakpoint);
    var Link = function (props) {
        var _a;
        return (React.createElement(FooterLink, { as: props.modal ? undefined : 'a', linkColor: linkColor, onClick: function () { return (props.modal ? showModal(props.modal) : undefined); }, href: (_a = props.link) !== null && _a !== void 0 ? _a : undefined }, props.label));
    };
    var Items = function () { return (React.createElement(FooterLinks, { direction: menuDisplay ? 'column' : 'row' }, links.map(function (item) {
        if (!item.modal && !item.link) {
            throw Error("item '".concat(item.label, "' deve ter link ou modal"));
        }
        return (React.createElement(Link, { key: item.label, label: item.label, link: item.link, modal: item.modal }));
    }))); };
    var Text = function () { return (React.createElement(TextFooter, { direction: menuDisplay ? 'column' : 'row' },
        React.createElement(YearText, { textColor: textColor },
            getMessage('system.sebrae'),
            " ",
            new Date().getFullYear(),
            " -",
            ' ',
            getMessage('system.rights')),
        React.createElement(SystemFooter, { versionColor: versionColor },
            systemName,
            " ",
            getMessage('footer.system.version'),
            " ",
            systemVersion))); };
    return (React.createElement(FooterWrapper, { backgroundColor: backgroundColor }, !menuDisplay ? (React.createElement(FooterContent, null,
        React.createElement(BaSeGrid, { delimitedOnBreakpoint: delimitedOnBreakpoint },
            React.createElement(BaSeGridItem, { size: 12 },
                React.createElement(TextFooter, { direction: menuDisplay ? 'column' : 'row' },
                    React.createElement(Items, null),
                    React.createElement(RelationFooter, { direction: menuDisplay ? 'column' : 'row' },
                        React.createElement(YearText, { textColor: textColor },
                            relationText,
                            React.createElement(Link, { key: relationLink.label, label: (_b = relationLink.label) !== null && _b !== void 0 ? _b : '0800 570 0800', modal: relationLink.modal, link: (_c = relationLink.link) !== null && _c !== void 0 ? _c : 'tel:08005700800' })))))),
        React.createElement(Line, { separatorColor: separatorColor }),
        React.createElement(BaSeGrid, { delimitedOnBreakpoint: delimitedOnBreakpoint },
            React.createElement(BaSeGridItem, { size: 12 },
                React.createElement(Text, null))))) : (React.createElement(React.Fragment, null,
        React.createElement(CollapsedUpperFooter, null,
            React.createElement(BaSeAccordion, { options: [
                    {
                        content: (React.createElement(React.Fragment, null,
                            React.createElement(Items, null),
                            React.createElement(Separator, { separatorColor: separatorColor }))),
                        title: collapsedHeader,
                    },
                ], backgroundTitleColor: collapsedHeaderColor, titleColor: BaSeTheme.colors.defaultColors.white, borderTitleColor: collapsedHeaderColor, backgroundContentColor: backgroundColor, shadow: "none" })),
        React.createElement(CollapsedSubFooter, null,
            React.createElement(RelationFooter, { direction: menuDisplay ? 'column' : 'row' },
                React.createElement(YearText, { textColor: textColor },
                    relationText,
                    React.createElement(Link, { key: relationLink.label, label: (_d = relationLink.label) !== null && _d !== void 0 ? _d : '0800 570 0800', modal: relationLink.modal, link: (_e = relationLink.link) !== null && _e !== void 0 ? _e : 'tel:08005700800' }))),
            React.createElement(Text, null))))));
};
BaSeFooter.displayName = 'BaSeFooter';

var BaSeStepContent = function (_a) {
    var canGotoNext = _a.canGotoNext, canGotoPrev = _a.canGotoPrev, content = _a.content, onNext = _a.onNext, onPrev = _a.onPrev, gotoStep = _a.gotoStep;
    return (React.createElement(React.Fragment, null, content({
        gotoPrev: onPrev,
        gotoNext: onNext,
        canGotoPrev: canGotoPrev,
        canGotoNext: canGotoNext,
        gotoStep: gotoStep,
    })));
};
BaSeStepContent.displayName = 'BaSeStepContent';

var cache = {};
var transformLightness = function (color, lightness) {
    var cacheKey = "".concat(color, "_").concat(lightness);
    try {
        if (cache.hasOwnProperty(cacheKey)) {
            return cache[cacheKey];
        }
        var colorInstance = Color.generate(color);
        var newColor = colorInstance.applyLightColor(function () { return lightness; }).toString();
        cache[cacheKey] = newColor;
        return newColor;
    }
    catch (error) {
        return color;
    }
};

function lighting$1(color, lightness) {
    return transformLightness(color, lightness);
}
function darking$1(color) {
    return transformLightness(color, 0.3);
}
function getFilter(color) {
    return transformToFilter(color);
}
var slideIn$1 = function (origin) { return keyframes(templateObject_1$H || (templateObject_1$H = __makeTemplateObject(["\n  from {\n    transform: translateX(", "%);\n    opacity: 0.9;\n  }\n  to {\n    opacity: 1;\n  }\n"], ["\n  from {\n    transform: translateX(", "%);\n    opacity: 0.9;\n  }\n  to {\n    opacity: 1;\n  }\n"])), origin); };
var fade = function (from) {
    if (from === void 0) { from = 0; }
    return keyframes(templateObject_2$B || (templateObject_2$B = __makeTemplateObject(["\n  from {\n    opacity: ", ";\n    transform: scale(1.3);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n"], ["\n  from {\n    opacity: ", ";\n    transform: scale(1.3);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n"])), from);
};
var StepperContainer = styled.div(templateObject_3$t || (templateObject_3$t = __makeTemplateObject(["\n  display: flex;\n  gap: 30px;\n  flex-direction: ", ";\n"], ["\n  display: flex;\n  gap: 30px;\n  flex-direction: ", ";\n"])), function (_a) {
    var orientation = _a.orientation;
    return orientation === 'horizontal' ? 'column' : 'row';
});
var StepsContainer = styled.ul(templateObject_4$p || (templateObject_4$p = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  box-sizing: border-box;\n  gap: 10px;\n  margin: 0;\n  padding: 0;\n  align-items: flex-start;\n  height: 100%;\n  width: 100%;\n\n  flex-direction: ", ";\n"], ["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  box-sizing: border-box;\n  gap: 10px;\n  margin: 0;\n  padding: 0;\n  align-items: flex-start;\n  height: 100%;\n  width: 100%;\n\n  flex-direction: ", ";\n"])), function (_a) {
    var orientation = _a.orientation;
    return orientation === 'horizontal' ? 'row' : 'column';
});
var StepContainer = styled.li(templateObject_11$a || (templateObject_11$a = __makeTemplateObject(["\n  flex: 1;\n  display: grid;\n  place-items: ", ";\n  position: relative;\n\n  &::before,\n  &::after {\n    content: '';\n    position: absolute;\n    ", "\n    z-index: ", ";\n  }\n\n  &::before {\n    background-color: ", ";\n    ", "\n  }\n\n  &::after {\n    transition: ", ";\n    background-color: ", ";\n    ", "\n    will-change: width;\n  }\n\n  &:last-child::before,\n  &:last-child::after {\n    content: none;\n  }\n"], ["\n  flex: 1;\n  display: grid;\n  place-items: ", ";\n  position: relative;\n\n  &::before,\n  &::after {\n    content: '';\n    position: absolute;\n    ", "\n    z-index: ", ";\n  }\n\n  &::before {\n    background-color: ", ";\n    ", "\n  }\n\n  &::after {\n    transition: ", ";\n    background-color: ", ";\n    ", "\n    will-change: width;\n  }\n\n  &:last-child::before,\n  &:last-child::after {\n    content: none;\n  }\n"])), function (_a) {
    var orientation = _a.orientation;
    return orientation === 'horizontal' ? 'center' : 'start';
}, function (_a) {
    var orientation = _a.orientation;
    return orientation === 'horizontal'
        ? css(templateObject_5$m || (templateObject_5$m = __makeTemplateObject(["\n            transform: translateX(20px);\n            width: calc(100% - 30px);\n            height: 1.5px;\n            top: 19px;\n            left: 50%;\n          "], ["\n            transform: translateX(20px);\n            width: calc(100% - 30px);\n            height: 1.5px;\n            top: 19px;\n            left: 50%;\n          "]))) : css(templateObject_6$l || (templateObject_6$l = __makeTemplateObject(["\n            width: 1.5px;\n            height: calc(100% - 31px);\n            transform: translateY(24px);\n            top: 15px;\n            left: 24px;\n          "], ["\n            width: 1.5px;\n            height: calc(100% - 31px);\n            transform: translateY(24px);\n            top: 15px;\n            left: 24px;\n          "])));
}, BaSeTheme.stackOrder.normal + 1, function (_a) {
    var isActive = _a.isActive, activeColor = _a.activeColor, incompletedColor = _a.incompletedColor;
    return isActive ? activeColor : lighting$1(incompletedColor, 0.75);
}, function (_a) {
    var orientation = _a.orientation, isActive = _a.isActive, isCompleted = _a.isCompleted;
    return orientation === 'horizontal'
        ? css(templateObject_7$h || (templateObject_7$h = __makeTemplateObject(["\n            width: ", ";\n          "], ["\n            width: ", ";\n          "])), !isCompleted || isActive ? 'calc(100% - 30px)' : '0') : css(templateObject_8$g || (templateObject_8$g = __makeTemplateObject(["\n            height: ", ";\n          "], ["\n            height: ", ";\n          "])), !isCompleted || isActive ? 'calc(100% - 31px)' : '0');
}, BaSeTheme.transitions.allPropertiesContinuousNormal, function (_a) {
    var completedColor = _a.completedColor;
    return lighting$1(completedColor, 0.75);
}, function (_a) {
    var orientation = _a.orientation, isCompleted = _a.isCompleted;
    return orientation === 'horizontal'
        ? css(templateObject_9$f || (templateObject_9$f = __makeTemplateObject(["\n            width: ", ";\n          "], ["\n            width: ", ";\n          "])), isCompleted ? 'calc(100% - 30px)' : '0') : css(templateObject_10$c || (templateObject_10$c = __makeTemplateObject(["\n            height: ", ";\n          "], ["\n            height: ", ";\n          "])), isCompleted ? 'calc(100% - 31px)' : '0');
});
var StepItem = styled.button(templateObject_16$4 || (templateObject_16$4 = __makeTemplateObject(["\n  appearance: none;\n  background: ", ";\n  border: none;\n  cursor: ", ";\n  ", ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  &:hover,\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n\n  ", ";\n\n  &:disabled {\n    div {\n      border-color: ", ";\n      background: ", ";\n    }\n  }\n  span {\n    small {\n      color: ", ";\n    }\n  }\n"], ["\n  appearance: none;\n  background: ", ";\n  border: none;\n  cursor: ", ";\n  ", ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  &:hover,\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n\n  ", ";\n\n  &:disabled {\n    div {\n      border-color: ", ";\n      background: ", ";\n    }\n  }\n  span {\n    small {\n      color: ", ";\n    }\n  }\n"])), BaSeTheme.colors.defaultColors.transparent, function (_a) {
    var disabled = _a.disabled, isClickable = _a.isClickable;
    return disabled ? 'not-allowed' : isClickable ? 'pointer' : 'default';
}, function (_a) {
    var isClickable = _a.isClickable;
    return !isClickable && css(templateObject_12$9 || (templateObject_12$9 = __makeTemplateObject(["\n      pointer-events: none;\n    "], ["\n      pointer-events: none;\n    "])));
}, function (_a) {
    var orientation = _a.orientation;
    return orientation === 'horizontal'
        ? css(templateObject_13$8 || (templateObject_13$8 = __makeTemplateObject(["\n          flex-direction: column;\n          justify-content: center;\n        "], ["\n          flex-direction: column;\n          justify-content: center;\n        "]))) : css(templateObject_14$8 || (templateObject_14$8 = __makeTemplateObject(["\n          flex-direction: row;\n          justify-content: flex-start;\n        "], ["\n          flex-direction: row;\n          justify-content: flex-start;\n        "])));
}, function (_a) {
    var disabled = _a.disabled, isClickable = _a.isClickable, isActive = _a.isActive, activeColor = _a.activeColor;
    return !disabled &&
        !isActive &&
        isClickable && css(templateObject_15$6 || (templateObject_15$6 = __makeTemplateObject(["\n      &:focus:not(:hover) {\n        div {\n          box-shadow: 0px 0px 5px 0px ", ";\n          border-color: ", ";\n        }\n        span,\n        small {\n          color: ", ";\n          img {\n            opacity: 0.9;\n            animation: ", " ", "\n              ", " 0.5 forwards;\n            filter: ", ";\n          }\n        }\n      }\n\n      &:hover {\n        div {\n          background: ", ";\n          border-color: ", ";\n        }\n        span,\n        small {\n          color: ", ";\n          img {\n            opacity: 0.9;\n            animation: ", " ", "\n              ", " 0.5 forwards;\n            filter: ", ";\n          }\n        }\n      }\n    "], ["\n      &:focus:not(:hover) {\n        div {\n          box-shadow: 0px 0px 5px 0px ", ";\n          border-color: ", ";\n        }\n        span,\n        small {\n          color: ", ";\n          img {\n            opacity: 0.9;\n            animation: ", " ", "\n              ", " 0.5 forwards;\n            filter: ", ";\n          }\n        }\n      }\n\n      &:hover {\n        div {\n          background: ", ";\n          border-color: ", ";\n        }\n        span,\n        small {\n          color: ", ";\n          img {\n            opacity: 0.9;\n            animation: ", " ", "\n              ", " 0.5 forwards;\n            filter: ", ";\n          }\n        }\n      }\n    "])), lighting$1(activeColor, 0.75), activeColor, activeColor, fade(0.9), BaSeTheme.transitions.durationFast, BaSeTheme.transitions.durationFast, getFilter(activeColor), lighting$1(activeColor, 0.97), darking$1(activeColor), darking$1(activeColor), fade(0.9), BaSeTheme.transitions.durationFast, BaSeTheme.transitions.durationFast, getFilter(darking$1(activeColor)));
}, BaSeTheme.colors.institucionais.cinzaSebrae90, BaSeTheme.colors.institucionais.cinzaSebrae90, BaSeTheme.colors.institucionais.cinzaSebrae75);
var StepCircleHeader = styled.div(templateObject_17$3 || (templateObject_17$3 = __makeTemplateObject(["\n  height: 32px;\n  width: 32px;\n  max-height: 32px;\n  max-width: 32px;\n  min-height: 32px;\n  min-width: 32px;\n  border: 2px solid ", ";\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background-color: ", ";\n  flex-basis: 50px;\n  transition: ", ";\n  z-index: ", ";\n  border-color: ", ";\n"], ["\n  height: 32px;\n  width: 32px;\n  max-height: 32px;\n  max-width: 32px;\n  min-height: 32px;\n  min-width: 32px;\n  border: 2px solid ", ";\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background-color: ", ";\n  flex-basis: 50px;\n  transition: ", ";\n  z-index: ", ";\n  border-color: ", ";\n"])), BaSeTheme.colors.defaultColors.transparent, BaSeTheme.colors.defaultColors.transparent, "\n    ".concat(BaSeTheme.transitions.allPropertiesContinuousFast, "\n    ").concat(BaSeTheme.transitions.durationFast, "\n  "), BaSeTheme.stackOrder.normal + 1, function (_a) {
    var isActive = _a.isActive, isCompleted = _a.isCompleted, activeColor = _a.activeColor, completedColor = _a.completedColor, incompletedColor = _a.incompletedColor;
    return isActive
        ? activeColor
        : lighting$1((isCompleted ? completedColor : incompletedColor), 0.75);
});
var FadableItem = styled.span(templateObject_18$3 || (templateObject_18$3 = __makeTemplateObject(["\n  opacity: 0;\n  animation: ", " ", "\n    ", " 1 forwards;\n"], ["\n  opacity: 0;\n  animation: ", " ", "\n    ", " 1 forwards;\n"])), fade(), BaSeTheme.transitions.durationFast, BaSeTheme.transitions.durationFast);
var CustomTooltip = styled.div(templateObject_19$3 || (templateObject_19$3 = __makeTemplateObject(["\n  width: 100%;\n  visibility: hidden;\n  background-color: #fff;\n  padding: 10px;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n  opacity: 0;\n  transition: opacity 0.5s ease;\n"], ["\n  width: 100%;\n  visibility: hidden;\n  background-color: #fff;\n  padding: 10px;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n  opacity: 0;\n  transition: opacity 0.5s ease;\n"])));
var StepText = styled(FadableItem)(templateObject_20$3 || (templateObject_20$3 = __makeTemplateObject(["\n  text-align: ", ";\n\n  & > div > [class*='BaSe'] {\n    display: -webkit-box;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n\n    transition: ", ";\n    color: ", ";\n  }\n\n  &:hover + ", " {\n    visibility: visible;\n    transition: opacity 0.5s ease;\n    opacity: 1;\n  }\n"], ["\n  text-align: ", ";\n\n  & > div > [class*='BaSe'] {\n    display: -webkit-box;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n\n    transition: ", ";\n    color: ", ";\n  }\n\n  &:hover + ", " {\n    visibility: visible;\n    transition: opacity 0.5s ease;\n    opacity: 1;\n  }\n"])), function (_a) {
    var orientation = _a.orientation;
    return orientation === 'horizontal' ? 'center' : 'start';
}, "".concat(BaSeTheme.transitions.allPropertiesContinuousFast, " ").concat(BaSeTheme.transitions.durationFast), function (_a) {
    var isActive = _a.isActive, isCompleted = _a.isCompleted, activeColor = _a.activeColor, completedColor = _a.completedColor, incompletedColor = _a.incompletedColor;
    return isActive ? activeColor : isCompleted ? completedColor : incompletedColor;
}, CustomTooltip);
var StepperContent = styled(FadableItem)(templateObject_22$2 || (templateObject_22$2 = __makeTemplateObject(["\n  overflow: hidden;\n  ", ";\n"], ["\n  overflow: hidden;\n  ", ";\n"])), function (_a) {
    var orientation = _a.orientation;
    return orientation === 'vertical' && css(templateObject_21$3 || (templateObject_21$3 = __makeTemplateObject(["\n      padding-left: 64px;\n    "], ["\n      padding-left: 64px;\n    "])));
});
var StepContentTransition = styled.div(templateObject_24$2 || (templateObject_24$2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var transition = _a.transition;
    return transition !== 'inert' && css(templateObject_23$2 || (templateObject_23$2 = __makeTemplateObject(["\n      animation: ", "\n        ", "\n        ", ";\n    "], ["\n      animation: ", "\n        ", "\n        ", ";\n    "])), slideIn$1(transition === 'leftToRight' ? -100 : 100), BaSeTheme.transitions.durationFast, BaSeTheme.transitions.continuousTimingFunction);
});
var templateObject_1$H, templateObject_2$B, templateObject_3$t, templateObject_4$p, templateObject_5$m, templateObject_6$l, templateObject_7$h, templateObject_8$g, templateObject_9$f, templateObject_10$c, templateObject_11$a, templateObject_12$9, templateObject_13$8, templateObject_14$8, templateObject_15$6, templateObject_16$4, templateObject_17$3, templateObject_18$3, templateObject_19$3, templateObject_20$3, templateObject_21$3, templateObject_22$2, templateObject_23$2, templateObject_24$2;

var getContent = function (orientation, transition, steps, currentStep, onStepChange) {
    var _a, _b, _c, _d;
    var content = steps[currentStep - 1].content;
    if (typeof content === 'function') {
        return (React.createElement(StepperContent, { as: "section", className: "BaSe--stepper-content", orientation: orientation },
            React.createElement(StepContentTransition, { transition: transition },
                React.createElement(BaSeStepContent, { content: content, canGotoNext: currentStep < steps.length &&
                        ((_b = !((_a = steps === null || steps === void 0 ? void 0 : steps[currentStep]) === null || _a === void 0 ? void 0 : _a.isDisabled)) !== null && _b !== void 0 ? _b : true), canGotoPrev: currentStep > 1 && ((_d = !((_c = steps === null || steps === void 0 ? void 0 : steps[currentStep - 2]) === null || _c === void 0 ? void 0 : _c.isDisabled)) !== null && _d !== void 0 ? _d : true), gotoStep: onStepChange, onNext: function () { return onStepChange(currentStep + 1); }, onPrev: function () { return onStepChange(currentStep - 1); } }))));
    }
    return;
};
var BaSeStepHeader = function (_a) {
    var _b;
    var steps = _a.steps, transition = _a.transition, title = _a.title, _c = _a.tooltip, tooltip = _c === void 0 ? 'none' : _c, currentStep = _a.currentStep, isActive = _a.isActive, isCompleted = _a.isCompleted, _d = _a.activeColor, activeColor = _d === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _d, _e = _a.completedColor, completedColor = _e === void 0 ? BaSeTheme.colors.feedbackInterface.sucesso45 : _e, _f = _a.incompletedColor, incompletedColor = _f === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae45 : _f, orientation = _a.orientation, _g = _a.isDisabled, isDisabled = _g === void 0 ? false : _g, _h = _a.isClickable, isClickable = _h === void 0 ? true : _h, onActived = _a.onActived, onStepChange = _a.onStepChange;
    var _j = React.useState(false), isTooltipOpen = _j[0], setIsTooltipOpen = _j[1];
    var itemRef = React.useRef(null);
    var renderText = React.useCallback(function (stringOrList) {
        var texts = !Array.isArray(stringOrList)
            ? [stringOrList]
            : stringOrList;
        return (React.createElement(StepText, { isActive: isActive, isCompleted: isCompleted, activeColor: activeColor, completedColor: completedColor, incompletedColor: incompletedColor, orientation: orientation },
            React.createElement("div", null, texts.map(function (text) { return text && React.createElement(BaSeSmall1, null, text); }))));
    }, [
        isActive,
        isCompleted,
        orientation,
        activeColor,
        completedColor,
        incompletedColor,
    ]);
    return (React.createElement(StepContainer, { className: "BaSe--stepper-header", isActive: isActive, isCompleted: isCompleted, activeColor: activeColor, completedColor: completedColor, incompletedColor: incompletedColor, orientation: orientation },
        React.createElement(StepItem, { ref: itemRef, isActive: isActive, isCompleted: isCompleted, activeColor: activeColor, completedColor: completedColor, incompletedColor: incompletedColor, onMouseEnter: function () { return setIsTooltipOpen(true); }, onMouseLeave: function () { return setIsTooltipOpen(false); }, disabled: isDisabled, isClickable: isClickable, onClick: function () { return onActived(); }, role: isClickable ? 'button' : 'heading', tabIndex: isClickable ? 0 : -1, orientation: orientation },
            React.createElement(StepCircleHeader, { activeColor: activeColor, completedColor: completedColor, incompletedColor: incompletedColor, isActive: isActive, isCompleted: isCompleted }, !isCompleted ? (renderText((_b = currentStep === null || currentStep === void 0 ? void 0 : currentStep.toString) === null || _b === void 0 ? void 0 : _b.call(currentStep))) : (React.createElement(FadableItem, null,
                React.createElement(BaSeI18nConsumer, null, function (_a) {
                    var getMessage = _a.getMessage;
                    return (React.createElement(BaSeIcon, { name: "check", description: getMessage("stepCurrent.description", currentStep.toString()), color: isActive ? activeColor : completedColor, colorTransition: "fast", size: 24 }));
                })))),
            renderText(title)),
        tooltip !== 'none' && title && (React.createElement(BaSeTooltip, { buddyRef: itemRef, color: "outlined", direction: tooltip, message: title, open: isTooltipOpen })),
        isActive &&
            orientation === 'vertical' &&
            getContent(orientation, transition, steps, currentStep, onStepChange)));
};
BaSeStepHeader.displayName = 'BaSeStepHeader';

var BaSeStepper = function (_a) {
    var initialStepper = _a.steps, activeColor = _a.activeColor, completedColor = _a.completedColor, incompletedColor = _a.incompletedColor, _b = _a.currentStep, currentStep = _b === void 0 ? 1 : _b, _c = _a.orientation, orientation = _c === void 0 ? 'horizontal' : _c, _d = _a.withTransition, withTransition = _d === void 0 ? false : _d, onStepChange = _a.onStepChange;
    var _e = React.useState(currentStep), lastActivatedTabIndex = _e[0], setLastActivatedTabIndex = _e[1];
    var _f = React.useState('inert'), transition = _f[0], setTransition = _f[1];
    var steps = React.useMemo(function () {
        if (typeof initialStepper === 'number') {
            return Array(initialStepper).fill({});
        }
        return initialStepper;
    }, [initialStepper]);
    if (!Array.isArray(steps) || (steps === null || steps === void 0 ? void 0 : steps.length) === 0) {
        throw Error('Prop "steps" é obrigatória');
    }
    if (!onStepChange) {
        throw Error('Prop "onStepChange" é obrigatória');
    }
    React.useEffect(function () {
        onStepChange(currentStep);
        if (withTransition) {
            setTransition(function () {
                return lastActivatedTabIndex < currentStep ? 'leftToRight' : 'rightToLeft';
            });
            setTimeout(function () {
                setTransition(function () { return 'inert'; });
            }, BaSeTheme.transitions.durationNormalInMilliseconds);
        }
        setLastActivatedTabIndex(currentStep);
    }, [currentStep]);
    return (React.createElement(StepperContainer, { className: "BaSe--stepper", orientation: orientation },
        React.createElement("nav", null,
            React.createElement(StepsContainer, { className: "BaSe--stepper-container", orientation: orientation }, steps.map(function (_a, index) {
                var title = _a.title, isDisabled = _a.isDisabled, isClickable = _a.isClickable, isCompleted = _a.isCompleted, tooltip = _a.tooltip;
                return (React.createElement(React.Fragment, { key: index },
                    React.createElement(BaSeStepHeader, { steps: steps, isDisabled: isDisabled, isClickable: isClickable, tooltip: tooltip, title: title, currentStep: index + 1, activeColor: activeColor, completedColor: completedColor, incompletedColor: incompletedColor, isActive: currentStep === index + 1, isCompleted: isCompleted !== null && isCompleted !== void 0 ? isCompleted : currentStep > index + 1, orientation: orientation, onActived: function () { return onStepChange(index + 1); }, onStepChange: onStepChange, transition: transition })));
            }))),
        orientation === 'horizontal' &&
            getContent(orientation, transition, steps, currentStep, onStepChange)));
};
BaSeStepper.displayName = 'BaSeStepper';

function lighting(color) {
    return transformLightness(color, 0.97);
}
function darking(color) {
    return transformLightness(color, 0.3);
}
var sidePadding = 8;
var slideIn = function (origin) { return keyframes(templateObject_1$G || (templateObject_1$G = __makeTemplateObject(["\n  from {\n    transform: translateX(", "%);\n    opacity: 0.9;\n  }\n  to {\n    opacity: 1;\n  }\n"], ["\n  from {\n    transform: translateX(", "%);\n    opacity: 0.9;\n  }\n  to {\n    opacity: 1;\n  }\n"])), origin); };
var TabsContainer = styled.div(templateObject_2$A || (templateObject_2$A = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var TabSeparator = styled.hr(templateObject_5$l || (templateObject_5$l = __makeTemplateObject(["\n  margin: 0;\n  width: 100%;\n  height: 1px;\n  border: none;\n  overflow: visible;\n  position: relative;\n  background-color: ", ";\n\n  &::before,\n  &::after {\n    content: '';\n    top: 0;\n    left: 0;\n    height: 4px;\n    position: absolute;\n    background: ", ";\n    z-index: ", ";\n  }\n\n  &::before {\n    transition: ", ";\n    will-change: transform, width;\n    ", "\n  }\n\n  &::after {\n    ", ";\n  }\n"], ["\n  margin: 0;\n  width: 100%;\n  height: 1px;\n  border: none;\n  overflow: visible;\n  position: relative;\n  background-color: ", ";\n\n  &::before,\n  &::after {\n    content: '';\n    top: 0;\n    left: 0;\n    height: 4px;\n    position: absolute;\n    background: ", ";\n    z-index: ", ";\n  }\n\n  &::before {\n    transition: ", ";\n    will-change: transform, width;\n    ", "\n  }\n\n  &::after {\n    ", ";\n  }\n"])), BaSeTheme.colors.institucionais.cinzaSebrae90, function (_a) {
    var activeColor = _a.activeColor;
    return activeColor;
}, BaSeTheme.stackOrder.normal, BaSeTheme.transitions.allPropertiesContinuousNormal, function (_a) {
    var activeLeft = _a.activeLeft, activeWidth = _a.activeWidth;
    return css(templateObject_3$s || (templateObject_3$s = __makeTemplateObject(["\n      transform: translateX(", "px);\n      width: ", "px;\n    "], ["\n      transform: translateX(", "px);\n      width: ", "px;\n    "])), activeLeft, activeWidth);
}, function (_a) {
    var destakLeft = _a.destakLeft, destakWidth = _a.destakWidth;
    return css(templateObject_4$o || (templateObject_4$o = __makeTemplateObject(["\n      transform: translateX(", "px);\n      width: ", "px;\n    "], ["\n      transform: translateX(", "px);\n      width: ", "px;\n    "])), destakLeft, destakWidth);
});
var TabHeader = styled.ul(templateObject_6$k || (templateObject_6$k = __makeTemplateObject(["\n  display: flex;\n  gap: 24px;\n  align-items: flex-end;\n  position: relative;\n\n  overflow-y: hidden;\n  overscroll-behavior-x: contain;\n  scroll-snap-type: x mandatory;\n  flex-shrink: 0;\n  min-block-size: fit-content;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"], ["\n  display: flex;\n  gap: 24px;\n  align-items: flex-end;\n  position: relative;\n\n  overflow-y: hidden;\n  overscroll-behavior-x: contain;\n  scroll-snap-type: x mandatory;\n  flex-shrink: 0;\n  min-block-size: fit-content;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"])));
var TabContent = styled.div(templateObject_8$f || (templateObject_8$f = __makeTemplateObject(["\n  position: relative;\n  ", ";\n"], ["\n  position: relative;\n  ", ";\n"])), function (_a) {
    var transition = _a.transition;
    return transition !== 'inert' && css(templateObject_7$g || (templateObject_7$g = __makeTemplateObject(["\n      animation: ", "\n        ", "\n        ", ";\n    "], ["\n      animation: ", "\n        ", "\n        ", ";\n    "])), slideIn(transition === 'leftToRight' ? -100 : 100), BaSeTheme.transitions.durationNormal, BaSeTheme.transitions.continuousTimingFunction);
});
var TabContainer = styled.li(templateObject_9$e || (templateObject_9$e = __makeTemplateObject([""], [""])));
var TabItem = styled.button(templateObject_11$9 || (templateObject_11$9 = __makeTemplateObject(["\n  appearance: none;\n  background: ", ";\n  border: none;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: ", "px;\n  white-space: nowrap;\n  scroll-snap-align: start;\n  cursor: ", ";\n\n  &:hover,\n  &:focus {\n    outline: none;\n    ", ";\n  }\n"], ["\n  appearance: none;\n  background: ", ";\n  border: none;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: ", "px;\n  white-space: nowrap;\n  scroll-snap-align: start;\n  cursor: ", ";\n\n  &:hover,\n  &:focus {\n    outline: none;\n    ", ";\n  }\n"])), BaSeTheme.colors.defaultColors.transparent, sidePadding, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var isActive = _a.isActive, inactiveColor = _a.inactiveColor;
    return !isActive && css(templateObject_10$b || (templateObject_10$b = __makeTemplateObject(["\n        h5 {\n          color: ", ";\n        }\n        background: ", ";\n      "], ["\n        h5 {\n          color: ", ";\n        }\n        background: ", ";\n      "])), darking(inactiveColor !== null && inactiveColor !== void 0 ? inactiveColor : ''), lighting(inactiveColor !== null && inactiveColor !== void 0 ? inactiveColor : ''));
});
var templateObject_1$G, templateObject_2$A, templateObject_3$s, templateObject_4$o, templateObject_5$l, templateObject_6$k, templateObject_7$g, templateObject_8$f, templateObject_9$e, templateObject_10$b, templateObject_11$9;

var BaSeTab = function (_a) {
    var title = _a.title, index = _a.index, isActive = _a.isActive, _b = _a.activeColor, activeColor = _b === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _b, _c = _a.inactiveColor, inactiveColor = _c === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae45 : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, onActivatedTabIndex = _a.onActivatedTabIndex, onActiveItem = _a.onActiveItem, onDestakItem = _a.onDestakItem;
    var itemRef = React__default.createRef();
    React__default.useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (isActive) {
            var rectActive = (_a = itemRef === null || itemRef === void 0 ? void 0 : itemRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            if (((_b = rectActive === null || rectActive === void 0 ? void 0 : rectActive.left) !== null && _b !== void 0 ? _b : 0) <= ((_d = (_c = itemRef === null || itemRef === void 0 ? void 0 : itemRef.current) === null || _c === void 0 ? void 0 : _c.offsetLeft) !== null && _d !== void 0 ? _d : 0)) {
                onActiveItem((_e = rectActive === null || rectActive === void 0 ? void 0 : rectActive.left) !== null && _e !== void 0 ? _e : 0, (_f = rectActive === null || rectActive === void 0 ? void 0 : rectActive.width) !== null && _f !== void 0 ? _f : 0);
            }
            else {
                onActiveItem((_h = (_g = itemRef === null || itemRef === void 0 ? void 0 : itemRef.current) === null || _g === void 0 ? void 0 : _g.offsetLeft) !== null && _h !== void 0 ? _h : 0, (_j = rectActive === null || rectActive === void 0 ? void 0 : rectActive.width) !== null && _j !== void 0 ? _j : 0);
            }
            onActivatedTabIndex(index);
        }
    }, [itemRef, isActive]);
    var setDestakItem = React__default.useCallback(function () {
        var _a, _b, _c, _d;
        var rectDestak = (_a = itemRef === null || itemRef === void 0 ? void 0 : itemRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        onDestakItem((_c = (_b = itemRef === null || itemRef === void 0 ? void 0 : itemRef.current) === null || _b === void 0 ? void 0 : _b.offsetLeft) !== null && _c !== void 0 ? _c : 0, (_d = rectDestak === null || rectDestak === void 0 ? void 0 : rectDestak.width) !== null && _d !== void 0 ? _d : 0);
    }, [itemRef]);
    return (React__default.createElement(TabContainer, { className: "BaSe--tab", isActive: isActive },
        React__default.createElement(TabItem, { ref: itemRef, isActive: isActive, disabled: isDisabled, inactiveColor: inactiveColor, onPointerLeave: function () { return !isActive && onDestakItem(0, 0); }, onBlur: function () { return !isActive && onDestakItem(0, 0); }, onFocus: function () { return !isActive && setDestakItem(); }, onPointerEnter: function () { return !isActive && setDestakItem(); }, onClick: function () {
                var _a, _b, _c, _d;
                var rect = (_a = itemRef === null || itemRef === void 0 ? void 0 : itemRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                onDestakItem(0, 0);
                onActiveItem((_c = (_b = itemRef === null || itemRef === void 0 ? void 0 : itemRef.current) === null || _b === void 0 ? void 0 : _b.offsetLeft) !== null && _c !== void 0 ? _c : 0, (_d = rect === null || rect === void 0 ? void 0 : rect.width) !== null && _d !== void 0 ? _d : 0);
                onActivatedTabIndex(index);
            } },
            React__default.createElement(BaSeHeading5, { isBold: isActive ? true : false, color: isActive ? activeColor : inactiveColor }, title))));
};
BaSeTab.displayName = 'BaSeTab';

var BaSeTabContent = function (_a) {
    var canGotoTab = _a.canGotoTab, gotoTab = _a.gotoTab, content = _a.content;
    return React.createElement(React.Fragment, null, content === null || content === void 0 ? void 0 : content({ canGotoTab: canGotoTab, gotoTab: gotoTab }));
};
BaSeTabContent.displayName = 'BaSeTabContent';

var BaSeTabs = function (_a) {
    var _b;
    var tabs = _a.tabs, _c = _a.activeColor, activeColor = _c === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _c, _d = _a.inactiveColor, inactiveColor = _d === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae45 : _d, _e = _a.activatedTabIndex, activatedTabIndex = _e === void 0 ? 0 : _e, _f = _a.withTransition, withTransition = _f === void 0 ? false : _f, onActivatedTabIndex = _a.onActivatedTabIndex;
    var tabsRef = React.createRef();
    var _g = React.useState(activatedTabIndex), lastActivatedTabIndex = _g[0], setLastActivatedTabIndex = _g[1];
    var _h = React.useState(0), activatedTabLeft = _h[0], setActivatedTabLeft = _h[1];
    var _j = React.useState(0), activatedTabWidth = _j[0], setActivatedTabWidth = _j[1];
    var _k = React.useState(0), destakTabLeft = _k[0], setDestakTabLeft = _k[1];
    var _l = React.useState(0), destakTabWidth = _l[0], setDestakTabWidth = _l[1];
    var _m = React.useState('inert'), transition = _m[0], setTransition = _m[1];
    if (!Array.isArray(tabs) || (tabs === null || tabs === void 0 ? void 0 : tabs.length) === 0) {
        throw Error('Prop "tabs" é obrigatória');
    }
    if (!onActivatedTabIndex) {
        throw Error('Prop "onActivatedTabIndex" é obrigatório');
    }
    React.useEffect(function () {
        onActivatedTabIndex(activatedTabIndex);
        if (withTransition) {
            setTransition(function () {
                return lastActivatedTabIndex < activatedTabIndex
                    ? 'leftToRight'
                    : 'rightToLeft';
            });
            setTimeout(function () {
                setTransition(function () { return 'inert'; });
            }, BaSeTheme.transitions.durationNormalInMilliseconds);
        }
        setLastActivatedTabIndex(activatedTabIndex);
    }, [activatedTabIndex]);
    var findIndex = React.useCallback(function (query) {
        var _a;
        return ((_a = query === null || query === void 0 ? void 0 : query.withIndex) !== null && _a !== void 0 ? _a : tabs.findIndex(function (tab) { return tab.title === (query === null || query === void 0 ? void 0 : query.withTitle); }));
    }, [tabs]);
    return (React.createElement(TabsContainer, { className: "BaSe--tabs" },
        React.createElement(TabHeader, { ref: tabsRef, onScroll: function () {
                setActivatedTabLeft(function (actual) { var _a, _b; return actual - ((_b = (_a = tabsRef === null || tabsRef === void 0 ? void 0 : tabsRef.current) === null || _a === void 0 ? void 0 : _a.scrollLeft) !== null && _b !== void 0 ? _b : 0); });
            } }, tabs.map(function (_a, index) {
            var title = _a.title, isDisabled = _a.isDisabled;
            return (React.createElement(React.Fragment, { key: index },
                React.createElement(BaSeTab, { title: title, index: index, activeColor: activeColor, inactiveColor: inactiveColor, isActive: activatedTabIndex === index, isDisabled: isDisabled, onActivatedTabIndex: function (tabIndex) {
                        onActivatedTabIndex(tabIndex);
                    }, onActiveItem: function (tabLeft, tabWidth) {
                        setActivatedTabLeft(tabLeft);
                        setActivatedTabWidth(tabWidth);
                    }, onDestakItem: function (tabLeft, tabWidth) {
                        setDestakTabLeft(tabLeft);
                        setDestakTabWidth(tabWidth);
                    } })));
        })),
        React.createElement(TabSeparator, { activeLeft: activatedTabLeft, activeWidth: activatedTabWidth, activeColor: activeColor, destakLeft: destakTabLeft, destakWidth: destakTabWidth }),
        React.createElement(TabContent, { as: "section", className: "BaSe--tab-content", transition: transition },
            React.createElement(BaSeTabContent, { canGotoTab: function (query) { var _a, _b; return (_b = !((_a = tabs === null || tabs === void 0 ? void 0 : tabs[findIndex(query)]) === null || _a === void 0 ? void 0 : _a.isDisabled)) !== null && _b !== void 0 ? _b : false; }, gotoTab: function (query) { return onActivatedTabIndex(findIndex(query)); }, content: (_b = tabs[activatedTabIndex]) === null || _b === void 0 ? void 0 : _b.content }))));
};
BaSeTabs.displayName = 'BaSeTabs';

var SideMenuMainItem = styled.li(templateObject_3$r || (templateObject_3$r = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var textColor = _a.textColor, hoverTextColor = _a.hoverTextColor, selectedTextColor = _a.selectedTextColor, bottomLineColor = _a.bottomLineColor, active = _a.active, backgroundColor = _a.backgroundColor, backgroundHoverColor = _a.backgroundHoverColor;
    return css(templateObject_2$z || (templateObject_2$z = __makeTemplateObject(["\n    font-size: 16px;\n    list-style: none;\n    line-height: 16px;\n    font-weight: bold;\n    position: relative;\n    padding: 16px;\n    background-color: ", ";\n    border-bottom: 1px solid ", ";\n    color: ", ";\n    cursor: pointer;\n    ", "\n    &:hover , &:focus {\n      color: ", ";\n      background-color: ", ";\n      outline: none;\n    }\n    img {\n      margin-right: 8px;\n    }\n  "], ["\n    font-size: 16px;\n    list-style: none;\n    line-height: 16px;\n    font-weight: bold;\n    position: relative;\n    padding: 16px;\n    background-color: ", ";\n    border-bottom: 1px solid ", ";\n    color: ", ";\n    cursor: pointer;\n    ", "\n    &:hover , &:focus {\n      color: ", ";\n      background-color: ", ";\n      outline: none;\n    }\n    img {\n      margin-right: 8px;\n    }\n  "])), backgroundColor, bottomLineColor, textColor, active && css(templateObject_1$F || (templateObject_1$F = __makeTemplateObject(["\n      color: ", ";\n      &::before {\n        content: '';\n        position: absolute;\n        left: 0;\n        width: 4px;\n        background-color: ", ";\n        top: 0;\n        bottom: 0;\n      }\n    "], ["\n      color: ", ";\n      &::before {\n        content: '';\n        position: absolute;\n        left: 0;\n        width: 4px;\n        background-color: ", ";\n        top: 0;\n        bottom: 0;\n      }\n    "])), selectedTextColor, selectedTextColor), hoverTextColor, backgroundHoverColor);
});
var SideMenuChildItem = styled(SideMenuMainItem)(templateObject_6$j || (templateObject_6$j = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var active = _a.active, childrenActiveTextColor = _a.childrenActiveTextColor;
    return css(templateObject_5$k || (templateObject_5$k = __makeTemplateObject(["\n    font-weight: normal;\n    font-size: 13px;\n    padding: 8px 16px;\n    border-bottom: none;\n    ", "\n    &::before {\n      display: none;\n    }\n  "], ["\n    font-weight: normal;\n    font-size: 13px;\n    padding: 8px 16px;\n    border-bottom: none;\n    ", "\n    &::before {\n      display: none;\n    }\n  "])), active && css(templateObject_4$n || (templateObject_4$n = __makeTemplateObject(["\n      color: ", ";\n      font-weight: bold;\n    "], ["\n      color: ", ";\n      font-weight: bold;\n    "])), childrenActiveTextColor));
});
var templateObject_1$F, templateObject_2$z, templateObject_3$r, templateObject_4$n, templateObject_5$k, templateObject_6$j;

var SideMenuColors = {
    light: {
        textColor: ColorMapper.grayScale.foreground,
        hoverTextColor: ColorMapper.grayScale.hover.defaultDark,
        selectedTextColor: ColorMapper.default.foreground,
        childrenActiveTextColor: ColorMapper.default.hover.defaultDark,
        bottomLineColor: ColorMapper.grayScale.getColorByNumber(90),
        backgroundColor: BaSeTheme.colors.defaultColors.white,
        backgroundHoverColor: ColorMapper.grayScale.hover.defaultLight,
    },
    dark: {
        textColor: ColorMapper.grayScale.focus.defaultLight,
        hoverTextColor: BaSeTheme.colors.defaultColors.white,
        selectedTextColor: BaSeTheme.colors.defaultColors.white,
        childrenActiveTextColor: BaSeTheme.colors.defaultColors.white,
        bottomLineColor: ColorMapper.grayScale.getColorByNumber(90),
        backgroundColor: BaSeTheme.colors.defaultColors.transparent,
        backgroundHoverColor: ColorMapper.createTransparent(ColorMapper.default.hover.defaultLight, 97, 0.5),
    },
};
// const colorMappedLight = {
//   // light
//   // relative: { s: 100, l: 36 }, // selected
//   normalText: { s: 16, l: 45 }, // s => s * .16 , l => (1 - l) / (64 / 9)
//   backhover: { s: 33, l: 97 }, // s => s * .33 , l => (1 - l) / (64 / 61)
//   lineColor: { s: 22, l: 90 }, // s => s * .22 , l => (1 - l) / (64 / 54)
//   selectedChildText: { s: 80, l: 30 }, // s => s * .8 , l => l * .83
//   hoverText: { s: 25, l: 30 }, // s => s * .8 , l => l * .83
// };
// const colorMappedDark = {
//   // dark
//   // relative: { s: 1, l: 1, o: 1 }, // selected
//   normalText: { s: 14, l: 75 }, // s => s * .14 , l => l + (1 - l) / (25 / 20)
//   backhover: { s: 33, l: 97, o: 0.5 }, // s => s * .33 , l => l * .97
//   lineColor: { s: 22, l: 90 }, // s => s * .22 , l => l * .9
//   selectedChildText: { s: 100, l: 100 }, // s  , l
//   hoverText: { s: 100, l: 100 }, // s  , l
// };
var colorMappedCustom$1 = function (color) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if (!color) {
        return SideMenuColors;
    }
    var mappedTypes = {
        destructive: ColorMapper.destructive.foreground,
        confirmation: ColorMapper.confirmation.foreground,
        attention: ColorMapper.attention.foreground,
    };
    var originalValues = getHSLValues((_a = mappedTypes[color]) !== null && _a !== void 0 ? _a : color);
    if (!originalValues) {
        return SideMenuColors;
    }
    var h = originalValues.h, s = originalValues.s, l = originalValues.l;
    h /= 100;
    s /= 100;
    l /= 100;
    return {
        light: {
            textColor: createColorSmartLightingControl((_b = mappedTypes[color]) !== null && _b !== void 0 ? _b : color, { h: h, s: s * 0.16, l: l + (1 - l) / (64 / 9) }, 'lighter'),
            hoverTextColor: createColorSmartLightingControl((_c = mappedTypes[color]) !== null && _c !== void 0 ? _c : color, { h: h, s: s * 0.25, l: l * 0.83 }, 'darker'),
            selectedTextColor: (_d = mappedTypes[color]) !== null && _d !== void 0 ? _d : color,
            childrenActiveTextColor: createColorSmartLightingControl((_e = mappedTypes[color]) !== null && _e !== void 0 ? _e : color, { h: h, s: s * 0.8, l: l * 0.83 }, 'darker'),
            bottomLineColor: createColorSmartLightingControl((_f = mappedTypes[color]) !== null && _f !== void 0 ? _f : color, { h: h, s: s * 0.22, l: l + (1 - l) / (64 / 54) }, 'lighter'),
            backgroundColor: BaSeTheme.colors.defaultColors.white,
            backgroundHoverColor: createColorSmartLightingControl((_g = mappedTypes[color]) !== null && _g !== void 0 ? _g : color, { h: h, s: s * 0.33, l: l + (1 - l) / (64 / 61) }, 'lighter'),
        },
        dark: {
            textColor: createColorSmartLightingControl((_h = mappedTypes[color]) !== null && _h !== void 0 ? _h : color, { h: h, s: s * 0.14, l: l + ((1 - l) / (25 / 6)) }, 'lighter'),
            hoverTextColor: (_j = mappedTypes[color]) !== null && _j !== void 0 ? _j : color,
            selectedTextColor: (_k = mappedTypes[color]) !== null && _k !== void 0 ? _k : color,
            childrenActiveTextColor: (_l = mappedTypes[color]) !== null && _l !== void 0 ? _l : color,
            bottomLineColor: createColorSmartLightingControl((_m = mappedTypes[color]) !== null && _m !== void 0 ? _m : color, { h: h, s: s * 0.22, l: l * 0.9 }, 'darker'),
            backgroundColor: BaSeTheme.colors.defaultColors.transparent,
            backgroundHoverColor: createColorSmartLightingControl((_o = mappedTypes[color]) !== null && _o !== void 0 ? _o : color, { h: h, s: s * 0.33, l: l * 0.97, opacity: 0.5 }, 'lighter'),
        },
    };
};

var BaSeSideMenuItem = function (_a) {
    var _b, _c;
    var label = _a.label, callback = _a.callback, subItens = _a.subItens, active = _a.active, icon = _a.icon, theme = _a.theme, activeCallback = _a.activeCallback, activeIndex = _a.activeIndex, insideIndex = _a.insideIndex, color = _a.color;
    var menuColors = !!color
        ? (_b = colorMappedCustom$1(color)[theme !== null && theme !== void 0 ? theme : 'light']) !== null && _b !== void 0 ? _b : colorMappedCustom$1(color).dark
        : (_c = SideMenuColors[theme !== null && theme !== void 0 ? theme : 'light']) !== null && _c !== void 0 ? _c : SideMenuColors.dark;
    var _d = React.useState(-1), activeIndexChild = _d[0], setActiveIndexChild = _d[1];
    var _e = React.useState(false), hasHover = _e[0], setHasHover = _e[1];
    var _f = React.useState(false), hasFocus = _f[0], setHasFocus = _f[1];
    var handleStateColor = React.useCallback(function () {
        if (hasHover || hasFocus) {
            return menuColors === null || menuColors === void 0 ? void 0 : menuColors.hoverTextColor;
        }
        if (insideIndex === activeIndex) {
            return menuColors === null || menuColors === void 0 ? void 0 : menuColors.selectedTextColor;
        }
        return menuColors === null || menuColors === void 0 ? void 0 : menuColors.textColor;
    }, [hasHover, hasFocus, menuColors, insideIndex, activeIndex]);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var handleCallback = function () {
        callback === null || callback === void 0 ? void 0 : callback();
        activeCallback === null || activeCallback === void 0 ? void 0 : activeCallback(insideIndex);
    };
    var handleChildrenCallback = function (index, fun) {
        fun === null || fun === void 0 ? void 0 : fun();
        setActiveIndexChild === null || setActiveIndexChild === void 0 ? void 0 : setActiveIndexChild(index);
    };
    React.useEffect(function () {
        if (active) {
            activeCallback === null || activeCallback === void 0 ? void 0 : activeCallback(insideIndex);
        }
    }, [active]);
    React.useEffect(function () {
        if (activeIndex !== insideIndex) {
            setActiveIndexChild(-1);
        }
    }, [activeIndex, insideIndex]);
    React.useEffect(function () {
        subItens === null || subItens === void 0 ? void 0 : subItens.forEach(function (item, key) {
            if (item === null || item === void 0 ? void 0 : item.active) {
                setActiveIndexChild(key);
                activeCallback === null || activeCallback === void 0 ? void 0 : activeCallback(insideIndex);
                return;
            }
        });
    }, [subItens]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SideMenuMainItem, __assign({ tabIndex: 0, onClick: handleCallback }, menuColors, { onMouseEnter: function () { return setHasHover(true); }, onMouseLeave: function () { return setHasHover(false); }, onFocus: function () { return setHasFocus(true); }, onBlur: function () { return setHasFocus(false); }, active: insideIndex === activeIndex }),
            !!icon && (React.createElement(BaSeIcon, { size: 13, name: icon, description: getMessage('icon.label', label), color: handleStateColor() })),
            label),
        insideIndex === activeIndex && !!subItens && subItens.length && (React.createElement("div", { style: { paddingLeft: 20 } }, subItens.map(function (_a, key) {
            var childLabel = _a.label, childCallback = _a.callback;
            return (React.createElement(SideMenuChildItem, __assign({ tabIndex: 0, active: activeIndexChild === key }, menuColors, { onClick: function () { return handleChildrenCallback(key, childCallback); }, key: key }), childLabel));
        })))));
};

var SideMenuContainer = styled.nav(templateObject_1$E || (templateObject_1$E = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n"], ["\n  display: flex;\n  flex-flow: column;\n"])));
var templateObject_1$E;

var BaSeSideMenu = function (_a) {
    var _b = _a.itens, itens = _b === void 0 ? [] : _b, _c = _a.themeMode, themeMode = _c === void 0 ? 'light' : _c, color = _a.color;
    var _d = React.useState(-1), activeIndex = _d[0], setActiveIndex = _d[1];
    if (!itens || !itens.length) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(SideMenuContainer, null, itens.map(function (props, index) { return (React.createElement("div", { key: index },
        React.createElement(BaSeSideMenuItem, __assign({}, props, { theme: themeMode, activeIndex: activeIndex, activeCallback: setActiveIndex, insideIndex: index, color: color })))); })));
};
BaSeSideMenu.displayName = 'BaSeSideMenu';

var ContainerStyled = styled.div.attrs({
    className: 'BaSe--container',
})(templateObject_2$y || (templateObject_2$y = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var maxWidth = _a.maxWidth;
    return css(templateObject_1$D || (templateObject_1$D = __makeTemplateObject(["\n    width: 100%;\n    max-width: ", ";\n    margin: 0 auto;\n  "], ["\n    width: 100%;\n    max-width: ", ";\n    margin: 0 auto;\n  "])), maxWidth ? "".concat(maxWidth, "px") : '100%');
});
var templateObject_1$D, templateObject_2$y;

var BaSeContainer = function (_a) {
    var delimitedOnBreakpoint = _a.delimitedOnBreakpoint, children = _a.children, other = __rest(_a, ["delimitedOnBreakpoint", "children"]);
    var handleDelimiterBreakpoint = React.useCallback(function () {
        if (delimitedOnBreakpoint && delimitedOnBreakpoint in BaSeTheme.breakpoints) {
            return BaSeTheme.breakpoints[delimitedOnBreakpoint].minWidth;
        }
        return;
    }, [delimitedOnBreakpoint]);
    return (React.createElement(ContainerStyled, __assign({ maxWidth: (handleDelimiterBreakpoint()) }, other), children));
};
BaSeContainer.displayName = 'BaSeContainer';

var borderSize$1 = 1;
function getSize(_a) {
    var size = _a.size, bigSize = _a.bigSize, mediumSize = _a.mediumSize, smallSize = _a.smallSize;
    return size === 'big' ? bigSize : size === 'medium' ? mediumSize : smallSize;
}
var TagContainerStyled = styled.div(templateObject_9$d || (templateObject_9$d = __makeTemplateObject(["\n  height: ", "px;\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  width: fit-content;\n  align-items: center;\n  border: ", ";\n  border-radius: ", "px;\n  background-color: ", ";\n\n  ", "\n\n  ", "\n\n  ", ";\n"], ["\n  height: ", "px;\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  width: fit-content;\n  align-items: center;\n  border: ", ";\n  border-radius: ", "px;\n  background-color: ", ";\n\n  ", "\n\n  ", "\n\n  ", ";\n"])), function (_a) {
    var size = _a.size;
    return size === 'small' ? 17 : size === 'medium' ? 20 : 32;
}, function (_a) {
    var type = _a.type, border = _a.border, isSelected = _a.isSelected;
    return type === 'primary' && !isSelected
        ? 'none'
        : "".concat(borderSize$1, "px solid ").concat(border);
}, function (props) { return getSize(props); }, function (_a) {
    var bgC = _a.bgC;
    return bgC;
}, function (_a) {
    var onClick = _a.onClick, boxShadowFocus = _a.boxShadowFocus, bcCHover = _a.bcCHover, isSelected = _a.isSelected, themeMode = _a.themeMode;
    return onClick && css(templateObject_4$m || (templateObject_4$m = __makeTemplateObject(["\n      cursor: pointer;\n      &:hover {\n        ", "\n        ", "\n      }\n      &:focus {\n        ", "\n        outline: none;\n        box-shadow: ", ";\n      }\n    "], ["\n      cursor: pointer;\n      &:hover {\n        ", "\n        ", "\n      }\n      &:focus {\n        ", "\n        outline: none;\n        box-shadow: ", ";\n      }\n    "])), isSelected && css(templateObject_1$C || (templateObject_1$C = __makeTemplateObject(["\n          border-color: ", ";\n        "], ["\n          border-color: ", ";\n        "])), bcCHover), isSelected &&
        themeMode === 'dark' && css(templateObject_2$x || (templateObject_2$x = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), bcCHover), isSelected && css(templateObject_3$q || (templateObject_3$q = __makeTemplateObject(["\n          border-color: ", ";\n        "], ["\n          border-color: ", ";\n        "])), bcCHover), boxShadowFocus);
}, function (_a) {
    var onClick = _a.onClick, bcCHover = _a.bcCHover, type = _a.type, isSelected = _a.isSelected;
    return onClick &&
        type === 'secondary' && css(templateObject_7$f || (templateObject_7$f = __makeTemplateObject(["\n      &:hover {\n        border-color: ", ";\n        ", "\n      }\n      &:focus {\n        border-color: ", ";\n        ", "\n      }\n    "], ["\n      &:hover {\n        border-color: ", ";\n        ", "\n      }\n      &:focus {\n        border-color: ", ";\n        ", "\n      }\n    "])), bcCHover, isSelected && css(templateObject_5$j || (templateObject_5$j = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), bcCHover), bcCHover, isSelected && css(templateObject_6$i || (templateObject_6$i = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), bcCHover));
}, function (_a) {
    var isDisabled = _a.isDisabled;
    return isDisabled && css(templateObject_8$e || (templateObject_8$e = __makeTemplateObject(["\n      cursor: not-allowed;\n    "], ["\n      cursor: not-allowed;\n    "])));
});
var TagIcon = styled.span(templateObject_10$a || (templateObject_10$a = __makeTemplateObject(["\n  border-radius: 50%;\n  background-color: ", ";\n  height: ", "px;\n  width: ", "px;\n  display: flex;\n  align-items: center;\n  justify-items: center;\n  img {\n    display: flex;\n    flex: 1;\n  }\n"], ["\n  border-radius: 50%;\n  background-color: ", ";\n  height: ", "px;\n  width: ", "px;\n  display: flex;\n  align-items: center;\n  justify-items: center;\n  img {\n    display: flex;\n    flex: 1;\n  }\n"])), function (_a) {
    var type = _a.type, newIconColor = _a.newIconColor;
    return type === 'primary' ? newIconColor : 'none';
}, function (_a) {
    var size = _a.size;
    return size === 'small' ? 17 : size === 'medium' ? 20 : 32;
}, function (_a) {
    var size = _a.size;
    return size === 'small' ? 17 : size === 'medium' ? 20 : 32;
});
var TagText = styled.span(templateObject_14$7 || (templateObject_14$7 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  padding: ", "px\n    ", "px;\n  ", "\n  ", "\n    ", "\n"], ["\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  padding: ", "px\n    ", "px;\n  ", "\n  ", "\n    ", "\n"])), function (_a) {
    var size = _a.size;
    return (size === 'big' ? 8 : 2);
}, function (_a) {
    var size = _a.size;
    return (size === 'big' ? 12 : 8);
}, function (_a) {
    var onClose = _a.onClose;
    return onClose && css(templateObject_11$8 || (templateObject_11$8 = __makeTemplateObject(["\n      padding-right: 4px;\n    "], ["\n      padding-right: 4px;\n    "])));
}, function (_a) {
    var icon = _a.icon;
    return icon && css(templateObject_12$8 || (templateObject_12$8 = __makeTemplateObject(["\n      padding-left: 4px;\n    "], ["\n      padding-left: 4px;\n    "])));
}, function (_a) {
    var icon = _a.icon, newIconColor = _a.newIconColor;
    return icon &&
        newIconColor === BaSeTheme.colors.defaultColors.transparent && css(templateObject_13$7 || (templateObject_13$7 = __makeTemplateObject(["\n      margin-left: 0;\n    "], ["\n      margin-left: 0;\n    "])));
});
var TagClose = styled.span(templateObject_16$3 || (templateObject_16$3 = __makeTemplateObject(["\n  button {\n    height: ", "px;\n    width: ", "px;\n    padding: 0;\n    display: flex;\n    ", "\n    img {\n      flex: 1;\n      height: ", "px;\n      width: ", "px;\n    }\n  }\n"], ["\n  button {\n    height: ", "px;\n    width: ", "px;\n    padding: 0;\n    display: flex;\n    ", "\n    img {\n      flex: 1;\n      height: ", "px;\n      width: ", "px;\n    }\n  }\n"])), function (_a) {
    var size = _a.size;
    return size === 'small' ? 17 : size === 'medium' ? 20 : 32;
}, function (_a) {
    var size = _a.size;
    return size === 'small' ? 17 : size === 'medium' ? 20 : 32;
}, function (_a) {
    var themeMode = _a.themeMode, bcCHover = _a.bcCHover;
    return themeMode === 'dark' && css(templateObject_15$5 || (templateObject_15$5 = __makeTemplateObject(["\n        &:hover {\n          background-color: ", ";\n        }\n      "], ["\n        &:hover {\n          background-color: ", ";\n        }\n      "])), bcCHover);
}, function (_a) {
    var size = _a.size;
    return size === 'big' ? 28 : size === 'medium' ? 14 : 12;
}, function (_a) {
    var size = _a.size;
    return size === 'big' ? 28 : size === 'medium' ? 14 : 12;
});
var templateObject_1$C, templateObject_2$x, templateObject_3$q, templateObject_4$m, templateObject_5$j, templateObject_6$i, templateObject_7$f, templateObject_8$e, templateObject_9$d, templateObject_10$a, templateObject_11$8, templateObject_12$8, templateObject_13$7, templateObject_14$7, templateObject_15$5, templateObject_16$3;

var mapTagValues = function (color) {
    var colorIsMapped = color === BaSeTheme.components.button.colors.default ||
        color === BaSeTheme.components.button.colors.destructive ||
        color === BaSeTheme.components.button.colors.attention ||
        color === BaSeTheme.components.button.colors.confirmation;
    if (colorIsMapped) {
        var darkColor = color === 'default'
            ? BaSeTheme.colors.defaultColors.white
            : ColorMapper[color].foreground;
        return {
            primary: {
                dark: {
                    iconColor: ColorMapper[color === 'default' ? 'grayScale' : color].foreground,
                    style: {
                        bgC: BaSeTheme.colors.defaultColors.white,
                        bcCHover: ColorMapper[color === 'default' ? 'grayScale' : color].hover
                            .defaultDark,
                        boxShadowFocus: "0px 0px 4px ".concat(BaSeTheme.colors.defaultColors.white),
                        border: BaSeTheme.colors.defaultColors.transparent,
                    },
                },
                light: {
                    iconColor: ColorMapper[color].foreground,
                    style: {
                        bgC: ColorMapper[color].hover.defaultLight,
                        bcCHover: ColorMapper[color].hover.defaultDark,
                        boxShadowFocus: "0px 0px 4px ".concat(ColorMapper[color].focus.defaultLight),
                        border: BaSeTheme.colors.defaultColors.transparent,
                    },
                },
            },
            secondary: {
                dark: {
                    iconColor: darkColor,
                    style: {
                        bgC: BaSeTheme.colors.institucionais.cinzaSebrae20,
                        bcCHover: ColorMapper[color === 'default' ? 'grayScale' : color].focus
                            .defaultLight,
                        boxShadowFocus: "0px 0px 4px ".concat(darkColor),
                        border: darkColor,
                    },
                },
                light: {
                    iconColor: ColorMapper[color].foreground,
                    style: {
                        bgC: BaSeTheme.colors.defaultColors.white,
                        bcCHover: ColorMapper[color].hover.defaultDark,
                        boxShadowFocus: "0px 0px 4px ".concat(ColorMapper[color].focus.defaultLight),
                        border: ColorMapper[color].foreground,
                    },
                },
            },
        };
    }
    var customColorHsv = Color.generateFromHex(color);
    return {
        primary: {
            light: {
                iconColor: color && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
                style: {
                    bgC: ColorMapper.light.hover.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36),
                    bcCHover: ColorMapper.dark.hover.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36),
                    boxShadowFocus: "0px 0px 4px ".concat(ColorMapper.light.focus.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36)),
                    border: BaSeTheme.colors.defaultColors.transparent,
                },
            },
            dark: {
                iconColor: color && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
                style: {
                    bgC: BaSeTheme.colors.defaultColors.white,
                    bcCHover: ColorMapper.dark.hover.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36),
                    boxShadowFocus: "0px 0px 4px ".concat(BaSeTheme.colors.defaultColors.white),
                    border: BaSeTheme.colors.defaultColors.transparent,
                },
            },
        },
        secondary: {
            light: {
                iconColor: color && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
                style: {
                    bgC: BaSeTheme.colors.defaultColors.transparent,
                    bcCHover: ColorMapper.dark.hover.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36),
                    boxShadowFocus: "0px 0px 4px ".concat(ColorMapper.light.focus.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36)),
                    border: color && customColorHsv
                        ? customColorHsv.toString()
                        : BaSeTheme.colors.institucionais.azulSebrae36,
                },
            },
            dark: {
                iconColor: color && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
                style: {
                    bgC: BaSeTheme.colors.institucionais.cinzaSebrae20,
                    bcCHover: ColorMapper.light.focus.create(color ? color : BaSeTheme.colors.institucionais.azulSebrae36),
                    boxShadowFocus: "0px 0px 4px ".concat(color && customColorHsv
                        ? customColorHsv.toString()
                        : BaSeTheme.colors.institucionais.azulSebrae36),
                    border: color && customColorHsv
                        ? customColorHsv.toString()
                        : BaSeTheme.colors.institucionais.azulSebrae36,
                },
            },
        },
    };
};

var BaSeTag = function (_a) {
    var _b, _c, _d;
    var icon = _a.icon, label = _a.label, overrideColor = _a.overrideColor, _e = _a.size, size = _e === void 0 ? 'medium' : _e, _f = _a.type, type = _f === void 0 ? 'primary' : _f, _g = _a.color, color = _g === void 0 ? 'default' : _g, _h = _a.themeMode, themeMode = _h === void 0 ? 'light' : _h, _j = _a.isSelected, isSelected = _j === void 0 ? false : _j, _k = _a.isDisabled, isDisabled = _k === void 0 ? false : _k, _l = _a.tooltip, tooltip = _l === void 0 ? {} : _l, clickCallback = _a.onClick, closeCallback = _a.onClose;
    if (themeMode && !['light', 'dark'].includes(themeMode)) {
        throw Error('Atributo "themeMode" deve ser do tipo: "light" ou "dark"');
    }
    if (type && !['primary', 'secondary'].includes(type)) {
        throw Error('Atributo "type" deve ser do tipo: "primary" ou "secondary"');
    }
    var _m = React.useMemo(function () { return ({
        onClick: isDisabled ? undefined : clickCallback,
        onClose: isDisabled ? undefined : closeCallback,
    }); }, [clickCallback, closeCallback, isDisabled]), onClick = _m.onClick, onClose = _m.onClose;
    var containerProps = React.useMemo(function () { return ({
        bigSize: 32,
        mediumSize: 24,
        smallSize: 16,
        className: 'BaSe--tag',
        icon: icon,
        size: size,
        type: type,
        isSelected: isSelected,
        isDisabled: isDisabled,
        themeMode: themeMode,
        onClose: onClose,
    }); }, [icon, size, type, isSelected, isDisabled, themeMode, onClose]);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var getColorsAtributes = function (newColor) {
        if (newColor) {
            return mapTagValues(newColor)[type][themeMode];
        }
        return mapTagValues('default')[type][themeMode];
    };
    var baseColor = themeMode === 'light'
        ? BaSeColors.defaultColors.white
        : BaSeColors.institucionais.cinzaSebrae20;
    var getValues = function () {
        if (isDisabled) {
            return {
                bgC: BaSeTheme.colors.institucionais.cinzaSebrae90,
                bcCHover: BaSeTheme.colors.institucionais.cinzaSebrae75,
                boxShadowFocus: BaSeTheme.colors.institucionais.cinzaSebrae75,
                border: isSelected
                    ? BaSeTheme.colors.institucionais.cinzaSebrae75
                    : BaSeTheme.colors.institucionais.cinzaSebrae90,
                newIconColor: BaSeTheme.colors.institucionais.cinzaSebrae75,
            };
        }
        var colorValue = getColorsAtributes(color);
        if (isSelected && type === 'secondary') {
            return {
                bgC: colorValue.iconColor,
                bcCHover: colorValue.style.bcCHover,
                boxShadowFocus: colorValue.style.boxShadowFocus,
                border: colorValue.style.border,
                newIconColor: colorValue.style.bgC,
            };
        }
        if (isSelected && type === 'primary') {
            return {
                bgC: themeMode === 'dark' ? colorValue.iconColor : baseColor,
                bcCHover: colorValue.style.bcCHover,
                boxShadowFocus: colorValue.style.boxShadowFocus,
                border: colorValue.iconColor,
                newIconColor: themeMode === 'dark' ? colorValue.style.bgC : colorValue.iconColor,
            };
        }
        return {
            bgC: colorValue.style.bgC,
            bcCHover: colorValue.style.bcCHover,
            boxShadowFocus: colorValue.style.boxShadowFocus,
            border: colorValue.style.border,
            newIconColor: colorValue.iconColor,
        };
    };
    var bcCHoverIcon = getColorsAtributes((_b = overrideColor === null || overrideColor === void 0 ? void 0 : overrideColor.iconColor) !== null && _b !== void 0 ? _b : color).style.bcCHover;
    var _o = getValues(), bgC = _o.bgC, bcCHover = _o.bcCHover, boxShadowFocus = _o.boxShadowFocus, border = _o.border, newIconColor = _o.newIconColor;
    var _p = React.useState(false), isHover = _p[0], setIsHover = _p[1];
    var _q = React.useState(false), isHoverClose = _q[0], setIsHoverClose = _q[1];
    var _r = React.useState(false), isFocus = _r[0], setIsFocus = _r[1];
    if (onClick) {
        containerProps.role = 'button';
        containerProps.tabIndex = 0;
        containerProps.onKeyUp = function (e) { return e.key === 'Enter' && onClick(e); };
        containerProps.onClick = function (e) { return onClick(e); };
    }
    var divRef = React.useRef(null);
    var _s = React.useState(false), isTooltipOpen = _s[0], setIsTooltipOpen = _s[1];
    var Text = size === 'small' ? BaSeSmall2 : BaSeSmall1;
    return (React.createElement(TagContainerStyled, __assign({}, containerProps, { bgC: bgC, bcCHover: bcCHover, boxShadowFocus: boxShadowFocus, border: border, newIconColor: newIconColor, onMouseEnter: function () {
            if (onClick) {
                setIsHover(true);
            }
            setIsTooltipOpen(true);
        }, onMouseLeave: function () {
            if (onClick) {
                setIsHover(false);
            }
            setIsTooltipOpen(false);
        }, onFocus: function () { return onClick && setIsFocus(true); }, onBlur: function () { return onClick && setIsFocus(false); }, ref: divRef, tabIndex: isDisabled ? -1 : 0 }),
        icon && (React.createElement(TagIcon, { className: "BaSe--tag-icon icon", type: type, newIconColor: (isHover || isFocus) && !isSelected
                ? bcCHoverIcon
                : (_c = overrideColor === null || overrideColor === void 0 ? void 0 : overrideColor.iconColor) !== null && _c !== void 0 ? _c : newIconColor, size: size },
            React.createElement(BaSeIcon, { size: size === 'big' ? 28 : size === 'medium' ? 14 : 12, name: icon, description: getMessage('icon.label', label), color: type === 'primary'
                    ? isSelected
                        ? bgC
                        : BaSeColors.defaultColors.white
                    : (isHover || isFocus) && !isSelected
                        ? bcCHoverIcon
                        : (_d = overrideColor === null || overrideColor === void 0 ? void 0 : overrideColor.iconColor) !== null && _d !== void 0 ? _d : newIconColor }))),
        label && (React.createElement(TagText, { className: "BaSe--tag-text text", newIconColor: newIconColor, size: size, icon: icon, onClose: onClose },
            React.createElement(Text, { isBold: true, color: isSelected || !(isHover || isFocus) ? newIconColor : bcCHover }, label))),
        onClose && (React.createElement(TagClose, { className: "BaSe--tag-close close", onClose: onClose, bcCHover: newIconColor, size: size, type: type, themeMode: themeMode, onMouseEnter: function () {
                setIsHoverClose(true);
            }, onMouseLeave: function () {
                setIsHoverClose(false);
            } },
            React.createElement(BaSeShapeButton, { buttonType: "button", nameIcon: "close", shape: "circle", size: size, sizeIcon: size, type: "tertiary", color: themeMode === 'dark' && isHoverClose ? bgC : newIconColor, onClick: function (e) {
                    if (onClick) {
                        e.stopPropagation();
                    }
                    onClose(e);
                } }))),
        objectNotEmpty(tooltip) && (React.createElement(BaSeTooltip, __assign({ buddyRef: divRef, open: isTooltipOpen }, tooltip)))));
};
BaSeTag.displayName = 'BaSeTag';

var colorMapper = {
    default: BaSeTheme.colors.institucionais.azulSebrae36,
    destructive: BaSeTheme.colors.feedbackInterface.erro45,
    attention: BaSeTheme.colors.feedbackInterface.atencao55,
    confirmation: BaSeTheme.colors.feedbackInterface.sucesso26,
};
function calculed(_a) {
    var size = _a.size, correction = _a.correction;
    return size ? "calc(".concat(size, " - ").concat(correction, "px)") : 'auto';
}
function gridTemplateAreaStacked(_a) {
    var _b = _a.hideHeader, hideHeader = _b === void 0 ? false : _b, _c = _a.hideContentInfo, hideContentInfo = _c === void 0 ? false : _c, _d = _a.hideContentCategory, hideContentCategory = _d === void 0 ? false : _d, _e = _a.hideContentTag, hideContentTag = _e === void 0 ? false : _e, _f = _a.hideContentAction, hideContentAction = _f === void 0 ? false : _f;
    var he = hideHeader ? '' : ' "he" '.repeat(3);
    var cc = hideContentCategory ? '' : ' "cc" ';
    var ct = hideContentTag ? '' : ' "ct" ';
    var ci = hideContentInfo ? '' : ' "ci" '.repeat(4);
    var ca = hideContentAction ? '' : ' "ca" ';
    var lines = [he, cc, ct, ci, ca];
    return lines.join('');
}
function gridTemplateAreaSideBySide(_a) {
    var _b = _a.hideHeader, hideHeader = _b === void 0 ? false : _b, _c = _a.hideContentInfo, hideContentInfo = _c === void 0 ? false : _c, _d = _a.hideContentCategory, hideContentCategory = _d === void 0 ? false : _d, _e = _a.hideContentTag, hideContentTag = _e === void 0 ? false : _e, _f = _a.hideContentAction, hideContentAction = _f === void 0 ? false : _f;
    var clearEmptyLine = function (line) {
        return line.replace(/^('\s+'|'\s+he\s+')$/g, '');
    };
    var he = hideHeader ? '' : ' he ';
    var ci = hideContentInfo ? '' : ' ci '.repeat(2);
    var cc = hideContentCategory ? '' : ' cc '.repeat(2);
    var ct = hideContentTag ? '' : ' ct '.repeat(2);
    var ca = hideContentAction ? '' : ' ca '.repeat(2);
    var he_cc = "'".concat(he, " ").concat(cc, "'");
    var he_ct = "'".concat(he, " ").concat(ct, "'");
    var he_ci = "'".concat(he, " ").concat(ci, "'");
    var he_ca = "'".concat(he, " ").concat(ca, "'");
    var lines = __spreadArray(__spreadArray([he_cc, he_ct], Array(3).fill(he_ci), true), [he_ca], false);
    return lines.map(clearEmptyLine).join('');
}
function gridTemplateAreaWide(_a) {
    var _b = _a.hideHeader, hideHeader = _b === void 0 ? false : _b, _c = _a.hideContentInfo, hideContentInfo = _c === void 0 ? false : _c, _d = _a.hideContentCategory, hideContentCategory = _d === void 0 ? false : _d, _e = _a.hideContentTag, hideContentTag = _e === void 0 ? false : _e;
    var clearEmptyLine = function (line) { return line.replace(/.*×.*/g, ''); };
    var he = hideHeader ? '' : ' he '.repeat(2);
    var ci = hideContentInfo ? '×' : ' ci '.repeat(4);
    var ct = hideContentTag ? '×' : ' ct '.repeat(4);
    var lines;
    if (hideContentCategory) {
        var he_ci_ca = "'".concat(he, " ").concat(ci, " ca'");
        var he_ct_ct = "'".concat(he, " ").concat(ct, " ct'");
        lines = __spreadArray(__spreadArray([], Array(4).fill(he_ci_ca), true), [he_ct_ct], false);
    }
    else {
        var cc = ' cc '.repeat(3);
        var he_cc_ca = "'".concat(he, " ").concat(cc, " ca'");
        var he_ci = "'".concat(he, " ").concat(ci, "'");
        var he_ct = "'".concat(he, " ").concat(ct, "'");
        lines = __spreadArray(__spreadArray([he_cc_ca], Array(3).fill(he_ci), true), [he_ct], false);
    }
    return lines.map(clearEmptyLine).join('');
}

var gridAreaMapper = function (_a) {
    var _b = _a.disposition, disposition = _b === void 0 ? 'stacked' : _b, 
    // tslint:disable-next-line: trailing-comma
    sliceCheck = __rest(_a, ["disposition"]);
    return ({
        stacked: css(templateObject_1$B || (templateObject_1$B = __makeTemplateObject(["\n      grid-template-areas: ", ";\n    "], ["\n      grid-template-areas: ", ";\n    "])), gridTemplateAreaStacked(sliceCheck)),
        'side-by-side': css(templateObject_2$w || (templateObject_2$w = __makeTemplateObject(["\n      grid-template-areas: ", ";\n    "], ["\n      grid-template-areas: ", ";\n    "])), gridTemplateAreaSideBySide(sliceCheck)),
        wide: css(templateObject_3$p || (templateObject_3$p = __makeTemplateObject(["\n      grid-template-areas: ", ";\n    "], ["\n      grid-template-areas: ", ";\n    "])), gridTemplateAreaWide(sliceCheck)),
    }[disposition]);
};
var elevated = function (_a) {
    var shadowLevel = _a.shadowLevel;
    return css(templateObject_4$l || (templateObject_4$l = __makeTemplateObject(["\n  transform: translateY(\n    -", "px\n  );\n  box-shadow: ", ";\n"], ["\n  transform: translateY(\n    -", /*  - shadowLevel */ "px\n  );\n  box-shadow: ", ";\n"])), shadowLevel * shadowLevelFactor /*  - shadowLevel */, getShadow((shadowLevel * shadowLevelFactor)));
};
var cardSlice = function (area) { return css(templateObject_5$i || (templateObject_5$i = __makeTemplateObject(["\n  grid-area: ", ";\n  place-self: stretch;\n\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-start;\n\n  background-color: transparent;\n"], ["\n  grid-area: ", ";\n  place-self: stretch;\n\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-start;\n\n  background-color: transparent;\n"])), area); };
var CardHeader = styled.header.attrs({
    className: 'BaSe--card-header',
})(templateObject_6$h || (templateObject_6$h = __makeTemplateObject(["\n  ", "\n\n  padding: 12px;\n"], ["\n  ", "\n\n  padding: 12px;\n"])), cardSlice('he'));
var CardContentInfo = styled.div.attrs({
    className: 'BaSe--card-content-info',
})(templateObject_7$e || (templateObject_7$e = __makeTemplateObject(["\n  ", "\n\n  padding: 24px;\n"], ["\n  ", "\n\n  padding: 24px;\n"])), cardSlice('ci'));
var CardContentCategoryItem = styled.div(templateObject_8$d || (templateObject_8$d = __makeTemplateObject(["\n  display: grid;\n  place-items: center;\n  grid-template-columns: repeat(2, auto);\n  gap: 8px;\n"], ["\n  display: grid;\n  place-items: center;\n  grid-template-columns: repeat(2, auto);\n  gap: 8px;\n"])));
var CardContentCategory = styled.div.attrs({
    className: 'BaSe--card-content-category',
})(templateObject_9$c || (templateObject_9$c = __makeTemplateObject(["\n  ", "\n\n  padding: 12px;\n  gap: 12px;\n"], ["\n  ", "\n\n  padding: 12px;\n  gap: 12px;\n"])), cardSlice('cc'));
var ContentTag = styled.li(templateObject_10$9 || (templateObject_10$9 = __makeTemplateObject(["\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n"])));
var CardTagContainer = styled.ul.attrs({
    className: 'BaSe--card-content-tag',
})(templateObject_14$6 || (templateObject_14$6 = __makeTemplateObject(["\n  ", "\n\n  position: relative;\n  padding: 24px 60px 24px 24px;\n  gap: 16px;\n  max-height: 100%;\n\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  position: relative;\n  padding: 24px 60px 24px 24px;\n  gap: 16px;\n  max-height: 100%;\n\n  ", "\n\n  ", "\n"])), cardSlice('ct'), function (_a) {
    var contentTagGrouped = _a.contentTagGrouped, isCollapsed = _a.isCollapsed;
    return contentTagGrouped &&
        (isCollapsed
            ? css(templateObject_11$7 || (templateObject_11$7 = __makeTemplateObject(["\n          ", ":not(:nth-last-of-type(2))::after {\n            margin-left: 8px;\n            content: '|';\n            color: ", ";\n          }\n        "], ["\n          ", ":not(:nth-last-of-type(2))::after {\n            margin-left: 8px;\n            content: '|';\n            color: ", ";\n          }\n        "])), ContentTag, BaSeTheme.colors.institucionais.cinzaSebrae75) : css(templateObject_12$7 || (templateObject_12$7 = __makeTemplateObject(["\n          ", " {\n            flex: 1 100%;\n          }\n        "], ["\n          ", " {\n            flex: 1 100%;\n          }\n        "])), ContentTag));
}, function (_a) {
    var contentTagExpandable = _a.contentTagExpandable, contentTagHeight = _a.contentTagHeight, isCollapsed = _a.isCollapsed;
    return isCollapsed &&
        contentTagHeight &&
        contentTagExpandable && css(templateObject_13$6 || (templateObject_13$6 = __makeTemplateObject(["\n      max-height: calc(", " - 8px);\n      overflow-y: hidden;\n    "], ["\n      max-height: calc(", " - 8px);\n      overflow-y: hidden;\n    "])), contentTagHeight);
});
var TagButtonWrapper = styled.li(templateObject_15$4 || (templateObject_15$4 = __makeTemplateObject(["\n  position: absolute;\n  top: 18px;\n  right: 24px;\n"], ["\n  position: absolute;\n  top: 18px;\n  right: 24px;\n"])));
var ContentTagSeparator = styled.hr(templateObject_16$2 || (templateObject_16$2 = __makeTemplateObject(["\n  margin: 0;\n  border: none;\n  width: 100%;\n  height: 0.5px;\n  margin-top: 8px;\n  background: ", ";\n"], ["\n  margin: 0;\n  border: none;\n  width: 100%;\n  height: 0.5px;\n  margin-top: 8px;\n  background: ", ";\n"])), BaSeTheme.colors.institucionais.cinzaSebrae90);
var CardContentAction = styled.footer.attrs({
    className: 'BaSe--card-content-action',
})(templateObject_17$2 || (templateObject_17$2 = __makeTemplateObject(["\n  ", "\n\n  padding: 12px;\n  gap: 12px;\n"], ["\n  ", "\n\n  padding: 12px;\n  gap: 12px;\n"])), cardSlice('ca'));
var CardWrapper = styled.section.attrs({
    className: 'BaSe--card',
})(templateObject_30$1 || (templateObject_30$1 = __makeTemplateObject(["\n  will-change: box-shadow, transform, border-left-width;\n  display: grid;\n  box-sizing: content-box;\n  border-radius: 12px;\n  overflow: hidden;\n  position: relative;\n\n  transition: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", ";\n"], ["\n  will-change: box-shadow, transform, border-left-width;\n  display: grid;\n  box-sizing: content-box;\n  border-radius: 12px;\n  overflow: hidden;\n  position: relative;\n\n  transition: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", ";\n"])), BaSeTheme.transitions.allPropertiesContinuousFast, gridAreaMapper, function (_a) {
    var withSideDestak = _a.withSideDestak, height = _a.height, width = _a.width;
    return css(templateObject_18$2 || (templateObject_18$2 = __makeTemplateObject(["\n    height: ", ";\n    width: ", ";\n  "], ["\n    height: ", ";\n    width: ", ";\n  "])), calculed({ size: height, correction: 2 }), calculed({ size: width, correction: withSideDestak ? 5 : 2 }));
}, function (_a) {
    var withSideDestak = _a.withSideDestak, destakColor = _a.destakColor, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor, disposition = _a.disposition, backgroundImage = _a.backgroundImage, hideHeader = _a.hideHeader, hideContentAction = _a.hideContentAction, hideContentTag = _a.hideContentTag, hideContentCategory = _a.hideContentCategory;
    return css(templateObject_27$1 || (templateObject_27$1 = __makeTemplateObject(["\n    background-color: ", ";\n    border: 1px solid ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    background-color: ", ";\n    border: 1px solid ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), backgroundColor, borderColor, hideHeader &&
        backgroundImage && css(templateObject_19$2 || (templateObject_19$2 = __makeTemplateObject(["\n      background-image: url('", "');\n      background-repeat: no-repeat;\n      background-size: cover;\n    "], ["\n      background-image: url('", "');\n      background-repeat: no-repeat;\n      background-size: cover;\n    "])), backgroundImage), withSideDestak && css(templateObject_20$2 || (templateObject_20$2 = __makeTemplateObject(["\n      border-left: 4px solid ", ";\n    "], ["\n      border-left: 4px solid ", ";\n    "])), destakColor), !hideHeader && css(templateObject_21$2 || (templateObject_21$2 = __makeTemplateObject(["\n      & > ", " {\n        background-color: ", ";\n        background-image: url('", "');\n        background-repeat: no-repeat;\n        background-size: cover;\n      }\n    "], ["\n      & > ", " {\n        background-color: ", ";\n        background-image: url('", "');\n        background-repeat: no-repeat;\n        background-size: cover;\n      }\n    "])), CardHeader, destakColor, backgroundImage), disposition === 'wide'
        ? css(templateObject_24$1 || (templateObject_24$1 = __makeTemplateObject(["\n          ", "\n\n          ", "\n        "], ["\n          ", "\n\n          ", "\n        "])), !hideContentAction && css(templateObject_22$1 || (templateObject_22$1 = __makeTemplateObject(["\n            & > ", " {\n              align-self: flex-start;\n              justify-self: flex-end;\n            }\n          "], ["\n            & > ", " {\n              align-self: flex-start;\n              justify-self: flex-end;\n            }\n          "])), CardContentAction), !hideContentTag && css(templateObject_23$1 || (templateObject_23$1 = __makeTemplateObject(["\n            & > ", " {\n              box-shadow: 8px 0 0 0 ", " inset,\n                -8px 0 0 0 ", " inset,\n                0 2px 0 0 ", " inset;\n            }\n          "], ["\n            & > ", " {\n              box-shadow: 8px 0 0 0 ", " inset,\n                -8px 0 0 0 ", " inset,\n                0 2px 0 0 ", " inset;\n            }\n          "])), CardTagContainer, backgroundColor, backgroundColor, borderColor)) : css(templateObject_26$1 || (templateObject_26$1 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), !hideContentCategory && css(templateObject_25$1 || (templateObject_25$1 = __makeTemplateObject(["\n            & > ", " {\n              background-color: ", ";\n            }\n          "], ["\n            & > ", " {\n              background-color: ", ";\n            }\n          "])), CardContentCategory, transformLightness(backgroundColor, 0.96))));
}, function (_a) {
    var shadowLevel = _a.shadowLevel, elevationOnHoverOrFocus = _a.elevationOnHoverOrFocus, isElevated = _a.isElevated;
    return shadowLevel && css(templateObject_29$1 || (templateObject_29$1 = __makeTemplateObject(["\n      box-shadow: ", ";\n\n      ", "\n\n      ", "\n    "], ["\n      box-shadow: ", ";\n\n      ", "\n\n      ", "\n    "])), getShadow(shadowLevel), isElevated && elevated, elevationOnHoverOrFocus && css(templateObject_28$1 || (templateObject_28$1 = __makeTemplateObject(["\n        &:hover,\n        &:focus-within {\n          ", "\n        }\n      "], ["\n        &:hover,\n        &:focus-within {\n          ", "\n        }\n      "])), elevated));
});
var templateObject_1$B, templateObject_2$w, templateObject_3$p, templateObject_4$l, templateObject_5$i, templateObject_6$h, templateObject_7$e, templateObject_8$d, templateObject_9$c, templateObject_10$9, templateObject_11$7, templateObject_12$7, templateObject_13$6, templateObject_14$6, templateObject_15$4, templateObject_16$2, templateObject_17$2, templateObject_18$2, templateObject_19$2, templateObject_20$2, templateObject_21$2, templateObject_22$1, templateObject_23$1, templateObject_24$1, templateObject_25$1, templateObject_26$1, templateObject_27$1, templateObject_28$1, templateObject_29$1, templateObject_30$1;

var BaSeCardContentTag = function (_a) {
    var destakColor = _a.destakColor, foregroundColor = _a.foregroundColor, renderContentTag = _a.renderContentTag;
    var ct = renderContentTag === null || renderContentTag === void 0 ? void 0 : renderContentTag();
    var containerTagRef = React.useRef(null);
    var _b = React.useState(), contentTagHeight = _b[0], setContentTagHeight = _b[1];
    var _c = React.useState(false), contentTagExpandable = _c[0], setContentTagExpandable = _c[1];
    var _d = React.useState(true), isCollapsed = _d[0], setIsCollapsed = _d[1];
    var _e = React.useState(false), contentTagGrouped = _e[0], setContentTagGrouped = _e[1];
    var _f = React.useState(false), showExpandableButton = _f[0], setShowExpandableButton = _f[1];
    var renderTag = React.useCallback(function (tag) { return React.createElement(BaSeTag, __assign({ color: foregroundColor }, tag)); }, [foregroundColor]);
    var renderOthers = React.useCallback(function (others, collapsedItem) {
        if (!others.length) {
            return React.createElement(React.Fragment, { key: "+".concat(others.length) });
        }
        return isCollapsed
            ? renderTag(__assign(__assign({ key: "+".concat(others.length) }, collapsedItem), { label: "+".concat(others.length), onClick: undefined, onClose: undefined, tooltip: undefined }))
            : others.map(function (tag, index) { return renderTag(__assign({ key: index }, tag)); });
    }, [renderTag, isCollapsed]);
    var renderCollpasibleTag = React.useCallback(function (group) {
        var _a, _b, _c, _d, _e;
        return Array.isArray(group.alwaysVisible)
            ? group.alwaysVisible
                .map(function (tag, index) { return renderTag(__assign({ key: index }, tag)); })
                .concat(renderOthers(group.collapsibleItems, group.collapsedItem))
            : Array.of(renderTag(__assign({ key: (_e = (_c = (_a = group === null || group === void 0 ? void 0 : group.key) !== null && _a !== void 0 ? _a : (_b = group.alwaysVisible) === null || _b === void 0 ? void 0 : _b.key) !== null && _c !== void 0 ? _c : (_d = group.alwaysVisible) === null || _d === void 0 ? void 0 : _d.label) !== null && _e !== void 0 ? _e : '😭' }, group.alwaysVisible))).concat(renderOthers(group.collapsibleItems, group.collapsedItem));
    }, [renderTag, renderOthers]);
    var renderContent = React.useCallback(function (value) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (value) {
            var tagProps = value;
            var collapsedTag = value;
            var expandableTag = value;
            if (Array.isArray(value)) {
                return value.map(function (item, index) {
                    var _a;
                    return (React.createElement(ContentTag, { key: (_a = item === null || item === void 0 ? void 0 : item.key) !== null && _a !== void 0 ? _a : index }, item && 'alwaysVisible' in item ? (React.createElement(React.Fragment, null,
                        renderCollpasibleTag(item),
                        !isCollapsed && value.length - 1 !== index && (React.createElement(ContentTagSeparator, null)))) : (renderTag(__assign({ key: index }, item)))));
                });
            }
            if (tagProps === null || tagProps === void 0 ? void 0 : tagProps.label) {
                return (React.createElement(ContentTag, { key: (_a = tagProps === null || tagProps === void 0 ? void 0 : tagProps.key) !== null && _a !== void 0 ? _a : tagProps === null || tagProps === void 0 ? void 0 : tagProps.label }, renderTag(__assign({ key: (_b = tagProps.key) !== null && _b !== void 0 ? _b : tagProps.label }, tagProps))));
            }
            if (collapsedTag === null || collapsedTag === void 0 ? void 0 : collapsedTag.alwaysVisible) {
                return (React.createElement(ContentTag, { key: (_j = (_g = (_e = (_c = collapsedTag === null || collapsedTag === void 0 ? void 0 : collapsedTag.key) !== null && _c !== void 0 ? _c : (_d = collapsedTag.alwaysVisible) === null || _d === void 0 ? void 0 : _d.key) !== null && _e !== void 0 ? _e : (_f = collapsedTag.alwaysVisible) === null || _f === void 0 ? void 0 : _f.label) !== null && _g !== void 0 ? _g : (_h = collapsedTag.alwaysVisible) === null || _h === void 0 ? void 0 : _h.length) !== null && _j !== void 0 ? _j : '🤔' }, renderCollpasibleTag(collapsedTag)));
            }
            if (expandableTag === null || expandableTag === void 0 ? void 0 : expandableTag.items) {
                return expandableTag.items.map(function (tag, index) {
                    var _a;
                    return (React.createElement(ContentTag, { key: (_a = tag === null || tag === void 0 ? void 0 : tag.key) !== null && _a !== void 0 ? _a : index }, renderTag(__assign({ key: index }, tag))));
                });
            }
        }
        return value;
    }, [isCollapsed, renderCollpasibleTag, renderTag]);
    React.useEffect(function () {
        var _a, _b;
        var tagContainer = containerTagRef.current;
        var isGroupedTag = (ct && 'alwaysVisible' in ct) ||
            (Array.isArray(ct) && 'alwaysVisible' in ct[0]);
        setShowExpandableButton(isGroupedTag);
        setContentTagGrouped(isGroupedTag);
        var isExpandableTag = ((_b = (_a = ct) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) > 0;
        if (isExpandableTag) {
            var calculateToShowButton_1 = function () {
                var _a;
                setContentTagExpandable(isExpandableTag);
                var firstLine = [];
                var list = Array.from((_a = tagContainer === null || tagContainer === void 0 ? void 0 : tagContainer.children) !== null && _a !== void 0 ? _a : []);
                for (var _i = 0, _b = list; _i < _b.length; _i++) {
                    var current = _b[_i];
                    var index = list.indexOf(current);
                    var currentRect = current.getBoundingClientRect();
                    if (index === 0) {
                        firstLine.push(current);
                        continue;
                    }
                    var prev = list[index - 1];
                    var prevRect = prev.getBoundingClientRect();
                    if (Math.abs(prevRect.y - currentRect.y) > 8) {
                        break;
                    }
                    firstLine.push(current);
                }
                var greaterHeight = firstLine.reduce(function (height, current) {
                    var currentRect = current.getBoundingClientRect();
                    return Math.max(height, currentRect.height);
                }, 0);
                setContentTagHeight("".concat(greaterHeight, "px"));
                setShowExpandableButton(list.length > firstLine.length);
            };
            if (tagContainer) {
                var calculate = function () { return calculateToShowButton_1(); };
                var resizeObserver_1 = new ResizeObserver(calculate);
                resizeObserver_1.observe(tagContainer);
                var timeout_1 = setTimeout(calculate, 1000);
                return function () {
                    resizeObserver_1.unobserve(tagContainer);
                    clearTimeout(timeout_1);
                };
            }
        }
        return;
    }, [containerTagRef.current]);
    return (React.createElement(CardTagContainer, { isCollapsed: isCollapsed, contentTagGrouped: contentTagGrouped, contentTagExpandable: contentTagExpandable, contentTagHeight: contentTagHeight, ref: containerTagRef, as: React.isValidElement(ct) ? 'div' : 'ul' },
        renderContent(ct),
        showExpandableButton && (React.createElement(TagButtonWrapper, null,
            React.createElement(BaSeShapeButton, { color: destakColor, type: "tertiary", size: "small", sizeIcon: "medium", nameIcon: isCollapsed ? 'angle-down' : 'angle-up', onClick: function () { return setIsCollapsed(function (actual) { return !actual; }); } })))));
};
BaSeCardContentTag.displayName = 'BaSeCardContentTag';

var colors$2 = BaSeTheme.colors;
var BaSeCard = function (_a) {
    var _b = _a.height, height = _b === void 0 ? 'auto' : _b, _c = _a.width, width = _c === void 0 ? 'auto' : _c, _d = _a.disposition, disposition = _d === void 0 ? 'stacked' : _d, _e = _a.shadowLevel, shadowLevel = _e === void 0 ? 2 : _e, _f = _a.elevationOnHoverOrFocus, elevationOnHoverOrFocus = _f === void 0 ? true : _f, _g = _a.isElevated, isElevated = _g === void 0 ? false : _g, _h = _a.withSideDestak, withSideDestak = _h === void 0 ? true : _h, _j = _a.destakColor, externalDestakColor = _j === void 0 ? 'default' : _j, _k = _a.backgroundColor, backgroundColor = _k === void 0 ? colors$2.defaultColors.white : _k, _l = _a.foregroundColor, foregroundColor = _l === void 0 ? colors$2.institucionais.cinzaSebrae45 : _l, _m = _a.headerColor, headerColor = _m === void 0 ? colors$2.defaultColors.white : _m, _o = _a.borderColor, borderColor = _o === void 0 ? colors$2.institucionais.cinzaSebrae90 : _o, backgroundImage = _a.backgroundImage, renderHeader = _a.renderHeader, renderContentInfo = _a.renderContentInfo, renderContentCategory = _a.renderContentCategory, renderContentTag = _a.renderContentTag, renderContentAction = _a.renderContentAction;
    var hideHeader = React.useMemo(function () { return typeof renderHeader !== 'function'; }, [renderHeader]);
    var hideContentInfo = React.useMemo(function () { return typeof renderContentInfo !== 'function'; }, [renderContentInfo]);
    var hideContentCategory = React.useMemo(function () { return typeof renderContentCategory !== 'function'; }, [renderContentCategory]);
    var hideContentTag = React.useMemo(function () { return typeof renderContentTag !== 'function'; }, [renderContentTag]);
    var hideContentAction = React.useMemo(function () { return typeof renderContentAction !== 'function'; }, [renderContentAction]);
    var destakColor = React.useMemo(function () {
        var _a;
        return (_a = colorMapper[externalDestakColor]) !== null && _a !== void 0 ? _a : externalDestakColor;
    }, [externalDestakColor]);
    if (!validateShadowLevel(shadowLevel)) {
        throw Error("[BaSeCard] \"shadowLevel\" ".concat(shadowLevel, " n\u00E3o existe"));
    }
    if (elevationOnHoverOrFocus && shadowLevel === maxShadowLevel) {
        throw Error("[BaSeCard] \"shadowLevel\" ".concat(shadowLevel, " n\u00E3o pode ter\n      eleva\u00E7\u00E3o com \"elevationOnHoverOrFocus\".\n      J\u00E1 est\u00E1 no \u00FAltimo nivel"));
    }
    if (disposition === 'side-by-side') {
        if (hideHeader) {
            throw Error("[BaSeCard] Quando \"disposition\" for \"side-by-side\",\n        n\u00E3o pode ocutar o header.\n        Use o \"disposition\" igual a \"stacked\" sem o header");
        }
        else if (hideContentInfo &&
            hideContentCategory &&
            hideContentTag &&
            hideContentAction) {
            throw Error("[BaSeCard] Quando \"disposition\" for \"side-by-side\",\n        n\u00E3o pode ocutar os outros sem se o header.\n        Use o \"disposition\" igual a \"stacked\" s\u00F3 com o header");
        }
    }
    if (disposition === 'wide') {
        if (hideHeader && hideContentAction) {
            throw Error("[BaSeCard] Quando \"disposition\" for \"wide\",\n        n\u00E3o pode ocutar o header e o content action.\n        Use o \"disposition\" igual a \"stacked\" sem o header e sem o content action");
        }
        if (hideContentInfo && hideContentCategory && hideContentTag) {
            throw Error("[BaSeCard] Quando \"disposition\" for \"wide\",\n        n\u00E3o pode ocutar o content info, content category e content tag.\n        Use o \"disposition\" igual a \"stacked\" s\u00F3 com o header e o content action");
        }
        if (hideContentAction) {
            throw Error("[BaSeCard] Quando \"disposition\" for \"wide\",\n        n\u00E3o pode ocutar o content action.\n        Use o \"disposition\" igual a \"stacked\" ou \"side-by-side\" sem o content action");
        }
    }
    var header = React.useCallback(function () {
        if (hideHeader) {
            return;
        }
        var he = renderHeader === null || renderHeader === void 0 ? void 0 : renderHeader();
        if (typeof he === 'string') {
            return (React.createElement(CardHeader, null,
                React.createElement(BaSeHeading4, { color: headerColor }, he)));
        }
        return React.createElement(CardHeader, null, he);
    }, [hideHeader, renderHeader, headerColor]);
    var contentInfo = React.useCallback(function () {
        if (hideContentInfo) {
            return;
        }
        var ci = renderContentInfo === null || renderContentInfo === void 0 ? void 0 : renderContentInfo();
        if (typeof ci === 'string') {
            return (React.createElement(CardContentInfo, null,
                React.createElement(BaSeHeading5, { color: foregroundColor }, ci)));
        }
        return React.createElement(CardContentInfo, null, ci);
    }, [hideContentInfo, renderContentInfo, foregroundColor]);
    var contentCategory = React.useCallback(function () {
        var _a;
        if (hideContentCategory) {
            return;
        }
        var cc = renderContentCategory === null || renderContentCategory === void 0 ? void 0 : renderContentCategory();
        if (React.isValidElement(cc)) {
            return React.createElement(CardContentCategory, null, cc);
        }
        return (React.createElement(CardContentCategory, null, (_a = cc) === null || _a === void 0 ? void 0 : _a.map(function (category) { return (React.createElement(BaSeI18nConsumer, { key: "".concat(category.label, "-").concat(category.icon) }, function (_a) {
            var getMessage = _a.getMessage;
            return (React.createElement(CardContentCategoryItem, null,
                category.icon && (React.createElement(BaSeIcon, { description: getMessage('icon.label', category.label), name: category.icon, color: destakColor, size: 13 })),
                React.createElement(BaSeSmall1, { color: foregroundColor }, category.label)));
        })); })));
    }, [
        hideContentCategory,
        renderContentCategory,
        foregroundColor,
        destakColor,
    ]);
    var contentAction = React.useCallback(function () {
        var _a, _b, _c, _d;
        if (hideContentAction) {
            return;
        }
        var ct = renderContentAction === null || renderContentAction === void 0 ? void 0 : renderContentAction();
        if (React.isValidElement(ct)) {
            return React.createElement(CardContentAction, null, ct);
        }
        return (React.createElement(CardContentAction, null, (_b = (_a = ct) === null || _a === void 0 ? void 0 : _a.shapeButtons) === null || _b === void 0 ? void 0 :
            _b.map(function (shapeButton) { return (React.createElement(BaSeShapeButton, __assign({ key: "".concat(shapeButton.nameIcon, "-").concat(shapeButton.value), color: foregroundColor, type: "secondary" }, shapeButton))); }), (_d = (_c = ct) === null || _c === void 0 ? void 0 : _c.buttons) === null || _d === void 0 ? void 0 :
            _d.map(function (button) { return (React.createElement(BaSeButton, __assign({ key: "".concat(button.leftIcon, "-").concat(button.value, "-").concat(button.rightIcon), color: foregroundColor, type: "secondary" }, button))); })));
    }, [hideContentAction, renderContentAction, foregroundColor]);
    return (React.createElement(CardWrapper, { height: height, width: width, disposition: disposition, shadowLevel: shadowLevel, withSideDestak: withSideDestak, elevationOnHoverOrFocus: elevationOnHoverOrFocus, isElevated: isElevated, backgroundColor: backgroundColor, borderColor: borderColor, backgroundImage: backgroundImage !== null && backgroundImage !== void 0 ? backgroundImage : (hideHeader
            ? ''
            : "".concat(BaSeConfig.staticAssetsUrl, "/images/others/card/background.png")), destakColor: destakColor, hideHeader: hideHeader, hideContentInfo: hideContentInfo, hideContentCategory: hideContentCategory, hideContentTag: hideContentTag, hideContentAction: hideContentAction },
        header(),
        contentInfo(),
        !hideContentTag && (React.createElement(BaSeCardContentTag, { destakColor: destakColor, foregroundColor: foregroundColor, renderContentTag: renderContentTag })),
        contentCategory(),
        contentAction()));
};
BaSeCard.displayName = 'BaSeCard';

var BaSeDataRowInfoContext = React.createContext({
    rowInfo: '',
    setRowInfo: function () { },
});
var BaSeDataRowInfoProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(''), rowInfo = _b[0], setRowInfo = _b[1];
    return (React.createElement(BaSeDataRowInfoContext.Provider, { value: {
            rowInfo: rowInfo,
            setRowInfo: setRowInfo,
        } }, children));
};
var BaSeDataRowInfoConsumer = BaSeDataRowInfoContext.Consumer;

var ArrowButton = styled.button(templateObject_15$3 || (templateObject_15$3 = __makeTemplateObject(["\n  ", "\n\n  &:active:not(:disabled) {\n    box-shadow: none;\n    transform: translateY(2px);\n  }\n"], ["\n  ", "\n\n  &:active:not(:disabled) {\n    box-shadow: none;\n    transform: translateY(2px);\n  }\n"])), function (_a) {
    var borderRadius = _a.borderRadius, background = _a.background, border = _a.border, borderColor = _a.borderColor, isLeft = _a.isLeft, hasBoxShadow = _a.hasBoxShadow, hoverColor = _a.hoverColor, isSecondaryNegative = _a.isSecondaryNegative, boxShadowFocus = _a.boxShadowFocus, textHoverColor = _a.textHoverColor, borderHoverColor = _a.borderHoverColor, isDisabled = _a.isDisabled;
    return css(templateObject_14$5 || (templateObject_14$5 = __makeTemplateObject(["\n    display: flex;\n    height: 40px;\n    padding: 7px;\n    box-sizing: border-box;\n    border-radius: ", ";\n    background-color: ", ";\n    z-index: ", ";\n    border-top: ", " solid ", ";\n    border-right: ", ";\n    border-left: ", ";\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    cursor: pointer;\n    border-bottom: ", " solid ", ";\n    transition: ", ";\n\n    ", ";\n    ", "\n\n    span {\n      z-index: ", ";\n    }\n\n    .arrow-shape {\n      border: ", " solid ", ";\n      ", "\n    }\n\n    .arrow-body {\n      background-color: ", ";\n    }\n\n    &:hover {\n      ", "\n      ", "\n    .arrow-shape {\n        ", "\n        ", "\n      }\n      .arrow-body {\n        background-color: ", ";\n      }\n\n      span {\n        ", "\n      }\n    }\n\n    ", "\n  "], ["\n    display: flex;\n    height: 40px;\n    padding: 7px;\n    box-sizing: border-box;\n    border-radius: ", ";\n    background-color: ", ";\n    z-index: ", ";\n    border-top: ", " solid ", ";\n    border-right: ", ";\n    border-left: ", ";\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    cursor: pointer;\n    border-bottom: ", " solid ", ";\n    transition: ", ";\n\n    ", ";\n    ", "\n\n    span {\n      z-index: ", ";\n    }\n\n    .arrow-shape {\n      border: ", " solid ", ";\n      ", "\n    }\n\n    .arrow-body {\n      background-color: ", ";\n    }\n\n    &:hover {\n      ", "\n      ", "\n    .arrow-shape {\n        ", "\n        ", "\n      }\n      .arrow-body {\n        background-color: ", ";\n      }\n\n      span {\n        ", "\n      }\n    }\n\n    ", "\n  "])), numberWithUnit(borderRadius), background, BaSeTheme.stackOrder.normal + 2, border, borderColor, isLeft ? "".concat(border, " solid ").concat(borderColor) : '0px', !isLeft ? "".concat(border, " solid ").concat(borderColor) : '0px', border, borderColor, BaSeTheme.transitions.allPropertiesContinuousFast, isLeft
        ? css(templateObject_1$A || (templateObject_1$A = __makeTemplateObject(["\n          border-top-left-radius: ", "px;\n          border-bottom-left-radius: ", "px;\n          margin-left: 20px;\n          padding-left: 36px;\n          padding-right: 12px;\n        "], ["\n          border-top-left-radius: ", "px;\n          border-bottom-left-radius: ", "px;\n          margin-left: 20px;\n          padding-left: 36px;\n          padding-right: 12px;\n        "])), isSecondaryNegative ? 0 : 1, isSecondaryNegative ? 0 : 1) : css(templateObject_2$v || (templateObject_2$v = __makeTemplateObject(["\n          border-top-right-radius: ", "px;\n          border-bottom-right-radius: ", "px;\n          margin-right: 20px;\n          padding-right: 36px;\n          padding-left: 12px;\n        "], ["\n          border-top-right-radius: ", "px;\n          border-bottom-right-radius: ", "px;\n          margin-right: 20px;\n          padding-right: 36px;\n          padding-left: 12px;\n        "])), isSecondaryNegative ? 0 : 1, isSecondaryNegative ? 0 : 1), hasBoxShadow && css(templateObject_3$o || (templateObject_3$o = __makeTemplateObject(["\n      box-shadow: 0px 2px 4px ", ";\n    "], ["\n      box-shadow: 0px 2px 4px ", ";\n    "])), BaSeTheme.colors.defaultColors.shadowColor), BaSeTheme.stackOrder.aboveNormal, border, borderColor, (!isSecondaryNegative || isDisabled) && css(templateObject_4$k || (templateObject_4$k = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), background), background, css(templateObject_5$h || (templateObject_5$h = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), hoverColor), borderHoverColor && "border-color: ".concat(borderHoverColor, ";"), css(templateObject_6$g || (templateObject_6$g = __makeTemplateObject(["\n          background-color: ", ";\n        "], ["\n          background-color: ", ";\n        "])), hoverColor), borderHoverColor && css(templateObject_7$d || (templateObject_7$d = __makeTemplateObject(["\n          border-color: ", ";\n        "], ["\n          border-color: ", ";\n        "])), borderHoverColor), hoverColor, textHoverColor && "color: ".concat(textHoverColor, ";"), isSecondaryNegative
        ? css(templateObject_10$8 || (templateObject_10$8 = __makeTemplateObject(["\n        &:focus {\n          outline: none;\n          border: 2px solid ", ";\n          border-", ":none;\n          .arrow-shape {\n            border: 2px solid ", ";\n          }\n          .arrow-shape {\n            box-shadow: 0px 0px 0px 3px ", ";\n          }\n          .arrow-body {\n            box-shadow: 0px 0px 0px 3px ", ";\n          }\n\n          ", "\n        }\n      "], ["\n        &:focus {\n          outline: none;\n          border: 2px solid ", ";\n          border-", ":none;\n          .arrow-shape {\n            border: 2px solid ", ";\n          }\n          .arrow-shape {\n            box-shadow: 0px 0px 0px 3px ", ";\n          }\n          .arrow-body {\n            box-shadow: 0px 0px 0px 3px ", ";\n          }\n\n          ", "\n        }\n      "])), BaSeTheme.colors.defaultColors.transparent, isLeft ? 'left' : 'right', BaSeTheme.colors.defaultColors.transparent, boxShadowFocus, boxShadowFocus, isLeft
            ? css(templateObject_8$c || (templateObject_8$c = __makeTemplateObject(["\n                  box-shadow: 3px 3px 0px 0px ", ",\n                    3px -3px 0px 0px ", ",\n                    0px 3px 0px 0px ", ",\n                    0px -3px 0px 0px ", ";\n                "], ["\n                  box-shadow: 3px 3px 0px 0px ", ",\n                    3px -3px 0px 0px ", ",\n                    0px 3px 0px 0px ", ",\n                    0px -3px 0px 0px ", ";\n                "])), boxShadowFocus, boxShadowFocus, boxShadowFocus, boxShadowFocus) : css(templateObject_9$b || (templateObject_9$b = __makeTemplateObject(["\n                  box-shadow: -3px 3px 0px 0px ", ",\n                    -3px -3px 0px 0px ", ",\n                    0px 3px 0px 0px ", ",\n                    0px -3px 0px 0px ", ";\n                "], ["\n                  box-shadow: -3px 3px 0px 0px ", ",\n                    -3px -3px 0px 0px ", ",\n                    0px 3px 0px 0px ", ",\n                    0px -3px 0px 0px ", ";\n                "])), boxShadowFocus, boxShadowFocus, boxShadowFocus, boxShadowFocus)) : css(templateObject_13$5 || (templateObject_13$5 = __makeTemplateObject(["\n          &:focus {\n            outline: none;\n            ", ";\n\n            .arrow-shape {\n              box-shadow: 0px 0px 0px 3px ", ";\n              border-color: ", ";\n            }\n            border-color: ", ";\n          }\n        "], ["\n          &:focus {\n            outline: none;\n            ", ";\n\n            .arrow-shape {\n              box-shadow: 0px 0px 0px 3px ", ";\n              border-color: ", ";\n            }\n            border-color: ", ";\n          }\n        "])), isLeft
        ? css(templateObject_11$6 || (templateObject_11$6 = __makeTemplateObject(["\n                  box-shadow: 1px 3px 0px 0px ", ",\n                    1px -3px 0px 0px ", ",\n                    0px 0px 0px 3px ", ";\n                "], ["\n                  box-shadow: 1px 3px 0px 0px ", ",\n                    1px -3px 0px 0px ", ",\n                    0px 0px 0px 3px ", ";\n                "])), boxShadowFocus, boxShadowFocus, boxShadowFocus) : css(templateObject_12$6 || (templateObject_12$6 = __makeTemplateObject(["\n                  box-shadow: -1px 3px 0px 0px ", ",\n                    -1px -3px 0px 0px ", ",\n                    0px 0px 0px 3px ", ";\n                "], ["\n                  box-shadow: -1px 3px 0px 0px ", ",\n                    -1px -3px 0px 0px ", ",\n                    0px 0px 0px 3px ", ";\n                "])), boxShadowFocus, boxShadowFocus, boxShadowFocus), boxShadowFocus, BaSeTheme.colors.defaultColors.transparent, BaSeTheme.colors.defaultColors.transparent));
});
var ArrowStyledContainer = styled.div.attrs({
    className: 'arrow-shape',
})(templateObject_21$1 || (templateObject_21$1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isLeft = _a.isLeft, clip = _a.clip, isSecondaryNegative = _a.isSecondaryNegative, boxShadow = _a.boxShadow;
    return css(templateObject_20$1 || (templateObject_20$1 = __makeTemplateObject(["\n    position: absolute;\n    box-sizing: border-box;\n    ", "\n    width: 30.5px;\n    height: 30.5px;\n    border-radius: 4px;\n    clip-path: ", ";\n    transform: rotate(", ");\n    ", ";\n  "], ["\n    position: absolute;\n    box-sizing: border-box;\n    ", "\n    width: 30.5px;\n    height: 30.5px;\n    border-radius: 4px;\n    clip-path: ", ";\n    transform: rotate(", ");\n    ", ";\n  "])), isSecondaryNegative
        ? isLeft
            ? css(templateObject_16$1 || (templateObject_16$1 = __makeTemplateObject(["\n            right: calc(100% - calc(30.5px / 2));\n          "], ["\n            right: calc(100% - calc(30.5px / 2));\n          "]))) : css(templateObject_17$1 || (templateObject_17$1 = __makeTemplateObject(["\n            left: calc(100% - calc(30.5px / 2));\n          "], ["\n            left: calc(100% - calc(30.5px / 2));\n          "])))
        : isLeft
            ? css(templateObject_18$1 || (templateObject_18$1 = __makeTemplateObject(["\n          right: calc(100% - 16px);\n        "], ["\n          right: calc(100% - 16px);\n        "]))) : css(templateObject_19$1 || (templateObject_19$1 = __makeTemplateObject(["\n          left: calc(100% - 16px);\n        "], ["\n          left: calc(100% - 16px);\n        "]))), clip !== null && clip !== void 0 ? clip : "polygon(300% -300%, -300% -300%, 300% 300%)", isLeft ? "225deg" : "45deg", boxShadow &&
        (isLeft
            ? "box-shadow: 0px -4px 4px -2px ".concat(BaSeTheme.colors.defaultColors.shadowColor)
            : "box-shadow: 4px 0px 4px -2px ".concat(BaSeTheme.colors.defaultColors.shadowColor)));
});
styled.div.attrs({
    className: 'arrow-body',
})(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isLeft = _a.isLeft, _b = _a.svgWidth, svgWidth = _b === void 0 ? '141.55' : _b;
    return css(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    position: absolute;\n    ", "\n    top:-0.5px;\n    bottom: -0.5px;\n    border-radius: 5px;\n    ", "\n  "], ["\n    position: absolute;\n    ", "\n    top:-0.5px;\n    bottom: -0.5px;\n    border-radius: 5px;\n    ", "\n  "])), isLeft
        ? css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n          left: -19.5px;\n          right: -0.5px;\n        "], ["\n          left: -19.5px;\n          right: -0.5px;\n        "]))) : css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n          right: -19.5px;\n          left: -0.5px;\n        "], ["\n          right: -19.5px;\n          left: -0.5px;\n        "]))), isLeft
        ? css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n          clip-path: polygon(22% 0, 100% 0, 100% 100%, 22% 100%, 2% 50%);\n        "], ["\n          clip-path: polygon(22% 0, 100% 0, 100% 100%, 22% 100%, 2% 50%);\n        "]))) : css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n          clip-path: path(\n            'M4,40 a4,4,0,0,1-4-4V4 A4,4,0,0,1,4,0 H", " a4,4,0,0,1,3.15,1.54l12.46,16 a4,4,0,0,1,0,4.92 l-12.46,16 A4,4,0,0,1,", ",40 Z'\n          );\n        "], ["\n          clip-path: path(\n            'M4,40 a4,4,0,0,1-4-4V4 A4,4,0,0,1,4,0 H", " a4,4,0,0,1,3.15,1.54l12.46,16 a4,4,0,0,1,0,4.92 l-12.46,16 A4,4,0,0,1,", ",40 Z'\n          );\n        "])), svgWidth, svgWidth));
});
styled.button(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var width = _a.width, isLeft = _a.isLeft;
    return css(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n    border: none;\n    background-color: ", ";\n    width: ", ";\n    cursor: pointer;\n    &:focus {\n      outline: none;\n      ", ";\n  "], ["\n    border: none;\n    background-color: ", ";\n    width: ", ";\n    cursor: pointer;\n    &:focus {\n      outline: none;\n      ", ";\n  "])), BaSeTheme.colors.defaultColors.transparent, numberWithUnit(width), isLeft
        ? css(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n              box-shadow: 3px 3px 0px 0px\n                  ", ",\n                3px -3px 0px 0px ", ",\n                0px 0px 0px 3px ", ";\n            "], ["\n              box-shadow: 3px 3px 0px 0px\n                  ", ",\n                3px -3px 0px 0px ", ",\n                0px 0px 0px 3px ", ";\n            "])), BaSeTheme.colors.institucionais.azulSebrae60, BaSeTheme.colors.institucionais.azulSebrae60, BaSeTheme.colors.institucionais.azulSebrae60) : css(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n              box-shadow: -3px 3px 0px 0px\n                  ", ",\n                -3px -3px 0px 0px\n                  ", ",\n                0px 0px 0px 3px ", ";\n            "], ["\n              box-shadow: -3px 3px 0px 0px\n                  ", ",\n                -3px -3px 0px 0px\n                  ", ",\n                0px 0px 0px 3px ", ";\n            "])), BaSeTheme.colors.institucionais.azulSebrae60, BaSeTheme.colors.institucionais.azulSebrae60, BaSeTheme.colors.institucionais.azulSebrae60));
});
var templateObject_1$A, templateObject_2$v, templateObject_3$o, templateObject_4$k, templateObject_5$h, templateObject_6$g, templateObject_7$d, templateObject_8$c, templateObject_9$b, templateObject_10$8, templateObject_11$6, templateObject_12$6, templateObject_13$5, templateObject_14$5, templateObject_15$3, templateObject_16$1, templateObject_17$1, templateObject_18$1, templateObject_19$1, templateObject_20$1, templateObject_21$1, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31;

var BaSeArrowButton = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var _j = _a.type, type = _j === void 0 ? 'primary' : _j, _k = _a.value, value = _k === void 0 ? 'Valor' : _k, _l = _a.color, color = _l === void 0 ? 'default' : _l, _m = _a.isDisabled, isDisabled = _m === void 0 ? false : _m, _o = _a.direction, direction = _o === void 0 ? 'right' : _o, _p = _a.buttonType, buttonType = _p === void 0 ? 'button' : _p, _q = _a.autoFocus, autoFocus = _q === void 0 ? false : _q, _r = _a.tooltip, tooltip = _r === void 0 ? {} : _r, _s = _a.onClick, onClick = _s === void 0 ? function () { } : _s, onFocus = _a.onFocus, onBlur = _a.onBlur;
    var colorIsMapped = color === BaSeTheme.components.button.colors.default ||
        color === BaSeTheme.components.button.colors.negative;
    var getColorsAtributes = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        if (color) {
            if (!colorIsMapped) {
                return ((_b = (_a = mapCustomColorsArrowButtonValues(color)) === null || _a === void 0 ? void 0 : _a[type]) !== null && _b !== void 0 ? _b : mapCustomColorsArrowButtonValues(color).primary);
            }
            else {
                return ((_d = (_c = arrowButtonMapStyle[type]) === null || _c === void 0 ? void 0 : _c[color]) !== null && _d !== void 0 ? _d : (_e = arrowButtonMapStyle.primary) === null || _e === void 0 ? void 0 : _e[color]);
            }
        }
        else {
            return ((_g = (_f = arrowButtonMapStyle[type]) === null || _f === void 0 ? void 0 : _f.default) !== null && _g !== void 0 ? _g : arrowButtonMapStyle.primary.default);
        }
    };
    var typeMapped = isDisabled
        ? color === 'negative'
            ? (_d = (_c = (_b = arrowButtonMapStyle[type]) === null || _b === void 0 ? void 0 : _b.disabled) === null || _c === void 0 ? void 0 : _c.negative) !== null && _d !== void 0 ? _d : (_e = arrowButtonMapStyle[type]) === null || _e === void 0 ? void 0 : _e.disabled
            : (_g = (_f = arrowButtonMapStyle[type]) === null || _f === void 0 ? void 0 : _f.disabled) !== null && _g !== void 0 ? _g : arrowButtonMapStyle.primary.default
        : getColorsAtributes();
    var iconColor = typeMapped.color, arrows = typeMapped.arrows, typeStyle = __rest(typeMapped, ["color", "arrows"]);
    var isLeft = direction === 'left';
    var _t = React.useState(false), isTooltipOpen = _t[0], setIsTooltipOpen = _t[1];
    var buttonRef = React.useRef(null);
    return (React.createElement(ArrowButton, __assign({ ref: buttonRef, "aria-disabled": isDisabled ? true : undefined, className: "BaSe--button-arrow", autoFocus: autoFocus, disabled: isDisabled, isDisabled: isDisabled, type: buttonType, isLeft: isLeft, isSecondaryNegative: color === 'negative' && type === 'secondary', hasBoxShadow: color !== 'negative' || !isDisabled, onMouseEnter: function () { return setIsTooltipOpen(true); }, onMouseLeave: function () { return setIsTooltipOpen(false); }, onClick: onClick, onFocus: onFocus, onBlur: onBlur }, typeStyle),
        React.createElement(ArrowStyledContainer, __assign({ isSecondaryNegative: color === 'negative' && type === 'secondary', boxShadow: color !== 'negative' || !isDisabled, isLeft: isLeft }, arrows)),
        React.createElement(BaSeTextButton, { fontSize: 1, lineHeight: 1.4, hasLeftIcon: false, hasRightIcon: false, fontWeigt: "normal", color: iconColor }, value),
        objectNotEmpty(tooltip) && (React.createElement(BaSeTooltip, { buddyRef: buttonRef, color: tooltip === null || tooltip === void 0 ? void 0 : tooltip.color, direction: tooltip === null || tooltip === void 0 ? void 0 : tooltip.direction, message: (_h = tooltip === null || tooltip === void 0 ? void 0 : tooltip.message) !== null && _h !== void 0 ? _h : '', open: isTooltipOpen, width: tooltip === null || tooltip === void 0 ? void 0 : tooltip.width, coordinates: tooltip === null || tooltip === void 0 ? void 0 : tooltip.coordinates }))));
};
BaSeArrowButton.displayName = 'BaSeArrowButton';

var MappedInputMasks = {
    cnpj: '99.999.999/9999-99',
    cpf: '999.999.999-99',
    cep: '99.999-999',
    phone: '9999-99999',
    phoneDDD: '(99) 9999-99999',
    oldPhone: '9999-9999',
    oldPhoneDDD: '(99) 9999-9999',
    date: '99/99/9999',
};
var addSeparatorToNumber = function (numb) {
    var fin = '';
    var count = 0;
    for (var i = numb.length - 1; i >= 0; i--) {
        if (count === 3) {
            fin = '.' + fin;
            count = 0;
        }
        fin = numb[i] + fin;
        count++;
    }
    return fin;
};
var currencyMask = function (curr) {
    var val = curr + '';
    if (val) {
        var minus = '';
        if (val[0] === '-') {
            minus = val[0];
        }
        val = val.replace(/\D/g, '');
        if (!val) {
            return '';
        }
        if (val.length < 5) {
            try {
                val = parseFloat(parseInt(val, 10) / 100 + '').toFixed(2) + '';
                var _a = val.split('.'), integer = _a[0], float = _a[1];
                var newInteger = addSeparatorToNumber(integer);
                val = newInteger + ',' + float;
            }
            catch (_b) {
                val = '';
            }
        }
        else {
            var splitter = val.length - 2;
            var integer = val.slice(0, splitter);
            var float = val.slice(splitter, splitter + 2);
            integer = addSeparatorToNumber(integer);
            val = integer + ',' + float;
        }
        return minus ? minus + val : val;
    }
    else {
        return '';
    }
};
var removeNonDigit = function (val) {
    return !!val ? val === null || val === void 0 ? void 0 : val.replace(/\D/g, '').replace(/\s/g, '') : '';
};
var rawValueMask = Object.keys(__assign(__assign({}, MappedInputMasks), { decimal: '' })).reduce(function (prev, curr) {
    var _a;
    return (__assign(__assign({}, prev), (_a = {}, _a[curr] = function (val) { return removeNonDigit(val); }, _a)));
}, [{}]);
var substringContainMask = function (target, value) {
    var _a;
    if (!target || !value) {
        return false;
    }
    var mappedTable = (_a = target === null || target === void 0 ? void 0 : target.split('')) === null || _a === void 0 ? void 0 : _a.map(function () { return false; });
    for (var index = 0, targetIndex = 0; index <= value.length - 1 && targetIndex <= target.length - 1; index++) {
        if (value[index] === target[targetIndex]) {
            mappedTable[targetIndex] = true;
            targetIndex++;
        }
    }
    return mappedTable.findIndex(function (bol) { return bol === false; }) !== -1;
};

var HelperStyled = styled.span.attrs({ className: 'BaSe--helper-text' })(templateObject_1$z || (templateObject_1$z = __makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-style:", ";\n  font-weight: normal;\n  font-size: ", ";\n  line-height: 13px;\n  ", "\n  display: flex;\n  align-items: center;\n  img {\n    margin-right: 4px;\n    ", "\n    transition: ", ";\n  }\n  ::selection {\n    color: inherit;\n    background: inherit;\n  }\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-style:", ";\n  font-weight: normal;\n  font-size: ", ";\n  line-height: 13px;\n  ", "\n  display: flex;\n  align-items: center;\n  img {\n    margin-right: 4px;\n    ", "\n    transition: ", ";\n  }\n  ::selection {\n    color: inherit;\n    background: inherit;\n  }\n"])), function (props) { return props.color ? props.color : BaSeTheme.colors.institucionais.azulSebrae36; }, BaSeTheme.typography.fontFamily, function (props) { return props.isItalic ? 'italic' : 'normal'; }, function (props) { return props.size === 'small' ? '11px' : '13px'; }, function (props) { return props.hasComplement && 'cursor: pointer;'; }, function (props) { return props.open && 'transform: rotate(180deg);'; }, BaSeTheme.transitions.allPropertiesContinuousNormal);
var HelperContainer = styled.div(templateObject_2$u || (templateObject_2$u = __makeTemplateObject(["\n"], ["\n"])));
var HelperDetailsContainer = styled.div(templateObject_3$n || (templateObject_3$n = __makeTemplateObject(["\n  padding-left: 16px;\n  max-height: ", ";\n  opacity: ", ";\n  transition: ", ";\n  overflow: hidden;\n"], ["\n  padding-left: 16px;\n  max-height: ", ";\n  opacity: ", ";\n  transition: ", ";\n  overflow: hidden;\n"])), function (props) { return props.open ? '100vh' : '0px'; }, function (props) { return props.open ? 1 : 0; }, BaSeTheme.transitions.allPropertiesContinuousNormal);
var templateObject_1$z, templateObject_2$u, templateObject_3$n;

// relative: { s: 100, l: 36 },
// normalText: { s: 16, l: 45 },
var defaultDetailsColor = BaSeTheme.colors.institucionais.cinzaSebrae45;
var colorMappedCustom = function (color) {
    var _a;
    if (!color) {
        return defaultDetailsColor;
    }
    var mappedTypes = {
        destructive: ColorMapper.destructive.foreground,
        confirmation: ColorMapper.confirmation.foreground,
        attention: ColorMapper.attention.foreground,
        default: ColorMapper.default.foreground,
    };
    var toTransformColor = (_a = mappedTypes[color]) !== null && _a !== void 0 ? _a : color;
    var originalValues = getHSLValues(toTransformColor);
    if (!originalValues) {
        return defaultDetailsColor;
    }
    var h = originalValues.h, s = originalValues.s, l = originalValues.l;
    h /= 100;
    s /= 100;
    l /= 100;
    return createColorSmartLightingControl(toTransformColor, { h: h, s: s * 0.16, l: l + (1 - l) / (64 / 9) }, 'lighter');
};

var BaSeHelperText = function (_a) {
    var _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.details, details = _c === void 0 ? '' : _c, color = _a.color, _d = _a.size, size = _d === void 0 ? 'medium' : _d, _e = _a.isItalic, isItalic = _e === void 0 ? false : _e;
    var _f = React.useState(false), open = _f[0], setOpen = _f[1];
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var handleDetailsColor = React.useCallback(function () { return colorMappedCustom(color); }, [color]);
    return (React.createElement(HelperContainer, null,
        React.createElement(HelperStyled, { isItalic: isItalic, size: size, open: open, color: ColorMapper.getColor(color, BaSeTheme.colors.institucionais.azulSebrae36), hasComplement: !!details, onClick: function () { return setOpen(function (prev) { return !prev && !!details; }); } },
            !!details && (React.createElement(BaSeIcon, { size: 12, name: "angle-down", description: open
                    ? getMessage('helperText.openButton')
                    : getMessage('helperText.closeButton'), color: ColorMapper.getColor(color, BaSeTheme.colors.institucionais.azulSebrae36) })),
            label),
        React.createElement(HelperDetailsContainer, { open: !!details && open },
            React.createElement(BaSeSmall2, { color: handleDetailsColor() }, details))));
};
BaSeHelperText.displayName = 'BaSeHelperText';

var StyledInput = styled.input.attrs({
    className: 'BaSe--input-input',
})(templateObject_2$t || (templateObject_2$t = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b = _a.paddingRight, paddingRight = _b === void 0 ? 12 : _b, size = _a.size, customColors = _a.customColors;
    return css(templateObject_1$y || (templateObject_1$y = __makeTemplateObject(["\n    padding-left: 12px;\n    padding-right: ", "px;\n    width: calc(100% - ", "px); // Nem tente entender \u00AF_(\u30C4)_/\u00AF\n    color: ", ";\n    background: ", ";\n    border: 1px solid ", ";\n    border-radius: 4px;\n    height: ", "px;\n    &:focus {\n      outline: none !important;\n      box-shadow: 0 0 4px ", ";\n      border: 1px solid ", ";\n      color: ", ";\n    }\n  "], ["\n    padding-left: 12px;\n    padding-right: ", "px;\n    width: calc(100% - ", "px); // Nem tente entender \u00AF\\_(\u30C4)_/\u00AF\n    color: ", ";\n    background: ", ";\n    border: 1px solid ", ";\n    border-radius: 4px;\n    height: ", "px;\n    &:focus {\n      outline: none !important;\n      box-shadow: 0 0 4px ", ";\n      border: 1px solid ", ";\n      color: ", ";\n    }\n  "])), paddingRight, paddingRight + 14, customColors === null || customColors === void 0 ? void 0 : customColors.color, customColors === null || customColors === void 0 ? void 0 : customColors.backgroundColor, customColors === null || customColors === void 0 ? void 0 : customColors.borderColor, size, customColors === null || customColors === void 0 ? void 0 : customColors.boxShadowFocus, customColors === null || customColors === void 0 ? void 0 : customColors.focusBorderColor, customColors === null || customColors === void 0 ? void 0 : customColors.focusTextColor);
});
styled.span(templateObject_4$j || (templateObject_4$j = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var color = _a.color;
    return css(templateObject_3$m || (templateObject_3$m = __makeTemplateObject(["\n    font-size: 0.83em;\n    color: ", ";\n    margin-top: 3px;\n    line-height: 1.2em;\n    font-family: ", ";\n    font-style: italic;\n    font-weight: normal;\n  "], ["\n    font-size: 0.83em;\n    color: ", ";\n    margin-top: 3px;\n    line-height: 1.2em;\n    font-family: ", ";\n    font-style: italic;\n    font-weight: normal;\n  "])), color, BaSeTheme.typography.fontFamily);
});
var ContainerInput = styled.div.attrs({
    className: 'BaSe--input',
})(templateObject_6$f || (templateObject_6$f = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var width = _a.width;
    return css(templateObject_5$g || (templateObject_5$g = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    width: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    width: ", ";\n  "])), numberWithUnit(width));
});
var WrapperInput = styled.div(templateObject_7$c || (templateObject_7$c = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  align-items: stretch;\n"], ["\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  align-items: stretch;\n"])));
var ContainerIcon = styled.div(templateObject_10$7 || (templateObject_10$7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var padding = _a.padding, rotation = _a.rotation;
    return css(templateObject_9$a || (templateObject_9$a = __makeTemplateObject(["\n    right: ", "px;\n    top: ", "px;\n    position: absolute;\n    justify-content: center;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    button {\n      border-radius: 0 4px 4px 0;\n      height: 100%;\n      &:focus {\n        border-radius: 0 4px 4px 0;\n      }\n    }\n    & > img {\n      transition: ", ";\n    }\n    ", "}\n  "], ["\n    right: ", "px;\n    top: ", "px;\n    position: absolute;\n    justify-content: center;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    button {\n      border-radius: 0 4px 4px 0;\n      height: 100%;\n      &:focus {\n        border-radius: 0 4px 4px 0;\n      }\n    }\n    & > img {\n      transition: ", ";\n    }\n    ", "}\n  "])), padding, padding, BaSeTheme.transitions.allPropertiesContinuousFast, rotation && css(templateObject_8$b || (templateObject_8$b = __makeTemplateObject(["\n        & > img {\n          transform: rotateX(180deg);\n        }\n      "], ["\n        & > img {\n          transform: rotateX(180deg);\n        }\n      "]))));
});
var MoreInfoContainer$3 = styled.div(templateObject_11$5 || (templateObject_11$5 = __makeTemplateObject(["\n  padding-top: 4px;\n"], ["\n  padding-top: 4px;\n"])));
var WrapperHelper$2 = styled.div(templateObject_12$5 || (templateObject_12$5 = __makeTemplateObject(["\n  padding-top: 2px;\n"], ["\n  padding-top: 2px;\n"])));
var CheckIconWrapper = styled.div(templateObject_14$4 || (templateObject_14$4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var top = _a.top;
    return css(templateObject_13$4 || (templateObject_13$4 = __makeTemplateObject(["\n    position: relative;\n    right: 12px;\n    top: ", "px;\n  "], ["\n    position: relative;\n    right: 12px;\n    top: ", "px;\n  "])), top);
});
var templateObject_1$y, templateObject_2$t, templateObject_3$m, templateObject_4$j, templateObject_5$g, templateObject_6$f, templateObject_7$c, templateObject_8$b, templateObject_9$a, templateObject_10$7, templateObject_11$5, templateObject_12$5, templateObject_13$4, templateObject_14$4;

var translationValueToName = {
    0: 'invalid',
    1: 'valid',
    2: 'normal',
    3: 'disabled',
};
var mapBaSeInputSize = {
    small: 28,
    medium: 36,
    big: 44,
};
var mapBaSeInputColor = {
    normal: {
        color: BaSeTheme.colors.institucionais.cinzaSebrae60,
        borderColor: BaSeTheme.colors.institucionais.cinzaSebrae75,
        backgroundColor: BaSeTheme.colors.defaultColors.white,
        focusTextColor: BaSeTheme.colors.institucionais.azulSebrae36,
        focusBorderColor: BaSeTheme.colors.institucionais.azulSebrae36,
        boxShadowFocus: BaSeTheme.colors.institucionais.azulSebrae75,
    },
    valid: {
        color: BaSeTheme.colors.feedbackInterface.sucesso20,
        borderColor: BaSeTheme.colors.feedbackInterface.sucesso20,
        backgroundColor: BaSeTheme.colors.defaultColors.white,
        focusTextColor: BaSeTheme.colors.feedbackInterface.sucesso20,
        focusBorderColor: BaSeTheme.colors.feedbackInterface.sucesso20,
        boxShadowFocus: BaSeTheme.colors.feedbackInterface.sucesso70,
    },
    invalid: {
        color: BaSeTheme.colors.feedbackInterface.erro35,
        borderColor: BaSeTheme.colors.feedbackInterface.erro35,
        backgroundColor: BaSeTheme.colors.defaultColors.white,
        focusTextColor: BaSeTheme.colors.feedbackInterface.erro35,
        focusBorderColor: BaSeTheme.colors.feedbackInterface.erro35,
        boxShadowFocus: BaSeTheme.colors.feedbackInterface.erro70,
    },
    disabled: {
        color: BaSeTheme.colors.institucionais.cinzaSebrae75,
        borderColor: BaSeTheme.colors.institucionais.cinzaSebrae75,
        backgroundColor: BaSeTheme.colors.institucionais.cinzaSebrae97,
    },
};
var removeAtributes = function (overrider) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var storageObj = {};
    if (overrider === null || overrider === void 0 ? void 0 : overrider.valid) {
        storageObj.valid = {
            borderColor: (_a = overrider.valid.foreground) !== null && _a !== void 0 ? _a : mapBaSeInputColor.valid.borderColor,
            backgroundColor: (_b = overrider.valid.background) !== null && _b !== void 0 ? _b : mapBaSeInputColor.valid.backgroundColor,
            focusTextColor: (_c = overrider.valid.foreground) !== null && _c !== void 0 ? _c : mapBaSeInputColor.valid.focusTextColor,
            focusBorderColor: (_d = overrider.valid.foreground) !== null && _d !== void 0 ? _d : mapBaSeInputColor.valid.focusBorderColor,
            boxShadowFocus: Color.validateColor(overrider === null || overrider === void 0 ? void 0 : overrider.valid.foreground)
                ? ColorMapper.light.focus.create(overrider.valid.foreground)
                : mapBaSeInputColor.valid.boxShadowFocus,
        };
    }
    if (overrider === null || overrider === void 0 ? void 0 : overrider.invalid) {
        storageObj.invalid = {
            color: (_e = overrider.invalid.foreground) !== null && _e !== void 0 ? _e : mapBaSeInputColor.invalid.color,
            borderColor: (_f = overrider.invalid.foreground) !== null && _f !== void 0 ? _f : mapBaSeInputColor.invalid.borderColor,
            backgroundColor: (_g = overrider.invalid.background) !== null && _g !== void 0 ? _g : mapBaSeInputColor.invalid.backgroundColor,
            focusTextColor: (_h = overrider.invalid.foreground) !== null && _h !== void 0 ? _h : mapBaSeInputColor.invalid.focusTextColor,
            focusBorderColor: (_j = overrider.invalid.foreground) !== null && _j !== void 0 ? _j : mapBaSeInputColor.invalid.focusBorderColor,
            boxShadowFocus: Color.validateColor(overrider === null || overrider === void 0 ? void 0 : overrider.invalid.foreground)
                ? ColorMapper.light.focus.create(overrider.invalid.foreground)
                : mapBaSeInputColor.invalid.boxShadowFocus,
        };
    }
    return __assign({}, storageObj);
};
var inputColorManager = function (color, overrideColor) {
    if (!color) {
        return __assign(__assign({}, mapBaSeInputColor), removeAtributes(overrideColor));
    }
    if (color in ColorMapper) {
        return __assign(__assign(__assign({}, mapBaSeInputColor), removeAtributes(overrideColor)), { normal: __assign(__assign({}, mapBaSeInputColor === null || mapBaSeInputColor === void 0 ? void 0 : mapBaSeInputColor.normal), { focusTextColor: ColorMapper[color].foreground, focusBorderColor: ColorMapper[color].foreground, boxShadowFocus: ColorMapper[color].focus.defaultLight }) });
    }
    if (!Color.validateColor(color)) {
        return __assign(__assign({}, mapBaSeInputColor), removeAtributes(overrideColor));
    }
    return __assign(__assign(__assign({}, mapBaSeInputColor), removeAtributes(overrideColor)), { normal: __assign(__assign({}, mapBaSeInputColor === null || mapBaSeInputColor === void 0 ? void 0 : mapBaSeInputColor.normal), { focusTextColor: color, focusBorderColor: color, boxShadowFocus: ColorMapper.light.focus.create(color) }) });
};
var labelColorsMapper = {
    color: BaSeTheme.colors.institucionais.cinzaSebrae45,
};
var subLabelColorMapper = {
    color: BaSeTheme.colors.institucionais.cinzaSebrae60,
};
var overrideExtraColorsMapper = {
    label: labelColorsMapper.color,
    subLabel: subLabelColorMapper.color,
};
var overrideExtraColors = function (overrideColors) {
    if (!overrideColors) {
        return __assign({}, overrideExtraColorsMapper);
    }
    var overrideObj = __assign({}, overrideExtraColorsMapper);
    var createValidObj = Object.keys(overrideColors);
    createValidObj.forEach(function (obj) {
        if (overrideColors[obj] && obj in overrideExtraColorsMapper) {
            overrideObj[obj] = overrideColors[obj];
        }
    });
    return overrideObj;
};

var none = 'none';
var borderSize = 7;
var transparenteBorder = "".concat(borderSize, "px solid ").concat(BaSeTheme.colors.defaultColors.transparent);
var basePosition = "".concat(-1 * borderSize, "px");
var calcPosition = "calc(50% - ".concat(borderSize, "px)");
var borderSizeSmaller = 6.5;
var filledBorderSmaller = function (color) {
    return color
        ? "".concat(borderSizeSmaller, "px solid ").concat(color)
        : "".concat(borderSizeSmaller, "px solid ").concat(BaSeTheme.colors.defaultColors.white);
};
var transparenteBorderSmaller = "".concat(borderSizeSmaller, "px solid ").concat(BaSeTheme.colors.defaultColors.transparent);
var basePositionSmaller = "".concat(-1 * borderSizeSmaller + 1, "px");
var calcPositionSmaller = "calc(50% - ".concat(borderSizeSmaller, "px)");
var getTriangleMapper = function (themeMode, color, direction, overrideColor) {
    var _a;
    var TriangleProps = {
        dark: {
            neutral: {
                widthTop: none,
                widthRight: none,
                widthBottom: none,
                widthLeft: none,
            },
            top: {
                positionBottom: basePosition,
                positionRight: calcPosition,
                widthTop: "".concat(borderSize, "px solid ").concat(overrideColor || transformLightness(color, 0.15)),
                widthRight: transparenteBorder,
                widthBottom: none,
                widthLeft: transparenteBorder,
            },
            right: {
                positionLeft: basePosition,
                positionBottom: calcPosition,
                widthTop: transparenteBorder,
                widthRight: "".concat(borderSize, "px solid ").concat(overrideColor || transformLightness(color, 0.15)),
                widthBottom: transparenteBorder,
                widthLeft: none,
            },
            bottom: {
                positionTop: basePosition,
                positionRight: calcPosition,
                widthTop: none,
                widthRight: transparenteBorder,
                widthBottom: "".concat(borderSize, "px solid ").concat(overrideColor || transformLightness(color, 0.15)),
                widthLeft: transparenteBorder,
            },
            left: {
                positionRight: basePosition,
                positionBottom: calcPosition,
                widthTop: transparenteBorder,
                widthRight: none,
                widthBottom: transparenteBorder,
                widthLeft: "".concat(borderSize, "px solid ").concat(overrideColor || transformLightness(color, 0.15)),
            },
        },
        light: {
            neutral: {
                widthTop: none,
                widthRight: none,
                widthBottom: none,
                widthLeft: none,
            },
            top: {
                positionBottom: basePosition,
                positionRight: calcPosition,
                widthTop: "".concat(borderSize, "px solid ").concat(overrideColor || transformLightness(color, 0.9)),
                widthRight: transparenteBorder,
                widthBottom: none,
                widthLeft: transparenteBorder,
            },
            right: {
                positionLeft: basePosition,
                positionBottom: calcPosition,
                widthTop: transparenteBorder,
                widthRight: "".concat(borderSize, "px solid ").concat(overrideColor || transformLightness(color, 0.9)),
                widthBottom: transparenteBorder,
                widthLeft: none,
            },
            bottom: {
                positionTop: basePosition,
                positionRight: calcPosition,
                widthTop: none,
                widthRight: transparenteBorder,
                widthBottom: "".concat(borderSize, "px solid ").concat(overrideColor || transformLightness(color, 0.9)),
                widthLeft: transparenteBorder,
            },
            left: {
                positionRight: basePosition,
                positionBottom: calcPosition,
                widthTop: transparenteBorder,
                widthRight: none,
                widthBottom: transparenteBorder,
                widthLeft: "".concat(borderSize, "px solid ").concat(overrideColor || transformLightness(color, 0.9)),
            },
        },
    };
    return TriangleProps[themeMode]
        ? (_a = TriangleProps[themeMode][direction]) !== null && _a !== void 0 ? _a : TriangleProps[themeMode].neutral
        : TriangleProps.dark.neutral;
};
var getTriangleMapperSmaller = function (themeMode, color, direction, overrideColor) {
    var _a;
    var TrianglePropsSmaller = {
        dark: {
            neutral: {
                widthTop: none,
                widthRight: none,
                widthBottom: none,
                widthLeft: none,
            },
            top: {
                positionBottom: basePositionSmaller,
                positionRight: calcPositionSmaller,
                widthTop: "".concat(borderSizeSmaller, "px solid ").concat(overrideColor || transformLightness(color, 0.15)),
                widthRight: transparenteBorderSmaller,
                widthBottom: none,
                widthLeft: transparenteBorderSmaller,
            },
            right: {
                positionLeft: basePositionSmaller,
                positionBottom: calcPositionSmaller,
                widthTop: transparenteBorderSmaller,
                widthRight: "".concat(borderSizeSmaller, "px solid ").concat(overrideColor || transformLightness(color, 0.15)),
                widthBottom: transparenteBorderSmaller,
                widthLeft: none,
            },
            bottom: {
                positionTop: basePositionSmaller,
                positionRight: calcPositionSmaller,
                widthTop: none,
                widthRight: transparenteBorderSmaller,
                widthBottom: "".concat(borderSizeSmaller, "px solid ").concat(overrideColor || transformLightness(color, 0.15)),
                widthLeft: transparenteBorderSmaller,
            },
            left: {
                positionRight: basePositionSmaller,
                positionBottom: calcPositionSmaller,
                widthTop: transparenteBorderSmaller,
                widthRight: none,
                widthBottom: transparenteBorderSmaller,
                widthLeft: "".concat(borderSizeSmaller, "px solid ").concat(overrideColor || transformLightness(color, 0.15)),
            },
        },
        light: {
            neutral: {
                widthTop: none,
                widthRight: none,
                widthBottom: none,
                widthLeft: none,
            },
            top: {
                positionBottom: basePositionSmaller,
                positionRight: calcPositionSmaller,
                widthTop: filledBorderSmaller(overrideColor),
                widthRight: transparenteBorderSmaller,
                widthBottom: none,
                widthLeft: transparenteBorderSmaller,
            },
            right: {
                positionLeft: basePositionSmaller,
                positionBottom: calcPositionSmaller,
                widthTop: transparenteBorderSmaller,
                widthRight: filledBorderSmaller(overrideColor),
                widthBottom: transparenteBorderSmaller,
                widthLeft: none,
            },
            bottom: {
                positionTop: basePositionSmaller,
                positionRight: calcPositionSmaller,
                widthTop: none,
                widthRight: transparenteBorderSmaller,
                widthBottom: filledBorderSmaller(overrideColor),
                widthLeft: transparenteBorderSmaller,
            },
            left: {
                positionRight: basePositionSmaller,
                positionBottom: calcPositionSmaller,
                widthTop: transparenteBorderSmaller,
                widthRight: none,
                widthBottom: transparenteBorderSmaller,
                widthLeft: filledBorderSmaller(overrideColor),
            },
        },
    };
    return TrianglePropsSmaller[themeMode]
        ? (_a = TrianglePropsSmaller[themeMode][direction]) !== null && _a !== void 0 ? _a : TrianglePropsSmaller[themeMode].neutral
        : TrianglePropsSmaller.dark.neutral;
};
var PopoverColorMapper = {
    default: BaSeTheme.colors.institucionais.azulSebrae36,
    destructive: BaSeTheme.colors.feedbackInterface.erro45,
    attention: BaSeTheme.colors.feedbackInterface.atencao55,
    confirmation: BaSeTheme.colors.feedbackInterface.sucesso26,
};

var PopoverContainer = styled.div.attrs({
    className: 'BaSe--popover',
})(templateObject_1$x || (templateObject_1$x = __makeTemplateObject(["\n  ", "\n  ", "\n  opacity: ", ";\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  min-width: ", "px;\n  z-index: ", ";\n  transition: ", ";\n  will-change: opacity;\n"], ["\n  ", "\n  ", "\n  opacity: ", ";\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  min-width: ", "px;\n  z-index: ", ";\n  transition: ", ";\n  will-change: opacity;\n"])), function (props) { return (props.open ? 'visibility: visible;' : 'visibility: hidden;'); }, function (props) { return !props.open && 'pointer-events: none;'; }, function (props) { return (props.open ? 1 : 0); }, function (props) { return props.top && 'top:' + props.top + ';'; }, function (props) { return props.right && 'right:' + props.right + ';'; }, function (props) { return props.bottom && 'bottom:' + props.bottom + ';'; }, function (props) { return props.left && 'left:' + props.left + ';'; }, function (props) { return props.width; }, BaSeTheme.stackOrder.aboveNormal, BaSeTheme.transitions.allPropertiesContinuousNormal);
var PopoverCard = styled.div.attrs({
    className: 'BaSe--popover-card',
})(templateObject_2$s || (templateObject_2$s = __makeTemplateObject(["\n  border-radius: 4px;\n  padding: 12px 24px 16px 16px;\n  position: relative;\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  box-shadow: ", ";\n"], ["\n  border-radius: 4px;\n  padding: 12px 24px 16px 16px;\n  position: relative;\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  box-shadow: ", ";\n"])), function (_a) {
    var color = _a.color, themeMode = _a.themeMode, overrideColors = _a.overrideColors;
    return (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor) ||
        (themeMode === 'light'
            ? BaSeTheme.colors.defaultColors.white
            : transformLightness(color, 0.15));
}, function (_a) {
    var color = _a.color, themeMode = _a.themeMode, overrideColors = _a.overrideColors;
    return (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.borderColor) ||
        (themeMode === 'light'
            ? transformLightness(color, 0.9)
            : transformLightness(color, 0.15));
}, BaSeTheme.shadows.profundidade4);
var PopoverCardTitleContainer = styled.div(templateObject_3$l || (templateObject_3$l = __makeTemplateObject(["\n  padding-bottom: 1px;\n  align-items: center;\n  > small {\n    font-weight: bold;\n    color: ", ";\n  }\n"], ["\n  padding-bottom: 1px;\n  align-items: center;\n  > small {\n    font-weight: bold;\n    color: ", ";\n  }\n"])), function (_a) {
    var color = _a.color, themeMode = _a.themeMode, overrideColors = _a.overrideColors;
    return (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.titleColor) ||
        (themeMode === 'light'
            ? color
            : transformLightness(color, 0.9));
});
var PopoverCardBodyContainer = styled.div(templateObject_4$i || (templateObject_4$i = __makeTemplateObject(["\n  > small {\n    color: ", ";\n  }\n"], ["\n  > small {\n    color: ", ";\n  }\n"])), function (_a) {
    var themeMode = _a.themeMode, overrideColors = _a.overrideColors;
    return (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.foreground) ||
        (themeMode === 'light'
            ? BaSeTheme.colors.institucionais.cinzaSebrae45
            : BaSeTheme.colors.defaultColors.white);
});
var PopoverCardContentContainer = styled.div(templateObject_5$f || (templateObject_5$f = __makeTemplateObject(["\n  &:not(:empty) {\n    margin-top: 8px;\n  }\n"], ["\n  &:not(:empty) {\n    margin-top: 8px;\n  }\n"])));
var PopoverButtonContainer = styled.div(templateObject_6$e || (templateObject_6$e = __makeTemplateObject(["\n  position: absolute;\n  right: 8px;\n  top: 8px;\n\n  > button {\n    width: 20px;\n    height: 20px;\n    > img {\n      width: 12px;\n      height: 12px;\n    }\n  }\n"], ["\n  position: absolute;\n  right: 8px;\n  top: 8px;\n\n  > button {\n    width: 20px;\n    height: 20px;\n    > img {\n      width: 12px;\n      height: 12px;\n    }\n  }\n"])));
var PopoverTriangle = styled.div(templateObject_7$b || (templateObject_7$b = __makeTemplateObject(["\n  width: 0;\n  height: 0;\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  border-top: ", ";\n  border-right: ", ";\n  border-left: ", ";\n  border-bottom: ", ";\n  z-index: ", ";\n"], ["\n  width: 0;\n  height: 0;\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  border-top: ", ";\n  border-right: ", ";\n  border-left: ", ";\n  border-bottom: ", ";\n  z-index: ", ";\n"])), function (props) { return props.positionTop && "top: ".concat(props.positionTop, ";"); }, function (props) { return props.positionRight && "right: ".concat(props.positionRight, ";"); }, function (props) { return props.positionLeft && "left: ".concat(props.positionLeft, ";"); }, function (props) { return props.positionBottom && "bottom: ".concat(props.positionBottom, ";"); }, function (props) { return props.widthTop; }, function (props) { return props.widthRight; }, function (props) { return props.widthLeft; }, function (props) { return props.widthBottom; }, BaSeTheme.stackOrder.aboveNormal + 1);
var PopoverTriangleSmaller = styled.div(templateObject_8$a || (templateObject_8$a = __makeTemplateObject(["\n  width: 0;\n  height: 0;\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  border-top: ", ";\n  border-right: ", ";\n  border-left: ", ";\n  border-bottom: ", ";\n  z-index: ", ";\n"], ["\n  width: 0;\n  height: 0;\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  border-top: ", ";\n  border-right: ", ";\n  border-left: ", ";\n  border-bottom: ", ";\n  z-index: ", ";\n"])), function (props) { return props.positionTop && "top: ".concat(props.positionTop, ";"); }, function (props) { return props.positionRight && "right: ".concat(props.positionRight, ";"); }, function (props) { return props.positionLeft && "left: ".concat(props.positionLeft, ";"); }, function (props) { return props.positionBottom && "bottom: ".concat(props.positionBottom, ";"); }, function (props) { return props.widthTop; }, function (props) { return props.widthRight; }, function (props) { return props.widthLeft; }, function (props) { return props.widthBottom; }, BaSeTheme.stackOrder.aboveNormal + 2);
var templateObject_1$x, templateObject_2$s, templateObject_3$l, templateObject_4$i, templateObject_5$f, templateObject_6$e, templateObject_7$b, templateObject_8$a;

var BaSePopover = function (_a) {
    var _b;
    var width = _a.width, _c = _a.title, title = _c === void 0 ? '' : _c, _d = _a.message, message = _d === void 0 ? '' : _d, _e = _a.direction, direction = _e === void 0 ? 'neutral' : _e, _f = _a.color, color = _f === void 0 ? 'default' : _f, _g = _a.themeMode, themeMode = _g === void 0 ? 'light' : _g, _h = _a.coordinates, coordinates = _h === void 0 ? {} : _h, _j = _a.delayToOpen, delayToOpen = _j === void 0 ? 0 : _j, _k = _a.open, externalOpen = _k === void 0 ? false : _k, overrideColors = _a.overrideColors, _l = _a.handleClose, handleClose = _l === void 0 ? function () { } : _l, _m = _a.refOutput, refOutput = _m === void 0 ? function () { } : _m, _o = _a.renderContent, renderContent = _o === void 0 ? function () { return null; } : _o;
    var open = useDebounce(externalOpen, externalOpen ? delayToOpen : 0);
    var mappedColor = (_b = PopoverColorMapper[color]) !== null && _b !== void 0 ? _b : color;
    var TriangleProps = React.useCallback(function () {
        return getTriangleMapper(themeMode, mappedColor, direction, overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.borderColor);
    }, [themeMode, mappedColor, direction, overrideColors]);
    var TrianglePropsSmaller = React.useCallback(function () {
        return getTriangleMapperSmaller(themeMode, mappedColor, direction, overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.backgroundColor);
    }, [themeMode, mappedColor, direction, overrideColors]);
    var top = coordinates.top, left = coordinates.left, bottom = coordinates.bottom, right = coordinates.right;
    var ref = React.useRef(null);
    React.useEffect(function () {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            refOutput(ref === null || ref === void 0 ? void 0 : ref.current);
        }
    }, [ref, message]);
    return (React.createElement(PopoverContainer, { "aria-hidden": !open, open: open, ref: ref, top: top, left: left, bottom: bottom, right: right, width: width },
        React.createElement(PopoverTriangle, __assign({}, TriangleProps())),
        React.createElement(PopoverTriangleSmaller, __assign({}, TrianglePropsSmaller())),
        React.createElement(PopoverCard, { color: mappedColor, themeMode: themeMode, overrideColors: overrideColors },
            React.createElement(PopoverCardTitleContainer, { color: mappedColor, themeMode: themeMode, overrideColors: overrideColors },
                React.createElement(BaSeSmall1, null, title),
                React.createElement(PopoverButtonContainer, null,
                    React.createElement(BaSeShapeButton, { buttonType: "button", onClick: handleClose, nameIcon: "multiply", shape: "circle", size: "small", sizeIcon: "medium", color: (overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.titleColor) ||
                            (themeMode === 'light'
                                ? color
                                : transformLightness(mappedColor, 0.9)), type: "tertiary" }))),
            React.createElement(PopoverCardBodyContainer, { overrideColors: overrideColors, themeMode: themeMode },
                React.createElement(BaSeSmall1, null, message),
                React.createElement(PopoverCardContentContainer, null, renderContent())))));
};
BaSePopover.displayName = 'BaSePopover';

var Coordinates = function (width, height, size) {
    if (height === void 0) { height = null; }
    if (size === void 0) { size = 13; }
    var half = (size / 2) + 4; // Add de 4 pixels pelo padding do ShapeButton
    var spaceToIcon = 5;
    var boundaries = 7;
    return ({
        top: {
            bottom: "calc(100% + ".concat(spaceToIcon, "px)"),
            left: "calc(-".concat(width / 2, "px + ").concat(half, "px)"),
        },
        right: {
            top: height ? "calc(-".concat(height / 2, "px + ").concat(half, "px)") : '',
            left: "calc(100% + ".concat(boundaries, "px)"),
        },
        left: {
            top: height ? "calc(-".concat(height / 2, "px + ").concat(half, "px)") : '',
            right: "calc(100% + ".concat(boundaries, "px)"),
        },
        bottom: {
            top: "calc(100% + ".concat(spaceToIcon, "px)"),
            left: "calc(-".concat(width / 2, "px + ").concat(half, "px)"),
        },
        neutral: {
            bottom: "calc(100% + ".concat(spaceToIcon, "px)"),
            left: "calc(-".concat(width / 2, "px + ").concat(half, "px)"),
        },
    });
};

var handleProps = function (size) {
    if (!size) {
        return undefined;
    }
    return numberWithUnit(size);
};
var HelperButtonContainer = styled.div.attrs({
    className: 'BaSe--helper-button-container',
})(templateObject_1$w || (templateObject_1$w = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var HelperButtonIconContainer = styled.div(templateObject_2$r || (templateObject_2$r = __makeTemplateObject(["\n  cursor: pointer;\n  button {\n    padding: 4px;\n  }\n\n  img {\n    width: ", ";\n    height: ", ";\n  }\n"], ["\n  cursor: pointer;\n  button {\n    padding: 4px;\n  }\n\n  img {\n    width: ", ";\n    height: ", ";\n  }\n"])), function (props) { var _a; return (_a = handleProps(props.size)) !== null && _a !== void 0 ? _a : '13px'; }, function (props) { var _a; return (_a = handleProps(props.size)) !== null && _a !== void 0 ? _a : '13px'; });
var templateObject_1$w, templateObject_2$r;

var defaultIconName = 'question-circle';
var defaultIconSize = 13;
var defaultIconColor = 'default';
var BaSePopupButton = function (_a) {
    var _b, _c, _d;
    var _e = _a.direction, direction = _e === void 0 ? 'top' : _e, _f = _a.type, type = _f === void 0 ? 'tooltip' : _f, _g = _a.tooltipColor, tooltipColor = _g === void 0 ? 'default' : _g, _h = _a.alertSize, alertSize = _h === void 0 ? type === 'tooltip' ? 106 : 180 : _h, _j = _a.message, message = _j === void 0 ? '' : _j, _k = _a.title, title = _k === void 0 ? '' : _k, _l = _a.iconProps, iconProps = _l === void 0 ? {
        name: defaultIconName,
        color: defaultIconColor,
        size: defaultIconSize,
        onClick: function () { },
    } : _l, overrideColors = _a.overrideColors;
    var _m = React.useState(Coordinates(alertSize, null, (_b = iconProps === null || iconProps === void 0 ? void 0 : iconProps.size) !== null && _b !== void 0 ? _b : defaultIconSize)[direction]), coordinates = _m[0], setCoordinates = _m[1];
    var handleRef = function (e) {
        var _a;
        setCoordinates(Coordinates(alertSize, e === null || e === void 0 ? void 0 : e.offsetHeight, (_a = iconProps === null || iconProps === void 0 ? void 0 : iconProps.size) !== null && _a !== void 0 ? _a : defaultIconSize)[direction]);
    };
    var _o = React.useState(false), open = _o[0], setOpen = _o[1];
    var helperButtonRef = React.useRef(null);
    useOutsideEvent(helperButtonRef, function (e) { return setOpen(e); });
    return (React.createElement(HelperButtonContainer, { ref: helperButtonRef },
        React.createElement(HelperButtonIconContainer, { size: (_c = iconProps.size) !== null && _c !== void 0 ? _c : defaultIconSize, onClick: function () { return setOpen(function (prev) { return !prev; }); } },
            React.createElement(BaSeShapeButton, { buttonType: "button", type: "tertiary", size: "medium", nameIcon: (_d = iconProps.name) !== null && _d !== void 0 ? _d : defaultIconName, color: ColorMapper.getColor(iconProps === null || iconProps === void 0 ? void 0 : iconProps.color, defaultIconColor), onClick: function (e) { var _a; return (_a = iconProps === null || iconProps === void 0 ? void 0 : iconProps.onClick) === null || _a === void 0 ? void 0 : _a.call(iconProps, e); } })),
        type === 'tooltip' ? (React.createElement(BaSeTooltip, { width: alertSize, open: open, direction: direction, message: message, color: tooltipColor, coordinates: coordinates, refOutput: handleRef, overrideColors: overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.alert })) : (React.createElement(BaSePopover, { width: alertSize, open: open, direction: direction, message: message, coordinates: coordinates, refOutput: handleRef, title: title, overrideColors: overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.alert, handleClose: function () { return setOpen(false); } }))));
};
BaSePopupButton.displayName = 'BaSePopupButton';

var WrapperInputlabel$1 = styled.div.attrs({
    className: 'BaSe--input-wrapper-label',
})(templateObject_2$q || (templateObject_2$q = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  z-index: ", ";\n  background-color: ", ";\n  position: relative;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 2px;\n  ", "\n"], ["\n  display: flex;\n  flex-direction: row;\n  z-index: ", ";\n  background-color: ", ";\n  position: relative;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 2px;\n  ", "\n"])), BaSeTheme.stackOrder.normal, BaSeTheme.colors.defaultColors.transparent, function (_a) {
    var isEmpty = _a.isEmpty;
    return isEmpty && css(templateObject_1$v || (templateObject_1$v = __makeTemplateObject(["\n      margin-bottom: 0px;\n    "], ["\n      margin-bottom: 0px;\n    "])));
});
var StyledLabel$3 = styled.label.attrs({
    className: 'BaSe--input-label',
})(templateObject_4$h || (templateObject_4$h = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var fontSize = _a.fontSize, lineHeight = _a.lineHeight, color = _a.color;
    return css(templateObject_3$k || (templateObject_3$k = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n    font-family: ", ";\n    font-style: normal;\n    font-weight: normal;\n  "], ["\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n    font-family: ", ";\n    font-style: normal;\n    font-weight: normal;\n  "])), fontSize, lineHeight, color, BaSeTheme.typography.fontFamily);
});
var StyledSubLabel$2 = styled.label.attrs({
    className: 'BaSe--input-sub-label',
})(templateObject_6$d || (templateObject_6$d = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var fontSize = _a.fontSize, lineHeight = _a.lineHeight, color = _a.color;
    return css(templateObject_5$e || (templateObject_5$e = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: ", ";\n    font-family: ", ";\n    font-weight: normal;\n    color: ", ";\n    font-style: italic;\n    margin-left: 4px;\n  "], ["\n    font-size: ", ";\n    line-height: ", ";\n    font-family: ", ";\n    font-weight: normal;\n    color: ", ";\n    font-style: italic;\n    margin-left: 4px;\n  "])), fontSize, lineHeight, BaSeTheme.typography.fontFamily, color);
});
var ButtonInfoContainer$2 = styled.div(templateObject_7$a || (templateObject_7$a = __makeTemplateObject(["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var templateObject_1$v, templateObject_2$q, templateObject_3$k, templateObject_4$h, templateObject_5$e, templateObject_6$d, templateObject_7$a;

var BaSeFormLabel = function (_a) {
    var _b, _c;
    var id = _a.id, size = _a.size, label = _a.label, subLabel = _a.subLabel, showHelpButton = _a.showHelpButton, helpButtonProps = _a.helpButtonProps, colors = _a.colors, getContainerHeight = _a.getContainerHeight;
    var containerRef = React.useRef(null);
    var isEmpty = React.useCallback(function () { return !label && !subLabel && !showHelpButton; }, [label, subLabel, showHelpButton]);
    var handleResize = React.useCallback(function () {
        var _a, _b;
        if (((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) &&
            getContainerHeight &&
            !isEmpty()) {
            getContainerHeight(((_b = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) + 2); // 2px da margin-bottom
        }
    }, [containerRef, isEmpty, getContainerHeight]);
    React.useLayoutEffect(function () {
        handleResize();
    }, [handleResize]);
    React.useEffect(function () {
        window.addEventListener('resize', function () { return handleResize(); });
        return window.removeEventListener('resize', function () { return handleResize(); });
    }, []);
    return (React.createElement(WrapperInputlabel$1, { ref: containerRef, isEmpty: isEmpty() },
        React.createElement(StyledLabel$3, { fontSize: size === 'small' ? '13px' : '16px', lineHeight: size === 'small' ? '16px' : '23px', htmlFor: id, color: (_b = colors === null || colors === void 0 ? void 0 : colors.label) !== null && _b !== void 0 ? _b : BaSeTheme.colors.institucionais.cinzaSebrae45 }, label),
        React.createElement(StyledSubLabel$2, { fontSize: size === 'small' ? '13px' : '16px', lineHeight: size === 'small' ? '16px' : '23px', htmlFor: id, color: (_c = colors === null || colors === void 0 ? void 0 : colors.subLabel) !== null && _c !== void 0 ? _c : BaSeTheme.colors.institucionais.cinzaSebrae60 }, subLabel),
        showHelpButton && (React.createElement(ButtonInfoContainer$2, null,
            React.createElement(BaSePopupButton, __assign({}, helpButtonProps))))));
};

var idSequence$7 = idGenerator();
var moneyDecimalMask = 'decimal';
var statusManager = {
    invalid: 0,
    valid: 1,
    normal: 2,
    disabled: 3,
};
var InpupMaskedWrapper = function (_a) {
    var validateMask = _a.validateMask, onFocus = _a.onFocus, onBlur = _a.onBlur, onKeyDownHandler = _a.onKeyDownHandler, value = _a.value, onChangeValue = _a.onChangeValue, isDisabled = _a.isDisabled, isReadOnly = _a.isReadOnly, handleMaskType = _a.handleMaskType, children = _a.children;
    if (validateMask) {
        return (React.createElement(InputMask, { onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDownHandler, value: value, onChange: onChangeValue, mask: handleMaskType, disabled: isDisabled, readOnly: isReadOnly }, function (inputProps) {
            if (React.isValidElement(children)) {
                return React.cloneElement(children, __assign({}, inputProps));
            }
            return children;
        }));
    }
    return children;
};
var BaSeInput = React.forwardRef(function (_a, externalRef) {
    var _b, _c, _d, _e, _f, _g, _h;
    var _j = _a.isLoading, isLoading = _j === void 0 ? false : _j, _k = _a.isDisabled, isDisabled = _k === void 0 ? false : _k, _l = _a.isReadOnly, isReadOnly = _l === void 0 ? false : _l, _m = _a.showHelpButton, showHelpButton = _m === void 0 ? false : _m, _o = _a.placeholder, placeholder = _o === void 0 ? '' : _o, _p = _a.label, label = _p === void 0 ? '' : _p, _q = _a.complement, complement = _q === void 0 ? '' : _q, _r = _a.moreInfoLabel, moreInfoLabel = _r === void 0 ? '' : _r, _s = _a.moreInfoDetails, moreInfoDetails = _s === void 0 ? '' : _s, _t = _a.size, size = _t === void 0 ? 'medium' : _t, _u = _a.typeInput, typeInput = _u === void 0 ? 'text' : _u, _v = _a.inputMode, inputMode = _v === void 0 ? 'text' : _v, _w = _a.value, value = _w === void 0 ? '' : _w, _x = _a.width, width = _x === void 0 ? '100%' : _x, _y = _a.subLabel, subLabel = _y === void 0 ? '' : _y, _z = _a.helpButtonProps, helpButtonProps = _z === void 0 ? {} : _z, _0 = _a.onSpecificKeyDown, onSpecificKeyDown = _0 === void 0 ? [] : _0, mask = _a.mask, _1 = _a.color, color = _1 === void 0 ? 'default' : _1, _2 = _a.overrideColors, overrideColors = _2 === void 0 ? {} : _2, _3 = _a.iconButton, iconButton = _3 === void 0 ? {
        typeButton: '',
        name: '',
        action: function () { },
        type: 'primary',
        value: '',
    } : _3, _4 = _a.inputStatus, inputStatus = _4 === void 0 ? 'normal' : _4, _5 = _a.onChange, onChange = _5 === void 0 ? function () { } : _5, _6 = _a.onBlur, onBlur = _6 === void 0 ? function () { } : _6, _7 = _a.onFocus, onFocus = _7 === void 0 ? function () { } : _7, onDirty = _a.onDirty, onMutated = _a.onModified;
    if (!['text', 'password', 'email', 'tel', 'url'].includes(typeInput)) {
        throw Error('Atributo "typeInput" deve ser do tipo: text ou password ou email ou tel ou url');
    }
    if (!['text', 'decimal', 'email', 'tel', 'url', 'search'].includes(inputMode)) {
        throw Error('Atributo "inputMode" deve ser do tipo: text ou decimal ou email ou tel ou url');
    }
    var id = getNextHash(idSequence$7);
    var _8 = React.useState(false), mutated = _8[0], setMutated = _8[1];
    var _9 = React.useState(false), dirty = _9[0], setDirty = _9[1];
    var copyValue = React.useState(value)[0];
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var inputRef = React.useRef(null);
    var _10 = React.useState(false), hasFocus = _10[0], setHasFocus = _10[1];
    var handleFocus = React.useCallback(function (e) {
        setHasFocus(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
    }, [onFocus, setHasFocus]);
    var handleBlur = React.useCallback(function (e) {
        setHasFocus(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    }, [onBlur, setHasFocus]);
    var handleInputStatus = React.useCallback(function () {
        var _a;
        if (isDisabled) {
            return statusManager.disabled;
        }
        if (!dirty && !mutated) {
            return statusManager.normal;
        }
        return (_a = statusManager[inputStatus !== null && inputStatus !== void 0 ? inputStatus : 'normal']) !== null && _a !== void 0 ? _a : statusManager.normal;
    }, [inputStatus, isDisabled, dirty, mutated]);
    var getColorsFromState = React.useCallback(function () {
        return inputColorManager(color, overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.status)[isDisabled
            ? 'disabled'
            : !dirty && !mutated
                ? 'normal'
                : inputStatus !== null && inputStatus !== void 0 ? inputStatus : 'normal'];
    }, [isDisabled, color, inputStatus, overrideColors, dirty, mutated]);
    var getOverriddeColorsExtra = React.useCallback(function () {
        return overrideExtraColors(overrideColors);
    }, [overrideColors]);
    var handleIconColorBaseIcon = React.useCallback(function (ignoreFocus) {
        var _a, _b, _c, _d;
        if (ignoreFocus) {
            return (_a = iconButton.color) !== null && _a !== void 0 ? _a : (_b = getColorsFromState()) === null || _b === void 0 ? void 0 : _b.focusTextColor;
        }
        return ((_c = iconButton.color) !== null && _c !== void 0 ? _c : (_d = getColorsFromState()) === null || _d === void 0 ? void 0 : _d[hasFocus ? 'focusTextColor' : 'color']);
    }, [hasFocus, getColorsFromState]);
    var getValidTopIconPositions = React.useCallback(function () {
        var _a;
        var topPositionMap = {
            small: 8,
            medium: 12,
            big: 16,
        };
        return (iconButton === null || iconButton === void 0 ? void 0 : iconButton.typeButton)
            ? (iconButton === null || iconButton === void 0 ? void 0 : iconButton.typeButton) !== 'base-icon'
                ? 2
                : 0
            : (_a = topPositionMap[size !== null && size !== void 0 ? size : 'medium']) !== null && _a !== void 0 ? _a : topPositionMap === null || topPositionMap === void 0 ? void 0 : topPositionMap.medium;
    }, [size, iconButton === null || iconButton === void 0 ? void 0 : iconButton.typeButton]);
    var _11 = React.useState(false), showPassword = _11[0], setShowPassword = _11[1];
    var _12 = React.useState(false), preventUpdate = _12[0], setPreventUpdate = _12[1];
    var hascomplement = complement !== '';
    var onClickIconButton = React.useCallback(function () {
        var _a, _b, _c;
        if (typeInput === 'password') {
            return setShowPassword(function (actualShowPassword) { return !actualShowPassword; });
        }
        (_a = iconButton === null || iconButton === void 0 ? void 0 : iconButton.action) === null || _a === void 0 ? void 0 : _a.call(iconButton);
        (_c = (_b = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _b === void 0 ? void 0 : _b.focus) === null || _c === void 0 ? void 0 : _c.call(_b);
    }, [typeInput, iconButton, inputRef]);
    var onChangeValue = function (newValue) {
        var _a, _b;
        if (mask === moneyDecimalMask) {
            onChange(currencyMask((_a = newValue === null || newValue === void 0 ? void 0 : newValue.currentTarget) === null || _a === void 0 ? void 0 : _a.value));
        }
        else {
            onChange((_b = newValue === null || newValue === void 0 ? void 0 : newValue.currentTarget) === null || _b === void 0 ? void 0 : _b.value);
        }
    };
    var onKeyDownHandler = React.useCallback(function (event) {
        var _a;
        for (var _i = 0, onSpecificKeyDown_1 = onSpecificKeyDown; _i < onSpecificKeyDown_1.length; _i++) {
            var keyListener = onSpecificKeyDown_1[_i];
            if ((keyListener === null || keyListener === void 0 ? void 0 : keyListener.listenerKey) === event.key) {
                (_a = keyListener === null || keyListener === void 0 ? void 0 : keyListener.callback) === null || _a === void 0 ? void 0 : _a.call(keyListener, event);
            }
        }
    }, [onSpecificKeyDown]);
    var handleHelperColor = function () {
        var _a, _b;
        var type = translationValueToName[handleInputStatus()];
        return (_b = (_a = mapBaSeInputColor[type]) === null || _a === void 0 ? void 0 : _a.color) !== null && _b !== void 0 ? _b : mapBaSeInputColor.normal.color;
    };
    var handleMaskExist = React.useCallback(function () {
        return !!(mask && mask !== moneyDecimalMask);
    }, [mask]);
    var handleMaskType = React.useCallback(function () {
        var _a;
        return mask && mask !== moneyDecimalMask
            ? (_a = MappedInputMasks[mask]) !== null && _a !== void 0 ? _a : mask
            : null;
    }, [mask]);
    React.useEffect(function () {
        if (!!mask && mask === moneyDecimalMask && !preventUpdate && !!value) {
            onChange(currencyMask(value));
            setPreventUpdate(true);
        }
    }, [value, mask]);
    React.useEffect(function () {
        var ref = {
            focus: function () {
                var _a, _b;
                (_b = (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
            },
        };
        if (typeof externalRef === 'function') {
            externalRef(ref);
        }
        else if (externalRef) {
            externalRef.current = ref;
        }
    }, [externalRef]);
    var getOriginalValueFromMaskedInput = React.useCallback(function () {
        var _a, _b;
        if (!!mask) {
            return mask in rawValueMask || mask === 'decimal'
                ? ((_a = rawValueMask === null || rawValueMask === void 0 ? void 0 : rawValueMask[mask]) === null || _a === void 0 ? void 0 : _a.call(rawValueMask, value + '')) !==
                    ((_b = rawValueMask === null || rawValueMask === void 0 ? void 0 : rawValueMask[mask]) === null || _b === void 0 ? void 0 : _b.call(rawValueMask, copyValue + ''))
                : substringContainMask(copyValue, value);
        }
        return value !== copyValue;
    }, [value, copyValue]);
    React.useEffect(function () { return setDirty(getOriginalValueFromMaskedInput()); }, [value, copyValue]);
    React.useEffect(function () { return onDirty === null || onDirty === void 0 ? void 0 : onDirty(dirty); }, [dirty]);
    React.useEffect(function () { return onMutated === null || onMutated === void 0 ? void 0 : onMutated(mutated); }, [mutated]);
    React.useEffect(function () {
        if (!!preventUpdate) {
            setPreventUpdate(false);
        }
        return;
    }, [preventUpdate]);
    return (React.createElement(ContainerInput, { width: width },
        React.createElement(BaSeFormLabel, { id: id, label: label, subLabel: subLabel, showHelpButton: showHelpButton, helpButtonProps: helpButtonProps, colors: {
                label: (_b = getOverriddeColorsExtra()) === null || _b === void 0 ? void 0 : _b.label,
                subLabel: (_c = getOverriddeColorsExtra()) === null || _c === void 0 ? void 0 : _c.subLabel,
            } }),
        React.createElement(WrapperInput, null,
            React.createElement(InpupMaskedWrapper, { validateMask: handleMaskExist(), onFocus: handleFocus, onBlur: handleBlur, onKeyDownHandler: onKeyDownHandler, value: value, onChangeValue: onChangeValue, onInput: function () { return setMutated(true); }, isDisabled: isDisabled, isReadOnly: isReadOnly, handleMaskType: handleMaskType() },
                React.createElement(StyledInput, { id: id, ref: inputRef, size: iconButton.type === 'secondary'
                        ? ((_d = mapBaSeInputSize[size]) !== null && _d !== void 0 ? _d : mapBaSeInputSize.medium) + 2
                        : (_e = mapBaSeInputSize[size]) !== null && _e !== void 0 ? _e : mapBaSeInputSize.medium, value: mask === 'decimal' ? currencyMask(value) : value, type: typeInput === 'password'
                        ? !showPassword
                            ? 'password'
                            : 'text'
                        : typeInput, inputMode: inputMode, disabled: isDisabled, readOnly: isReadOnly, placeholder: placeholder, onChange: onChangeValue, onInput: function () { return setMutated(true); }, onFocus: handleFocus, onBlur: handleBlur, onKeyDown: onKeyDownHandler, customColors: getColorsFromState(), paddingRight: typeInput === 'password' ||
                        iconButton.typeButton === 'base-icon'
                        ? 26
                        : 12 })),
            React.createElement(ContainerIcon, { rotation: typeInput === 'password' && showPassword, padding: isLoading ||
                    typeInput === 'password' ||
                    iconButton.typeButton === 'base-icon'
                    ? size === 'small'
                        ? 8
                        : 12
                    : 0 }, isLoading ? (React.createElement(BaSeLoadingSpinner, { description: getMessage('loading.description'), diameter: size === 'big' ? 24 : 16, color: handleIconColorBaseIcon() })) : (React.createElement(React.Fragment, null,
                inputStatus === 'valid' && (dirty || mutated) && (React.createElement(CheckIconWrapper, { top: getValidTopIconPositions() },
                    React.createElement(BaSeIcon, { description: "Campo validado", name: "check", color: handleIconColorBaseIcon(true), size: 18 }))),
                (typeInput === 'password' ||
                    iconButton.typeButton === 'base-icon') && (React.createElement(BaSeIcon, { description: iconButton.value !== '' && iconButton.value !== undefined
                        ? iconButton.value
                        : typeInput === 'password'
                            ? !showPassword
                                ? getMessage('buttonIcon.showPassword')
                                : getMessage('buttonIcon.hidePassword')
                            : getMessage('buttonIcon.inputIcon'), name: typeInput === 'password'
                        ? !showPassword
                            ? 'eye-slash'
                            : 'eye'
                        : (_f = iconButton.name) !== null && _f !== void 0 ? _f : '', size: size === 'big' ? 24 : 16, color: handleIconColorBaseIcon(true), onClick: onClickIconButton })),
                iconButton.typeButton === 'base-button' && (React.createElement(BaSeButton, { value: iconButton.value, onClick: onClickIconButton, type: iconButton.type, leftIcon: iconButton.name, size: size, buttonType: "button", isDisabled: isDisabled, color: handleIconColorBaseIcon(true) })),
                iconButton.typeButton === 'base-shape-button' && (React.createElement(BaSeShapeButton, { onClick: onClickIconButton, buttonType: "button", nameIcon: (_g = iconButton.name) !== null && _g !== void 0 ? _g : '', shape: "square", size: size, type: iconButton.type, isDisabled: isDisabled, color: handleIconColorBaseIcon(true) })))))),
        hascomplement && (React.createElement(WrapperHelper$2, null,
            React.createElement(BaSeHelperText, { isItalic: true, color: (_h = overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.complement) !== null && _h !== void 0 ? _h : handleHelperColor(), label: complement }))),
        !!moreInfoLabel && (React.createElement(MoreInfoContainer$3, null,
            React.createElement(BaSeHelperText, { color: overrideColors === null || overrideColors === void 0 ? void 0 : overrideColors.moreInfo, size: "small", label: moreInfoLabel, details: moreInfoDetails })))));
});
BaSeInput.displayName = 'BaSeInput';

var BaSeScrollbarCss = css(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n  &::-webkit-scrollbar {\n    width: 4px;\n    background: ", ";\n    border-radius: 100px;\n    cursor: pointer;\n  }\n\n  &::-webkit-scrollbar-track {\n    border: none;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    width: 4px;\n    background: ", ";\n    border-radius: 100px;\n    cursor: pointer;\n  }\n\n  &::-webkit-scrollbar-thumb:window-inactive {\n    background: ", ";\n  }\n"], ["\n  &::-webkit-scrollbar {\n    width: 4px;\n    background: ", ";\n    border-radius: 100px;\n    cursor: pointer;\n  }\n\n  &::-webkit-scrollbar-track {\n    border: none;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    width: 4px;\n    background: ", ";\n    border-radius: 100px;\n    cursor: pointer;\n  }\n\n  &::-webkit-scrollbar-thumb:window-inactive {\n    background: ", ";\n  }\n"])), BaSeTheme.colors.institucionais.cinzaSebrae90, BaSeTheme.colors.institucionais.cinzaSebrae45, BaSeTheme.colors.institucionais.cinzaSebrae10);
var templateObject_1$u;

var AutocompleteWrapper = styled.div.attrs({
    className: 'BaSe--autocomplete',
})(templateObject_2$p || (templateObject_2$p = __makeTemplateObject(["\n  position: relative;\n  ", "\n\n"], ["\n  position: relative;\n  ", "\n\n"])), function (_a) {
    var isOpen = _a.isOpen, mode = _a.mode;
    return (mode === 'list' && isOpen) && css(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n    & .BaSe--input-input:not(:focus) {\n      border: 1px solid ", ";\n      color: ", ";\n      box-shadow: ", ";\n    }\n  "], ["\n    & .BaSe--input-input:not(:focus) {\n      border: 1px solid ", ";\n      color: ", ";\n      box-shadow: ", ";\n    }\n  "])), BaSeTheme.colors.institucionais.azulSebrae36, BaSeTheme.colors.institucionais.azulSebrae36, BaSeTheme.shadows.focusPrimary);
});
var AutocompleteResultInline = styled.output.attrs({
    className: 'BaSe--autocomplete-result-inline',
})(templateObject_3$j || (templateObject_3$j = __makeTemplateObject(["\n  position: absolute;\n  bottom: ", "px;\n  left: 0.8em;\n  color: ", ";\n  pointer-events: none;\n\n  & > span {\n    color: ", ";\n  }\n"], ["\n  position: absolute;\n  bottom: ", "px;\n  left: 0.8em;\n  color: ", ";\n  pointer-events: none;\n\n  & > span {\n    color: ", ";\n  }\n"])), function (_a) {
    var size = _a.size;
    return size === 'small' ? 7 : size === 'medium' ? 11 : 15;
}, BaSeTheme.colors.institucionais.cinzaSebrae75, BaSeTheme.colors.defaultColors.transparent);
var HideTopOfAutocompleteResultList = styled.div(templateObject_4$g || (templateObject_4$g = __makeTemplateObject(["\n  height: 8px;\n  width: calc(100% - 2px);\n  background: ", ";\n  border: none;\n  box-sizing: border-box;\n  position: relative;\n  z-index: ", ";\n  margin: 0;\n  padding: 0;\n  margin-top: -8px;\n  margin-left: 1px;\n"], ["\n  height: 8px;\n  width: calc(100% - 2px);\n  background: ", ";\n  border: none;\n  box-sizing: border-box;\n  position: relative;\n  z-index: ", ";\n  margin: 0;\n  padding: 0;\n  margin-top: -8px;\n  margin-left: 1px;\n"])), BaSeTheme.colors.defaultColors.white, BaSeTheme.stackOrder.overlay + 1);
var AutocompleteResultList = styled.ul.attrs({
    className: 'BaSe--autocomplete-result-list',
})(templateObject_6$c || (templateObject_6$c = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding: 1px;\n  transition: ", ";\n  position: absolute;\n  max-height: 200px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  width: 100%;\n  box-sizing: border-box;\n  z-index: ", ";\n  background-color: ", ";\n  border-radius: 4px;\n  border: 1px solid\n    ", ";\n  ", ";\n  height: ", ";\n  opacity: ", ";\n  margin-top: ", ";\n  border-width: ", ";\n  box-shadow: ", ";\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 1px;\n  transition: ", ";\n  position: absolute;\n  max-height: 200px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  width: 100%;\n  box-sizing: border-box;\n  z-index: ", ";\n  background-color: ", ";\n  border-radius: 4px;\n  border: 1px solid\n    ", ";\n  ", ";\n  height: ", ";\n  opacity: ", ";\n  margin-top: ", ";\n  border-width: ", ";\n  box-shadow: ", ";\n\n  ", "\n"])), BaSeTheme.transitions.allPropertiesContinuousNormal, BaSeTheme.stackOrder.overlay, BaSeTheme.colors.defaultColors.white, function (_a) {
    var hasError = _a.hasError;
    return hasError
        ? BaSeTheme.colors.feedbackInterface.erro35
        : BaSeTheme.colors.institucionais.azulSebrae36;
}, function (_a) {
    var attached = _a.attached;
    return attached && css(templateObject_5$d || (templateObject_5$d = __makeTemplateObject(["\n      border-top: none;\n      border-radius: 0px 0px 4px 4px;\n    "], ["\n      border-top: none;\n      border-radius: 0px 0px 4px 4px;\n    "])));
}, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? 'auto' : '0px');
}, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? '1' : '0');
}, function (_a) {
    var isOpen = _a.isOpen, attached = _a.attached;
    return isOpen && attached ? '-3px' : '4px';
}, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? '1px' : '0');
}, function (_a) {
    var isOpen = _a.isOpen, hasError = _a.hasError;
    return isOpen
        ? hasError
            ? BaSeTheme.shadows.focusError
            : BaSeTheme.shadows.focusPrimary
        : 'none';
}, BaSeScrollbarCss);
var AutocompleteResultListItem = styled.li(templateObject_7$9 || (templateObject_7$9 = __makeTemplateObject(["\n  padding-left: 12px;\n  display: flex;\n  align-items: center;\n  transition: ", ";\n  will-change: background-color;\n  padding: 8px 4px;\n  gap: 16px;\n  cursor: pointer;\n  background-color: ", ";\n\n  &:hover {\n    outline: none;\n    background-color: ", ";\n  }\n\n  &.active {\n    background-color: ", ";\n  }\n"], ["\n  padding-left: 12px;\n  display: flex;\n  align-items: center;\n  transition: ", ";\n  will-change: background-color;\n  padding: 8px 4px;\n  gap: 16px;\n  cursor: pointer;\n  background-color: ", ";\n\n  &:hover {\n    outline: none;\n    background-color: ", ";\n  }\n\n  &.active {\n    background-color: ", ";\n  }\n"])), BaSeTheme.transitions.allPropertiesContinuousFast, BaSeTheme.colors.contrast.institucionais.azulSebrae, BaSeTheme.colors.institucionais.azulSebrae97, BaSeTheme.colors.institucionais.azulSebrae);
var AutocompleteResultItemImage = styled.img(templateObject_9$9 || (templateObject_9$9 = __makeTemplateObject(["\n  border: 2px solid ", ";\n  object-fit: contain;\n  ", "\n"], ["\n  border: 2px solid ", ";\n  object-fit: contain;\n  ", "\n"])), BaSeTheme.colors.institucionais.cinzaSebrae75, function (_a) {
    var size = _a.size;
    return css(templateObject_8$9 || (templateObject_8$9 = __makeTemplateObject(["\n    border-radius: ", "px;\n    height: ", "px;\n    width: ", "px;\n    max-width: ", "px;\n    max-height: ", "px;\n    flex: 0 0 ", "px;\n  "], ["\n    border-radius: ", "px;\n    height: ", "px;\n    width: ", "px;\n    max-width: ", "px;\n    max-height: ", "px;\n    flex: 0 0 ", "px;\n  "])), size, size, size, size, size, size);
});
var templateObject_1$t, templateObject_2$p, templateObject_3$j, templateObject_4$g, templateObject_5$d, templateObject_6$c, templateObject_7$9, templateObject_8$9, templateObject_9$9;

var BaSeAutocomplete = function (_a) {
    var _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.mode, mode = _c === void 0 ? 'list' : _c, _d = _a.placeholder, placeholder = _d === void 0 ? '' : _d, _e = _a.width, width = _e === void 0 ? '100%' : _e, _f = _a.inputMode, inputMode = _f === void 0 ? 'search' : _f, _g = _a.isDisabled, isDisabled = _g === void 0 ? false : _g, _h = _a.minLengthToSearch, minLengthToSearch = _h === void 0 ? 3 : _h, _j = _a.showHelpButton, showHelpButton = _j === void 0 ? false : _j, _k = _a.complement, complement = _k === void 0 ? '' : _k, _l = _a.moreInfoLabel, moreInfoLabel = _l === void 0 ? '' : _l, _m = _a.moreInfoDetails, moreInfoDetails = _m === void 0 ? '' : _m, _o = _a.size, size = _o === void 0 ? 'medium' : _o, _p = _a.subLabel, subLabel = _p === void 0 ? '' : _p, _q = _a.helpButtonProps, helpButtonProps = _q === void 0 ? {} : _q, _r = _a.imageAndIconSize, imageAndIconSize = _r === void 0 ? 48 : _r, onSearchTerm = _a.onSearchTerm, onSelectedItem = _a.onSelectedItem, onClearSelection = _a.onClearSelection;
    var _s = React.useState(0), selectedIndex = _s[0], setSelectedIndex = _s[1];
    var _t = React.useState(false), isOpen = _t[0], setIsOpen = _t[1];
    var _u = React.useState(false), isLoading = _u[0], setIsLoading = _u[1];
    var _v = React.useState(false), isInputFocused = _v[0], setIsInputFocused = _v[1];
    var _w = React.useState(false), hasError = _w[0], setHasError = _w[1];
    var _x = React.useState(''), value = _x[0], setValue = _x[1];
    var _y = React.useState([]), resultList = _y[0], setResultList = _y[1];
    var wrapperRef = React.useRef(null);
    var listRef = React.useRef(null);
    var term = useDebounce(value, 350);
    useOutsideEvent(wrapperRef, setIsOpen);
    var foundResult = React.useCallback(function () { return !hasError && (resultList === null || resultList === void 0 ? void 0 : resultList.length) > 0; }, [hasError, resultList]);
    var selectItem = React.useCallback(function (item) {
        var resultItem = item !== null && item !== void 0 ? item : resultList === null || resultList === void 0 ? void 0 : resultList[selectedIndex];
        onSelectedItem === null || onSelectedItem === void 0 ? void 0 : onSelectedItem(resultItem);
    }, [resultList, selectedIndex]);
    var getResult = React.useCallback(function () { var _a; return (_a = resultList === null || resultList === void 0 ? void 0 : resultList[selectedIndex]) === null || _a === void 0 ? void 0 : _a.label; }, [resultList, selectedIndex]);
    var resultInline = React.useCallback(function () {
        var _a, _b;
        var regExp = new RegExp("(^.{".concat(term.length, "})(.*$)"));
        return (_b = (_a = getResult()) === null || _a === void 0 ? void 0 : _a.replace) === null || _b === void 0 ? void 0 : _b.call(_a, regExp, "<span>".concat(term, "</span>$2"));
    }, [resultList, term]);
    var isActive = React.useCallback(function (item) {
        var itemIndex = resultList.findIndex(function (resultItem) { return resultItem.id === item.id; });
        return itemIndex === selectedIndex;
    }, [selectedIndex, resultList]);
    // const closeWithDelay = React.useCallback(
    //   () => setTimeout(() => setIsOpen(false), 150),
    //   [],
    // );
    var attached = React.useCallback(function () { return !complement && !moreInfoLabel; }, [complement, moreInfoLabel]);
    var clear = React.useCallback(function () {
        setSelectedIndex(0);
        setValue('');
        onClearSelection === null || onClearSelection === void 0 ? void 0 : onClearSelection();
    }, [setValue, setSelectedIndex]);
    var eventPreparation = React.useCallback(function (event) {
        if (mode !== 'inline') {
            event.preventDefault();
            event.stopPropagation();
            return true;
        }
        return false;
    }, [mode]);
    var getCurrentItemHeightActive = React.useCallback(function () {
        var _a, _b, _c, _d, _e;
        return (_e = (_d = (_c = (_b = (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.active')) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 ? void 0 : _d.height) !== null && _e !== void 0 ? _e : 0;
    }, [listRef]);
    var onEnter = React.useCallback(function () {
        setValue(getResult());
        selectItem();
        setSelectedIndex(0);
    }, [setValue, getResult, selectItem]);
    var onEscape = React.useCallback(function () { return clear(); }, [clear]);
    var onArrowUp = React.useCallback(function (event) {
        var _a;
        if (eventPreparation(event)) {
            var min_1 = 0;
            setSelectedIndex(function (actualSelectedIndex) {
                return --actualSelectedIndex < min_1 ? min_1 : actualSelectedIndex;
            });
            (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.scrollBy({
                behavior: 'smooth',
                top: getCurrentItemHeightActive() * -1,
            });
        }
    }, [setSelectedIndex]);
    var onArrowDown = React.useCallback(function (event) {
        var _a;
        if (eventPreparation(event)) {
            var max_1 = resultList.length - 1;
            setSelectedIndex(function (actualSelectedIndex) {
                return ++actualSelectedIndex >= max_1 ? max_1 : actualSelectedIndex;
            });
            (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.scrollBy({
                behavior: 'smooth',
                top: getCurrentItemHeightActive(),
            });
        }
    }, [setSelectedIndex, resultList]);
    var onFocus = React.useCallback(function () {
        setIsInputFocused(true);
        setIsOpen(true);
    }, []);
    React.useEffect(function () {
        if (value !== term) {
            setHasError(false);
            setResultList([]);
        }
        if (value === '') {
            onClearSelection === null || onClearSelection === void 0 ? void 0 : onClearSelection();
        }
    }, [term, value]);
    React.useEffect(function () {
        setHasError(false);
        setResultList([]);
        if (!term || minLengthToSearch > (term === null || term === void 0 ? void 0 : term.length)) {
            return;
        }
        setIsLoading(true);
        var afterSearchTerm = onSearchTerm(term);
        if (Array.isArray(afterSearchTerm)) {
            setResultList(afterSearchTerm);
            return setIsLoading(false);
        }
        afterSearchTerm
            .then(setResultList)
            .catch(function () { return setHasError(true); })
            .finally(function () { return setIsLoading(false); });
    }, [term]);
    React.useEffect(function () { return setHasError(resultList.some(function (item) { return !(item === null || item === void 0 ? void 0 : item.id) || !(item === null || item === void 0 ? void 0 : item.label); })); }, [resultList]);
    React.useEffect(function () { return setIsOpen(foundResult() && isInputFocused); }, [resultList, foundResult]);
    return (React.createElement(AutocompleteWrapper, { ref: wrapperRef, isOpen: isOpen, mode: mode },
        React.createElement(BaSeInput, { width: width, showHelpButton: showHelpButton, complement: complement, moreInfoLabel: moreInfoLabel, moreInfoDetails: moreInfoDetails, size: size, subLabel: subLabel, helpButtonProps: helpButtonProps, label: label, inputMode: inputMode, placeholder: placeholder, value: value, isDisabled: isDisabled, isLoading: isLoading, iconButton: {
                action: !!(value === null || value === void 0 ? void 0 : value.length) ? clear : undefined,
                color: BaSeTheme.colors.institucionais.azulSebrae,
                name: !!(value === null || value === void 0 ? void 0 : value.length) ? 'close' : 'search',
                typeButton: 'base-icon',
            }, onSpecificKeyDown: [
                { listenerKey: 'Enter', callback: onEnter },
                { listenerKey: 'Escape', callback: onEscape },
                { listenerKey: 'ArrowUp', callback: onArrowUp },
                { listenerKey: 'ArrowDown', callback: onArrowDown },
            ], inputStatus: hasError ? 'invalid' : 'normal', onChange: function (newValue) { return setValue(newValue); }, onFocus: onFocus }),
        foundResult() &&
            (mode === 'list' ? (React.createElement(React.Fragment, null,
                isOpen && attached() && React.createElement(HideTopOfAutocompleteResultList, null),
                React.createElement(AutocompleteResultList, { ref: listRef, attached: attached(), hasError: hasError, isOpen: isOpen }, resultList.map(function (item) { return (React.createElement(AutocompleteResultListItem, { className: "BaSe--autocomplete-result-list-item ".concat(isActive(item) ? 'active' : ''), key: item.id, onClick: function () {
                        setValue(item.label);
                        selectItem(item);
                        setIsInputFocused(false);
                        setIsOpen(false);
                    } },
                    (item === null || item === void 0 ? void 0 : item.imageSource) && (React.createElement(AutocompleteResultItemImage, { size: imageAndIconSize, src: item.imageSource, alt: "Imagem de ".concat(item === null || item === void 0 ? void 0 : item.label) })),
                    (item === null || item === void 0 ? void 0 : item.iconName) && (React.createElement(BaSeIcon, { name: item.iconName, size: imageAndIconSize, description: "\u00CDcone do item: ".concat(item === null || item === void 0 ? void 0 : item.label), color: BaSeTheme.colors.defaultColors.black })),
                    React.createElement("span", null,
                        React.createElement(BaSeParagraph, { color: isActive(item)
                                ? BaSeTheme.colors.defaultColors.white
                                : BaSeTheme.colors.defaultColors.black }, item === null || item === void 0 ? void 0 : item.label),
                        (item === null || item === void 0 ? void 0 : item.description) && (React.createElement(React.Fragment, null,
                            React.createElement("br", null),
                            React.createElement(BaSeSmall1, { color: isActive(item)
                                    ? BaSeTheme.colors.institucionais.cinzaSebrae75
                                    : BaSeTheme.colors.institucionais.cinzaSebrae45 }, item === null || item === void 0 ? void 0 : item.description)))))); })))) : (React.createElement(AutocompleteResultInline, { size: size, dangerouslySetInnerHTML: { __html: resultInline() } })))));
};
BaSeAutocomplete.displayName = 'BaSeAutocomplete';

var mapSizeCheckbox = {
    small: 13,
    medium: 16,
};
var mapCheckBoxValues = function (color) {
    var isDisabled = color === 'disabled';
    return {
        primary: {
            generalColors: {
                iconColor: BaSeTheme.colors.defaultColors.white,
                style: {
                    bgC: ColorMapper[color].foreground,
                    bcCHover: isDisabled
                        ? BaSeTheme.colors.defaultColors.lightGray
                        : ColorMapper[color].hover.defaultDark,
                    boxShadowFocus: isDisabled
                        ? 'none'
                        : ColorMapper[color].focus.defaultLight,
                    border: 'none',
                },
            },
            negative: {
                iconColor: ColorMapper[color].foreground,
                style: {
                    bgC: BaSeTheme.colors.defaultColors.white,
                    bcCHover: isDisabled
                        ? BaSeTheme.colors.defaultColors.lightGray
                        : BaSeTheme.colors.institucionais.cinzaSebrae97,
                    boxShadowFocus: isDisabled
                        ? 'none'
                        : BaSeTheme.colors.institucionais.azulSebrae90,
                    border: 'none',
                },
            },
        },
    };
};
var mapCustomColorsCheckboxValues = function (customColor) {
    var customColorHsv = Color.generateFromHex(customColor);
    return {
        primary: {
            color: BaSeTheme.colors.defaultColors.white,
            iconColor: BaSeTheme.colors.defaultColors.white,
            style: {
                bgC: customColor && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
                bcCHover: ColorMapper.dark.hover.create(customColor
                    ? customColor
                    : BaSeTheme.colors.institucionais.azulSebrae36),
                boxShadowFocus: ColorMapper.light.focus.create(customColor
                    ? customColor
                    : BaSeTheme.colors.institucionais.azulSebrae36),
                border: 'none',
            },
        },
    };
};

var checkboxContainerSize = 18;
var checkboxBorderSize = 2;
var checkboxIconSize = 16 - checkboxBorderSize;
var CheckboxContainer = styled.div(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n  width: ", "px;\n  height: ", "px;\n  position: relative;\n  align-self: ", ";\n  cursor: ", ";\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n  width: ", "px;\n  height: ", "px;\n  position: relative;\n  align-self: ", ";\n  cursor: ", ";\n"])), checkboxContainerSize, checkboxContainerSize, function (_a) {
    var verticalAlign = _a.verticalAlign;
    return verticalAlign;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
});
var HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })(templateObject_2$o || (templateObject_2$o = __makeTemplateObject(["\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: ", ";\n  cursor: ", ";\n"], ["\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: ", ";\n  cursor: ", ";\n"])), BaSeTheme.stackOrder.normal + 1, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
});
var hoverCheckedStyles = function (backgroundColor) { return css(templateObject_3$i || (templateObject_3$i = __makeTemplateObject(["\n  background: ", ";\n  border-color: ", ";\n  transition: none;\n"], ["\n  background: ", ";\n  border-color: ", ";\n  transition: none;\n"])), backgroundColor, backgroundColor); };
var hoverUncheckedStyles = css(templateObject_4$f || (templateObject_4$f = __makeTemplateObject(["\n  border: ", "px solid\n    ", ";\n"], ["\n  border: ", "px solid\n    ", ";\n"])), checkboxBorderSize, BaSeTheme.colors.institucionais.azulSebrae30);
var checkedStyles = function (backgroundColor) { return css(templateObject_5$c || (templateObject_5$c = __makeTemplateObject(["\n  display: inline-block;\n  width: ", "px;\n  height: ", "px;\n  border: ", "px solid ", ";\n  background: ", ";\n  border-radius: 4px;\n  position: relative;\n  transition: ", ";\n"], ["\n  display: inline-block;\n  width: ", "px;\n  height: ", "px;\n  border: ", "px solid ", ";\n  background: ", ";\n  border-radius: 4px;\n  position: relative;\n  transition: ", ";\n"])), checkboxIconSize, checkboxIconSize, checkboxBorderSize, backgroundColor, backgroundColor, "background ".concat(BaSeTheme.transitions.durationNormal)); };
var uncheckedStyles = function (disabled) { return css(templateObject_6$b || (templateObject_6$b = __makeTemplateObject(["\n  display: inline-block;\n  width: ", "px;\n  height: ", "px;\n  border-radius: 4px;\n  background: ", ";\n  border: ", "px solid\n    ", ";\n  transition: ", ";\n"], ["\n  display: inline-block;\n  width: ", "px;\n  height: ", "px;\n  border-radius: 4px;\n  background: ", ";\n  border: ", "px solid\n    ", ";\n  transition: ", ";\n"])), checkboxIconSize, checkboxIconSize, disabled
    ? BaSeTheme.colors.institucionais.cinzaSebrae97
    : BaSeTheme.colors.defaultColors.white, checkboxBorderSize, disabled
    ? BaSeTheme.colors.defaultColors.lightGray
    : BaSeTheme.colors.institucionais.cinzaSebrae75, "background ".concat(BaSeTheme.transitions.durationNormal)); };
var StyledCheckbox = styled.div(templateObject_9$8 || (templateObject_9$8 = __makeTemplateObject(["\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (props) {
    return props.checked
        ? checkedStyles(props.backgroundColor)
        : uncheckedStyles(props.disabled);
}, function (props) {
    return props.focus && css(templateObject_7$8 || (templateObject_7$8 = __makeTemplateObject(["\n      outline: none;\n      box-shadow: 0px 0px 0px 3px ", ";\n    "], ["\n      outline: none;\n      box-shadow: 0px 0px 0px 3px ", ";\n    "])), props.boxShadowFocus);
}, function (props) {
    return !props.disabled &&
        props.hover &&
        (props.checked
            ? hoverCheckedStyles(props.backgroundOnHover)
            : hoverUncheckedStyles);
}, function (_a) {
    var isHoverable = _a.isHoverable, disabled = _a.disabled, checked = _a.checked, backgroundOnHover = _a.backgroundOnHover;
    return isHoverable && css(templateObject_8$8 || (templateObject_8$8 = __makeTemplateObject(["\n      &:hover {\n        ", "\n      }\n    "], ["\n      &:hover {\n        ", "\n      }\n    "])), !disabled &&
        (checked
            ? hoverCheckedStyles(backgroundOnHover)
            : hoverUncheckedStyles));
});
var StyledLabel$2 = styled.label(templateObject_11$4 || (templateObject_11$4 = __makeTemplateObject(["\n  margin: 0 5px;\n  font-size: ", "px;\n  ", "\n"], ["\n  margin: 0 5px;\n  font-size: ", "px;\n  ", "\n"])), function (_a) {
    var _b;
    var size = _a.size;
    return (_b = mapSizeCheckbox[size]) !== null && _b !== void 0 ? _b : mapSizeCheckbox.medium;
}, function (_a) {
    var disabled = _a.disabled;
    return css(templateObject_10$6 || (templateObject_10$6 = __makeTemplateObject(["\n    color: ", ";\n    cursor: ", ";\n  "], ["\n    color: ", ";\n    cursor: ", ";\n  "])), disabled
        ? BaSeTheme.colors.institucionais.cinzaSebrae75
        : BaSeTheme.colors.institucionais.cinzaSebrae30, disabled ? 'not-allowed' : 'pointer');
});
var WrapperCheckbox = styled.div(templateObject_12$4 || (templateObject_12$4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  height: 24;\n  align-items: center;\n  text-align: ", ";\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  height: 24;\n  align-items: center;\n  text-align: ", ";\n"])), function (_a) {
    var horizontalAlign = _a.horizontalAlign;
    return horizontalAlign;
}, function (_a) {
    var horizontalAlign = _a.horizontalAlign;
    return horizontalAlign === 'row' ? 'left' : 'right';
});
var templateObject_1$s, templateObject_2$o, templateObject_3$i, templateObject_4$f, templateObject_5$c, templateObject_6$b, templateObject_7$8, templateObject_8$8, templateObject_9$8, templateObject_10$6, templateObject_11$4, templateObject_12$4;

var idSequence$6 = idGenerator();
var BaSeCheckbox = function (_a) {
    var _b;
    var _c = _a.label, label = _c === void 0 ? '' : _c, _d = _a.value, value = _d === void 0 ? '' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.isInteractive, isInteractive = _f === void 0 ? true : _f, _g = _a.checked, checked = _g === void 0 ? false : _g, _h = _a.indeterminate, indeterminate = _h === void 0 ? false : _h, _j = _a.align, align = _j === void 0 ? 'top-left' : _j, _k = _a.size, size = _k === void 0 ? 'medium' : _k, _l = _a.color, color = _l === void 0 ? 'default' : _l, _m = _a.onChange, onChange = _m === void 0 ? function () { } : _m;
    var idCheckbox = useNextHashId(idSequence$6);
    var _o = React.useState(false), focus = _o[0], setFocus = _o[1];
    var _p = React.useState(false), hover = _p[0], setHover = _p[1];
    var onCheckOrUncheck = function (event) {
        if (!disabled) {
            onChange(!checked, value, event);
        }
    };
    value = value !== null && value !== void 0 ? value : label;
    var re = new RegExp('(.*)-(.*)');
    var verticalAlign = function () {
        var verticalValue = (align.match(re) || [])[1];
        if (verticalValue === 'top') {
            return 'start';
        }
        if (verticalValue === 'bottom') {
            return 'flex-end';
        }
        if (verticalValue === 'center') {
            return 'center';
        }
        throw Error("BaSeCheckbox: Valor de \"align\" referente ao valor vertical \"".concat(verticalValue, "\" \u00E9 invalido! Informe \"top\", \"bottom\" ou \"center\""));
    };
    var horizontalAlign = function () {
        var horizontalValue = (align.match(re) || [])[2];
        if (horizontalValue === 'right') {
            return 'row-reverse';
        }
        if (horizontalValue === 'left') {
            return 'row';
        }
        throw Error("BaSeCheckbox: Valor de \"align\" referente ao valor horizontal \"".concat(horizontalValue, "\" \u00E9 invalido! Informe \"right\" ou \"left\""));
    };
    var colorIsMapped = color === BaSeTheme.components.button.colors.default ||
        color === BaSeTheme.components.button.colors.destructive ||
        color === BaSeTheme.components.button.colors.confirmation ||
        color === BaSeTheme.components.button.colors.negative;
    var getColorsAtributes = function () {
        var _a, _b;
        if (color) {
            if (!colorIsMapped) {
                return mapCustomColorsCheckboxValues(color).primary;
            }
            else {
                if (color === BaSeTheme.components.button.colors.negative) {
                    return (_a = mapCheckBoxValues('default').primary) === null || _a === void 0 ? void 0 : _a.negative;
                }
                return (_b = mapCheckBoxValues(color).primary) === null || _b === void 0 ? void 0 : _b.generalColors;
            }
        }
        else {
            return mapCheckBoxValues('default').primary.generalColors;
        }
    };
    var buttonValues = disabled
        ? color === 'negative'
            ? (_b = mapCheckBoxValues('disabled').primary) === null || _b === void 0 ? void 0 : _b.negative
            : mapCheckBoxValues('disabled').primary.generalColors
        : getColorsAtributes();
    var _q = buttonValues.style, bgC = _q.bgC, bcCHover = _q.bcCHover, boxShadowFocus = _q.boxShadowFocus, border = _q.border, iconColor = buttonValues.iconColor;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(WrapperCheckbox, { horizontalAlign: horizontalAlign() },
        React.createElement(CheckboxContainer, { verticalAlign: verticalAlign(), disabled: disabled },
            React.createElement(HiddenCheckbox, { defaultValue: value, tabIndex: isInteractive ? 0 : -1, id: idCheckbox, checked: checked, disabled: disabled, onChange: onCheckOrUncheck, onPointerEnter: function () { return setHover(isInteractive && true); }, onFocus: function () { return setFocus(isInteractive && true); }, onPointerLeave: function () { return setHover(false); }, onBlur: function () { return setFocus(false); }, onKeyPress: function (event) {
                    return event.key === 'Enter' && isInteractive && onCheckOrUncheck(event);
                } }),
            React.createElement(StyledCheckbox, { hover: hover, focus: focus, disabled: disabled, checked: checked, backgroundColor: bgC, backgroundOnHover: bcCHover, isHoverable: isInteractive, border: border, boxShadowFocus: boxShadowFocus }, checked && (React.createElement(BaSeIcon, { description: getMessage('checkbox.iconDescription'), name: indeterminate ? 'minus' : 'check', color: iconColor, size: checkboxIconSize })))),
        React.createElement(StyledLabel$2, { htmlFor: idCheckbox, size: size, disabled: disabled }, label)));
};
BaSeCheckbox.displayName = 'BaSeCheckbox';

var WrapperCounterlabel = styled.div.attrs({
    className: 'BaSe--counter-wrapper-label',
})(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  background-color: ", ";\n  position: relative;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 2px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  background-color: ", ";\n  position: relative;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 2px;\n"])), BaSeTheme.colors.defaultColors.transparent);
var StyledLabel$1 = styled.label(templateObject_2$n || (templateObject_2$n = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 2px;\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 2px;\n"])), function (props) { return props.fontSize; }, function (props) { return props.lineHeight; }, BaSeTheme.colors.institucionais.cinzaSebrae45, BaSeTheme.typography.fontFamily);
var StyledSubLabel$1 = styled.label.attrs({
    className: 'BaSe--counter-sub-label',
})(templateObject_3$h || (templateObject_3$h = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  font-family: ", ";\n  font-weight: normal;\n  color: ", ";\n  font-style: italic;\n  margin-left: 4px;\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  font-family: ", ";\n  font-weight: normal;\n  color: ", ";\n  font-style: italic;\n  margin-left: 4px;\n"])), function (_a) {
    var fontSize = _a.fontSize;
    return fontSize;
}, function (_a) {
    var lineHeight = _a.lineHeight;
    return lineHeight;
}, BaSeTheme.typography.fontFamily, BaSeTheme.colors.institucionais.cinzaSebrae60);
var ButtonInfoContainer$1 = styled.div(templateObject_4$e || (templateObject_4$e = __makeTemplateObject(["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var StyledApoio = styled.span(templateObject_5$b || (templateObject_5$b = __makeTemplateObject(["\n  font-size: 0.83em;\n  color: ", ";\n  margin-top: 3px;\n  line-height: 1.2em;\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n"], ["\n  font-size: 0.83em;\n  color: ", ";\n  margin-top: 3px;\n  line-height: 1.2em;\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n"])), function (props) {
    return props.hasError
        ? BaSeTheme.colors.feedbackInterface.erro35
        : BaSeTheme.colors.institucionais.cinzaSebrae45;
}, BaSeTheme.typography.fontFamily);
var StyledCounterInput = styled.input(templateObject_6$a || (templateObject_6$a = __makeTemplateObject(["\n  padding-left: 12px;\n  background: ", ";\n  border-top: 1px solid\n    ", ";\n  border-bottom: 1px solid\n    ", ";\n  border-left: 0px;\n  border-right: 0px;\n  border-radius: 0px;\n  height: ", "px;\n  padding-right: 26px;\n  padding: 0;\n  margin-left: -2px;\n  margin-right: -2px;\n  width: ", ";\n  min-width: 60px;\n  color: ", ";\n  text-align: center;\n  &:focus {\n    outline: 0;\n  }\n"], ["\n  padding-left: 12px;\n  background: ", ";\n  border-top: 1px solid\n    ", ";\n  border-bottom: 1px solid\n    ", ";\n  border-left: 0px;\n  border-right: 0px;\n  border-radius: 0px;\n  height: ", "px;\n  padding-right: 26px;\n  padding: 0;\n  margin-left: -2px;\n  margin-right: -2px;\n  width: ", ";\n  min-width: 60px;\n  color: ", ";\n  text-align: center;\n  &:focus {\n    outline: 0;\n  }\n"])), BaSeTheme.colors.defaultColors.transparent, function (props) {
    return props.hasError
        ? BaSeTheme.colors.feedbackInterface.erro35
        : BaSeTheme.colors.institucionais.cinzaSebrae75;
}, function (props) {
    return props.hasError
        ? BaSeTheme.colors.feedbackInterface.erro35
        : BaSeTheme.colors.institucionais.cinzaSebrae75;
}, function (props) { return props.height; }, function (_a) {
    var width = _a.width;
    return numberWithUnit(width);
}, function (props) {
    return props.hasError
        ? BaSeTheme.colors.feedbackInterface.erro35
        : BaSeTheme.colors.institucionais.cinzaSebrae30;
});
var CounterContainer = styled.div(templateObject_7$7 || (templateObject_7$7 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var MoreInfoContainer$2 = styled.div(templateObject_8$7 || (templateObject_8$7 = __makeTemplateObject(["\n  padding-top: 4px;\n"], ["\n  padding-top: 4px;\n"])));
var CounterInnerContainer = styled.div(templateObject_9$7 || (templateObject_9$7 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var templateObject_1$r, templateObject_2$n, templateObject_3$h, templateObject_4$e, templateObject_5$b, templateObject_6$a, templateObject_7$7, templateObject_8$7, templateObject_9$7;

var mapCounterSize = {
    small: {
        padding: 30,
    },
    big: {
        padding: 46,
    },
    medium: {
        padding: 38,
    },
};

var idSequence$5 = idGenerator();
var BaSeCounter = function (_a) {
    var _b, _c;
    var _d = _a.value, value = _d === void 0 ? 0 : _d, _e = _a.size, size = _e === void 0 ? 'medium' : _e, _f = _a.label, label = _f === void 0 ? '' : _f, _g = _a.subLabel, subLabel = _g === void 0 ? '' : _g, _h = _a.complement, complement = _h === void 0 ? '' : _h, _j = _a.moreInfoLabel, moreInfoLabel = _j === void 0 ? '' : _j, _k = _a.moreInfoDetails, moreInfoDetails = _k === void 0 ? '' : _k, _l = _a.showHelpButton, showHelpButton = _l === void 0 ? false : _l, _m = _a.type, type = _m === void 0 ? 'primary' : _m, _o = _a.color, color = _o === void 0 ? 'default' : _o, _p = _a.minValue, minValue = _p === void 0 ? Number.MIN_SAFE_INTEGER : _p, _q = _a.maxValue, maxValue = _q === void 0 ? Number.MAX_SAFE_INTEGER : _q, _r = _a.stepValue, stepValue = _r === void 0 ? 1 : _r, _s = _a.isDisabled, isDisabled = _s === void 0 ? false : _s, _t = _a.width, width = _t === void 0 ? 0 : _t, _u = _a.helpButtonProps, helpButtonProps = _u === void 0 ? {} : _u, _v = _a.onChange, onChange = _v === void 0 ? function () { } : _v;
    var id = getNextHash(idSequence$5);
    var onChangeInput = function (newValue) {
        var cleanedValue = newValue.target.value;
        if (isNumeric(cleanedValue)) {
            var castedValue = Number(cleanedValue);
            onChange(castedValue <= maxValue
                ? castedValue >= minValue
                    ? castedValue
                    : minValue
                : maxValue);
        }
    };
    var increaseValue = function () { return onChange(Number(value) + stepValue); };
    var decreaseValue = function () { return onChange(Number(value) - stepValue); };
    var isLeftButtonDisabled = Number(value) <= Number(minValue) || isDisabled;
    var isRightButtonDisabled = Number(value) >= Number(maxValue) || isDisabled;
    var height = (_c = (_b = mapCounterSize[size]) === null || _b === void 0 ? void 0 : _b.padding) !== null && _c !== void 0 ? _c : mapCounterSize.medium.padding;
    var hasError = color === 'destructive';
    return (React.createElement(CounterContainer, null,
        React.createElement(WrapperCounterlabel, null,
            React.createElement(StyledLabel$1, { fontSize: size === 'small' ? '13px' : '16px', lineHeight: size === 'small' ? '16px' : '23px', htmlFor: id }, label),
            React.createElement(StyledSubLabel$1, { fontSize: size === 'small' ? '13px' : '16px', lineHeight: size === 'small' ? '16px' : '23px', htmlFor: id }, subLabel),
            showHelpButton && (React.createElement(ButtonInfoContainer$1, null,
                React.createElement(BaSePopupButton, __assign({}, helpButtonProps))))),
        React.createElement(CounterInnerContainer, null,
            React.createElement(BaSeShapeButton, { shape: "square", nameIcon: "minus", sideButton: "left", isDisabled: !hasError && isLeftButtonDisabled, type: type, color: color, onClick: function () { return !isLeftButtonDisabled && decreaseValue(); }, size: size, buttonType: "button" }),
            React.createElement(StyledCounterInput, { id: id, value: value, disabled: isDisabled, hasError: hasError, width: width, height: height, onChange: onChangeInput }),
            React.createElement(BaSeShapeButton, { shape: "square", nameIcon: "plus", sideButton: "right", isDisabled: !hasError && isRightButtonDisabled, type: type, color: color, onClick: function () { return !isRightButtonDisabled && increaseValue(); }, size: size, buttonType: "button" })),
        React.createElement(StyledApoio, { hasError: hasError }, complement),
        !!moreInfoLabel && (React.createElement(MoreInfoContainer$2, null,
            React.createElement(BaSeHelperText, { size: "small", label: moreInfoLabel, details: moreInfoDetails })))));
};
BaSeCounter.displayName = 'BaSeCounter';

var LeftButton = styled.button(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n  border-radius: 4px 0px 0px 4px;\n  display: flex;\n  width: ", ";\n  background-color: ", ";\n  border-style: solid;\n  border-color: ", ";\n  border-width: 1px 1px 1px 1px;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  transition: ", ";\n  &:hover {\n    &:before {\n      background-color: ", ";\n    }\n    cursor: pointer;\n    background-color: ", ";\n  }\n  &:focus {\n    border-radius: ", "px 0px 0px\n      ", "px;\n    background-color: ", ";\n    box-shadow: ", ";\n    outline: none;\n    z-index: ", ";\n    &:before {\n      border-radius: ", "px 0px 0px\n        ", "px;\n      background-color: ", ";\n      box-shadow: ", ";\n      outline: none;\n    }\n  }\n  &:active {\n    box-shadow: none;\n    transform: translateY(2px);\n  }\n"], ["\n  border-radius: 4px 0px 0px 4px;\n  display: flex;\n  width: ", ";\n  background-color: ", ";\n  border-style: solid;\n  border-color: ", ";\n  border-width: 1px 1px 1px 1px;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  transition: ", ";\n  &:hover {\n    &:before {\n      background-color: ", ";\n    }\n    cursor: pointer;\n    background-color: ", ";\n  }\n  &:focus {\n    border-radius: ", "px 0px 0px\n      ", "px;\n    background-color: ", ";\n    box-shadow: ", ";\n    outline: none;\n    z-index: ", ";\n    &:before {\n      border-radius: ", "px 0px 0px\n        ", "px;\n      background-color: ", ";\n      box-shadow: ", ";\n      outline: none;\n    }\n  }\n  &:active {\n    box-shadow: none;\n    transform: translateY(2px);\n  }\n"])), function (_a) {
    var width = _a.width;
    return numberWithUnit(width);
}, function (props) { return props.background; }, function (props) { return props.borderColor; }, BaSeTheme.transitions.allPropertiesContinuousFast, function (props) { return props.hoverColor; }, function (props) { return props.hoverColor; }, function (props) { return props.borderRadius; }, function (props) { return props.borderRadius; }, function (props) { return props.hoverColor; }, function (props) { return props.boxShadowFocus; }, BaSeTheme.stackOrder.belowOverlay, function (props) { return props.borderRadius; }, function (props) { return props.borderRadius; }, function (props) { return props.hoverColor; }, BaSeTheme.shadows.profundidade2);
var RightButton = styled.button(templateObject_2$m || (templateObject_2$m = __makeTemplateObject(["\n  border-radius: 0px 4px 4px 0px;\n  display: flex;\n  width: ", ";\n  background-color: ", ";\n  border-style: solid;\n  border-color: ", ";\n  border-width: 1px 1px 1px 0px;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  transition: ", ";\n  &:hover {\n    cursor: pointer;\n    background-color: ", ";\n  }\n  &:focus {\n    border-radius: 0px ", "px\n      ", "px 0px;\n    background-color: ", ";\n    box-shadow: ", ";\n    outline: none;\n    z-index: ", ";\n  }\n  &:active {\n    box-shadow: none;\n    transform: translateY(2px);\n  }\n"], ["\n  border-radius: 0px 4px 4px 0px;\n  display: flex;\n  width: ", ";\n  background-color: ", ";\n  border-style: solid;\n  border-color: ", ";\n  border-width: 1px 1px 1px 0px;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  transition: ", ";\n  &:hover {\n    cursor: pointer;\n    background-color: ", ";\n  }\n  &:focus {\n    border-radius: 0px ", "px\n      ", "px 0px;\n    background-color: ", ";\n    box-shadow: ", ";\n    outline: none;\n    z-index: ", ";\n  }\n  &:active {\n    box-shadow: none;\n    transform: translateY(2px);\n  }\n"])), function (_a) {
    var width = _a.width;
    return numberWithUnit(width);
}, function (props) { return props.background; }, function (props) { return props.borderColor; }, BaSeTheme.transitions.allPropertiesContinuousFast, function (props) { return props.hoverColor; }, function (props) { return props.borderRadius; }, function (props) { return props.borderRadius; }, function (props) { return props.hoverColor; }, function (props) { return props.boxShadowFocus; }, BaSeTheme.stackOrder.belowOverlay);
var Container = styled.div(templateObject_3$g || (templateObject_3$g = __makeTemplateObject(["\n  display: flex;\n  flex-direction: 'row';\n"], ["\n  display: flex;\n  flex-direction: 'row';\n"])));
var Label = styled.label(templateObject_4$d || (templateObject_4$d = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 23px;\n  color: ", ";\n  font-family: Lato;\n  font-style: normal;\n  font-weight: normal;\n  display: flex;\n  margin: 1px;\n"], ["\n  font-size: 16px;\n  line-height: 23px;\n  color: ", ";\n  font-family: Lato;\n  font-style: normal;\n  font-weight: normal;\n  display: flex;\n  margin: 1px;\n"])), BaSeTheme.colors.institucionais.cinzaSebrae45);
var templateObject_1$q, templateObject_2$m, templateObject_3$g, templateObject_4$d;

var idSequence$4 = idGenerator();
var BaSeDualButton = function (_a) {
    var _b = _a.buttonType, buttonType = _b === void 0 ? 'button' : _b, _c = _a.type, type = _c === void 0 ? 'primary-default' : _c, _d = _a.hasError, hasError = _d === void 0 ? false : _d, label = _a.label, _e = _a.right, right = _e === void 0 ? {
        value: true,
        label: 'Valor da direita',
        width: 'auto',
    } : _e, _f = _a.left, left = _f === void 0 ? {
        value: false,
        label: 'Valor da esquerda',
        width: 'auto',
    } : _f, externalSelected = _a.selected, _g = _a.onChange, onChange = _g === void 0 ? function () { } : _g;
    var id = useNextHashId(idSequence$4);
    var _h = React.useState(), selected = _h[0], setSelected = _h[1];
    var leftSelected = React.useMemo(function () { return selected === 'left'; }, [selected]);
    var rightSelected = React.useMemo(function () { return selected === 'right'; }, [selected]);
    var _j = React.useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var typeSplit = type.split('-');
        var typeMapped = hasError
            ? (_b = (_a = dualButtonMapStyle[typeSplit[0]]) === null || _a === void 0 ? void 0 : _a.error) !== null && _b !== void 0 ? _b : dualButtonMapStyle.primary.error
            : (_d = (_c = dualButtonMapStyle[typeSplit[0]]) === null || _c === void 0 ? void 0 : _c[typeSplit[1]]) !== null && _d !== void 0 ? _d : dualButtonMapStyle.primary.default;
        var typeMappedSelected = hasError
            ? (_f = (_e = dualButtonMapStyle[typeSplit[0]]) === null || _e === void 0 ? void 0 : _e.error) !== null && _f !== void 0 ? _f : dualButtonMapStyle.primary.error
            : (_h = (_g = dualButtonMapStyle.selected) === null || _g === void 0 ? void 0 : _g[typeSplit[1]]) !== null && _h !== void 0 ? _h : dualButtonMapStyle.selected.default;
        var colorMapped = typeMapped.color, typeStyle = __rest(typeMapped, ["color"]);
        var colorMappedSelected = typeMappedSelected.color, typeStyleSelected = __rest(typeMappedSelected, ["color"]);
        return {
            color: colorMapped,
            colorSelected: colorMappedSelected,
            leftButtonProps: leftSelected ? typeStyleSelected : typeStyle,
            rightButtonProps: rightSelected ? typeStyleSelected : typeStyle,
        };
    }, [hasError, type, leftSelected, rightSelected]), color = _j.color, colorSelected = _j.colorSelected, leftButtonProps = _j.leftButtonProps, rightButtonProps = _j.rightButtonProps;
    React.useEffect(function () { return setSelected(externalSelected); }, [externalSelected]);
    return (React.createElement("div", { className: "BaSe--dual-button" },
        label && React.createElement(Label, { htmlFor: id }, label),
        React.createElement(Container, null,
            React.createElement(LeftButton, __assign({ id: id }, leftButtonProps, { type: buttonType, width: left.width, onClick: function () {
                    onChange(left.value);
                    setSelected('left');
                } }),
                React.createElement(BaSeTextButton, { color: leftSelected ? colorSelected : color, fontSize: 1, lineHeight: 1.4, hasLeftIcon: false, hasRightIcon: false, fontWeigt: "normal" }, left.label)),
            React.createElement(RightButton, __assign({}, rightButtonProps, { type: buttonType, width: right.width, onClick: function () {
                    onChange(right.value);
                    setSelected('right');
                } }),
                React.createElement(BaSeTextButton, { color: rightSelected ? colorSelected : color, fontSize: 1, lineHeight: 1.4, hasLeftIcon: false, hasRightIcon: false, fontWeigt: "normal" }, right.label)))));
};
BaSeDualButton.displayName = 'BaSeDualButton';

var mapSizeRadio = {
    small: 13,
    medium: 16,
};
var mapRadioValues = function (color) {
    var isDisabled = color === 'disabled';
    return {
        primary: {
            generalColors: {
                iconColor: BaSeTheme.colors.defaultColors.white,
                style: {
                    bgC: ColorMapper[color].foreground,
                    bcCHover: isDisabled
                        ? BaSeTheme.colors.defaultColors.lightGray
                        : ColorMapper[color].hover.defaultDark,
                    boxShadowFocus: isDisabled
                        ? 'none'
                        : ColorMapper[color].focus.defaultLight,
                    border: isDisabled
                        ? ColorMapper.disabled.foreground
                        : ColorMapper[color].foreground,
                },
            },
            negative: {
                iconColor: ColorMapper[color].foreground,
                style: {
                    bgC: BaSeTheme.colors.defaultColors.white,
                    bcCHover: isDisabled
                        ? BaSeTheme.colors.defaultColors.lightGray
                        : BaSeTheme.colors.institucionais.cinzaSebrae97,
                    boxShadowFocus: isDisabled
                        ? 'none'
                        : BaSeTheme.colors.institucionais.azulSebrae90,
                    border: isDisabled
                        ? ColorMapper.disabled.foreground
                        : 'none',
                },
            },
        },
    };
};
var mapCustomColorsRadioValues = function (customColor) {
    var customColorHsv = Color.generateFromHex(customColor);
    return {
        primary: {
            iconColor: BaSeTheme.colors.defaultColors.white,
            style: {
                bgC: customColor && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
                bcCHover: ColorMapper.dark.hover.create(customColor
                    ? customColor
                    : BaSeTheme.colors.institucionais.azulSebrae36),
                boxShadowFocus: ColorMapper.light.focus.create(customColor
                    ? customColor
                    : BaSeTheme.colors.institucionais.azulSebrae36),
                border: customColor && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
            },
        },
    };
};

var RadioWrapper = styled.div(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n"])));
var RadioMarker = styled.div(templateObject_4$c || (templateObject_4$c = __makeTemplateObject(["\n  border-radius: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n  z-index: ", ";\n  transition: ", ";\n  background: ", ";\n  ", "\n"], ["\n  border-radius: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n  z-index: ", ";\n  transition: ", ";\n  background: ", ";\n  ", "\n"])), BaSeTheme.stackOrder.normal, BaSeTheme.transitions.allPropertiesContinuousNormal, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var checked = _a.checked;
    return checked
        ? css(templateObject_2$l || (templateObject_2$l = __makeTemplateObject(["\n          width: calc(100% - 10px);\n          height: calc(100% - 10px);\n        "], ["\n          width: calc(100% - 10px);\n          height: calc(100% - 10px);\n        "]))) : css(templateObject_3$f || (templateObject_3$f = __makeTemplateObject(["\n          width: 0;\n          height: 0;\n        "], ["\n          width: 0;\n          height: 0;\n        "])));
});
var ContainerRadio = styled.div(templateObject_6$9 || (templateObject_6$9 = __makeTemplateObject(["\n  margin: 5px;\n  cursor: pointer;\n  width: 18px;\n  height: 18px;\n  max-height: 18px;\n  max-width: 18px;\n  min-height: 18px;\n  min-width: 18px;\n  position: relative;\n  display: flex;\n\n  &::before {\n    content: '';\n    border-radius: 100%;\n    border: 2px solid\n      ", ";\n    background: ", ";\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    box-sizing: border-box;\n    pointer-events: none;\n    z-index: ", ";\n  }\n  ", ";\n"], ["\n  margin: 5px;\n  cursor: pointer;\n  width: 18px;\n  height: 18px;\n  max-height: 18px;\n  max-width: 18px;\n  min-height: 18px;\n  min-width: 18px;\n  position: relative;\n  display: flex;\n\n  &::before {\n    content: '';\n    border-radius: 100%;\n    border: 2px solid\n      ", ";\n    background: ", ";\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    box-sizing: border-box;\n    pointer-events: none;\n    z-index: ", ";\n  }\n  ", ";\n"])), function (_a) {
    var disabled = _a.disabled, checked = _a.checked, border = _a.border;
    return checked
        ? border
        : disabled
            ? BaSeTheme.colors.institucionais.cinzaSebrae90
            : BaSeTheme.colors.institucionais.cinzaSebrae75;
}, function (_a) {
    var disabled = _a.disabled, checked = _a.checked, iconColor = _a.iconColor;
    return checked
        ? iconColor
        : disabled
            ? BaSeTheme.colors.institucionais.cinzaSebrae97
            : BaSeTheme.colors.defaultColors.white;
}, BaSeTheme.stackOrder.default, function (_a) {
    var disabled = _a.disabled, checked = _a.checked, backgroundOnHover = _a.backgroundOnHover;
    return !disabled && css(templateObject_5$a || (templateObject_5$a = __makeTemplateObject(["\n      &:hover,\n      &.hover {\n        &::before {\n          border: 2px solid\n            ", ";\n        }\n        & ", " {\n          background: ", ";\n        }\n      }\n    "], ["\n      &:hover,\n      &.hover {\n        &::before {\n          border: 2px solid\n            ", ";\n        }\n        & ", " {\n          background: ", ";\n        }\n      }\n    "])), function () {
        return checked
            ? backgroundOnHover
            : BaSeTheme.colors.institucionais.azulSebrae30;
    }, RadioMarker, backgroundOnHover);
});
var InputRadio = styled.input.attrs({ type: 'radio' })(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject(["\n  opacity: 0;\n  z-index: ", ";\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  cursor: pointer;\n  &:focus {\n    outline: none;\n  }\n  &:disabled {\n    cursor: not-allowed;\n  }\n"], ["\n  opacity: 0;\n  z-index: ", ";\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  cursor: pointer;\n  &:focus {\n    outline: none;\n  }\n  &:disabled {\n    cursor: not-allowed;\n  }\n"])), BaSeTheme.stackOrder.normal + 1);
var LabelRadio = styled.label(templateObject_10$5 || (templateObject_10$5 = __makeTemplateObject(["\n  display: block;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-size: ", "px;\n  width: ", ";\n  ", ";\n"], ["\n  display: block;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  font-size: ", "px;\n  width: ", ";\n  ", ";\n"])), function (_a) {
    var _b;
    var size = _a.size;
    return (_b = mapSizeRadio[size]) !== null && _b !== void 0 ? _b : mapSizeRadio.medium;
}, function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var disabled = _a.disabled;
    return disabled
        ? css(templateObject_8$6 || (templateObject_8$6 = __makeTemplateObject(["\n          color: ", ";\n          cursor: not-allowed;\n        "], ["\n          color: ", ";\n          cursor: not-allowed;\n        "])), BaSeTheme.colors.institucionais.cinzaSebrae75) : css(templateObject_9$6 || (templateObject_9$6 = __makeTemplateObject(["\n          color: ", ";\n          cursor: pointer;\n        "], ["\n          color: ", ";\n          cursor: pointer;\n        "])), BaSeTheme.colors.institucionais.cinzaSebrae30);
});
var templateObject_1$p, templateObject_2$l, templateObject_3$f, templateObject_4$c, templateObject_5$a, templateObject_6$9, templateObject_7$6, templateObject_8$6, templateObject_9$6, templateObject_10$5;

var BaSeRadio = function (_a) {
    var id = _a.id, name = _a.name, _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.labelWidth, labelWidth = _c === void 0 ? 'auto' : _c, _d = _a.size, size = _d === void 0 ? 'medium' : _d, _e = _a.checked, checked = _e === void 0 ? false : _e, _f = _a.onChange, onChange = _f === void 0 ? function () { } : _f, _g = _a.disabled, disabled = _g === void 0 ? false : _g, _h = _a.color, color = _h === void 0 ? 'default' : _h;
    if (!name) {
        throw Error('Atributo "name" é obrigatório no BaSeRadio');
    }
    if (!id) {
        throw Error('Atributo "id" é obrigatório no BaSeRadio');
    }
    var _j = React.useState(false), hover = _j[0], setHover = _j[1];
    var changeValue = function () { return onChange(id); };
    var colorIsMapped = color === BaSeTheme.components.button.colors.default ||
        color === BaSeTheme.components.button.colors.destructive ||
        color === BaSeTheme.components.button.colors.confirmation ||
        color === BaSeTheme.components.button.colors.negative;
    var getColorsAtributes = function () {
        var _a, _b;
        if (color) {
            if (!colorIsMapped) {
                return mapCustomColorsRadioValues(color).primary;
            }
            else {
                if (color === BaSeTheme.components.button.colors.negative) {
                    return (_a = mapRadioValues('default').primary) === null || _a === void 0 ? void 0 : _a.negative;
                }
                return (_b = mapRadioValues(color).primary) === null || _b === void 0 ? void 0 : _b.generalColors;
            }
        }
        else {
            return mapRadioValues('default').primary.generalColors;
        }
    };
    var buttonValues = disabled
        ? color === 'negative'
            ? mapRadioValues('disabled').primary.negative
            : mapRadioValues('disabled').primary.generalColors
        : getColorsAtributes();
    var _k = buttonValues.style, bgC = _k.bgC, border = _k.border, bcCHover = _k.bcCHover, iconColor = buttonValues.iconColor;
    return (React.createElement(RadioWrapper, { className: "BaSe--radio" },
        React.createElement(ContainerRadio, { className: "BaSe--radio-marker-container ".concat(hover ? 'hover' : ''), checked: checked, disabled: disabled, backgroundColor: bgC, border: border, iconColor: iconColor, backgroundOnHover: bcCHover },
            React.createElement(InputRadio, { className: "BaSe--radio-input", onChange: changeValue, name: name, value: id, checked: checked, "aria-checked": checked, disabled: disabled }),
            React.createElement(RadioMarker, { className: "BaSe--radio-marker", checked: checked, disabled: disabled, backgroundColor: bgC, border: border, backgroundOnHover: bcCHover, iconColor: iconColor })),
        React.createElement(LabelRadio, { className: "BaSe--radio-label", disabled: disabled, size: size, width: labelWidth, onClick: function () { return !disabled && onChange(id); }, onPointerEnter: function () { return setHover(true); }, onPointerLeave: function () { return setHover(false); } }, label)));
};
BaSeRadio.displayName = 'BaSeRadio';

var mapSelectValues = function (color) {
    var colorIsMapped = color === BaSeTheme.components.button.colors.default ||
        color === BaSeTheme.components.button.colors.destructive ||
        color === BaSeTheme.components.button.colors.attention ||
        color === BaSeTheme.components.button.colors.confirmation;
    if (colorIsMapped) {
        return {
            style: {
                bgC: ColorMapper[color].foreground,
                bcCHover: ColorMapper[color].hover.defaultLight,
                boxShadowFocus: ColorMapper[color].focus.defaultLight,
                border: ColorMapper[color].foreground,
            },
        };
    }
    else {
        var customColorHsv = Color.generateFromHex(color);
        return {
            style: {
                bgC: color && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
                bcCHover: ColorMapper.light.hover.create(color
                    ? color
                    : BaSeTheme.colors.institucionais.azulSebrae36),
                boxShadowFocus: ColorMapper.light.focus.create(color
                    ? color
                    : BaSeTheme.colors.institucionais.azulSebrae36),
                border: color && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
            },
        };
    }
};
var mapBaSeSelectColor = {
    default: {
        iconColor: ColorMapper.grayScale.foreground,
        color: BaSeTheme.colors.institucionais.cinzaSebrae60,
        selectedColor: ColorMapper.grayScale.hover.defaultDark,
        borderColor: ColorMapper.grayScale.focus.defaultLight,
        bgC: BaSeTheme.colors.defaultColors.white,
    },
    error: {
        iconColor: BaSeTheme.colors.feedbackInterface.erro35,
        color: BaSeTheme.colors.feedbackInterface.erro35,
        selectedColor: BaSeTheme.colors.feedbackInterface.erro35,
        borderColor: BaSeTheme.colors.feedbackInterface.erro35,
        bgC: BaSeTheme.colors.defaultColors.white,
    },
    disabled: {
        iconColor: BaSeTheme.colors.institucionais.cinzaSebrae75,
        color: BaSeTheme.colors.institucionais.cinzaSebrae75,
        selectedColor: ColorMapper.grayScale.hover.defaultDark,
        borderColor: BaSeTheme.colors.institucionais.cinzaSebrae75,
        bgC: BaSeTheme.colors.institucionais.cinzaSebrae97,
    },
};

var getPixelsFromSize = function (size, hasLabel) {
    if (hasLabel) {
        return size === 'small' ? 32 : size === 'medium' ? 38 : 43;
    }
    else {
        return size === 'small' ? 9 : size === 'medium' ? 15 : 16;
    }
};
var WrapperSelect = styled.div.attrs({
    className: 'BaSe--select',
})(templateObject_2$k || (templateObject_2$k = __makeTemplateObject(["\n  position: relative;\n  width: ", ";\n\n  ", "\n"], ["\n  position: relative;\n  width: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.width, width = _b === void 0 ? 'auto' : _b;
    return numberWithUnit(width);
}, function (_a) {
    var isDisabled = _a.isDisabled;
    return isDisabled && css(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n      * {\n        cursor: not-allowed;\n        user-select: none;\n      }\n    "], ["\n      * {\n        cursor: not-allowed;\n        user-select: none;\n      }\n    "])));
});
var WrapperInputlabel = styled.div(templateObject_3$e || (templateObject_3$e = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  z-index: ", ";\n  background-color: transparent;\n  position: relative;\n  margin-bottom: 2px;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  z-index: ", ";\n  background-color: transparent;\n  position: relative;\n  margin-bottom: 2px;\n"])), BaSeTheme.stackOrder.aboveNormal);
var HideTopOfWrapperOptions = styled.div(templateObject_4$b || (templateObject_4$b = __makeTemplateObject(["\n  height: 8px;\n  width: calc(100% - 2px);\n  background: ", ";\n  border: none;\n  box-sizing: border-box;\n  position: relative;\n  z-index: ", ";\n  margin: 0;\n  padding: 0;\n  margin-top: -8px;\n  margin-left: 1px;\n"], ["\n  height: 8px;\n  width: calc(100% - 2px);\n  background: ", ";\n  border: none;\n  box-sizing: border-box;\n  position: relative;\n  z-index: ", ";\n  margin: 0;\n  padding: 0;\n  margin-top: -8px;\n  margin-left: 1px;\n"])), BaSeTheme.colors.defaultColors.white, BaSeTheme.stackOrder.overlay + 1);
var WrapperOptions = styled.ul.attrs({
    className: 'BaSe--select-options',
})(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding: 1px;\n  transition: ", ";\n  position: absolute;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  z-index: ", ";\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  border-top: none;\n  border-radius: 0px 0px 4px 4px;\n  height: ", ";\n  opacity: ", ";\n  margin-top: ", ";\n  border-width: ", ";\n  box-shadow: ", ";\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 1px;\n  transition: ", ";\n  position: absolute;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  z-index: ", ";\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  border-top: none;\n  border-radius: 0px 0px 4px 4px;\n  height: ", ";\n  opacity: ", ";\n  margin-top: ", ";\n  border-width: ", ";\n  box-shadow: ", ";\n\n  ", "\n"])), BaSeTheme.transitions.allPropertiesContinuousNormal, BaSeTheme.stackOrder.overlay, BaSeTheme.colors.defaultColors.white, function (_a) {
    var hasError = _a.hasError, border = _a.border;
    return hasError ? mapBaSeSelectColor.error.borderColor : border;
}, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? 'auto' : '0px');
}, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? '1' : '0');
}, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? '-3px' : '0');
}, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? '1px' : '0');
}, function (_a) {
    var isOpen = _a.isOpen, hasError = _a.hasError, boxShadowFocus = _a.boxShadowFocus;
    return isOpen
        ? hasError
            ? BaSeTheme.shadows.focusError
            : "0 0 4px ".concat(boxShadowFocus)
        : 'none';
}, BaSeScrollbarCss);
var WrapperOption = styled.li.attrs({
    className: 'BaSe--select-option',
})(templateObject_6$8 || (templateObject_6$8 = __makeTemplateObject(["\n  padding-left: 12px;\n  display: flex;\n  align-items: center;\n  transition: ", ";\n  will-change: background-color;\n  padding: 5px;\n  background-color: ", ";\n  cursor: pointer;\n\n  & > * {\n    will-change: font-weight;\n  }\n\n  &:focus,\n  &:hover {\n    outline: none;\n    background-color: ", ";\n  }\n\n  &:focus {\n    & > * {\n      font-weight: bold;\n    }\n  }\n\n  img {\n    float: left;\n    width: 1.46em;\n    height: 1.46em;\n  }\n"], ["\n  padding-left: 12px;\n  display: flex;\n  align-items: center;\n  transition: ", ";\n  will-change: background-color;\n  padding: 5px;\n  background-color: ", ";\n  cursor: pointer;\n\n  & > * {\n    will-change: font-weight;\n  }\n\n  &:focus,\n  &:hover {\n    outline: none;\n    background-color: ", ";\n  }\n\n  &:focus {\n    & > * {\n      font-weight: bold;\n    }\n  }\n\n  img {\n    float: left;\n    width: 1.46em;\n    height: 1.46em;\n  }\n"])), BaSeTheme.transitions.allPropertiesContinuousFast, function (_a) {
    var isActive = _a.isActive, multiple = _a.multiple, bcCHover = _a.bcCHover, bgC = _a.bgC;
    return isActive
        ? multiple
            ? bcCHover
            : bgC
        : BaSeTheme.colors.defaultColors.white;
}, function (_a) {
    var isActive = _a.isActive, multiple = _a.multiple, bgC = _a.bgC, bcCHover = _a.bcCHover;
    return isActive && !multiple ? bgC : bcCHover;
});
var WrapperIcon = styled.div(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject(["\n  position: absolute;\n  transition: ", ";\n  will-change: transform;\n  transform: ", ";\n  right: 9px;\n  top: ", "px;\n  width: 16px;\n  height: 16px;\n  & > * {\n    transition: opacity ", ";\n    will-change: transform, opacity;\n    transform: scale(0);\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n\n    &:last-child {\n      transform: scale(1);\n      opacity: 1;\n    }\n  }\n"], ["\n  position: absolute;\n  transition: ", ";\n  will-change: transform;\n  transform: ", ";\n  right: 9px;\n  top: ", "px;\n  width: 16px;\n  height: 16px;\n  & > * {\n    transition: opacity ", ";\n    will-change: transform, opacity;\n    transform: scale(0);\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n\n    &:last-child {\n      transform: scale(1);\n      opacity: 1;\n    }\n  }\n"])), BaSeTheme.transitions.allPropertiesContinuousNormal, function (_a) {
    var isOpen = _a.isOpen;
    return (!isOpen ? 'rotateX(0)' : 'rotateX(180deg)');
}, function (_a) {
    var vSize = _a.vSize, hasLabel = _a.hasLabel;
    return getPixelsFromSize(vSize, hasLabel);
}, BaSeTheme.transitions.durationNormal);
var SelectInput = styled.input.attrs({
    className: 'BaSe--select-input',
})(templateObject_11$3 || (templateObject_11$3 = __makeTemplateObject(["\n  width: calc(100% - 46px);\n  height: ", "px;\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: 4px;\n  font-size: ", "px;\n  padding: 0px 32px 0px 12px;\n\n  ", "\n\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n\n  ", "\n\n  &:read-only {\n    cursor: default;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    user-select: none;\n  }\n"], ["\n  width: calc(100% - 46px);\n  height: ", "px;\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: 4px;\n  font-size: ", "px;\n  padding: 0px 32px 0px 12px;\n\n  ", "\n\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n\n  ", "\n\n  &:read-only {\n    cursor: default;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    user-select: none;\n  }\n"])), function (_a) {
    var vSize = _a.vSize;
    return vSize === 'small' ? 30 : vSize === 'medium' ? 38 : 46;
}, function (_a) {
    var colorType = _a.colorType;
    return mapBaSeSelectColor[colorType].bgC;
}, function (_a) {
    var isOpen = _a.isOpen, border = _a.border, colorType = _a.colorType;
    return colorType !== 'default'
        ? mapBaSeSelectColor[colorType].borderColor
        : isOpen
            ? border
            : mapBaSeSelectColor[colorType].borderColor;
}, function (_a) {
    var vSize = _a.vSize;
    return (vSize === 'small' ? 13 : 16);
}, function (_a) {
    var hasIcon = _a.hasIcon, isOpen = _a.isOpen;
    return hasIcon &&
        !isOpen && css(templateObject_8$5 || (templateObject_8$5 = __makeTemplateObject(["\n      width: calc(100% - 58px);\n      padding-left: 28px;\n    "], ["\n      width: calc(100% - 58px);\n      padding-left: 28px;\n    "])));
}, function (_a) {
    var isOpen = _a.isOpen, hasError = _a.hasError, boxShadowFocus = _a.boxShadowFocus, colorType = _a.colorType, bgC = _a.bgC;
    return isOpen && css(templateObject_9$5 || (templateObject_9$5 = __makeTemplateObject(["\n      box-shadow: ", ";\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n    "], ["\n      box-shadow: ", ";\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n    "])), hasError
        ? BaSeTheme.shadows.focusError
        : "0 0 4px ".concat(boxShadowFocus), mapBaSeSelectColor[colorType].iconColor, bgC);
}, function (_a) {
    var colorType = _a.colorType, hasSelectedOption = _a.hasSelectedOption;
    return css(templateObject_10$4 || (templateObject_10$4 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), hasSelectedOption
        ? mapBaSeSelectColor[colorType].selectedColor
        : mapBaSeSelectColor[colorType].color);
});
styled.span(templateObject_12$3 || (templateObject_12$3 = __makeTemplateObject(["\n  font-size: 0.83em;\n  color: ", ";\n  margin-top: 3px;\n  line-height: 1.2em;\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n"], ["\n  font-size: 0.83em;\n  color: ", ";\n  margin-top: 3px;\n  line-height: 1.2em;\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n"])), BaSeTheme.colors.feedbackInterface.erro35, BaSeTheme.typography.fontFamily);
var StyledLabel = styled.label(templateObject_13$3 || (templateObject_13$3 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n"])), function (props) { return props.fontSize; }, function (props) { return props.lineHeight; }, BaSeTheme.colors.institucionais.cinzaSebrae45, BaSeTheme.typography.fontFamily);
styled.div(templateObject_14$3 || (templateObject_14$3 = __makeTemplateObject(["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var StyledSubLabel = styled.label(templateObject_15$2 || (templateObject_15$2 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 23px;\n  color: ", ";\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n  margin-left: 4px;\n"], ["\n  font-size: 16px;\n  line-height: 23px;\n  color: ", ";\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n  margin-left: 4px;\n"])), BaSeTheme.colors.institucionais.cinzaSebrae60, BaSeTheme.typography.fontFamily);
var ButtonInfoContainerHelper = styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var MoreInfoContainer$1 = styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  padding-top: 4px;\n"], ["\n  padding-top: 4px;\n"])));
var WrapperHelper$1 = styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  padding-top: 2px;\n"], ["\n  padding-top: 2px;\n"])));
var WrapperMultipleInformation = styled.li(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n  color: ", ";\n  background-color: ", ";\n  position: sticky;\n  top: 0;\n  z-index: ", ";\n  &:focus,\n  &:hover {\n    outline: none;\n    background-color: ", ";\n  }\n\n  &:focus {\n    & > * {\n      font-weight: bold;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n  color: ", ";\n  background-color: ", ";\n  position: sticky;\n  top: 0;\n  z-index: ", ";\n  &:focus,\n  &:hover {\n    outline: none;\n    background-color: ", ";\n  }\n\n  &:focus {\n    & > * {\n      font-weight: bold;\n    }\n  }\n"])), BaSeTheme.colors.institucionais.cinzaSebrae45, BaSeTheme.colors.defaultColors.white, BaSeTheme.stackOrder.overlay, function (_a) {
    var bcCHover = _a.bcCHover;
    return bcCHover;
});
styled.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var OptionWithIconSelected = styled.div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  position: absolute;\n  left: 9px;\n  top: ", "px;\n  width: 16px;\n  height: 16px;\n"], ["\n  position: absolute;\n  left: 9px;\n  top: ", "px;\n  width: 16px;\n  height: 16px;\n"])), function (_a) {
    var vSize = _a.vSize, hasLabel = _a.hasLabel;
    return getPixelsFromSize(vSize, hasLabel);
});
var templateObject_1$o, templateObject_2$k, templateObject_3$e, templateObject_4$b, templateObject_5$9, templateObject_6$8, templateObject_7$5, templateObject_8$5, templateObject_9$5, templateObject_10$4, templateObject_11$3, templateObject_12$3, templateObject_13$3, templateObject_14$3, templateObject_15$2, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;

var idSequence$3 = idGenerator();
function filteredEmptyValue(list, removeEmptyValue, emptyValueLabel) {
    if (removeEmptyValue) {
        return list.filter(function (item) { return item.label !== emptyValueLabel; });
    }
    return list;
}
var BaSeSelect = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var _h = _a.complement, complement = _h === void 0 ? '' : _h, _j = _a.hasError, hasError = _j === void 0 ? false : _j, _k = _a.label, label = _k === void 0 ? '' : _k, _l = _a.searchable, searchable = _l === void 0 ? false : _l, _m = _a.selectedValueId, selectedValueId = _m === void 0 ? 0 : _m, _o = _a.subLabel, subLabel = _o === void 0 ? '' : _o, _p = _a.showHelpButton, showHelpButton = _p === void 0 ? false : _p, _q = _a.values, values = _q === void 0 ? [] : _q, _r = _a.width, width = _r === void 0 ? null : _r, _s = _a.size, size = _s === void 0 ? 'medium' : _s, _t = _a.emptyValueLabel, emptyValueLabel = _t === void 0 ? '' : _t, _u = _a.isDisabled, isDisabled = _u === void 0 ? false : _u, _v = _a.helpButtonProps, helpButtonProps = _v === void 0 ? {} : _v, _w = _a.moreInfoLabel, moreInfoLabel = _w === void 0 ? '' : _w, _x = _a.moreInfoDetails, moreInfoDetails = _x === void 0 ? '' : _x, _y = _a.removeEmptyValue, removeEmptyValue = _y === void 0 ? false : _y, _z = _a.color, color = _z === void 0 ? 'default' : _z, _0 = _a.overrideColor, overrideColor = _0 === void 0 ? {} : _0, _1 = _a.onChange, onChange = _1 === void 0 ? function () { } : _1;
    var id = getNextHash(idSequence$3);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var getColorsAtributes = function () {
        if (color) {
            return mapSelectValues(color);
        }
        return mapSelectValues('default');
    };
    var _2 = getColorsAtributes().style, bcCHover = _2.bcCHover, bgC = _2.bgC, boxShadowFocus = _2.boxShadowFocus, border = _2.border;
    emptyValueLabel =
        emptyValueLabel === '' ? getMessage('select.emptyValue') : emptyValueLabel;
    var memoValues = React.useMemo(function () {
        if (!Array.isArray(values)) {
            return [];
        }
        return values;
    }, [values.toString()]); // Nem repara nisso.. Vai entender? ¯\_(ツ)_/¯
    var emptyValue = React.useMemo(function () { return ({ label: emptyValueLabel, id: 0 }); }, []);
    var originalValues = React.useMemo(function () {
        return __spreadArray([
            emptyValue
        ], filteredEmptyValue(memoValues, removeEmptyValue, emptyValueLabel), true).map(function (item) { return (__assign(__assign({}, item), { ref: React.createRef() })); });
    }, [memoValues]);
    var externalSelectedValues = React.useMemo(function () {
        return Array.isArray(selectedValueId) ? selectedValueId : [selectedValueId];
    }, [selectedValueId]);
    var initialSelectedValues = React.useMemo(function () {
        return originalValues.filter(function (s) {
            return externalSelectedValues.some(function (valueId) { return s.id === valueId; });
        });
    }, [
        originalValues.map(function (val) { return val.id; }).toString(),
        externalSelectedValues.toString(),
    ]);
    var _3 = React.useState('default'), colorType = _3[0], setColorType = _3[1];
    var _4 = React.useState(true), firstTimeEmited = _4[0], setFirstTimeEmited = _4[1];
    var _5 = React.useState(''), searchableText = _5[0], setSearchableText = _5[1];
    var _6 = React.useState(false), isOpen = _6[0], setIsOpen = _6[1];
    var _7 = React.useState([]), allValues = _7[0], setAllValues = _7[1];
    var _8 = React.useState([originalValues[0]]), selectedValues = _8[0], setSelectedValues = _8[1];
    var selectInputRef = React.useRef(null);
    var wrapperRef = React.useRef(null);
    useOutsideEvent(wrapperRef, setIsOpen);
    React.useEffect(function () {
        setColorType(isDisabled ? 'disabled' : hasError ? 'error' : 'default');
    }, [hasError, isDisabled]);
    var emitChange = React.useCallback(function () {
        if (firstTimeEmited) {
            setFirstTimeEmited(false);
            return;
        }
        function valueToEmit(val) {
            var finalValue = __assign({}, val);
            delete finalValue.ref;
            return finalValue;
        }
        onChange(valueToEmit(selectedValues[0]));
        return;
    }, [selectedValues]);
    var setSingleValue = React.useCallback(function (selected, noClose) {
        if (!noClose) {
            setIsOpen(false);
        }
        if (selected.id === 0) {
            setSearchableText('');
        }
        setSelectedValues([selected]);
    }, []);
    var updateValue = React.useCallback(function (selected, isNotInputEvent, noClose) {
        if (isNotInputEvent === void 0) { isNotInputEvent = false; }
        if (noClose === void 0) { noClose = false; }
        if (isNotInputEvent) {
            setAllValues(originalValues);
            setSingleValue(selected, noClose);
        }
        else {
            var valueFromTarget_1 = selected.target.value;
            var filteredValues = filteredEmptyValue(originalValues, removeEmptyValue, emptyValueLabel).filter(function (item) {
                return normalize(item.label).includes(normalize(valueFromTarget_1));
            });
            setSearchableText(valueFromTarget_1);
            setAllValues(filteredValues);
        }
    }, [originalValues]);
    var onFocusInput = React.useCallback(function () { return setIsOpen(!isDisabled && true); }, [isDisabled]);
    var onKeyDownWrapper = React.useCallback(function (key) {
        if (['ArrowUp', 'ArrowDown'].includes(key)) {
            var focusedIndex_1 = allValues.findIndex(function (option) { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = option === null || option === void 0 ? void 0 : option.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.classList) === null || _c === void 0 ? void 0 : _c.contains) === null || _d === void 0 ? void 0 : _d.call(_c, 'focus'); });
            selectedValues.map(function (value) {
                var _a, _b;
                var activeIndex = allValues.findIndex(function (option) { return option.id === value.id; });
                var actualIndex = focusedIndex_1 > -1 ? focusedIndex_1 : activeIndex;
                var nextIndex = actualIndex + (key === 'ArrowDown' ? 1 : -1);
                var nextItem = allValues === null || allValues === void 0 ? void 0 : allValues[nextIndex];
                (_b = (_a = nextItem === null || nextItem === void 0 ? void 0 : nextItem.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
            });
        }
    }, [selectedValues, allValues]);
    var onClose = React.useCallback(function () {
        allValues.forEach(function (_a) {
            var _b, _c, _d;
            var ref = _a.ref;
            return (_d = (_c = (_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.classList) === null || _c === void 0 ? void 0 : _c.remove) === null || _d === void 0 ? void 0 : _d.call(_c, 'focus');
        });
        setSearchableText('');
    }, [allValues]);
    React.useEffect(function () {
        emitChange();
    }, [selectedValues]);
    React.useEffect(function () {
        initialSelectedValues.forEach(function (value) { return updateValue(value, true, true); });
    }, [initialSelectedValues]);
    React.useEffect(function () {
        setAllValues(originalValues);
    }, [originalValues]);
    React.useEffect(function () {
        var _a;
        if (isDisabled) {
            return;
        }
        if (isOpen) {
            (_a = selectInputRef === null || selectInputRef === void 0 ? void 0 : selectInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            onClose();
        }
    }, [isOpen]);
    return (React.createElement(WrapperSelect, { ref: wrapperRef, isDisabled: isDisabled, width: width, onKeyDown: function (event) { return onKeyDownWrapper(event.key); } },
        React.createElement(BaSeFormLabel, { id: id, label: label, subLabel: subLabel, showHelpButton: showHelpButton, helpButtonProps: helpButtonProps }),
        React.createElement(WrapperIcon, { hasLabel: !!label, vSize: size, isOpen: isOpen, searchable: searchable },
            React.createElement(BaSeIcon, { description: isOpen
                    ? getMessage('select.closeOptions')
                    : getMessage('select.openOptions'), name: "arrow-head-down", size: 16, onClick: isDisabled
                    ? undefined
                    : function () { return setIsOpen(function (actualState) { return !actualState; }); }, color: isDisabled
                    ? BaSeTheme.colors.institucionais.cinzaSebrae75
                    : (_b = overrideColor.iconColor) !== null && _b !== void 0 ? _b : bgC }),
            searchable && selectedValues && isOpen && (React.createElement(BaSeIcon, { description: getMessage('select.cleanSearch'), name: "close", size: 16, onClick: isDisabled ? undefined : function () { return updateValue(emptyValue, true, true); }, color: isDisabled
                    ? BaSeTheme.colors.institucionais.cinzaSebrae75
                    : (_c = overrideColor.iconColor) !== null && _c !== void 0 ? _c : bgC }))),
        React.createElement(OptionWithIconSelected, { hasLabel: !!label, vSize: size }, selectedValues[0].icon && !isOpen && (React.createElement(BaSeIcon, { name: (_d = selectedValues[0].icon) !== null && _d !== void 0 ? _d : '', color: (_e = overrideColor.selectedBackgroundColor) !== null && _e !== void 0 ? _e : bgC, description: (_g = (_f = selectedValues[0]) === null || _f === void 0 ? void 0 : _f.iconDescription) !== null && _g !== void 0 ? _g : getMessage('icon.label', selectedValues[0].label), size: 16 }))),
        React.createElement(SelectInput, { id: id, ref: selectInputRef, hasSelectedOption: selectedValues[0].label !== emptyValueLabel, disabled: isDisabled, readOnly: !searchable, vSize: size, boxShadowFocus: boxShadowFocus, border: border, bgC: searchable ? bgC : mapBaSeSelectColor[colorType].iconColor, colorType: colorType, value: searchable && isOpen
                ? searchableText
                : selectedValues.length > 3
                    ? getMessage('select.selectedCounter', selectedValues.filter(function (val) { return val.id !== 0; }).length)
                    : "".concat(selectedValues
                        .map(function (val) { return val.label; })
                        .join(', ')
                        .replace(/, ([^,]*)$/, " ".concat(getMessage('select.and'), " $1"))), isOpen: isOpen, hasIcon: selectedValues[0].icon !== undefined, hasError: hasError, onChange: function (newValue) { return updateValue(newValue); }, onFocus: onFocusInput }),
        allValues.length > 0 && (React.createElement(React.Fragment, null,
            isOpen && React.createElement(HideTopOfWrapperOptions, null),
            React.createElement(WrapperOptions, { border: border, boxShadowFocus: boxShadowFocus, isOpen: isOpen, role: "menu", hasError: hasError }, filteredEmptyValue(allValues, removeEmptyValue, emptyValueLabel).map(function (option) {
                var _a, _b, _c, _d, _e;
                return (React.createElement(WrapperOption, { ref: option.ref, key: option.id.toString(), multiple: false, bcCHover: (_a = overrideColor.selectHoverColor) !== null && _a !== void 0 ? _a : bcCHover, bgC: (_b = overrideColor.selectedBackgroundColor) !== null && _b !== void 0 ? _b : bgC, isActive: selectedValues.findIndex(function (select) { return select.id === option.id; }) > -1, role: "menuitem", tabIndex: -1, onKeyDown: function (event) {
                        return event.key === 'Enter' && updateValue(option, true);
                    }, onClick: function (e) {
                        e.preventDefault();
                        updateValue(option, true);
                    }, onFocus: function () { var _a, _b; return (_b = (_a = option.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.classList.add('focus'); }, onBlur: function () { var _a, _b; return (_b = (_a = option.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.classList.remove('focus'); } },
                    React.createElement(BaSeText, { color: selectedValues.findIndex(function (select) { return select.id === option.id; }) > -1
                            ? BaSeTheme.colors.defaultColors.white
                            : BaSeTheme.colors.institucionais.cinzaSebrae30 },
                        option.icon && (React.createElement(BaSeIcon, { name: (_c = option.icon) !== null && _c !== void 0 ? _c : '', color: selectedValues.findIndex(function (select) { return select.id === option.id; }) > -1
                                ? BaSeTheme.colors.defaultColors.white
                                : (_d = overrideColor.selectedBackgroundColor) !== null && _d !== void 0 ? _d : bgC, size: 23, description: (_e = option.iconDescription) !== null && _e !== void 0 ? _e : getMessage('icon.label', option.label) })),
                        option.label)));
            })))),
        !!complement && (React.createElement(WrapperHelper$1, null,
            React.createElement(BaSeHelperText, { isItalic: true, size: "medium", color: mapBaSeSelectColor[colorType].color, label: complement }))),
        !!moreInfoLabel && (React.createElement(MoreInfoContainer$1, null,
            React.createElement(BaSeHelperText, { size: "small", label: moreInfoLabel, details: moreInfoDetails, color: bgC })))));
};
BaSeSelect.displayName = 'BaSeSelect';

var idSequence$2 = idGenerator();
var BaSeMultipleSelect = function (_a) {
    var _b, _c;
    var _d = _a.initialSelectedValuesId, initialSelectedValuesId = _d === void 0 ? [0] : _d, _e = _a.values, values = _e === void 0 ? [] : _e, _f = _a.label, label = _f === void 0 ? '' : _f, _g = _a.subLabel, subLabel = _g === void 0 ? '' : _g, _h = _a.complement, complement = _h === void 0 ? '' : _h, _j = _a.moreInfoLabel, moreInfoLabel = _j === void 0 ? '' : _j, _k = _a.moreInfoDetails, moreInfoDetails = _k === void 0 ? '' : _k, _l = _a.showHelpButton, showHelpButton = _l === void 0 ? false : _l, _m = _a.helpButtonProps, helpButtonProps = _m === void 0 ? {} : _m, _o = _a.size, size = _o === void 0 ? 'medium' : _o, _p = _a.width, width = _p === void 0 ? null : _p, _q = _a.isDisabled, isDisabled = _q === void 0 ? false : _q, _r = _a.hasError, hasError = _r === void 0 ? false : _r, _s = _a.color, color = _s === void 0 ? 'default' : _s, _t = _a.overrideColor, overrideColor = _t === void 0 ? {} : _t, _u = _a.onChange, onChange = _u === void 0 ? function () { } : _u, _v = _a.emptyValueLabel, emptyValueLabel = _v === void 0 ? '' : _v;
    var id = getNextHash(idSequence$2);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var getColorsAtributes = function () {
        if (color) {
            return mapSelectValues(color);
        }
        return mapSelectValues('default');
    };
    var _w = getColorsAtributes().style, bcCHover = _w.bcCHover, bgC = _w.bgC, boxShadowFocus = _w.boxShadowFocus, border = _w.border;
    emptyValueLabel =
        emptyValueLabel === '' ? getMessage('select.emptyValue') : emptyValueLabel;
    var _x = React.useState('default'), colorType = _x[0], setColorType = _x[1];
    var _y = React.useState(false), isOpen = _y[0], setIsOpen = _y[1];
    var _z = React.useState(initialSelectedValuesId), selectedValuesId = _z[0], setSelectedValuesId = _z[1];
    var _0 = React.useState([]), refValues = _0[0], setRefValues = _0[1];
    React.useEffect(function () {
        setRefValues(values.map(function (item) { return (__assign(__assign({}, item), { ref: React.createRef() })); }));
    }, [values]);
    React.useEffect(function () {
        setSelectedValuesId(initialSelectedValuesId);
    }, [initialSelectedValuesId.toString()]);
    var selectInputRef = React.useRef(null);
    var wrapperRef = React.useRef(null);
    useOutsideEvent(wrapperRef, setIsOpen);
    React.useEffect(function () {
        setColorType(isDisabled ? 'disabled' : hasError ? 'error' : 'default');
    }, [hasError, isDisabled]);
    function emitChange() {
        var emitValues = values.filter(function (val) { return selectedValuesId.indexOf(val.id) > -1; });
        onChange(emitValues);
    }
    React.useEffect(function () {
        emitChange();
    }, [selectedValuesId.toString()]);
    var updateValue = React.useCallback(function (selected) {
        if (selectedValuesId.indexOf(selected.id) > -1) {
            return setSelectedValuesId(function (input) {
                return input.filter(function (val) { return val !== selected.id; });
            });
        }
        setSelectedValuesId(function (input) { return input.concat([selected.id]); });
    }, [selectedValuesId]);
    var selectAll = React.useCallback(function () {
        if (refValues.length > selectedValuesId.length) {
            setSelectedValuesId(refValues.map(function (option) { return option.id; }));
        }
        else {
            setSelectedValuesId([]);
        }
    }, [refValues, selectedValuesId]);
    var onFocusInput = React.useCallback(function () { return setIsOpen(!isDisabled && true); }, [isDisabled]);
    var onClose = React.useCallback(function () { }, []);
    React.useEffect(function () {
        var _a;
        if (isDisabled) {
            return;
        }
        if (isOpen) {
            (_a = selectInputRef === null || selectInputRef === void 0 ? void 0 : selectInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            onClose();
        }
    }, [isOpen]);
    return (React.createElement(WrapperSelect, { ref: wrapperRef, isDisabled: isDisabled, width: width },
        React.createElement(WrapperInputlabel, null,
            React.createElement(StyledLabel, { fontSize: size === 'small' ? '13px' : '16px', lineHeight: size === 'small' ? '16px' : '23px', htmlFor: id }, label),
            React.createElement(StyledSubLabel, { htmlFor: id }, subLabel),
            showHelpButton && (React.createElement(ButtonInfoContainerHelper, null,
                React.createElement(BaSePopupButton, __assign({}, helpButtonProps))))),
        React.createElement(WrapperIcon, { hasLabel: !!label, vSize: size, isOpen: isOpen, searchable: false },
            React.createElement(BaSeIcon, { description: isOpen
                    ? getMessage('select.closeOptions')
                    : getMessage('select.openOptions'), name: "arrow-head-down", size: 16, onClick: isDisabled
                    ? undefined
                    : function () { return setIsOpen(function (actualState) { return !actualState; }); }, color: isDisabled
                    ? BaSeTheme.colors.institucionais.cinzaSebrae75
                    : (_b = overrideColor.iconColor) !== null && _b !== void 0 ? _b : bgC })),
        React.createElement(SelectInput, { id: id, ref: selectInputRef, hasSelectedOption: false, disabled: isDisabled, vSize: size, boxShadowFocus: boxShadowFocus, readOnly: true, border: border, bgC: mapBaSeSelectColor[colorType].iconColor, colorType: colorType, value: selectedValuesId.length < 1
                ? emptyValueLabel
                : selectedValuesId.length > 3
                    ? getMessage('select.selectedCounter', selectedValuesId.length)
                    : "".concat(refValues
                        .filter(function (val) { return selectedValuesId.indexOf(val.id) > -1; })
                        .map(function (val) { return val.label; })
                        .join(', ')
                        .replace(/, ([^,]*)$/, " ".concat(getMessage('select.and'), " $1"))), isOpen: isOpen, hasError: hasError, onChange: function (newValue) { return updateValue(newValue); }, onFocus: onFocusInput }),
        refValues.length > 0 && (React.createElement(React.Fragment, null,
            isOpen && React.createElement(HideTopOfWrapperOptions, null),
            React.createElement(WrapperOptions, { border: border, boxShadowFocus: boxShadowFocus, isOpen: isOpen, role: "menu", hasError: hasError },
                React.createElement(WrapperMultipleInformation, { tabIndex: 0, bcCHover: (_c = overrideColor.selectHoverColor) !== null && _c !== void 0 ? _c : bcCHover, onKeyDown: function (event) { return event.key === 'Enter' && selectAll(); }, onClick: function (e) {
                        e.preventDefault();
                        selectAll();
                    } },
                    React.createElement(BaSeCheckbox, { align: "top-left", isInteractive: false, color: color, label: getMessage('select.selectAll'), size: "medium", indeterminate: selectedValuesId.length !== refValues.length, checked: selectedValuesId.length > 0 })),
                refValues.map(function (option) {
                    var _a;
                    return (React.createElement(WrapperOption, { ref: option.ref, key: option.id.toString(), multiple: true, bcCHover: (_a = overrideColor.selectHoverColor) !== null && _a !== void 0 ? _a : bcCHover, bgC: bgC, isActive: false, role: "menuitem", tabIndex: 0, onKeyDown: function (event) {
                            return event.key === 'Enter' && updateValue(option);
                        }, onClick: function (e) {
                            e.preventDefault();
                            updateValue(option);
                        }, onFocus: function () { var _a, _b; return (_b = (_a = option.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.classList.add('focus'); }, onBlur: function () { var _a, _b; return (_b = (_a = option.ref) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.classList.remove('focus'); } },
                        React.createElement(BaSeCheckbox, { align: "top-left", isInteractive: false, label: option.label, color: color, size: "medium", checked: selectedValuesId.indexOf(option.id) > -1 })));
                })))),
        !!complement && (React.createElement(WrapperHelper$1, null,
            React.createElement(BaSeHelperText, { isItalic: true, size: "medium", color: mapBaSeSelectColor[colorType].color, label: complement }))),
        !!moreInfoLabel && (React.createElement(MoreInfoContainer$1, null,
            React.createElement(BaSeHelperText, { size: "small", label: moreInfoLabel, details: moreInfoDetails, color: bgC })))));
};
BaSeMultipleSelect.displayName = 'BaSeMultipleSelect';

var mapBaseTextAreaFontSize = {
    medium: {
        size: 16,
        lineHeight: 23,
    },
    small: {
        size: 13,
        lineHeight: 16,
    },
    default: {
        size: 16,
        lineHeight: 23,
    },
};
var mapBaseTextAreaColor = {
    default: {
        borderColor: BaSeTheme.colors.institucionais.cinzaSebrae75,
        color: BaSeTheme.colors.institucionais.cinzaSebrae30,
        boxShadow: 'none',
        backgroundColor: BaSeTheme.colors.defaultColors.white,
    },
    error: {
        borderColor: BaSeTheme.colors.feedbackInterface.erro35,
        color: BaSeTheme.colors.feedbackInterface.erro35,
        boxShadow: 'none',
        backgroundColor: BaSeTheme.colors.defaultColors.white,
    },
    focus: {
        borderColor: BaSeTheme.colors.institucionais.azulSebrae36,
        color: BaSeTheme.colors.institucionais.azulSebrae36,
        boxShadow: BaSeTheme.colors.institucionais.azulSebrae75,
        backgroundColor: BaSeTheme.colors.defaultColors.white,
    },
    disabled: {
        color: BaSeTheme.colors.institucionais.cinzaSebrae75,
        borderColor: BaSeTheme.colors.institucionais.cinzaSebrae75,
        backgroundColor: BaSeTheme.colors.institucionais.cinzaSebrae97,
        boxShadow: 'none',
    },
};

var StyledTextArea = styled.textarea.attrs({
    className: 'BaSe--text-area',
})(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  padding-right: 8px;\n  resize: none;\n  width: 100%;\n  height: 100%;\n\n  font-family: ", ";\n  font-weight: 400;\n  box-sizing: border-box;\n  border: none;\n  font-size: ", "px;\n  line-height: ", "px;\n\n  &:not(:disabled) {\n    color: ", ";\n  }\n\n  &:focus {\n    color: ", ";\n    outline: none !important;\n  }\n\n  ", "\n\n  &:disabled {\n    background: ", ";\n    color: ", ";\n  }\n"], ["\n  padding-right: 8px;\n  resize: none;\n  width: 100%;\n  height: 100%;\n\n  font-family: ", ";\n  font-weight: 400;\n  box-sizing: border-box;\n  border: none;\n  font-size: ", "px;\n  line-height: ", "px;\n\n  &:not(:disabled) {\n    color: ", ";\n  }\n\n  &:focus {\n    color: ", ";\n    outline: none !important;\n  }\n\n  ", "\n\n  &:disabled {\n    background: ", ";\n    color: ", ";\n  }\n"])), BaSeTheme.typography.fontFamily, function (props) {
    var _a, _b;
    return (_b = (_a = mapBaseTextAreaFontSize[props.size]) === null || _a === void 0 ? void 0 : _a.size) !== null && _b !== void 0 ? _b : mapBaseTextAreaFontSize.default.size;
}, function (props) {
    var _a, _b;
    return (_b = (_a = mapBaseTextAreaFontSize[props.size]) === null || _a === void 0 ? void 0 : _a.lineHeight) !== null && _b !== void 0 ? _b : mapBaseTextAreaFontSize.default.lineHeight;
}, function (props) {
    return props.hasError
        ? mapBaseTextAreaColor.error.color
        : mapBaseTextAreaColor.default.color;
}, function (props) {
    return props.hasError
        ? mapBaseTextAreaColor.error.color
        : BaSeTheme.colors.institucionais.azulSebrae36;
}, BaSeScrollbarCss, mapBaseTextAreaColor.disabled.backgroundColor, mapBaseTextAreaColor.disabled.color);
var StyledOuterTextAreaBox = styled.div(templateObject_3$d || (templateObject_3$d = __makeTemplateObject(["\n  background: ", ";\n  box-sizing: border-box;\n  border-radius: 4px;\n  border: 1px solid\n    ", ";\n  padding: 8px;\n  ", "\n  ", "\n  box-shadow: ", "\n"], ["\n  background: ", ";\n  box-sizing: border-box;\n  border-radius: 4px;\n  border: 1px solid\n    ", ";\n  padding: 8px;\n  ", "\n  ", "\n  box-shadow: ", "\n"])), BaSeTheme.colors.defaultColors.white, function (props) {
    return props.hasError && !props.disabled
        ? mapBaseTextAreaColor.error.borderColor
        : props.hasFocus
            ? mapBaseTextAreaColor.focus.borderColor
            : mapBaseTextAreaColor.default.borderColor;
}, function (props) {
    return props.disabled && css(templateObject_2$j || (templateObject_2$j = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), mapBaseTextAreaColor.disabled.backgroundColor);
}, function (props) { return props.disabled && 'pointer-events:none'; }, function (props) {
    return props.hasFocus &&
        (props.hasError
            ? BaSeTheme.shadows.focusError
            : BaSeTheme.shadows.focusPrimary);
});
var StyledTextAreaContainer = styled.div(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var StyledTextAreaLabel = styled.label.attrs({
    className: 'BaSe--text-area-label',
})(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  line-height: 23px;\n  color: ", ";\n  margin-bottom: 2px;\n  font-size: ", ";\n"], ["\n  margin: 0;\n  padding: 0;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  line-height: 23px;\n  color: ", ";\n  margin-bottom: 2px;\n  font-size: ", ";\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.colors.institucionais.cinzaSebrae45, function (props) { return (props.size === 'medium' ? '16px' : '13px'); });
var StyledTextAreaLabelContainer = styled.div.attrs({
    className: 'BaSe--text-area-label-container',
})(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var StyledTextAreaSubLabel = styled.label.attrs({
    className: 'BaSe--text-area-sub-label',
})(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  font-size: ", ";\n  line-height: 23px;\n  font-family: ", ";\n  font-weight: normal;\n  color: ", ";\n  font-style: italic;\n  margin-left: 4px;\n  margin-bottom: 2px;\n"], ["\n  margin: 0;\n  padding: 0;\n  font-size: ", ";\n  line-height: 23px;\n  font-family: ", ";\n  font-weight: normal;\n  color: ", ";\n  font-style: italic;\n  margin-left: 4px;\n  margin-bottom: 2px;\n"])), function (props) { return (props.size === 'medium' ? '16px' : '13px'); }, BaSeTheme.typography.fontFamily, BaSeTheme.colors.institucionais.cinzaSebrae60);
var StyledTextAreaErrorText = styled.span(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject(["\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n  font-size: 13px;\n  line-height: 16px;\n  color: ", ";\n  margin-top: 2px;\n  grid-column: 1/2;\n"], ["\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n  font-size: 13px;\n  line-height: 16px;\n  color: ", ";\n  margin-top: 2px;\n  grid-column: 1/2;\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.colors.feedbackInterface.erro35);
var StyledTextAreaFooter = styled.div(templateObject_10$3 || (templateObject_10$3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var showMultiple = _a.showMultiple;
    return css(templateObject_9$4 || (templateObject_9$4 = __makeTemplateObject(["\n    display: grid;\n    grid-template-columns: 1fr ", ";\n  "], ["\n    display: grid;\n    grid-template-columns: 1fr ", ";\n  "])), showMultiple && '1fr');
});
var StyledTextAreaFooterLimit = styled.div(templateObject_11$2 || (templateObject_11$2 = __makeTemplateObject(["\n  grid-column: 2/3;\n  display: flex;\n  justify-content: flex-end;\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n  font-size: 13px;\n  line-height: 16px;\n  color: ", ";\n  margin-top: 2px;\n  color: #717b88;\n"], ["\n  grid-column: 2/3;\n  display: flex;\n  justify-content: flex-end;\n  font-family: ", ";\n  font-style: italic;\n  font-weight: normal;\n  font-size: 13px;\n  line-height: 16px;\n  color: ", ";\n  margin-top: 2px;\n  color: #717b88;\n"])), BaSeTheme.typography.fontFamily, BaSeTheme.colors.feedbackInterface.erro35);
styled.div(templateObject_12$2 || (templateObject_12$2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding-left: 4px;\n  color: #45586a;\n"], ["\n  display: flex;\n  align-items: center;\n  padding-left: 4px;\n  color: #45586a;\n"])));
var ButtonInfoContainer = styled.div(templateObject_13$2 || (templateObject_13$2 = __makeTemplateObject(["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  margin-left: 5.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var MoreInfoContainer = styled.div(templateObject_14$2 || (templateObject_14$2 = __makeTemplateObject(["\n  padding-top: 4px;\n"], ["\n  padding-top: 4px;\n"])));
var WrapperHelper = styled.div(templateObject_15$1 || (templateObject_15$1 = __makeTemplateObject(["\n  padding-top: 2px;\n"], ["\n  padding-top: 2px;\n"])));
var templateObject_1$n, templateObject_2$j, templateObject_3$d, templateObject_4$a, templateObject_5$8, templateObject_6$7, templateObject_7$4, templateObject_8$4, templateObject_9$4, templateObject_10$3, templateObject_11$2, templateObject_12$2, templateObject_13$2, templateObject_14$2, templateObject_15$1;

var idSequence$1 = idGenerator();
var lineSeparatorRegEx = /\n/;
var wordSeparatorRegEx = /(!([^\s0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ][^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w])+|\s|[-–@.,][^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w])+/gim;
function clearValueToFilterWord(value) {
    if (value === void 0) { value = ''; }
    return value
        .trim()
        .replace(/^[^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w]+/gim, '')
        .replace(/[^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w]+$/gim, '');
}
function charCounter(value) {
    var _a;
    return (_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0;
}
function lineCounter(value) {
    return value.split(lineSeparatorRegEx).length;
}
function wordCounter(value) {
    var cleanValue = clearValueToFilterWord(value);
    if (!cleanValue) {
        return 0;
    }
    var splittedValue = cleanValue.split(wordSeparatorRegEx);
    var filteredVaue = splittedValue.filter(function (val) { return !!clearValueToFilterWord(val); });
    var length = filteredVaue.length;
    return length;
}
var BaSeTextArea = function (_a) {
    var _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, _c = _a.placeholder, placeholder = _c === void 0 ? '' : _c, _d = _a.label, label = _d === void 0 ? '' : _d, _e = _a.textSize, textSize = _e === void 0 ? 'medium' : _e, _f = _a.value, value = _f === void 0 ? '' : _f, _g = _a.onChange, onChange = _g === void 0 ? function () { } : _g, _h = _a.textError, textError = _h === void 0 ? '' : _h, _j = _a.name, name = _j === void 0 ? '' : _j, _k = _a.rows, rows = _k === void 0 ? 0 : _k, _l = _a.subLabel, subLabel = _l === void 0 ? '' : _l, _m = _a.helpButtonProps, helpButtonProps = _m === void 0 ? {} : _m, _o = _a.showHelpButton, showHelpButton = _o === void 0 ? false : _o, _p = _a.complement, complement = _p === void 0 ? '' : _p, _q = _a.moreInfoLabel, moreInfoLabel = _q === void 0 ? '' : _q, _r = _a.moreInfoDetails, moreInfoDetails = _r === void 0 ? '' : _r, _s = _a.inputStatus, inputStatus = _s === void 0 ? 'normal' : _s, _t = _a.hasCounter, hasCounter = _t === void 0 ? 'chars' : _t, maxLength = _a.maxLength, _u = _a.counterMinLength, counterMinLength = _u === void 0 ? 0 : _u, _v = _a.counterMaxLength, counterMaxLength = _v === void 0 ? 0 : _v;
    if (hasCounter === 'chars' && counterMaxLength > 0) {
        if (counterMaxLength > (maxLength !== null && maxLength !== void 0 ? maxLength : 0)) {
            throw Error('[BaSeTextArea] "maxLength" informado é menor do que o "counterMaxLength"');
        }
        maxLength !== null && maxLength !== void 0 ? maxLength : (maxLength = counterMaxLength);
    }
    var id = getNextHash(idSequence$1);
    var textAreaRef = React.useRef(null);
    var _w = React.useState(false), hasFocus = _w[0], setHasFocus = _w[1];
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var lengthChars = React.useMemo(function () { return charCounter(value); }, [value]);
    var lengthLines = React.useMemo(function () { return lineCounter(value); }, [value]);
    var lengthWords = React.useMemo(function () { return wordCounter(value); }, [value]);
    var getDescription = React.useCallback(function (length, singularWord, pluralWord) {
        return counterMinLength && counterMaxLength
            ? getMessage('textArea.counter.minMax', length <= counterMinLength ? length : counterMinLength, counterMinLength, length, counterMaxLength, counterMaxLength > 1 ? pluralWord : singularWord)
            : counterMinLength && length === 0
                ? getMessage('textArea.counter.initialMin', counterMinLength, counterMinLength > 1 ? pluralWord : singularWord)
                : counterMinLength && length < counterMinLength
                    ? getMessage(counterMinLength - length === 1
                        ? 'textArea.counter.minLastOne'
                        : 'textArea.counter.min', counterMinLength - length, counterMinLength - length > 1 ? pluralWord : singularWord)
                    : counterMinLength && length >= counterMinLength
                        ? getMessage('textArea.counter.doneMin', counterMinLength, counterMinLength > 1 ? pluralWord : singularWord)
                        : counterMaxLength && length === 0
                            ? getMessage('textArea.counter.initialMax', counterMaxLength, counterMaxLength > 1 ? pluralWord : singularWord)
                            : counterMaxLength && length < counterMaxLength
                                ? getMessage(counterMaxLength - length === 1
                                    ? 'textArea.counter.maxLastOne'
                                    : 'textArea.counter.max', counterMaxLength - length, counterMaxLength - length > 1 ? pluralWord : singularWord)
                                : counterMaxLength && length === counterMaxLength
                                    ? getMessage('textArea.counter.doneMax', counterMaxLength, counterMaxLength > 1 ? pluralWord : singularWord)
                                    : getMessage('textArea.counter.withoutMinMax', length, length > 1 ? pluralWord : singularWord);
    }, []);
    var cropWord = React.useCallback(function (newValue) {
        var _a;
        var separatorList = (_a = newValue.match(wordSeparatorRegEx)) !== null && _a !== void 0 ? _a : [];
        var cleanValue = clearValueToFilterWord(newValue);
        var splittedValue = cleanValue.split(wordSeparatorRegEx);
        var filteredVaue = splittedValue.filter(function (val) { return !!clearValueToFilterWord(val); });
        var valueListCropped = filteredVaue.splice(0, counterMaxLength);
        var valueToChange = valueListCropped.reduce(function (acc, item, index, list) {
            return acc + item + (index + 1 < list.length ? separatorList[index] : '');
        }, '');
        onChange(valueToChange);
    }, [counterMaxLength, onChange]);
    var cropLine = React.useCallback(function (newValue) {
        return onChange(newValue
            .split(lineSeparatorRegEx)
            .splice(0, counterMaxLength)
            .join('\n'));
    }, [counterMaxLength, onChange]);
    var cropText = React.useCallback(function (newValue) {
        if (hasCounter === 'chars') {
            return;
        }
        var length = hasCounter === 'words' ? wordCounter(newValue) : lineCounter(newValue);
        length <= counterMaxLength
            ? onChange(newValue)
            : hasCounter === 'words'
                ? cropWord(newValue)
                : cropLine(newValue);
    }, [value, hasCounter, counterMaxLength, onChange]);
    var counterDescriptionMap = React.useMemo(function () { return ({
        words: {
            description: getDescription(lengthWords, getMessage('textArea.counter.word'), getMessage('textArea.counter.words')),
        },
        chars: {
            description: getDescription(lengthChars, getMessage('textArea.counter.char'), getMessage('textArea.counter.chars')),
        },
        lines: {
            description: getDescription(lengthLines, getMessage('textArea.counter.line'), getMessage('textArea.counter.lines')),
        },
    }); }, [
        getDescription,
        getMessage,
        lengthWords,
        lengthChars,
        lengthLines,
        counterMaxLength,
    ]);
    var updateTextAreaValue = React.useCallback(function (event) {
        if (hasCounter !== 'chars') {
            return;
        }
        var val = event.target.value;
        if (!!counterMaxLength) {
            val = val.substring(0, counterMaxLength);
        }
        if (maxLength) {
            val = val.substring(0, maxLength);
        }
        onChange(val);
    }, [counterMaxLength, hasCounter, maxLength, onChange]);
    var handleErrorStatus = React.useCallback(function () { return inputStatus === 'invalid'; }, [inputStatus, counterMaxLength]);
    var giveFocus = React.useCallback(function () {
        var _a;
        (_a = textAreaRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [textAreaRef.current]);
    return (React.createElement(StyledTextAreaContainer, null,
        React.createElement(StyledTextAreaLabelContainer, null,
            React.createElement(StyledTextAreaLabel, { size: textSize, htmlFor: id }, label),
            React.createElement(StyledTextAreaSubLabel, { size: textSize, htmlFor: id }, subLabel),
            showHelpButton && (React.createElement(ButtonInfoContainer, null,
                React.createElement(BaSePopupButton, __assign({}, helpButtonProps))))),
        React.createElement(StyledOuterTextAreaBox, { disabled: isDisabled, hasFocus: hasFocus, onClick: function () { return giveFocus(); }, hasError: handleErrorStatus() },
            React.createElement(StyledTextArea, { id: id, maxLength: maxLength, disabled: isDisabled, hasError: handleErrorStatus(), rows: rows, name: name, ref: textAreaRef, value: value, onChange: updateTextAreaValue, onInput: function (event) {
                    return counterMaxLength
                        ? cropText(event.currentTarget.value)
                        : onChange(event.currentTarget.value);
                }, placeholder: placeholder, size: textSize, onFocus: function () { return setHasFocus(true); }, onBlur: function () { return setHasFocus(false); } })),
        React.createElement(StyledTextAreaFooter, { showMultiple: !!complement && !!counterMaxLength },
            inputStatus === 'invalid' ? (React.createElement(StyledTextAreaErrorText, null, textError)) : (!!complement && (React.createElement(WrapperHelper, null,
                React.createElement(BaSeHelperText, { color: BaSeTheme.colors.institucionais.cinzaSebrae45, isItalic: true, size: "medium", label: complement })))),
            React.createElement(StyledTextAreaFooterLimit, null, counterDescriptionMap[hasCounter].description)),
        !!moreInfoLabel && (React.createElement(MoreInfoContainer, null,
            React.createElement(BaSeHelperText, { size: "small", label: moreInfoLabel, details: moreInfoDetails })))));
};
BaSeTextArea.displayName = 'BaSeTextArea';

var mapTogglerTypeSpan = {
    outlined: {
        position: {
            top: '4.5%',
            left: '2px',
        },
        size: '22px',
        transform: 'translateX(32px);',
    },
    contained: {
        position: {
            top: '-7px',
            left: '-3px',
        },
        size: '26px',
        transform: ' translateX(35px);',
    },
};
var TogglerMapper = {
    outlined: {
        default: {
            unchecked: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.default.unchecked),
                foreground: ColorMapper.default.unchecked,
                shadowFocus: ColorMapper.default.focus.defaultLight,
                iconColor: ColorMapper.default.hover.defaultDark,
            },
            checked: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.default.foreground),
                foreground: ColorMapper.default.foreground,
                shadowFocus: ColorMapper.default.focus.defaultLight,
                iconColor: ColorMapper.default.hover.defaultDark,
            },
            disabled: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.disabled.foreground),
                foreground: ColorMapper.disabled.foreground,
                shadowFocus: 'none',
            },
        },
        confirmation: {
            unchecked: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.confirmation.unchecked),
                foreground: ColorMapper.confirmation.unchecked,
                shadowFocus: ColorMapper.confirmation.focus.defaultLight,
                iconColor: ColorMapper.confirmation.hover.defaultDark,
            },
            checked: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.confirmation.foreground),
                foreground: ColorMapper.confirmation.foreground,
                shadowFocus: ColorMapper.confirmation.focus.defaultLight,
                iconColor: ColorMapper.confirmation.hover.defaultDark,
            },
            disabled: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.disabled.foreground),
                foreground: ColorMapper.disabled.foreground,
                shadowFocus: 'none',
            },
        },
        destructive: {
            unchecked: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.destructive.unchecked),
                foreground: ColorMapper.destructive.unchecked,
                shadowFocus: ColorMapper.destructive.focus.defaultLight,
                iconColor: ColorMapper.destructive.hover.defaultDark,
            },
            checked: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.destructive.foreground),
                foreground: ColorMapper.destructive.foreground,
                shadowFocus: ColorMapper.destructive.focus.defaultLight,
                iconColor: ColorMapper.destructive.hover.defaultDark,
            },
            disabled: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.disabled.foreground),
                foreground: ColorMapper.disabled.foreground,
                shadowFocus: 'none',
            },
        },
        negative: {
            unchecked: {
                backgroundColor: BaSeTheme.colors.defaultColors.transparent,
                border: "2px solid ".concat(BaSeTheme.colors.defaultColors.white),
                foreground: BaSeTheme.colors.defaultColors.white,
                shadowFocus: ColorMapper.default.focus.defaultLight,
            },
            checked: {
                backgroundColor: BaSeTheme.colors.defaultColors.transparent,
                border: "2px solid ".concat(ColorMapper.default.hover.defaultLight),
                foreground: ColorMapper.default.hover.defaultLight,
                shadowFocus: ColorMapper.default.focus.defaultLight,
            },
            disabled: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.disabled.foreground),
                foreground: ColorMapper.disabled.foreground,
                shadowFocus: 'none',
            },
        },
    },
    contained: {
        default: {
            unchecked: {
                backgroundColor: ColorMapper.default.unchecked,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: ColorMapper.default.focus.defaultLight,
                hoverColor: ColorMapper.default.hover.defaultDark,
            },
            checked: {
                backgroundColor: ColorMapper.default.foreground,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: ColorMapper.default.focus.defaultLight,
                hoverColor: ColorMapper.default.hover.defaultDark,
            },
            disabled: {
                backgroundColor: ColorMapper.disabled.foreground,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: 'none',
            },
        },
        confirmation: {
            unchecked: {
                backgroundColor: ColorMapper.confirmation.unchecked,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: ColorMapper.confirmation.focus.defaultLight,
                hoverColor: ColorMapper.confirmation.hover.defaultDark,
            },
            checked: {
                backgroundColor: ColorMapper.confirmation.foreground,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: ColorMapper.confirmation.focus.defaultLight,
                hoverColor: ColorMapper.confirmation.hover.defaultDark,
            },
            disabled: {
                backgroundColor: ColorMapper.disabled.foreground,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: 'none',
            },
        },
        destructive: {
            unchecked: {
                backgroundColor: ColorMapper.destructive.unchecked,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: ColorMapper.destructive.focus.defaultLight,
                hoverColor: ColorMapper.destructive.hover.defaultDark,
            },
            checked: {
                backgroundColor: ColorMapper.destructive.foreground,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: ColorMapper.destructive.focus.defaultLight,
                hoverColor: ColorMapper.destructive.hover.defaultDark,
            },
            disabled: {
                backgroundColor: ColorMapper.disabled.foreground,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: 'none',
            },
        },
        negative: {
            unchecked: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: 'none',
                foreground: ColorMapper.default.foreground,
                spanBorder: ColorMapper.default.foreground,
                shadowFocus: ColorMapper.default.focus.defaultLight,
                hoverColor: ColorMapper.default.hover.defaultLight,
            },
            checked: {
                backgroundColor: ColorMapper.default.hover.defaultLight,
                border: 'none',
                foreground: ColorMapper.default.foreground,
                spanBorder: ColorMapper.default.foreground,
                shadowFocus: ColorMapper.default.focus.defaultLight,
                hoverColor: ColorMapper.default.hover.defaultLight,
            },
            disabled: {
                backgroundColor: ColorMapper.disabled.foreground,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: ColorMapper.default.foreground,
                shadowFocus: ColorMapper.default.focus.defaultLight,
            },
        },
    },
};
/*
light
main (checked) : {l: .36, s: 1 } => l, s
unchecked : {l: .6, s: .6} // s => s * .6, l => (1 - l) / (64 / 24)
hover: use createHoverColorDark
focus: use createFocusColorLight
*/
var makeUnchecked = function (color) {
    var _a = getHSLValues(color), s = _a.s, l = _a.l;
    s /= 100;
    l /= 100;
    return createColor(color, { s: s * .6, l: l + (1 - l) / (64 / 24) });
};
var createTogglerColor = function (color) {
    if (!Color.validateColor(color)) {
        return undefined;
    }
    return {
        outlined: {
            unchecked: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(makeUnchecked(color)),
                foreground: makeUnchecked(color),
                shadowFocus: ColorMapper.light.focus.create(color),
                iconColor: ColorMapper.dark.hover.create(color),
            },
            checked: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(color),
                foreground: color,
                shadowFocus: ColorMapper.light.focus.create(color),
                iconColor: ColorMapper.dark.hover.create(color),
            },
            disabled: {
                backgroundColor: BaSeTheme.colors.defaultColors.white,
                border: "2px solid ".concat(ColorMapper.disabled.foreground),
                foreground: ColorMapper.disabled.foreground,
                shadowFocus: 'none',
            },
        },
        contained: {
            unchecked: {
                backgroundColor: makeUnchecked(color),
                border: "none",
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: ColorMapper.light.focus.create(color),
                hoverColor: ColorMapper.dark.hover.create(color),
            },
            checked: {
                backgroundColor: color,
                border: "none",
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: ColorMapper.light.focus.create(color),
                hoverColor: ColorMapper.dark.hover.create(color),
            },
            disabled: {
                backgroundColor: ColorMapper.disabled.foreground,
                border: 'none',
                foreground: BaSeTheme.colors.defaultColors.white,
                spanBorder: BaSeTheme.colors.defaultColors.white,
                shadowFocus: 'none',
            },
        },
    };
};

// const memo = {};
// const handleColorTransform = (color: string) => {
//   if (color in memo) {
//     return memo[color];
//   }
//   memo[color] = ColorMapper.dark.hover.create(color);
//   return memo[color];
// };
var StyledTogglerLabel = styled.label(templateObject_2$i || (templateObject_2$i = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var _b, _c, _d, _e;
    var type = _a.type, isDisabled = _a.isDisabled, colors = _a.colors, hasFocus = _a.hasFocus;
    return css(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n    display: flex;\n    width: 58px;\n    height: ", ";\n    position: relative;\n    border-radius: 26px;\n    cursor: ", ";\n    background-color: ", ";\n    border: ", ";\n    ", "\n    &:hover {\n      ", "\n    }\n  "], ["\n    display: flex;\n    width: 58px;\n    height: ", ";\n    position: relative;\n    border-radius: 26px;\n    cursor: ", ";\n    background-color: ", ";\n    border: ", ";\n    ", "\n    &:hover {\n      ", "\n    }\n  "])), type === 'contained' ? '16px' : '24px', isDisabled ? 'not-allowed' : 'pointer', colors.backgroundColor, colors.border, hasFocus &&
        "\n      box-shadow: 0px 0px 0px 3px ".concat(colors === null || colors === void 0 ? void 0 : colors.shadowFocus, ";\n    "), !isDisabled &&
        "\n        ".concat(colors.border === 'none'
            ? "\n          background-color: ".concat((_b = colors === null || colors === void 0 ? void 0 : colors.iconColor) !== null && _b !== void 0 ? _b : colors === null || colors === void 0 ? void 0 : colors.hoverColor, ";\n          > span {\n            background-color: ").concat((_c = colors === null || colors === void 0 ? void 0 : colors.iconColor) !== null && _c !== void 0 ? _c : colors === null || colors === void 0 ? void 0 : colors.hoverColor, ";\n          }\n        ")
            : "\n          border: 2px solid  ".concat((_d = colors === null || colors === void 0 ? void 0 : colors.iconColor) !== null && _d !== void 0 ? _d : colors === null || colors === void 0 ? void 0 : colors.hoverColor, ";\n          > span {\n            background-color: ").concat((_e = colors === null || colors === void 0 ? void 0 : colors.iconColor) !== null && _e !== void 0 ? _e : colors === null || colors === void 0 ? void 0 : colors.hoverColor, ";\n          }\n        "), "\n      "));
});
var StyledTogglerInput = styled.input(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n  opacity: 0;\n  width: 0;\n  height: 0;\n"], ["\n  opacity: 0;\n  width: 0;\n  height: 0;\n"])));
var StyledTogglerSpan = styled.span(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var type = _a.type, value = _a.value, colors = _a.colors;
    return css(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n    position: absolute;\n    border-radius: 40px;\n    width: ", ";\n    height: ", ";\n    top: ", ";\n    left: ", ";\n    ", ";\n    background-color: ", ";\n    border ", "\n    transition: transform ", ";\n  "], ["\n    position: absolute;\n    border-radius: 40px;\n    width: ", ";\n    height: ", ";\n    top: ", ";\n    left: ", ";\n    ", ";\n    background-color: ", ";\n    border ", "\n    transition: transform ", ";\n  "])), mapTogglerTypeSpan[type].size, mapTogglerTypeSpan[type].size, mapTogglerTypeSpan[type].position.top, mapTogglerTypeSpan[type].position.left, value && 'transform:' + mapTogglerTypeSpan[type].transform, type === 'contained' ? colors.backgroundColor : colors.foreground, type === 'contained' ? "2px solid ".concat(colors.spanBorder, ";") : 'none;', BaSeTheme.transitions.durationNormal);
});
var StyledTogglerIconContainer = styled.div(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject(["\n  visibility: ", ";\n  position: absolute;\n  top: ", ";\n  left: 2px;\n  transition: ", ";\n"], ["\n  visibility: ", ";\n  position: absolute;\n  top: ", ";\n  left: 2px;\n  transition: ", ";\n"])), function (props) { return (props.value ? 'visible' : 'hidden'); }, function (props) { return (props.type === 'contained' ? '-2.2px' : '2px'); }, BaSeTheme.transitions.allPropertiesContinuousFast);
var templateObject_1$m, templateObject_2$i, templateObject_3$c, templateObject_4$9, templateObject_5$7, templateObject_6$6;

var TogglerColorOptions = [
    'default',
    'negative',
    'confirmation',
    'destructive',
];
var handleMappedType = function (type) {
    return type === 'outlined' || type === 'contained' ? type : 'outlined';
};
var handleMappedColor = function (color) {
    return !!TogglerColorOptions.find(function (c) { return c === color; })
        ? color
        : Color.validateColor(color)
            ? 'unmapped'
            : 'default';
};
var BaSeToggler = function (_a) {
    var _b, _c, _d;
    var _e = _a.type, type = _e === void 0 ? 'outlined' : _e, _f = _a.isDisabled, isDisabled = _f === void 0 ? false : _f, _g = _a.value, value = _g === void 0 ? false : _g, _h = _a.onChange, onChange = _h === void 0 ? function () { } : _h, color = _a.color;
    var _j = React.useState(false), hasFocus = _j[0], setHasFocus = _j[1];
    var styledMappedValues = React.useCallback(function () {
        var _a, _b;
        if (!color) {
            return TogglerMapper[handleMappedType(type)].default;
        }
        if (handleMappedColor(color) === 'unmapped') {
            return (_a = createTogglerColor(color)) === null || _a === void 0 ? void 0 : _a[handleMappedType(type)];
        }
        return (_b = TogglerMapper[handleMappedType(type)]) === null || _b === void 0 ? void 0 : _b[color];
    }, [color, type]);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var _k = (_b = styledMappedValues()) !== null && _b !== void 0 ? _b : TogglerMapper[handleMappedType(type)].default, unchecked = _k.unchecked, checked = _k.checked, disabledState = _k.disabled;
    var getStyles = React.useCallback(function () {
        if (isDisabled) {
            return disabledState;
        }
        return value ? checked : unchecked;
    }, [isDisabled, value, unchecked, checked, disabledState]);
    // const getStyles() = getStyles();
    var _l = React.useState(false), hasHover = _l[0], setHasHover = _l[1];
    return (React.createElement(StyledTogglerLabel, { className: "BaSe--toggler", value: value, isDisabled: isDisabled, type: handleMappedType(type), colors: getStyles(), hasFocus: hasFocus, onMouseEnter: function () { return setHasHover(true); }, onMouseLeave: function () { return setHasHover(false); } },
        React.createElement(StyledTogglerInput, { "aria-checked": value, role: "checkbox", checked: value, onChange: onChange, type: "checkbox", disabled: isDisabled, onFocus: function () { return setHasFocus(true); }, onBlur: function () { return setHasFocus(false); } }),
        React.createElement(StyledTogglerSpan, { type: handleMappedType(type), isDisabled: isDisabled, value: value, colors: getStyles() }),
        React.createElement(StyledTogglerIconContainer, { value: value, type: handleMappedType(type) },
            React.createElement(BaSeIcon, { color: type === 'contained'
                    ? color === 'negative'
                        ? BaSeTheme.colors.institucionais.azulSebrae36
                        : BaSeTheme.colors.defaultColors.white
                    : hasHover
                        ? (_c = getStyles()) === null || _c === void 0 ? void 0 : _c.iconColor
                        : (_d = getStyles()) === null || _d === void 0 ? void 0 : _d.foreground, description: getMessage('toggler.iconDescription'), name: "check", size: 20 }))));
};
BaSeToggler.displayName = 'BaSeToggler';

var WrapperList = styled.ul.attrs({
    className: 'BaSe--list',
})(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: ", ";\n  gap: ", ";\n  max-height: ", ";\n  overflow: auto;\n  padding: 22px 0;\n"], ["\n  display: grid;\n  grid-template-columns: ", ";\n  gap: ", ";\n  max-height: ", ";\n  overflow: auto;\n  padding: 22px 0;\n"])), function (_a) {
    var columnNum = _a.columnNum;
    return "repeat(".concat(columnNum, ", 1fr)");
}, function (_a) {
    var gap = _a.gap;
    return numberWithUnit(gap);
}, function (_a) {
    var maxHeight = _a.maxHeight;
    return numberWithUnit(maxHeight);
});
var Wrapperbtn = styled.div(templateObject_2$h || (templateObject_2$h = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var WrapperItem = styled.li.attrs({
    className: 'BaSe--list-item',
})(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  align-items: center;\n  justify-content: ", ";\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  align-items: center;\n  justify-content: ", ";\n"])), function (_a) {
    var direction = _a.direction;
    return direction;
}, function (_a) {
    var direction = _a.direction;
    return direction === 'row-reverse' ? 'space-between' : 'none';
});
var templateObject_1$l, templateObject_2$h, templateObject_3$b;

// import { string } from 'prop-types';
var BaSeList = function (_a) {
    var _b = _a.direction, direction = _b === void 0 ? 'column' : _b, _c = _a.maxHeight, maxHeight = _c === void 0 ? '' : _c, _d = _a.gap, gap = _d === void 0 ? '10px' : _d, _e = _a.valuesList, valuesList = _e === void 0 ? [] : _e, _f = _a.columnNum, columnNum = _f === void 0 ? 1 : _f, _g = _a.listActions, listActions = _g === void 0 ? [
        {
            size: 'medium',
            sizeIcon: 'medium',
            ActionisDisabled: false,
            nameIcon: 'trash-alt',
            color: BaSeTheme.colors.institucionais.azulSebrae36,
            listAction: function () { },
        },
    ] : _g;
    return (React.createElement(WrapperList, { columnNum: columnNum, gap: gap, maxHeight: maxHeight }, valuesList.map(function (item) {
        return (React.createElement(WrapperItem, { key: item.id, direction: direction },
            React.createElement(Wrapperbtn, null, listActions.map(function (action, index) { return (React.createElement(React.Fragment, { key: index },
                React.createElement(BaSeShapeButton, { onClick: function () { return action.listAction(item); }, type: "tertiary", nameIcon: action.nameIcon, size: action.size, sizeIcon: action.sizeIcon, buttonType: "button", isDisabled: action.ActionisDisabled, color: action.color }))); })),
            item.label));
    })));
};
BaSeList.displayName = 'BaSeList';

var ContainerInputList = styled.div.attrs({
    className: 'BaSe--input-list-container',
})(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: ", ";\n"])), function (_a) {
    var width = _a.width;
    return numberWithUnit(width);
});
var WrapperInputList = styled.div(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isFlex = _a.isFlex;
    return css(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n    display: ", ";\n    flex-direction: row;\n    position: relative;\n    align-items: stretch;\n  "], ["\n    display: ", ";\n    flex-direction: row;\n    position: relative;\n    align-items: stretch;\n  "])), isFlex ? 'flex' : 'block');
});
var templateObject_1$k, templateObject_2$g, templateObject_3$a;

var BaSeInputList = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '100%' : _b, _c = _a.listItems, listItems = _c === void 0 ? {
        valuesList: [],
        direction: 'column',
        listActions: [
            {
                size: 'medium',
                sizeIcon: 'medium',
                ActionisDisabled: false,
                nameIcon: 'trash-alt',
                color: BaSeTheme.colors.institucionais.azulSebrae36,
                listAction: function () { },
            },
        ],
    } : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.nameButton, nameButton = _e === void 0 ? 'plus' : _e, _f = _a.valueButton, valueButton = _f === void 0 ? 'Adicionar' : _f, _g = _a.sizeInput, sizeInput = _g === void 0 ? 'medium' : _g, _h = _a.typeButton, typeButton = _h === void 0 ? 'base-button' : _h, _j = _a.placeholder, placeholder = _j === void 0 ? '' : _j, _k = _a.value, value = _k === void 0 ? '' : _k, _l = _a.label, label = _l === void 0 ? '' : _l, _m = _a.subLabel, subLabel = _m === void 0 ? '' : _m, _o = _a.expandToMaxWidth, expandToMaxWidth = _o === void 0 ? false : _o, _p = _a.buttonAction, buttonAction = _p === void 0 ? function () { } : _p;
    var _q = React.useState(value), newValue = _q[0], setNewValue = _q[1];
    var inputAction = function () {
        buttonAction(newValue);
        setNewValue('');
    };
    return (React.createElement(ContainerInputList, { width: width },
        React.createElement(WrapperInputList, { isFlex: !expandToMaxWidth },
            React.createElement(BaSeInput, { value: newValue, onChange: function (changeValue) { return setNewValue(changeValue); }, onFocus: function () { }, onBlur: function () { }, label: label, size: sizeInput, subLabel: subLabel, typeInput: "text", inputMode: "text", complement: "", width: "100%", showHelpButton: false, isDisabled: isDisabled, isReadOnly: false, placeholder: placeholder, iconButton: {
                    typeButton: typeButton,
                    name: nameButton,
                    action: inputAction,
                    type: 'primary',
                    value: valueButton,
                    color: BaSeTheme.colors.institucionais.azulSebrae36,
                } })),
        React.createElement(BaSeList, __assign({}, listItems))));
};
BaSeInputList.displayName = 'BaSeInputList';

var ContainerSelectList = styled.div.attrs({
    className: 'BaSe--select-list-container',
})(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: ", ";\n"])), function (_a) {
    var width = _a.width;
    return numberWithUnit(width);
});
var WrapperSelectList = styled.div.attrs({
    className: 'BaSe--select-list',
})(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  align-items: flex-end;\n  gap: ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  align-items: flex-end;\n  gap: ", ";\n"])), function (_a) {
    var gap = _a.gap;
    return numberWithUnit(gap);
});
var templateObject_1$j, templateObject_2$f;

var BaSeSelectList = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '100%' : _b, _c = _a.gapButton, gapButton = _c === void 0 ? '8px' : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.listItems, listItems = _e === void 0 ? {
        valuesList: [],
        direction: 'column',
        listActions: [
            {
                size: 'medium',
                sizeIcon: 'medium',
                ActionisDisabled: false,
                nameIcon: 'trash-alt',
                color: BaSeTheme.colors.institucionais.azulSebrae36,
                listAction: function () { },
            },
        ],
    } : _e, valueButton = _a.valueButton, _f = _a.label, label = _f === void 0 ? '' : _f, _g = _a.subLabel, subLabel = _g === void 0 ? '' : _g, _h = _a.values, values = _h === void 0 ? [] : _h, _j = _a.sizeInput, sizeInput = _j === void 0 ? 'medium' : _j, _k = _a.nameButton, nameButton = _k === void 0 ? 'plus' : _k, _l = _a.selectIdValue, selectIdValue = _l === void 0 ? 0 : _l, _m = _a.buttonAction, buttonAction = _m === void 0 ? function () { } : _m;
    var _o = React.useState(selectIdValue), newValue = _o[0], setNewValue = _o[1];
    var inputAction = function () {
        buttonAction(newValue.label);
    };
    return (React.createElement(ContainerSelectList, { width: width },
        React.createElement(WrapperSelectList, { gap: gapButton },
            React.createElement(BaSeSelect, { isDisabled: isDisabled, label: label, subLabel: subLabel, values: values, size: sizeInput, width: "100%", selectedValueId: selectIdValue, onChange: function (value) { return setNewValue(value); } }),
            valueButton ? (React.createElement(BaSeButton, { color: BaSeTheme.colors.institucionais.azulSebrae36, onClick: inputAction, isDisabled: isDisabled, size: sizeInput, value: valueButton, leftIcon: nameButton })) : (React.createElement(BaSeShapeButton, { color: BaSeTheme.colors.institucionais.azulSebrae36, nameIcon: nameButton, isDisabled: isDisabled, shape: "square", size: sizeInput, onClick: inputAction }))),
        React.createElement(BaSeList, __assign({}, listItems))));
};
BaSeSelectList.displayName = 'BaSeSelectList';

var CrooperContainer = styled.div.attrs({
    className: 'BaSe--cropper',
})(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  /* style react crop */\n\n  .ReactCrop {\n    position: relative;\n    display: inline-block;\n    cursor: crosshair;\n    overflow: hidden;\n    max-width: 100%;\n  }\n  .ReactCrop:focus {\n    outline: none;\n  }\n  .ReactCrop--disabled,\n  .ReactCrop--locked {\n    cursor: inherit;\n  }\n  .ReactCrop__image {\n    display: block;\n    max-width: 100%;\n    touch-action: none;\n  }\n  .ReactCrop__crop-selection {\n    position: absolute;\n    top: 0;\n    left: 0;\n    transform: translate3d(0, 0, 0);\n    box-sizing: border-box;\n    cursor: move;\n    box-shadow: 0 0 0 9999em rgba(0, 0, 0, 0.5);\n    touch-action: none;\n    border: 1px solid;\n    border-image-source: url('data:image/gif;base64,R0lGODlhCgAKAJECAAAAAP///////wAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OEI5RDc5MTFDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OEI5RDc5MTBDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEBQoAAgAsAAAAAAoACgAAAhWEERkn7W3ei7KlagMWF/dKgYeyGAUAIfkEBQoAAgAsAAAAAAoACgAAAg+UYwLJ7RnQm7QmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYgLJHdiinNSAVfOEKoUCACH5BAUKAAIALAAAAAAKAAoAAAIRVISAdusPo3RAzYtjaMIaUQAAIfkEBQoAAgAsAAAAAAoACgAAAg+MDiem7Q8bSLFaG5il6xQAIfkEBQoAAgAsAAAAAAoACgAAAg+UYRLJ7QnQm7SmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYBLJDdiinNSEVfOEKoECACH5BAUKAAIALAAAAAAKAAoAAAIRFISBdusPo3RBzYsjaMIaUQAAOw==');\n    border-image-slice: 1;\n    border-image-repeat: repeat;\n  }\n  .ReactCrop--disabled .ReactCrop__crop-selection {\n    cursor: inherit;\n  }\n  .ReactCrop--circular-crop .ReactCrop__crop-selection {\n    border-radius: 50%;\n    box-shadow: 0px 0px 1px 1px white, 0 0 0 9999em rgba(0, 0, 0, 0.5);\n  }\n  .ReactCrop--invisible-crop .ReactCrop__crop-selection {\n    display: none;\n  }\n  .ReactCrop__rule-of-thirds-vt::before,\n  .ReactCrop__rule-of-thirds-vt::after,\n  .ReactCrop__rule-of-thirds-hz::before,\n  .ReactCrop__rule-of-thirds-hz::after {\n    content: '';\n    display: block;\n    position: absolute;\n    background-color: rgba(255, 255, 255, 0.4);\n  }\n  .ReactCrop__rule-of-thirds-vt::before,\n  .ReactCrop__rule-of-thirds-vt::after {\n    width: 1px;\n    height: 100%;\n  }\n  .ReactCrop__rule-of-thirds-vt::before {\n    left: 33.3333%;\n    left: calc(100% / 3);\n  }\n  .ReactCrop__rule-of-thirds-vt::after {\n    left: 66.6666%;\n    left: calc(100% / 3 * 2);\n  }\n  .ReactCrop__rule-of-thirds-hz::before,\n  .ReactCrop__rule-of-thirds-hz::after {\n    width: 100%;\n    height: 1px;\n  }\n  .ReactCrop__rule-of-thirds-hz::before {\n    top: 33.3333%;\n    top: calc(100% / 3);\n  }\n  .ReactCrop__rule-of-thirds-hz::after {\n    top: 66.6666%;\n    top: calc(100% / 3 * 2);\n  }\n  .ReactCrop__drag-handle {\n    position: absolute;\n  }\n  .ReactCrop__drag-handle::after {\n    position: absolute;\n    content: '';\n    display: block;\n    width: 10px;\n    height: 10px;\n    background-color: rgba(0, 0, 0, 0.2);\n    border: 1px solid rgba(255, 255, 255, 0.7);\n    box-sizing: border-box;\n    outline: 1px solid transparent;\n  }\n  .ReactCrop .ord-nw {\n    top: 0;\n    left: 0;\n    margin-top: -5px;\n    margin-left: -5px;\n    cursor: nw-resize;\n  }\n  .ReactCrop .ord-nw::after {\n    top: 0;\n    left: 0;\n  }\n  .ReactCrop .ord-n {\n    top: 0;\n    left: 50%;\n    margin-top: -5px;\n    margin-left: -5px;\n    cursor: n-resize;\n  }\n  .ReactCrop .ord-n::after {\n    top: 0;\n  }\n  .ReactCrop .ord-ne {\n    top: 0;\n    right: 0;\n    margin-top: -5px;\n    margin-right: -5px;\n    cursor: ne-resize;\n  }\n  .ReactCrop .ord-ne::after {\n    top: 0;\n    right: 0;\n  }\n  .ReactCrop .ord-e {\n    top: 50%;\n    right: 0;\n    margin-top: -5px;\n    margin-right: -5px;\n    cursor: e-resize;\n  }\n  .ReactCrop .ord-e::after {\n    right: 0;\n  }\n  .ReactCrop .ord-se {\n    bottom: 0;\n    right: 0;\n    margin-bottom: -5px;\n    margin-right: -5px;\n    cursor: se-resize;\n  }\n  .ReactCrop .ord-se::after {\n    bottom: 0;\n    right: 0;\n  }\n  .ReactCrop .ord-s {\n    bottom: 0;\n    left: 50%;\n    margin-bottom: -5px;\n    margin-left: -5px;\n    cursor: s-resize;\n  }\n  .ReactCrop .ord-s::after {\n    bottom: 0;\n  }\n  .ReactCrop .ord-sw {\n    bottom: 0;\n    left: 0;\n    margin-bottom: -5px;\n    margin-left: -5px;\n    cursor: sw-resize;\n  }\n  .ReactCrop .ord-sw::after {\n    bottom: 0;\n    left: 0;\n  }\n  .ReactCrop .ord-w {\n    top: 50%;\n    left: 0;\n    margin-top: -5px;\n    margin-left: -5px;\n    cursor: w-resize;\n  }\n  .ReactCrop .ord-w::after {\n    left: 0;\n  }\n  .ReactCrop__disabled .ReactCrop__drag-handle {\n    cursor: inherit;\n  }\n  .ReactCrop__drag-bar {\n    position: absolute;\n  }\n  .ReactCrop__drag-bar.ord-n {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 6px;\n    margin-top: -3px;\n  }\n  .ReactCrop__drag-bar.ord-e {\n    right: 0;\n    top: 0;\n    width: 6px;\n    height: 100%;\n    margin-right: -3px;\n  }\n  .ReactCrop__drag-bar.ord-s {\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 6px;\n    margin-bottom: -3px;\n  }\n  .ReactCrop__drag-bar.ord-w {\n    top: 0;\n    left: 0;\n    width: 6px;\n    height: 100%;\n    margin-left: -3px;\n  }\n  .ReactCrop--new-crop .ReactCrop__drag-bar,\n  .ReactCrop--new-crop .ReactCrop__drag-handle,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-bar {\n    display: none;\n  }\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-n,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-e,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-s,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-w {\n    display: none;\n  }\n  @media (pointer: coarse) {\n    .ReactCrop .ord-n,\n    .ReactCrop .ord-e,\n    .ReactCrop .ord-s,\n    .ReactCrop .ord-w {\n      display: none;\n    }\n    .ReactCrop__drag-handle {\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n  /*# sourceMappingURL=ReactCrop.css.map */\n  /* style react crop */\n\n  /* customiza\u00E7\u00E3o pr\u00F3pria  */\n  position: relative;\n  display: flex;\n  flex-flow: column;\n  .ReactCrop {\n    max-height: calc(100vh - 200px);\n    margin: 0 auto;\n    ", "\n  }\n\n  img {\n    max-height: calc(100vh - 200px);\n  }\n  /* customiza\u00E7\u00E3o pr\u00F3pria  */\n"], ["\n  /* style react crop */\n\n  .ReactCrop {\n    position: relative;\n    display: inline-block;\n    cursor: crosshair;\n    overflow: hidden;\n    max-width: 100%;\n  }\n  .ReactCrop:focus {\n    outline: none;\n  }\n  .ReactCrop--disabled,\n  .ReactCrop--locked {\n    cursor: inherit;\n  }\n  .ReactCrop__image {\n    display: block;\n    max-width: 100%;\n    touch-action: none;\n  }\n  .ReactCrop__crop-selection {\n    position: absolute;\n    top: 0;\n    left: 0;\n    transform: translate3d(0, 0, 0);\n    box-sizing: border-box;\n    cursor: move;\n    box-shadow: 0 0 0 9999em rgba(0, 0, 0, 0.5);\n    touch-action: none;\n    border: 1px solid;\n    border-image-source: url('data:image/gif;base64,R0lGODlhCgAKAJECAAAAAP///////wAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OEI5RDc5MTFDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OEI5RDc5MTBDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEBQoAAgAsAAAAAAoACgAAAhWEERkn7W3ei7KlagMWF/dKgYeyGAUAIfkEBQoAAgAsAAAAAAoACgAAAg+UYwLJ7RnQm7QmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYgLJHdiinNSAVfOEKoUCACH5BAUKAAIALAAAAAAKAAoAAAIRVISAdusPo3RAzYtjaMIaUQAAIfkEBQoAAgAsAAAAAAoACgAAAg+MDiem7Q8bSLFaG5il6xQAIfkEBQoAAgAsAAAAAAoACgAAAg+UYRLJ7QnQm7SmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYBLJDdiinNSEVfOEKoECACH5BAUKAAIALAAAAAAKAAoAAAIRFISBdusPo3RBzYsjaMIaUQAAOw==');\n    border-image-slice: 1;\n    border-image-repeat: repeat;\n  }\n  .ReactCrop--disabled .ReactCrop__crop-selection {\n    cursor: inherit;\n  }\n  .ReactCrop--circular-crop .ReactCrop__crop-selection {\n    border-radius: 50%;\n    box-shadow: 0px 0px 1px 1px white, 0 0 0 9999em rgba(0, 0, 0, 0.5);\n  }\n  .ReactCrop--invisible-crop .ReactCrop__crop-selection {\n    display: none;\n  }\n  .ReactCrop__rule-of-thirds-vt::before,\n  .ReactCrop__rule-of-thirds-vt::after,\n  .ReactCrop__rule-of-thirds-hz::before,\n  .ReactCrop__rule-of-thirds-hz::after {\n    content: '';\n    display: block;\n    position: absolute;\n    background-color: rgba(255, 255, 255, 0.4);\n  }\n  .ReactCrop__rule-of-thirds-vt::before,\n  .ReactCrop__rule-of-thirds-vt::after {\n    width: 1px;\n    height: 100%;\n  }\n  .ReactCrop__rule-of-thirds-vt::before {\n    left: 33.3333%;\n    left: calc(100% / 3);\n  }\n  .ReactCrop__rule-of-thirds-vt::after {\n    left: 66.6666%;\n    left: calc(100% / 3 * 2);\n  }\n  .ReactCrop__rule-of-thirds-hz::before,\n  .ReactCrop__rule-of-thirds-hz::after {\n    width: 100%;\n    height: 1px;\n  }\n  .ReactCrop__rule-of-thirds-hz::before {\n    top: 33.3333%;\n    top: calc(100% / 3);\n  }\n  .ReactCrop__rule-of-thirds-hz::after {\n    top: 66.6666%;\n    top: calc(100% / 3 * 2);\n  }\n  .ReactCrop__drag-handle {\n    position: absolute;\n  }\n  .ReactCrop__drag-handle::after {\n    position: absolute;\n    content: '';\n    display: block;\n    width: 10px;\n    height: 10px;\n    background-color: rgba(0, 0, 0, 0.2);\n    border: 1px solid rgba(255, 255, 255, 0.7);\n    box-sizing: border-box;\n    outline: 1px solid transparent;\n  }\n  .ReactCrop .ord-nw {\n    top: 0;\n    left: 0;\n    margin-top: -5px;\n    margin-left: -5px;\n    cursor: nw-resize;\n  }\n  .ReactCrop .ord-nw::after {\n    top: 0;\n    left: 0;\n  }\n  .ReactCrop .ord-n {\n    top: 0;\n    left: 50%;\n    margin-top: -5px;\n    margin-left: -5px;\n    cursor: n-resize;\n  }\n  .ReactCrop .ord-n::after {\n    top: 0;\n  }\n  .ReactCrop .ord-ne {\n    top: 0;\n    right: 0;\n    margin-top: -5px;\n    margin-right: -5px;\n    cursor: ne-resize;\n  }\n  .ReactCrop .ord-ne::after {\n    top: 0;\n    right: 0;\n  }\n  .ReactCrop .ord-e {\n    top: 50%;\n    right: 0;\n    margin-top: -5px;\n    margin-right: -5px;\n    cursor: e-resize;\n  }\n  .ReactCrop .ord-e::after {\n    right: 0;\n  }\n  .ReactCrop .ord-se {\n    bottom: 0;\n    right: 0;\n    margin-bottom: -5px;\n    margin-right: -5px;\n    cursor: se-resize;\n  }\n  .ReactCrop .ord-se::after {\n    bottom: 0;\n    right: 0;\n  }\n  .ReactCrop .ord-s {\n    bottom: 0;\n    left: 50%;\n    margin-bottom: -5px;\n    margin-left: -5px;\n    cursor: s-resize;\n  }\n  .ReactCrop .ord-s::after {\n    bottom: 0;\n  }\n  .ReactCrop .ord-sw {\n    bottom: 0;\n    left: 0;\n    margin-bottom: -5px;\n    margin-left: -5px;\n    cursor: sw-resize;\n  }\n  .ReactCrop .ord-sw::after {\n    bottom: 0;\n    left: 0;\n  }\n  .ReactCrop .ord-w {\n    top: 50%;\n    left: 0;\n    margin-top: -5px;\n    margin-left: -5px;\n    cursor: w-resize;\n  }\n  .ReactCrop .ord-w::after {\n    left: 0;\n  }\n  .ReactCrop__disabled .ReactCrop__drag-handle {\n    cursor: inherit;\n  }\n  .ReactCrop__drag-bar {\n    position: absolute;\n  }\n  .ReactCrop__drag-bar.ord-n {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 6px;\n    margin-top: -3px;\n  }\n  .ReactCrop__drag-bar.ord-e {\n    right: 0;\n    top: 0;\n    width: 6px;\n    height: 100%;\n    margin-right: -3px;\n  }\n  .ReactCrop__drag-bar.ord-s {\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 6px;\n    margin-bottom: -3px;\n  }\n  .ReactCrop__drag-bar.ord-w {\n    top: 0;\n    left: 0;\n    width: 6px;\n    height: 100%;\n    margin-left: -3px;\n  }\n  .ReactCrop--new-crop .ReactCrop__drag-bar,\n  .ReactCrop--new-crop .ReactCrop__drag-handle,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-bar {\n    display: none;\n  }\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-n,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-e,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-s,\n  .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-w {\n    display: none;\n  }\n  @media (pointer: coarse) {\n    .ReactCrop .ord-n,\n    .ReactCrop .ord-e,\n    .ReactCrop .ord-s,\n    .ReactCrop .ord-w {\n      display: none;\n    }\n    .ReactCrop__drag-handle {\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n  /*# sourceMappingURL=ReactCrop.css.map */\n  /* style react crop */\n\n  /* customiza\u00E7\u00E3o pr\u00F3pria  */\n  position: relative;\n  display: flex;\n  flex-flow: column;\n  .ReactCrop {\n    max-height: calc(100vh - 200px);\n    margin: 0 auto;\n    ", "\n  }\n\n  img {\n    max-height: calc(100vh - 200px);\n  }\n  /* customiza\u00E7\u00E3o pr\u00F3pria  */\n"])), function (props) { return (props === null || props === void 0 ? void 0 : props.width) && "width:".concat(props === null || props === void 0 ? void 0 : props.width, "px;"); });
var CrooperActionsButton = styled.div(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0;\n"])));
var templateObject_1$i, templateObject_2$e;

var handleFirstImageCrop = function (aspectRatio, imageAux) {
    if (!aspectRatio || !imageAux) {
        return;
    }
    if (aspectRatio > 1) {
        return {
            width: imageAux.width,
            height: Math.round(imageAux.width / aspectRatio),
        };
    }
    return {
        height: imageAux.height,
        width: Math.round(imageAux.height * aspectRatio),
    };
};
var cropDefaultParams = {
    aspect: 16 / 9,
    unit: '%',
    x: 0,
    y: 0,
    width: 100,
};
var SVGToPngType = function (type) {
    if (!type) {
        return 'image/jpg';
    }
    if (type.includes('svg')) {
        return 'image/png';
    }
    return type;
};
var makeBlobFromCanvas = function (canvas, originalImgTag, getName) {
    return new Promise(function (resolve, reject) {
        try {
            canvas.toBlob(function (blob) {
                var _a;
                if (!blob) {
                    reject('canvas is empty');
                    return;
                }
                var image = new File([blob], (_a = originalImgTag === null || originalImgTag === void 0 ? void 0 : originalImgTag.name) !== null && _a !== void 0 ? _a : getName('cropper.file.default.name', Date === null || Date === void 0 ? void 0 : Date.now()), {
                    type: SVGToPngType(originalImgTag === null || originalImgTag === void 0 ? void 0 : originalImgTag.type),
                });
                resolve(image);
            }, SVGToPngType(originalImgTag === null || originalImgTag === void 0 ? void 0 : originalImgTag.type));
        }
        catch (e) {
            reject(e);
        }
    });
};
var BaSeCropper = function (_a) {
    var _b;
    var file = _a.file, cropInitalValues = _a.cropInitalValues, saveCallback = _a.saveCallback, cancelCallback = _a.cancelCallback, onCropError = _a.onCropError;
    var _c = React.useState(__assign(__assign({}, cropDefaultParams), cropInitalValues)), crop = _c[0], setCrop = _c[1];
    var _d = React.useState(''), image = _d[0], setImage = _d[1];
    var _e = React.useState(), refImage = _e[0], setRefImage = _e[1];
    var _f = React.useState(), completedCrop = _f[0], setCompletedCrop = _f[1];
    var _g = React.useState(''), imageUrl = _g[0], setImageUrl = _g[1];
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var handleUpload = function (part) { return __awaiter(void 0, void 0, void 0, function () {
        var imageTag, canvas, scaleX, scaleY, ctx, pixelRatio, canvasSize;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!part) {
                        onCropError === null || onCropError === void 0 ? void 0 : onCropError(getMessage('cropper.error.upload'));
                        return [2 /*return*/];
                    }
                    setImage(part);
                    imageTag = part;
                    canvas = document.createElement('canvas');
                    scaleX = imageTag.naturalWidth / imageTag.width;
                    scaleY = imageTag.naturalHeight / imageTag.height;
                    ctx = canvas.getContext('2d');
                    pixelRatio = window.devicePixelRatio;
                    canvasSize = handleFirstImageCrop(crop === null || crop === void 0 ? void 0 : crop.aspect, imageTag);
                    if (!canvasSize) {
                        onCropError === null || onCropError === void 0 ? void 0 : onCropError(getMessage('cropper.error.upload'));
                        return [2 /*return*/];
                    }
                    canvas.width = canvasSize.width * pixelRatio;
                    canvas.height = canvasSize.height * pixelRatio;
                    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
                    ctx.imageSmoothingQuality = 'high';
                    ctx.drawImage(imageTag, 0, 0, canvasSize.width * scaleX, canvasSize.height * scaleY, 0, 0, canvasSize.width, canvasSize.height);
                    return [4 /*yield*/, makeBlobFromCanvas(canvas, file, getMessage)
                            .then(function (recreatedImage) { return setRefImage(recreatedImage); })
                            .catch(function (error) { return onCropError === null || onCropError === void 0 ? void 0 : onCropError(getMessage('cropper.error.crop'), error); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSave = function (imageToSave) { return __awaiter(void 0, void 0, void 0, function () {
        var canvas, scaleX, scaleY, ctx, pixelRatio;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!completedCrop || !file || !imageToSave || !refImage) {
                        return [2 /*return*/];
                    }
                    canvas = document.createElement('canvas');
                    scaleX = imageToSave.naturalWidth / imageToSave.width;
                    scaleY = imageToSave.naturalHeight / imageToSave.height;
                    ctx = canvas.getContext('2d');
                    pixelRatio = window.devicePixelRatio;
                    canvas.width = completedCrop.width * pixelRatio;
                    canvas.height = completedCrop.height * pixelRatio;
                    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
                    ctx.imageSmoothingQuality = 'high';
                    ctx.drawImage(imageToSave, completedCrop.x * scaleX, completedCrop.y * scaleY, completedCrop.width * scaleX, completedCrop.height * scaleY, 0, 0, completedCrop.width, completedCrop.height);
                    return [4 /*yield*/, makeBlobFromCanvas(canvas, file, getMessage)
                            .then(function (recreatedImage) { return saveCallback(recreatedImage); })
                            .catch(function (error) { return onCropError === null || onCropError === void 0 ? void 0 : onCropError(getMessage('cropper.error.crop'), error); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        if (file) {
            var urls = URL.createObjectURL(file);
            setImageUrl(urls);
        }
        return function () {
            URL.revokeObjectURL(imageUrl);
        };
    }, [file]);
    return (React.createElement(CrooperContainer, { width: (_b = image) === null || _b === void 0 ? void 0 : _b.width }, file && imageUrl && (React.createElement(React.Fragment, null,
        React.createElement(Cropper, { src: imageUrl, crop: crop, onChange: setCrop, onImageLoaded: handleUpload, onComplete: setCompletedCrop }),
        React.createElement(CrooperActionsButton, null,
            React.createElement(BaSeButton, { value: getMessage('cropper.button.save'), onClick: function () { return handleSave(image); } }),
            React.createElement(BaSeButton, { value: getMessage('cropper.button.cancel'), onClick: function () { return cancelCallback(); } }))))));
};
BaSeCropper.displayName = 'BaSeCropper';

var institucionais = BaSeTheme.colors.institucionais;
var defaults = BaSeTheme.colors.defaultColors;
var ImagePickerWrapper = styled.div.attrs({
    className: 'BaSe--image-picker',
})(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isDrag = _a.isDrag;
    return css(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n    display: grid;\n    border: 2px dashed ", ";\n    background-color: ", ";\n    place-items: center;\n    border-radius: 4px;\n    padding: 16px;\n    gap: 8px;\n    width: calc(100% - 32px);\n    height: calc(100% - 32px);\n  "], ["\n    display: grid;\n    border: 2px dashed ", ";\n    background-color: ", ";\n    place-items: center;\n    border-radius: 4px;\n    padding: 16px;\n    gap: 8px;\n    width: calc(100% - 32px);\n    height: calc(100% - 32px);\n  "])), institucionais.cinzaSebrae90, isDrag ? institucionais.azulSebrae90 : defaults.white);
});
var SelectedImage = styled.img.attrs({
    className: 'BaSe--image-picker-selected-image',
    loading: 'lazy',
    decoding: 'async',
})(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var hasRadius = _a.hasRadius;
    return css(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n    height: 75px;\n    width: 75px;\n    min-height: 75px;\n    min-width: 75px;\n    max-height: 75px;\n    max-width: 75px;\n    border-radius: ", ";\n    object-fit: cover;\n  "], ["\n    height: 75px;\n    width: 75px;\n    min-height: 75px;\n    min-width: 75px;\n    max-height: 75px;\n    max-width: 75px;\n    border-radius: ", ";\n    object-fit: cover;\n  "])), hasRadius ? '50%' : '0');
});
var HiddenInputFile = styled.input.attrs({
    className: 'BaSe--image-picker-input-file',
    type: 'file',
    accept: 'image/*',
    multiple: false,
})(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));
var ActionButtonWrapper = styled.div(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n"])));
var templateObject_1$h, templateObject_2$d, templateObject_3$9, templateObject_4$8, templateObject_5$6, templateObject_6$5;

var handleShowNames = function (files) {
    var names = '';
    files === null || files === void 0 ? void 0 : files.forEach(function (file) { return (names += (file === null || file === void 0 ? void 0 : file.name) + ' /'); });
    return names;
};
var BaSeImagePicker = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
    var selectedImage = _a.selectedImage, _8 = _a.iconNotFoundPlaceholder, iconNotFoundPlaceholder = _8 === void 0 ? 'times-circle-tonescale' : _8, onError = _a.onError, onFilePick = _a.onFilePick, onUrlPick = _a.onUrlPick, onDelete = _a.onDelete, _9 = _a.renderStyle, renderStyle = _9 === void 0 ? 'box' : _9, _10 = _a.cropEnable, cropEnable = _10 === void 0 ? false : _10, _11 = _a.imageShape, imageShape = _11 === void 0 ? 'square' : _11, dialogContext = _a.dialogContext, // TODO encontrar melhor maneira de abrir modal?
    cropModalCrops = _a.cropModalCrops, cropInitalValues = _a.cropInitalValues, uploadButtonProps = _a.uploadButtonProps, updateButtonProps = _a.updateButtonProps, deleteButtonProps = _a.deleteButtonProps, uploadBaseIconProps = _a.uploadBaseIconProps, dragInfoText = _a.dragInfoText, dragInfoProps = _a.dragInfoProps;
    var inputRef = React.useRef(null);
    var _12 = React.useState(false), notFound = _12[0], setNotFound = _12[1];
    var _13 = React.useState([]), files = _13[0], setFiles = _13[1];
    var _14 = React.useState([]), urls = _14[0], setUrls = _14[1];
    var _15 = React.useState(false), isDrag = _15[0], setIsDrag = _15[1];
    var _16 = React.useState(''), selectedImageSource = _16[0], setSelectedImageSource = _16[1];
    var showModal = React.useContext(dialogContext !== null && dialogContext !== void 0 ? dialogContext : BaSeDialogContext).showModal;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var handleChange = React.useCallback(function (event) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var filelist = (_c = (_b = (_a = event) === null || _a === void 0 ? void 0 : _a.target) === null || _b === void 0 ? void 0 : _b.files) !== null && _c !== void 0 ? _c : (_e = (_d = event) === null || _d === void 0 ? void 0 : _d.dataTransfer) === null || _e === void 0 ? void 0 : _e.files;
        if (filelist && filelist.length) {
            var varFile_1 = filelist[0];
            if (cropEnable) {
                showModal(__assign(__assign({}, cropModalCrops), { content: function (modalProps) { return (React.createElement(BaSeCropper, { file: varFile_1, saveCallback: function (croppedImage) {
                            var _a;
                            setFiles([croppedImage]);
                            (_a = modalProps === null || modalProps === void 0 ? void 0 : modalProps.closeModal) === null || _a === void 0 ? void 0 : _a.call(modalProps, '');
                        }, cancelCallback: function () { var _a; return (_a = modalProps === null || modalProps === void 0 ? void 0 : modalProps.closeModal) === null || _a === void 0 ? void 0 : _a.call(modalProps, ''); }, onCropError: function (message) {
                            var _a;
                            onError === null || onError === void 0 ? void 0 : onError(message);
                            (_a = modalProps === null || modalProps === void 0 ? void 0 : modalProps.closeModal) === null || _a === void 0 ? void 0 : _a.call(modalProps, message);
                        }, cropInitalValues: cropInitalValues })); }, title: (_f = cropModalCrops === null || cropModalCrops === void 0 ? void 0 : cropModalCrops.title) !== null && _f !== void 0 ? _f : getMessage('ImagePicker.modalTitle'), actions: [], size: (_g = cropModalCrops === null || cropModalCrops === void 0 ? void 0 : cropModalCrops.size) !== null && _g !== void 0 ? _g : 'large' }));
            }
            else {
                return setFiles([filelist[0]]);
            }
        }
        if (((_h = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _h === void 0 ? void 0 : _h.value) && cropEnable) {
            inputRef.current.value = ''; // limpar value do hiddenInput depois do upload
        }
    }, []);
    var handleDrag = function (bol) { return function (event) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        setIsDrag(bol);
    }; };
    var handleDrop = function (event) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        handleChange(event);
        setIsDrag(false);
    };
    React.useEffect(function () {
        onFilePick === null || onFilePick === void 0 ? void 0 : onFilePick(files);
        if (files) {
            setUrls(Array.from(files).map(function (file) { return URL.createObjectURL(file); }));
        }
    }, [files]);
    React.useEffect(function () {
        onUrlPick === null || onUrlPick === void 0 ? void 0 : onUrlPick(urls);
        return function () { return urls === null || urls === void 0 ? void 0 : urls.forEach(function (url) { return URL.revokeObjectURL(url); }); };
    }, [urls]);
    React.useEffect(function () {
        if (selectedImage instanceof File) {
            if (!selectedImage.type.startsWith('image/')) {
                return onError === null || onError === void 0 ? void 0 : onError(getMessage('filePicker.fileInvalidMessage'));
            }
            return setSelectedImageSource(URL.createObjectURL(selectedImage));
        }
        setSelectedImageSource(selectedImage !== null && selectedImage !== void 0 ? selectedImage : '');
    }, [selectedImage]);
    React.useEffect(function () {
        if (selectedImage) {
            setNotFound(false);
        }
        if (selectedImage instanceof File) {
            return function () {
                URL.revokeObjectURL(selectedImageSource);
            };
        }
        return;
    }, [selectedImage, selectedImageSource]);
    return (React.createElement(React.Fragment, null,
        renderStyle === 'input-field' && (React.createElement(React.Fragment, null,
            React.createElement(HiddenInputFile, { ref: inputRef, onChange: handleChange }),
            React.createElement(BaSeInput, { isReadOnly: true, value: handleShowNames(files), iconButton: {
                    action: function () {
                        var _a, _b, _c;
                        (_b = (_a = uploadButtonProps) === null || _a === void 0 ? void 0 : _a.action) === null || _b === void 0 ? void 0 : _b.call(_a);
                        (_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.click();
                    },
                    color: (_c = (_b = uploadButtonProps) === null || _b === void 0 ? void 0 : _b.color) !== null && _c !== void 0 ? _c : 'default',
                    name: (_e = (_d = uploadButtonProps) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : 'search',
                    typeButton: (_g = (_f = uploadButtonProps) === null || _f === void 0 ? void 0 : _f.typeButton) !== null && _g !== void 0 ? _g : 'base-button',
                    value: (_j = (_h = uploadButtonProps) === null || _h === void 0 ? void 0 : _h.value) !== null && _j !== void 0 ? _j : getMessage('filePicker.buttonPickLabel'),
                    type: (_l = (_k = uploadButtonProps) === null || _k === void 0 ? void 0 : _k.type) !== null && _l !== void 0 ? _l : 'primary',
                } }))),
        renderStyle === 'box' && (React.createElement(ImagePickerWrapper, { onDragEnter: handleDrag(true), onDragLeave: handleDrag(false), onDragOver: handleDrag(true), onDrop: handleDrop, isDrag: isDrag },
            React.createElement(HiddenInputFile, { ref: inputRef, onChange: handleChange }),
            selectedImage ? (React.createElement(React.Fragment, null,
                notFound ? (React.createElement(BaSeIcon, { color: BaSeTheme.colors.institucionais.azulSebrae75, size: 75, name: iconNotFoundPlaceholder, description: getMessage('imagePicker.imageNotFound') })) : (React.createElement(SelectedImage, { hasRadius: imageShape === 'circle', src: selectedImageSource, alt: getMessage('imagePicker.selectedImage'), onError: function () { return setNotFound(true); } })),
                React.createElement(ActionButtonWrapper, null,
                    React.createElement(BaSeButton, __assign({}, updateButtonProps, { type: (_m = updateButtonProps === null || updateButtonProps === void 0 ? void 0 : updateButtonProps.type) !== null && _m !== void 0 ? _m : 'default', size: (_o = updateButtonProps === null || updateButtonProps === void 0 ? void 0 : updateButtonProps.size) !== null && _o !== void 0 ? _o : 'small', color: (_p = updateButtonProps === null || updateButtonProps === void 0 ? void 0 : updateButtonProps.color) !== null && _p !== void 0 ? _p : 'default', leftIcon: (_q = updateButtonProps === null || updateButtonProps === void 0 ? void 0 : updateButtonProps.leftIcon) !== null && _q !== void 0 ? _q : 'refresh-alt', value: (_r = updateButtonProps === null || updateButtonProps === void 0 ? void 0 : updateButtonProps.value) !== null && _r !== void 0 ? _r : getMessage('filePicker.buttonUpdateLabel'), onClick: function (clickEvent) {
                            var _a, _b;
                            (_a = updateButtonProps === null || updateButtonProps === void 0 ? void 0 : updateButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(updateButtonProps, clickEvent);
                            (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.click();
                        } })),
                    React.createElement(BaSeButton, __assign({}, deleteButtonProps, { type: (_s = deleteButtonProps === null || deleteButtonProps === void 0 ? void 0 : deleteButtonProps.type) !== null && _s !== void 0 ? _s : 'primary', size: (_t = deleteButtonProps === null || deleteButtonProps === void 0 ? void 0 : deleteButtonProps.size) !== null && _t !== void 0 ? _t : 'small', color: (_u = deleteButtonProps === null || deleteButtonProps === void 0 ? void 0 : deleteButtonProps.color) !== null && _u !== void 0 ? _u : 'default', leftIcon: (_v = deleteButtonProps === null || deleteButtonProps === void 0 ? void 0 : deleteButtonProps.leftIcon) !== null && _v !== void 0 ? _v : 'trash-alt', value: (_w = deleteButtonProps === null || deleteButtonProps === void 0 ? void 0 : deleteButtonProps.value) !== null && _w !== void 0 ? _w : getMessage('filePicker.buttonDeleteLabel'), onClick: function (clickEvent) {
                            var _a;
                            (_a = deleteButtonProps === null || deleteButtonProps === void 0 ? void 0 : deleteButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(deleteButtonProps, clickEvent);
                            onDelete === null || onDelete === void 0 ? void 0 : onDelete(selectedImage);
                        } }))))) : (React.createElement(React.Fragment, null,
                React.createElement("div", { style: { pointerEvents: 'none' } },
                    React.createElement(BaSeIcon, __assign({ color: BaSeTheme.colors.institucionais.cinzaSebrae90, size: 75, name: "file-plus-alt", description: getMessage('imagePicker.imagePlaceholder') }, uploadBaseIconProps))),
                React.createElement(BaSeButton, __assign({}, uploadButtonProps, { type: (_y = (_x = uploadButtonProps) === null || _x === void 0 ? void 0 : _x.type) !== null && _y !== void 0 ? _y : 'primary', size: (_0 = (_z = uploadButtonProps) === null || _z === void 0 ? void 0 : _z.size) !== null && _0 !== void 0 ? _0 : 'small', color: (_2 = (_1 = uploadButtonProps) === null || _1 === void 0 ? void 0 : _1.color) !== null && _2 !== void 0 ? _2 : 'default', leftIcon: (_4 = (_3 = uploadButtonProps) === null || _3 === void 0 ? void 0 : _3.leftIcon) !== null && _4 !== void 0 ? _4 : 'upload', value: (_6 = (_5 = uploadButtonProps) === null || _5 === void 0 ? void 0 : _5.value) !== null && _6 !== void 0 ? _6 : getMessage('filePicker.buttonPickLabel'), onClick: function (clickEvent) {
                        var _a, _b, _c;
                        (_b = (_a = uploadButtonProps) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a, clickEvent);
                        (_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.click();
                    } })),
                React.createElement(BaSeParagraph, __assign({}, dragInfoProps, { color: (_7 = dragInfoProps === null || dragInfoProps === void 0 ? void 0 : dragInfoProps.color) !== null && _7 !== void 0 ? _7 : BaSeTheme.colors.institucionais.cinzaSebrae45 }), dragInfoText !== null && dragInfoText !== void 0 ? dragInfoText : getMessage('filePicker.dragInfo'))))))));
};
BaSeImagePicker.displayName = 'BaSeImagePicker';

var DatePickerOriginal = styled.div(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  .react-datepicker__navigation-icon::before,\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow {\n    border-color: #ccc;\n    border-style: solid;\n    border-width: 3px 3px 0 0;\n    content: '';\n    display: block;\n    height: 9px;\n    position: absolute;\n    top: 6px;\n    width: 9px;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle,\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle {\n    margin-left: -4px;\n    position: absolute;\n    width: 0;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::after,\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::after {\n    box-sizing: content-box;\n    position: absolute;\n    border: 8px solid transparent;\n    height: 0;\n    width: 1px;\n    content: '';\n    z-index: -1;\n    border-width: 8px;\n    left: -8px;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::before {\n    border-bottom-color: #aeaeae;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle {\n    top: 0;\n    margin-top: -8px;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::after {\n    border-top: none;\n    border-bottom-color: #f0f0f0;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::after {\n    top: 0;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::before {\n    top: -1px;\n    border-bottom-color: #aeaeae;\n  }\n\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle {\n    bottom: 0;\n    margin-bottom: -8px;\n  }\n\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::after {\n    border-bottom: none;\n    border-top-color: #fff;\n  }\n\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::after {\n    bottom: 0;\n  }\n\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::before {\n    bottom: -1px;\n    border-top-color: #aeaeae;\n  }\n\n  .react-datepicker-wrapper {\n    display: inline-block;\n    padding: 0;\n    border: 0;\n  }\n\n  .react-datepicker {\n    font-family: 'Helvetica Neue', helvetica, arial, sans-serif;\n    font-size: 0.8rem;\n    background-color: #fff;\n    color: #000;\n    border: 1px solid #aeaeae;\n    border-radius: 0.3rem;\n    display: inline-block;\n    position: relative;\n  }\n\n  .react-datepicker--time-only .react-datepicker__triangle {\n    left: 35px;\n  }\n\n  .react-datepicker--time-only .react-datepicker__time-container {\n    border-left: 0;\n  }\n\n  .react-datepicker--time-only .react-datepicker__time,\n  .react-datepicker--time-only .react-datepicker__time-box {\n    border-bottom-left-radius: 0.3rem;\n    border-bottom-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__triangle {\n    position: absolute;\n    left: 50px;\n  }\n\n  .react-datepicker-popper {\n    z-index: 1;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom'] {\n    padding-top: 10px;\n  }\n\n  .react-datepicker-popper[data-placement='bottom-end']\n    .react-datepicker__triangle,\n  .react-datepicker-popper[data-placement='top-end']\n    .react-datepicker__triangle {\n    left: auto;\n    right: 50px;\n  }\n\n  .react-datepicker-popper[data-placement^='top'] {\n    padding-bottom: 10px;\n  }\n\n  .react-datepicker-popper[data-placement^='right'] {\n    padding-left: 8px;\n  }\n\n  .react-datepicker-popper[data-placement^='right']\n    .react-datepicker__triangle {\n    left: auto;\n    right: 42px;\n  }\n\n  .react-datepicker-popper[data-placement^='left'] {\n    padding-right: 8px;\n  }\n\n  .react-datepicker-popper[data-placement^='left'] .react-datepicker__triangle {\n    left: 42px;\n    right: auto;\n  }\n\n  .react-datepicker__header {\n    text-align: center;\n    background-color: #f0f0f0;\n    border-bottom: 1px solid #aeaeae;\n    border-top-left-radius: 0.3rem;\n    padding: 8px 0;\n    position: relative;\n  }\n\n  .react-datepicker__header--time {\n    padding-bottom: 8px;\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n\n  .react-datepicker__header--time:not(.react-datepicker__header--time--only) {\n    border-top-left-radius: 0;\n  }\n\n  .react-datepicker__header:not(.react-datepicker__header--has-time-select) {\n    border-top-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__year-dropdown-container--select,\n  .react-datepicker__month-dropdown-container--select,\n  .react-datepicker__month-year-dropdown-container--select,\n  .react-datepicker__year-dropdown-container--scroll,\n  .react-datepicker__month-dropdown-container--scroll,\n  .react-datepicker__month-year-dropdown-container--scroll {\n    display: inline-block;\n    margin: 0 2px;\n  }\n\n  .react-datepicker__current-month,\n  .react-datepicker-time__header,\n  .react-datepicker-year-header {\n    margin-top: 0;\n    color: #000;\n    font-weight: bold;\n    font-size: 0.944rem;\n  }\n\n  .react-datepicker-time__header {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n\n  .react-datepicker__navigation {\n    align-items: center;\n    background: none;\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    cursor: pointer;\n    position: absolute;\n    top: 2px;\n    padding: 0;\n    border: none;\n    z-index: 1;\n    height: 32px;\n    width: 32px;\n    text-indent: -999em;\n    overflow: hidden;\n  }\n\n  .react-datepicker__navigation--previous {\n    left: 2px;\n  }\n\n  .react-datepicker__navigation--next {\n    right: 2px;\n  }\n\n  .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n    right: 85px;\n  }\n\n  .react-datepicker__navigation--years {\n    position: relative;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .react-datepicker__navigation--years-previous {\n    top: 4px;\n  }\n\n  .react-datepicker__navigation--years-upcoming {\n    top: -4px;\n  }\n\n  .react-datepicker__navigation:hover *::before {\n    border-color: #a6a6a6;\n  }\n\n  .react-datepicker__navigation-icon {\n    position: relative;\n    top: -1px;\n    font-size: 20px;\n  }\n\n  .react-datepicker__navigation-icon--next {\n    left: -2px;\n  }\n\n  .react-datepicker__navigation-icon--next::before {\n    transform: rotate(45deg);\n    left: -7px;\n  }\n\n  .react-datepicker__navigation-icon--previous {\n    right: -2px;\n  }\n\n  .react-datepicker__navigation-icon--previous::before {\n    transform: rotate(225deg);\n    right: -7px;\n  }\n\n  .react-datepicker__month-container {\n    float: left;\n  }\n\n  .react-datepicker__year {\n    margin: 0.4rem;\n    text-align: center;\n  }\n\n  .react-datepicker__year-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    max-width: 180px;\n  }\n\n  .react-datepicker__year .react-datepicker__year-text {\n    display: inline-block;\n    width: 4rem;\n    margin: 2px;\n  }\n\n  .react-datepicker__month {\n    margin: 0.4rem;\n    text-align: center;\n  }\n\n  .react-datepicker__month .react-datepicker__month-text,\n  .react-datepicker__month .react-datepicker__quarter-text {\n    display: inline-block;\n    width: 4rem;\n    margin: 2px;\n  }\n\n  .react-datepicker__input-time-container {\n    clear: both;\n    width: 100%;\n    float: left;\n    margin: 5px 0 10px 15px;\n    text-align: left;\n  }\n\n  .react-datepicker__input-time-container .react-datepicker-time__caption {\n    display: inline-block;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container {\n    display: inline-block;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input {\n    display: inline-block;\n    margin-left: 10px;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input {\n    width: auto;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input[type='time']::-webkit-inner-spin-button,\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input[type='time']::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input[type='time'] {\n    -moz-appearance: textfield;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__delimiter {\n    margin-left: 5px;\n    display: inline-block;\n  }\n\n  .react-datepicker__time-container {\n    float: right;\n    border-left: 1px solid #aeaeae;\n    width: 85px;\n  }\n\n  .react-datepicker__time-container--with-today-button {\n    display: inline;\n    border: 1px solid #aeaeae;\n    border-radius: 0.3rem;\n    position: absolute;\n    right: -72px;\n    top: 0;\n  }\n\n  .react-datepicker__time-container .react-datepicker__time {\n    position: relative;\n    background: white;\n    border-bottom-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box {\n    width: 85px;\n    overflow-x: hidden;\n    margin: 0 auto;\n    text-align: center;\n    border-bottom-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list {\n    list-style: none;\n    margin: 0;\n    height: calc(195px + (1.7rem / 2));\n    overflow-y: scroll;\n    padding-right: 0;\n    padding-left: 0;\n    width: 100%;\n    box-sizing: content-box;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item {\n    height: 30px;\n    padding: 5px 10px;\n    white-space: nowrap;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item:hover {\n    cursor: pointer;\n    background-color: #f0f0f0;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--selected {\n    background-color: #216ba5;\n    color: white;\n    font-weight: bold;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--selected:hover {\n    background-color: #216ba5;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--disabled {\n    color: #ccc;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--disabled:hover {\n    cursor: default;\n    background-color: transparent;\n  }\n\n  .react-datepicker__week-number {\n    color: #ccc;\n    display: inline-block;\n    width: 1.7rem;\n    line-height: 1.7rem;\n    text-align: center;\n    margin: 0.166rem;\n  }\n\n  .react-datepicker__week-number.react-datepicker__week-number--clickable {\n    cursor: pointer;\n  }\n\n  .react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n    border-radius: 0.3rem;\n    background-color: #f0f0f0;\n  }\n\n  .react-datepicker__day-names,\n  .react-datepicker__week {\n    white-space: nowrap;\n  }\n\n  .react-datepicker__day-names {\n    margin-bottom: -8px;\n  }\n\n  .react-datepicker__day-name,\n  .react-datepicker__day,\n  .react-datepicker__time-name {\n    color: #000;\n    display: inline-block;\n    width: 1.7rem;\n    line-height: 1.7rem;\n    text-align: center;\n    margin: 0.166rem;\n  }\n\n  .react-datepicker__month--selected,\n  .react-datepicker__month--in-selecting-range,\n  .react-datepicker__month--in-range,\n  .react-datepicker__quarter--selected,\n  .react-datepicker__quarter--in-selecting-range,\n  .react-datepicker__quarter--in-range {\n    border-radius: 0.3rem;\n    background-color: #216ba5;\n    color: #fff;\n  }\n\n  .react-datepicker__month--selected:hover,\n  .react-datepicker__month--in-selecting-range:hover,\n  .react-datepicker__month--in-range:hover,\n  .react-datepicker__quarter--selected:hover,\n  .react-datepicker__quarter--in-selecting-range:hover,\n  .react-datepicker__quarter--in-range:hover {\n    background-color: #1d5d90;\n  }\n\n  .react-datepicker__month--disabled,\n  .react-datepicker__quarter--disabled {\n    color: #ccc;\n    pointer-events: none;\n  }\n\n  .react-datepicker__month--disabled:hover,\n  .react-datepicker__quarter--disabled:hover {\n    cursor: default;\n    background-color: transparent;\n  }\n\n  .react-datepicker__day,\n  .react-datepicker__month-text,\n  .react-datepicker__quarter-text,\n  .react-datepicker__year-text {\n    cursor: pointer;\n  }\n\n  .react-datepicker__day:hover,\n  .react-datepicker__month-text:hover,\n  .react-datepicker__quarter-text:hover,\n  .react-datepicker__year-text:hover {\n    border-radius: 0.3rem;\n    background-color: #f0f0f0;\n  }\n\n  .react-datepicker__day--today,\n  .react-datepicker__month-text--today,\n  .react-datepicker__quarter-text--today,\n  .react-datepicker__year-text--today {\n    font-weight: bold;\n  }\n\n  .react-datepicker__day--highlighted,\n  .react-datepicker__month-text--highlighted,\n  .react-datepicker__quarter-text--highlighted,\n  .react-datepicker__year-text--highlighted {\n    border-radius: 0.3rem;\n    background-color: #3dcc4a;\n    color: #fff;\n  }\n\n  .react-datepicker__day--highlighted:hover,\n  .react-datepicker__month-text--highlighted:hover,\n  .react-datepicker__quarter-text--highlighted:hover,\n  .react-datepicker__year-text--highlighted:hover {\n    background-color: #32be3f;\n  }\n\n  .react-datepicker__day--highlighted-custom-1,\n  .react-datepicker__month-text--highlighted-custom-1,\n  .react-datepicker__quarter-text--highlighted-custom-1,\n  .react-datepicker__year-text--highlighted-custom-1 {\n    color: magenta;\n  }\n\n  .react-datepicker__day--highlighted-custom-2,\n  .react-datepicker__month-text--highlighted-custom-2,\n  .react-datepicker__quarter-text--highlighted-custom-2,\n  .react-datepicker__year-text--highlighted-custom-2 {\n    color: green;\n  }\n\n  .react-datepicker__day--selected,\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__day--in-range,\n  .react-datepicker__month-text--selected,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__month-text--in-range,\n  .react-datepicker__quarter-text--selected,\n  .react-datepicker__quarter-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-range,\n  .react-datepicker__year-text--selected,\n  .react-datepicker__year-text--in-selecting-range,\n  .react-datepicker__year-text--in-range {\n    border-radius: 0.3rem;\n    background-color: #216ba5;\n    color: #fff;\n  }\n\n  .react-datepicker__day--selected:hover,\n  .react-datepicker__day--in-selecting-range:hover,\n  .react-datepicker__day--in-range:hover,\n  .react-datepicker__month-text--selected:hover,\n  .react-datepicker__month-text--in-selecting-range:hover,\n  .react-datepicker__month-text--in-range:hover,\n  .react-datepicker__quarter-text--selected:hover,\n  .react-datepicker__quarter-text--in-selecting-range:hover,\n  .react-datepicker__quarter-text--in-range:hover,\n  .react-datepicker__year-text--selected:hover,\n  .react-datepicker__year-text--in-selecting-range:hover,\n  .react-datepicker__year-text--in-range:hover {\n    background-color: #1d5d90;\n  }\n\n  .react-datepicker__day--keyboard-selected,\n  .react-datepicker__month-text--keyboard-selected,\n  .react-datepicker__quarter-text--keyboard-selected,\n  .react-datepicker__year-text--keyboard-selected {\n    border-radius: 0.3rem;\n    background-color: #2a87d0;\n    color: #fff;\n  }\n\n  .react-datepicker__day--keyboard-selected:hover,\n  .react-datepicker__month-text--keyboard-selected:hover,\n  .react-datepicker__quarter-text--keyboard-selected:hover,\n  .react-datepicker__year-text--keyboard-selected:hover {\n    background-color: #1d5d90;\n  }\n\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-selecting-range,\n  .react-datepicker__year-text--in-selecting-range {\n    background-color: rgba(33, 107, 165, 0.5);\n  }\n\n  .react-datepicker__month--selecting-range .react-datepicker__day--in-range,\n  .react-datepicker__month--selecting-range\n    .react-datepicker__month-text--in-range,\n  .react-datepicker__month--selecting-range\n    .react-datepicker__quarter-text--in-range,\n  .react-datepicker__month--selecting-range\n    .react-datepicker__year-text--in-range {\n    background-color: #f0f0f0;\n    color: #000;\n  }\n\n  .react-datepicker__day--disabled,\n  .react-datepicker__month-text--disabled,\n  .react-datepicker__quarter-text--disabled,\n  .react-datepicker__year-text--disabled {\n    cursor: default;\n    color: #ccc;\n  }\n\n  .react-datepicker__day--disabled:hover,\n  .react-datepicker__month-text--disabled:hover,\n  .react-datepicker__quarter-text--disabled:hover,\n  .react-datepicker__year-text--disabled:hover {\n    background-color: transparent;\n  }\n\n  .react-datepicker__month-text.react-datepicker__month--selected:hover,\n  .react-datepicker__month-text.react-datepicker__month--in-range:hover,\n  .react-datepicker__month-text.react-datepicker__quarter--selected:hover,\n  .react-datepicker__month-text.react-datepicker__quarter--in-range:hover,\n  .react-datepicker__quarter-text.react-datepicker__month--selected:hover,\n  .react-datepicker__quarter-text.react-datepicker__month--in-range:hover,\n  .react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,\n  .react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {\n    background-color: #216ba5;\n  }\n\n  .react-datepicker__month-text:hover,\n  .react-datepicker__quarter-text:hover {\n    background-color: #f0f0f0;\n  }\n\n  .react-datepicker__input-container {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n  }\n\n  .react-datepicker__year-read-view,\n  .react-datepicker__month-read-view,\n  .react-datepicker__month-year-read-view {\n    border: 1px solid transparent;\n    border-radius: 0.3rem;\n    position: relative;\n  }\n\n  .react-datepicker__year-read-view:hover,\n  .react-datepicker__month-read-view:hover,\n  .react-datepicker__month-year-read-view:hover {\n    cursor: pointer;\n  }\n\n  .react-datepicker__year-read-view:hover\n    .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__year-read-view:hover\n    .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-read-view:hover\n    .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view:hover\n    .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view:hover\n    .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-year-read-view:hover\n    .react-datepicker__month-read-view--down-arrow {\n    border-top-color: #b3b3b3;\n  }\n\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow {\n    transform: rotate(135deg);\n    right: -16px;\n    top: 0;\n  }\n\n  .react-datepicker__year-dropdown,\n  .react-datepicker__month-dropdown,\n  .react-datepicker__month-year-dropdown {\n    background-color: #f0f0f0;\n    position: absolute;\n    width: 50%;\n    left: 25%;\n    top: 30px;\n    z-index: 1;\n    text-align: center;\n    border-radius: 0.3rem;\n    border: 1px solid #aeaeae;\n  }\n\n  .react-datepicker__year-dropdown:hover,\n  .react-datepicker__month-dropdown:hover,\n  .react-datepicker__month-year-dropdown:hover {\n    cursor: pointer;\n  }\n\n  .react-datepicker__year-dropdown--scrollable,\n  .react-datepicker__month-dropdown--scrollable,\n  .react-datepicker__month-year-dropdown--scrollable {\n    height: 150px;\n    overflow-y: scroll;\n  }\n\n  .react-datepicker__year-option,\n  .react-datepicker__month-option,\n  .react-datepicker__month-year-option {\n    line-height: 20px;\n    width: 100%;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .react-datepicker__year-option:first-of-type,\n  .react-datepicker__month-option:first-of-type,\n  .react-datepicker__month-year-option:first-of-type {\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__year-option:last-of-type,\n  .react-datepicker__month-option:last-of-type,\n  .react-datepicker__month-year-option:last-of-type {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    border-bottom-left-radius: 0.3rem;\n    border-bottom-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__year-option:hover,\n  .react-datepicker__month-option:hover,\n  .react-datepicker__month-year-option:hover {\n    background-color: #ccc;\n  }\n\n  .react-datepicker__year-option:hover\n    .react-datepicker__navigation--years-upcoming,\n  .react-datepicker__month-option:hover\n    .react-datepicker__navigation--years-upcoming,\n  .react-datepicker__month-year-option:hover\n    .react-datepicker__navigation--years-upcoming {\n    border-bottom-color: #b3b3b3;\n  }\n\n  .react-datepicker__year-option:hover\n    .react-datepicker__navigation--years-previous,\n  .react-datepicker__month-option:hover\n    .react-datepicker__navigation--years-previous,\n  .react-datepicker__month-year-option:hover\n    .react-datepicker__navigation--years-previous {\n    border-top-color: #b3b3b3;\n  }\n\n  .react-datepicker__year-option--selected,\n  .react-datepicker__month-option--selected,\n  .react-datepicker__month-year-option--selected {\n    position: absolute;\n    left: 15px;\n  }\n\n  .react-datepicker__close-icon {\n    cursor: pointer;\n    background-color: transparent;\n    border: 0;\n    outline: 0;\n    padding: 0 6px 0 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    display: table-cell;\n    vertical-align: middle;\n  }\n\n  .react-datepicker__close-icon::after {\n    cursor: pointer;\n    background-color: #216ba5;\n    color: #fff;\n    border-radius: 50%;\n    height: 16px;\n    width: 16px;\n    padding: 2px;\n    font-size: 12px;\n    line-height: 1;\n    text-align: center;\n    display: table-cell;\n    vertical-align: middle;\n  }\n\n  .react-datepicker__today-button {\n    background: #f0f0f0;\n    border-top: 1px solid #aeaeae;\n    cursor: pointer;\n    text-align: center;\n    font-weight: bold;\n    padding: 5px 0;\n    clear: left;\n  }\n\n  .react-datepicker__portal {\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.8);\n    left: 0;\n    top: 0;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    z-index: 2147483647;\n  }\n\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 3rem;\n    line-height: 3rem;\n  }\n\n  @media (max-width: 400px), (max-height: 550px) {\n    .react-datepicker__portal .react-datepicker__day-name,\n    .react-datepicker__portal .react-datepicker__day,\n    .react-datepicker__portal .react-datepicker__time-name {\n      width: 2rem;\n      line-height: 2rem;\n    }\n  }\n\n  .react-datepicker__portal .react-datepicker__current-month,\n  .react-datepicker__portal .react-datepicker-time__header {\n    font-size: 1.44rem;\n  }\n"], ["\n  .react-datepicker__navigation-icon::before,\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow {\n    border-color: #ccc;\n    border-style: solid;\n    border-width: 3px 3px 0 0;\n    content: '';\n    display: block;\n    height: 9px;\n    position: absolute;\n    top: 6px;\n    width: 9px;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle,\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle {\n    margin-left: -4px;\n    position: absolute;\n    width: 0;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::after,\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::after {\n    box-sizing: content-box;\n    position: absolute;\n    border: 8px solid transparent;\n    height: 0;\n    width: 1px;\n    content: '';\n    z-index: -1;\n    border-width: 8px;\n    left: -8px;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::before {\n    border-bottom-color: #aeaeae;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle {\n    top: 0;\n    margin-top: -8px;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::after {\n    border-top: none;\n    border-bottom-color: #f0f0f0;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::after {\n    top: 0;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom']\n    .react-datepicker__triangle::before {\n    top: -1px;\n    border-bottom-color: #aeaeae;\n  }\n\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle {\n    bottom: 0;\n    margin-bottom: -8px;\n  }\n\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::after {\n    border-bottom: none;\n    border-top-color: #fff;\n  }\n\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::after {\n    bottom: 0;\n  }\n\n  .react-datepicker-popper[data-placement^='top']\n    .react-datepicker__triangle::before {\n    bottom: -1px;\n    border-top-color: #aeaeae;\n  }\n\n  .react-datepicker-wrapper {\n    display: inline-block;\n    padding: 0;\n    border: 0;\n  }\n\n  .react-datepicker {\n    font-family: 'Helvetica Neue', helvetica, arial, sans-serif;\n    font-size: 0.8rem;\n    background-color: #fff;\n    color: #000;\n    border: 1px solid #aeaeae;\n    border-radius: 0.3rem;\n    display: inline-block;\n    position: relative;\n  }\n\n  .react-datepicker--time-only .react-datepicker__triangle {\n    left: 35px;\n  }\n\n  .react-datepicker--time-only .react-datepicker__time-container {\n    border-left: 0;\n  }\n\n  .react-datepicker--time-only .react-datepicker__time,\n  .react-datepicker--time-only .react-datepicker__time-box {\n    border-bottom-left-radius: 0.3rem;\n    border-bottom-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__triangle {\n    position: absolute;\n    left: 50px;\n  }\n\n  .react-datepicker-popper {\n    z-index: 1;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom'] {\n    padding-top: 10px;\n  }\n\n  .react-datepicker-popper[data-placement='bottom-end']\n    .react-datepicker__triangle,\n  .react-datepicker-popper[data-placement='top-end']\n    .react-datepicker__triangle {\n    left: auto;\n    right: 50px;\n  }\n\n  .react-datepicker-popper[data-placement^='top'] {\n    padding-bottom: 10px;\n  }\n\n  .react-datepicker-popper[data-placement^='right'] {\n    padding-left: 8px;\n  }\n\n  .react-datepicker-popper[data-placement^='right']\n    .react-datepicker__triangle {\n    left: auto;\n    right: 42px;\n  }\n\n  .react-datepicker-popper[data-placement^='left'] {\n    padding-right: 8px;\n  }\n\n  .react-datepicker-popper[data-placement^='left'] .react-datepicker__triangle {\n    left: 42px;\n    right: auto;\n  }\n\n  .react-datepicker__header {\n    text-align: center;\n    background-color: #f0f0f0;\n    border-bottom: 1px solid #aeaeae;\n    border-top-left-radius: 0.3rem;\n    padding: 8px 0;\n    position: relative;\n  }\n\n  .react-datepicker__header--time {\n    padding-bottom: 8px;\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n\n  .react-datepicker__header--time:not(.react-datepicker__header--time--only) {\n    border-top-left-radius: 0;\n  }\n\n  .react-datepicker__header:not(.react-datepicker__header--has-time-select) {\n    border-top-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__year-dropdown-container--select,\n  .react-datepicker__month-dropdown-container--select,\n  .react-datepicker__month-year-dropdown-container--select,\n  .react-datepicker__year-dropdown-container--scroll,\n  .react-datepicker__month-dropdown-container--scroll,\n  .react-datepicker__month-year-dropdown-container--scroll {\n    display: inline-block;\n    margin: 0 2px;\n  }\n\n  .react-datepicker__current-month,\n  .react-datepicker-time__header,\n  .react-datepicker-year-header {\n    margin-top: 0;\n    color: #000;\n    font-weight: bold;\n    font-size: 0.944rem;\n  }\n\n  .react-datepicker-time__header {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n\n  .react-datepicker__navigation {\n    align-items: center;\n    background: none;\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    cursor: pointer;\n    position: absolute;\n    top: 2px;\n    padding: 0;\n    border: none;\n    z-index: 1;\n    height: 32px;\n    width: 32px;\n    text-indent: -999em;\n    overflow: hidden;\n  }\n\n  .react-datepicker__navigation--previous {\n    left: 2px;\n  }\n\n  .react-datepicker__navigation--next {\n    right: 2px;\n  }\n\n  .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n    right: 85px;\n  }\n\n  .react-datepicker__navigation--years {\n    position: relative;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .react-datepicker__navigation--years-previous {\n    top: 4px;\n  }\n\n  .react-datepicker__navigation--years-upcoming {\n    top: -4px;\n  }\n\n  .react-datepicker__navigation:hover *::before {\n    border-color: #a6a6a6;\n  }\n\n  .react-datepicker__navigation-icon {\n    position: relative;\n    top: -1px;\n    font-size: 20px;\n  }\n\n  .react-datepicker__navigation-icon--next {\n    left: -2px;\n  }\n\n  .react-datepicker__navigation-icon--next::before {\n    transform: rotate(45deg);\n    left: -7px;\n  }\n\n  .react-datepicker__navigation-icon--previous {\n    right: -2px;\n  }\n\n  .react-datepicker__navigation-icon--previous::before {\n    transform: rotate(225deg);\n    right: -7px;\n  }\n\n  .react-datepicker__month-container {\n    float: left;\n  }\n\n  .react-datepicker__year {\n    margin: 0.4rem;\n    text-align: center;\n  }\n\n  .react-datepicker__year-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    max-width: 180px;\n  }\n\n  .react-datepicker__year .react-datepicker__year-text {\n    display: inline-block;\n    width: 4rem;\n    margin: 2px;\n  }\n\n  .react-datepicker__month {\n    margin: 0.4rem;\n    text-align: center;\n  }\n\n  .react-datepicker__month .react-datepicker__month-text,\n  .react-datepicker__month .react-datepicker__quarter-text {\n    display: inline-block;\n    width: 4rem;\n    margin: 2px;\n  }\n\n  .react-datepicker__input-time-container {\n    clear: both;\n    width: 100%;\n    float: left;\n    margin: 5px 0 10px 15px;\n    text-align: left;\n  }\n\n  .react-datepicker__input-time-container .react-datepicker-time__caption {\n    display: inline-block;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container {\n    display: inline-block;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input {\n    display: inline-block;\n    margin-left: 10px;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input {\n    width: auto;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input[type='time']::-webkit-inner-spin-button,\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input[type='time']::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input[type='time'] {\n    -moz-appearance: textfield;\n  }\n\n  .react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__delimiter {\n    margin-left: 5px;\n    display: inline-block;\n  }\n\n  .react-datepicker__time-container {\n    float: right;\n    border-left: 1px solid #aeaeae;\n    width: 85px;\n  }\n\n  .react-datepicker__time-container--with-today-button {\n    display: inline;\n    border: 1px solid #aeaeae;\n    border-radius: 0.3rem;\n    position: absolute;\n    right: -72px;\n    top: 0;\n  }\n\n  .react-datepicker__time-container .react-datepicker__time {\n    position: relative;\n    background: white;\n    border-bottom-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box {\n    width: 85px;\n    overflow-x: hidden;\n    margin: 0 auto;\n    text-align: center;\n    border-bottom-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list {\n    list-style: none;\n    margin: 0;\n    height: calc(195px + (1.7rem / 2));\n    overflow-y: scroll;\n    padding-right: 0;\n    padding-left: 0;\n    width: 100%;\n    box-sizing: content-box;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item {\n    height: 30px;\n    padding: 5px 10px;\n    white-space: nowrap;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item:hover {\n    cursor: pointer;\n    background-color: #f0f0f0;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--selected {\n    background-color: #216ba5;\n    color: white;\n    font-weight: bold;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--selected:hover {\n    background-color: #216ba5;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--disabled {\n    color: #ccc;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--disabled:hover {\n    cursor: default;\n    background-color: transparent;\n  }\n\n  .react-datepicker__week-number {\n    color: #ccc;\n    display: inline-block;\n    width: 1.7rem;\n    line-height: 1.7rem;\n    text-align: center;\n    margin: 0.166rem;\n  }\n\n  .react-datepicker__week-number.react-datepicker__week-number--clickable {\n    cursor: pointer;\n  }\n\n  .react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n    border-radius: 0.3rem;\n    background-color: #f0f0f0;\n  }\n\n  .react-datepicker__day-names,\n  .react-datepicker__week {\n    white-space: nowrap;\n  }\n\n  .react-datepicker__day-names {\n    margin-bottom: -8px;\n  }\n\n  .react-datepicker__day-name,\n  .react-datepicker__day,\n  .react-datepicker__time-name {\n    color: #000;\n    display: inline-block;\n    width: 1.7rem;\n    line-height: 1.7rem;\n    text-align: center;\n    margin: 0.166rem;\n  }\n\n  .react-datepicker__month--selected,\n  .react-datepicker__month--in-selecting-range,\n  .react-datepicker__month--in-range,\n  .react-datepicker__quarter--selected,\n  .react-datepicker__quarter--in-selecting-range,\n  .react-datepicker__quarter--in-range {\n    border-radius: 0.3rem;\n    background-color: #216ba5;\n    color: #fff;\n  }\n\n  .react-datepicker__month--selected:hover,\n  .react-datepicker__month--in-selecting-range:hover,\n  .react-datepicker__month--in-range:hover,\n  .react-datepicker__quarter--selected:hover,\n  .react-datepicker__quarter--in-selecting-range:hover,\n  .react-datepicker__quarter--in-range:hover {\n    background-color: #1d5d90;\n  }\n\n  .react-datepicker__month--disabled,\n  .react-datepicker__quarter--disabled {\n    color: #ccc;\n    pointer-events: none;\n  }\n\n  .react-datepicker__month--disabled:hover,\n  .react-datepicker__quarter--disabled:hover {\n    cursor: default;\n    background-color: transparent;\n  }\n\n  .react-datepicker__day,\n  .react-datepicker__month-text,\n  .react-datepicker__quarter-text,\n  .react-datepicker__year-text {\n    cursor: pointer;\n  }\n\n  .react-datepicker__day:hover,\n  .react-datepicker__month-text:hover,\n  .react-datepicker__quarter-text:hover,\n  .react-datepicker__year-text:hover {\n    border-radius: 0.3rem;\n    background-color: #f0f0f0;\n  }\n\n  .react-datepicker__day--today,\n  .react-datepicker__month-text--today,\n  .react-datepicker__quarter-text--today,\n  .react-datepicker__year-text--today {\n    font-weight: bold;\n  }\n\n  .react-datepicker__day--highlighted,\n  .react-datepicker__month-text--highlighted,\n  .react-datepicker__quarter-text--highlighted,\n  .react-datepicker__year-text--highlighted {\n    border-radius: 0.3rem;\n    background-color: #3dcc4a;\n    color: #fff;\n  }\n\n  .react-datepicker__day--highlighted:hover,\n  .react-datepicker__month-text--highlighted:hover,\n  .react-datepicker__quarter-text--highlighted:hover,\n  .react-datepicker__year-text--highlighted:hover {\n    background-color: #32be3f;\n  }\n\n  .react-datepicker__day--highlighted-custom-1,\n  .react-datepicker__month-text--highlighted-custom-1,\n  .react-datepicker__quarter-text--highlighted-custom-1,\n  .react-datepicker__year-text--highlighted-custom-1 {\n    color: magenta;\n  }\n\n  .react-datepicker__day--highlighted-custom-2,\n  .react-datepicker__month-text--highlighted-custom-2,\n  .react-datepicker__quarter-text--highlighted-custom-2,\n  .react-datepicker__year-text--highlighted-custom-2 {\n    color: green;\n  }\n\n  .react-datepicker__day--selected,\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__day--in-range,\n  .react-datepicker__month-text--selected,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__month-text--in-range,\n  .react-datepicker__quarter-text--selected,\n  .react-datepicker__quarter-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-range,\n  .react-datepicker__year-text--selected,\n  .react-datepicker__year-text--in-selecting-range,\n  .react-datepicker__year-text--in-range {\n    border-radius: 0.3rem;\n    background-color: #216ba5;\n    color: #fff;\n  }\n\n  .react-datepicker__day--selected:hover,\n  .react-datepicker__day--in-selecting-range:hover,\n  .react-datepicker__day--in-range:hover,\n  .react-datepicker__month-text--selected:hover,\n  .react-datepicker__month-text--in-selecting-range:hover,\n  .react-datepicker__month-text--in-range:hover,\n  .react-datepicker__quarter-text--selected:hover,\n  .react-datepicker__quarter-text--in-selecting-range:hover,\n  .react-datepicker__quarter-text--in-range:hover,\n  .react-datepicker__year-text--selected:hover,\n  .react-datepicker__year-text--in-selecting-range:hover,\n  .react-datepicker__year-text--in-range:hover {\n    background-color: #1d5d90;\n  }\n\n  .react-datepicker__day--keyboard-selected,\n  .react-datepicker__month-text--keyboard-selected,\n  .react-datepicker__quarter-text--keyboard-selected,\n  .react-datepicker__year-text--keyboard-selected {\n    border-radius: 0.3rem;\n    background-color: #2a87d0;\n    color: #fff;\n  }\n\n  .react-datepicker__day--keyboard-selected:hover,\n  .react-datepicker__month-text--keyboard-selected:hover,\n  .react-datepicker__quarter-text--keyboard-selected:hover,\n  .react-datepicker__year-text--keyboard-selected:hover {\n    background-color: #1d5d90;\n  }\n\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-selecting-range,\n  .react-datepicker__year-text--in-selecting-range {\n    background-color: rgba(33, 107, 165, 0.5);\n  }\n\n  .react-datepicker__month--selecting-range .react-datepicker__day--in-range,\n  .react-datepicker__month--selecting-range\n    .react-datepicker__month-text--in-range,\n  .react-datepicker__month--selecting-range\n    .react-datepicker__quarter-text--in-range,\n  .react-datepicker__month--selecting-range\n    .react-datepicker__year-text--in-range {\n    background-color: #f0f0f0;\n    color: #000;\n  }\n\n  .react-datepicker__day--disabled,\n  .react-datepicker__month-text--disabled,\n  .react-datepicker__quarter-text--disabled,\n  .react-datepicker__year-text--disabled {\n    cursor: default;\n    color: #ccc;\n  }\n\n  .react-datepicker__day--disabled:hover,\n  .react-datepicker__month-text--disabled:hover,\n  .react-datepicker__quarter-text--disabled:hover,\n  .react-datepicker__year-text--disabled:hover {\n    background-color: transparent;\n  }\n\n  .react-datepicker__month-text.react-datepicker__month--selected:hover,\n  .react-datepicker__month-text.react-datepicker__month--in-range:hover,\n  .react-datepicker__month-text.react-datepicker__quarter--selected:hover,\n  .react-datepicker__month-text.react-datepicker__quarter--in-range:hover,\n  .react-datepicker__quarter-text.react-datepicker__month--selected:hover,\n  .react-datepicker__quarter-text.react-datepicker__month--in-range:hover,\n  .react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,\n  .react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {\n    background-color: #216ba5;\n  }\n\n  .react-datepicker__month-text:hover,\n  .react-datepicker__quarter-text:hover {\n    background-color: #f0f0f0;\n  }\n\n  .react-datepicker__input-container {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n  }\n\n  .react-datepicker__year-read-view,\n  .react-datepicker__month-read-view,\n  .react-datepicker__month-year-read-view {\n    border: 1px solid transparent;\n    border-radius: 0.3rem;\n    position: relative;\n  }\n\n  .react-datepicker__year-read-view:hover,\n  .react-datepicker__month-read-view:hover,\n  .react-datepicker__month-year-read-view:hover {\n    cursor: pointer;\n  }\n\n  .react-datepicker__year-read-view:hover\n    .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__year-read-view:hover\n    .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-read-view:hover\n    .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view:hover\n    .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view:hover\n    .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-year-read-view:hover\n    .react-datepicker__month-read-view--down-arrow {\n    border-top-color: #b3b3b3;\n  }\n\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow {\n    transform: rotate(135deg);\n    right: -16px;\n    top: 0;\n  }\n\n  .react-datepicker__year-dropdown,\n  .react-datepicker__month-dropdown,\n  .react-datepicker__month-year-dropdown {\n    background-color: #f0f0f0;\n    position: absolute;\n    width: 50%;\n    left: 25%;\n    top: 30px;\n    z-index: 1;\n    text-align: center;\n    border-radius: 0.3rem;\n    border: 1px solid #aeaeae;\n  }\n\n  .react-datepicker__year-dropdown:hover,\n  .react-datepicker__month-dropdown:hover,\n  .react-datepicker__month-year-dropdown:hover {\n    cursor: pointer;\n  }\n\n  .react-datepicker__year-dropdown--scrollable,\n  .react-datepicker__month-dropdown--scrollable,\n  .react-datepicker__month-year-dropdown--scrollable {\n    height: 150px;\n    overflow-y: scroll;\n  }\n\n  .react-datepicker__year-option,\n  .react-datepicker__month-option,\n  .react-datepicker__month-year-option {\n    line-height: 20px;\n    width: 100%;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .react-datepicker__year-option:first-of-type,\n  .react-datepicker__month-option:first-of-type,\n  .react-datepicker__month-year-option:first-of-type {\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__year-option:last-of-type,\n  .react-datepicker__month-option:last-of-type,\n  .react-datepicker__month-year-option:last-of-type {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    border-bottom-left-radius: 0.3rem;\n    border-bottom-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__year-option:hover,\n  .react-datepicker__month-option:hover,\n  .react-datepicker__month-year-option:hover {\n    background-color: #ccc;\n  }\n\n  .react-datepicker__year-option:hover\n    .react-datepicker__navigation--years-upcoming,\n  .react-datepicker__month-option:hover\n    .react-datepicker__navigation--years-upcoming,\n  .react-datepicker__month-year-option:hover\n    .react-datepicker__navigation--years-upcoming {\n    border-bottom-color: #b3b3b3;\n  }\n\n  .react-datepicker__year-option:hover\n    .react-datepicker__navigation--years-previous,\n  .react-datepicker__month-option:hover\n    .react-datepicker__navigation--years-previous,\n  .react-datepicker__month-year-option:hover\n    .react-datepicker__navigation--years-previous {\n    border-top-color: #b3b3b3;\n  }\n\n  .react-datepicker__year-option--selected,\n  .react-datepicker__month-option--selected,\n  .react-datepicker__month-year-option--selected {\n    position: absolute;\n    left: 15px;\n  }\n\n  .react-datepicker__close-icon {\n    cursor: pointer;\n    background-color: transparent;\n    border: 0;\n    outline: 0;\n    padding: 0 6px 0 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    display: table-cell;\n    vertical-align: middle;\n  }\n\n  .react-datepicker__close-icon::after {\n    cursor: pointer;\n    background-color: #216ba5;\n    color: #fff;\n    border-radius: 50%;\n    height: 16px;\n    width: 16px;\n    padding: 2px;\n    font-size: 12px;\n    line-height: 1;\n    text-align: center;\n    display: table-cell;\n    vertical-align: middle;\n  }\n\n  .react-datepicker__today-button {\n    background: #f0f0f0;\n    border-top: 1px solid #aeaeae;\n    cursor: pointer;\n    text-align: center;\n    font-weight: bold;\n    padding: 5px 0;\n    clear: left;\n  }\n\n  .react-datepicker__portal {\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.8);\n    left: 0;\n    top: 0;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    z-index: 2147483647;\n  }\n\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 3rem;\n    line-height: 3rem;\n  }\n\n  @media (max-width: 400px), (max-height: 550px) {\n    .react-datepicker__portal .react-datepicker__day-name,\n    .react-datepicker__portal .react-datepicker__day,\n    .react-datepicker__portal .react-datepicker__time-name {\n      width: 2rem;\n      line-height: 2rem;\n    }\n  }\n\n  .react-datepicker__portal .react-datepicker__current-month,\n  .react-datepicker__portal .react-datepicker-time__header {\n    font-size: 1.44rem;\n  }\n"])));
var templateObject_1$g;

var DatePickerWrapper = styled(DatePickerOriginal)(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  ", "\n\n  /** Componente do base de wrapper */\n  display: flex;\n  flex-flow: column;\n  position: relative;\n  /** Componente do base de wrapper */\n"], ["\n  ", "\n\n  /** Componente do base de wrapper */\n  display: flex;\n  flex-flow: column;\n  position: relative;\n  /** Componente do base de wrapper */\n"])), function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19;
    var colorProps = _a.colorProps, isStartDaySameEndDay = _a.isStartDaySameEndDay, maskInputProp = _a.maskInputProp;
    return css(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n    .react-datepicker {\n      font-family: Lato;\n      border-radius: 4px;\n      border: 1px solid ", ";\n      box-shadow: 0px 0px 4px ", ";\n      background-color: ", ";\n    }\n\n    .react-datepicker-popper {\n      z-index: ", ";\n    }\n\n    /** Display do m\u00EAs atual */\n    .react-datepicker__current-month {\n      font-family: Lato;\n      font-weight: bold;\n      font-size: 19px;\n      line-height: 23px;\n      text-align: center;\n      color: ", ";\n      &::first-letter {\n        text-transform: capitalize;\n      }\n    }\n    /** Display do m\u00EAs atual */\n\n    /**Cabe\u00E7alho */\n    .react-datepicker__header {\n      padding: 16px 12px 0 12px;\n      background-color: ", ";\n      border-bottom: none;\n    }\n    .react-datepicker__day-names {\n      margin-bottom: 0;\n    }\n    /**Cabe\u00E7alho */\n\n    /** Icones de navega\u00E7\u00E3o */\n    .react-datepicker__navigation-icon::before {\n      border-color: ", ";\n      border-style: solid;\n      border-width: 0;\n      content: '';\n      display: block;\n      position: absolute;\n      width: 0;\n      height: 0;\n    }\n\n    .react-datepicker__navigation-icon--previous::before {\n      border-top: 8px solid ", ";\n      border-bottom: 8px solid ", ";\n      border-right: 8px solid ", ";\n      transform: rotate(0);\n    }\n\n    .react-datepicker__navigation-icon--next::before {\n      border-top: 8px solid ", ";\n      border-bottom: 8px solid ", ";\n      border-left: 8px solid ", ";\n      transform: rotate(0);\n    }\n\n    .react-datepicker__navigation:hover *::before {\n      border-color: ", ";\n    }\n\n    .react-datepicker__navigation:hover {\n      .react-datepicker__navigation-icon--next::before {\n        border-left-color: ", ";\n      }\n      .react-datepicker__navigation-icon--previous::before {\n        border-right-color: ", ";\n      }\n    }\n    /** Icones de navega\u00E7\u00E3o */\n\n    /* Dias do m\u00EAs e da semana*/\n\n    .react-datepicker__day-names {\n      padding-top: 16px;\n      padding-left: 3px;\n    }\n\n    .react-datepicker__day-name {\n      font-family: Lato;\n      font-style: normal;\n      font-weight: normal;\n      font-size: 16px;\n      line-height: 19px;\n      width: 16px;\n      height: 16px;\n      margin: 0px;\n      padding: 8px;\n      color: ", ";\n      &::first-letter {\n        text-transform: capitalize;\n        color: #333333; // TODO cor n\u00E3o mapeada no base\n      }\n    }\n\n    .react-datepicker__day-name--outside-month,\n    .react-datepicker__day,\n    .react-datepicker__time-name {\n      font-family: Lato;\n      font-style: normal;\n      font-weight: normal;\n      font-size: 13px;\n      line-height: 16px;\n      width: 16px;\n      height: 16px;\n      margin: 0;\n      padding: 8px;\n      color: ", ";\n      user-select: none;\n    }\n\n    .react-datepicker__day-name--outside-month:hover,\n    .react-datepicker__day:hover,\n    .react-datepicker__time-name:hover {\n      border-radius: 0;\n      background-color: ", ";\n    }\n\n    .react-datepicker__day--keyboard-selected,\n    .react-datepicker__month-text--keyboard-selected,\n    .react-datepicker__quarter-text--keyboard-selected,\n    .react-datepicker__year-text--keyboard-selected {\n      border-radius: 100%;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        background-color: ", ";\n      }\n    }\n\n    .react-datepicker__day--in-selecting-range,\n    .react-datepicker__day--in-range,\n    .react-datepicker__month-text--in-selecting-range,\n    .react-datepicker__month-text--in-range,\n    .react-datepicker__quarter-text--in-selecting-range,\n    .react-datepicker__quarter-text--in-range,\n    .react-datepicker__year-text--in-selecting-range,\n    .react-datepicker__year-text--in-range {\n      background-color: ", ";\n      border-radius: 0;\n    }\n\n    .react-datepicker__day--selected,\n    .react-datepicker__month-text--selected,\n    .react-datepicker__quarter-text--selected,\n    .react-datepicker__year-text--selected {\n      font-family: Lato;\n      font-style: normal;\n      font-weight: normal;\n      font-size: 13px;\n      line-height: 16px;\n      width: 16px;\n      height: 16px;\n      margin: 0;\n      padding: 8px;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        border-radius: 0;\n        background-color: ", ";\n      }\n    }\n    .unique-date {\n      color: ", ";\n      background-color: ", ";\n      border-radius: 100%;\n      &:hover {\n        border-radius: 100%;\n        background-color: ", ";\n      }\n    }\n\n    .react-datepicker__day--highlighted,\n    .react-datepicker__month-text--highlighted,\n    .react-datepicker__quarter-text--highlighted,\n    .react-datepicker__year-text--highlighted {\n      position: relative;\n      border-radius: 100%;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        border-radius: 100%;\n        background-color: ", ";\n      }\n    }\n\n    .startDate {\n      position: relative;\n      border-top-left-radius: 5px;\n      border-bottom-left-radius: 5px;\n      border-top-right-radius: ", "px;\n      border-bottom-right-radius: ", "px;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        border-top-left-radius: 5px;\n        border-bottom-left-radius: 5px;\n        border-top-right-radius: ", "px;\n        border-bottom-right-radius: ", "px;\n        background-color: ", ";\n      }\n      ", "\n    }\n    .endDate {\n      position: relative;\n      border-top-left-radius: ", "px;\n      border-bottom-left-radius: ", "px;\n      border-top-right-radius: 5px;\n      border-bottom-right-radius: 5px;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        border-top-left-radius: ", "px;\n        border-bottom-left-radius: ", "px;\n        border-top-right-radius: 5px;\n        border-bottom-right-radius: 5px;\n        background-color: ", ";\n      }\n      ", "\n    }\n\n    .react-datepicker__day--outside-month {\n      color: ", ";\n      &.endDate,\n      &.startDate {\n        color: ", ";\n      }\n      &:empty {\n        height: 0;\n        overflow: hidden;\n        opacity: 0;\n        cursor: auto;\n        padding: 0 8px;\n        &:hover {\n          background-color: ", ";\n        }\n      }\n    }\n\n    .react-datepicker__day--disabled,\n    .react-datepicker__month-text--disabled,\n    .react-datepicker__quarter-text--disabled,\n    .react-datepicker__year-text--disabled {\n      background-color: ", ";\n      cursor: not-allowed;\n      color: ", ";\n      &:hover {\n        background-color: ", ";\n        color: ", ";\n      }\n    }\n\n    /* Dias do m\u00EAs e da semana*/\n\n    /*Cores do arrow */\n    .react-datepicker-popper[data-placement^='bottom']\n      .react-datepicker__triangle::before {\n      border-bottom-color: ", ";\n    }\n    .react-datepicker-popper[data-placement^='bottom']\n      .react-datepicker__triangle::after {\n      border-bottom-color: ", ";\n    }\n\n    .react-datepicker-popper[data-placement^='top']\n      .react-datepicker__triangle::before {\n      border-top-color: ", ";\n    }\n    .react-datepicker-popper[data-placement^='top']\n      .react-datepicker__triangle::after {\n      border-top-color: ", ";\n    }\n    /*Cores do arrow */\n    /** Corpo do calend\u00E1rio */\n    .react-datepicker__month-container {\n      &:nth-child(1) {\n        border-right: 1px solid red;\n      }\n    }\n    /** Corpo do calend\u00E1rio */\n\n    /** Wrapper do date picker */\n    .react-datepicker-wrapper {\n      display: flex;\n    }\n    /** Wrapper do date picker */\n\n    /**Deixar com width com 100% de espa\u00E7o */\n    .BaSe--date-picker {\n      width: 100%;\n    }\n\n    .react-datepicker__input-container {\n      > input {\n        padding-left: 12px;\n        padding-right: 12px;\n        width: calc(100% - 26px);\n        color: ", ";\n        background: ", ";\n        border: 1px solid ", ";\n        border-radius: 4px;\n        height: ", "px;\n        &:focus {\n          outline: none !important;\n          box-shadow: 0 0 4px ", ";\n          border: 1px solid ", ";\n          color: ", ";\n        }\n      }\n    }\n  "], ["\n    .react-datepicker {\n      font-family: Lato;\n      border-radius: 4px;\n      border: 1px solid ", ";\n      box-shadow: 0px 0px 4px ", ";\n      background-color: ", ";\n    }\n\n    .react-datepicker-popper {\n      z-index: ", ";\n    }\n\n    /** Display do m\u00EAs atual */\n    .react-datepicker__current-month {\n      font-family: Lato;\n      font-weight: bold;\n      font-size: 19px;\n      line-height: 23px;\n      text-align: center;\n      color: ", ";\n      &::first-letter {\n        text-transform: capitalize;\n      }\n    }\n    /** Display do m\u00EAs atual */\n\n    /**Cabe\u00E7alho */\n    .react-datepicker__header {\n      padding: 16px 12px 0 12px;\n      background-color: ", ";\n      border-bottom: none;\n    }\n    .react-datepicker__day-names {\n      margin-bottom: 0;\n    }\n    /**Cabe\u00E7alho */\n\n    /** Icones de navega\u00E7\u00E3o */\n    .react-datepicker__navigation-icon::before {\n      border-color: ", ";\n      border-style: solid;\n      border-width: 0;\n      content: '';\n      display: block;\n      position: absolute;\n      width: 0;\n      height: 0;\n    }\n\n    .react-datepicker__navigation-icon--previous::before {\n      border-top: 8px solid ", ";\n      border-bottom: 8px solid ", ";\n      border-right: 8px solid ", ";\n      transform: rotate(0);\n    }\n\n    .react-datepicker__navigation-icon--next::before {\n      border-top: 8px solid ", ";\n      border-bottom: 8px solid ", ";\n      border-left: 8px solid ", ";\n      transform: rotate(0);\n    }\n\n    .react-datepicker__navigation:hover *::before {\n      border-color: ", ";\n    }\n\n    .react-datepicker__navigation:hover {\n      .react-datepicker__navigation-icon--next::before {\n        border-left-color: ", ";\n      }\n      .react-datepicker__navigation-icon--previous::before {\n        border-right-color: ", ";\n      }\n    }\n    /** Icones de navega\u00E7\u00E3o */\n\n    /* Dias do m\u00EAs e da semana*/\n\n    .react-datepicker__day-names {\n      padding-top: 16px;\n      padding-left: 3px;\n    }\n\n    .react-datepicker__day-name {\n      font-family: Lato;\n      font-style: normal;\n      font-weight: normal;\n      font-size: 16px;\n      line-height: 19px;\n      width: 16px;\n      height: 16px;\n      margin: 0px;\n      padding: 8px;\n      color: ", ";\n      &::first-letter {\n        text-transform: capitalize;\n        color: #333333; // TODO cor n\u00E3o mapeada no base\n      }\n    }\n\n    .react-datepicker__day-name--outside-month,\n    .react-datepicker__day,\n    .react-datepicker__time-name {\n      font-family: Lato;\n      font-style: normal;\n      font-weight: normal;\n      font-size: 13px;\n      line-height: 16px;\n      width: 16px;\n      height: 16px;\n      margin: 0;\n      padding: 8px;\n      color: ", ";\n      user-select: none;\n    }\n\n    .react-datepicker__day-name--outside-month:hover,\n    .react-datepicker__day:hover,\n    .react-datepicker__time-name:hover {\n      border-radius: 0;\n      background-color: ", ";\n    }\n\n    .react-datepicker__day--keyboard-selected,\n    .react-datepicker__month-text--keyboard-selected,\n    .react-datepicker__quarter-text--keyboard-selected,\n    .react-datepicker__year-text--keyboard-selected {\n      border-radius: 100%;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        background-color: ", ";\n      }\n    }\n\n    .react-datepicker__day--in-selecting-range,\n    .react-datepicker__day--in-range,\n    .react-datepicker__month-text--in-selecting-range,\n    .react-datepicker__month-text--in-range,\n    .react-datepicker__quarter-text--in-selecting-range,\n    .react-datepicker__quarter-text--in-range,\n    .react-datepicker__year-text--in-selecting-range,\n    .react-datepicker__year-text--in-range {\n      background-color: ", ";\n      border-radius: 0;\n    }\n\n    .react-datepicker__day--selected,\n    .react-datepicker__month-text--selected,\n    .react-datepicker__quarter-text--selected,\n    .react-datepicker__year-text--selected {\n      font-family: Lato;\n      font-style: normal;\n      font-weight: normal;\n      font-size: 13px;\n      line-height: 16px;\n      width: 16px;\n      height: 16px;\n      margin: 0;\n      padding: 8px;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        border-radius: 0;\n        background-color: ", ";\n      }\n    }\n    .unique-date {\n      color: ", ";\n      background-color: ", ";\n      border-radius: 100%;\n      &:hover {\n        border-radius: 100%;\n        background-color: ", ";\n      }\n    }\n\n    .react-datepicker__day--highlighted,\n    .react-datepicker__month-text--highlighted,\n    .react-datepicker__quarter-text--highlighted,\n    .react-datepicker__year-text--highlighted {\n      position: relative;\n      border-radius: 100%;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        border-radius: 100%;\n        background-color: ", ";\n      }\n    }\n\n    .startDate {\n      position: relative;\n      border-top-left-radius: 5px;\n      border-bottom-left-radius: 5px;\n      border-top-right-radius: ", "px;\n      border-bottom-right-radius: ", "px;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        border-top-left-radius: 5px;\n        border-bottom-left-radius: 5px;\n        border-top-right-radius: ", "px;\n        border-bottom-right-radius: ", "px;\n        background-color: ", ";\n      }\n      ", "\n    }\n    .endDate {\n      position: relative;\n      border-top-left-radius: ", "px;\n      border-bottom-left-radius: ", "px;\n      border-top-right-radius: 5px;\n      border-bottom-right-radius: 5px;\n      color: ", ";\n      background-color: ", ";\n      &:hover {\n        border-top-left-radius: ", "px;\n        border-bottom-left-radius: ", "px;\n        border-top-right-radius: 5px;\n        border-bottom-right-radius: 5px;\n        background-color: ", ";\n      }\n      ", "\n    }\n\n    .react-datepicker__day--outside-month {\n      color: ", ";\n      &.endDate,\n      &.startDate {\n        color: ", ";\n      }\n      &:empty {\n        height: 0;\n        overflow: hidden;\n        opacity: 0;\n        cursor: auto;\n        padding: 0 8px;\n        &:hover {\n          background-color: ", ";\n        }\n      }\n    }\n\n    .react-datepicker__day--disabled,\n    .react-datepicker__month-text--disabled,\n    .react-datepicker__quarter-text--disabled,\n    .react-datepicker__year-text--disabled {\n      background-color: ", ";\n      cursor: not-allowed;\n      color: ", ";\n      &:hover {\n        background-color: ", ";\n        color: ", ";\n      }\n    }\n\n    /* Dias do m\u00EAs e da semana*/\n\n    /*Cores do arrow */\n    .react-datepicker-popper[data-placement^='bottom']\n      .react-datepicker__triangle::before {\n      border-bottom-color: ", ";\n    }\n    .react-datepicker-popper[data-placement^='bottom']\n      .react-datepicker__triangle::after {\n      border-bottom-color: ", ";\n    }\n\n    .react-datepicker-popper[data-placement^='top']\n      .react-datepicker__triangle::before {\n      border-top-color: ", ";\n    }\n    .react-datepicker-popper[data-placement^='top']\n      .react-datepicker__triangle::after {\n      border-top-color: ", ";\n    }\n    /*Cores do arrow */\n    /** Corpo do calend\u00E1rio */\n    .react-datepicker__month-container {\n      &:nth-child(1) {\n        border-right: 1px solid red;\n      }\n    }\n    /** Corpo do calend\u00E1rio */\n\n    /** Wrapper do date picker */\n    .react-datepicker-wrapper {\n      display: flex;\n    }\n    /** Wrapper do date picker */\n\n    /**Deixar com width com 100% de espa\u00E7o */\n    .BaSe--date-picker {\n      width: 100%;\n    }\n\n    .react-datepicker__input-container {\n      > input {\n        padding-left: 12px;\n        padding-right: 12px;\n        width: calc(100% - 26px);\n        color: ", ";\n        background: ", ";\n        border: 1px solid ", ";\n        border-radius: 4px;\n        height: ", "px;\n        &:focus {\n          outline: none !important;\n          box-shadow: 0 0 4px ", ";\n          border: 1px solid ", ";\n          color: ", ";\n        }\n      }\n    }\n  "])), (_b = colorProps === null || colorProps === void 0 ? void 0 : colorProps.containerCardProps) === null || _b === void 0 ? void 0 : _b.borderColor, (_c = colorProps === null || colorProps === void 0 ? void 0 : colorProps.containerCardProps) === null || _c === void 0 ? void 0 : _c.borderColor, (_d = colorProps === null || colorProps === void 0 ? void 0 : colorProps.containerCardProps) === null || _d === void 0 ? void 0 : _d.color, BaSeTheme.stackOrder.overlay, (_e = colorProps === null || colorProps === void 0 ? void 0 : colorProps.titleProps) === null || _e === void 0 ? void 0 : _e.color, (_f = colorProps === null || colorProps === void 0 ? void 0 : colorProps.headerProps) === null || _f === void 0 ? void 0 : _f.color, BaSeTheme.colors.defaultColors.transparent, BaSeTheme.colors.defaultColors.transparent, BaSeTheme.colors.defaultColors.transparent, (_g = colorProps === null || colorProps === void 0 ? void 0 : colorProps.arrowProps) === null || _g === void 0 ? void 0 : _g.color, BaSeTheme.colors.defaultColors.transparent, BaSeTheme.colors.defaultColors.transparent, (_h = colorProps === null || colorProps === void 0 ? void 0 : colorProps.arrowProps) === null || _h === void 0 ? void 0 : _h.color, BaSeTheme.colors.defaultColors.transparent, (_j = colorProps === null || colorProps === void 0 ? void 0 : colorProps.arrowProps) === null || _j === void 0 ? void 0 : _j.hoverColor, (_k = colorProps === null || colorProps === void 0 ? void 0 : colorProps.arrowProps) === null || _k === void 0 ? void 0 : _k.hoverColor, (_l = colorProps === null || colorProps === void 0 ? void 0 : colorProps.headerProps) === null || _l === void 0 ? void 0 : _l.color, (_m = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _m === void 0 ? void 0 : _m.color, (_o = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _o === void 0 ? void 0 : _o.hoverColor, (_p = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _p === void 0 ? void 0 : _p.color, (_q = colorProps === null || colorProps === void 0 ? void 0 : colorProps.containerCardProps) === null || _q === void 0 ? void 0 : _q.color, (_r = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _r === void 0 ? void 0 : _r.hoverColor, (_s = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _s === void 0 ? void 0 : _s.hoverColor, (_t = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _t === void 0 ? void 0 : _t.color, (_u = colorProps === null || colorProps === void 0 ? void 0 : colorProps.containerCardProps) === null || _u === void 0 ? void 0 : _u.color, (_v = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _v === void 0 ? void 0 : _v.hoverColor, (_w = BaSeTheme.colors.defaultColors) === null || _w === void 0 ? void 0 : _w.white, (_x = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _x === void 0 ? void 0 : _x.focusColor, (_y = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _y === void 0 ? void 0 : _y.focusColor, (_z = BaSeTheme.colors.defaultColors) === null || _z === void 0 ? void 0 : _z.white, (_0 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _0 === void 0 ? void 0 : _0.focusColor, (_1 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _1 === void 0 ? void 0 : _1.focusColor, isStartDaySameEndDay ? 5 : 1.5, isStartDaySameEndDay ? 5 : 1.5, (_2 = BaSeTheme.colors.defaultColors) === null || _2 === void 0 ? void 0 : _2.white, (_3 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _3 === void 0 ? void 0 : _3.focusColor, isStartDaySameEndDay ? 5 : 1.5, isStartDaySameEndDay ? 5 : 1.5, (_4 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _4 === void 0 ? void 0 : _4.focusColor, !isStartDaySameEndDay && css(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n        &::after {\n          content: '';\n          position: absolute;\n          border-left: 6px solid ", ";\n          border-top: 16px solid ", ";\n          border-bottom: 16px solid\n            ", ";\n          left: 98%;\n          top: 0;\n          border-radius: 6px;\n        }\n      "], ["\n        &::after {\n          content: '';\n          position: absolute;\n          border-left: 6px solid ", ";\n          border-top: 16px solid ", ";\n          border-bottom: 16px solid\n            ", ";\n          left: 98%;\n          top: 0;\n          border-radius: 6px;\n        }\n      "])), (_5 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _5 === void 0 ? void 0 : _5.focusColor, (_6 = BaSeTheme.colors.defaultColors) === null || _6 === void 0 ? void 0 : _6.transparent, (_7 = BaSeTheme.colors.defaultColors) === null || _7 === void 0 ? void 0 : _7.transparent), isStartDaySameEndDay ? 5 : 1.5, isStartDaySameEndDay ? 5 : 1.5, (_8 = BaSeTheme.colors.defaultColors) === null || _8 === void 0 ? void 0 : _8.white, (_9 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _9 === void 0 ? void 0 : _9.focusColor, isStartDaySameEndDay ? 5 : 1.5, isStartDaySameEndDay ? 5 : 1.5, (_10 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _10 === void 0 ? void 0 : _10.focusColor, !isStartDaySameEndDay && css(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n        &::before {\n          content: '';\n          position: absolute;\n          border-right: 6px solid ", ";\n          border-top: 16px solid ", ";\n          border-bottom: 16px solid\n            ", ";\n          right: 98%;\n          top: 0;\n          border-radius: 6px;\n        }\n      "], ["\n        &::before {\n          content: '';\n          position: absolute;\n          border-right: 6px solid ", ";\n          border-top: 16px solid ", ";\n          border-bottom: 16px solid\n            ", ";\n          right: 98%;\n          top: 0;\n          border-radius: 6px;\n        }\n      "])), (_11 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.daysText) === null || _11 === void 0 ? void 0 : _11.focusColor, (_12 = BaSeTheme.colors.defaultColors) === null || _12 === void 0 ? void 0 : _12.transparent, (_13 = BaSeTheme.colors.defaultColors) === null || _13 === void 0 ? void 0 : _13.transparent), (_14 = ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.grayScale) === null || _14 === void 0 ? void 0 : _14.focus.defaultLight, BaSeTheme.colors.defaultColors.white, (_15 = BaSeTheme.colors.defaultColors) === null || _15 === void 0 ? void 0 : _15.transparent, ColorMapper.grayScale.hover.defaultLight, ColorMapper.grayScale.foreground, ColorMapper.grayScale.hover.defaultLight, ColorMapper.grayScale.foreground, (_16 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.containerCardProps) === null || _16 === void 0 ? void 0 : _16.borderColor, (_17 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.containerCardProps) === null || _17 === void 0 ? void 0 : _17.color, (_18 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.containerCardProps) === null || _18 === void 0 ? void 0 : _18.borderColor, (_19 = colorProps === null || colorProps === void 0 ? void 0 : colorProps.containerCardProps) === null || _19 === void 0 ? void 0 : _19.color, maskInputProp === null || maskInputProp === void 0 ? void 0 : maskInputProp.color, maskInputProp === null || maskInputProp === void 0 ? void 0 : maskInputProp.backgroundColor, maskInputProp === null || maskInputProp === void 0 ? void 0 : maskInputProp.borderColor, maskInputProp === null || maskInputProp === void 0 ? void 0 : maskInputProp.size, maskInputProp === null || maskInputProp === void 0 ? void 0 : maskInputProp.boxShadowFocus, maskInputProp === null || maskInputProp === void 0 ? void 0 : maskInputProp.focusBorderColor, maskInputProp === null || maskInputProp === void 0 ? void 0 : maskInputProp.focusTextColor);
});
var DatePickerCalendarContainer = styled.div(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var width = _a.width, top = _a.top;
    return css(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n    position: absolute;\n    right: 12px;\n    top: ", "px;\n    bottom: 0;\n    width: ", "px;\n    z-index: ", ";\n  "], ["\n    position: absolute;\n    right: 12px;\n    top: ", "px;\n    bottom: 0;\n    width: ", "px;\n    z-index: ", ";\n  "])), top, width, BaSeTheme.stackOrder.aboveNormal);
});
var templateObject_1$f, templateObject_2$c, templateObject_3$8, templateObject_4$7, templateObject_5$5, templateObject_6$4;

var handleDateFalsy = function (date) { return !!date; };
var addLeftZero = function (num) {
    if (!num) {
        return '';
    }
    var stringNum = num + '';
    return (stringNum === null || stringNum === void 0 ? void 0 : stringNum.length) === 1 ? '0' + stringNum : stringNum;
};
var yearMode = function (year, isFullYear) {
    if (isFullYear === void 0) { isFullYear = true; }
    return !year
        ? ''
        : isFullYear
            ? year.getUTCFullYear()
            : year.getFullYear().toString().substr(2, 4);
};
var localDateFormate = {
    en: function (date, props) {
        var _a;
        return handleDateFalsy(date)
            ? "".concat(addLeftZero(((_a = date === null || date === void 0 ? void 0 : date.getUTCMonth()) !== null && _a !== void 0 ? _a : -1) + 1), "/").concat(addLeftZero(date === null || date === void 0 ? void 0 : date.getUTCDate()), "/").concat(yearMode(date, props === null || props === void 0 ? void 0 : props.fullYear))
            : '';
    },
    'pt-BR': function (date, props) {
        var _a;
        return handleDateFalsy(date)
            ? "".concat(addLeftZero(date === null || date === void 0 ? void 0 : date.getUTCDate()), "/").concat(addLeftZero(((_a = date === null || date === void 0 ? void 0 : date.getUTCMonth()) !== null && _a !== void 0 ? _a : -1) + 1), "/").concat(yearMode(date, props === null || props === void 0 ? void 0 : props.fullYear))
            : '';
    },
};
var localeMapFormat = {
    en: 'MM/dd/yyyy',
    'pt-BR': 'dd/MM/yyyy',
};

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

var DatePickerColorMapper = {
    titleProps: {
        color: ColorMapper.grayScale.hover.defaultDark,
    },
    headerProps: {
        color: BaSeTheme.colors.defaultColors.white, // Adaptar para themeMode dark
    },
    arrowProps: {
        color: ColorMapper.default.foreground,
        hoverColor: ColorMapper.default.hover.defaultDark,
    },
    containerCardProps: {
        color: BaSeTheme.colors.defaultColors.white,
        borderColor: ColorMapper.default.focus.defaultLight,
    },
    daysText: {
        color: ColorMapper.default.getColorByNumber(20),
        hoverColor: ColorMapper === null || ColorMapper === void 0 ? void 0 : ColorMapper.default.hover.defaultLight,
        focusColor: ColorMapper.default.foreground,
    },
};
var DatePickerColorManager = function (color, inputStatus) {
    var statusMapper = {
        normal: 'default',
        invalid: 'destructive',
        valid: 'confirmation',
    };
    var statusColor;
    if (inputStatus && inputStatus in statusMapper && inputStatus !== 'normal') {
        statusColor = statusMapper[inputStatus];
    }
    if (statusColor) {
        return __assign(__assign({}, DatePickerColorMapper), { arrowProps: __assign(__assign({}, DatePickerColorMapper === null || DatePickerColorMapper === void 0 ? void 0 : DatePickerColorMapper.arrowProps), { color: ColorMapper[statusColor].foreground, hoverColor: ColorMapper[statusColor].hover.defaultDark }), containerCardProps: __assign(__assign({}, DatePickerColorMapper.containerCardProps), { borderColor: ColorMapper[statusColor].focus.defaultLight }), daysText: __assign(__assign({}, DatePickerColorMapper.daysText), { color: ColorMapper[statusColor].getColorByNumber(20), hoverColor: ColorMapper[statusColor].hover.defaultLight, focusColor: ColorMapper[statusColor].foreground }), statusColor: ColorMapper[statusColor].foreground });
    }
    if (!color) {
        return __assign({}, DatePickerColorMapper);
    }
    if (ColorMapper.isValidType(color)) {
        return __assign(__assign({}, DatePickerColorMapper), { arrowProps: __assign(__assign({}, DatePickerColorMapper === null || DatePickerColorMapper === void 0 ? void 0 : DatePickerColorMapper.arrowProps), { color: ColorMapper[color].foreground, hoverColor: ColorMapper[color].hover.defaultDark }), containerCardProps: __assign(__assign({}, DatePickerColorMapper.containerCardProps), { borderColor: ColorMapper[color].focus.defaultLight }), daysText: __assign(__assign({}, DatePickerColorMapper.daysText), { color: ColorMapper[color].getColorByNumber(20), hoverColor: ColorMapper[color].hover.defaultLight, focusColor: ColorMapper[color].foreground }) });
    }
    if (!Color.validateColor(color)) {
        return __assign({}, DatePickerColorMapper);
    }
    return __assign(__assign({}, DatePickerColorMapper), { arrowProps: __assign(__assign({}, DatePickerColorMapper === null || DatePickerColorMapper === void 0 ? void 0 : DatePickerColorMapper.arrowProps), { color: color, hoverColor: ColorMapper.dark.hover.create(color) }), containerCardProps: __assign(__assign({}, DatePickerColorMapper.containerCardProps), { borderColor: ColorMapper.light.focus.create(color) }), daysText: __assign(__assign({}, DatePickerColorMapper.daysText), { color: ColorMapper.create(color, 0.2), hoverColor: ColorMapper.light.hover.create(color), focusColor: color }) });
};
var maskSizeMap = {
    small: 28,
    medium: 36,
    big: 44,
};
var MaskDatePickerSize = function (optionalSize) {
    return maskSizeMap[!optionalSize || !(optionalSize in maskSizeMap) ? 'medium' : optionalSize];
};

var idSequence = idGenerator();
var BaSeDatePicker = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate, closeOnScroll = _a.closeOnScroll, multipleMonths = _a.multipleMonths, selectRange = _a.selectRange, color = _a.color, inputStatus = _a.inputStatus, size = _a.size, isDisabled = _a.isDisabled, maxDate = _a.maxDate, minDate = _a.minDate, placeholder = _a.placeholder, label = _a.label, subLabel = _a.subLabel, showHelpButton = _a.showHelpButton, helpButtonProps = _a.helpButtonProps, hascomplement = _a.hascomplement, moreInfoLabel = _a.moreInfoLabel, moreInfoDetails = _a.moreInfoDetails, complement = _a.complement, onFocus = _a.onFocus, onBlur = _a.onBlur, onSelect = _a.onSelect, onCalendarOpen = _a.onCalendarOpen, onCalendarClose = _a.onCalendarClose, onStartDateChange = _a.onStartDateChange, onEndDateChange = _a.onEndDateChange;
    var id = getNextHash(idSequence);
    var _b = React.useState(''), inputDate = _b[0], setInputDate = _b[1];
    var _c = React.useState(false), reg = _c[0], setReg = _c[1];
    var _d = React.useContext(BaSeI18nContext), locale = _d.locale, registerDateLocale = _d.registerDateLocale;
    var _e = React.useState(), labelHeight = _e[0], setLabelHeight = _e[1];
    var getColors = React.useCallback(function () {
        return DatePickerColorManager(color, inputStatus);
    }, [color, inputStatus]);
    var _f = React.useState(false), hasFocus = _f[0], setHasFocus = _f[1];
    var handleCalendarClose = React.useCallback(function () {
        onCalendarClose === null || onCalendarClose === void 0 ? void 0 : onCalendarClose();
        setHasFocus(false);
    }, [onCalendarClose]);
    var handleSelection = React.useCallback(function (e) {
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(e);
        setHasFocus(false);
    }, [onSelect]);
    var handleFocus = React.useCallback(function (e) {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
        setHasFocus(true);
    }, [onFocus]);
    var handleBlur = React.useCallback(function (e) {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        setHasFocus(false);
    }, [onBlur]);
    var handleChange = function (dates) {
        if (!dates) {
            return;
        }
        var _a = dates, start = _a[0], end = _a[1];
        if (start || end) {
            onStartDateChange === null || onStartDateChange === void 0 ? void 0 : onStartDateChange(start);
            onEndDateChange === null || onEndDateChange === void 0 ? void 0 : onEndDateChange(end);
        }
        else {
            onStartDateChange === null || onStartDateChange === void 0 ? void 0 : onStartDateChange(dates);
        }
    };
    var showSelected = React.useCallback(function () { return (multipleMonths ? endDate !== null && endDate !== void 0 ? endDate : startDate : startDate); }, [multipleMonths, startDate, endDate]);
    var showHighlightedDates = React.useCallback(function () {
        if (!selectRange) {
            return [{ 'unique-date': [startDate !== null && startDate !== void 0 ? startDate : new Date()] }];
        }
        var datesToHighlight = [];
        if (endDate) {
            datesToHighlight.push({ endDate: [endDate] });
        }
        datesToHighlight.push({ startDate: [startDate !== null && startDate !== void 0 ? startDate : new Date()] });
        return datesToHighlight;
    }, [selectRange, startDate, endDate]);
    var compareStarEndDates = React.useCallback(function () {
        return !!startDate && !!endDate ? isEqual(startDate, endDate) : false;
    }, [startDate, endDate]);
    var getMaskSize = React.useCallback(function () { return MaskDatePickerSize(size); }, [size]);
    var getValidStatus = React.useCallback(function () {
        var inputStatusTypes = {
            normal: 'normal',
            valid: 'valid',
            invalid: 'invalid',
        };
        return isDisabled
            ? 'disabled'
            : !inputStatus || !(inputStatus in inputStatusTypes)
                ? 'normal'
                : inputStatusTypes[inputStatus];
    }, [inputStatus, isDisabled]);
    var hasInfoLabel = React.useCallback(function () { return !!label || !!subLabel || !!showHelpButton; }, [label, subLabel, showHelpButton]);
    var getIconTopCoordinates = React.useCallback(function () {
        var _a;
        var parentHeight;
        if (labelHeight) {
            parentHeight = labelHeight;
        }
        var sizes = {
            small: 23,
            default: 24.4,
        };
        var aditionalSize = hasInfoLabel()
            ? (_a = sizes[size !== null && size !== void 0 ? size : 'default']) !== null && _a !== void 0 ? _a : sizes.default
            : 0;
        if (parentHeight) {
            return parentHeight + (size === 'small' ? 8 : 12);
        }
        return aditionalSize + (size === 'small' ? 8 : 12);
    }, [size, labelHeight]);
    var getSize = React.useCallback(function () { return (size === 'big' ? 24 : 16); }, [size]);
    var getIconColor = React.useCallback(function () {
        var _a;
        return (_a = inputColorManager(color)[getValidStatus()]) === null || _a === void 0 ? void 0 : _a[hasFocus ? 'focusTextColor' : 'color'];
    }, [hasFocus, color]);
    var getIconName = React.useCallback(function () {
        var _a;
        var iconsNameMap = {
            valid: 'check',
            invalid: 'exclamation-circle-solid',
            default: 'calendar-alt',
        };
        return (_a = iconsNameMap[inputStatus !== null && inputStatus !== void 0 ? inputStatus : 'default']) !== null && _a !== void 0 ? _a : iconsNameMap.default;
    }, [inputStatus]);
    React.useEffect(function () {
        setInputDate(function () {
            var _a, _b;
            return ((_a = localDateFormate[locale]) === null || _a === void 0 ? void 0 : _a.call(localDateFormate, startDate)) +
                "".concat(endDate ? ' - ' + ((_b = localDateFormate[locale]) === null || _b === void 0 ? void 0 : _b.call(localDateFormate, endDate)) : '');
        });
        if (startDate && endDate && isAfter(startDate, endDate)) {
            onEndDateChange === null || onEndDateChange === void 0 ? void 0 : onEndDateChange(undefined);
        }
    }, [startDate, endDate]);
    React.useEffect(function () {
        registerDateLocale === null || registerDateLocale === void 0 ? void 0 : registerDateLocale(locale);
        var timeout = setTimeout(function () { return setReg(true); }, 0);
        return function () { return clearTimeout(timeout); };
    }, [registerDateLocale, locale]);
    return (React.createElement(DatePickerWrapper, { isStartDaySameEndDay: compareStarEndDates(), colorProps: getColors(), maskInputProp: __assign({ size: getMaskSize() }, inputColorManager(color)[getValidStatus()]) },
        React.createElement(DatePickerCalendarContainer, { top: getIconTopCoordinates(), width: getSize() },
            React.createElement(BaSeIcon, { size: getSize(), name: getIconName(), description: "BaSe--date-picker-icon", color: getIconColor() })),
        React.createElement(BaSeFormLabel, { id: id, label: label, subLabel: subLabel, showHelpButton: showHelpButton, helpButtonProps: helpButtonProps, getContainerHeight: function (value) { return setLabelHeight(value); } }),
        reg && (React.createElement(DatePicker, { id: id, onCalendarOpen: onCalendarOpen, onCalendarClose: handleCalendarClose, selected: showSelected(), onChange: handleChange, onSelect: handleSelection, locale: locale, closeOnScroll: closeOnScroll, customInput: selectRange ? (React.createElement(BaSeInput, { size: size, isReadOnly: true, value: inputDate })) : (React.createElement(InputMask, { mask: "99/99/9999" })), monthsShown: +!!multipleMonths + 1, startDate: startDate, endDate: endDate, selectsRange: selectRange, highlightDates: showHighlightedDates(), dropdownMode: "select", dateFormat: localeMapFormat[locale], wrapperClassName: "BaSe--date-picker", popperPlacement: "auto", disabled: isDisabled, maxDate: maxDate, minDate: minDate, placeholderText: placeholder, onFocus: handleFocus, onBlur: handleBlur })),
        hascomplement && (React.createElement(WrapperHelper$2, null,
            React.createElement(BaSeHelperText, { isItalic: true, color: color, label: complement !== null && complement !== void 0 ? complement : '' }))),
        !!moreInfoLabel && (React.createElement(MoreInfoContainer$3, null,
            React.createElement(BaSeHelperText, { size: "small", label: moreInfoLabel, details: moreInfoDetails })))));
};

var StyledAvatar = styled.img.attrs({
    className: 'BaSe--avatar BaSe--avatar-image',
})(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n"], ["\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n"])));
var StyledSpan = styled.span.attrs({
    className: 'BaSe--avatar BaSe--avatar-nameAbbreviation',
})(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n"], ["\n  color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n"])), function (props) { return props.iconColor; }, function (props) { return props.iconSize; }, function (props) { return (props.isBoldIcon ? 'bold' : 'normal'); });
var templateObject_1$e, templateObject_2$b;

function getAvatar(avatarUrl, keycloak, userId) {
    var _a, _b;
    if (userId === void 0) { userId = ''; }
    return "".concat(urlSanitizer(avatarUrl), "/").concat((_b = (keycloak ? (_a = keycloak.tokenParsed) === null || _a === void 0 ? void 0 : _a.sub : userId)) !== null && _b !== void 0 ? _b : 'O.o');
}

var BaSeAvatar = function (_a) {
    var _b, _c, _d, _e, _f;
    var imageSrc = _a.imageSrc, keycloak = _a.keycloak, userId = _a.userId, userName = _a.userName, avatarUrl = _a.avatarUrl, _g = _a.iconColor, iconColor = _g === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _g, _h = _a.iconSize, iconSize = _h === void 0 ? 16 : _h, _j = _a.isBoldIcon, isBoldIcon = _j === void 0 ? false : _j, _k = _a.onErrorLoading, onErrorLoading = _k === void 0 ? function () { } : _k, _l = _a.onLoadSuccess, onLoadSuccess = _l === void 0 ? function () { } : _l;
    var _m = React.useState(true), hasAvatar = _m[0], setHasAvatar = _m[1];
    if (keycloak) {
        avatarUrl =
            (_c = (_b = BaSeConfig.ameiConfig) === null || _b === void 0 ? void 0 : _b[keycloak.authServerUrl]) === null || _c === void 0 ? void 0 : _c.avatarUrl;
        userId = (_d = keycloak.tokenParsed) === null || _d === void 0 ? void 0 : _d.sub;
        userName = (_f = (_e = keycloak.tokenParsed) === null || _e === void 0 ? void 0 : _e['name']) !== null && _f !== void 0 ? _f : '';
    }
    if (!userName) {
        throw Error('Nome é obrigatório');
    }
    if (hasAvatar) {
        return (React.createElement(StyledAvatar, { loading: "lazy", alt: "Imagem da pessoa com o nome ".concat(userName), key: userId, src: imageSrc
                ? imageSrc
                : "".concat(getAvatar(avatarUrl, keycloak, userId)), onLoad: function () { return onLoadSuccess(); }, onError: function () {
                setHasAvatar(false);
                onErrorLoading();
            } }));
    }
    return (React.createElement(StyledSpan, { isBoldIcon: isBoldIcon, "aria-hidden": true, iconColor: iconColor, iconSize: iconSize }, nameAbbreviation(userName)));
};
BaSeAvatar.displayName = 'BaSeAvatar';

var BaSeEmoticon = function (_a) {
    var name = _a.name, description = _a.description;
    return (React.createElement(BaSeStaticAsset, { description: description, path: "images/emoticons/".concat(name, ".svg") }));
};
BaSeEmoticon.displayName = 'BaSeEmoticon';

var BaSeImageFlag = function (_a) {
    var name = _a.name, description = _a.description;
    return (React.createElement(BaSeStaticAsset, { description: description, path: "images/flags/".concat(name, ".svg") }));
};
BaSeImageFlag.displayName = 'BaSeImageFlag';

var BaSeImageMap = function (_a) {
    var name = _a.name, description = _a.description;
    return (React.createElement(BaSeStaticAsset, { description: description, path: "images/maps/".concat(name, ".svg") }));
};
BaSeImageMap.displayName = 'BaSeImageMap';

var BaSeLogoSebraeRestrict = function (_a) {
    var onClick = _a.onClick, _b = _a.width, width = _b === void 0 ? 'auto' : _b, _c = _a.easterEgg, easterEgg = _c === void 0 ? false : _c;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(BaSeStaticAsset, { description: getMessage('logo.description'), path: getLogoPath(easterEgg, 'images/logos/sebrae_logo-restrict'), onClick: onClick, width: numberWithUnit(width) }));
};
BaSeLogoSebraeRestrict.displayName = 'BaSeLogoSebraeRestrict';

var BaSeLogoSebraeRestrictInverse = function (_a) {
    var onClick = _a.onClick, _b = _a.width, width = _b === void 0 ? 'auto' : _b, _c = _a.easterEgg, easterEgg = _c === void 0 ? false : _c;
    return (React.createElement(BaSeStaticAsset, { description: "Logotipo do Sebrae", path: getLogoPath(easterEgg, 'images/logos/sebrae_logo-restrict-inverse'), onClick: onClick, width: numberWithUnit(width) }));
};
BaSeLogoSebraeRestrictInverse.displayName = 'BaSeLogoSebraeRestrictInverse';

var BaSeIllustration = function (_a) {
    var name = _a.name, description = _a.description, width = _a.width, height = _a.height, color = _a.color, colorTransition = _a.colorTransition, _b = _a.colorSchema, colorSchema = _b === void 0 ? 'mono' : _b, onClick = _a.onClick;
    if (colorSchema === 'multi') {
        throw Error('[BaSeIllustration] "colowSchema = multi" ainda não implementado');
    }
    return (React.createElement(BaSeStaticAsset, { width: width ? numberWithUnit(width) : undefined, height: height ? numberWithUnit(height) : undefined, description: description, path: "images/illustrations/static/".concat(colorSchema, "-color/").concat(name, ".svg"), color: color, colorTransition: colorTransition, onClick: onClick }));
};
BaSeIllustration.displayName = 'BaSeIllustration';

var diameterBaseRadius = 24;
var checkNumber = function (num) {
    return typeof num === 'number';
};
var handleFloor = function (num) {
    num = num < 0 ? 0 : num > 100 ? 100 : num;
    return Math.floor(num);
};
var BaSeLoading = function (_a) {
    var _b = _a.text, text = _b === void 0 ? 'Carregando…' : _b, textColor = _a.textColor, spinnerColor = _a.spinnerColor, progress = _a.progress, _c = _a.lightMode, lightMode = _c === void 0 ? 'default' : _c, _d = _a.shadowLevel, shadowLevel = _d === void 0 ? 0 : _d, backgroundColor = _a.backgroundColor, spinnerSize = _a.spinnerSize, roundedCorner = _a.roundedCorner;
    var _e = React.useState({}), accessibility = _e[0], setAcessibility = _e[1];
    var handleColor = function () {
        if (textColor) {
            return textColor;
        }
        return lightMode === 'default'
            ? BaSeTheme.colors.institucionais.azulSebrae
            : BaSeTheme.colors.defaultColors.white;
    };
    var handleShadow = function () {
        if (!shadowLevel || shadowLevel < 0) {
            return 'none;';
        }
        var options = [2, 4, 8, 16, 32, 64];
        var filtered = options.find(function (opt) { return opt === shadowLevel; });
        if (filtered) {
            return BaSeTheme.shadows['profundidade' + filtered];
        }
        else {
            var index = -1;
            var space = 99;
            // tslint:disable-next-line: prefer-for-of
            for (var i = 0; i < options.length; i++) {
                if (space >= Math.abs(shadowLevel - options[i])) {
                    index = i;
                    space = Math.abs(shadowLevel - options[i]);
                }
            }
            return BaSeTheme.shadows['profundidade' + options[index]];
        }
    };
    React.useEffect(function () {
        if (checkNumber(progress)) {
            setAcessibility({
                'aria-valuenow': handleFloor(progress !== null && progress !== void 0 ? progress : 0),
                'aria-valuemin': 0,
                'aria-valuemax': 100,
            });
        }
    }, [progress]);
    return (React.createElement(LoadingContainer, { className: "BaSe--loading", roundedCorner: roundedCorner, shadow: handleShadow(), backgroundColor: backgroundColor },
        React.createElement(LoadingItems, __assign({ role: checkNumber(progress) ? 'slider' : 'presentation' }, accessibility),
            React.createElement(BaSeLoadingSpinner, { color: spinnerColor, type: lightMode === 'default' ? 'tertiary' : 'primary', description: false, diameter: spinnerSize !== null && spinnerSize !== void 0 ? spinnerSize : diameterBaseRadius }),
            React.createElement(BaSeHeading5, { color: handleColor() },
                text,
                " ",
                checkNumber(progress) && "(".concat(handleFloor(progress !== null && progress !== void 0 ? progress : 0), "%)")))));
};
BaSeLoading.displayName = 'BaSeLoading';

var BadgeValues = styled.div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  min-width: 18px;\n  width: fit-content;\n  box-sizing: border-box;\n  display: flex;\n  padding: 4px;\n  border-radius: 100px;\n  border: 2px solid ", ";\n  font-size: 8px;\n  height: 18px;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n  background-color: ", ";\n  position: relative;\n  top: ", ";\n  bottom: ", ";\n  left: ", ";\n  right: ", ";\n"], ["\n  min-width: 18px;\n  width: fit-content;\n  box-sizing: border-box;\n  display: flex;\n  padding: 4px;\n  border-radius: 100px;\n  border: 2px solid ", ";\n  font-size: 8px;\n  height: 18px;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n  background-color: ", ";\n  position: relative;\n  top: ", ";\n  bottom: ", ";\n  left: ", ";\n  right: ", ";\n"])), function (_a) {
    var border = _a.border;
    return border;
}, function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var bgC = _a.bgC;
    return bgC;
}, function (_a) {
    var top = _a.top;
    return numberWithUnit(top);
}, function (_a) {
    var bottom = _a.bottom;
    return numberWithUnit(bottom);
}, function (_a) {
    var left = _a.left;
    return numberWithUnit(left);
}, function (_a) {
    var right = _a.right;
    return numberWithUnit(right);
});
var BadgeContainer = styled.div(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var templateObject_1$d, templateObject_2$a;

var mapBadgeValues = function (color) {
    color = !color ? 'default' : color;
    var colorIsMapped = color === BaSeTheme.components.button.colors.default ||
        color === BaSeTheme.components.button.colors.destructive ||
        color === BaSeTheme.components.button.colors.attention ||
        color === BaSeTheme.components.button.colors.confirmation;
    // color === BaSeTheme.components.button.colors.negative;
    if (colorIsMapped) {
        return {
            primary: {
                color: BaSeTheme.colors.defaultColors.white,
                style: {
                    bgC: ColorMapper[color].foreground,
                    border: BaSeTheme.colors.defaultColors.white,
                },
            },
            secondary: {
                color: ColorMapper[color].hover.defaultDark,
                style: {
                    bgC: ColorMapper[color].hover.defaultLight,
                    border: ColorMapper[color].foreground,
                },
            },
            tertiary: {
                color: ColorMapper[color].hover.defaultDark,
                style: {
                    bgC: ColorMapper[color].hover.defaultLight,
                    border: 'none',
                },
            },
        };
    }
    var customColorHsv = Color.generateFromHex(color);
    return {
        primary: {
            color: BaSeTheme.colors.defaultColors.white,
            style: {
                bgC: color && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
                border: BaSeTheme.colors.defaultColors.white,
            },
        },
        secondary: {
            color: ColorMapper.dark.hover.create(color
                ? color
                : BaSeTheme.colors.institucionais.azulSebrae36),
            style: {
                bgC: ColorMapper.light.hover.create(color
                    ? color
                    : BaSeTheme.colors.institucionais.azulSebrae36),
                border: color && customColorHsv
                    ? customColorHsv.toString()
                    : BaSeTheme.colors.institucionais.azulSebrae36,
            },
        },
        tertiary: {
            color: ColorMapper.dark.hover.create(color
                ? color
                : BaSeTheme.colors.institucionais.azulSebrae36),
            style: {
                bgC: ColorMapper.light.hover.create(color
                    ? color
                    : BaSeTheme.colors.institucionais.azulSebrae36),
                border: 'none',
            },
        },
    };
};

var BaSeBadge = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var _l = mapBadgeValues((_a = props.color) !== null && _a !== void 0 ? _a : 'default')[(_b = props.type) !== null && _b !== void 0 ? _b : 'primary'], textColor = _l.color, _m = _l.style, bgC = _m.bgC, border = _m.border;
    return (React.createElement(BadgeContainer, null,
        props.children,
        React.createElement(BadgeValues, { right: (_d = (_c = props.position) === null || _c === void 0 ? void 0 : _c.right) !== null && _d !== void 0 ? _d : 'none', left: (_f = (_e = props.position) === null || _e === void 0 ? void 0 : _e.left) !== null && _f !== void 0 ? _f : 'none', bottom: (_h = (_g = props.position) === null || _g === void 0 ? void 0 : _g.bottom) !== null && _h !== void 0 ? _h : 'none', top: (_k = (_j = props.position) === null || _j === void 0 ? void 0 : _j.top) !== null && _k !== void 0 ? _k : 'none', bgC: bgC, border: border, color: textColor }, typeof props.value === 'string'
            ? props.value
            : props.value > 9
                ? '9+'
                : props.value < -9
                    ? '9-'
                    : props.value)));
};
BaSeBadge.displayName = 'BaSeBadge';

var handleNumberString = function (val) { return numberWithUnit(val); };
var ActionItemWrapper = styled.div(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
    return props.relative
        ? css(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n          position: relative;\n          display: inline-block;\n        "], ["\n          position: relative;\n          display: inline-block;\n        "]))) : css(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n          width: 100%;\n          height: 100%;\n          position: absolute;\n          top: 0;\n          bottom: 0;\n          left: 0;\n          right: 0;\n        "], ["\n          width: 100%;\n          height: 100%;\n          position: absolute;\n          top: 0;\n          bottom: 0;\n          left: 0;\n          right: 0;\n        "])));
});
var ActionItemContainer = styled.div(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  ", "\n  ", ";\n  position: absolute;\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  box-shadow: ", ";\n  border-radius: 4px;\n  transition: ", ";\n  max-height: 0;\n  overflow-y: hidden;\n  visibility: hidden;\n  z-index: ", ";\n\n  &.BaSe--action-item-open {\n    max-height: 1000vh;\n    visibility: visible;\n  }\n"], ["\n  ", "\n  ", ";\n  position: absolute;\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  box-shadow: ", ";\n  border-radius: 4px;\n  transition: ", ";\n  max-height: 0;\n  overflow-y: hidden;\n  visibility: hidden;\n  z-index: ", ";\n\n  &.BaSe--action-item-open {\n    max-height: 1000vh;\n    visibility: visible;\n  }\n"])), function (props) {
    return css(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n      min-width: ", ";\n    "], ["\n      min-width: ", ";\n    "])), handleNumberString(props.minWidth));
}, function (props) { return props.addStyles; }, BaSeTheme.colors.defaultColors.white, ColorMapper.disabled.foreground, BaSeTheme.shadows.profundidade2, BaSeTheme.transitions.allPropertiesContinuousNormal, BaSeTheme.stackOrder.belowOverlay);
var ActionItemListWrapper = styled.div(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  padding: 8px 0;\n"], ["\n  display: flex;\n  flex-flow: column;\n  padding: 8px 0;\n"])));
var ActionItemSingleItem = styled.button(templateObject_9$3 || (templateObject_9$3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var customColor = _a.customColor;
    return css(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject(["\n    padding: 8px 16px;\n    display: flex;\n    align-items: center;\n    background-color: ", ";\n    border: none;\n    outline: none;\n    cursor: ", ";\n    margin: 0;\n    box-sizing: border-box;\n    gap: 14px;\n    will-change: background-color;\n\n    &,\n    span {\n      transition: ", ";\n    }\n\n    span {\n      color: ", ";\n      font-size: 16px;\n      will-change: color, font-weight;\n    }\n\n    img {\n      width: 20px;\n    }\n\n    ", "\n  "], ["\n    padding: 8px 16px;\n    display: flex;\n    align-items: center;\n    background-color: ", ";\n    border: none;\n    outline: none;\n    cursor: ", ";\n    margin: 0;\n    box-sizing: border-box;\n    gap: 14px;\n    will-change: background-color;\n\n    &,\n    span {\n      transition: ", ";\n    }\n\n    span {\n      color: ", ";\n      font-size: 16px;\n      will-change: color, font-weight;\n    }\n\n    img {\n      width: 20px;\n    }\n\n    ", "\n  "])), customColor === null || customColor === void 0 ? void 0 : customColor.backgroundColor, (customColor === null || customColor === void 0 ? void 0 : customColor.disabled) ? 'not-allowed' : 'pointer', BaSeTheme.transitions.allPropertiesContinuousFast, customColor === null || customColor === void 0 ? void 0 : customColor.textColor, (customColor === null || customColor === void 0 ? void 0 : customColor.hoverBackgroundColor) && css(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n      &:hover,\n      &:focus {\n        background-color: ", ";\n      }\n\n      &:focus span {\n        font-weight: bold;\n      }\n    "], ["\n      &:hover,\n      &:focus {\n        background-color: ", ";\n      }\n\n      &:focus span {\n        font-weight: bold;\n      }\n    "])), customColor === null || customColor === void 0 ? void 0 : customColor.hoverBackgroundColor));
});
styled.div(templateObject_10$2 || (templateObject_10$2 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var templateObject_1$c, templateObject_2$9, templateObject_3$7, templateObject_4$6, templateObject_5$4, templateObject_6$3, templateObject_7$3, templateObject_8$3, templateObject_9$3, templateObject_10$2;

var UP_KEY_CODE = 'ArrowUp';
var DOWN_KEY_CODE = 'ArrowDown';
var NEGATIVE_INDEX = -99;
var DEFAULT_ITEM_COLORS = {
    unselected: {
        textColor: ColorMapper.default.foreground,
        backgroundColor: BaSeTheme.colors.defaultColors.white,
        hoverBackgroundColor: ColorMapper.default.hover.defaultLight,
    },
    selected: {
        textColor: BaSeTheme.colors.defaultColors.white,
        backgroundColor: ColorMapper.default.foreground,
        hoverBackgroundColor: ColorMapper.default.hover.defaultDark,
    },
    disabled: {
        textColor: ColorMapper.disabled.foreground,
        backgroundColor: ColorMapper.disabled.background,
        disabled: true,
    },
};
var SingleActionItem = function (_a) {
    var item = _a.item, index = _a.index, opened = _a.opened, hasFocus = _a.hasFocus, callback = _a.callback, updateCurrent = _a.updateCurrent;
    var selfRef = React.useRef(null);
    var handleClick = React.useCallback(function () {
        if (!(item === null || item === void 0 ? void 0 : item.isDisabled)) {
            item.callback();
            callback === null || callback === void 0 ? void 0 : callback();
        }
    }, [item, callback]);
    var handleFocus = React.useCallback(function (event) {
        event.preventDefault();
        event.stopPropagation();
        updateCurrent(index);
    }, [updateCurrent]);
    var getIconColor = React.useCallback(function () {
        var _a, _b;
        if (!(item === null || item === void 0 ? void 0 : item.color)) {
            return ColorMapper.default.foreground;
        }
        if (ColorMapper.isValidType((_a = item === null || item === void 0 ? void 0 : item.color) !== null && _a !== void 0 ? _a : '')) {
            return ColorMapper[item.color].foreground;
        }
        if (ColorMapper.isValidColor((_b = item === null || item === void 0 ? void 0 : item.color) !== null && _b !== void 0 ? _b : '')) {
            return item.color;
        }
        return ColorMapper.default.foreground;
    }, [item]);
    var createDisableIconColor = React.useCallback(function () {
        if (item === null || item === void 0 ? void 0 : item.isDisabled) {
            return BaSeTheme.colors.institucionais.cinzaSebrae75;
        }
        return item.isSelected
            ? BaSeTheme.colors.defaultColors.white
            : getIconColor();
    }, [item, getIconColor]);
    var disableTabIndex = React.useCallback(function () {
        return (item === null || item === void 0 ? void 0 : item.isDisabled) ? { tabIndex: -1 } : {};
    }, [item]);
    var getItemColor = React.useCallback(function () {
        var _a, _b;
        if (item === null || item === void 0 ? void 0 : item.isDisabled) {
            return DEFAULT_ITEM_COLORS.disabled;
        }
        var selected = (item === null || item === void 0 ? void 0 : item.isSelected) ? 'selected' : 'unselected';
        if (ColorMapper.isValidType((_a = item === null || item === void 0 ? void 0 : item.color) !== null && _a !== void 0 ? _a : '')) {
            return {
                unselected: {
                    textColor: ColorMapper[item.color].foreground,
                    backgroundColor: BaSeTheme.colors.defaultColors.white,
                    hoverBackgroundColor: ColorMapper[item.color].hover.defaultLight,
                },
                selected: {
                    backgroundColor: ColorMapper[item.color].foreground,
                    textColor: BaSeTheme.colors.defaultColors.white,
                    hoverBackgroundColor: ColorMapper[item.color].hover.defaultDark,
                },
            }[selected];
        }
        if (ColorMapper.isValidColor((_b = item === null || item === void 0 ? void 0 : item.color) !== null && _b !== void 0 ? _b : '')) {
            return {
                unselected: {
                    textColor: item === null || item === void 0 ? void 0 : item.color,
                    backgroundColor: BaSeTheme.colors.defaultColors.white,
                    hoverBackgroundColor: ColorMapper.light.hover.create(item.color),
                },
                selected: {
                    backgroundColor: item === null || item === void 0 ? void 0 : item.color,
                    textColor: BaSeTheme.colors.defaultColors.white,
                    hoverBackgroundColor: ColorMapper.dark.hover.create(item.color),
                },
            }[selected];
        }
        return DEFAULT_ITEM_COLORS[selected];
    }, [item]);
    React.useEffect(function () {
        var _a;
        if (hasFocus && opened && (selfRef === null || selfRef === void 0 ? void 0 : selfRef.current)) {
            (_a = selfRef === null || selfRef === void 0 ? void 0 : selfRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [hasFocus, opened, selfRef, index]);
    return (React.createElement(ActionItemSingleItem, __assign({ ref: selfRef, onFocus: handleFocus, onClick: handleClick, customColor: getItemColor(), "aria-disabled": item === null || item === void 0 ? void 0 : item.isDisabled }, disableTabIndex()),
        (item === null || item === void 0 ? void 0 : item.icon) && (React.createElement(BaSeI18nConsumer, null, function (_a) {
            var getMessage = _a.getMessage;
            return (React.createElement(BaSeIcon, { description: getMessage('icon.label', item.text), name: item.icon, color: createDisableIconColor() }));
        })),
        React.createElement("span", null, item.text)));
};
var BaSeActionItem = function (_a) {
    var _b;
    var _c = _a.icon, icon = _c === void 0 ? 'ellipsis-v' : _c, _d = _a.type, type = _d === void 0 ? 'tertiary' : _d, _e = _a.size, size = _e === void 0 ? 'extra-small' : _e, _f = _a.sizeIcon, sizeIcon = _f === void 0 ? 'medium' : _f, _g = _a.color, color = _g === void 0 ? BaSeTheme.colors.institucionais.azulSebrae36 : _g, _h = _a.items, items = _h === void 0 ? [] : _h, _j = _a.isDisabled, isDisabled = _j === void 0 ? false : _j, _k = _a.closeOnAction, closeOnAction = _k === void 0 ? true : _k, _l = _a.minWidth, minWidth = _l === void 0 ? 164 : _l, _m = _a.open, open = _m === void 0 ? false : _m, _o = _a.noIcon, noIcon = _o === void 0 ? false : _o, _p = _a.trackPosition, trackPosition = _p === void 0 ? false : _p, _q = _a.position, position = _q === void 0 ? 'top-left' : _q, _r = _a.tooltip, tooltip = _r === void 0 ? {} : _r, _s = _a.buttonType, buttonType = _s === void 0 ? 'base-shape-button' : _s, _t = _a.customButtonProps, customButtonProps = _t === void 0 ? {} : _t, onClose = _a.onClose, onOpen = _a.onOpen;
    var _u = React.useState(false), menuOpen = _u[0], setMenuOpen = _u[1];
    var menuRef = React.useRef(null);
    var _v = React.useState(NEGATIVE_INDEX), currentIndex = _v[0], setCurrentIndex = _v[1];
    var _w = React.useState(''), styles = _w[0], setStyles = _w[1];
    var parent = React.useState(window)[0];
    var _x = React.useState(false), isTooltipOpen = _x[0], setIsTooltipOpen = _x[1];
    useOutsideEvent(menuRef, function () {
        setMenuOpen(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    });
    var handleButtonType = React.useCallback(function () {
        var _a;
        if (!buttonType) {
            return 'base-shape-button';
        }
        var option = ['base-button', 'base-shape-button', 'base-arrow-button'];
        return (_a = option.find(function (i) { return i === buttonType; })) !== null && _a !== void 0 ? _a : 'base-shape-button';
    }, [buttonType]);
    var displayButton = React.useCallback(function () {
        return {
            'base-button': function (baseButtonProps) { return (React.createElement(BaSeButton, __assign({}, baseButtonProps, { tooltip: tooltip, onClick: function () { return setMenuOpen(function (prev) { return !prev; }); }, isDisabled: isDisabled, size: size, color: color, type: type, onFocus: undefined, onBlur: undefined }))); },
            'base-shape-button': function (baseShapeButtonProps) { return (React.createElement(BaSeShapeButton, __assign({}, baseShapeButtonProps, { tooltip: tooltip, isDisabled: isDisabled, size: size, sizeIcon: sizeIcon, color: color, type: type, nameIcon: icon, onClick: function () { return setMenuOpen(function (prev) { return !prev; }); }, onFocus: undefined, onBlur: undefined }))); },
            'base-arrow-button': function (baseArrowButtonProps) { return (React.createElement(BaSeArrowButton, __assign({}, baseArrowButtonProps, { tooltip: tooltip, isDisabled: isDisabled, color: color, type: type, onClick: function () { return setMenuOpen(function (prev) { return !prev; }); }, onFocus: undefined, onBlur: undefined }))); },
        };
    }, [isDisabled, size, color, type, tooltip, sizeIcon, icon]);
    var checkNextElement = React.useCallback(function (index, direction, init) {
        var _a;
        if (index === init) {
            return index;
        }
        if (index > (items === null || items === void 0 ? void 0 : items.length) - 1) {
            return checkNextElement(0, direction, init);
        }
        if (index < 0) {
            return checkNextElement((items === null || items === void 0 ? void 0 : items.length) - 1, direction, init);
        }
        if ((_a = items[index]) === null || _a === void 0 ? void 0 : _a.isDisabled) {
            return checkNextElement(index + (direction === 'up' ? -1 : 1), direction, init);
        }
        return index;
    }, [items]);
    var handleArrowKeys = React.useCallback(function (event) {
        if (menuOpen) {
            if (event.key === DOWN_KEY_CODE) {
                event === null || event === void 0 ? void 0 : event.preventDefault();
                setCurrentIndex(function (prev) { return checkNextElement(prev + 1, 'down', prev); });
            }
            if (event.key === UP_KEY_CODE) {
                event === null || event === void 0 ? void 0 : event.preventDefault();
                setCurrentIndex(function (prev) { return checkNextElement(prev - 1, 'up', prev); });
            }
        }
    }, [menuOpen, setCurrentIndex, checkNextElement]);
    var returnDefault = React.useCallback(function () {
        setCurrentIndex(NEGATIVE_INDEX);
        setMenuOpen(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [onClose]);
    var handlePosition = React.useCallback(function (pos) {
        var styledPosition = '';
        styledPosition += pos.includes('top') ? 'top:100%;' : 'bottom: 100%;';
        styledPosition += pos.includes('left') ? 'left:0;' : 'right: 0;';
        return styledPosition;
    }, [position]);
    React.useEffect(function () {
        if (menuOpen) {
            onOpen === null || onOpen === void 0 ? void 0 : onOpen();
            setTimeout(function () {
                setCurrentIndex(0);
            }, 200);
            parent.addEventListener('keydown', handleArrowKeys);
        }
        else {
            parent.removeEventListener('keydown', handleArrowKeys);
            setStyles('');
            setCurrentIndex(NEGATIVE_INDEX);
        }
        return function () {
            parent.removeEventListener('keydown', handleArrowKeys);
        };
    }, [menuOpen]);
    React.useEffect(function () {
        if (currentIndex < 0 && currentIndex !== NEGATIVE_INDEX) {
            setCurrentIndex(items.length - 1);
        }
        if (currentIndex > items.length - 1) {
            setCurrentIndex(0);
        }
    }, [currentIndex]);
    React.useEffect(function () {
        if (noIcon) {
            setMenuOpen(open);
        }
    }, [open, noIcon]);
    React.useEffect(function () {
        return function () {
            parent.removeEventListener('keydown', handleArrowKeys);
        };
    }, []);
    React.useEffect(function () {
        var _a;
        if (trackPosition) {
            try {
                var style = '';
                var _b = (_a = menuRef === null || menuRef === void 0 ? void 0 : menuRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect(), bottom = _b.bottom, right = _b.right, width = _b.width, height = _b.height;
                if (right && bottom && width && height && !styles) {
                    var _c = window, innerWidth_1 = _c.innerWidth, innerHeight_1 = _c.innerHeight;
                    if (height < innerHeight_1) {
                        if (bottom > innerHeight_1) {
                            style += 'bottom: 100%;';
                        }
                        else {
                            style += 'top:100%;';
                        }
                    }
                    if (width < innerWidth_1) {
                        if (right > innerWidth_1) {
                            style += 'right:0;';
                        }
                        else {
                            style += 'left:0;';
                        }
                    }
                    if (style === styles) {
                        return;
                    }
                    setStyles(style);
                }
            }
            catch (_d) {
                setStyles('');
            }
        }
        else {
            if (position) {
                setStyles(handlePosition(position));
            }
        }
    }, [menuRef, (_b = menuRef === null || menuRef === void 0 ? void 0 : menuRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()]);
    return (React.createElement(ActionItemWrapper, { onMouseEnter: function () {
            setIsTooltipOpen(true);
        }, onMouseLeave: function () {
            setIsTooltipOpen(false);
        }, relative: !noIcon, ref: menuRef },
        !noIcon && displayButton()[handleButtonType()](customButtonProps),
        items.length > 0 && !isDisabled && (React.createElement(ActionItemContainer, { minWidth: minWidth, addStyles: styles, className: menuOpen ? 'BaSe--action-item-open' : '' },
            React.createElement(ActionItemListWrapper, null, items.map(function (item, key) { return (React.createElement(SingleActionItem, { callback: closeOnAction ? returnDefault : undefined, item: item, key: key, index: key, opened: menuOpen, hasFocus: key === currentIndex, updateCurrent: setCurrentIndex })); })))),
        objectNotEmpty(tooltip) && !!noIcon && (React.createElement(BaSeTooltip, __assign({ buddyRef: menuRef, open: isTooltipOpen }, tooltip)))));
};
BaSeActionItem.displayName = 'BaSeActionItem';

var BaSeDataSelectionContext = React.createContext({
    isAllSelected: false,
    isAllFromPageSelected: false,
    selectedItems: [],
    setIsAllSelected: function () { },
    setIsAllFromPageSelected: function () { },
    setSelectedItems: function () { },
});
function BaSeDataSelectionProvider(_a) {
    var hasSelection = _a.hasSelection, isAllSelected = _a.isAllSelected, isAllFromPageSelected = _a.isAllFromPageSelected, selectedItems = _a.selectedItems, setIsAllSelected = _a.setIsAllSelected, setIsAllFromPageSelected = _a.setIsAllFromPageSelected, setSelectedItems = _a.setSelectedItems, children = _a.children;
    if (hasSelection) {
        return (React.createElement(BaSeDataSelectionContext.Provider, { value: {
                isAllSelected: isAllSelected,
                isAllFromPageSelected: isAllFromPageSelected,
                selectedItems: selectedItems,
                setIsAllSelected: setIsAllSelected,
                setIsAllFromPageSelected: setIsAllFromPageSelected,
                setSelectedItems: setSelectedItems,
            } }, children));
    }
    return React.createElement(React.Fragment, null, children);
}
var BaSeDataSelectionConsumer = BaSeDataSelectionContext.Consumer;

var spacePixels = '24px';
var densityPixels = function (densityLevel, factor) {
    if (factor === void 0) { factor = 1; }
    return "".concat(factor * (densityLevel === 'high' ? 4 : densityLevel === 'low' ? 16 : 8) // normal
    , "px");
};
var DataWrapper = styled.section.attrs({
    className: 'BaSe--data',
})(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  display: grid;\n  grid-template-areas:\n    'header'\n    'selection-helper'\n    'filter-or-tags'\n    'content'\n    'footer';\n  box-sizing: border-box;\n  border-radius: 8px;\n  ", "\n  ", "\n  ", "\n"], ["\n  display: grid;\n  grid-template-areas:\n    'header'\n    'selection-helper'\n    'filter-or-tags'\n    'content'\n    'footer';\n  box-sizing: border-box;\n  border-radius: 8px;\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
    var width = _a.width;
    return css(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n    width: ", ";\n  "], ["\n    width: ", ";\n  "])), numberWithUnit(width));
}, function (_a) {
    var shadow = _a.shadow;
    return shadow && css(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n      box-shadow: ", ";\n    "], ["\n      box-shadow: ", ";\n    "])), shadow);
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor && css(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), backgroundColor);
});
var DataLoading = styled.div(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  will-change: min-height;\n  min-height: ", "px;\n"], ["\n  will-change: min-height;\n  min-height: ", "px;\n"])), function (_a) {
    var height = _a.height;
    return height;
});
var DataHeader = styled.header.attrs({
    className: 'BaSe--data-header',
})(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  grid-area: header;\n  border-radius: 8px 8px 0 0;\n  position: relative;\n  will-change: padding;\n  padding: ", " ", ";\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  border: none;\n  ", "\n\n  & > *:last-child {\n    flex: 1;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    height: 48px;\n    gap: 4px;\n  }\n"], ["\n  grid-area: header;\n  border-radius: 8px 8px 0 0;\n  position: relative;\n  will-change: padding;\n  padding: ", " ", ";\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  border: none;\n  ", "\n\n  & > *:last-child {\n    flex: 1;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    height: 48px;\n    gap: 4px;\n  }\n"])), spacePixels, function (_a) {
    var horizontalPadding = _a.horizontalPadding;
    return horizontalPadding;
}, function (_a) {
    var headerBackgroundColor = _a.headerBackgroundColor;
    return headerBackgroundColor && css(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), headerBackgroundColor);
});
var DataHeaderTitle = styled.span.attrs({
    className: 'BaSe--data-header-title',
})(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 4px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 4px;\n"])));
var DataFooter = styled.footer.attrs({
    className: 'BaSe--data-footer',
})(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject(["\n  grid-area: footer;\n  border-radius: 0 0 8px 8px;\n  border: none;\n  border-top: 1px solid ", ";\n  will-change: padding;\n  ", "\n  ", "\n"], ["\n  grid-area: footer;\n  border-radius: 0 0 8px 8px;\n  border: none;\n  border-top: 1px solid ", ";\n  will-change: padding;\n  ", "\n  ", "\n"])), function (_a) {
    var separatorColor = _a.separatorColor;
    return separatorColor;
}, function (_a) {
    var _b = _a.verticalPadding, verticalPadding = _b === void 0 ? '8px' : _b, _c = _a.horizontalPadding, horizontalPadding = _c === void 0 ? spacePixels : _c;
    return css(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), verticalPadding, horizontalPadding);
}, function (_a) {
    var footerBackgroundColor = _a.footerBackgroundColor;
    return footerBackgroundColor && css(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), footerBackgroundColor);
});
var DataSelectionHelper = styled.div(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject(["\n  grid-area: selection-helper;\n"], ["\n  grid-area: selection-helper;\n"])));
var DataFilterOrTags = styled.div(templateObject_13$1 || (templateObject_13$1 = __makeTemplateObject(["\n  grid-area: filter-or-tags;\n"], ["\n  grid-area: filter-or-tags;\n"])));
var DataContent = styled.div(templateObject_14$1 || (templateObject_14$1 = __makeTemplateObject(["\n  grid-area: content;\n"], ["\n  grid-area: content;\n"])));
var templateObject_1$b, templateObject_2$8, templateObject_3$6, templateObject_4$5, templateObject_5$3, templateObject_6$2, templateObject_7$2, templateObject_8$2, templateObject_9$2, templateObject_10$1, templateObject_11$1, templateObject_12$1, templateObject_13$1, templateObject_14$1;

function configMapper(_a) {
    var _b, _c;
    var config = _a.config, groupConfig = _a.groupConfig, reloadData = _a.reloadData, whenRenderTextCell = _a.whenRenderTextCell;
    return ((_c = (_b = groupConfig === null || groupConfig === void 0 ? void 0 : groupConfig.map) === null || _b === void 0 ? void 0 : _b.call(groupConfig, function (groupConfigItem) { return ({
        Header: groupConfigItem.header,
        columns: configMapper({
            whenRenderTextCell: whenRenderTextCell,
            reloadData: reloadData,
            config: groupConfigItem.config,
        }),
    }); })) !== null && _c !== void 0 ? _c : config.map(function (configItem) { return ({
        Header: configItem.header,
        accessor: configItem.accessorKey,
        id: configItem.id,
        Cell: function (data) {
            if (configItem.mapper) {
                var cellToRender = configItem.mapper({
                    values: data.data[data.row.index],
                    reloadData: reloadData,
                });
                if (cellToRender === undefined || cellToRender === null) {
                    return whenRenderTextCell('');
                }
                if (['number', 'string'].includes(typeof cellToRender)) {
                    return whenRenderTextCell(String(cellToRender));
                }
                return cellToRender;
            }
            return whenRenderTextCell(String(data.value));
        },
    }); }));
}
function rowIsSelected(_a) {
    var isAllSelected = _a.isAllSelected, selectedItems = _a.selectedItems, item = _a.item, itemKey = _a.itemKey;
    return (isAllSelected ||
        selectedItems.some(function (selectedItem) {
            return selectedItem[itemKey] && selectedItem[itemKey] === item[itemKey];
        }));
}
function renderColumnFilter(id, columnConfig) {
    var _a;
    return (_a = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.find(function (_a) {
        var columnId = _a.columnId;
        return columnId === id;
    })) === null || _a === void 0 ? void 0 : _a.renderColumnFilter;
}
function columnFilterIconProps(id, columnConfig) {
    var _a;
    return (_a = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.find(function (_a) {
        var columnId = _a.columnId;
        return columnId === id;
    })) === null || _a === void 0 ? void 0 : _a.columnFilterIconProps;
}
var cachePageReducedRange = {};
function pageReducedRange(options, actual) {
    var cacheKey = "".concat(actual, ": [").concat(options.toString(), "]");
    if (cachePageReducedRange[cacheKey]) {
        return cachePageReducedRange[cacheKey];
    }
    function resultWithCache(result) {
        cachePageReducedRange[cacheKey] = result;
        return result;
    }
    var ellipsis = '…';
    var siblingCount = 1;
    var boundaryCount = 1;
    var page = actual + 1;
    var count = options.length;
    function range(start, end) {
        var length = end - start + 1;
        return Array.from({ length: length }, function (_, index) { return start + index; });
    }
    var startPages = range(1, Math.min(boundaryCount, count));
    var endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    var startSiblingsPages = Math.max(Math.min(page - siblingCount, count - boundaryCount - siblingCount * 2 - 1), boundaryCount + 2);
    var startSiblingsPagesOrEllipsis = startSiblingsPages > boundaryCount + 2
        ? [ellipsis]
        : boundaryCount + 1 < count - boundaryCount
            ? [boundaryCount + 1]
            : [];
    var endSiblingsPages = Math.min(Math.max(page + siblingCount, boundaryCount + siblingCount * 2 + 2), endPages.length > 0 ? endPages[0] - 2 : count - 1);
    var endSiblingsPagesOrEllipsis = endSiblingsPages < count - boundaryCount - 1
        ? [ellipsis]
        : count - boundaryCount > boundaryCount
            ? [count - boundaryCount]
            : [];
    var middlePages = range(startSiblingsPages, endSiblingsPages);
    var pages = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], startPages, true), startSiblingsPagesOrEllipsis, true), middlePages, true), endSiblingsPagesOrEllipsis, true), endPages, true);
    return resultWithCache(pages.map(function (item) { return (typeof item === 'number' ? item - 1 : item); }));
    // const boundary = 6;
    // const halfBoundary = Math.ceil(boundary / 2);
    // const total = options.length;
    // const first = 0;
    // const last = options[total - 1] ?? first;
    // const almostFirst = first + 1;
    // const almostLast = last - 1;
    // const dontNeedToReduce = last <= first + boundary - halfBoundary;
    // function inTheStart(item: number): boolean {
    //   return item <= first;
    // }
    // function notInTheStart(item: number): boolean {
    //   return !inTheStart(item);
    // }
    // function inTheEnd(item: number): boolean {
    //   return item >= last;
    // }
    // function notInTheEnd(item: number): boolean {
    //   return !inTheEnd(item);
    // }
    // function isActualAndSibling(item: number): boolean {
    //   const start = Array(halfBoundary)
    //     .fill(actual)
    //     .map((x, index) => x - index)
    //     .reverse();
    //   const end = Array(halfBoundary)
    //     .fill(actual)
    //     .map((x, index) => x + index);
    //   const actualAndSiblings = [...start, ...end];
    //   return actualAndSiblings.some(
    //     (actualAndSibling) => actualAndSibling === item,
    //   );
    // }
    // if (dontNeedToReduce) {
    //   return resultWithCache(options);
    // }
    // if (inTheEnd(actual)) {
    //   const end = Array(boundary)
    //     .fill(last)
    //     .map((x, index) => x - index)
    //     .reverse();
    //   return resultWithCache([first, '…', ...end]);
    // }
    // if (inTheStart(actual)) {
    //   const start = Array(boundary)
    //     .fill(first)
    //     .map((x, index) => x + index);
    //   return resultWithCache([...start, '…', last]);
    // }
    // const middleWithFirstAndLast: DataPageReducedRangeItem[] =
    //   options.filter(isActualAndSibling);
    // const sizeOfMiddle = middleWithFirstAndLast.length;
    // const startOfMiddle = middleWithFirstAndLast[0];
    // const endOfMiddle = middleWithFirstAndLast[sizeOfMiddle - 1];
    // if (startOfMiddle > almostFirst) {
    //   middleWithFirstAndLast.splice(0, 0, '…');
    // }
    // if (endOfMiddle < almostLast) {
    //   middleWithFirstAndLast.splice(sizeOfMiddle, 0, '…');
    // }
    // const middle = middleWithFirstAndLast
    //   .filter(notInTheStart)
    //   .filter(notInTheEnd);
    // return resultWithCache([first, ...middle, last]);
}

var showUp = keyframes(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  from {\n    opacity: 0;\n    transform: translateY(-50%);\n  }\n"], ["\n  from {\n    opacity: 0;\n    transform: translateY(-50%);\n  }\n"])));
var showUpAnimation = css(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  transform-origin: center;\n  will-change: opacity, transform;\n  animation: ", " ", "\n    ", " 1;\n"], ["\n  transform-origin: center;\n  will-change: opacity, transform;\n  animation: ", " ", "\n    ", " 1;\n"])), showUp, BaSeTheme.transitions.durationFast, BaSeTheme.transitions.continuousTimingFunction);
var FilterArea = styled.div(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  flex: 1 100%;\n  padding: 16px ", ";\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  & > * {\n    ", "\n  }\n"], ["\n  flex: 1 100%;\n  padding: 16px ", ";\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  & > * {\n    ", "\n  }\n"])), spacePixels, showUpAnimation);
var ActivatedFilters = styled.div(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  justify-content: flex-start;\n"], ["\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  justify-content: flex-start;\n"])));
var CustomFilterItem = styled.div(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: stretch;\n  gap: 8px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: stretch;\n  gap: 8px;\n"])));
var DataFilterAreaWrapper = styled.div(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n  transition: max-height ", ";\n  position: relative;\n  padding: 0;\n  margin: 0;\n  box-sizing: content-box;\n  display: flex;\n  align-items: stretch;\n  justify-content: stretch;\n  border: none;\n  will-change: max-height, margin-bottom, overflow;\n  background-color: ", ";\n\n  ", "\n\n  ", "\n"], ["\n  transition: max-height ", ";\n  position: relative;\n  padding: 0;\n  margin: 0;\n  box-sizing: content-box;\n  display: flex;\n  align-items: stretch;\n  justify-content: stretch;\n  border: none;\n  will-change: max-height, margin-bottom, overflow;\n  background-color: ", ";\n\n  ", "\n\n  ", "\n"])), "\n    ".concat(BaSeTheme.transitions.durationFast, "\n    ").concat(BaSeTheme.transitions.continuousTimingFunction, "\n  "), function (_a) {
    var filterAreaBackgroundColor = _a.filterAreaBackgroundColor;
    return filterAreaBackgroundColor;
}, function (_a) {
    var separatorColor = _a.separatorColor;
    return separatorColor && css(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n      border-top: 1px solid ", ";\n    "], ["\n      border-top: 1px solid ", ";\n    "])), separatorColor);
}, function (_a) {
    var filterAreaVisible = _a.filterAreaVisible;
    return filterAreaVisible
        ? css(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n          max-height: 100%;\n          margin-bottom: 0;\n        "], ["\n          max-height: 100%;\n          margin-bottom: 0;\n        "]))) : css(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n          max-height: 0;\n          margin-bottom: -100%;\n        "], ["\n          max-height: 0;\n          margin-bottom: -100%;\n        "])));
});
var templateObject_1$a, templateObject_2$7, templateObject_3$5, templateObject_4$4, templateObject_5$2, templateObject_6$1, templateObject_7$1, templateObject_8$1, templateObject_9$1;

function BaSeDataFilterArea(_a) {
    var customFilterClearButtonProps = _a.customFilterClearButtonProps, textColor = _a.textColor, filterAreaBackgroundColor = _a.filterAreaBackgroundColor, tags = _a.tags, separatorColor = _a.separatorColor, _b = _a.customFilterVisible, initialCustomFilterVisible = _b === void 0 ? false : _b, _c = _a.customFilterVisibleWhenHasTags, customFilterVisibleWhenHasTags = _c === void 0 ? false : _c, setClearFilterButtonClicked = _a.setClearFilterButtonClicked, onClearFilter = _a.onClearFilter, renderCustomFilter = _a.renderCustomFilter, setFilter = _a.setFilter, setTags = _a.setTags;
    if (renderCustomFilter === undefined) {
        throw Error('BaSeDataCustomFilter: "renderCustomFilter" é obrigatório');
    }
    var tagsVisible = React.useMemo(function () { return (tags === null || tags === void 0 ? void 0 : tags.length) > 0; }, [tags === null || tags === void 0 ? void 0 : tags.length]);
    var customFilterVisible = React.useMemo(function () {
        return (customFilterVisibleWhenHasTags && tags.length > 0) ||
            initialCustomFilterVisible;
    }, [initialCustomFilterVisible, customFilterVisibleWhenHasTags, tags === null || tags === void 0 ? void 0 : tags.length]);
    return (React.createElement(DataFilterAreaWrapper, { separatorColor: separatorColor, filterAreaVisible: tagsVisible || customFilterVisible, filterAreaBackgroundColor: filterAreaBackgroundColor }, (customFilterVisible || tagsVisible) && (React.createElement(FilterArea, null,
        React.createElement(BaSeI18nConsumer, null, function (_a) {
            var getMessage = _a.getMessage;
            return (React.createElement(React.Fragment, null,
                customFilterVisible && (React.createElement(CustomFilterItem, null,
                    React.createElement(BaSeSmall1, { color: textColor }, getMessage('dataFilter.customFilterTitle')),
                    React.createElement("div", null, renderCustomFilter({ setFilter: setFilter, setTags: setTags })))),
                tagsVisible && (React.createElement(ActivatedFilters, null,
                    React.createElement(BaSeSmall1, { isItalic: true, color: textColor }, getMessage('dataFilter.customFilterActivated')),
                    tags.map(function (tag) { return (React.createElement(BaSeTag, __assign({ key: "".concat(tag.label, "-").concat(tag.icon), color: textColor }, tag))); }),
                    React.createElement(BaSeButton, __assign({ size: "small", type: "tertiary", color: "destructive", value: getMessage('dataFilter.customFilterClear'), onClick: function () {
                            setFilter(undefined);
                            setTags === null || setTags === void 0 ? void 0 : setTags([]);
                            onClearFilter === null || onClearFilter === void 0 ? void 0 : onClearFilter();
                            setClearFilterButtonClicked(function (clicked) { return ++clicked; });
                        } }, customFilterClearButtonProps))))));
        })))));
}

var DataPaginationWrapper = styled.div.attrs({
    className: 'BaSe--data-pagination',
})(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  height: 48px;\n  display: flex;\n  align-items: center;\n"], ["\n  height: 48px;\n  display: flex;\n  align-items: center;\n"])));
var DataPaginationController = styled.div.attrs({
    className: 'BaSe--data-pagination-controller',
})(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 48px;\n  gap: 4px;\n"], ["\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 48px;\n  gap: 4px;\n"])));
var DataPaginationFixedItem = styled.div(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  width: 24px;\n"], ["\n  width: 24px;\n"])));
var templateObject_1$9, templateObject_2$6, templateObject_3$4;

function BaSeDataPagination(_a) {
    var canNextPage = _a.canNextPage, canPreviousPage = _a.canPreviousPage, page = _a.page, pageCount = _a.pageCount, pageIndex = _a.pageIndex, pageReducedRange = _a.pageReducedRange, pageSize = _a.pageSize, total = _a.total, notFoundMessage = _a.notFoundMessage, singularItemDescription = _a.singularItemDescription, pluralItemDescription = _a.pluralItemDescription, _b = _a.highlightedColor, highlightedColor = _b === void 0 ? BaSeTheme.colors.institucionais.azulSebrae : _b, _c = _a.foregroundColor, foregroundColor = _c === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae60 : _c, _d = _a.itemsPerPage, itemsPerPage = _d === void 0 ? [5, 10, 15] : _d, _e = _a.compactMode, compactMode = _e === void 0 ? false : _e, gotoPage = _a.gotoPage, nextPage = _a.nextPage, previousPage = _a.previousPage, setDataPageSize = _a.setDataPageSize, setPageSize = _a.setPageSize;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(DataPaginationWrapper, null, page ? (React.createElement(React.Fragment, null,
        React.createElement(BaSeSmall1, { color: foregroundColor }, total === 0
            ? notFoundMessage !== null && notFoundMessage !== void 0 ? notFoundMessage : getMessage('dataPagination.noItemsToDisplay', pluralItemDescription !== null && pluralItemDescription !== void 0 ? pluralItemDescription : getMessage('dataItem.pluralItemDescription'))
            : total === 1
                ? getMessage('dataPagination.showingOneItems', singularItemDescription !== null && singularItemDescription !== void 0 ? singularItemDescription : getMessage('dataItem.singularItemDescription'))
                : getMessage('dataPagination.showingItems', page.length, total, pluralItemDescription !== null && pluralItemDescription !== void 0 ? pluralItemDescription : getMessage('dataItem.pluralItemDescription'))),
        total > 0 && (React.createElement(DataPaginationController, null, compactMode ? (React.createElement(React.Fragment, null,
            React.createElement(BaSeShapeButton, { type: "tertiary", color: foregroundColor, onClick: function () { return previousPage(); }, isDisabled: !canPreviousPage, sizeIcon: "big", nameIcon: "angle-left" }),
            React.createElement(BaSeShapeButton, { type: "tertiary", color: foregroundColor, onClick: function () { return nextPage(); }, isDisabled: !canNextPage, sizeIcon: "big", nameIcon: "angle-right" }))) : (React.createElement(React.Fragment, null,
            (pageReducedRange === null || pageReducedRange === void 0 ? void 0 : pageReducedRange.length) > 1 && (React.createElement(React.Fragment, null,
                React.createElement(DataPaginationFixedItem, null,
                    React.createElement(BaSeShapeButton, { type: "tertiary", color: foregroundColor, size: "small", sizeIcon: "small", onClick: function () { return gotoPage(0); }, isDisabled: !canPreviousPage, nameIcon: "angle-double-left" })),
                React.createElement(DataPaginationFixedItem, null,
                    React.createElement(BaSeShapeButton, { type: "tertiary", color: foregroundColor, size: "small", sizeIcon: "small", onClick: function () { return previousPage(); }, isDisabled: !canPreviousPage, nameIcon: "angle-left" })),
                React.createElement("span", { style: { display: 'flex', gap: '4px' } }, pageReducedRange.map(function (pageOption, index) { return (React.createElement(DataPaginationFixedItem, { key: "".concat(pageOption, "-").concat(index) }, typeof pageOption === 'number' ? (React.createElement(BaSeShapeButton, { type: pageOption === pageIndex
                        ? 'primary'
                        : 'tertiary', color: pageOption === pageIndex
                        ? highlightedColor
                        : foregroundColor, size: "small", sizeIcon: "small", onClick: function () { return gotoPage(pageOption); }, value: pageOption + 1 + '' })) : (React.createElement(BaSeText, { color: foregroundColor }, pageOption)))); })),
                React.createElement(DataPaginationFixedItem, null,
                    React.createElement(BaSeShapeButton, { type: "tertiary", color: foregroundColor, size: "small", sizeIcon: "small", onClick: function () { return nextPage(); }, isDisabled: !canNextPage, nameIcon: "angle-right" })),
                React.createElement(DataPaginationFixedItem, null,
                    React.createElement(BaSeShapeButton, { type: "tertiary", color: foregroundColor, size: "small", sizeIcon: "small", onClick: function () { return gotoPage(pageCount - 1); }, isDisabled: !canNextPage, nameIcon: "angle-double-right" })))),
            React.createElement(BaSeSmall1, { color: foregroundColor }, getMessage('dataPagination.showingItemsPerPage')),
            React.createElement(BaSeSelect, { size: "small", width: "70px", color: foregroundColor, removeEmptyValue: true, selectedValueId: pageSize, values: itemsPerPage.map(function (itemPageSize) { return ({
                    id: +itemPageSize,
                    label: itemPageSize + '',
                }); }), onChange: function (_a) {
                    var itemPageSize = _a.id;
                    if (itemPageSize) {
                        setPageSize(+itemPageSize);
                        setDataPageSize(+itemPageSize);
                    }
                } }))))))) : (React.createElement(BaSeSmall1, { color: foregroundColor }, total === 0
        ? notFoundMessage !== null && notFoundMessage !== void 0 ? notFoundMessage : getMessage('dataPagination.noItemsToDisplay', pluralItemDescription !== null && pluralItemDescription !== void 0 ? pluralItemDescription : getMessage('dataItem.pluralItemDescription'))
        : total === 1
            ? getMessage('dataPagination.showingOneItems', singularItemDescription !== null && singularItemDescription !== void 0 ? singularItemDescription : getMessage('dataItem.singularItemDescription'))
            : getMessage('dataPagination.showingMoreThanOneItem', total, pluralItemDescription !== null && pluralItemDescription !== void 0 ? pluralItemDescription : getMessage('dataItem.pluralItemDescription'))))));
}

var DataHeaderTitleSelection = styled(DataHeaderTitle)(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n"], ["\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n"])));
var DataSelectOrUnselectAllItem = styled(DataHeaderTitleSelection)(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 4px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 4px;\n"])));
var DataSelectionCounter = styled.span(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  flex: 1 100%;\n  opacity: ", ";\n  pointer-events: none;\n"], ["\n  flex: 1 100%;\n  opacity: ", ";\n  pointer-events: none;\n"])), function (_a) {
    var fadeIn = _a.fadeIn;
    return (fadeIn ? 1 : 0);
});
var DataSelectOrUnselectAllArea = styled.span(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n  height: 50px;\n  margin-bottom: 0;\n  will-change: height, margin-bottom;\n  transition: height ", ";\n  background-color: ", ";\n\n  &:empty {\n    height: 0;\n    margin-bottom: -100%;\n  }\n"], ["\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n  height: 50px;\n  margin-bottom: 0;\n  will-change: height, margin-bottom;\n  transition: height ", ";\n  background-color: ", ";\n\n  &:empty {\n    height: 0;\n    margin-bottom: -100%;\n  }\n"])), "\n    ".concat(BaSeTheme.transitions.durationFast, "\n    ").concat(BaSeTheme.transitions.continuousTimingFunction, "\n  "), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
});
var templateObject_1$8, templateObject_2$5, templateObject_3$3, templateObject_4$3;

function DataHeaderSelection(_a) {
    var _b, _c;
    var isAllSelected = _a.isAllSelected, pluralItemDescription = _a.pluralItemDescription, singularItemDescription = _a.singularItemDescription, selectedItems = _a.selectedItems, _d = _a.foregroundColor, foregroundColor = _d === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae60 : _d, _e = _a.genderOfItemDescription, genderOfItemDescription = _e === void 0 ? 'male' : _e, _f = _a.total, total = _f === void 0 ? 0 : _f, reloadData = _a.reloadData, selectionIconActions = _a.selectionIconActions, selectionButtonActions = _a.selectionButtonActions;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var showCounter = React.useMemo(function () { return isAllSelected || selectedItems.length > 0; }, [isAllSelected, selectedItems.length]);
    /**/
    return (React.createElement(DataHeaderTitleSelection, null, (_b = selectionIconActions === null || selectionIconActions === void 0 ? void 0 : selectionIconActions({
        selectedItems: selectedItems,
        isAllSelected: isAllSelected,
        reloadData: reloadData,
    })) === null || _b === void 0 ? void 0 :
        _b.map(function (selectionIconAction) { return (React.createElement(BaSeShapeButton, __assign({ key: "".concat(selectionIconAction.nameIcon, "-").concat(selectionIconAction.value), size: "small", sizeIcon: "small", type: "tertiary", color: foregroundColor }, selectionIconAction))); }), (_c = selectionButtonActions === null || selectionButtonActions === void 0 ? void 0 : selectionButtonActions({
        selectedItems: selectedItems,
        isAllSelected: isAllSelected,
        reloadData: reloadData,
    })) === null || _c === void 0 ? void 0 :
        _c.map(function (selectionButtonAction) { return (React.createElement(BaSeButton, __assign({ key: "".concat(selectionButtonAction.rightIcon, "-").concat(selectionButtonAction.value, "-").concat(selectionButtonAction.leftIcon), size: "small", type: "tertiary", color: foregroundColor }, selectionButtonAction))); }),
        React.createElement(DataSelectionCounter, { fadeIn: showCounter },
            React.createElement(BaSeSmall1, { color: foregroundColor }, isAllSelected || selectedItems.length === total
                ? getMessage("dataSelection.allItemsSelected.".concat(genderOfItemDescription), total, pluralItemDescription !== null && pluralItemDescription !== void 0 ? pluralItemDescription : getMessage('dataItem.pluralItemDescription'))
                : selectedItems.length === 1
                    ? getMessage("dataSelection.oneItemSelected.".concat(genderOfItemDescription), singularItemDescription !== null && singularItemDescription !== void 0 ? singularItemDescription : getMessage('dataItem.singularItemDescription'))
                    : getMessage("dataSelection.manyItemSelected.".concat(genderOfItemDescription), selectedItems.length, pluralItemDescription !== null && pluralItemDescription !== void 0 ? pluralItemDescription : getMessage('dataItem.pluralItemDescription'))))));
}

var colors$1 = BaSeTheme.colors;
function DataSelectOrUnselectAll(_a) {
    var hasPagination = _a.hasPagination, singularItemDescription = _a.singularItemDescription, pluralItemDescription = _a.pluralItemDescription, compactMode = _a.compactMode, isAllFromPageSelected = _a.isAllFromPageSelected, selectedItems = _a.selectedItems, isAllSelected = _a.isAllSelected, _b = _a.genderOfItemDescription, genderOfItemDescription = _b === void 0 ? 'male' : _b, _c = _a.total, total = _c === void 0 ? 0 : _c, _d = _a.highlightedColor, highlightedColor = _d === void 0 ? colors$1.institucionais.azulSebrae : _d, _e = _a.backgroundColor, backgroundColor = _e === void 0 ? colors$1.defaultColors.white : _e, _f = _a.textColor, textColor = _f === void 0 ? colors$1.institucionais.cinzaSebrae30 : _f, _g = _a.selectOrUnselectAllBackgroundColor, selectOrUnselectAllBackgroundColor = _g === void 0 ? colors$1.institucionais.cinzaSebrae97 : _g, setIsAllSelected = _a.setIsAllSelected;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(DataSelectOrUnselectAllArea, { backgroundColor: compactMode ? backgroundColor : selectOrUnselectAllBackgroundColor }, hasPagination &&
        isAllFromPageSelected &&
        selectedItems.length !== total &&
        (isAllSelected ? (React.createElement(DataSelectOrUnselectAllItem, null,
            React.createElement(BaSeParagraph, { color: textColor }, "".concat(getMessage("dataSelection.allItemsSelected.".concat(genderOfItemDescription), total, pluralItemDescription !== null && pluralItemDescription !== void 0 ? pluralItemDescription : getMessage('dataItem.pluralItemDescription')), ".")),
            React.createElement(BaSeButton, { size: "medium", type: "tertiary", color: highlightedColor, leftIcon: "close", onClick: function () { return setIsAllSelected(false); }, value: getMessage("dataSelection.unselectAllItems.".concat(genderOfItemDescription)) }))) : (React.createElement(DataSelectOrUnselectAllItem, null,
            React.createElement(BaSeParagraph, { color: textColor }, "".concat(selectedItems.length === 1
                ? getMessage("dataSelection.almostAllSelected.".concat(genderOfItemDescription))
                : getMessage("dataSelection.allPageSelected"), ".")),
            React.createElement(BaSeButton, { size: "medium", type: "tertiary", color: highlightedColor, leftIcon: "check-double-tonescale", onClick: function () { return setIsAllSelected(true); }, value: total - selectedItems.length === 1
                    ? getMessage("dataSelection.selectTheLastOne.".concat(genderOfItemDescription), singularItemDescription !== null && singularItemDescription !== void 0 ? singularItemDescription : getMessage('dataItem.singularItemDescription'))
                    : getMessage("dataSelection.selectAnothersRemaining.".concat(genderOfItemDescription), total - selectedItems.length, pluralItemDescription !== null && pluralItemDescription !== void 0 ? pluralItemDescription : getMessage('dataItem.pluralItemDescription')) }))))));
}

function DataToggleAllCheckbox(_a) {
    var highlightedColor = _a.highlightedColor, actualItems = _a.actualItems, rowIdKey = _a.rowIdKey;
    var _b = React.useContext(BaSeDataSelectionContext), isAllSelected = _b.isAllSelected, isAllFromPageSelected = _b.isAllFromPageSelected, selectedItems = _b.selectedItems, setIsAllFromPageSelected = _b.setIsAllFromPageSelected, setSelectedItems = _b.setSelectedItems;
    var checked = React.useMemo(function () { return isAllSelected || isAllFromPageSelected; }, [isAllSelected, isAllFromPageSelected]);
    var indeterminate = React.useMemo(function () {
        return actualItems.some(function (actualItem) {
            return selectedItems.some(function (selectedItem) { return selectedItem[rowIdKey] === actualItem[rowIdKey]; });
        });
    }, [actualItems, selectedItems]);
    React.useEffect(function () {
        return setIsAllFromPageSelected(isAllSelected ||
            (selectedItems.length > 0 &&
                actualItems.every(function (actualItem) {
                    return selectedItems.some(function (selectedItem) {
                        return selectedItem[rowIdKey] === actualItem[rowIdKey];
                    });
                })));
    }, [isAllSelected, actualItems, selectedItems, rowIdKey]);
    return isAllSelected || actualItems.length === 0 ? (React.createElement(React.Fragment, null)) : (React.createElement(BaSeCheckbox, { color: highlightedColor, checked: checked || indeterminate, indeterminate: !checked && indeterminate, onChange: function (changedChecked) {
            setSelectedItems(function (actualSelectedItems) {
                return actualSelectedItems.filter(function (actualSelectedItem) {
                    return actualItems.every(function (actualItem) {
                        return actualItem[rowIdKey] !== actualSelectedItem[rowIdKey];
                    });
                });
            });
            if (changedChecked) {
                setSelectedItems(function (actual) { return __spreadArray(__spreadArray([], actual, true), actualItems, true); });
            }
        } }));
}

function DataToggleRowCheckbox(_a) {
    var highlightedColor = _a.highlightedColor, rowIdKey = _a.rowIdKey, rowItem = _a.rowItem;
    var _b = React.useContext(BaSeDataSelectionContext), isAllSelected = _b.isAllSelected, selectedItems = _b.selectedItems, setSelectedItems = _b.setSelectedItems;
    var rowSelected = React.useMemo(function () {
        return isAllSelected ||
            selectedItems.some(function (item) { return rowItem[rowIdKey] === item[rowIdKey]; });
    }, [isAllSelected, selectedItems]);
    return isAllSelected ? (React.createElement(BaSeIcon, { name: "check", description: "asd", color: highlightedColor, size: 28 })) : (React.createElement(BaSeCheckbox, { color: highlightedColor, checked: rowSelected, onChange: function (changedChecked) {
            setSelectedItems(function (actual) {
                return actual.filter(function (item) { return rowItem[rowIdKey] !== item[rowIdKey]; });
            });
            if (changedChecked) {
                setSelectedItems(function (actual) { return __spreadArray(__spreadArray([], actual, true), [rowItem], false); });
            }
        } }));
}

var IconButton = styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  overflow: visible;\n"], ["\n  overflow: visible;\n"])));
var TextFilter = styled.div(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  overflow: hidden;\n  transition: width ", ";\n"], ["\n  overflow: hidden;\n  transition: width ", ";\n"])), BaSeTheme.transitions.durationSlow);
var DataTextFilterWrapper = styled.div(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var textFilterVisible = _a.textFilterVisible, textFilterWidth = _a.textFilterWidth;
    return textFilterVisible
        ? css(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n          ", " {\n            width: ", "px;\n            height: auto;\n          }\n          ", " {\n            display: none;\n          }\n        "], ["\n          ", " {\n            width: ", "px;\n            height: auto;\n          }\n          ", " {\n            display: none;\n          }\n        "])), TextFilter, textFilterWidth, IconButton) : css(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n          ", " {\n            width: 0;\n            height: 0;\n          }\n          ", " {\n            display: block;\n          }\n        "], ["\n          ", " {\n            width: 0;\n            height: 0;\n          }\n          ", " {\n            display: block;\n          }\n        "])), TextFilter, IconButton);
});
var templateObject_1$7, templateObject_2$4, templateObject_3$2, templateObject_4$2, templateObject_5$1;

var delay = 350;
function BaSeDataTextFilter(_a) {
    var textFilterPlaceholder = _a.textFilterPlaceholder, textFilterIconProps = _a.textFilterIconProps, _b = _a.textFilterAlwaysVisible, textFilterAlwaysVisible = _b === void 0 ? false : _b, _c = _a.textFilterWidth, textFilterWidth = _c === void 0 ? 250 : _c, _d = _a.highlightedColor, highlightedColor = _d === void 0 ? BaSeTheme.colors.institucionais.azulSebrae : _d, _e = _a.foregroundColor, foregroundColor = _e === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae60 : _e, _f = _a.textColor, textColor = _f === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae30 : _f, clearFilterButtonClicked = _a.clearFilterButtonClicked, setFilter = _a.setFilter, setTags = _a.setTags, onClearFilter = _a.onClearFilter, onTextFilter = _a.onTextFilter;
    var _g = React.useState(textFilterAlwaysVisible), textFilterVisible = _g[0], setTextFilterVisible = _g[1];
    var _h = React.useState(''), textFilterInputValue = _h[0], setTextFilterInputValue = _h[1];
    var _j = React.useState(foregroundColor), color = _j[0], setColor = _j[1];
    var textFilterValue = useDebounce(textFilterInputValue, delay);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var textFilterInputRef = React.createRef();
    var cleanAndClose = React.useCallback(function () {
        if (textFilterValue) {
            setTextFilterInputValue('');
        }
        setTextFilterVisible(textFilterAlwaysVisible);
    }, [textFilterValue, textFilterAlwaysVisible]);
    var sendFilter = React.useCallback(function (text) {
        var _a;
        var term = (_a = text === null || text === void 0 ? void 0 : text.trim) === null || _a === void 0 ? void 0 : _a.call(text);
        if (typeof onTextFilter === 'function') {
            onTextFilter({ setFilter: setFilter, setTags: setTags, term: term });
        }
        else {
            setFilter((term || undefined));
        }
        if (clearFilterButtonClicked &&
            !term &&
            typeof onClearFilter === 'function') {
            onClearFilter();
        }
    }, [onTextFilter, onClearFilter, setFilter, setTags, clearFilterButtonClicked]);
    React.useEffect(function () {
        var _a;
        if (!textFilterAlwaysVisible && textFilterVisible) {
            (_a = textFilterInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [textFilterVisible]);
    React.useEffect(function () {
        if (clearFilterButtonClicked) {
            cleanAndClose();
        }
    }, [clearFilterButtonClicked]);
    React.useEffect(function () { return sendFilter(textFilterValue); }, [textFilterValue]);
    return (React.createElement(DataTextFilterWrapper, { textFilterVisible: textFilterVisible, textFilterWidth: textFilterWidth },
        React.createElement(TextFilter, null,
            React.createElement(BaSeInput, { ref: textFilterInputRef, size: "small", placeholder: textFilterPlaceholder !== null && textFilterPlaceholder !== void 0 ? textFilterPlaceholder : getMessage('dataFilter.textFilterPlaceholder'), iconButton: {
                    color: color,
                    name: textFilterInputValue ? 'close' : 'search',
                    typeButton: 'base-icon',
                    action: function () { return cleanAndClose(); },
                }, onSpecificKeyDown: [
                    { listenerKey: 'Esc', callback: function () { return cleanAndClose(); } },
                    {
                        listenerKey: 'Enter',
                        callback: function () { return sendFilter(textFilterValue); },
                    },
                ], color: color, value: textFilterInputValue, onFocus: function () { return setColor(highlightedColor); }, onBlur: function () {
                    setColor(foregroundColor);
                    if (!textFilterInputValue) {
                        setTextFilterVisible(textFilterAlwaysVisible);
                    }
                }, onChange: function (value) {
                    setColor(textFilterInputValue ? highlightedColor : foregroundColor);
                    setTextFilterInputValue(value);
                } })),
        !textFilterAlwaysVisible && (React.createElement(IconButton, null,
            React.createElement(BaSeShapeButton, __assign({ size: "small", sizeIcon: "small", nameIcon: "search", type: "tertiary", color: foregroundColor, tooltip: {
                    size: 'small',
                    direction: 'top',
                    messageNoBreakLine: true,
                    color: textColor,
                    message: textFilterPlaceholder !== null && textFilterPlaceholder !== void 0 ? textFilterPlaceholder : getMessage('dataFilter.textFilterPlaceholder'),
                }, onClick: function () { return setTextFilterVisible(true); } }, textFilterIconProps))))));
}

var DATA_SELECTION_ID = 'BaSe-data-selection';
var colors = BaSeTheme.colors;
function BaSeData(_a) {
    var _b, _c, _d, _e, _f;
    var 
    // data
    total = _a.total, _g = _a.items, items = _g === void 0 ? [] : _g, _h = _a.initialPageSize, initialPageSize = _h === void 0 ? 10 : _h, _j = _a.initialPageIndex, initialPageIndex = _j === void 0 ? 0 : _j, _k = _a.initialSortType, initialSortType = _k === void 0 ? 'ASC' : _k, initialSortField = _a.initialSortField, _l = _a.idAccessorKey, idAccessorKey = _l === void 0 ? 'id' : _l, itemsPerPage = _a.itemsPerPage, 
    // config
    config = _a.config, configActionItems = _a.configActionItems, groupConfig = _a.groupConfig, loadingText = _a.loadingText, textFilterPlaceholder = _a.textFilterPlaceholder, textFilterAlwaysVisible = _a.textFilterAlwaysVisible, textFilterWidth = _a.textFilterWidth, _m = _a.customFilterIconVisible, customFilterIconVisible = _m === void 0 ? true : _m, _o = _a.customFilterVisibleWhenHasTags, customFilterVisibleWhenHasTags = _o === void 0 ? false : _o, _p = _a.customFilterVisible, initialCustomFilterVisible = _p === void 0 ? false : _p, _q = _a.isLoading, isLoading = _q === void 0 ? false : _q, _r = _a.hasCustomFilter, hasCustomFilter = _r === void 0 ? false : _r, _s = _a.hasPagination, hasPagination = _s === void 0 ? false : _s, _t = _a.hasSelection, hasSelection = _t === void 0 ? false : _t, _u = _a.hasSorting, hasSorting = _u === void 0 ? false : _u, _v = _a.hasTextFilter, hasTextFilter = _v === void 0 ? false : _v, 
    // layout
    title = _a.title, subTitle = _a.subTitle, width = _a.width, notFoundMessage = _a.notFoundMessage, _w = _a.genderOfItemDescription, genderOfItemDescription = _w === void 0 ? 'male' : _w, singularItemDescription = _a.singularItemDescription, pluralItemDescription = _a.pluralItemDescription, configActionItemsProps = _a.configActionItemsProps, textFilterIconProps = _a.textFilterIconProps, customFilterIconProps = _a.customFilterIconProps, customFilterClearButtonProps = _a.customFilterClearButtonProps, _x = _a.compactMode, compactMode = _x === void 0 ? false : _x, _y = _a.shadow, shadow = _y === void 0 ? BaSeTheme.shadows.profundidade4 : _y, 
    // colors
    _z = _a.highlightedColor, 
    // colors
    highlightedColor = _z === void 0 ? colors.institucionais.azulSebrae : _z, _0 = _a.foregroundColor, foregroundColor = _0 === void 0 ? colors.institucionais.cinzaSebrae60 : _0, _1 = _a.backgroundColor, backgroundColor = _1 === void 0 ? colors.defaultColors.white : _1, _2 = _a.headerBackgroundColor, headerBackgroundColor = _2 === void 0 ? colors.defaultColors.white : _2, _3 = _a.footerBackgroundColor, footerBackgroundColor = _3 === void 0 ? colors.defaultColors.white : _3, _4 = _a.titleColor, titleColor = _4 === void 0 ? colors.institucionais.cinzaSebrae45 : _4, _5 = _a.textColor, textColor = _5 === void 0 ? colors.institucionais.cinzaSebrae30 : _5, _6 = _a.separatorColor, separatorColor = _6 === void 0 ? colors.institucionais.cinzaSebrae90 : _6, _7 = _a.filterAreaBackgroundColor, filterAreaBackgroundColor = _7 === void 0 ? colors.institucionais.cinzaSebrae97 : _7, _8 = _a.selectOrUnselectAllBackgroundColor, selectOrUnselectAllBackgroundColor = _8 === void 0 ? colors.institucionais.cinzaSebrae97 : _8, 
    // methods
    fetchData = _a.fetchData, render = _a.render, whenRenderTextCell = _a.whenRenderTextCell, renderCustomFilter = _a.renderCustomFilter, onClearFilter = _a.onClearFilter, onTextFilter = _a.onTextFilter, renderNotFoundContent = _a.renderNotFoundContent, _9 = _a.extraIconActions, extraIconActions = _9 === void 0 ? function () { return []; } : _9, _10 = _a.extraButtonActions, extraButtonActions = _10 === void 0 ? function () { return []; } : _10, _11 = _a.selectionIconActions, selectionIconActions = _11 === void 0 ? function () { return []; } : _11, _12 = _a.selectionButtonActions, selectionButtonActions = _12 === void 0 ? function () { return []; } : _12;
    total !== null && total !== void 0 ? total : (total = (_b = items === null || items === void 0 ? void 0 : items.length) !== null && _b !== void 0 ? _b : 0);
    if (total === undefined) {
        throw Error('[BaSeData] "total" inválido');
    }
    if (groupConfig && config) {
        throw Error('[BaSeData] Use somente o "config" ou o "groupConfig"');
    }
    if (hasSorting && initialSortField === undefined) {
        throw Error('[BaSeData] Informe o campo inicial que veio ordenado com o "initialSortField"');
    }
    if (hasPagination && fetchData === undefined) {
        throw Error('[BaSeData] Informe o callback "fetchData" para utilizar a paginação');
    }
    if (customFilterVisibleWhenHasTags && customFilterIconVisible) {
        throw Error('[BaSeData] Caso configure que o custom filter só fique visivel ' +
            'quando tiver tag, não pode exibir o ícone do custom filter');
    }
    var _13 = React.useState(foregroundColor), configActionItemsColor = _13[0], setConfigActionItemsColor = _13[1];
    var _14 = React.useState(initialPageSize), dataPageSize = _14[0], setDataPageSize = _14[1];
    var _15 = React.useState(0), fetchAgain = _15[0], setFetchAgain = _15[1];
    var _16 = React.useState(0), containerHeight = _16[0], setContainerHeight = _16[1];
    var _17 = React.useState(false), isAllSelected = _17[0], setIsAllSelected = _17[1];
    var _18 = React.useState(false), isAllFromPageSelected = _18[0], setIsAllFromPageSelected = _18[1];
    var _19 = React.useState(items.filter(function (item) { var _a; return (_a = item === null || item === void 0 ? void 0 : item['isSelected']) !== null && _a !== void 0 ? _a : false; })), selectedItems = _19[0], setSelectedItems = _19[1];
    var _20 = React.useState(), filter = _20[0], setFilter = _20[1];
    var _21 = React.useState([]), tags = _21[0], setTags = _21[1];
    var _22 = React.useState(0), clearFilterButtonClicked = _22[0], setClearFilterButtonClicked = _22[1];
    var _23 = React.useState(initialCustomFilterVisible), customFilterVisible = _23[0], setCustomFilterVisible = _23[1];
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var renderedContainerRef = React.useRef(null);
    var initialState = {};
    var pluggins = [];
    if (hasSorting) {
        initialState.sortBy = [
            {
                id: initialSortField,
                desc: initialSortType === 'DESC',
            },
        ];
        pluggins.push(useSortBy);
    }
    if (hasPagination) {
        initialState.pageIndex = initialPageIndex;
        initialState.pageSize = initialPageSize;
        pluggins.push(usePagination);
    }
    if (hasSelection) {
        pluggins.push(function (hooks) {
            hooks.visibleColumns.push(function (columns) { return __spreadArray([
                {
                    id: DATA_SELECTION_ID,
                    Header: function (_a) {
                        var rows = _a.rows;
                        return (React.createElement(DataToggleAllCheckbox, { highlightedColor: highlightedColor, rowIdKey: idAccessorKey, actualItems: rows.map(function (row) { return row.original; }) }));
                    },
                    Cell: function (_a) {
                        var row = _a.row;
                        return (React.createElement(DataToggleRowCheckbox, { highlightedColor: highlightedColor, rowIdKey: idAccessorKey, rowItem: row.original }));
                    },
                }
            ], columns, true); });
        });
    }
    function reloadData(reloadDataConfig) {
        if (reloadDataConfig === void 0) { reloadDataConfig = {}; }
        if (reloadDataConfig === null || reloadDataConfig === void 0 ? void 0 : reloadDataConfig.resetSelection) {
            setIsAllSelected(false);
            setIsAllFromPageSelected(false);
            setSelectedItems([]);
        }
        setFetchAgain(function (counter) { return ++counter; });
    }
    var tableInstance = useTable.apply(void 0, __spreadArray([{
            data: React.useMemo(function () { return items; }, [items]),
            columns: React.useMemo(function () {
                return configMapper({
                    config: config !== null && config !== void 0 ? config : [],
                    groupConfig: groupConfig,
                    reloadData: reloadData,
                    whenRenderTextCell: whenRenderTextCell,
                });
            }, [config, groupConfig]),
            initialState: initialState,
            manualPagination: true,
            pageCount: Math.ceil(total / dataPageSize),
            manualSortBy: true,
            disableMultiSort: true,
        }], pluggins, false));
    var renderData = React.useCallback(function () {
        if (isLoading) {
            return (React.createElement(DataLoading, { height: containerHeight },
                React.createElement(BaSeLoading, { spinnerSize: 64, text: loadingText, textColor: foregroundColor, backgroundColor: backgroundColor, spinnerColor: highlightedColor })));
        }
        if (!total && typeof renderNotFoundContent === 'function') {
            return renderNotFoundContent({ reloadData: reloadData });
        }
        return (React.createElement(BaSeDataSelectionProvider, { hasSelection: hasSelection, isAllSelected: isAllSelected, setIsAllSelected: setIsAllSelected, isAllFromPageSelected: isAllFromPageSelected, setIsAllFromPageSelected: setIsAllFromPageSelected, selectedItems: selectedItems, setSelectedItems: setSelectedItems },
            React.createElement("div", { ref: renderedContainerRef }, render({
                table: tableInstance,
                setFilter: setFilter,
                setTags: setTags,
            }))));
    }, [
        total,
        isLoading,
        hasSelection,
        renderNotFoundContent,
        render,
        reloadData,
        tableInstance,
        isAllSelected,
        isAllFromPageSelected,
        selectedItems,
    ]);
    React.useEffect(function () {
        var _a, _b;
        setContainerHeight((_b = (_a = renderedContainerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height) !== null && _b !== void 0 ? _b : 300);
    }, [dataPageSize, renderedContainerRef.current]);
    React.useEffect(function () {
        if (hasSelection && isAllSelected) {
            setSelectedItems([]);
        }
    }, [hasSelection, isAllSelected]);
    React.useEffect(function () {
        var _a;
        if (!fetchData) {
            return;
        }
        var pageIndex = tableInstance.state.pageIndex;
        var pageSize = tableInstance.state.pageSize;
        var sortBy = ((_a = tableInstance.state.sortBy) !== null && _a !== void 0 ? _a : [])[0];
        var sortType = ((sortBy === null || sortBy === void 0 ? void 0 : sortBy.desc) ? 'DESC' : 'ASC');
        var sortField = sortBy === null || sortBy === void 0 ? void 0 : sortBy.id;
        var timeout = setTimeout(function () {
            return fetchData({
                page: {
                    index: pageIndex,
                    size: pageSize,
                },
                sort: {
                    type: sortType,
                    field: sortField,
                },
                filter: filter,
            });
        }, 15);
        return function () { return clearTimeout(timeout); };
    }, [
        fetchData,
        fetchAgain,
        tableInstance.state.pageIndex,
        tableInstance.state.pageSize,
        tableInstance.state.sortBy,
        filter,
    ]);
    React.useEffect(function () { var _a; return (_a = tableInstance === null || tableInstance === void 0 ? void 0 : tableInstance.gotoPage) === null || _a === void 0 ? void 0 : _a.call(tableInstance, 0); }, [filter]);
    var TitleWithoutSelection = function () { return (React.createElement(DataHeaderTitle, null,
        title && React.createElement(BaSeHeading5, { color: titleColor }, title),
        subTitle && (React.createElement(BaSeHeading6, { color: foregroundColor }, subTitle)))); };
    var TitleWithSelectionAndIconActions = function () {
        return isAllSelected || selectedItems.length || (!title && !subTitle) ? (React.createElement(DataHeaderSelection, { total: total, foregroundColor: foregroundColor, genderOfItemDescription: genderOfItemDescription, pluralItemDescription: pluralItemDescription, singularItemDescription: singularItemDescription, isAllSelected: isAllSelected, selectedItems: selectedItems, reloadData: reloadData, selectionIconActions: selectionIconActions, selectionButtonActions: selectionButtonActions })) : (React.createElement(TitleWithoutSelection, null));
    };
    var Title = function () {
        return hasSelection ? (React.createElement(TitleWithSelectionAndIconActions, null)) : (React.createElement(TitleWithoutSelection, null));
    };
    return (React.createElement(DataWrapper, { shadow: compactMode ? 'none' : shadow, width: width, backgroundColor: compactMode ? colors.defaultColors.transparent : backgroundColor },
        React.createElement(DataHeader, { horizontalPadding: compactMode ? '0' : spacePixels, headerBackgroundColor: compactMode ? colors.defaultColors.transparent : headerBackgroundColor },
            React.createElement(Title, null),
            React.createElement("div", { className: "BaSe--data-header-actions" },
                hasTextFilter && (React.createElement(BaSeDataTextFilter, { highlightedColor: highlightedColor, foregroundColor: foregroundColor, textFilterPlaceholder: textFilterPlaceholder, textFilterAlwaysVisible: textFilterAlwaysVisible, textFilterWidth: textFilterWidth, textFilterIconProps: textFilterIconProps, setFilter: setFilter, setTags: setTags, onTextFilter: onTextFilter, onClearFilter: onClearFilter, clearFilterButtonClicked: clearFilterButtonClicked })),
                hasCustomFilter && customFilterIconVisible && (React.createElement(BaSeShapeButton, __assign({ size: "small", sizeIcon: "small", type: "tertiary", color: customFilterVisible ? highlightedColor : foregroundColor, nameIcon: "filter", tooltip: {
                        size: 'small',
                        direction: 'top',
                        messageNoBreakLine: true,
                        color: textColor,
                        message: getMessage(customFilterVisible
                            ? 'dataFilter.closeFilter'
                            : 'dataFilter.openFilter'),
                    }, onClick: function () { return setCustomFilterVisible(function (shown) { return !shown; }); } }, customFilterIconProps))), (_c = extraIconActions === null || extraIconActions === void 0 ? void 0 : extraIconActions({ reloadData: reloadData })) === null || _c === void 0 ? void 0 :
                _c.map(function (extraIconAction) { return (React.createElement(BaSeShapeButton, __assign({ key: "".concat(extraIconAction.nameIcon, "-").concat(extraIconAction.value), size: "small", sizeIcon: "small", type: "tertiary", color: foregroundColor }, extraIconAction))); }),
                configActionItems && (React.createElement(BaSeActionItem, __assign({ size: "small", sizeIcon: "small", icon: "sliders-v-alt", position: "top-right", color: configActionItemsColor, onOpen: function () { return setConfigActionItemsColor(highlightedColor); }, onClose: function () { return setConfigActionItemsColor(foregroundColor); }, items: configActionItems.map(function (configActionItem) {
                        return 'color' in configActionItem
                            ? configActionItem
                            : __assign(__assign({}, configActionItem), { color: foregroundColor });
                    }), tooltip: {
                        size: 'small',
                        direction: 'top',
                        messageNoBreakLine: true,
                        color: textColor,
                        message: getMessage('dataConfigAction.hint'),
                    } }, configActionItemsProps))), (_d = extraButtonActions === null || extraButtonActions === void 0 ? void 0 : extraButtonActions({ reloadData: reloadData })) === null || _d === void 0 ? void 0 :
                _d.map(function (extraButtonAction) { return (React.createElement(BaSeButton, __assign({ key: "".concat(extraButtonAction.rightIcon, "-").concat(extraButtonAction.value, "-").concat(extraButtonAction.leftIcon), size: "small", type: "tertiary", color: foregroundColor }, extraButtonAction))); }))),
        React.createElement(DataContent, null, renderData()),
        hasSelection && (React.createElement(DataSelectionHelper, null,
            React.createElement(DataSelectOrUnselectAll, { total: total, hasPagination: hasPagination, isAllFromPageSelected: isAllFromPageSelected, isAllSelected: isAllSelected, selectedItems: selectedItems, setIsAllSelected: setIsAllSelected, singularItemDescription: singularItemDescription, pluralItemDescription: pluralItemDescription, compactMode: compactMode, genderOfItemDescription: genderOfItemDescription, highlightedColor: highlightedColor, backgroundColor: backgroundColor, textColor: textColor, selectOrUnselectAllBackgroundColor: selectOrUnselectAllBackgroundColor }))),
        (hasCustomFilter || tags.length > 0) && (React.createElement(DataFilterOrTags, null,
            React.createElement(BaSeDataFilterArea, { separatorColor: separatorColor, textColor: textColor, filterAreaBackgroundColor: filterAreaBackgroundColor, customFilterClearButtonProps: customFilterClearButtonProps, customFilterVisible: customFilterVisible, customFilterVisibleWhenHasTags: customFilterVisibleWhenHasTags, tags: tags, setTags: setTags, setFilter: setFilter, renderCustomFilter: renderCustomFilter, setClearFilterButtonClicked: setClearFilterButtonClicked, onClearFilter: onClearFilter }))),
        !total && typeof renderNotFoundContent === 'function' ? (React.createElement(DataFooter, { verticalPadding: spacePixels, separatorColor: colors.defaultColors.transparent, footerBackgroundColor: colors.defaultColors.transparent })) : (React.createElement(DataFooter, { horizontalPadding: compactMode ? '0' : spacePixels, separatorColor: compactMode ? colors.defaultColors.transparent : separatorColor, footerBackgroundColor: compactMode
                ? colors.defaultColors.transparent
                : footerBackgroundColor }, tableInstance && (React.createElement(BaSeDataPagination, { notFoundMessage: notFoundMessage, singularItemDescription: singularItemDescription, pluralItemDescription: pluralItemDescription, compactMode: compactMode, highlightedColor: highlightedColor, foregroundColor: foregroundColor, itemsPerPage: itemsPerPage, total: total, canNextPage: tableInstance.canNextPage, canPreviousPage: tableInstance.canPreviousPage, page: tableInstance.page, pageCount: tableInstance.pageCount, pageIndex: tableInstance.state.pageIndex, pageSize: tableInstance.state.pageSize, pageReducedRange: pageReducedRange((_e = tableInstance.pageOptions) !== null && _e !== void 0 ? _e : [], (_f = tableInstance.state.pageIndex) !== null && _f !== void 0 ? _f : 0), gotoPage: tableInstance.gotoPage, nextPage: tableInstance.nextPage, previousPage: tableInstance.previousPage, setDataPageSize: setDataPageSize, setPageSize: tableInstance.setPageSize }))))));
}

var DataBodyGrid = styled.div.attrs({
    className: 'BaSe--data-body-grid',
})(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  padding: ", ";\n  margin: 0;\n  box-sizing: content-box;\n\n  ul.BaSe--data-grid {\n    display: grid;\n    grid-template-columns: repeat(\n      ", ",\n      1fr\n    );\n    gap: ", ";\n  }\n"], ["\n  padding: ", ";\n  margin: 0;\n  box-sizing: content-box;\n\n  ul.BaSe--data-grid {\n    display: grid;\n    grid-template-columns: repeat(\n      ", ",\n      1fr\n    );\n    gap: ", ";\n  }\n"])), spacePixels, function (_a) {
    var _b = _a.gridColumns, gridColumns = _b === void 0 ? 3 : _b;
    return (gridColumns < 1 ? 1 : gridColumns);
}, function (_a) {
    var densityLevel = _a.densityLevel;
    return densityPixels(densityLevel);
});
var templateObject_1$6;

function BaSeDataGrid(props) {
    var _a = props.gridColumns, gridColumns = _a === void 0 ? 3 : _a, _b = props.itemsPerPage, itemsPerPage = _b === void 0 ? Array(4)
        .fill(gridColumns)
        .map(function (column, index) { return column * (index + 1); }) : _b, _c = props.densityLevel, densityLevel = _c === void 0 ? 'normal' : _c, hasSelection = props.hasSelection, renderCard = props.renderCard, 
    // tslint:disable-next-line: trailing-comma
    dataProps = __rest(props, ["gridColumns", "itemsPerPage", "densityLevel", "hasSelection", "renderCard"]);
    if (typeof renderCard !== 'function') {
        throw Error('BaSeDataGrid: "renderCard" inválido');
    }
    if (gridColumns <= 1) {
        throw Error('[BaSeDataGrid] Se vai mostrar um item, melhor usar o BaSeDataList, não?');
    }
    return (React.createElement(BaSeData, __assign({}, dataProps, { config: [
            {
                header: '',
                accessorKey: 'BaSe--data-grid-item',
                mapper: renderCard,
            },
        ], groupConfig: undefined, itemsPerPage: itemsPerPage, densityLevel: densityLevel, hasSelection: hasSelection, whenRenderTextCell: function () { return React.createElement(React.Fragment, null); }, render: function (_a) {
            var _b = _a.table, rows = _b.rows, page = _b.page, prepareRow = _b.prepareRow;
            return (React.createElement(DataBodyGrid, { gridColumns: gridColumns, densityLevel: densityLevel },
                React.createElement("ul", { className: "BaSe--data-grid" }, (page !== null && page !== void 0 ? page : rows).map(function (row) {
                    prepareRow(row);
                    return (React.createElement("li", { key: row.id, className: "BaSe--data-grid-item" },
                        row.cells[0].render('Cell'),
                        hasSelection && row.cells[1].render('Cell')));
                }))));
        } })));
}

var DataBodyList = styled.div.attrs({
    className: 'BaSe--data-body-list',
})(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  padding: ", ";\n  margin: 0;\n  box-sizing: content-box;\n\n  ul.BaSe--data-list {\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  }\n"], ["\n  padding: ", ";\n  margin: 0;\n  box-sizing: content-box;\n\n  ul.BaSe--data-list {\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  }\n"])), spacePixels, function (_a) {
    var densityLevel = _a.densityLevel;
    return densityPixels(densityLevel);
});
var templateObject_1$5;

function BaSeDataList(props) {
    var _a = props.itemsPerPage, itemsPerPage = _a === void 0 ? [3, 5, 10, 15] : _a, _b = props.densityLevel, densityLevel = _b === void 0 ? 'normal' : _b, renderCard = props.renderCard, hasSelection = props.hasSelection, 
    // tslint:disable-next-line: trailing-comma
    dataProps = __rest(props, ["itemsPerPage", "densityLevel", "renderCard", "hasSelection"]);
    if (typeof renderCard !== 'function') {
        throw Error('[BaSeDataList] "renderCard" inválido');
    }
    return (React.createElement(BaSeData, __assign({}, dataProps, { config: [
            {
                header: '',
                accessorKey: 'BaSe--data-list-item',
                mapper: renderCard,
            },
        ], groupConfig: undefined, itemsPerPage: itemsPerPage, densityLevel: densityLevel, hasSelection: hasSelection, whenRenderTextCell: function () { return React.createElement(React.Fragment, null); }, render: function (_a) {
            var _b = _a.table, rows = _b.rows, page = _b.page, prepareRow = _b.prepareRow;
            return (React.createElement(DataBodyList, { densityLevel: densityLevel },
                React.createElement("ul", { className: "BaSe--data-list" }, (page !== null && page !== void 0 ? page : rows).map(function (row) {
                    prepareRow(row);
                    return (React.createElement("li", { key: row.id, className: "BaSe--data-list-item" },
                        row.cells[0].render('Cell'),
                        hasSelection && row.cells[1].render('Cell')));
                }))));
        } })));
}

var tableRow = function (_a) {
    var separatorColor = _a.separatorColor, densityLevel = _a.densityLevel;
    return css(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  tr {\n    ", ",\n    ", " {\n      display: flex;\n      align-items: center;\n      padding: 0;\n      margin: 0;\n    }\n\n    ", " {\n      gap: 4px;\n      justify-content: flex-start;\n    }\n\n    th,\n    td {\n      will-change: background-color;\n      transition: ", ";\n      vertical-align: middle;\n      will-change: min-height, padding;\n      min-height: ", ";\n      padding: ", ";\n\n      &:first-of-type {\n        padding-left: ", ";\n      }\n      &:last-of-type {\n        padding-right: ", ";\n      }\n    }\n\n    td {\n      border: 1px solid ", ";\n      border-left: none;\n      border-right: none;\n    }\n  }\n"], ["\n  tr {\n    ", ",\n    ", " {\n      display: flex;\n      align-items: center;\n      padding: 0;\n      margin: 0;\n    }\n\n    ", " {\n      gap: 4px;\n      justify-content: flex-start;\n    }\n\n    th,\n    td {\n      will-change: background-color;\n      transition: ", ";\n      vertical-align: middle;\n      will-change: min-height, padding;\n      min-height: ", ";\n      padding: ", ";\n\n      &:first-of-type {\n        padding-left: ", ";\n      }\n      &:last-of-type {\n        padding-right: ", ";\n      }\n    }\n\n    td {\n      border: 1px solid ", ";\n      border-left: none;\n      border-right: none;\n    }\n  }\n"])), DataTableHeader, DataTableCell, DataTableHeader, BaSeTheme.transitions.allPropertiesContinuousNormal, densityPixels(densityLevel, 4), "".concat(densityPixels(densityLevel), " 8px"), spacePixels, spacePixels, separatorColor);
};
var lightness = 0.96;
var DataTableHeader = styled.span(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var DataTableCell = styled(DataTableHeader)(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject([""], [""])));
var DataBodyTable = styled.div.attrs({
    className: 'BaSe--data-body-table',
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  padding: 0;\n  margin: 0;\n  box-sizing: content-box;\n\n  & > table.BaSe--data-table {\n    width: 100%;\n    border: none;\n\n    ", "\n\n    ", "\n\n    ", "\n  }\n"], ["\n  padding: 0;\n  margin: 0;\n  box-sizing: content-box;\n\n  & > table.BaSe--data-table {\n    width: 100%;\n    border: none;\n\n    ", "\n\n    ", "\n\n    ", "\n  }\n"])), function (props) { return tableRow(props); }, function (_a) {
    var tableHeaderBackgroundColor = _a.tableHeaderBackgroundColor;
    return css(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n      thead > tr {\n        background-color: ", ";\n      }\n    "], ["\n      thead > tr {\n        background-color: ", ";\n      }\n    "])), tableHeaderBackgroundColor);
}, function (_a) {
    var backgroundColor = _a.backgroundColor, textColor = _a.textColor;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      tbody > tr {\n        will-change: background-color;\n        transition: ", ";\n        background-color: ", ";\n\n        &:hover {\n          background-color: ", ";\n        }\n      }\n    "], ["\n      tbody > tr {\n        will-change: background-color;\n        transition: ", ";\n        background-color: ", ";\n\n        &:hover {\n          background-color: ", ";\n        }\n      }\n    "])), BaSeTheme.transitions.allPropertiesContinuousNormal, transformLightness(backgroundColor, lightness), transformLightness(textColor, lightness));
});
var ColumnFilterWrapper = styled.div.attrs({
    className: 'BaSe--data-table-colum-filter',
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: absolute;\n  top: 100%;\n  z-index: ", ";\n  border-radius: 4px;\n  padding: ", ";\n  border: 1px solid ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n  ", "\n"], ["\n  position: absolute;\n  top: 100%;\n  z-index: ", ";\n  border-radius: 4px;\n  padding: ", ";\n  border: 1px solid ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n  ", "\n"])), BaSeTheme.stackOrder.aboveNormal, spacePixels, function (_a) {
    var separatorColor = _a.separatorColor;
    return separatorColor;
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, BaSeTheme.shadows.profundidade2, showUpAnimation);
var DataCompactTables = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  border-radius: 8px;\n  gap: ", ";\n  justify-content: stretch;\n  align-items: stretch;\n"], ["\n  display: flex;\n  flex-direction: column;\n  border-radius: 8px;\n  gap: ", ";\n  justify-content: stretch;\n  align-items: stretch;\n"])), spacePixels);
var DataCompactTable = styled.div.attrs({
    className: 'BaSe--data-compact-mode-table',
})(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  box-sizing: border-box;\n  border-radius: 8px;\n  will-change: background-color;\n  transition: ", ";\n\n  ", "\n\n  ", "\n\n  & > table.BaSe--data-table {\n    width: 100%;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    tr:first-of-type td {\n      border-top: none;\n    }\n\n    tr:last-of-type td {\n      border-bottom: none;\n    }\n  }\n"], ["\n  box-sizing: border-box;\n  border-radius: 8px;\n  will-change: background-color;\n  transition: ", ";\n\n  ", "\n\n  ", "\n\n  & > table.BaSe--data-table {\n    width: 100%;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    tr:first-of-type td {\n      border-top: none;\n    }\n\n    tr:last-of-type td {\n      border-bottom: none;\n    }\n  }\n"])), BaSeTheme.transitions.allPropertiesContinuousNormal, function (_a) {
    var shadow = _a.shadow;
    return shadow && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      box-shadow: ", ";\n    "], ["\n      box-shadow: ", ";\n    "])), shadow);
}, function (_a) {
    var backgroundColor = _a.backgroundColor, borderColor = _a.borderColor;
    return backgroundColor && css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      border: 1px solid ", ";\n      background: ", ";\n    "], ["\n      border: 1px solid ", ";\n      background: ", ";\n    "])), borderColor, backgroundColor);
}, function (props) { return tableRow(props); }, function (_a) {
    var tableHeaderBackgroundColor = _a.tableHeaderBackgroundColor;
    return tableHeaderBackgroundColor && css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n        thead > tr > td {\n          border-radius: 8px 8px 0 0;\n          background-color: ", ";\n        }\n      "], ["\n        thead > tr > td {\n          border-radius: 8px 8px 0 0;\n          background-color: ", ";\n        }\n      "])), tableHeaderBackgroundColor);
}, function (_a) {
    var textColor = _a.textColor;
    return css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      tbody > tr:hover > td {\n          background-color: ", ";\n        }\n      }\n    "], ["\n      tbody > tr:hover > td {\n          background-color: ", ";\n        }\n      }\n    "])), transformLightness(textColor, lightness));
});
var DataStickyCellContainer = styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n\n  align-items: center;\n  gap: 4px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n\n  align-items: center;\n  gap: 4px;\n"])));
var DataStickyCell = styled(DataTableHeader)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  &:last-of-type {\n    flex: 1;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end !important;\n    align-items: center;\n  }\n"], ["\n  &:last-of-type {\n    flex: 1;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end !important;\n    align-items: center;\n  }\n"])));
var templateObject_1$4, templateObject_2$3, templateObject_3$1, templateObject_4$1, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;

function DataTableCompactMode(_a) {
    var page = _a.page, rows = _a.rows, idAccessorKey = _a.idAccessorKey, shadow = _a.shadow, 
    // columnFilterVisible,
    densityLevel = _a.densityLevel, _b = _a.columnConfig, columnConfig = _b === void 0 ? [] : _b, _c = _a.highlightedColor, highlightedColor = _c === void 0 ? BaSeTheme.colors.institucionais.azulSebrae : _c, _d = _a.foregroundColor, foregroundColor = _d === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae60 : _d, _e = _a.textColor, textColor = _e === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae30 : _e, _f = _a.separatorColor, separatorColor = _f === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae90 : _f, _g = _a.backgroundColor, backgroundColor = _g === void 0 ? BaSeTheme.colors.defaultColors.white : _g, _h = _a.tableHeaderBackgroundColor, tableHeaderBackgroundColor = _h === void 0 ? BaSeTheme.colors.defaultColors.white : _h, prepareRow = _a.prepareRow, 
    // setColumnFilterVisible,
    // setFilter,
    // setTags,
    getTableProps = _a.getTableProps;
    var stickyColumn = React.useCallback(function (id) {
        var _a;
        return id === DATA_SELECTION_ID ||
            ((_a = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.find(function (_a) {
                var columnId = _a.columnId;
                return columnId === id;
            })) === null || _a === void 0 ? void 0 : _a.stickyOnCompactMode);
    }, [columnConfig]);
    var selected = React.useCallback(function (row, isAllSelected, selectedItems) {
        return rowIsSelected({
            itemKey: idAccessorKey,
            item: row.original,
            isAllSelected: isAllSelected,
            selectedItems: selectedItems,
        });
    }, [idAccessorKey]);
    return (React.createElement(DataCompactTables, null, (page !== null && page !== void 0 ? page : rows).map(function (row) {
        prepareRow(row);
        return (React.createElement(BaSeDataRowInfoProvider, { key: row.id },
            React.createElement(BaSeDataSelectionConsumer, null, function (_a) {
                var isAllSelected = _a.isAllSelected, selectedItems = _a.selectedItems;
                return (React.createElement(DataCompactTable, { shadow: shadow, densityLevel: densityLevel, textColor: textColor, separatorColor: separatorColor, tableHeaderBackgroundColor: selected(row, isAllSelected, selectedItems)
                        ? transformLightness(highlightedColor, lightness)
                        : tableHeaderBackgroundColor, backgroundColor: selected(row, isAllSelected, selectedItems)
                        ? transformLightness(highlightedColor, lightness)
                        : backgroundColor, borderColor: selected(row, isAllSelected, selectedItems)
                        ? highlightedColor
                        : backgroundColor },
                    React.createElement("table", __assign({}, getTableProps({ className: 'BaSe--data-table' })),
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("td", { colSpan: 2 },
                                    React.createElement(DataStickyCellContainer, null, row.cells
                                        .filter(function (cell) { return stickyColumn(cell.column.id); })
                                        .map(function (cell) { return (React.createElement(DataStickyCell, { key: cell.column.id },
                                        React.createElement(DataTableCell, null, cell.render('Cell')))); }))))),
                        React.createElement("tbody", null, row.cells
                            .filter(function (cell) { return !stickyColumn(cell.column.id); })
                            .map(function (cell) { return (React.createElement("tr", { key: cell.column.id },
                            React.createElement("td", __assign({}, cell.column.getHeaderProps()),
                                React.createElement(DataTableHeader, null,
                                    React.createElement(BaSeSmall1, { color: foregroundColor }, cell.column.render('Header')))),
                            React.createElement("td", __assign({}, cell.getCellProps()),
                                React.createElement(DataTableCell, null, cell.render('Cell'))))); })))));
            })));
    })));
}

var DataTableColumnFilter = function (_a) {
    var _b;
    var separatorColor = _a.separatorColor, backgroundColor = _a.backgroundColor, renderColumnFilter = _a.renderColumnFilter, column = _a.column, columnConfig = _a.columnConfig, setFilter = _a.setFilter, setTags = _a.setTags, setColumnFilterVisible = _a.setColumnFilterVisible;
    var wrapperRef = React.useRef(null);
    useOutsideEvent(wrapperRef, function () {
        return setTimeout(function () {
            return setColumnFilterVisible(function (actual) {
                var _a;
                return (__assign(__assign({}, actual), (_a = {}, _a[column.id] = false, _a)));
            });
        }, 100);
    });
    return (React.createElement(ColumnFilterWrapper, { ref: wrapperRef, separatorColor: separatorColor, backgroundColor: backgroundColor, onClick: function (event) { return event.stopPropagation(); } }, (_b = renderColumnFilter(column.id, columnConfig)) === null || _b === void 0 ? void 0 : _b({
        setFilter: setFilter,
        setTags: setTags,
        closeFilter: function () {
            return setColumnFilterVisible(function (actual) {
                var _a;
                return (__assign(__assign({}, actual), (_a = {}, _a[column.id] = false, _a)));
            });
        },
    })));
};
DataTableColumnFilter.displayName = 'DataTableColumnFilter';

function DataTableNormalMode(_a) {
    var headerGroups = _a.headerGroups, page = _a.page, rows = _a.rows, idAccessorKey = _a.idAccessorKey, columnFilterVisible = _a.columnFilterVisible, densityLevel = _a.densityLevel, _b = _a.columnConfig, columnConfig = _b === void 0 ? [] : _b, _c = _a.highlightedColor, highlightedColor = _c === void 0 ? BaSeTheme.colors.institucionais.azulSebrae : _c, _d = _a.foregroundColor, foregroundColor = _d === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae60 : _d, _e = _a.textColor, textColor = _e === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae30 : _e, _f = _a.separatorColor, separatorColor = _f === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae90 : _f, _g = _a.backgroundColor, backgroundColor = _g === void 0 ? BaSeTheme.colors.defaultColors.white : _g, _h = _a.tableHeaderBackgroundColor, tableHeaderBackgroundColor = _h === void 0 ? BaSeTheme.colors.defaultColors.white : _h, _j = _a.sortIcon, sortIcon = _j === void 0 ? 'arrow-head-down' : _j, _k = _a.sortingAscIcon, sortingAscIcon = _k === void 0 ? 'arrow-head-down' : _k, _l = _a.sortingDescIcon, sortingDescIcon = _l === void 0 ? 'arrow-head-up' : _l, getTableBodyProps = _a.getTableBodyProps, getTableProps = _a.getTableProps, prepareRow = _a.prepareRow, setColumnFilterVisible = _a.setColumnFilterVisible, setFilter = _a.setFilter, setTags = _a.setTags;
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var width = React.useCallback(function (id) { var _a; return (_a = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.find(function (_a) {
        var columnId = _a.columnId;
        return columnId === id;
    })) === null || _a === void 0 ? void 0 : _a.width; }, [columnConfig]);
    return (React.createElement(DataBodyTable, { densityLevel: densityLevel, separatorColor: separatorColor, textColor: textColor, tableHeaderBackgroundColor: tableHeaderBackgroundColor },
        React.createElement("table", __assign({}, getTableProps({ className: 'BaSe--data-table' })),
            React.createElement("thead", null, headerGroups.map(function (headerGroup) { return (
            // tslint:disable-next-line: jsx-key
            React.createElement("tr", __assign({}, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column) {
                var _a, _b;
                var sortClick = (_a = column === null || column === void 0 ? void 0 : column.getSortByToggleProps) === null || _a === void 0 ? void 0 : _a.call(column)['onClick'];
                return (column.isVisible && (React.createElement("th", __assign({}, column.getHeaderProps((_b = column === null || column === void 0 ? void 0 : column.getSortByToggleProps) === null || _b === void 0 ? void 0 : _b.call(column, {
                    title: undefined,
                    onClick: undefined,
                    style: {
                        cursor: 'default',
                        width: width(column.id),
                    },
                }))),
                    React.createElement(DataTableHeader, null,
                        React.createElement(BaSeSmall1, { color: foregroundColor }, column.render('Header')),
                        column.canSort &&
                            (column.isSorted ? (column.isSortedDesc ? (React.createElement(BaSeShapeButton, { size: "small", sizeIcon: "small", type: "tertiary", nameIcon: sortingDescIcon, color: highlightedColor, tooltip: {
                                    size: 'small',
                                    direction: 'top',
                                    messageNoBreakLine: true,
                                    delayToOpen: 500,
                                    color: textColor,
                                    message: getMessage('dataTable.sortHint.desc'),
                                }, onClick: function () { return sortClick === null || sortClick === void 0 ? void 0 : sortClick(); } })) : (React.createElement(BaSeShapeButton, { size: "small", sizeIcon: "small", color: highlightedColor, type: "tertiary", nameIcon: sortingAscIcon, tooltip: {
                                    size: 'small',
                                    direction: 'top',
                                    messageNoBreakLine: true,
                                    delayToOpen: 500,
                                    color: textColor,
                                    message: getMessage('dataTable.sortHint.asc'),
                                }, onClick: function () { return sortClick === null || sortClick === void 0 ? void 0 : sortClick(); } }))) : (React.createElement(BaSeShapeButton, { size: "small", sizeIcon: "small", type: "tertiary", nameIcon: sortIcon, color: foregroundColor, tooltip: {
                                    size: 'small',
                                    direction: 'top',
                                    messageNoBreakLine: true,
                                    delayToOpen: 500,
                                    color: textColor,
                                    message: getMessage('dataTable.sortHint'),
                                }, onClick: function () { return sortClick === null || sortClick === void 0 ? void 0 : sortClick(); } }))),
                        !!renderColumnFilter(column.id, columnConfig) && (React.createElement(React.Fragment, null,
                            React.createElement(BaSeShapeButton, __assign({ key: column.id, size: "small", sizeIcon: "small", nameIcon: "filter", type: "tertiary", color: !!(columnFilterVisible === null || columnFilterVisible === void 0 ? void 0 : columnFilterVisible[column.id])
                                    ? highlightedColor
                                    : foregroundColor, tooltip: {
                                    size: 'small',
                                    direction: 'top',
                                    messageNoBreakLine: true,
                                    delayToOpen: 500,
                                    color: textColor,
                                    message: getMessage(!!(columnFilterVisible === null || columnFilterVisible === void 0 ? void 0 : columnFilterVisible[column.id])
                                        ? 'dataFilter.closeFilter'
                                        : 'dataFilter.openFilter'),
                                }, onClick: function (event) {
                                    event.stopPropagation();
                                    setColumnFilterVisible(function (actual) {
                                        var _a;
                                        return (__assign(__assign({}, actual), (_a = {}, _a[column.id] = !(actual === null || actual === void 0 ? void 0 : actual[column.id]), _a)));
                                    });
                                } }, columnFilterIconProps(column.id, columnConfig))),
                            !!(columnFilterVisible === null || columnFilterVisible === void 0 ? void 0 : columnFilterVisible[column.id]) && (React.createElement(DataTableColumnFilter, { separatorColor: separatorColor, backgroundColor: backgroundColor, renderColumnFilter: renderColumnFilter, column: column, columnConfig: columnConfig, setFilter: setFilter, setTags: setTags, setColumnFilterVisible: setColumnFilterVisible }))))))));
            }))); })),
            React.createElement("tbody", __assign({}, getTableBodyProps()), (page !== null && page !== void 0 ? page : rows).map(function (row) {
                prepareRow(row);
                return (React.createElement(BaSeDataRowInfoProvider, { key: row.id },
                    React.createElement(BaSeDataSelectionConsumer, null, function (_a) {
                        var isAllSelected = _a.isAllSelected, selectedItems = _a.selectedItems;
                        return (React.createElement("tr", __assign({}, row.getRowProps({
                            style: {
                                backgroundColor: rowIsSelected({
                                    itemKey: idAccessorKey,
                                    item: row.original,
                                    isAllSelected: isAllSelected,
                                    selectedItems: selectedItems,
                                })
                                    ? transformLightness(highlightedColor, 0.96)
                                    : undefined,
                            },
                        })), row.cells.map(function (cell) { return (
                        // tslint:disable-next-line: jsx-key
                        React.createElement("td", __assign({}, cell.getCellProps()),
                            React.createElement(DataTableCell, null, cell.render('Cell')))); })));
                    })));
            })))));
}

function BaSeDataTable(props) {
    var _a = props.itemsPerPage, itemsPerPage = _a === void 0 ? [5, 10, 15, 50, 100] : _a, _b = props.densityLevel, initialDensityLevel = _b === void 0 ? 'normal' : _b, _c = props.configActionItems, configActionItems = _c === void 0 ? [] : _c, _d = props.highlightedColor, highlightedColor = _d === void 0 ? BaSeTheme.colors.institucionais.azulSebrae : _d, _e = props.foregroundColor, foregroundColor = _e === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae60 : _e, _f = props.textColor, textColor = _f === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae30 : _f, _g = props.separatorColor, separatorColor = _g === void 0 ? BaSeTheme.colors.institucionais.cinzaSebrae90 : _g, _h = props.backgroundColor, backgroundColor = _h === void 0 ? BaSeTheme.colors.defaultColors.white : _h, _j = props.tableHeaderBackgroundColor, tableHeaderBackgroundColor = _j === void 0 ? BaSeTheme.colors.defaultColors.white : _j, _k = props.sortIcon, sortIcon = _k === void 0 ? 'arrow-head-down' : _k, _l = props.sortingAscIcon, sortingAscIcon = _l === void 0 ? 'arrow-head-down' : _l, _m = props.sortingDescIcon, sortingDescIcon = _m === void 0 ? 'arrow-head-up' : _m, _o = props.columnConfig, columnConfig = _o === void 0 ? [] : _o, compactMode = props.compactMode, shadow = props.shadow, _p = props.idAccessorKey, idAccessorKey = _p === void 0 ? 'id' : _p, 
    // tslint:disable-next-line: trailing-comma
    dataProps = __rest(props, ["itemsPerPage", "densityLevel", "configActionItems", "highlightedColor", "foregroundColor", "textColor", "separatorColor", "backgroundColor", "tableHeaderBackgroundColor", "sortIcon", "sortingAscIcon", "sortingDescIcon", "columnConfig", "compactMode", "shadow", "idAccessorKey"]);
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    var _q = React.useState(initialDensityLevel), densityLevel = _q[0], setDensityLevel = _q[1];
    var _r = React.useState({}), columnFilterVisible = _r[0], setColumnFilterVisible = _r[1];
    return (React.createElement(BaSeData, __assign({}, dataProps, { itemsPerPage: itemsPerPage, densityLevel: densityLevel, highlightedColor: highlightedColor, foregroundColor: foregroundColor, textColor: textColor, separatorColor: separatorColor, backgroundColor: backgroundColor, compactMode: compactMode, shadow: shadow, idAccessorKey: idAccessorKey, configActionItems: __spreadArray([
            {
                icon: 'bars-high-density',
                text: getMessage('dataDensity.high'),
                color: foregroundColor,
                isSelected: densityLevel === 'high',
                callback: function () { return setDensityLevel('high'); },
            },
            {
                icon: 'bars',
                text: getMessage('dataDensity.normal'),
                color: foregroundColor,
                isSelected: densityLevel === 'normal',
                callback: function () { return setDensityLevel('normal'); },
            },
            {
                icon: 'bars-low-density',
                text: getMessage('dataDensity.low'),
                color: foregroundColor,
                isSelected: densityLevel === 'low',
                callback: function () { return setDensityLevel('low'); },
            }
        ], configActionItems, true), whenRenderTextCell: function (value) { return (React.createElement(BaSeParagraph, { color: textColor }, value)); }, render: function (_a) {
            var setTags = _a.setTags, setFilter = _a.setFilter, _b = _a.table, getTableBodyProps = _b.getTableBodyProps, getTableProps = _b.getTableProps, headerGroups = _b.headerGroups, rows = _b.rows, page = _b.page, prepareRow = _b.prepareRow;
            return compactMode ? (React.createElement(DataTableCompactMode, { page: page, rows: rows, shadow: shadow, idAccessorKey: idAccessorKey, densityLevel: densityLevel, columnFilterVisible: columnFilterVisible, columnConfig: columnConfig, backgroundColor: backgroundColor, foregroundColor: foregroundColor, highlightedColor: highlightedColor, separatorColor: separatorColor, textColor: textColor, tableHeaderBackgroundColor: tableHeaderBackgroundColor, getTableProps: getTableProps, prepareRow: prepareRow, setColumnFilterVisible: setColumnFilterVisible, setFilter: setFilter, setTags: setTags })) : (React.createElement(DataTableNormalMode, { headerGroups: headerGroups, page: page, rows: rows, idAccessorKey: idAccessorKey, columnFilterVisible: columnFilterVisible, columnConfig: columnConfig, densityLevel: densityLevel, sortIcon: sortIcon, sortingAscIcon: sortingAscIcon, sortingDescIcon: sortingDescIcon, backgroundColor: backgroundColor, foregroundColor: foregroundColor, highlightedColor: highlightedColor, separatorColor: separatorColor, textColor: textColor, tableHeaderBackgroundColor: tableHeaderBackgroundColor, getTableBodyProps: getTableBodyProps, getTableProps: getTableProps, prepareRow: prepareRow, setColumnFilterVisible: setColumnFilterVisible, setFilter: setFilter, setTags: setTags }));
        } })));
}

var handlePosition = function (position) {
    if (position === 'center') {
        return 'place-items: center';
    }
    else {
        var css = {
            'align-self': 'center;',
            'justify-self': 'center;',
        };
        if (position.includes('top')) {
            css['align-self'] = 'flex-start;';
        }
        if (position.includes('bottom')) {
            css['align-self'] = 'flex-end;';
        }
        if (position.includes('left')) {
            css['justify-self'] = 'flex-start;';
        }
        if (position.includes('right')) {
            css['justify-self'] = 'flex-end;';
        }
        return "align-self: ".concat(css['align-self'], " ;justify-self: ").concat(css['justify-self']);
    }
};
var CenterStyled = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  display: grid;\n  place-items: center;\n"], ["\n  display: grid;\n  place-items: center;\n"])));
styled.div(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  display: grid;\n  ", "\n"], ["\n  display: grid;\n  ", "\n"])), function (props) { return handlePosition(props.position); });
var templateObject_1$3, templateObject_2$2;

var PageWrapperStyled = styled.section(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  display: grid;\n  place-items: center;\n  padding: 50px;\n  background-color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  display: grid;\n  place-items: center;\n  padding: 50px;\n  background-color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n"])), function (_a) {
    var color = _a.color;
    return color !== null && color !== void 0 ? color : BaSeTheme.colors.defaultColors.white;
}, BaSeTheme.typography.fontFamily, BaSeTheme.typography.fontSizeBase);
var templateObject_1$2;

var rotate = function (_a) {
    var rotation = _a.rotation;
    return keyframes(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  40% {\n    transform: scale(.8);\n  }\n  100% {\n    transform: rotate(", "deg) scale(1);\n  }\n"], ["\n  40% {\n    transform: scale(.8);\n  }\n  100% {\n    transform: rotate(", "deg) scale(1);\n  }\n"])), rotation);
};
var slideDown = function (_a) {
    var initialOpacity = _a.initialOpacity;
    return keyframes(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  0% {\n    opacity: ", ";\n    transform: translateY(-100%);\n  }\n  80% {\n    transform: translateY(0);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"], ["\n  0% {\n    opacity: ", ";\n    transform: translateY(-100%);\n  }\n  80% {\n    transform: translateY(0);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"])), initialOpacity);
};
var RotateTransitionStyled = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  animation: ", " ", "\n    ", " ", "\n    forwards;\n"], ["\n  display: inline-block;\n  animation: ", " ", "\n    ", " ", "\n    forwards;\n"])), function (props) { return rotate(props); }, BaSeTheme.transitions.durationSlow, function (_a) {
    var delay = _a.delay;
    return delay;
}, BaSeTheme.transitions.elasticTimingFunction);
var SlideDownTransitionStyled = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline-block;\n  opacity: ", ";\n  transform-origin: center;\n  animation: ", "\n    ", " ", "\n    ", " forwards;\n"], ["\n  display: inline-block;\n  opacity: ", ";\n  transform-origin: center;\n  animation: ", "\n    ", " ", "\n    ", " forwards;\n"])), function (_a) {
    var initialOpacity = _a.initialOpacity;
    return initialOpacity;
}, function (props) { return slideDown(props); }, BaSeTheme.transitions.durationSlow, function (_a) {
    var delay = _a.delay;
    return delay;
}, BaSeTheme.transitions.elasticTimingFunction);
var templateObject_1$1, templateObject_2$1, templateObject_3, templateObject_4;

var cssMobile = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  gap: 21px;\n  flex-direction: column;\n  & > *:first-child {\n    align-self: center;\n  }\n"], ["\n  gap: 21px;\n  flex-direction: column;\n  & > *:first-child {\n    align-self: center;\n  }\n"])));
var SideBySideStyled = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 70px;\n\n  /*mobileSmall*/\n  ", "\n  /*mobile*/\n  ", "\n  /*mobileLarge*/\n  ", "\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 70px;\n\n  /*mobileSmall*/\n  ", "\n  /*mobile*/\n  ", "\n  /*mobileLarge*/\n  ", "\n"])), BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(cssMobile.toString()), BaSeTheme.breakpoints.mobile.mediaQueryCss(cssMobile.toString()), BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(cssMobile.toString()));
var templateObject_1, templateObject_2;

var transitionDelay = '2s';
var BaSeErrorPage = function (_a) {
    var title = _a.title, error = _a.error, button = _a.button, _b = _a.showButton, showButton = _b === void 0 ? true : _b;
    var hasButton = React.useMemo(function () { return showButton && (window.history.length > 1 || button); }, [button, showButton]);
    return (React.createElement(BaSeI18nConsumer, null, function (_a) {
        var getMessage = _a.getMessage;
        return (React.createElement(PageWrapperStyled, { color: BaSeTheme.colors.institucionais.cinzaSebrae97 },
            React.createElement(CenterStyled, null,
                React.createElement(SideBySideStyled, null,
                    React.createElement("div", { style: {
                            margin: '10px 0',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '24px',
                        } },
                        React.createElement(BaSeLogoSebrae, { width: 143, easterEgg: true }),
                        hasButton && (React.createElement(SlideDownTransitionStyled, { initialOpacity: 0, delay: transitionDelay },
                            React.createElement(BaSeButton, __assign({ onClick: function () { return window.history.back(); }, type: "tertiary", leftIcon: button ? button.leftIcon : 'history-alt', color: BaSeTheme.colors.institucionais.cinzaSebrae20, value: getMessage('errorPage.backButton') }, button))))),
                    React.createElement("div", null,
                        React.createElement(BaSeHeading1, { isBold: true, color: BaSeTheme.colors.institucionais.azulSebrae },
                            React.createElement(RotateTransitionStyled, { rotation: 90, delay: transitionDelay }, ": ("),
                            React.createElement("br", null),
                            "Ops!"),
                        React.createElement("div", { style: { margin: '21px 0' } },
                            React.createElement(BaSeHeading4, { isBold: true, color: BaSeTheme.colors.institucionais.cinzaSebrae20 }, title || getMessage('errorPage.defaultTitle')),
                            React.createElement(BaSeParagraph, { color: BaSeTheme.colors.institucionais.cinzaSebrae45 }, error || getMessage('errorPage.defaultDescription'))))))));
    }));
};

var BaSeBackendNoSignalPage = function () {
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(BaSeErrorPage, { title: getMessage('backendNoSignalPage.title'), error: getMessage('backendNoSignalPage.errorMessage') }));
};

var BaSeForbiddenPage = function () {
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(BaSeErrorPage, { title: getMessage('forbiddenPage.title'), error: getMessage('forbiddenPage.errorMessage') }));
};

var BaSeLoadingPage = function () { return (React.createElement(PageWrapperStyled, null,
    React.createElement(BaSeLoading, null))); };

var BaSeNotFoundPage = function () {
    var getMessage = React.useContext(BaSeI18nContext).getMessage;
    return (React.createElement(BaSeErrorPage, { title: getMessage('notFoundPage.title'), error: getMessage('notFoundPage.errorMessage') }));
};

var BaSeHomePage = BaSeConfig.docsUrl;

export { BaSeAccordion, BaSeAccountProfile, BaSeActionItem, BaSeArrowButton, BaSeAutocomplete, BaSeAvatar, BaSeBackendNoSignalPage, BaSeBadge, BaSeBreakpointConsumer, BaSeBreakpointContext, BaSeButton, BaSeCard, BaSeCheckbox, BaSeContainer, BaSeCounter, BaSeDataGrid, BaSeDataList, BaSeDataRowInfoConsumer, BaSeDataRowInfoContext, BaSeDataTable, BaSeDatePicker, BaSeDialogConsumer, BaSeDialogContext, BaSeDualButton, BaSeEmoticon, BaSeErrorPage, BaSeFooter, BaSeForbiddenPage, BaSeGrid, BaSeGridItem, BaSeHeader, BaSeHeading1, BaSeHeading2, BaSeHeading3, BaSeHeading4, BaSeHeading5, BaSeHeading6, BaSeHelperText, BaSeHomePage, BaSeIcon, BaSeIllustration, BaSeImageFlag, BaSeImageMap, BaSeImagePicker, BaSeInput, BaSeInputList, BaSeLoading, BaSeLoadingPage, BaSeLoadingSpinner, BaSeLogoSebrae, BaSeLogoSebraeInverse, BaSeLogoSebraeRestrict, BaSeLogoSebraeRestrictInverse, BaSeMultipleSelect, BaSeNotFoundPage, BaSeParagraph, BaSePopover, BaSePopupButton, BaSeRadio, BaSeRoot, BaSeSelect, BaSeSelectList, BaSeShapeButton, BaSeSideMenu, BaSeSmall1, BaSeSmall2, BaSeStepper, BaSeTabs, BaSeTag, BaSeTextArea, BaSeTheme, BaSeToggler, BaSeTooltip, version as BaSeVersion, Color, base64Decode, base64DecodeToBlob, base64DecodeToTypedArray, base64Encode, camelCase, createButtonDarkTextColor, createButtonFocusColor, createButtonHoverColor, createColor, createColorSmartLightingControl, firstLetterUpperCase, getHSLValues, hueMapperFocus, hueMapperHover, isNumeric, nameAbbreviation, normalize, numberWithUnit, stringToBlob, stringToTypedArray, stripHtmlTags, urlDecode, urlEncode, urlSanitizer, useDebounce, useOutsideEvent };
//# sourceMappingURL=index.es.js.map
